
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9pcjO", function(module, exports) {
const $b4698b95fb92ddf1$export$81f65d0c79fe28b4 = {
    QUICK_FIND: 'quick-find',
    SEARCH_PAGE: 'search-page'
};
module.exports["SearchExperience"] = $b4698b95fb92ddf1$export$81f65d0c79fe28b4;

});

parcelRegister("c11PZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

// This function is used to override the values of an object with the values of another object.
// Unless the value is null or undefined, the value from the source object will be used.
function $78996b68e17eef8d$export$8b58be045bf06082(target, source) {
    const result = {
        ...target
    };
    for(const key in source)if (source[key] !== null && source[key] !== undefined) result[key] = source[key];
    return result;
}



var $gQNge = parcelRequire("gQNge");


var $lYEhB = parcelRequire("lYEhB");

const $e14c00de9dfb3994$export$554c849e7e3a0f1 = {
    mapUserIdToProfileUrl: ()=>null,
    generateSearchUrl: (0, $gQNge.defaultGenerateSearchUrl),
    getFeatureGate: ()=>false,
    getFrontendExperiment: ()=>({
            abTestId: '',
            cohort: '',
            serveExperiment: false
        }),
    queryParams: {},
    onNavigate: (0, $lYEhB.defaultOnNavigate),
    isNav4Enabled: false,
    isAdminHubAIEnabled: false,
    isRovoLLMEnabled: false
};
/**
 * Provides information about the host application that can't be stored in a state store,
 * e.g. a function.
 */ const $e14c00de9dfb3994$var$AppContext = /*#__PURE__*/ (0, $cozmU.createContext)($e14c00de9dfb3994$export$554c849e7e3a0f1);
const $e14c00de9dfb3994$export$fdc397e486fa83e7 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useContext($e14c00de9dfb3994$var$AppContext);
const $e14c00de9dfb3994$export$20d2b7652facc723 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($e14c00de9dfb3994$var$AppContext.Provider, {
        value: (0, $78996b68e17eef8d$export$8b58be045bf06082)($e14c00de9dfb3994$export$554c849e7e3a0f1, props)
    }, children);
module.exports["useAppContext"] = $e14c00de9dfb3994$export$fdc397e486fa83e7;
module.exports["AppContextProvider"] = $e14c00de9dfb3994$export$20d2b7652facc723;

});

parcelRegister("gQNge", function(module, exports) {
function $fef788de4a50ec08$export$3c0cdf0037f37eca(queryParams) {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams();
    Object.entries(queryParams).forEach(([key, value])=>{
        if (value !== undefined && value !== null) searchParams.set(key, String(value));
        else searchParams.delete(key);
    });
    url.search = searchParams.toString();
    return url.href;
}
module.exports["defaultGenerateSearchUrl"] = $fef788de4a50ec08$export$3c0cdf0037f37eca;

});

parcelRegister("lYEhB", function(module, exports) {
const $a0f07052a6e35159$export$bd386de500a3324b = {
    callback: (url)=>{
        window.location.href = url;
    },
    options: {
        alwaysUseOnLinkClick: false
    }
};
module.exports["defaultOnNavigate"] = $a0f07052a6e35159$export$bd386de500a3324b;

});

parcelRegister("hdMUr", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $ej0c1 = parcelRequire("ej0c1");






























const $b229105ea1272257$export$8d1690c334cb6ec1 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("eesba"));
        case 'da':
            return (parcelRequire("bLTm3"));
        case 'de':
            return (parcelRequire("3XVa6"));
        case 'en':
            return (parcelRequire("jaYAM"));
        case 'en_GB':
            return (parcelRequire("7Bkma"));
        case 'en_ZZ':
            return (parcelRequire("iJnNd"));
        case 'es':
            return (parcelRequire("ksjH0"));
        case 'fi':
            return (parcelRequire("kUbIB"));
        case 'fr':
            return (parcelRequire("kaNfw"));
        case 'hr':
            return (parcelRequire("jO13r"));
        case 'hu':
            return (parcelRequire("6mYVW"));
        case 'it':
            return (parcelRequire("8ml2N"));
        case 'ja':
            return (parcelRequire("fpOW4"));
        case 'ko':
            return (parcelRequire("7F4l3"));
        case 'nb':
            return (parcelRequire("gfKOF"));
        case 'nl':
            return (parcelRequire("fOS8M"));
        case 'pl':
            return (parcelRequire("aSAb5"));
        case 'pt_BR':
            return (parcelRequire("6trHz"));
        case 'ru':
            return (parcelRequire("fl3PF"));
        case 'sl':
            return (parcelRequire("dqkwI"));
        case 'sr_RS':
            return (parcelRequire("3oOtg"));
        case 'sr_YR':
            return (parcelRequire("eP8bg"));
        case 'sv':
            return (parcelRequire("cu6Sm"));
        case 'th':
            return (parcelRequire("grzGi"));
        case 'tr':
            return (parcelRequire("9rVUk"));
        case 'uk':
            return (parcelRequire("jmCuW"));
        case 'vi':
            return (parcelRequire("l5SiF"));
        case 'zh':
            return (parcelRequire("5SBU6"));
        case 'zh_TW':
            return (parcelRequire("jfjtW"));
    }
};































const $d59ac6f5f0ea5120$export$8d1690c334cb6ec1 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("a8J3L"));
        case 'da':
            return (parcelRequire("hyjql"));
        case 'de':
            return (parcelRequire("4d7mR"));
        case 'en':
            return (parcelRequire("l414Y"));
        case 'en_GB':
            return (parcelRequire("d1vR7"));
        case 'en_ZZ':
            return (parcelRequire("lbIOK"));
        case 'es':
            return (parcelRequire("erEK7"));
        case 'fi':
            return (parcelRequire("dwQIL"));
        case 'fr':
            return (parcelRequire("9mlgJ"));
        case 'hr':
            return (parcelRequire("g1JlU"));
        case 'hu':
            return (parcelRequire("ZF1G9"));
        case 'it':
            return (parcelRequire("fagXR"));
        case 'ja':
            return (parcelRequire("gJKhA"));
        case 'ko':
            return (parcelRequire("a0jez"));
        case 'nb':
            return (parcelRequire("ea0Re"));
        case 'nl':
            return (parcelRequire("gL0Dx"));
        case 'pl':
            return (parcelRequire("bhJWq"));
        case 'pt_BR':
            return (parcelRequire("hUo4O"));
        case 'ru':
            return (parcelRequire("hDbbU"));
        case 'sl':
            return (parcelRequire("77INV"));
        case 'sr_RS':
            return (parcelRequire("9sz3K"));
        case 'sr_YR':
            return (parcelRequire("ctEz6"));
        case 'sv':
            return (parcelRequire("im1dt"));
        case 'th':
            return (parcelRequire("fRkaa"));
        case 'tr':
            return (parcelRequire("jOXsT"));
        case 'uk':
            return (parcelRequire("5oZ61"));
        case 'vi':
            return (parcelRequire("lXomr"));
        case 'zh':
            return (parcelRequire("6AJxn"));
        case 'zh_TW':
            return (parcelRequire("3yxPO"));
    }
};































const $acf6cbf82438a9be$export$8d1690c334cb6ec1 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("agerH"));
        case 'da':
            return (parcelRequire("1guW5"));
        case 'de':
            return (parcelRequire("fBVAD"));
        case 'en':
            return (parcelRequire("540xp"));
        case 'en_GB':
            return (parcelRequire("dDn4v"));
        case 'en_ZZ':
            return (parcelRequire("fheBd"));
        case 'es':
            return (parcelRequire("h8W7L"));
        case 'fi':
            return (parcelRequire("aUnph"));
        case 'fr':
            return (parcelRequire("d7Xrz"));
        case 'hr':
            return (parcelRequire("1vhaM"));
        case 'hu':
            return (parcelRequire("b1QGl"));
        case 'it':
            return (parcelRequire("8RgFL"));
        case 'ja':
            return (parcelRequire("imD26"));
        case 'ko':
            return (parcelRequire("dKwIN"));
        case 'nb':
            return (parcelRequire("2TMvz"));
        case 'nl':
            return (parcelRequire("edNkB"));
        case 'pl':
            return (parcelRequire("7v0d6"));
        case 'pt_BR':
            return (parcelRequire("i6YAa"));
        case 'ru':
            return (parcelRequire("8hihb"));
        case 'sl':
            return (parcelRequire("2ZCu4"));
        case 'sr_RS':
            return (parcelRequire("byEb5"));
        case 'sr_YR':
            return (parcelRequire("3pj4Z"));
        case 'sv':
            return (parcelRequire("jys7x"));
        case 'th':
            return (parcelRequire("1KJtX"));
        case 'tr':
            return (parcelRequire("jA8mS"));
        case 'uk':
            return (parcelRequire("fjM8E"));
        case 'vi':
            return (parcelRequire("kvVV6"));
        case 'zh':
            return (parcelRequire("cHEVj"));
        case 'zh_TW':
            return (parcelRequire("ehjC2"));
    }
};
































const $6a978b70b7be62de$export$417b577dd0ae3221 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (parcelRequire("lXiQY"));
        case 'da':
            return (parcelRequire("ceL5Y"));
        case 'de':
            return (parcelRequire("9PFi4"));
        case 'en':
            return Promise.resolve((parcelRequire("ej0c1")));
        case 'en_GB':
            return (parcelRequire("9XxAb"));
        case 'en_ZZ':
            return (parcelRequire("OStr5"));
        case 'es':
            return (parcelRequire("1J13e"));
        case 'fi':
            return (parcelRequire("gyaDS"));
        case 'fr':
            return (parcelRequire("lSLlQ"));
        case 'hr':
            return (parcelRequire("kMWsF"));
        case 'hu':
            return (parcelRequire("kP2Kb"));
        case 'it':
            return (parcelRequire("cCQAD"));
        case 'ja':
            return (parcelRequire("d7Jf3"));
        case 'ko':
            return (parcelRequire("92nxS"));
        case 'nb':
            return (parcelRequire("deUzL"));
        case 'nl':
            return (parcelRequire("aykdQ"));
        case 'pl':
            return (parcelRequire("8gT6G"));
        case 'pt_BR':
        case 'pt-BR':
            return (parcelRequire("gRJMd"));
        case 'ru':
            return (parcelRequire("egG6R"));
        case 'sl':
            return (parcelRequire("2OF8N"));
        case 'sr_RS':
            return (parcelRequire("lRRyP"));
        case 'sr_YR':
            return (parcelRequire("atzeI"));
        case 'sv':
            return (parcelRequire("ix7N8"));
        case 'th':
            return (parcelRequire("fXCNp"));
        case 'tr':
            return (parcelRequire("bMuJn"));
        case 'uk':
            return (parcelRequire("e0LRB"));
        case 'vi':
            return (parcelRequire("1ougv"));
        case 'zh_TW':
            return (parcelRequire("4S2B8"));
        case 'zh':
            return (parcelRequire("79XJS"));
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $6a978b70b7be62de$export$417b577dd0ae3221(fragments[0]);
                else return Promise.resolve((parcelRequire("ej0c1")));
            }
    }
};
const $6a978b70b7be62de$export$bb2dfe5d62b737e9 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('cs');
        case 'da':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('da');
        case 'de':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('de');
        case 'en':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('en');
        case 'en_GB':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('en_GB');
        case 'en_ZZ':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('en_ZZ');
        case 'es':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('es');
        case 'fi':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('fi');
        case 'fr':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('fr');
        case 'hr':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('hr');
        case 'hu':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('hu');
        case 'it':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('it');
        case 'ja':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('ja');
        case 'ko':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('ko');
        case 'nb':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('nb');
        case 'nl':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('nl');
        case 'pl':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('pl');
        case 'pt_BR':
        case 'pt-BR':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('pt_BR');
        case 'ru':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('ru');
        case 'sl':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('sl');
        case 'sr_RS':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('sr_RS');
        case 'sr_YR':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('sr_YR');
        case 'sv':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('sv');
        case 'th':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('th');
        case 'tr':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('tr');
        case 'uk':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('uk');
        case 'vi':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('vi');
        case 'zh_TW':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('zh_TW');
        case 'zh':
            return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('zh');
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $6a978b70b7be62de$export$bb2dfe5d62b737e9(fragments[0]);
                else return (0, $d59ac6f5f0ea5120$export$8d1690c334cb6ec1)('en');
            }
    }
};
const $6a978b70b7be62de$export$622f604e3a034452 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('cs');
        case 'da':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('da');
        case 'de':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('de');
        case 'en':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('en');
        case 'en_GB':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('en_GB');
        case 'en_ZZ':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('en_ZZ');
        case 'es':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('es');
        case 'fi':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('fi');
        case 'fr':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('fr');
        case 'hr':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('hr');
        case 'hu':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('hu');
        case 'it':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('it');
        case 'ja':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('ja');
        case 'ko':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('ko');
        case 'nb':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('nb');
        case 'nl':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('nl');
        case 'pl':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('pl');
        case 'pt_BR':
        case 'pt-BR':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('pt_BR');
        case 'ru':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('ru');
        case 'sl':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('sl');
        case 'sr_RS':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('sr_RS');
        case 'sr_YR':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('sr_YR');
        case 'sv':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('sv');
        case 'th':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('th');
        case 'tr':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('tr');
        case 'uk':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('uk');
        case 'vi':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('vi');
        case 'zh_TW':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('zh_TW');
        case 'zh':
            return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('zh');
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $6a978b70b7be62de$export$622f604e3a034452(fragments[0]);
                else return (0, $acf6cbf82438a9be$export$8d1690c334cb6ec1)('en');
            }
    }
};
const $6a978b70b7be62de$export$97d82de8c43f5d55 = async (locale)=>{
    switch(locale){
        case 'cs':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('cs');
        case 'da':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('da');
        case 'de':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('de');
        case 'en':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('en');
        case 'en_GB':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('en_GB');
        case 'en_ZZ':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('en_ZZ');
        case 'es':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('es');
        case 'fi':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('fi');
        case 'fr':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('fr');
        case 'hr':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('hr');
        case 'hu':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('hu');
        case 'it':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('it');
        case 'ja':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('ja');
        case 'ko':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('ko');
        case 'nb':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('nb');
        case 'nl':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('nl');
        case 'pl':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('pl');
        case 'pt_BR':
        case 'pt-BR':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('pt_BR');
        case 'ru':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('ru');
        case 'sl':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('sl');
        case 'sr_RS':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('sr_RS');
        case 'sr_YR':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('sr_YR');
        case 'sv':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('sv');
        case 'th':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('th');
        case 'tr':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('tr');
        case 'uk':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('uk');
        case 'vi':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('vi');
        case 'zh_TW':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('zh_TW');
        case 'zh':
            return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('zh');
        default:
            {
                const fragments = locale.split(/[_-]/);
                if (fragments.length === 2) return $6a978b70b7be62de$export$97d82de8c43f5d55(fragments[0]);
                else return (0, $b229105ea1272257$export$8d1690c334cb6ec1)('en');
            }
    }
};
function $6a978b70b7be62de$export$6e4716e192dd76c5(locale) {
    return Promise.allSettled([
        $6a978b70b7be62de$export$417b577dd0ae3221(locale),
        $6a978b70b7be62de$export$bb2dfe5d62b737e9(locale),
        $6a978b70b7be62de$export$622f604e3a034452(locale),
        $6a978b70b7be62de$export$97d82de8c43f5d55(locale)
    ]).then((results)=>{
        const accumulatedMessages = results.reduce((acc, result)=>{
            if (result.status === 'fulfilled') return {
                ...acc,
                ...result.value.default
            };
            return acc;
        }, {});
        return accumulatedMessages;
    });
}


const $60e352734959f7f0$var$useI18n = (locale, source)=>{
    const [messages, setMessages] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState((0, $ej0c1.default));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useEffect(()=>{
        let aborted = false;
        setMessages((0, $ej0c1.default));
        (0, $6a978b70b7be62de$export$6e4716e192dd76c5)(locale).then((messages)=>{
            if (!aborted) setMessages(messages);
        }).catch((error)=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'error',
                    actionSubject: 'i18n_messages_load_error',
                    source: source,
                    attributes: {
                        locale: locale,
                        error: error.message
                    }
                }
            }).fire();
        });
        return ()=>{
            aborted = true;
        };
    }, [
        locale,
        source,
        createAnalyticsEvent
    ]);
    return messages;
};
const $60e352734959f7f0$var$MessagesIntlProvider = (props)=>{
    const { children: children } = props;
    const intl = (0, $kSwu1.useIntl)();
    const messages = $60e352734959f7f0$var$useI18n(intl.locale, props.experience);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.IntlProvider), {
        ...intl,
        messages: messages
    }, children);
};
var $60e352734959f7f0$export$2e2bcd8739ae039 = $60e352734959f7f0$var$MessagesIntlProvider;
module.exports["default"] = $60e352734959f7f0$export$2e2bcd8739ae039;

});

parcelRegister("ej0c1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $6e2a0e01d55c9360$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ /* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //
var $295b7ff928e6276a$export$2e2bcd8739ae039 = {
    '3p-result-labeling.knowledge_article.label': 'Knowledge article',
    '3p-result-labeling.news_article.label': 'News article',
    'advanced-search.labels.filter.no.text': 'Start typing to search for a label',
    'ai-summary-label': 'Summarize',
    'archive.label': 'Archive',
    'assets-app-message-banner-available-soon': '<bold>Assets will be available here soon</bold>. For now, try <assetsSearchLink>Assets search</assetsSearchLink>.',
    'assets-app-message-banner-dismiss-message': 'Dismiss',
    attachment_type: 'Attachment',
    'audio.label': 'Audio',
    avatar: 'Avatar',
    'blogpost.label': 'Blogpost',
    blogpost_type: 'Blogpost',
    'branch.label': 'Branch',
    'channel.label': 'Channel',
    'code.label': 'Code',
    'comment-result.label': 'Comment',
    comment_type: 'Comment',
    'commit.label': 'Commit',
    connect_third_party_product_description: 'Connect your account to see missing results',
    connect_third_party_product_title: 'Your admin has added {product}!',
    connect_third_party_product_title_alternate: '{product} is now available!',
    'copied-link-tooltip-label': 'Copied!',
    'copy-content-link-label': 'Copy link',
    'copy-link-button-label': 'Copy Link',
    'copy-link-success-icon-label': 'Success icon',
    'copy-link-tooltip-label': 'Copy link',
    createdNewest: 'Created (newest)',
    createdOldest: 'Created (oldest)',
    'customer-org.label': 'Customer Org',
    'dashboard.label': 'Dashboard',
    'database.label': 'Database',
    'date.filter.after.label': 'after',
    'date.filter.any.time': 'Anytime',
    'date.filter.before.label': 'before',
    'date.filter.custom': 'Custom',
    'date.filter.custom.invalid.after.end': 'The From date has to be before the To date',
    'date.filter.custom.invalid.after.today': "The From date can\u2019t be in the future",
    'date.filter.custom.invalid.to.after.today': "The To date can\u2019t be in the future",
    'date.filter.from.label': 'Choose start date to filter',
    'date.filter.from.title': 'From',
    'date.filter.input.placeholder': 'Choose a date',
    'date.filter.last.month': 'Past 30 days',
    'date.filter.last.week': 'Past 7 days',
    'date.filter.last.year': 'Past year',
    'date.filter.title': 'Last updated',
    'date.filter.to.label': 'Choose end date to filter',
    'date.filter.to.range': 'to',
    'date.filter.to.title': 'To',
    'date.filter.today': 'Today',
    'date.filter.update.button': 'Update',
    'date.filter.yesterday': 'Yesterday',
    'deal.label': 'Deal',
    'design-search-result.label': 'Design',
    'design.label': 'Design',
    'document-search-result.google-docs-label': 'Docs',
    'document-search-result.google-sheets-label': 'Sheets',
    'document-search-result.google-slides-label': 'Slides',
    'document-search-result.ms-excel-label': 'Excel',
    'document-search-result.ms-powerpoint-label': 'PowerPoint',
    'document-search-result.ms-word-label': 'Word',
    'document.label': 'Document',
    draft_label: 'Draft',
    dropdown_generate_answer: 'Generate answer',
    dropdown_recent_icon_label: 'Recent',
    dropdown_search: 'Search',
    dropdown_search_icon_label: 'Search',
    'error-boundary.code': 'The code associated with this error: {code}',
    'error-boundary.description': 'The issue should resolve on its own, but if it keeps happening, ask your admin to contact {atlassianSupportLink} and give them:',
    'error-boundary.description.support-link': 'Atlassian Support',
    'error-boundary.reload-page': 'Refresh page',
    'error-boundary.support-link-text': 'our support team',
    'error-boundary.title': "We've hit a snag",
    'error-boundary.url': 'The URL of this page',
    error_primary: "We're having trouble searching",
    error_secondary: 'It might just be a hiccup. The best thing to do is to <btn>try again</btn>.',
    externalPeopleLabel: 'External people #{channelName}',
    externalPersonLabel: 'External person',
    'file.label': 'File',
    filter: 'Filter icon',
    give_feedback_text: 'Give feedback',
    'image.label': 'Image',
    'inline-app-selector.1p-3p-app-tooltip': 'Open a full page search for this term filtered by {productName} results',
    'inline-app-selector.additional-products': '+ {count}',
    'inline-app-selector.all-apps-tooltip': 'Open a full page search for this term searching all apps',
    'inline-product-filters.more-filters.tooltip': 'Open a full page search with more filter options for {product}',
    input_aria_label: 'Search, press enter to navigate to advanced search with your text query',
    input_clear_icon_label: 'Clear search',
    input_copy_link_icon_label: 'Copy link',
    input_placeholder: 'Search',
    input_placeholder_default: 'Search for anything',
    input_placeholder_ghost_text_kpi_acronym: 'Search any acronym, like "KPI"',
    input_placeholder_ghost_text_mention_teammates: '@mention a teammate to see their work',
    input_placeholder_ghost_text_search_across: 'Search across {products}, and more',
    input_placeholder_ghost_text_search_teammate: 'Search the name of a teammate',
    input_placeholder_ghost_text_submit_expense: 'Ask a question like "How do I submit an expense?"',
    input_placeholder_nav3: 'Search',
    input_placeholder_with_atlassian_intelligence: 'Search or ask anything',
    input_placeholder_with_rovo: 'Search or ask Rovo',
    input_search_icon_label: 'Search',
    'invoice.label': 'Invoice',
    'issue.label': 'Issue',
    issue_type: 'Work item',
    jira_advanced_search: 'Search Jira for work items',
    jira_single_site_boards: 'Boards',
    jira_single_site_filters: 'Filters',
    jira_single_site_label: 'Go to all:',
    jira_single_site_people: 'Teams',
    jira_single_site_plans: 'Plans',
    jira_single_site_projects: 'Projects',
    jira_single_site_spaces: 'Spaces',
    jira_single_site_work_items_jql: 'Work items (JQL)',
    landing_primary: 'Seek and you shall find',
    landing_secondary: "Search for what you're looking for in your Atlassian and connected apps",
    landing_secondary_rovo: "Search or ask Rovo what you're looking for in your Atlassian and connected apps",
    landing_secondary_unified_with_sain: 'Search or ask anything across your Atlassian apps',
    landing_secondary_unified_without_sain: 'Search for anything across your Atlassian apps',
    landing_secondary_with_atlassian_intelligence: "Search or ask what you're looking for in your Atlassian and connected apps",
    'leap-query.title.related-search': 'Related searches',
    'leap-query.title.teammates-also-ask': 'Your teammates also ask',
    'link-attachments.button.label': '{count, plural, one {# link} other {# links}}',
    live_doc_type: 'Live Doc',
    'more-actions-label': 'More Actions',
    'more-label': 'More',
    'new-product-message-banner-dismiss-message-button': 'Dismiss',
    'new-product-message-banner-text': "{product} was only recently added and we're still tweaking the results.",
    noOptions: 'No options',
    no_results_clear_filters: 'Clear filters',
    no_results_content_cleared_by_space_change: 'No results - the selected folder may have been moved or deleted.',
    no_results_primary: "We couldn't find anything matching your search",
    no_results_search_all_drives: 'Search all Drives',
    no_results_search_all_sites: 'Search all Sites',
    no_results_secondary_no_filters: 'Try again with a different term.',
    no_results_secondary_some_filters_applied: 'Looks like you have some filters applied. You could try clearing them.',
    'oauth-banner.acknowledgement.success-flag-action': 'Understood',
    'oauth-banner.authorization-fail': 'Failed to connect to {product}.',
    'oauth-banner.authorization-success': 'Account connected to {product}.',
    'oauth-banner.soft-banner-description': "You\u2019re seeing public channels. Connect your account to also search DMs and private channels.",
    'oauth-banner.soft-banner-title': 'Connect {product} for personalized results',
    'oauth-message-connect': 'Connect',
    'oauth-message-dismiss': 'Dismiss',
    'other.label': 'Other',
    'page.label': 'Page',
    page_type: 'Page',
    'pdf.label': 'PDF',
    'presentation.label': 'Presentation',
    'project.label': 'Project',
    'pull-request.label': 'Pull Request',
    pull_request_type: 'Pull Request',
    'quick-find-filters.filter-by-icon-label': 'Filter by Icon',
    'quick-find.assets.filter.assets-schema.icon.label': 'Assets schema filter',
    'quick-find.assets.filter.assets-schema.label.selected': 'Selected',
    'quick-find.assets.filter.assets-schema.label.unselected': 'Suggested',
    'quick-find.assets.filter.assets-schema.placeholder': 'Find schemas',
    'quick-find.assets.filter.assets-type.icon.label': 'Object type filter',
    'quick-find.assets.filter.assets-type.label.selected': 'Selected',
    'quick-find.assets.filter.assets-type.label.unselected': 'Suggested',
    'quick-find.assets.filter.assets-type.placeholder': 'Find object types',
    'quick-find.confluence.filter.contributor.placeholder': 'Find people',
    'quick-find.confluence.filter.label.selected': 'Selected',
    'quick-find.confluence.filter.label.unselected': 'Suggested',
    'quick-find.filter.type.label.selected': 'Selected',
    'quick-find.filter.type.label.unselected': 'Available',
    'quick-find.filter.type.placeholder': 'Find type',
    'quick-find.filters.clear-filters-button-label': 'Clear filters',
    'quick-find.filters.names.assets-schema': 'Schema',
    'quick-find.filters.names.assets-type': 'Object type',
    'quick-find.filters.names.assignee': 'Assignee',
    'quick-find.filters.names.contributor': 'Contributor',
    'quick-find.filters.names.project': 'Project',
    'quick-find.filters.names.spaces': 'Space',
    'quick-find.filters.names.type': 'Type',
    'quick-find.ghost-text.3p-multiple': 'Search {firstPartyApp}, {thirdPartyApp1}, {thirdPartyApp2} and other apps',
    'quick-find.ghost-text.3p.github': 'Search your GitHub repos, commits and PRs',
    'quick-find.ghost-text.3p.google-drive': 'Search your Google Drive Docs, Sheets and Slides',
    'quick-find.ghost-text.3p.onedrive': 'Search your OneDrive documents and files',
    'quick-find.ghost-text.3p.sharepoint': 'Search your SharePoint documents and files',
    'quick-find.ghost-text.3p.slack': 'Search your Slack DMs and messages',
    'quick-find.ghost-text.3p.teams': 'Search your Microsoft Teams chats and messages',
    'quick-find.ghost-text.control': 'Search',
    'quick-find.ghost-text.default-3p': 'Search across all your apps',
    'quick-find.ghost-text.mixed-apps': 'Search {currentApp}, {otherFirstPartyApp}, {thirdPartyApp} and other apps',
    'quick-find.ghost-text.sain': 'Ask me anything or search...',
    'quick-find.ghost-text.sain.benefits': 'Try any question, like "Where can I see my benefits?"',
    'quick-find.ghost-text.sain.it-support': 'Try any question, like "How do I contact IT support?"',
    'quick-find.ghost-text.sain.meeting-room': 'Try any question, like "How do I book a meeting room?"',
    'quick-find.ghost-text.sain.notifications': 'Try any question, like "How do I change my notification settings?"',
    'quick-find.ghost-text.sain.reset-password': 'Try any question, like "How do I reset my password?"',
    'quick-find.ghost-text.sain.time-off': 'Try any question, like "How do I request time off?"',
    'quick-find.ghost-text.two-apps': 'Search {firstPartyApp}, {thirdPartyApp1} and other apps',
    'quick-find.github.code.type': 'Code',
    'quick-find.jira.filter.assignee.placeholder': 'Find people',
    'quick-find.jira.filter.assignee.selected': 'Selected',
    'quick-find.jira.filter.assignee.unselected': 'Suggested',
    'quick-find.jira.filter.project.placeholder': 'Find projects',
    'quick-find.jira.filter.project.selected': 'Selected',
    'quick-find.jira.filter.project.unselected': 'Suggested',
    'quick-find.jira.filter.spaces.placeholder': 'Find spaces',
    'quick-find.jira.filter.spaces.selected': 'Selected',
    'quick-find.jira.filter.spaces.unselected': 'Suggested',
    'quick-find.mercury.focus-area-status-update.title': 'Update for {focusAreaName}',
    'quick-find.mercury.risk.icon-label': 'Risk',
    'quick-find.talent.position.external-position-key': 'External key {positionKey}',
    'quick-find.talent.position.title': '{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}',
    quick_find_connect_apps_button_aria_label: 'Open app connections',
    quick_find_connect_apps_label: 'Connect apps',
    'recentWork.eventTypeMessage.absolute.commented': 'You commented on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.created': 'You created on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.edited': 'You edited on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.published': 'You published on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.updated': 'You updated on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.viewed': 'You viewed on {absoluteTime}',
    'recentWork.eventTypeMessage.absolute.workedOn': 'You worked on {absoluteTime}',
    'recentWork.eventTypeMessage.commented': 'You commented',
    'recentWork.eventTypeMessage.created': 'You created',
    'recentWork.eventTypeMessage.edited': 'You edited',
    'recentWork.eventTypeMessage.multi.absolute.commented': 'Commented on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.created': 'Created on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.edited': 'Edited on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.published': 'Published on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.updated': 'Updated on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.viewed': 'Viewed on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.absolute.workedOn': 'Worked on {absoluteTime}',
    'recentWork.eventTypeMessage.multi.commented': 'Commented',
    'recentWork.eventTypeMessage.multi.created': 'Created',
    'recentWork.eventTypeMessage.multi.dateTime.workedOn': 'Worked on {relativeTime}',
    'recentWork.eventTypeMessage.multi.edited': 'Edited',
    'recentWork.eventTypeMessage.multi.published': 'Published',
    'recentWork.eventTypeMessage.multi.relative.commented': 'Commented {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.created': 'Created {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.edited': 'Edited {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.published': 'Published {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.updated': 'Updated {relativeTime}',
    'recentWork.eventTypeMessage.multi.relative.viewed': 'Viewed {relativeTime}',
    'recentWork.eventTypeMessage.multi.updated': 'Updated',
    'recentWork.eventTypeMessage.multi.viewed': 'Viewed',
    'recentWork.eventTypeMessage.multi.workedOn': 'Worked on',
    'recentWork.eventTypeMessage.published': 'You published',
    'recentWork.eventTypeMessage.relative.commented': 'You commented {relativeTime}',
    'recentWork.eventTypeMessage.relative.created': 'You created {relativeTime}',
    'recentWork.eventTypeMessage.relative.edited': 'You edited {relativeTime}',
    'recentWork.eventTypeMessage.relative.published': 'You published {relativeTime}',
    'recentWork.eventTypeMessage.relative.updated': 'You updated {relativeTime}',
    'recentWork.eventTypeMessage.relative.viewed': 'You viewed {relativeTime}',
    'recentWork.eventTypeMessage.relative.workedOn': 'You worked on {relativeTime}',
    'recentWork.eventTypeMessage.updated': 'You updated',
    'recentWork.eventTypeMessage.viewed': 'You viewed',
    'recentWork.eventTypeMessage.workedOn': 'You worked on',
    recents_heading: 'Search Results',
    'recommended.eventTypeMessage.icu.absolute.clicked': '{actor, select, you {You clicked on {absoluteTime}} collaborator {Collaborator clicked on {absoluteTime}} other {{username} clicked on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.commented': '{actor, select, you {You commented on {absoluteTime}} collaborator {Collaborator commented on {absoluteTime}} other {{username} commented on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.created': '{actor, select, you {You created on {absoluteTime}} collaborator {Collaborator created on {absoluteTime}} other {{username} created on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.edited': '{actor, select, you {You edited on {absoluteTime}} collaborator {Collaborator edited on {absoluteTime}} other {{username} edited on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.interacted': '{actor, select, you {You interacted on {absoluteTime}} collaborator {Collaborator interacted on {absoluteTime}} other {{username} interacted on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.mentioned': '{actor, select, you {You were mentioned on {absoluteTime}} collaborator {Collaborator was mentioned on {absoluteTime}} other {{username} was mentioned on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.reacted': '{actor, select, you {You reacted on {absoluteTime}} collaborator {Collaborator reacted on {absoluteTime}} other {{username} reacted on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.read': '{actor, select, you {You read on {absoluteTime}} collaborator {Collaborator read on {absoluteTime}} other {{username} read on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.shared': '{actor, select, you {You shared on {absoluteTime}} collaborator {Collaborator shared on {absoluteTime}} other {{username} shared on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.absolute.viewed': '{actor, select, you {You viewed on {absoluteTime}} collaborator {Collaborator viewed on {absoluteTime}} other {{username} viewed on {absoluteTime}}}',
    'recommended.eventTypeMessage.icu.clicked': '{actor, select, you {You clicked} collaborator {Collaborator clicked} other {{username} clicked}}',
    'recommended.eventTypeMessage.icu.commented': '{actor, select, you {You commented} collaborator {Collaborator commented} other {{username} commented}}',
    'recommended.eventTypeMessage.icu.created': '{actor, select, you {You created} collaborator {Collaborator created} other {{username} created}}',
    'recommended.eventTypeMessage.icu.edited': '{actor, select, you {You edited} collaborator {Collaborator edited} other {{username} edited}}',
    'recommended.eventTypeMessage.icu.interacted': '{actor, select, you {You interacted} collaborator {Collaborator interacted} other {{username} interacted}}',
    'recommended.eventTypeMessage.icu.mentioned': '{actor, select, you {You were mentioned} collaborator {Collaborator was mentioned} other {{username} was mentioned}}',
    'recommended.eventTypeMessage.icu.reacted': '{actor, select, you {You reacted} collaborator {Collaborator reacted} other {{username} reacted}}',
    'recommended.eventTypeMessage.icu.read': '{actor, select, you {You read} collaborator {Collaborator read} other {{username} read}}',
    'recommended.eventTypeMessage.icu.relative.clicked': '{actor, select, you {You clicked {relativeTime}} collaborator {Collaborator clicked {relativeTime}} other {{username} clicked {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.commented': '{actor, select, you {You commented {relativeTime}} collaborator {Collaborator commented {relativeTime}} other {{username} commented {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.created': '{actor, select, you {You created {relativeTime}} collaborator {Collaborator created {relativeTime}} other {{username} created {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.edited': '{actor, select, you {You edited {relativeTime}} collaborator {Collaborator edited {relativeTime}} other {{username} edited {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.interacted': '{actor, select, you {You interacted {relativeTime}} collaborator {Collaborator interacted {relativeTime}} other {{username} interacted {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.mentioned': '{actor, select, you {You were mentioned {relativeTime}} collaborator {Collaborator was mentioned {relativeTime}} other {{username} was mentioned {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.reacted': '{actor, select, you {You reacted {relativeTime}} collaborator {Collaborator reacted {relativeTime}} other {{username} reacted {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.read': '{actor, select, you {You read {relativeTime}} collaborator {Collaborator read {relativeTime}} other {{username} read {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.shared': '{actor, select, you {You shared {relativeTime}} collaborator {Collaborator shared {relativeTime}} other {{username} shared {relativeTime}}}',
    'recommended.eventTypeMessage.icu.relative.viewed': '{actor, select, you {You viewed {relativeTime}} collaborator {Collaborator viewed {relativeTime}} other {{username} viewed {relativeTime}}}',
    'recommended.eventTypeMessage.icu.shared': '{actor, select, you {You shared} collaborator {Collaborator shared} other {{username} shared}}',
    'recommended.eventTypeMessage.icu.viewed': '{actor, select, you {You viewed} collaborator {Collaborator viewed} other {{username} viewed}}',
    'relay.jira-dc-work-item.issue-label': 'Issue',
    'relay.jira-dc-work-item.work-item.work-item-label': 'Work item',
    'relay.jira-dc.comment-result.label': 'Comment',
    'relay.jira-dc.issue-result.label': 'Work item',
    'relay.jira-dc.project-result.label': 'Project',
    'relay.jira-dc.space-result.label': 'Space',
    'relay.jira-dc.work-item-assignee.assigned': '{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}',
    'relay.jira-dc.work-item-creator.created': '{created, select, internal {{firstName} created} other {External person created}}',
    'relay.jira-dc.work-item-status.for': '{statusLozenge} for {dateLozenge}',
    'relay.search-page.results.product-results.third-party.conversation-search-result.tabs-label': 'Tabs',
    'relay.search-page.results.product-results.third-party.message-search-result.file-attachments-expand-button-label': '{count, plural, one {# attachment} other {# attachments}}',
    'relay.search-page.results.product-results.third-party.message-search-result.member-count': '{count, plural, one {# member} other {# members}}',
    'relay.search-page.results.product-results.third-party.message-search-result.smartlink-attachments-expand-button-label': '{count, plural, one {# link} other {# links}}',
    'relay.search-result.attachment-label': 'Attachment',
    'relay.search-result.attachments.attached-date.label': 'Attached {formattedDate}',
    'relay.search-result.attachments.audio-label': 'Audio',
    'relay.search-result.attachments.expand.label': 'Expand',
    'relay.search-result.attachments.image-label': 'Image',
    'relay.search-result.attachments.pdf-label': 'PDF',
    'relay.search-result.attachments.video-label': 'Video',
    'relay.search-result.message-last-active': 'Last active {formattedDate}',
    'relay.search-result.message-type-label': 'Message',
    'relay.search-result.multi-workspace-label': 'Multi-workspace',
    'relay.search-result.private-channel-label': 'Private Channel',
    'relay.search-result.thread-type-label': 'Thread',
    relevance: 'Relevance',
    'repository.label': 'Repository',
    'results-sort.createdDate.selected': 'Sort by created (newest)',
    'results-sort.createdDateASC': 'Created (oldest)',
    'results-sort.createdDateASCSelected.selected': 'Sort by created (oldest)',
    'results-sort.createdDateDESC': 'Created (newest)',
    'results-sort.latestModifiedDateASC': 'Updated (oldest)',
    'results-sort.latestModifiedDateASC.selected': 'Sort by updated (oldest)',
    'results-sort.latestModifiedDateDESC': 'Updated (newest)',
    'results-sort.latestModifiedDateDESC.selected': 'Sort by updated (newest)',
    'results-sort.relevanceDESC': 'Relevance',
    'results-sort.relevanceDESC.selected': 'Sort by relevance',
    'results-sort.sort-options.label': 'Change list sorting',
    'rovo-onboarding-got-it': 'Got it',
    'rovo-onboarding-step-1-description': 'Choose an app to get more relevant results and filters. For example, filter by Space in Confluence.',
    'rovo-onboarding-step-1-heading': 'Search across company apps',
    'rovo-search.assets.filter.icon.label': 'Assets filter',
    'rovo-search.confluence.filter.icon.label': 'Confluence filter',
    'rovo-search.jira.filter.icon.label': 'Jira filter',
    'rovo-search.talent.filter.icon.label': 'Talent filter',
    'rovo.search.quick-find-3p.connect': 'Connect {connectorName}',
    'rovo.search.quick-find-3p.dismiss': 'Dismiss',
    'rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.body': 'Connect to see missing results',
    'rovo.search.quick-find-3p.full-connector.admin-blessed-missing-results.heading-v2': 'Your admin added {connectorName}.',
    'rovo.search.quick-find-3p.full-connector.social-proof-high.heading-v2': '{teamConnectAppPercentage}% of your team have connected apps',
    'rovo.search.quick-find-3p.smart-link-connector.social-proof-high.heading-v3': '{teamConnectAppPercentage}% of your team have connected apps',
    'rovo.search.quick-find-3p.smart-link-connector.social-proof-low.body': 'Connect your account to see missing results',
    'rovo.search.quick-find-3p.smart-link-connector.social-proof-low.heading-v2': '{connectorName} is now available!',
    'rovo.search.quick-find-authorization-fail': 'Failed to connect to {product}.',
    'rovo.search.quick-find.authorization-success': 'Account connected to {product}.',
    'seaech-page.townsquare.api.goal-state.archived': 'Archived',
    'seaech-page.townsquare.api.goal-state.at-risk': 'At risk',
    'seaech-page.townsquare.api.goal-state.cancelled': 'Canceled',
    'seaech-page.townsquare.api.goal-state.completed': 'Completed',
    'seaech-page.townsquare.api.goal-state.off-track': 'Off track',
    'seaech-page.townsquare.api.goal-state.on-track': 'On track',
    'seaech-page.townsquare.api.goal-state.paused': 'Paused',
    'seaech-page.townsquare.api.goal-state.pending': 'Pending',
    'search-branch-result.label': 'Branch',
    'search-commit-result.committed': 'Committed {formattedDate}',
    'search-commit-result.label': 'Commit',
    'search-federated-result.email.label': 'Email',
    'search-federated-result.external-person.label': 'External person',
    'search-federated-result.forwarded.label': '{person} forwarded',
    'search-federated-result.inbox.label': 'Inbox',
    'search-federated-result.sent.label': '{person} sent',
    'search-federated-result.timestamp.label': '{formattedDate}',
    'search-filters.filter-by-icon': 'Filter by icon',
    'search-filters.names.contributor': 'Contributor',
    'search-filters.names.type': 'Type',
    'search-git-build-status.failed': '{failed} of {total} failed',
    'search-git-build-status.failed-generic': 'Build failed',
    'search-git-build-status.icon-label': 'Build status',
    'search-git-build-status.passed': '{passed} of {total} passed',
    'search-git-build-status.passed-generic': 'Build passed',
    'search-git-build-status.paused': 'Build paused',
    'search-git-build-status.pending': 'Build pending',
    'search-git-build-status.running': 'Build in progress',
    'search-git-build-status.stopped': 'Build stopped',
    'search-git-build-status.unknown': 'Build status unknown',
    'search-graph-calendar.calendar-label': 'Calendar',
    'search-graph-calendar.created.placeholder': '{person} created',
    'search-graph-calendar.external-person': 'External person',
    'search-graph-calendar.join-meeting-link': 'Join meeting',
    'search-graph-calendar.meeting-link': 'Meeting link',
    'search-graph-calendar.meeting-link-icon': 'Join meeting',
    'search-graph-calendar.past-events-button': 'Past events',
    'search-graph-calendar.recurring-event-icon': 'Recurring event',
    'search-graph-calendar.recurring-event-label': 'Recurring',
    'search-graph-calendar.upcoming-events-button': 'Upcoming events',
    'search-graph-campaign.campaign-label': 'Campaign',
    'search-graph-campaign.ended-on': 'Ended on {date}',
    'search-graph-campaign.ends-on': 'Ends on {date}',
    'search-graph-case.case-label': 'Case',
    'search-graph-case.closed-on': 'Closed on {date}',
    'search-graph-case.closes-on': 'Closes on {date}',
    'search-graph-confluence-dc.document.attachmentLabel': 'Attachment',
    'search-graph-confluence-dc.document.blogpostLabel': 'Blog Post',
    'search-graph-confluence-dc.document.commentLabel': 'Comment',
    'search-graph-confluence-dc.document.pageLabel': 'Page',
    'search-graph-confluence-dc.document.spaceLabel': 'Space',
    'search-graph-customer-contact.customer-contact-label': 'Customer Contact',
    'search-graph-customer-org.customer-org-label': 'Customer Organization',
    'search-graph-dashboard.dashboard-label': 'Dashboard',
    'search-graph-data-table.data-table-label': 'Data table',
    'search-graph-deal.closed-on': 'Closed on {date}',
    'search-graph-deal.closes-on': 'Closes on {date}',
    'search-graph-deal.deal-label': 'Deal',
    'search-graph-default.dashboard.label': 'Dashboard',
    'search-graph-default.deal.label': 'Deal',
    'search-graph-default.design.label': 'Design',
    'search-graph-default.invoice.label': 'Invoice',
    'search-graph-default.task.label': 'Task',
    'search-graph-jira-dc.comment-result.label': 'Comment',
    'search-graph-jira-dc.issue-result.label': 'Work item',
    'search-graph-jira-dc.project-result.label': 'Project',
    'search-graph-jira-dc.space-result.label': 'Space',
    'search-graph-lead.lead-label': 'Lead',
    'search-graph-video.dropdown-message': '{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}',
    'search-graph-video.duration.hours': '{hours} hour {minutes} min',
    'search-graph-video.duration.minutes': '{minutes} min',
    'search-graph-video.duration.seconds': '{seconds} sec',
    'search-graph-video.past-meetings': 'Past meetings',
    'search-graph-video.past-meetings-updated': 'Updated {relativeTime}',
    'search-graph-video.see-all': 'See all',
    'search-graph-video.video-icon-label': 'video icon',
    'search-graph-video.video-thumbnail-alt-text': 'Video thumbnail',
    'search-graph-video.video-type': 'Video',
    'search-graph-work-item.approval': 'Approval',
    'search-graph-work-item.bug.label': 'Bug',
    'search-graph-work-item.catalog_item': 'Catalog item',
    'search-graph-work-item.epic.label': 'Epic',
    'search-graph-work-item.incident': 'Incident',
    'search-graph-work-item.issue': 'Issue',
    'search-graph-work-item.label': 'Work item',
    'search-graph-work-item.milestone.label': 'Milestone',
    'search-graph-work-item.problem': 'Problem',
    'search-graph-work-item.question': 'Question',
    'search-graph-work-item.requested_item': 'Requested item',
    'search-graph-work-item.section': 'Section',
    'search-graph-work-item.story.label': 'Story',
    'search-graph-work-item.task.label': 'Task',
    'search-graph-work-item.ticket': 'Ticket',
    'search-page-relay.filters.product-filters.slack-channel.label': 'Channel',
    'search-page-relay.filters.product-filters.slack-channel.placeholder': 'Filter by channel',
    'search-page-relay.filters.product-filters.slack-channel.selected-label': 'Selected',
    'search-page-relay.filters.product-filters.slack-channel.suggested-label': 'Channels',
    'search-page-relay.filters.product-filters.workspace-name.label': 'Team',
    'search-page-relay.filters.product-filters.workspace-name.placeholder': 'Filter by team',
    'search-page-relay.filters.product-filters.workspace-name.selected-label': 'Selected',
    'search-page-relay.filters.product-filters.workspace-name.suggested-label': 'Teams',
    'search-page-relay.results.product-results.third-party.conversation-search-result.label': 'Channel',
    'search-page-relay.results.product-results.third-party.conversation-search-result.member-count': '{count, plural, one {# member} other {# members}}',
    'search-page-relay.results.product-results.third-party.conversation-search-result.multi-workspace-channel-label': 'Multi-workspace channel',
    'search-page-relay.results.product-results.third-party.conversation-search-result.private-channel': 'Private channel',
    'search-page-relay.results.product-results.third-party.conversation-search-result.time-since-label': 'Last active {formattedDate}',
    'search-page-relay.results.product-results.third-party.conversation-search-result.unknown-channel': 'unknown-channel',
    'search-page.ai-mode.ai-mode': 'AI Mode',
    'search-page.ai-mode.results': 'Results',
    'search-page.app-filter-sidebar.all': 'All',
    'search-page.app-filter-sidebar.connect-apps-description': 'Get better answers and more results across Search and Chat.',
    'search-page.app-filter-sidebar.connect-apps-header': 'Connect apps',
    'search-page.app-filter-sidebar.connected-apps-header': 'Filter results',
    'search-page.app-filter-sidebar.filter-menu.menu-item.hide': 'Hide app',
    'search-page.app-filter-sidebar.filter-menu.trigger': 'Show more options',
    'search-page.app-filter-sidebar.group': 'Filter search by app',
    'search-page.app-filter-sidebar.improve-search': 'Improve search',
    'search-page.app-filter-sidebar.no-matching-results-tooltip': 'No matching results in {product}',
    'search-page.app-filter-sidebar.product-timeout-button-text': 'See only {product} results',
    'search-page.app-filter-sidebar.product-timeout-primary-text': '{product} results took too long to show',
    'search-page.app-filter-sidebar.product-timeout-secondary-text': 'Try again by filtering just for {product}.',
    'search-page.app-filter-sidebar.product-timeout-tooltip': '{product} results were too slow to show',
    'search-page.app-filter-sidebar.show-all-apps.button.label': 'Show all apps',
    'search-page.app-filter-sidebar.show-more.button.label': 'Show more',
    'search-page.app-filter-sidebar.show-more.filter.placeholder': 'Find apps',
    'search-page.assets.filter.assets-schema.icon.label': 'Assets schema filter',
    'search-page.assets.filter.assets-schema.label.selected': 'Selected',
    'search-page.assets.filter.assets-schema.label.unselected': 'Suggested',
    'search-page.assets.filter.assets-schema.placeholder': 'Find schemas',
    'search-page.assets.filter.assets-type.icon.label': 'Object type filter',
    'search-page.assets.filter.assets-type.label.selected': 'Selected',
    'search-page.assets.filter.assets-type.label.unselected': 'Suggested',
    'search-page.assets.filter.assets-type.placeholder': 'Find object types',
    'search-page.atlas.for': 'for',
    'search-page.atlas.goal.for': 'for',
    'search-page.auto-correction.did-you-mean': 'Did you mean {suggestedQuery}',
    'search-page.auto-correction.search-instead-for': 'Search instead for {originalQuery}',
    'search-page.auto-correction.showing-results-for': 'Showing results for {replacementQuery}',
    'search-page.browser-extension-banner.close-button-label': 'Close browser extension banner',
    'search-page.browser-extension-banner.link-text': 'Get the browser extension',
    'search-page.browser-extension-banner.title': 'Use Rovo wherever you are',
    'search-page.close-date-filter.date-label': 'Select date',
    'search-page.close-date-filter.date-placeholder': 'Select a date',
    'search-page.close-date-filter.label': 'Close date',
    'search-page.close-date-filter.update-button': 'Apply',
    'search-page.comment-icon-label': 'Comment',
    'search-page.common.display-name-tooltip.displayNameLabel': 'Display name: {displayName}',
    'search-page.common.display-name-tooltip.nameLabel': 'Name: {name}',
    'search-page.common.graph-work-item-status.closed': 'Closed',
    'search-page.common.graph-work-item-status.open': 'Open',
    'search-page.common.status-target-date-display.for': 'for',
    'search-page.common.ui.clear-filter-button.label': 'Clear filter',
    'search-page.common.ui.quick-find.search-dialog-announcer.availableOptions': '{count} options available',
    'search-page.common.ui.quick-find.search-dialog-announcer.errorAnnouncement': "Something went wrong. We couldn't load your search results. Please try again.",
    'search-page.common.ui.quick-find.search-dialog-announcer.noResultsAnnouncement': "We couldn't find any results with that title",
    'search-page.common.ui.top-reaction.image-reaction-fallback-label': 'Like',
    'search-page.common.ui.top-reaction.unicode-reaction-aria-label': '{emojiName} reaction',
    'search-page.confluence.filter.content.placeholder': 'Find content',
    'search-page.confluence.filter.content.selected': 'Selected',
    'search-page.confluence.filter.content.unselected': 'Suggested',
    'search-page.confluence.filter.contributor.label.selected': 'Selected',
    'search-page.confluence.filter.contributor.label.unselected': 'Suggested',
    'search-page.confluence.filter.contributor.placeholder': 'Find people',
    'search-page.confluence.filter.creator.placeholder': 'Find people',
    'search-page.confluence.filter.creator.selected': 'Selected',
    'search-page.confluence.filter.creator.unselected': 'Suggested',
    'search-page.confluence.filter.icon.label': 'Confluence filter',
    'search-page.confluence.filter.label.selected': 'Selected',
    'search-page.confluence.filter.label.unselected': 'Suggested',
    'search-page.confluence.filter.labels.placeholder': 'Find labels',
    'search-page.confluence.filter.space.icon': 'Space Icon',
    'search-page.confluence.filter.space.placeholder': 'Find spaces',
    'search-page.dropdown.search-suggestions': 'Search Suggestions Dropdown',
    'search-page.embedded-comments.comment-header-prefix': 'Re: {label}',
    'search-page.filter.app-select.all': 'All',
    'search-page.filter.app-select.label.selected': 'Selected',
    'search-page.filter.app-select.label.unselected': 'Suggested',
    'search-page.filter.app-select.placeholder': 'Find app',
    'search-page.filter.app-select.tooltip.redirect': 'Open a full page search filtered by {appLabel} results',
    'search-page.filter.clear.filter.label': 'Clear filter',
    'search-page.filter.close.date.anytime': 'Anytime',
    'search-page.filter.close.date.custom': 'Specific date',
    'search-page.filter.close.date.last30days': 'Last 30 days',
    'search-page.filter.close.date.last365days': 'Last 365 days',
    'search-page.filter.close.date.last7days': 'Last 7 days',
    'search-page.filter.close.date.last90days': 'Last 90 days',
    'search-page.filter.close.date.next30days': 'Next 30 days',
    'search-page.filter.close.date.next365days': 'Next 365 days',
    'search-page.filter.close.date.next7days': 'Next 7 days',
    'search-page.filter.close.date.next90days': 'Next 90 days',
    'search-page.filter.close.date.today': 'Today',
    'search-page.filter.last.updated.anytime': 'Anytime',
    'search-page.filter.last.updated.custom': 'Custom',
    'search-page.filter.last.updated.past30Days': 'Past 30 days',
    'search-page.filter.last.updated.past7Days': 'Past 7 days',
    'search-page.filter.last.updated.pastYear': 'Past year',
    'search-page.filter.last.updated.today': 'Today',
    'search-page.filter.last.updated.yesterday': 'Yesterday',
    'search-page.filter.opportunityStatus.all': 'Any',
    'search-page.filter.opportunityStatus.closed': 'Closed',
    'search-page.filter.opportunityStatus.open': 'Open',
    'search-page.filter.pageStatus.all': 'All',
    'search-page.filter.pageStatus.inProgress': 'In progress',
    'search-page.filter.pageStatus.readyForReview': 'Ready for review',
    'search-page.filter.pageStatus.roughDraft': 'Rough draft',
    'search-page.filter.pageStatus.verified': 'Verified',
    'search-page.filter.pull-request-status.declined': 'Declined',
    'search-page.filter.pull-request-status.draft': 'Draft',
    'search-page.filter.pull-request-status.merged': 'Merged',
    'search-page.filter.pull-request-status.open': 'Open',
    'search-page.filter.pull-request-status.unknown': 'Unknown',
    'search-page.filter.reviewer.label.selected': 'Selected',
    'search-page.filter.reviewer.label.unselected': 'Suggested',
    'search-page.filter.reviewer.placeholder': 'Find people',
    'search-page.filter.status.done': 'Done',
    'search-page.filter.status.indeterminate': 'In Progress (Open)',
    'search-page.filter.status.new': 'To Do (Open)',
    'search-page.filter.status.open': 'Open',
    'search-page.filter.status.undefined': 'Other',
    'search-page.filter.suggested.options.section': 'Suggested',
    'search-page.filter.type.Story': 'Story',
    'search-page.filter.type.all': 'All',
    'search-page.filter.type.answer': 'Answers',
    'search-page.filter.type.archive': 'Archive',
    'search-page.filter.type.article': 'Articles',
    'search-page.filter.type.ask': 'Asks',
    'search-page.filter.type.attachment': 'Attachments',
    'search-page.filter.type.audio': 'Audio',
    'search-page.filter.type.blogpost': 'Blog posts',
    'search-page.filter.type.board': 'Boards',
    'search-page.filter.type.branch': 'Branches',
    'search-page.filter.type.bug': 'Bug',
    'search-page.filter.type.calendar': 'Calendars',
    'search-page.filter.type.campaign': 'Campaigns',
    'search-page.filter.type.card': 'Cards',
    'search-page.filter.type.case': 'Cases',
    'search-page.filter.type.catalog-item': 'Catalog items',
    'search-page.filter.type.code': 'Code',
    'search-page.filter.type.comment': 'Comments',
    'search-page.filter.type.commit': 'Commits',
    'search-page.filter.type.component': 'Components',
    'search-page.filter.type.conversation': 'Channels',
    'search-page.filter.type.customer-contact': 'Customer Contacts',
    'search-page.filter.type.customer-org': 'Customer Organizations',
    'search-page.filter.type.dashboard': 'Dashboards',
    'search-page.filter.type.data-table': 'Data tables',
    'search-page.filter.type.database': 'Databases',
    'search-page.filter.type.deal': 'Deals',
    'search-page.filter.type.demand': 'Demands',
    'search-page.filter.type.design': 'Designs',
    'search-page.filter.type.devops-work-item': 'Issues',
    'search-page.filter.type.documents': 'Documents',
    'search-page.filter.type.embed': 'Smart Links',
    'search-page.filter.type.epic': 'Epic',
    'search-page.filter.type.filter': 'Filters',
    'search-page.filter.type.focus-area': 'Focus areas',
    'search-page.filter.type.folder': 'Folders',
    'search-page.filter.type.form': 'Form',
    'search-page.filter.type.gliffy': 'Gliffy Diagrams',
    'search-page.filter.type.goal': 'Goals',
    'search-page.filter.type.image': 'Images',
    'search-page.filter.type.incident': 'Incidents',
    'search-page.filter.type.invoice': 'Invoices',
    'search-page.filter.type.jira-work-item': 'Work items',
    'search-page.filter.type.knowledge-article': 'Knowledge articles',
    'search-page.filter.type.lead': 'Leads',
    'search-page.filter.type.message': 'Messages',
    'search-page.filter.type.news-article': 'News articles',
    'search-page.filter.type.notebook': 'Notebook',
    'search-page.filter.type.object': 'Objects',
    'search-page.filter.type.organization': 'Organizations',
    'search-page.filter.type.other': 'Other',
    'search-page.filter.type.page': 'Pages',
    'search-page.filter.type.pageAndLiveDoc': 'Pages and Live Docs',
    'search-page.filter.type.pdf': 'PDF',
    'search-page.filter.type.placeholder': 'Find type',
    'search-page.filter.type.plan': 'Plans',
    'search-page.filter.type.position': 'Positions',
    'search-page.filter.type.post': 'Posts',
    'search-page.filter.type.presentation': 'Presentations',
    'search-page.filter.type.project': 'Projects',
    'search-page.filter.type.pull-request': 'Pull requests',
    'search-page.filter.type.question': 'Questions',
    'search-page.filter.type.repository': 'Repositories',
    'search-page.filter.type.requested-item': 'Requested items',
    'search-page.filter.type.risk': 'Risks',
    'search-page.filter.type.schema': 'Schemas',
    'search-page.filter.type.shortcut': 'Shortcut',
    'search-page.filter.type.slide': 'Slides',
    'search-page.filter.type.space': 'Spaces',
    'search-page.filter.type.space-calendar': 'Space calendars',
    'search-page.filter.type.spreadsheet': 'Spreadsheets',
    'search-page.filter.type.subtask': 'Subtask',
    'search-page.filter.type.tag': 'Tags',
    'search-page.filter.type.task': 'Task',
    'search-page.filter.type.ticket': 'Tickets',
    'search-page.filter.type.type': 'Object types',
    'search-page.filter.type.video': 'Videos',
    'search-page.filter.type.web-page': 'Web pages',
    'search-page.filter.type.whiteboard': 'Whiteboards',
    'search-page.filter.type.work-item': 'Tasks',
    'search-page.filters.clear-filters-button-label': 'Clear filters',
    'search-page.filters.dropdown.button': 'More filters',
    'search-page.filters.dropdown.clear-filters': 'Clear filters',
    'search-page.filters.names.app-select': 'App',
    'search-page.filters.names.archived': 'Show archived content',
    'search-page.filters.names.archivedAndPendingComponents': 'Show archived/pending components',
    'search-page.filters.names.assets-schema': 'Schema',
    'search-page.filters.names.assets-type': 'Object type',
    'search-page.filters.names.assignee': 'Assignee',
    'search-page.filters.names.closeDate': 'Close date',
    'search-page.filters.names.content': 'Content under',
    'search-page.filters.names.contributor': 'Contributor',
    'search-page.filters.names.createdBy': 'Created by',
    'search-page.filters.names.drive': 'Drive',
    'search-page.filters.names.focusAreaType': 'Focus area type',
    'search-page.filters.names.focusAreaUnder': 'Focus area under',
    'search-page.filters.names.has-attachment': 'Has attachment',
    'search-page.filters.names.labels': 'Label',
    'search-page.filters.names.lastUpdated': 'Last updated',
    'search-page.filters.names.lastUpdatedBy': 'Last updated by',
    'search-page.filters.names.owner': 'Owner',
    'search-page.filters.names.pageStatus': 'Status',
    'search-page.filters.names.position-status-filter': 'Filled status',
    'search-page.filters.names.positionEmploymentType': 'Employment type',
    'search-page.filters.names.positionFocusArea': 'Focus area',
    'search-page.filters.names.positionJobFamily': 'Job family',
    'search-page.filters.names.positionTeam': 'Team',
    'search-page.filters.names.project': 'Project',
    'search-page.filters.names.pull-request-status': 'PR status',
    'search-page.filters.names.reporter': 'Reporter',
    'search-page.filters.names.repository': 'Repository',
    'search-page.filters.names.repository.no-options': 'No repositories available',
    'search-page.filters.names.reviewer': 'Reviewer',
    'search-page.filters.names.site': 'Site',
    'search-page.filters.names.space': 'Space',
    'search-page.filters.names.spaces': 'Space',
    'search-page.filters.names.status': 'Status',
    'search-page.filters.names.titleMatchOnly': 'Search title only',
    'search-page.filters.names.type': 'Type',
    'search-page.filters.names.verified': 'Verified',
    'search-page.filters.names.work-commented-on': "Work I've commented on",
    'search-page.filters.names.work-watching': "Work I\u2019m watching",
    'search-page.filters.suggested-filters-section-label': 'Suggested',
    'search-page.google-drive.filter.drive.placeholder': 'Find drives',
    'search-page.jira-assignee.assignee': 'Assignee: {assigneeName}',
    'search-page.jira-assignee.unassigned': 'Unassigned',
    'search-page.jira.filter.assignee.placeholder': 'Find people',
    'search-page.jira.filter.assignee.selected': 'Selected',
    'search-page.jira.filter.assignee.unselected': 'Suggested',
    'search-page.jira.filter.project.placeholder': 'Find projects',
    'search-page.jira.filter.project.selected': 'Selected',
    'search-page.jira.filter.project.unselected': 'Suggested',
    'search-page.jira.filter.reporter.placeholder': 'Find people',
    'search-page.jira.filter.reporter.selected': 'Selected',
    'search-page.jira.filter.reporter.unselected': 'Suggested',
    'search-page.jira.filter.spaces.placeholder': 'Find spaces',
    'search-page.jira.filter.spaces.selected': 'Selected',
    'search-page.jira.filter.spaces.unselected': 'Suggested',
    'search-page.linked-pull-requests.expand-label': '{count}{hasMore, select, true {+} other {}} {count, plural, one {Pull request} other {Pull requests}}',
    'search-page.linked-pull-requests.last-updated': 'Updated {relativeTime}',
    'search-page.linked-pull-requests.metadata-label': 'Pull Request',
    'search-page.linked-pull-requests.pull-request-id': 'ID# {prId}',
    'search-page.linked-pull-requests.reviewer-count': '{count, plural, =0 {No reviewers} one {# reviewer} other {# reviewers}}',
    'search-page.linked-pull-requests.status-declined': 'Declined',
    'search-page.linked-pull-requests.status-draft': 'Draft',
    'search-page.linked-pull-requests.status-merged': 'Merged',
    'search-page.linked-pull-requests.status-open': 'Open',
    'search-page.linked-pull-requests.status-unknown': 'Unknown',
    'search-page.linked-results.comments': 'Comments',
    'search-page.linked-results.external-link': 'External link',
    'search-page.linked-results.found-in': 'Found in',
    'search-page.linked-results.mentioned-in': 'Mentioned in',
    'search-page.linked-results.related': 'Related links',
    'search-page.linked-results.related-pages': 'Related pages',
    'search-page.linked-results.see-all': 'See all',
    'search-page.linked-results.show-more': 'Show {count} more',
    'search-page.linked-results.similar': '{count} similar',
    'search-page.mercury.filter.content.placeholder': 'Find focus areas',
    'search-page.mercury.filter.content.selected': 'Selected',
    'search-page.mercury.filter.content.unselected': 'Suggested',
    'search-page.mercury.filter.focusAreaType.label.selected': 'Selected',
    'search-page.mercury.filter.focusAreaType.label.unselected': 'Suggested',
    'search-page.mercury.filter.focusAreaType.placeholder': 'Find focus area types',
    'search-page.mercury.focus-area-update.title': 'Update for {focusAreaName}',
    'search-page.navigation.search.work-items': 'Search work items',
    'search-page.nouns.goal': 'Goal',
    'search-page.nouns.goals': 'Goals',
    'search-page.nouns.project': 'Project',
    'search-page.nouns.projects': 'Projects',
    'search-page.nouns.tag': 'Tag',
    'search-page.nouns.tags': 'Tags',
    'search-page.products.custom-website': 'Web page',
    'search-page.products.custom-websites': 'Web pages',
    'search-page.profile-avatar.label': 'Person Avatar',
    'search-page.quick-find.dialog.banners.github-tip.dismissBannerLabel': 'Dismiss GitHub tip',
    'search-page.quick-find.dialog.banners.github-tip.oauthFailFlagTitle': 'Could not connect to GitHub',
    'search-page.quick-find.dialog.banners.github-tip.oauthSuccessFlagDescription': 'You can now find and action on PRs, commits, and repos in Rovo Search and Chat.',
    'search-page.quick-find.dialog.banners.github-tip.oauthSuccessFlagTitle': 'GitHub connected',
    'search-page.quick-find.dialog.banners.github-tip.tipBanner': '<b>Tip:</b> <connectLink>Connect GitHub</connectLink> to find and action on PRs, issues, and repos in your search results.',
    'search-page.quick-find.dialog.chat-intent-router.chat': 'Ask Rovo',
    'search-page.quick-find.dialog.chat-intent-router.results-heading': 'Search results',
    'search-page.quick-find.dialog.chat-intent-router.search': 'Search all apps',
    'search-page.quick-find.dialog.chat-intent-router.search-for-query': 'Search',
    'search-page.quick-find.filters.product-filters.loom-folder.loomFilterFolderIcon': 'Folder Icon',
    'search-page.quick-find.filters.product-filters.loom-folder.loomFilterFolderPlaceholder': 'Find folders',
    'search-page.quick-find.filters.product-filters.loom-folder.loomFilterLabelSelected': 'Selected',
    'search-page.quick-find.filters.product-filters.loom-folder.loomFilterLabelUnselected': 'Suggested',
    'search-page.quick-find.filters.product-filters.loom-folder.loomFolder': 'Folder',
    'search-page.quick-find.filters.product-filters.loom-space.loomFilterLabelSelected': 'Selected',
    'search-page.quick-find.filters.product-filters.loom-space.loomFilterLabelUnselected': 'Suggested',
    'search-page.quick-find.filters.product-filters.loom-space.loomFilterSpaceIcon': 'Space Icon',
    'search-page.quick-find.filters.product-filters.loom-space.loomFilterSpacePlaceholder': 'Find spaces',
    'search-page.quick-find.filters.product-filters.loom-space.loomSpace': 'Space',
    'search-page.relay.compass.owner-name': 'Owned by {ownerName}',
    'search-page.relay.compass.tier': 'Tier {tier}',
    'search-page.relay.fps-inline-rovo-chat.title': 'Dive deeper into this topic with Rovo',
    'search-page.result.mercury.risk.icon.label': 'Risk',
    'search-page.result.mercury.risk.status.accepted': 'Accepted',
    'search-page.result.mercury.risk.status.canceled': 'Canceled',
    'search-page.result.mercury.risk.status.draft': 'Draft',
    'search-page.result.mercury.risk.status.resolved': 'Resolved',
    'search-page.results.private-result-label': 'Private',
    'search-page.results.private-result-tooltip': 'Only visible to you',
    'search-page.results.product-results.third-party.channel-member-count': '{memberCount, plural, one {# member} other {# members}}',
    'search-page.results.product-results.third-party.channel-type-label': 'Channel',
    'search-page.results.product-results.third-party.external-people-label': 'External people',
    'search-page.results.product-results.third-party.external-person-label': 'External person',
    'search-page.results.product-results.third-party.last-active': 'Last active {relativeDate}',
    'search-page.results.product-results.third-party.message-search-result.message-result-lock-icon-tooltip': 'Restricted - Only specific people can see this result',
    'search-page.results.product-results.third-party.message-type-label': 'Message',
    'search-page.results.product-results.third-party.no-contributors-label': 'External people in #{channelName}',
    'search-page.results.product-results.third-party.private-conversation-text': '{users} in a private conversation',
    'search-page.results.product-results.third-party.thread-type-label': 'Thread',
    'search-page.results.product-results.third-party.title-and-channel-name': '{title} in #{channelName}',
    'search-page.results.product-results.third-party.title-with-remaining-contributors': '{title} and {remainingContributorsCount} {remainingContributorsCount, plural, one {other} other {others}}',
    'search-page.results.restricted-result-label': 'Restricted',
    'search-page.results.restricted-result-tooltip': 'Only visible to specific people',
    'search-page.salesforce.filter.calendarType': 'Calendar Type',
    'search-page.salesforce.filter.calendarType.no-options': 'No calendar types available',
    'search-page.salesforce.filter.campaignStatus': 'Campaign status',
    'search-page.salesforce.filter.campaignStatus.no-options': 'No statuses available',
    'search-page.salesforce.filter.caseStatus': 'Case status',
    'search-page.salesforce.filter.caseStatus.no-options': 'No statuses available',
    'search-page.salesforce.filter.dealStatus': 'Deal status',
    'search-page.salesforce.filter.documentStatus': 'Document status',
    'search-page.salesforce.filter.documentStatus.no-options': 'No statuses available',
    'search-page.salesforce.filter.leadStatus': 'Lead Status',
    'search-page.salesforce.filter.leadStatus.no-options': 'No lead statuses available',
    'search-page.salesforce.filter.stage': 'Deal stage',
    'search-page.salesforce.filter.stage.closed-lost-send-survey': 'Closed Lost (Send Survey)',
    'search-page.salesforce.filter.stage.closed-won': 'Closed Won',
    'search-page.salesforce.filter.stage.closed-won-auto-linked': 'Closed Won (Auto Linked)',
    'search-page.salesforce.filter.stage.develop-opportunity': 'Develop Opportunity',
    'search-page.salesforce.filter.stage.invalid-opp': 'Invalid Opp',
    'search-page.salesforce.filter.stage.lost': 'Lost',
    'search-page.salesforce.filter.stage.new': 'New',
    'search-page.salesforce.filter.stage.no-opportunity': 'No Opportunity',
    'search-page.salesforce.filter.stage.no-options': 'No stages available',
    'search-page.salesforce.filter.stage.qualify-opportunity': 'Qualify Opportunity',
    'search-page.salesforce.filter.taskStatus': 'Task Status',
    'search-page.salesforce.filter.taskStatus.no-options': 'No task statuses available',
    'search-page.salesforce.filter.taskType': 'Task Type',
    'search-page.salesforce.filter.taskType.no-options': 'No task types available',
    'search-page.search-link.label': 'Search Link',
    'search-page.search-page-header.search-results': 'Search results',
    'search-page.search-page-relay.filters.product-filters.contributor.confluenceFilterContributorDeactivatedLabel': '{userName} (Deactivated)',
    'search-page.search-page-relay.filters.product-filters.contributor.confluenceFilterContributorUnknownUser': 'Unknown user',
    'search-page.search-page-relay.filters.product-filters.site-select.currentSiteLabel': '{name} <hint>(current)</hint>',
    'search-page.search-page-relay.filters.product-filters.site-select.find-sites-placeholder.ai-non-final': 'Find sites',
    'search-page.search-page-relay.filters.product-filters.site-select.label': 'Sites',
    'search-page.search-page-relay.filters.product-filters.site-select.selectedHeadingMax': 'Selected <hint>(Select up to {max})</hint>',
    'search-page.search-page-relay.filters.product-filters.site-select.selectedHeadingMaxReached': 'Selected <hint>(Maximum selected)</hint>',
    'search-page.search-page-relay.filters.product-filters.site-select.selectedHeadingPlain': 'Selected',
    'search-page.search-page-relay.filters.product-filters.site-select.unselectedHeading': '{count, plural, one {Site} other {Sites}}',
    'search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-code.code': 'Code',
    'search-page.search-page-relay.search-results.search-result.search-result-renderer.search-graph-result.search-graph-project.projectLabel': 'Project',
    'search-page.sharepoint.filter.site.placeholder': 'Find sites',
    'search-page.show-more-breadcrumbs-button-label': 'Show more breadcrumbs',
    'search-page.tab-filter.accessible-more-dropdown-label': 'Filter by more apps',
    'search-page.tab-filter.all-filter-accessible-label': 'Filter by all apps',
    'search-page.tab-filter.all-filter-visual-label': 'All',
    'search-page.tab-filter.more-dropdown-label': 'More',
    'search-page.talent.filter.focus-area.content.placeholder': 'Find focus areas',
    'search-page.talent.filter.focus-area.content.selected': 'Selected',
    'search-page.talent.filter.focus-area.content.unselected': 'Suggested',
    'search-page.talent.filter.position-employment-type.content.placeholder': 'Find employment types',
    'search-page.talent.filter.position-employment-type.content.selected': 'Selected',
    'search-page.talent.filter.position-employment-type.content.unselected': 'Suggested',
    'search-page.talent.filter.position-job-family.content.placeholder': 'Find job families',
    'search-page.talent.filter.position-job-family.content.selected': 'Selected',
    'search-page.talent.filter.position-job-family.content.unselected': 'Suggested',
    'search-page.talent.filter.position-status-filter.content.placeholder': 'Find filled status',
    'search-page.talent.filter.position-status-filter.content.selected': 'Selected',
    'search-page.talent.filter.position-status-filter.content.unselected': 'Suggested',
    'search-page.talent.filter.position-team.content.placeholder': 'Find teams',
    'search-page.talent.filter.position-team.content.selected': 'Selected',
    'search-page.talent.filter.position-team.content.unselected': 'Suggested',
    'search-page.verified-icon-label': 'Verified',
    'search-page.verified-icon-tooltip-message': 'This page has been verified by an owner or admin.',
    'search-pull-request-result.comments-label': '{count} {count, plural, one {comment} other {comments}}',
    'search-pull-request-result.label': 'Pull request',
    'search-pull-request-result.status.declined': 'Declined',
    'search-pull-request-result.status.draft': 'Draft',
    'search-pull-request-result.status.merged': 'Merged',
    'search-pull-request-result.status.open': 'Open',
    'search-pull-request-result.status.unknown': 'Unknown',
    'search-respository-result.label': 'Repository',
    'search-result.direct-message-single-user': '{name1} and 1 other',
    'search-result.direct-message-two-users': '{name1} and {name2}',
    'search-result.federated-group-direct-message': '{knownNamesCount, plural, =1 {{name1}} =2 {{name1} and {name2}} =3 {{name1}, {name2}, and {name3}} =4 {{name1}, {name2}, {name3}, and {name4}} other {{name1}, {name2}, {name3}, and {name4}} }',
    'search-result.federated-group-direct-message-with-multiple-others': '{knownNamesCount, plural, =1 {{name1} and {totalOthersCount} others} =2 {{name1}, {name2}, and {totalOthersCount} others} =3 {{name1}, {name2}, {name3}, and {totalOthersCount} others} =4 {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} others} other {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} others} }',
    'search-result.federated-group-direct-message-with-one-other': '{knownNamesCount, plural, =1 {{name1} and {totalOthersCount} other} =2 {{name1}, {name2}, and {totalOthersCount} other} =3 {{name1}, {name2}, {name3}, and {totalOthersCount} other} =4 {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} other} other {{name1}, {name2}, {name3}, {name4}, and {totalOthersCount} other} }',
    'search-result.group-chat-title': '{contributorCount, plural, =0 {Group message with external users} =1 {{name1}} =2 {{name1} and {name2}} =3 {{name1}, {name2}, and {name3}} =4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other} other {{name1}, {name2}, {name3}, and {overflowContributorCount} others} }',
    'search-result.group-direct-message-unknown-names': '{totalPeopleCount} people',
    'search-result.group-meeting-title': '{contributorCount, plural, =0 {} =1 {{name1} in } =2 {{name1} and {name2} in } =3 {{name1}, {name2}, and {name3} in } =4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in } other {{name1}, {name2}, {name3}, and {overflowContributorCount} others in } }{channelName}',
    'search-result.last-modified': 'Updated {formattedDate}',
    'search-result.private-channel-label': 'Private Channel',
    'search-result.remove-recent-search': 'Remove recent search icon',
    'search-result.remove-recent-search-result-subheading': 'Recent search',
    'search-result.thread-title-with-others-and-channel-name': '{contributorCount, plural, =0 {} =1 {{name1} in } =2 {{name1} and {name2} in } =3 {{name1}, {name2}, and {name3} in } =4 {{name1}, {name2}, {name3}, and {overflowContributorCount} other in } other {{name1}, {name2}, {name3}, and {overflowContributorCount} others in } }#{channelName}',
    'search-result.unknown-channel-in-thread': 'unknown-channel',
    'search-result.user-mention.external-person': 'External person',
    'search.quickFind.intentRouter.allApps': 'All apps',
    'search.quickFind.intentRouter.jiraWorkItemsJql': 'Jira work items (JQL)',
    'search.quickFind.intentRouter.searchForAllApps': 'Search for all apps',
    'search.quickFind.intentRouter.searchForJiraWorkItems': 'Search for Jira work items',
    search_dialog_aria_label: 'Search Dialog',
    search_dialog_assets_display_name_search_warning: '<b>Search by display name is coming soon.</b> Try searching by name.',
    search_dialog_assets_unavailable_message: '<bold>Assets</bold> will be available here soon. For now, try <searchLink>Assets search</searchLink>.',
    search_dialog_autocomplete_suggestion: 'Suggestion',
    search_dialog_dismiss_banner_label: 'Dismiss banner',
    search_dialog_error_search_body: 'It might just be a hiccup. Please try refreshing the page or <button>try again</button>.',
    search_dialog_error_search_heading: "We're having trouble loading your recently viewed content.",
    search_dialog_feedback_footer: 'Help us improve search',
    search_dialog_no_content_body: "Search for what you're looking for in your Atlassian and integrated apps",
    search_dialog_no_content_body_default: 'Search for anything across your Atlassian apps',
    search_dialog_no_content_body_with_ai: "Search or ask what you're looking for in your Atlassian and integrated apps",
    search_dialog_no_content_body_with_atlassian_intelligence: 'Search or ask anything across your Atlassian apps',
    search_dialog_no_content_body_with_rovo: "Search or ask Rovo what you're looking for in your Atlassian and integrated apps",
    search_dialog_no_content_heading: 'Seek and you shall find',
    search_dialog_no_results_heading: "We couldn't find any results with that title",
    search_dialog_no_results_search_body: '<link>Search all content across your organization</link> or try again with a different term.',
    search_dialog_recent_search: 'Recent search',
    search_dialog_recents_heading: 'Recent',
    search_dialog_recommendations_heading: 'Recommendations',
    search_dialog_recommended_heading: 'Recommended',
    search_dialog_remove_recent_search_label: 'Remove recent search',
    search_dialog_rovo_banner_message: "Enter a question like \u201CWhat\u2019s the vacation policy?\u201D and Rovo will find the answer",
    search_dialog_rovo_tip: 'Rovo tip:',
    search_dialog_search_across_products: 'Search all apps',
    'search_dialog_search_across_products.more': 'more',
    'search_dialog_search_across_products.more-apps': '+ {more}',
    'search_dialog_search_across_products.more-apps-count': '+{count}',
    search_dialog_search_change_message: 'Why has search changed?',
    search_dialog_team: 'Team',
    search_dialog_zero_query: 'Suggestion',
    search_dialog_zero_query_collaborator_profile_suggestion: "{personAvatar} {name}'s profile",
    search_dialog_zero_query_confluence_pages_created_30_days_suggestion: '{productIcon} Confluence pages I created in the {dateIcon} last 30 days',
    search_dialog_zero_query_confluence_pages_created_7_days_suggestion: '{productIcon} Confluence pages I created in the {dateIcon} last 7 days',
    search_dialog_zero_query_confluence_pages_created_collaborator_7_days_suggestion: '{productIcon} Confluence pages created by {personAvatar} {name} in the {dateIcon} last 7 days',
    search_dialog_zero_query_confluence_pages_created_collaborator_last_30_days_suggestion: '{productIcon} Confluence pages created by {personAvatar} {name} in the {dateIcon} last 30 days',
    search_dialog_zero_query_confluence_pages_created_collaborator_suggestion: '{productIcon} Confluence pages created by {personAvatar} {name}',
    search_dialog_zero_query_confluence_pages_created_collaborator_topic_suggestion_v2: '{productIcon} Confluence pages about <b>{topic}</b> by {personAvatar} {name}',
    search_dialog_zero_query_confluence_pages_created_suggestion: '{productIcon} Confluence pages I created',
    search_dialog_zero_query_icon_label: 'Suggestion search',
    search_dialog_zero_query_issues_assigned_to_me_in_the_past_7_days_suggestion: 'Issues assigned to me in the past 7 days',
    search_dialog_zero_query_issues_i_created_in_the_last_month_suggestion: 'Issues I created in the last month',
    search_dialog_zero_query_jira_my_work_items_suggestion: 'Show my {productIcon} work items',
    search_dialog_zero_query_jira_nlq_collaborator_suggestion: 'Recent open items assigned to {name}',
    search_dialog_zero_query_jira_nlq_progress_for_epics_created_by_me_suggestion: 'Progress for epics created by me',
    search_dialog_zero_query_jira_tickets_assigned_collaborator_suggestion: '{productIcon} tickets assigned to {personAvatar} {name}',
    search_dialog_zero_query_jira_tickets_assigned_suggestion: '{productIcon} Jira tickets assigned to me',
    search_dialog_zero_query_jira_tickets_created_collaborator_suggestion: '{productIcon} Jira tickets created by {personAvatar} {name}',
    search_dialog_zero_query_jira_tickets_created_collaborator_topic_suggestion_v2: '{productIcon} Jira work items about <b>{topic}</b> by {personAvatar} {name}',
    search_dialog_zero_query_jira_tickets_created_suggestion: '{productIcon} Jira tickets I created',
    search_dialog_zero_query_recent_tickets_created_by_me_suggestion: 'Recent tickets created by me',
    search_dialog_zero_query_show_all_the_bugs_assigned_to_me_suggestion: 'Show all the bugs assigned to me',
    search_dialog_zero_query_show_high_priority_tickets_assigned_to_me_suggestion: 'Show high priority tickets assigned to me',
    search_dialog_zero_query_show_me_all_of_my_in_progress_work_items_suggestion: 'Show me all of my in-progress work items',
    search_dialog_zero_query_show_tickets_due_this_week_suggestion: 'Show tickets due this week',
    search_dialog_zero_query_third_party_google_collaborator_docs_suggestion: '{productIcon} Google docs from {personAvatar} {name}',
    search_dialog_zero_query_third_party_google_collaborator_docs_topic_suggestion_v2: '{productIcon} Google docs about <b>{topic}</b> by {personAvatar} {name}',
    search_dialog_zero_query_third_party_google_my_docs_suggestion: 'My {productIcon} Google Drive docs',
    search_dialog_zero_query_third_party_sharepoint_collaborator_docs_suggestion: '{productIcon} SharePoint docs from {personAvatar} {name}',
    search_dialog_zero_query_third_party_sharepoint_collaborator_docs_topic_suggestion_v2: '{productIcon} SharePoint docs about <b>{topic}</b> by {personAvatar} {name}',
    search_dialog_zero_query_third_party_sharepoint_my_docs_suggestion: 'My {productIcon} SharePoint documents',
    search_dialog_zero_query_third_party_slack_collaborator_messages_suggestion: '{productIcon} Slack messages from {personAvatar} {name}',
    search_dialog_zero_query_third_party_slack_my_messages_suggestion: 'My {productIcon} Slack messages',
    search_dialog_zero_query_what_are_my_open_tickets_suggestion: 'What are my open tickets?',
    search_dialog_zero_query_who_is_suggestion: 'Who is {name}?',
    'search_filters.more': 'more',
    'search_filters.more-apps-search': 'Open full page search for this term searching all apps',
    'search_page.lite_app_filter_bar.all': 'All',
    'search_page.lite_app_filter_bar.connect': 'Connect',
    'search_page.lite_app_filter_bar.connect_app_aria': 'Connect {app}',
    'search_page.lite_app_filter_bar.find_apps': 'Find apps',
    'search_page.lite_app_filter_bar.more_apps': 'More apps',
    'search_page.lite_header.feedback_button_label': 'Feedback',
    search_result_skeleton_loading_result: 'Loading result',
    search_result_type_answer: 'Answer',
    search_result_type_ask: 'Ask',
    search_result_type_attachment: 'Attachment',
    search_result_type_blogpost: 'Blog Post',
    search_result_type_board: 'Board',
    search_result_type_branch: 'Branch',
    search_result_type_bug: 'Bug',
    search_result_type_calendar: 'Calendar',
    search_result_type_card: 'Card',
    search_result_type_change: 'Change',
    search_result_type_channel: 'Channel',
    search_result_type_comment: 'Comment',
    search_result_type_commit: 'Commit',
    search_result_type_component: 'Component',
    search_result_type_customer_contact: 'Customer contact',
    search_result_type_customer_org: 'Customer Organization',
    search_result_type_dashboard: 'Dashboard',
    search_result_type_data_table: 'Data table',
    search_result_type_database: 'Database',
    search_result_type_deal: 'Deal',
    search_result_type_document: 'Document',
    search_result_type_email: 'Email',
    search_result_type_embed: 'Smart Link',
    search_result_type_epic: 'Epic',
    search_result_type_file: 'File',
    search_result_type_filter: 'Filter',
    search_result_type_focus_area: 'Focus area',
    search_result_type_focus_area_status_update: 'Focus area update',
    search_result_type_folder: 'Folder',
    search_result_type_gliffy: 'Gliffy Diagram',
    search_result_type_goal: 'Goal',
    search_result_type_improvement: 'Improvement',
    search_result_type_incident: 'Incident',
    search_result_type_issue: 'Work item',
    search_result_type_learning: 'Learning',
    search_result_type_message: 'Message',
    search_result_type_new_feature: 'New feature',
    search_result_type_object: 'Object',
    search_result_type_organization: 'Organization',
    search_result_type_organization_status_update: 'Organization update',
    search_result_type_page: 'Page',
    search_result_type_plan: 'Plan',
    search_result_type_position: 'Position',
    search_result_type_presentation: 'Presentation',
    search_result_type_problem: 'Problem',
    search_result_type_project: 'Project',
    search_result_type_pull_request: 'Pull Request',
    search_result_type_question: 'Question',
    search_result_type_repository: 'Repository',
    search_result_type_risk: 'Risk',
    search_result_type_schema: 'Schema',
    search_result_type_service_request: 'Service request',
    search_result_type_sharepoint_document: 'Sharepoint Document',
    search_result_type_slide: 'Slides',
    search_result_type_space: 'Space',
    search_result_type_space_calendar: 'Space calendar',
    search_result_type_spreadsheet: 'Spreadsheet',
    search_result_type_story: 'Story',
    search_result_type_sub_task: 'Sub-task',
    search_result_type_subtask: 'Sub-task',
    search_result_type_tag: 'Tag',
    search_result_type_task: 'Task',
    search_result_type_type: 'Object type',
    search_result_type_unrecognised: 'Unrecognised',
    search_result_type_video: 'Video',
    search_result_type_whiteboard: 'Whiteboard',
    search_result_type_work_item: 'Work Item',
    search_results_lite_issue_table_header_assignee: 'Assignee',
    search_results_lite_issue_table_header_labels: 'Labels',
    search_results_lite_issue_table_header_priority: 'Priority',
    search_results_lite_issue_table_header_status: 'Status',
    search_results_lite_issue_table_header_work: 'Work',
    search_results_lite_project_table_header_category: 'Category',
    search_results_lite_project_table_header_key: 'Key',
    search_results_lite_project_table_header_lead: 'Lead',
    search_results_lite_project_table_header_spaceUrl: 'Space URL',
    search_results_lite_project_table_header_spaces: 'Spaces',
    search_results_lite_project_table_header_type: 'Type',
    'search_talent_position.external_position_key': 'External key {positionExternalKey}',
    'search_talent_position.position_title': '{preferredName, select, undefined {{positionKey}} other {{positionKey}: {preferredName}}}',
    'sidebar-oauth-warning-authorize': 'Authorize',
    'sidebar-oauth-warning-dismiss': 'Dismiss',
    'sidebar-oauth-warning.app-filter-tooltip-content': 'Connect your account to see missing results, including documents only you have access to.',
    'sidebar-oauth-warning.app-filter-tooltip-content-alternate': 'Connect your account to see missing results, including content only you have access to.',
    'sidebar-oauth-warning.authorization-fail': 'Failed to connect to {product}.',
    'sidebar-oauth-warning.authorization-success': 'Successfully connected to {product}.',
    'sidebar-oauth-warning.connect': 'Connect',
    'space.label': 'Space',
    'spreadsheet.label': 'Spreadsheet',
    suggestion: 'See all results for "{inputQuery}" across apps',
    'summarize-in-chat-button-text': 'Summarize',
    'summarize-in-chat-label': 'Summarize',
    'task.label': 'Task',
    team: 'Team',
    'third-party-query-suggestion.dismiss': 'Dismiss',
    'third-party-query-suggestion.title': 'Do smarter searches with {product}',
    updatedNewest: 'Updated (newest)',
    updatedOldest: 'Updated (oldest)',
    'video.label': 'Video',
    'web-page.label': 'Web Page',
    whiteboard_type: 'Whiteboard',
    'work-item-assignee.assigned': '{isAssigned, select, internal {{firstName} is assigned} other {External person is assigned}}',
    'work-item-creator.created': '{created, select, internal {{firstName} created} other {External person created}}',
    'work-item-status.for': '{statusLozenge} for {dateLozenge}',
    'work-item.label': 'Work Item',
    work_item: 'Work item'
};


var $6e2a0e01d55c9360$export$2e2bcd8739ae039 = (0, $295b7ff928e6276a$export$2e2bcd8739ae039);

});

parcelRegister("eesba", function(module, exports) {

let $a5c83b44e9fdea48$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a5c83b44e9fdea48$var$load("k73rC").then(()=>parcelRequire('gnkFp'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("bLTm3", function(module, exports) {

let $891f05cea736a671$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $891f05cea736a671$var$load("aT1FI").then(()=>parcelRequire('kcajw'));

});

parcelRegister("3XVa6", function(module, exports) {

let $2e3338f01b56c7f8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $2e3338f01b56c7f8$var$load("76dF2").then(()=>parcelRequire('kWKcd'));

});

parcelRegister("jaYAM", function(module, exports) {

let $039a4a204ec8a801$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $039a4a204ec8a801$var$load("11uX1").then(()=>parcelRequire('8PAZb'));

});

parcelRegister("7Bkma", function(module, exports) {

let $588bc7789402af19$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $588bc7789402af19$var$load("iQsOe").then(()=>parcelRequire('asQjt'));

});

parcelRegister("iJnNd", function(module, exports) {

let $da2ee2b99abcf819$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $da2ee2b99abcf819$var$load("kspPT").then(()=>parcelRequire('bTdEJ'));

});

parcelRegister("ksjH0", function(module, exports) {

let $ee45b2bae6cfe4c7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ee45b2bae6cfe4c7$var$load("2vdCN").then(()=>parcelRequire('hE8ma'));

});

parcelRegister("kUbIB", function(module, exports) {

let $f38220a15fe52194$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f38220a15fe52194$var$load("jStPO").then(()=>parcelRequire('75kab'));

});

parcelRegister("kaNfw", function(module, exports) {

let $eafaf1b352a5f436$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eafaf1b352a5f436$var$load("81fn2").then(()=>parcelRequire('dzPtg'));

});

parcelRegister("jO13r", function(module, exports) {

let $e6b3813d34188852$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6b3813d34188852$var$load("ljRTH").then(()=>parcelRequire('98f4B'));

});

parcelRegister("6mYVW", function(module, exports) {

let $4a3410431f114883$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4a3410431f114883$var$load("hJCLg").then(()=>parcelRequire('12Cdy'));

});

parcelRegister("8ml2N", function(module, exports) {

let $6160b3b3be19f5f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6160b3b3be19f5f1$var$load("4inSo").then(()=>parcelRequire('itV7i'));

});

parcelRegister("fpOW4", function(module, exports) {

let $b390b38e295de6e3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b390b38e295de6e3$var$load("aleYU").then(()=>parcelRequire('1gKG3'));

});

parcelRegister("7F4l3", function(module, exports) {

let $593fba50eff65939$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $593fba50eff65939$var$load("5Nr2n").then(()=>parcelRequire('fZTFf'));

});

parcelRegister("gfKOF", function(module, exports) {

let $bd525ccb566c0a28$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bd525ccb566c0a28$var$load("6y3Ya").then(()=>parcelRequire('1J1Lf'));

});

parcelRegister("fOS8M", function(module, exports) {

let $b84585b81d1cff0c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b84585b81d1cff0c$var$load("hGtK1").then(()=>parcelRequire('yFbLe'));

});

parcelRegister("aSAb5", function(module, exports) {

let $7ebb02aff65be5f1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7ebb02aff65be5f1$var$load("lbAcV").then(()=>parcelRequire('1FqU4'));

});

parcelRegister("6trHz", function(module, exports) {

let $4b6af08391b4612d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4b6af08391b4612d$var$load("cTBsP").then(()=>parcelRequire('574Af'));

});

parcelRegister("fl3PF", function(module, exports) {

let $b2abca3a710e2814$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b2abca3a710e2814$var$load("di4bq").then(()=>parcelRequire('kdeFV'));

});

parcelRegister("dqkwI", function(module, exports) {

let $9c5da04016c71bf2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9c5da04016c71bf2$var$load("6U78m").then(()=>parcelRequire('8iUSn'));

});

parcelRegister("3oOtg", function(module, exports) {

let $279ac37d35b37318$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $279ac37d35b37318$var$load("8Dmyz").then(()=>parcelRequire('8PZAu'));

});

parcelRegister("eP8bg", function(module, exports) {

let $acac2c9ae2fdf3b1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $acac2c9ae2fdf3b1$var$load("1bl5r").then(()=>parcelRequire('avWuI'));

});

parcelRegister("cu6Sm", function(module, exports) {

let $916d9ebf20eec742$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $916d9ebf20eec742$var$load("dY9Sh").then(()=>parcelRequire('ffr5O'));

});

parcelRegister("grzGi", function(module, exports) {

let $bf8ad87fc4e61406$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $bf8ad87fc4e61406$var$load("k058b").then(()=>parcelRequire('bHCuS'));

});

parcelRegister("9rVUk", function(module, exports) {

let $6e138deb6e9df0cb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e138deb6e9df0cb$var$load("2026J").then(()=>parcelRequire('cZOuw'));

});

parcelRegister("jmCuW", function(module, exports) {

let $e18def5143ec8c95$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e18def5143ec8c95$var$load("6zpyO").then(()=>parcelRequire('28Moa'));

});

parcelRegister("l5SiF", function(module, exports) {

let $f5b42f7de5c19246$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f5b42f7de5c19246$var$load("aRuDI").then(()=>parcelRequire('bhwyo'));

});

parcelRegister("5SBU6", function(module, exports) {

let $447f65d3169a3fa4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $447f65d3169a3fa4$var$load("9riYE").then(()=>parcelRequire('iFup6'));

});

parcelRegister("jfjtW", function(module, exports) {

let $e02e87c1789655d1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e02e87c1789655d1$var$load("eUHuf").then(()=>parcelRequire('ap9AQ'));

});

parcelRegister("a8J3L", function(module, exports) {

let $761d9aad5426ba10$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $761d9aad5426ba10$var$load("cszkW").then(()=>parcelRequire('dIqfm'));

});

parcelRegister("hyjql", function(module, exports) {

let $cc74adcebc639df4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cc74adcebc639df4$var$load("74Kmq").then(()=>parcelRequire('2JNgk'));

});

parcelRegister("4d7mR", function(module, exports) {

let $310e1769d668fb5a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $310e1769d668fb5a$var$load("35IX9").then(()=>parcelRequire('lhhjl'));

});

parcelRegister("l414Y", function(module, exports) {

let $f55acf03fb6d4f94$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f55acf03fb6d4f94$var$load("3GIiH").then(()=>parcelRequire('g8ITL'));

});

parcelRegister("d1vR7", function(module, exports) {

let $97b4144299995d21$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $97b4144299995d21$var$load("4kV5T").then(()=>parcelRequire('ac1R4'));

});

parcelRegister("lbIOK", function(module, exports) {

let $f6cd63e6276725cf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f6cd63e6276725cf$var$load("kypvv").then(()=>parcelRequire('7e4b1'));

});

parcelRegister("erEK7", function(module, exports) {

let $a84330fd3deaab75$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a84330fd3deaab75$var$load("7q9cq").then(()=>parcelRequire('6G3fP'));

});

parcelRegister("dwQIL", function(module, exports) {

let $9d9728ccbf553a2e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9d9728ccbf553a2e$var$load("eHGU5").then(()=>parcelRequire('asn5j'));

});

parcelRegister("9mlgJ", function(module, exports) {

let $6d06aaafb7441a35$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6d06aaafb7441a35$var$load("hLlcq").then(()=>parcelRequire('aR3Oj'));

});

parcelRegister("g1JlU", function(module, exports) {

let $baafeb614b6ad174$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $baafeb614b6ad174$var$load("jA8Dl").then(()=>parcelRequire('bbXwh'));

});

parcelRegister("ZF1G9", function(module, exports) {

let $0b95858b55ef9d9e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0b95858b55ef9d9e$var$load("3xRvV").then(()=>parcelRequire('fKLcB'));

});

parcelRegister("fagXR", function(module, exports) {

let $b0a4f2f5988f3388$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b0a4f2f5988f3388$var$load("2aYhb").then(()=>parcelRequire('3F4yA'));

});

parcelRegister("gJKhA", function(module, exports) {

let $c2f4c013cacbeb0e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c2f4c013cacbeb0e$var$load("eTz5K").then(()=>parcelRequire('eCWoW'));

});

parcelRegister("a0jez", function(module, exports) {

let $7488d2ecd5949cb3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7488d2ecd5949cb3$var$load("lGmgj").then(()=>parcelRequire('1I19A'));

});

parcelRegister("ea0Re", function(module, exports) {

let $a4f2aa2ec838f126$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a4f2aa2ec838f126$var$load("c5IHZ").then(()=>parcelRequire('kHsMr'));

});

parcelRegister("gL0Dx", function(module, exports) {

let $c331879192c45873$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c331879192c45873$var$load("01RV0").then(()=>parcelRequire('IV7cu'));

});

parcelRegister("bhJWq", function(module, exports) {

let $8374eb3cbaf38bfe$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8374eb3cbaf38bfe$var$load("1qUsO").then(()=>parcelRequire('dhBpP'));

});

parcelRegister("hUo4O", function(module, exports) {

let $d09a57c1784e3f41$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d09a57c1784e3f41$var$load("kn0SI").then(()=>parcelRequire('768ND'));

});

parcelRegister("hDbbU", function(module, exports) {

let $cd5ec284bb37b0e6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $cd5ec284bb37b0e6$var$load("kfz2N").then(()=>parcelRequire('hJ2oL'));

});

parcelRegister("77INV", function(module, exports) {

let $52fbf10edd1e05a3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $52fbf10edd1e05a3$var$load("hL2Ox").then(()=>parcelRequire('4GJLD'));

});

parcelRegister("9sz3K", function(module, exports) {

let $6e31ecae7dd61d0a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6e31ecae7dd61d0a$var$load("bplo5").then(()=>parcelRequire('46ahm'));

});

parcelRegister("ctEz6", function(module, exports) {

let $9157a8e065c5c420$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9157a8e065c5c420$var$load("fpQoY").then(()=>parcelRequire('aQ5Tz'));

});

parcelRegister("im1dt", function(module, exports) {

let $d5cb399c13c97b96$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5cb399c13c97b96$var$load("3wUy9").then(()=>parcelRequire('5esOH'));

});

parcelRegister("fRkaa", function(module, exports) {

let $b8bb72359051e69a$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b8bb72359051e69a$var$load("gUBgW").then(()=>parcelRequire('9LFDS'));

});

parcelRegister("jOXsT", function(module, exports) {

let $e6e0d056bdbc3b93$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e6e0d056bdbc3b93$var$load("4Z6hE").then(()=>parcelRequire('72uMY'));

});

parcelRegister("5oZ61", function(module, exports) {

let $3eee960aad957c3c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3eee960aad957c3c$var$load("jrPIf").then(()=>parcelRequire('iYfMn'));

});

parcelRegister("lXomr", function(module, exports) {

let $ffc2013f8d22e2e1$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ffc2013f8d22e2e1$var$load("iwZyn").then(()=>parcelRequire('49G5V'));

});

parcelRegister("6AJxn", function(module, exports) {

let $4cc96d9f255d58b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $4cc96d9f255d58b2$var$load("jOvje").then(()=>parcelRequire('bw4dB'));

});

parcelRegister("3yxPO", function(module, exports) {

let $296ecaeafc3054dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $296ecaeafc3054dd$var$load("b697X").then(()=>parcelRequire('ihuI8'));

});

parcelRegister("agerH", function(module, exports) {

let $77869aa32814e433$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $77869aa32814e433$var$load("8roB9").then(()=>parcelRequire('iUPOS'));

});

parcelRegister("1guW5", function(module, exports) {

let $0ebf484815edccae$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0ebf484815edccae$var$load("8p0tm").then(()=>parcelRequire('7lFmB'));

});

parcelRegister("fBVAD", function(module, exports) {

let $b5d6fbd95f7e26ec$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b5d6fbd95f7e26ec$var$load("bvA6j").then(()=>parcelRequire('kThIJ'));

});

parcelRegister("540xp", function(module, exports) {

let $3afdbe4dccd46815$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $3afdbe4dccd46815$var$load("lDY72").then(()=>parcelRequire('3st9s'));

});

parcelRegister("dDn4v", function(module, exports) {

let $9ed0d06bfafce5dd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9ed0d06bfafce5dd$var$load("hmIOy").then(()=>parcelRequire('52wUs'));

});

parcelRegister("fheBd", function(module, exports) {

let $b1f3c4a832b70faf$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b1f3c4a832b70faf$var$load("8FID8").then(()=>parcelRequire('hJHXJ'));

});

parcelRegister("h8W7L", function(module, exports) {

let $c7b04547c11d530f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c7b04547c11d530f$var$load("3009f").then(()=>parcelRequire('8R8Ed'));

});

parcelRegister("aUnph", function(module, exports) {

let $7f114a6b125a47dc$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7f114a6b125a47dc$var$load("7MNN1").then(()=>parcelRequire('ift71'));

});

parcelRegister("d7Xrz", function(module, exports) {

let $98ea0a196cc4377c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98ea0a196cc4377c$var$load("cTLJ3").then(()=>parcelRequire('gGJSc'));

});

parcelRegister("1vhaM", function(module, exports) {

let $118601e0142afacd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $118601e0142afacd$var$load("cVPtW").then(()=>parcelRequire('arZEy'));

});

parcelRegister("b1QGl", function(module, exports) {

let $8078a73aaa6f6e71$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8078a73aaa6f6e71$var$load("gnbOU").then(()=>parcelRequire('cN3s9'));

});

parcelRegister("8RgFL", function(module, exports) {

let $01aa115e39a6de8d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $01aa115e39a6de8d$var$load("aiiZC").then(()=>parcelRequire('DvCR2'));

});

parcelRegister("imD26", function(module, exports) {

let $d5e88f36797f8011$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d5e88f36797f8011$var$load("hMjWd").then(()=>parcelRequire('ffj9v'));

});

parcelRegister("dKwIN", function(module, exports) {

let $a028f407cfdcdec5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a028f407cfdcdec5$var$load("IhBze").then(()=>parcelRequire('lTN0T'));

});

parcelRegister("2TMvz", function(module, exports) {

let $21c658868d58172c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $21c658868d58172c$var$load("lpt3C").then(()=>parcelRequire('fw0aI'));

});

parcelRegister("edNkB", function(module, exports) {

let $a5a88bbb9642364b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a5a88bbb9642364b$var$load("kXIxn").then(()=>parcelRequire('fEvLi'));

});

parcelRegister("7v0d6", function(module, exports) {

let $575b977196bb2fd8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $575b977196bb2fd8$var$load("6Q9lF").then(()=>parcelRequire('b4eRY'));

});

parcelRegister("i6YAa", function(module, exports) {

let $d2f7c7ec265ccbe0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d2f7c7ec265ccbe0$var$load("4cNqp").then(()=>parcelRequire('9J119'));

});

parcelRegister("8hihb", function(module, exports) {

let $606e1681ee668ae9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $606e1681ee668ae9$var$load("aleGF").then(()=>parcelRequire('by7sz'));

});

parcelRegister("2ZCu4", function(module, exports) {

let $22df216920b5c4d7$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $22df216920b5c4d7$var$load("lcHkg").then(()=>parcelRequire('e6oLi'));

});

parcelRegister("byEb5", function(module, exports) {

let $86a20926b8e12f5d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $86a20926b8e12f5d$var$load("dBV4Q").then(()=>parcelRequire('hCB2M'));

});

parcelRegister("3pj4Z", function(module, exports) {

let $27b281b133f5f3a4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $27b281b133f5f3a4$var$load("98UUs").then(()=>parcelRequire('aGhJr'));

});

parcelRegister("jys7x", function(module, exports) {

let $e3c70171a2df9892$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e3c70171a2df9892$var$load("7riC8").then(()=>parcelRequire('jF6w4'));

});

parcelRegister("1KJtX", function(module, exports) {

let $146d5e22b51e681e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $146d5e22b51e681e$var$load("65lxD").then(()=>parcelRequire('4IIWN'));

});

parcelRegister("jA8mS", function(module, exports) {

let $e417ded6695ebae6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $e417ded6695ebae6$var$load("4nogl").then(()=>parcelRequire('jjtQ9'));

});

parcelRegister("fjM8E", function(module, exports) {

let $b26df8a7d4de83e0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b26df8a7d4de83e0$var$load("d44ni").then(()=>parcelRequire('10FmW'));

});

parcelRegister("kvVV6", function(module, exports) {

let $eef3a196b06bc6e4$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $eef3a196b06bc6e4$var$load("1Eqvr").then(()=>parcelRequire('iyPW7'));

});

parcelRegister("cHEVj", function(module, exports) {

let $0262fce1f4df4432$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $0262fce1f4df4432$var$load("44wmz").then(()=>parcelRequire('y7v0S'));

});

parcelRegister("ehjC2", function(module, exports) {

let $a651ddda02217e68$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a651ddda02217e68$var$load("cO5a2").then(()=>parcelRequire('6GEqi'));

});

parcelRegister("lXiQY", function(module, exports) {

let $ffbdbb8992e3db0b$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ffbdbb8992e3db0b$var$load("8lqWA").then(()=>parcelRequire('4hUYF'));

});

parcelRegister("ceL5Y", function(module, exports) {

let $8e8b5304204c4a51$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $8e8b5304204c4a51$var$load("iNx4G").then(()=>parcelRequire('1wCbk'));

});

parcelRegister("9PFi4", function(module, exports) {

let $7288e7e5fcf03bf0$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7288e7e5fcf03bf0$var$load("2Vvbg").then(()=>parcelRequire('7Zjm5'));

});

parcelRegister("9XxAb", function(module, exports) {

let $7403ac8e62227f8e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7403ac8e62227f8e$var$load("cbliz").then(()=>parcelRequire('8LZPn'));

});

parcelRegister("OStr5", function(module, exports) {

let $098eecfbad8ef0a9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $098eecfbad8ef0a9$var$load("w5kq3").then(()=>parcelRequire('8Ufq7'));

});

parcelRegister("1J13e", function(module, exports) {

let $141acf231ad6f73e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $141acf231ad6f73e$var$load("8T4jX").then(()=>parcelRequire('lFgl9'));

});

parcelRegister("gyaDS", function(module, exports) {

let $c0c813a05a3bae9e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c0c813a05a3bae9e$var$load("awIQZ").then(()=>parcelRequire('1TKS1'));

});

parcelRegister("lSLlQ", function(module, exports) {

let $fee35f1d7ec59492$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $fee35f1d7ec59492$var$load("ktJiV").then(()=>parcelRequire('9fR4t'));

});

parcelRegister("kMWsF", function(module, exports) {

let $f225a38ff59bb52e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f225a38ff59bb52e$var$load("k2NKg").then(()=>parcelRequire('jsK0e'));

});

parcelRegister("kP2Kb", function(module, exports) {

let $f28ab2f843922754$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $f28ab2f843922754$var$load("35V4w").then(()=>parcelRequire('aOTyk'));

});

parcelRegister("cCQAD", function(module, exports) {

let $9311d3e32497017c$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9311d3e32497017c$var$load("fd9zH").then(()=>parcelRequire('dJUEP'));

});

parcelRegister("d7Jf3", function(module, exports) {

let $98df05ea3ffdc63d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $98df05ea3ffdc63d$var$load("jw64g").then(()=>parcelRequire('69xlO'));

});

parcelRegister("92nxS", function(module, exports) {

let $6946909a866c352e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $6946909a866c352e$var$load("sKZUj").then(()=>parcelRequire('8KIPG'));

});

parcelRegister("deUzL", function(module, exports) {

let $9a3877f40d68371e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $9a3877f40d68371e$var$load("l0Mz3").then(()=>parcelRequire('d2I6i'));

});

parcelRegister("aykdQ", function(module, exports) {

let $7aecc4163bd958b2$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7aecc4163bd958b2$var$load("5waBG").then(()=>parcelRequire('dNc9t'));

});

parcelRegister("8gT6G", function(module, exports) {

let $605a9065d5008449$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $605a9065d5008449$var$load("5rP2y").then(()=>parcelRequire('3xF0f'));

});

parcelRegister("gRJMd", function(module, exports) {

let $c4751ae05be1bcfa$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $c4751ae05be1bcfa$var$load("fiBWE").then(()=>parcelRequire('d1Kho'));

});

parcelRegister("egG6R", function(module, exports) {

let $a633396e1498b365$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a633396e1498b365$var$load("eYOVp").then(()=>parcelRequire('hr2Qm'));

});

parcelRegister("2OF8N", function(module, exports) {

let $20d02a00ff17dcef$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $20d02a00ff17dcef$var$load("lbVei").then(()=>parcelRequire('02spC'));

});

parcelRegister("lRRyP", function(module, exports) {

let $feb8183ce4d847d8$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $feb8183ce4d847d8$var$load("cuyR5").then(()=>parcelRequire('54AMW'));

});

parcelRegister("atzeI", function(module, exports) {

let $7a07f1ff89cb22b5$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $7a07f1ff89cb22b5$var$load("lakqH").then(()=>parcelRequire('i6RHe'));

});

parcelRegister("ix7N8", function(module, exports) {

let $d7e15a4dd1c248f3$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $d7e15a4dd1c248f3$var$load("cuanT").then(()=>parcelRequire('7d5GQ'));

});

parcelRegister("fXCNp", function(module, exports) {

let $b9ea75c06abd605e$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b9ea75c06abd605e$var$load("aNRRd").then(()=>parcelRequire('eST2B'));

});

parcelRegister("bMuJn", function(module, exports) {

let $893c03e9a992a969$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $893c03e9a992a969$var$load("1QSLQ").then(()=>parcelRequire('7Ephn'));

});

parcelRegister("e0LRB", function(module, exports) {

let $a336317671bf8f82$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $a336317671bf8f82$var$load("iVQPs").then(()=>parcelRequire('7WwX6'));

});

parcelRegister("1ougv", function(module, exports) {

let $103f825c35464783$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $103f825c35464783$var$load("llV4l").then(()=>parcelRequire('auOWd'));

});

parcelRegister("4S2B8", function(module, exports) {

let $38be38745e348a18$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $38be38745e348a18$var$load("2WZd3").then(()=>parcelRequire('3Agpb'));

});

parcelRegister("79XJS", function(module, exports) {

let $5367b69606bc7ca6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $5367b69606bc7ca6$var$load("9Dn1E").then(()=>parcelRequire('8Kulp'));

});

parcelRegister("emZZY", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $318f13e1b27fe321$var$WidthObserverContext = /*#__PURE__*/ (0, $cozmU.createContext)(undefined);
const $318f13e1b27fe321$export$75f7910544138d14 = ({ children: children })=>{
    const [elements, setElements] = (0, $cozmU.useState)({});
    const [callbacks, setCallbacks] = (0, $cozmU.useState)({});
    (0, $cozmU.useEffect)(()=>{
        const handleResize = (entries)=>{
            entries.forEach((entry)=>{
                const id = entry.target.getAttribute('data-width-observer-id');
                if (id && callbacks[id]) {
                    const width = entry.contentRect.width;
                    callbacks[id].forEach((callback)=>callback(width));
                }
            });
        };
        const observer = new ResizeObserver(handleResize);
        Object.values(elements).forEach((element)=>observer.observe(element));
        return ()=>{
            observer.disconnect();
        };
    }, [
        elements,
        callbacks
    ]);
    const registerElement = (0, $cozmU.useCallback)((id, element)=>{
        setElements((prev)=>({
                ...prev,
                [id]: element
            }));
    }, [
        setElements
    ]);
    const unregisterElement = (0, $cozmU.useCallback)((id)=>{
        setElements((prev)=>{
            const newElements = {
                ...prev
            };
            delete newElements[id];
            return newElements;
        });
    }, [
        setElements
    ]);
    const subscribe = (0, $cozmU.useCallback)((id, callback)=>{
        setCallbacks((prev)=>({
                ...prev,
                [id]: [
                    ...prev[id] || [],
                    callback
                ]
            }));
        return ()=>{
            setCallbacks((prev)=>({
                    ...prev,
                    [id]: (prev[id] || []).filter((cb)=>cb !== callback)
                }));
        };
    }, [
        setCallbacks
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($318f13e1b27fe321$var$WidthObserverContext.Provider, {
        value: {
            registerElement: registerElement,
            unregisterElement: unregisterElement,
            subscribe: subscribe
        }
    }, children);
};
const $318f13e1b27fe321$export$b78842cb7cd02769 = ()=>{
    const context = (0, $cozmU.useContext)($318f13e1b27fe321$var$WidthObserverContext);
    if (!context) throw new Error('useWidthObserver must be used within a WidthObserverProvider');
    return context;
};
const $318f13e1b27fe321$export$ad8c32a8eb05ab3d = (id, ref)=>{
    const { registerElement: registerElement, unregisterElement: unregisterElement } = $318f13e1b27fe321$export$b78842cb7cd02769();
    (0, $cozmU.useEffect)(()=>{
        const element = ref.current;
        if (element) {
            element.setAttribute('data-width-observer-id', id);
            registerElement(id, element);
        }
        return ()=>{
            unregisterElement(id);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        id,
        ref,
        ref.current,
        // This is required as the useEffect is not triggered when ref.current becomes defined
        registerElement,
        unregisterElement
    ]);
};
const $318f13e1b27fe321$export$f8586f54f6b8f867 = ({ id: id, children: children })=>{
    const elementRef = (0, $cozmU.useRef)(null);
    $318f13e1b27fe321$export$ad8c32a8eb05ab3d(id, elementRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        ref: elementRef
    }, children);
};
const $318f13e1b27fe321$export$1217913212f99c7 = (id)=>{
    const { subscribe: subscribe } = $318f13e1b27fe321$export$b78842cb7cd02769();
    const [width, setWidth] = (0, $cozmU.useState)(0);
    (0, $cozmU.useEffect)(()=>{
        const unsubscribe = subscribe(id, setWidth);
        return ()=>{
            unsubscribe();
        };
    }, [
        id,
        subscribe
    ]);
    return width;
};
const $318f13e1b27fe321$export$f29cb180c1a7eb72 = ({ target: id, children: children })=>{
    const width = $318f13e1b27fe321$export$1217913212f99c7(id);
    if (width === 0) return null;
    return children(width);
};
const $318f13e1b27fe321$var$breakpoints = {
    xxs: 0,
    xs: 480,
    sm: 768,
    md: 1024,
    lg: 1440,
    xl: 1768
};
const $318f13e1b27fe321$export$c44b7f69e7aa026 = ({ width: width, above: above, below: below })=>{
    return above && width > $318f13e1b27fe321$var$breakpoints[above] || below && width < $318f13e1b27fe321$var$breakpoints[below] || false;
};
const $318f13e1b27fe321$export$f6a3d19be20f5819 = ({ target: target, above: above, below: below, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($318f13e1b27fe321$export$f29cb180c1a7eb72, {
        target: target
    }, (width)=>{
        if ($318f13e1b27fe321$export$c44b7f69e7aa026({
            width: width,
            above: above,
            below: below
        })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
    });
};
const $318f13e1b27fe321$export$bed28288a051538 = ({ target: target, above: above, below: below, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($318f13e1b27fe321$export$f29cb180c1a7eb72, {
        target: target
    }, (width)=>{
        if ($318f13e1b27fe321$export$c44b7f69e7aa026({
            width: width,
            above: above,
            below: below
        })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, children);
    });
};
module.exports["WidthObserverProvider"] = $318f13e1b27fe321$export$75f7910544138d14;
module.exports["useWidthObserverRegistration"] = $318f13e1b27fe321$export$ad8c32a8eb05ab3d;
module.exports["WidthObserverElement"] = $318f13e1b27fe321$export$f8586f54f6b8f867;
module.exports["useElementWidth"] = $318f13e1b27fe321$export$1217913212f99c7;
module.exports["Hide"] = $318f13e1b27fe321$export$bed28288a051538;

});

parcelRegister("cJff5", function(module, exports) {
/* eslint-disable @atlaskit/platform/use-recommended-utils */ 
var $cXtTj = parcelRequire("cXtTj");


var $cha5E = parcelRequire("cha5E");


var $2pQiO = parcelRequire("2pQiO");


var $iDrrr = parcelRequire("iDrrr");


var $fR63l = parcelRequire("fR63l");


var $8fNUp = parcelRequire("8fNUp");

/**
 * Statsig experiment gating impersonated (3LO-free) Microsoft Teams serving in search.
 *
 * Not surface-scoped: the impersonation check it feeds (`isImpersonationEnabled`) lives in the
 * shared `getThirdPartyFilters`, which builds queries for both Full Page Search and Quick Find.
 * Teams currently only surfaces in Full Page Search because Quick Find omits it from its connector
 * list and never requests the `graph:conversation` / `graph:message` entities.
 */ const $84806324b2485b8b$var$TEAMS_IMPERSONATION_SEARCH_EXPERIMENT = 'enable_teams_impersonation_search';
const $84806324b2485b8b$export$59c9152b54b9272 = ()=>{
    (0, $cha5E.expVal)($84806324b2485b8b$var$TEAMS_IMPERSONATION_SEARCH_EXPERIMENT, 'cohort', 'control');
};
const $84806324b2485b8b$export$f88a0d041695e20e = ()=>{
    return (0, $2pQiO.UNSAFE_expValNoExposure)($84806324b2485b8b$var$TEAMS_IMPERSONATION_SEARCH_EXPERIMENT, 'cohort', 'control') === 'test';
};
const $84806324b2485b8b$export$43910e1172480373 = ()=>{
    return (0, $cXtTj.default).getExperimentValue('kd_convo_starters_same_line', 'cohort', 'control') === 'test';
};
const $84806324b2485b8b$export$9f3b4e44245ab299 = (thirdPartyConfigs, isAllProductSearch)=>{
    const isSlackAuthenticated = !thirdPartyConfigs?.[(0, $fR63l.ProductKeys3P).Slack]?.userNeedsOAuth;
    const hasFederatedConnectorSource = thirdPartyConfigs?.[(0, $fR63l.ProductKeys3P).Slack]?.connectorSources?.includes((0, $8fNUp.FEDERATED_CONNECTOR_SOURCE));
    const isUserEligible = isSlackAuthenticated && hasFederatedConnectorSource && isAllProductSearch;
    if (!isUserEligible) return isUserEligible;
    // The latency experiment keeps federated Slack in the all-products request path so
    // we can measure request behavior without the FPS-side exclusion. The gate scopes who
    // is enrolled at all, and the experiment splits enrolled users into cohorts.
    const isLatencyExperimentEnabled = (0, $iDrrr.fg)('ai_3p_slack_search_latency_experiment_enabled') && (0, $cXtTj.default).getExperimentValue('ai-3p-latency-slack-experiment', 'isEnabled', false, {
        fireExperimentExposure: false
    });
    return !isLatencyExperimentEnabled;
};
const $84806324b2485b8b$export$b8eda33c6a73a867 = (fireExperimentExposure = false)=>{
    return (0, $cXtTj.default).getExperimentValue('rovosearch_noun_result_counts', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $84806324b2485b8b$export$6cc04d45455a2e52 = (fireExperimentExposure = false)=>{
    return (0, $cXtTj.default).getExperimentValue('web_pages_type_filter_bug', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $84806324b2485b8b$export$a254d1715475fc25 = ()=>{
    return (0, $cXtTj.default).getExperimentValue('quick-find-3p-banner', 'bannerType', 'control') !== 'control';
};
const $84806324b2485b8b$export$6308fede6bfa9216 = ()=>{
    return (0, $cXtTj.default).getExperimentValue('quick-find-3p-banner', 'bannerType', 'control', {
        fireExperimentExposure: false
    }) !== 'control';
};
const $84806324b2485b8b$export$a28677150905172f = ()=>{
    return (0, $cXtTj.default).getExperimentValue('confluence_space_icon_update', 'isEnabled', false) === true;
};
const $84806324b2485b8b$export$f980294cad954499 = (thirdPartyConfigs, options = {
    fireExperimentExposure: true
})=>{
    const isEligible3PUser = Object.keys(thirdPartyConfigs).some((productKey)=>thirdPartyConfigs[productKey]?.userNeedsOAuth === false);
    return isEligible3PUser && (0, $cXtTj.default).getExperimentValue('3p_clicks_in_fps_as_qf_recents', 'cohort', 'control', options) === 'test';
};
const $84806324b2485b8b$export$32815557e5d06f0a = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $cXtTj.default).getExperimentValue('quick_find_3p_boosting_experiment', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $84806324b2485b8b$export$752769d90d201b0a = ()=>{
    return (0, $cXtTj.default).getExperimentValue('afm_customer_contact_search_type_experiment', 'cohort', 'control') === 'test';
};
const $84806324b2485b8b$export$9e14285db0210414 = (experimentConfig)=>{
    const cohort = experimentConfig.frontendExperiments?.['multi_site_search_in_rovo']?.cohort;
    return cohort === 'test';
};
/**
 * Resolves whether the multi-site search experiment is enabled for the current user.
 * Only served for Confluence and Jira
 * */ const $84806324b2485b8b$var$IMPROVE_BANNER_TARGETING_COHORTS = [
    'control',
    'usage-threshold',
    'max-dismissals'
];
const $84806324b2485b8b$export$647c2f5a2b1ce3a5 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const cohort = (0, $cXtTj.default).getExperimentValue('rovo_search_improve_banner_targeting', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($84806324b2485b8b$var$IMPROVE_BANNER_TARGETING_COHORTS.includes(cohort)) return cohort;
    return 'control';
};
const $84806324b2485b8b$export$9da12dc1aa287e01 = ({ thirdPartyConfigs: thirdPartyConfigs })=>{
    const githubConfig = thirdPartyConfigs?.[(0, $fR63l.ProductKeys3P).Github];
    if (!githubConfig) return false;
    // 1. GitHub connector enabled in tenant.
    if (typeof githubConfig.isEnabled === 'function' && !githubConfig.isEnabled()) return false;
    // 2. User is not yet connected to GitHub.
    if (githubConfig.userNeedsOAuth !== true) return false;
    return true;
};
const $84806324b2485b8b$export$e4fdf56860b85064 = ()=>{
    return (0, $cXtTj.default).getExperimentValue('unified_search_right_rail_enhancements', 'cohort', 'control');
};
const $84806324b2485b8b$export$97f8cc609584332 = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>(0, $cXtTj.default).getExperimentValue('rovo_fps_show_slack_top_reaction_in_search_ab', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) !== 'control';
const $84806324b2485b8b$export$1a64a03574a6a9b9 = 'quickfind_user_recs';
const $84806324b2485b8b$export$215e8e0e5adc6c3d = 'quickfind_user_recs_challenger_1';
const $84806324b2485b8b$export$eaa28b2ddfe6f8be = (thirdPartyConfigs)=>{
    if (!thirdPartyConfigs) return false;
    const isAuthorised = (productKey)=>{
        const config = thirdPartyConfigs[productKey];
        if (!config) return false;
        if (config.userNeedsOAuth === false) return true;
        return config.datasources?.some((ds)=>ds?.userNeedsOAuth === false) ?? false;
    };
    return isAuthorised((0, $fR63l.ProductKeys3P).GoogleDrive) || isAuthorised((0, $fR63l.ProductKeys3P).Sharepoint);
};
const $84806324b2485b8b$export$66d5be1a719ee001 = (thirdPartyConfigs, options = {
    fireExperimentExposure: false
})=>{
    if (!$84806324b2485b8b$export$eaa28b2ddfe6f8be(thirdPartyConfigs)) return undefined;
    const value = (0, $cXtTj.default).getExperimentValue('quick_find_recs_3p_sequence_model_exp', 'featureServiceModel', $84806324b2485b8b$export$1a64a03574a6a9b9, options);
    return value === $84806324b2485b8b$export$215e8e0e5adc6c3d ? $84806324b2485b8b$export$215e8e0e5adc6c3d : $84806324b2485b8b$export$1a64a03574a6a9b9;
};
/**
 * Cohorts for QF GitHub tip banner experiment.
 *
 * - `control`            : banner is not rendered at all.
 * - `test-with-gnin`     : banner triggers on EITHER a GitHub keyword OR a
 *                         Jira GNIN-routing intent (typed JQL / work-item
 *                         key). Matches the experiment doc's "Test 1".
 * - `test-keyword-only`  : banner triggers on a GitHub keyword ONLY \u2014 the
 *                         Jira GNIN intent path is skipped. Matches the
 *                         experiment doc's "Test 2", Jira-specific.
 */ const $84806324b2485b8b$var$QF_GITHUB_TIP_BANNER_COHORTS = [
    'control',
    'test-with-gnin',
    'test-keyword-only'
];
const $84806324b2485b8b$export$839b881580a7010a = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    const value = (0, $cXtTj.default).getExperimentValue('rovo_qf_github_tip_banner', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    return $84806324b2485b8b$var$QF_GITHUB_TIP_BANNER_COHORTS.includes(value) ? value : 'control';
};
const $84806324b2485b8b$var$SEARCH_PAGE_PROACTIVE_AI_MULTI_VARIANT_COHORTS = [
    'control',
    'auto_open_chat_modal',
    'on_demand_sain_banner',
    'inline_chat_input_in_results',
    'floating_chat_input'
];
const $84806324b2485b8b$export$e611075348720a7f = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    const cohort = (0, $cXtTj.default).getExperimentValue('search_page_proactive_ai_multi_variant', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($84806324b2485b8b$var$SEARCH_PAGE_PROACTIVE_AI_MULTI_VARIANT_COHORTS.includes(cohort)) return cohort;
    return 'control';
};
const $84806324b2485b8b$export$1f8098f0a4df3d11 = ({ fireExperimentExposure: fireExperimentExposure = false } = {})=>{
    return (0, $cXtTj.default).getExperimentValue('append_deactivated_account_to_contributor_list', 'isEnabled', false, {
        fireExperimentExposure: fireExperimentExposure
    }) === true;
};
const $84806324b2485b8b$var$JIRA_NAVIGATION_TO_GNIN_COHORTS = [
    'control',
    'work-item-icon',
    'header-link'
];
const $84806324b2485b8b$export$b68b3a4558aaedca = ({ fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    const cohort = (0, $cXtTj.default).getExperimentValue('rovo_jira_navigation_to_gnin', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    });
    if ($84806324b2485b8b$var$JIRA_NAVIGATION_TO_GNIN_COHORTS.includes(cohort)) return cohort;
    return 'control';
};
const $84806324b2485b8b$export$951b40241628ffcc = ()=>(0, $cXtTj.default).getExperimentValue('ai_3p_google_drive_federated_search_experiment', 'cohort', 'control') === 'test';
const $84806324b2485b8b$export$48676ed348c9fd9 = ()=>(0, $cha5E.expVal)('rovo_fps_jira_fast_hydration', 'isEnabled', false);
module.exports["triggerExposureForTeamsImpersonatedSearchExp"] = $84806324b2485b8b$export$59c9152b54b9272;
module.exports["serveTeamsImpersonatedSearchExpWithoutExposure"] = $84806324b2485b8b$export$f88a0d041695e20e;
module.exports["serveConvoStartersSameLine"] = $84806324b2485b8b$export$43910e1172480373;
module.exports["removeFedSlackFromAllProductSearch"] = $84806324b2485b8b$export$9f3b4e44245ab299;
module.exports["serveNounResultCounts"] = $84806324b2485b8b$export$b8eda33c6a73a867;
module.exports["serveWebPagesInTypeFilter"] = $84806324b2485b8b$export$6cc04d45455a2e52;
module.exports["serveQF3PBannerExperiment"] = $84806324b2485b8b$export$a254d1715475fc25;
module.exports["serveQF3PBannerExperimentWithoutExposure"] = $84806324b2485b8b$export$6308fede6bfa9216;
module.exports["serveConfluenceSpaceIconUpdate"] = $84806324b2485b8b$export$a28677150905172f;
module.exports["serve3PClickIngestionExperiment"] = $84806324b2485b8b$export$f980294cad954499;
module.exports["serveQuickFind3PBoostingExperiment"] = $84806324b2485b8b$export$32815557e5d06f0a;
module.exports["getMultiSiteSearchInRovo"] = $84806324b2485b8b$export$9e14285db0210414;
module.exports["serveImproveBannerTargetingExperiment"] = $84806324b2485b8b$export$647c2f5a2b1ce3a5;
module.exports["getUnifiedSearchRightRailEnhancementsExpValue"] = $84806324b2485b8b$export$e4fdf56860b85064;
module.exports["serveSlackTopReactionInSearchExperiment"] = $84806324b2485b8b$export$97f8cc609584332;
module.exports["getQuickFindRecs3PSequenceModel"] = $84806324b2485b8b$export$66d5be1a719ee001;
module.exports["serveQfGithubTipBannerExperiment"] = $84806324b2485b8b$export$839b881580a7010a;
module.exports["getSearchPageProactiveAiMultiVariantCohort"] = $84806324b2485b8b$export$e611075348720a7f;
module.exports["serveAppendDeactivatedAccountToContributorList"] = $84806324b2485b8b$export$1f8098f0a4df3d11;
module.exports["serveJiraNavigationToGNIN"] = $84806324b2485b8b$export$b68b3a4558aaedca;
module.exports["enableFederatedSearchForGoogleDrive"] = $84806324b2485b8b$export$951b40241628ffcc;
module.exports["serveFastJiraHydrationExperiment"] = $84806324b2485b8b$export$48676ed348c9fd9;

});

parcelRegister("8fNUp", function(module, exports) {
// The canonical `ThirdPartyConfig` interface lives in
// `@atlassian/rovo-connectors-config`. It is consumed here to build the derived
// `ThirdPartyConfigsWithAPIResponse` type below.

var $1hmDb = parcelRequire("1hmDb");

const $a0602398df0f360b$export$e88fb694deeca21a = 'smartlinks-connector';
const $a0602398df0f360b$export$83921c8e433ffcd9 = 'lite-connector-';
const $a0602398df0f360b$export$7ad7a95070d8bb93 = (0, $1hmDb.ConnectorSources).Federated;
const $a0602398df0f360b$export$e3a0662f044cd99b = (0, $1hmDb.ConnectorSources).Lite;
const $a0602398df0f360b$export$c14e5e3fa6d8b46 = (0, $1hmDb.ConnectorSources).Smartlinks;
const $a0602398df0f360b$export$aa06c0b5cc41ad9a = (0, $1hmDb.ConnectorSources).Full;
const $a0602398df0f360b$export$d18b7c9bcda587c4 = 'ADMIN_IMPORTED_USER_LINK';
const $a0602398df0f360b$export$37e0ed5b7fa94503 = (0, $1hmDb.ConnectorSources).Backfill;
const $a0602398df0f360b$export$af092ad5a950adea = (value)=>{
    return Object.values((0, $1hmDb.ConnectorSources)).includes(value);
};
const $a0602398df0f360b$export$9a0cf6dd1d986cc2 = 'forge-connector-';
const $a0602398df0f360b$export$e5725489d3388d22 = (type)=>{
    return type.startsWith($a0602398df0f360b$export$9a0cf6dd1d986cc2);
};
/**
 * Runtime registry for Forge connector icons.
 * Similar to ThirdPartyConfigs, but populated dynamically from API responses.
 */ const $a0602398df0f360b$var$forgeConnectorIconsRegistry = new Map();
const $a0602398df0f360b$export$4e96e986802512bd = (productKey, icon)=>{
    $a0602398df0f360b$var$forgeConnectorIconsRegistry.set(productKey, icon);
};
const $a0602398df0f360b$export$2f2bd8960b497856 = (productKey)=>{
    return $a0602398df0f360b$var$forgeConnectorIconsRegistry.get(productKey);
};
const $a0602398df0f360b$export$2768da79a2599ca3 = ()=>{
    $a0602398df0f360b$var$forgeConnectorIconsRegistry.clear();
};
module.exports["SMARTLINKS_RESOURCE_TYPE_PREFIX"] = $a0602398df0f360b$export$e88fb694deeca21a;
module.exports["LITE_CONNECTOR_SOURCE_PREFIX"] = $a0602398df0f360b$export$83921c8e433ffcd9;
module.exports["FEDERATED_CONNECTOR_SOURCE"] = $a0602398df0f360b$export$7ad7a95070d8bb93;
module.exports["LITE_CONNECTOR_SOURCE"] = $a0602398df0f360b$export$e3a0662f044cd99b;
module.exports["SMARTLINKS_CONNECTOR_SOURCE"] = $a0602398df0f360b$export$c14e5e3fa6d8b46;
module.exports["FULL_CONNECTOR_SOURCE"] = $a0602398df0f360b$export$aa06c0b5cc41ad9a;
module.exports["AUTH_RESOLUTION_MODE_ADMIN_IMPORTED"] = $a0602398df0f360b$export$d18b7c9bcda587c4;
module.exports["isConnectorSource"] = $a0602398df0f360b$export$af092ad5a950adea;
module.exports["isForgeConnectorProductKey"] = $a0602398df0f360b$export$e5725489d3388d22;
module.exports["registerForgeConnectorIcon"] = $a0602398df0f360b$export$4e96e986802512bd;
module.exports["getForgeConnectorIcon"] = $a0602398df0f360b$export$2f2bd8960b497856;

});

parcelRegister("1hmDb", function(module, exports) {
const $7f7ae3614280bba9$export$499e9a6668a55181 = {
    Federated: 'federated',
    Smartlinks: 'smartlinks',
    Lite: 'lite-connector',
    Full: 'full-connector',
    Backfill: 'backfill'
};
module.exports["ConnectorSources"] = $7f7ae3614280bba9$export$499e9a6668a55181;

});

parcelRegister("535ZC", function(module, exports) {
/*
 * Minimize imports in this entrypoint to avoid increasing the product bundle size.
 */ 
var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $7zn5c = parcelRequire("7zn5c");

const $950a68da474a5cd4$export$5f3101fcfc6eab72 = (value)=>{
    return typeof value === 'boolean';
};


const $d2a20def158b4bc1$var$JIRA_PRODUCT_NAME = 'jira';
// This is referencing KnowledgeDiscoveryJiraIntentDetectionModel.GNIN_HEURISTIC from @atlassian/search-client package
// Do not import @atlassian/search-client package as it will increase the NIN bundle size. A unit test is associated to this reference.
// Update DEFAULT_MODEL_ID if the default model ID for intent detection changes
const $d2a20def158b4bc1$var$DEFAULT_MODEL_ID = 'GNIN_HEURISTIC';
const $d2a20def158b4bc1$var$navigationCtaVariants = [
    'control',
    'button'
];
const $d2a20def158b4bc1$export$2e05ac0a6fbb40c7 = (cohortValue)=>{
    return Boolean($d2a20def158b4bc1$var$navigationCtaVariants.find((variant)=>cohortValue === variant));
};
const $d2a20def158b4bc1$var$isEnglishLocale = (locale)=>{
    // English locale or starts with 'en-', `en-US`, `en-GB`, etc.
    return Boolean(locale?.toLowerCase().startsWith('en'));
};
const $d2a20def158b4bc1$export$f2e8952d10c578ba = ({ primaryProduct: primaryProduct, fireLayerExposure: fireLayerExposure = true, locale: locale } = {})=>{
    if (primaryProduct !== $d2a20def158b4bc1$var$JIRA_PRODUCT_NAME) return undefined;
    // cohortForIntentDetectionExperiment AKA Experiment 2
    const intentDetectionExperiment = $d2a20def158b4bc1$export$678dc8b37f93853d({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: // Exposure should only be fired when intent detection has occured on Quick Find
        locale
    });
    const cohortForIntentDetectionExperiment = intentDetectionExperiment?.uiFeatures.navigationCTA;
    // Intent detection experiment takes priority on what CTA is used.
    // For example: If the Jira NIN FPS navigation experiment is decided and we start experiment 2, we still want to be able to set
    // different navigation CTAs in case we want to test different CTA variants in experiment 2.
    if (cohortForIntentDetectionExperiment) return {
        cohort: cohortForIntentDetectionExperiment,
        hideNavigationCTAOnGNIN: intentDetectionExperiment?.uiFeatures?.hideNavigationCTAOnGNIN,
        showQueryInHeader: intentDetectionExperiment?.uiFeatures?.showQueryInHeader
    };
    // This gate is used to ensure that certain audiences (i.e. CentralAI) are included in the Jira UI experiment.
    // Without it, some users might be excluded due to layer allocation opting out potential candidates.
    // The gate guarantees participation of the targeted audience during the initial experimentation phase.
    if (!(0, $iDrrr.fg)('rovo_jira_ui_experience_audience_gate')) return undefined;
    const layer = (0, $7zn5c.getMutuallyExclusiveUIExperiment)('rovo_jira_nin_fps_navigation_exp', 'rovo_jira_ui_experience_layer', {
        fireLayerExposure: fireLayerExposure
    });
    // cohortForNinFpsExperiment AKA Experiment 1
    const cohortForNinFpsExperiment = layer?.get('cohort', undefined, $d2a20def158b4bc1$export$2e05ac0a6fbb40c7);
    return {
        cohort: cohortForNinFpsExperiment,
        hideNavigationCTAOnGNIN: undefined,
        showQueryInHeader: undefined
    };
};
const $d2a20def158b4bc1$export$cd09c61ec4486079 = {
    navigationCTA: 'button',
    hideNavigationCTAOnGNIN: false,
    showMatchingWorkItem: true,
    showQueryInHeader: true,
    maxRecentQueryCountWhenNoSuggestions: 1
};
const $d2a20def158b4bc1$var$variants = [
    'control',
    'test'
];
const $d2a20def158b4bc1$var$serveJiraNINFpsNLQNavigationUserBased = ({ primaryProduct: primaryProduct, locale: locale } = {})=>{
    if (primaryProduct !== $d2a20def158b4bc1$var$JIRA_PRODUCT_NAME) return undefined;
    // This gate is used to ensure that certain audiences (i.e. CentralAI) are included in the Jira UI experiment.
    // Without it, some users might be excluded due to layer allocation opting out potential candidates.
    // The gate guarantees participation of the targeted audience during the initial experimentation phase.
    if (!(0, $iDrrr.fg)('rovo_jira_intent_detection_audience_gate')) return undefined;
    if ($d2a20def158b4bc1$var$isEnglishLocale(locale)) return {
        cohort: 'test',
        uiFeatures: $d2a20def158b4bc1$export$cd09c61ec4486079,
        modelId: $d2a20def158b4bc1$var$DEFAULT_MODEL_ID
    };
    // If not an english user, do not show intent detection
    return;
};
const $d2a20def158b4bc1$var$serveMultiLangIntentDetection = ({ primaryProduct: primaryProduct, fireLayerExposure: fireLayerExposure = true, locale: locale } = {})=>{
    if (primaryProduct !== $d2a20def158b4bc1$var$JIRA_PRODUCT_NAME) return undefined;
    // This gate is used to ensure that certain audiences (i.e. CentralAI) are included in the Jira UI experiment.
    // Without it, some users might be excluded due to layer allocation opting out potential candidates.
    // The gate guarantees participation of the targeted audience during the initial experimentation phase.
    if (!(0, $iDrrr.fg)('jira_fps_intent_classifier_fg') || $d2a20def158b4bc1$var$isEnglishLocale(locale)) return;
    const experiment = (0, $cXtTj.default).getExperiment('rovo_jira_nin_fps_nlq_navigation_non_english_exp', {
        fireExperimentExposure: fireLayerExposure
    });
    const cohort = experiment?.get('cohort', undefined, (cohortValue)=>{
        return Boolean($d2a20def158b4bc1$var$variants.find((variant)=>cohortValue === variant));
    });
    const uiFeaturesFromStatsig = experiment?.get('uiFeatures', {}, (uiFeaturesValue)=>{
        if (!uiFeaturesValue || typeof uiFeaturesValue !== 'object') return false;
        const isEnableControlIntentDetectionAnalyticsValid = 'enableControlIntentDetectionAnalytics' in uiFeaturesValue ? (0, $950a68da474a5cd4$export$5f3101fcfc6eab72)(uiFeaturesValue.enableControlIntentDetectionAnalytics) : true; // Undefined values are valid
        return isEnableControlIntentDetectionAnalyticsValid;
    }) ?? {};
    const modelId = experiment?.get('modelId', $d2a20def158b4bc1$var$DEFAULT_MODEL_ID, (modelIdValue)=>typeof modelIdValue === 'string' && modelIdValue.length > 0) ?? $d2a20def158b4bc1$var$DEFAULT_MODEL_ID;
    const uiFeaturesWithDefaults = {
        ...uiFeaturesFromStatsig,
        ...$d2a20def158b4bc1$export$cd09c61ec4486079
    };
    return {
        cohort: cohort,
        uiFeatures: uiFeaturesWithDefaults,
        modelId: modelId
    };
};
const $d2a20def158b4bc1$export$678dc8b37f93853d = (props = {})=>{
    // Holdout gate for the Carillon release (Jira's 3x/year rollout). Users in this holdout group
    // are opted out of intent detection, allowing different models to be tested against the holdout.
    if ((0, $iDrrr.fg)('rovo_jira_intent_detection_holdout')) // This is where the future intent detection experiments will live
    return undefined;
    const serveUserBasedExp = $d2a20def158b4bc1$var$serveJiraNINFpsNLQNavigationUserBased(props);
    if (serveUserBasedExp) return serveUserBasedExp;
    return $d2a20def158b4bc1$var$serveMultiLangIntentDetection(props);
};
const $d2a20def158b4bc1$export$bf4748641fc251b9 = (primaryProduct, locale)=>{
    const experiment = $d2a20def158b4bc1$export$678dc8b37f93853d({
        primaryProduct: primaryProduct,
        fireLayerExposure: false,
        locale: locale
    });
    return experiment?.cohort === 'test' || experiment?.cohort === 'control' && (experiment?.uiFeatures.enableControlIntentDetectionAnalytics ?? false);
};
module.exports["serveJiraNinFpsNavigation"] = $d2a20def158b4bc1$export$f2e8952d10c578ba;
module.exports["serveJiraNINFpsNLQNavigation"] = $d2a20def158b4bc1$export$678dc8b37f93853d;
module.exports["isIntentDetectionTriggeredForExperiment"] = $d2a20def158b4bc1$export$bf4748641fc251b9;

});

parcelRegister("hnDqW", function(module, exports) {

var $3Ydx7 = parcelRequire("3Ydx7");


var $iHg8v = parcelRequire("iHg8v");

const $520a04896497429c$export$e20882a9bd54a04f = (primaryProduct)=>{
    const { chatIntentDetectionEnabled: chatIntentDetectionEnabled } = (0, $iHg8v.serveChatConvergenceExperiment)();
    return chatIntentDetectionEnabled && (primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Confluence || primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Atlas);
};
const $520a04896497429c$export$fb43ed8ef2efa491 = (value)=>typeof value === 'string' && value.length > 0 ? value : undefined;
module.exports["isRovoJourneyIdEnabled"] = $520a04896497429c$export$e20882a9bd54a04f;
module.exports["normalizeRovoJourneyId"] = $520a04896497429c$export$fb43ed8ef2efa491;

});

parcelRegister("3Ydx7", function(module, exports) {
const $060ced86ed2d012d$export$15d12effc8830544 = {
    // Fully supported as GA
    Atlas: 'townsquare',
    Confluence: 'confluence',
    // In development
    Assets: 'cmdb',
    Focus: 'mercury',
    Jira: 'jira',
    Elevate: 'elevate',
    Talent: 'radar',
    RovoExtension: 'rovo-extension',
    Loom: 'loom'
};
module.exports["PrimaryProductKeys"] = $060ced86ed2d012d$export$15d12effc8830544;

});

parcelRegister("iHg8v", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $9d5177bc01113e11$export$763430070b25bb55 = ()=>{
    const fullPageChatEnabled = (0, $iDrrr.fg)('rovo_search_chat_convergence');
    const newTabChatEnabled = (0, $iDrrr.fg)('rovo_search_chat_convergence_tab');
    const sidebarChatEnabled = (0, $iDrrr.fg)('rovo_search_chat_convergence_sidebar');
    const floatyChatEnabled = (0, $iDrrr.fg)('rovo_search_chat_convergence_floaty');
    let chatSurface;
    if (newTabChatEnabled) chatSurface = 'new-tab';
    else if (sidebarChatEnabled) chatSurface = 'sidebar';
    else if (floatyChatEnabled) chatSurface = 'floaty';
    else if (fullPageChatEnabled) chatSurface = 'full-page';
    return {
        chatIntentDetectionEnabled: chatSurface !== undefined,
        chatSurface: chatSurface
    };
};
module.exports["serveChatConvergenceExperiment"] = $9d5177bc01113e11$export$763430070b25bb55;

});

parcelRegister("4ISS6", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Shares a detached DOM node that the placement is portaled into.
 * PlacementSlot moves this node into the results list when it mounts.
 */ const $2e308c88a8b5a21d$var$PlacementPortalContainerContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $2e308c88a8b5a21d$export$a1158697c36e3e9e = ()=>(0, $cozmU.useContext)($2e308c88a8b5a21d$var$PlacementPortalContainerContext);
const $2e308c88a8b5a21d$export$bdd60c847fd6f319 = $2e308c88a8b5a21d$var$PlacementPortalContainerContext.Provider;
const $2e308c88a8b5a21d$export$e2f7832e35c3b25 = ({ trackImpressionOnMount: trackImpressionOnMount } = {})=>{
    const slotRef = (0, $cozmU.useRef)(null);
    const placementContainer = $2e308c88a8b5a21d$export$a1158697c36e3e9e();
    const trackImpression = $2e308c88a8b5a21d$export$28e9482e7fdec750();
    (0, $cozmU.useLayoutEffect)(()=>{
        const slot = slotRef.current;
        if (slot && placementContainer) {
            placementContainer.style.display = '';
            slot.appendChild(placementContainer);
        }
        return ()=>{
            if (placementContainer) {
                placementContainer.style.display = 'none';
                placementContainer.remove();
            }
        };
    }, [
        placementContainer
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (trackImpressionOnMount) trackImpression?.();
    }, [
        trackImpressionOnMount,
        trackImpression
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        ref: slotRef
    });
};
/**
 * Shares the trackImpression callback captured from the PostOffice placement's onMessageViewed.
 * This allows OAuthContainer to trigger the "viewed" event when the banner becomes visible.
 */ const $2e308c88a8b5a21d$var$TrackImpressionContext = /*#__PURE__*/ (0, $cozmU.createContext)(null);
const $2e308c88a8b5a21d$export$28e9482e7fdec750 = ()=>(0, $cozmU.useContext)($2e308c88a8b5a21d$var$TrackImpressionContext);
const $2e308c88a8b5a21d$export$4a7d74782d15578 = $2e308c88a8b5a21d$var$TrackImpressionContext.Provider;
module.exports["usePlacementPortalContainer"] = $2e308c88a8b5a21d$export$a1158697c36e3e9e;
module.exports["PlacementPortalContainerProvider"] = $2e308c88a8b5a21d$export$bdd60c847fd6f319;
module.exports["PlacementSlot"] = $2e308c88a8b5a21d$export$e2f7832e35c3b25;
module.exports["TrackImpressionProvider"] = $2e308c88a8b5a21d$export$4a7d74782d15578;

});

parcelRegister("gPOtu", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $fR63l = parcelRequire("fR63l");


var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");

/**
 * Products for which 3LO (user OAuth) has been removed.
 * The Connect button will be hidden for these products when the admin has
 * configured a full connector, since the user no longer needs to authenticate.
 * Add more product keys here as 3LO removal is completed for each product.
 */ const $2298d11be5d540f9$var$PRODUCTS_WITH_3LO_REMOVAL = new Set([
    (0, $fR63l.ProductKeys3P).GoogleDrive,
    (0, $fR63l.ProductKeys3P).Github
]);
// `connectorSyncType` and `type` are spread onto each datasource from the raw API resource but are
// absent from the typed shape, hence the casts. Same precedent as `getDatasourceConnectorSource`.
const $2298d11be5d540f9$var$isFederatedDatasource = (datasource)=>datasource.connectorSyncType === (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE);
// Must read `type`, not `resourceType`: the latter is inherited from the static Slack config and
// reads `slack-connector` for both variants.
const $2298d11be5d540f9$var$isSmartlinksDatasource = (datasource)=>datasource.type?.startsWith((0, $8fNUp.SMARTLINKS_RESOURCE_TYPE_PREFIX)) ?? false;
const $2298d11be5d540f9$export$b8781914c72600e0 = (productKey, thirdPartyConfigs)=>{
    if (productKey !== (0, $fR63l.ProductKeys3P).Slack) return undefined;
    const datasources = thirdPartyConfigs[(0, $fR63l.ProductKeys3P).Slack]?.datasources;
    const federatedDatasource = datasources?.find($2298d11be5d540f9$var$isFederatedDatasource);
    if (!federatedDatasource || !datasources?.some($2298d11be5d540f9$var$isSmartlinksDatasource)) return undefined;
    // Gate last so the exposure is scoped to the affected population.
    return (0, $iDrrr.fg)('ai_3p_slack_federated_connect_cta_enabled') ? federatedDatasource : undefined;
};
const $2298d11be5d540f9$export$baed88e51744500d = (productKey, thirdPartyConfigs)=>{
    if (!productKey) return false;
    const productConfig = thirdPartyConfigs[productKey];
    return Boolean(productConfig?.connectorSources?.includes((0, $8fNUp.FULL_CONNECTOR_SOURCE)) && productConfig.datasources?.some((datasource)=>datasource.authResolutionMode === (0, $8fNUp.AUTH_RESOLUTION_MODE_ADMIN_IMPORTED)) && // Gate last so the exposure is scoped to the affected population.
    (0, $iDrrr.fg)('ai_3p_cds_auth_resolution_mode_flock'));
};
const $2298d11be5d540f9$export$a3e2d74740ffbb74 = (productKey, thirdPartyConfigs)=>{
    if (!productKey) return true;
    const productConfig = thirdPartyConfigs[productKey];
    if (!productConfig) {
        // For allowlisted products with the gate ON, treat missing config as not connected
        // (the API returned no resource for this product, so no full connector is configured)
        if ($2298d11be5d540f9$var$PRODUCTS_WITH_3LO_REMOVAL.has(productKey) && (0, $iDrrr.fg)('ai_3p_remove_connect_button_for_allowlist_product') // must be last for exposure tracking
        ) return false;
        return true;
    }
    // Full connector admin-configured AND impersonation enabled → no user OAuth needed for products with 3LO removed
    // Check datasources directly rather than product config root, since impersonationEnabled at the
    // product config level is overwritten by the last resource processed and may be stale.
    // SmartLinks/lite-connector resources never have impersonationEnabled: true, so checking any
    // datasource is safe and effectively scopes to full-connector resources only.
    const hasFullConnectorWithImpersonation = productConfig.datasources?.some((ds)=>ds?.impersonationEnabled === true);
    if ($2298d11be5d540f9$var$PRODUCTS_WITH_3LO_REMOVAL.has(productKey) && productConfig.connectorSources?.includes((0, $8fNUp.FULL_CONNECTOR_SOURCE)) && hasFullConnectorWithImpersonation && (0, $iDrrr.fg)('ai_3p_remove_connect_button_for_allowlist_product')) return true;
    if ($2298d11be5d540f9$export$baed88e51744500d(productKey, thirdPartyConfigs)) return true;
    const preferredDatasource = $2298d11be5d540f9$export$b8781914c72600e0(productKey, thirdPartyConfigs);
    if (preferredDatasource) return !preferredDatasource.userNeedsOAuth;
    return productConfig.datasources?.some((ds)=>!ds?.userNeedsOAuth) ?? false;
};
const $2298d11be5d540f9$export$edde6dcae8734ece = ({ productKey: productKey, thirdPartyConfigs: thirdPartyConfigs })=>{
    const product3PConfig = productKey && (0, $dvVWp.is3pProductKey)(productKey) ? thirdPartyConfigs[productKey] : null;
    return product3PConfig?.connectorSources?.length === 1 && product3PConfig.connectorSources[0] === (0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE);
};
module.exports["getPreferredConnectorDatasource"] = $2298d11be5d540f9$export$b8781914c72600e0;
module.exports["hasAdminImportedUserLink"] = $2298d11be5d540f9$export$baed88e51744500d;
module.exports["isProductConnected"] = $2298d11be5d540f9$export$a3e2d74740ffbb74;
module.exports["isProductSmartlink"] = $2298d11be5d540f9$export$edde6dcae8734ece;

});

parcelRegister("9PGk3", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $4MnFz = parcelRequire("4MnFz");


var $eh6Ml = parcelRequire("eh6Ml");


var $24dy7 = parcelRequire("24dy7");


var $eEPSE = parcelRequire("eEPSE");


var $iDrrr = parcelRequire("iDrrr");


var $kQgL7 = parcelRequire("kQgL7");


var $kh8w1 = parcelRequire("kh8w1");


var $dv1ov = parcelRequire("dv1ov");


var $51bn2 = parcelRequire("51bn2");


var $bFOSn = parcelRequire("bFOSn");


var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");


var $c11PZ = parcelRequire("c11PZ");


var $gPOtu = parcelRequire("gPOtu");


var $95n8y = parcelRequire("95n8y");


var $lDUCP = parcelRequire("lDUCP");


var $32Eau = parcelRequire("32Eau");


var $5lH3O = parcelRequire("5lH3O");


var $1i979 = parcelRequire("1i979");




const $a76917150290cb9d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    understoodAction: {
        id: "oauth-banner.acknowledgement.success-flag-action",
        defaultMessage: "Understood"
    }
});


/**
 * Updates the in-memory bootstrap configs synchronously (for immediate UI feedback)
 * and asynchronously updates the combined-config promiseCache so that both the
 * in-memory cache and localStorage stay consistent for subsequent page loads.
 *
 * This always produces updated configs with userNeedsOAuth=false.
 */ const $1fd89922a22afd0b$var$refreshCombinedOAuthCache = (product, userId, cloudId, thirdPartyConfigs, datasourceId)=>{
    const newThirdPartyConfigs = {
        ...thirdPartyConfigs
    };
    const productKey = product;
    const existingConfig = newThirdPartyConfigs[productKey];
    if (existingConfig) {
        if (datasourceId) newThirdPartyConfigs[productKey] = {
            ...existingConfig,
            datasources: existingConfig.datasources?.map((ds)=>ds.datasourceId === datasourceId ? {
                    ...ds,
                    userNeedsOAuth: false
                } : ds)
        };
        else newThirdPartyConfigs[productKey] = {
            ...existingConfig,
            userNeedsOAuth: false
        };
    }
    const thirdPartyTypes = (0, $95n8y.getThirdPartyTypes)();
    (0, $kQgL7.updateCombinedConfigCacheEntry)(userId, cloudId, (config)=>({
            ...config,
            thirdPartyProducts: config.thirdPartyProducts?.map((entry)=>{
                if (datasourceId) {
                    if (entry.datasourceId === datasourceId) return {
                        ...entry,
                        isUserOAuthed: true
                    };
                } else if (thirdPartyTypes[entry.name] === product) return {
                    ...entry,
                    isUserOAuthed: true
                };
                return entry;
            })
        }));
    return newThirdPartyConfigs;
};
const $1fd89922a22afd0b$export$4de3515a937b03f6 = ({ product: product, connectorSource: connectorSource, successFlagTitle: successFlagTitle, successFlagDescription: successFlagDescription, showUnderstoodButton: showUnderstoodButton = false, failFlagTitle: failFlagTitle, outboundAuthUrl: outboundAuthUrl, onCompletedAction: onCompletedAction = ()=>{}, onDismissAction: onDismissAction = ()=>{}, onFailAction: onFailAction = ()=>{}, isOnSearchDialog: isOnSearchDialog, isBulkConnect: isBulkConnect, query: query = '', datasourceId: datasourceId, extraAttributes: extraAttributes })=>{
    const [cloudId] = (0, $32Eau.useCloudId)();
    const [user] = (0, $32Eau.useUser)();
    const [thirdPartyConfigs] = (0, $32Eau.useThirdPartyConfigs)();
    const setThirdPartyConfigs = (0, $32Eau.useSetThirdPartyConfigs)();
    const onOAuthSuccess = (0, $32Eau.useOnOAuthSuccess)();
    // Keep a ref to the latest thirdPartyConfigs so that the onSuccess closure
    // (which fires asynchronously after the auth popup closes) always reads the
    // current store value instead of a stale captured snapshot.
    const thirdPartyConfigsRef = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useRef(thirdPartyConfigs);
    thirdPartyConfigsRef.current = thirdPartyConfigs;
    const { generateSearchUrl: generateSearchUrl, queryParams: queryParams } = (0, $c11PZ.useAppContext)();
    const userId = user?.id;
    const { retrySearch: retrySearch } = (0, $1i979.useSearchActions)();
    const { showFlag: showFlag, hideFlag: hideFlag } = (0, $4MnFz.useFlags)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { setQuickFindOpen: setQuickFindOpen } = (0, $5lH3O.useQuickFindActions)();
    const oAuthAnalyticsProps = {
        product: product || '',
        connectorSource: connectorSource,
        cloudId: cloudId || '',
        isOnSearchDialog: isOnSearchDialog,
        thirdPartyConfigs: thirdPartyConfigs,
        extraAttributes: extraAttributes
    };
    const fireOAuthStartedEvent = (0, $lDUCP.useFireOAuthStarted)(oAuthAnalyticsProps);
    const fireOAuthCompletedEvent = (0, $lDUCP.useFireOAuthCompleted)(oAuthAnalyticsProps);
    const fireOAuthFailedEvent = (0, $lDUCP.useFireOAuthFailed)(oAuthAnalyticsProps);
    const onSuccess = (oAuthSource)=>{
        fireOAuthCompletedEvent(oAuthSource);
        if (product === 'slack') (0, $51bn2.sendSlackAuthSuccessRequest)({
            cloudId: cloudId
        });
        if (product === 'teams' && (0, $iDrrr.fg)('ai_3p_is_teams_platform_connector_enabled')) (0, $bFOSn.sendTeamsAuthSuccessRequest)({
            cloudId: cloudId
        });
        onCompletedAction();
        const successFlagId = `oauth-success-flag-${product ?? 'unknown'}-${Date.now()}`;
        showFlag({
            id: successFlagId,
            title: successFlagTitle,
            ...successFlagDescription !== undefined && {
                description: successFlagDescription
            },
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eh6Ml))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-success, #6A9A23)"
            }),
            isAutoDismiss: true,
            ...showUnderstoodButton && {
                actions: [
                    {
                        content: formatMessage((0, $a76917150290cb9d$export$defe85febe8b728c).understoodAction),
                        onClick: ()=>hideFlag(successFlagId)
                    }
                ]
            }
        });
        if (onOAuthSuccess && (0, $kh8w1.isRovoFPSUseRovoConfigEnabled)()) onOAuthSuccess({
            product: product,
            datasourceId: datasourceId
        });
        else {
            const newOutboundAuthConfigs = $1fd89922a22afd0b$var$refreshCombinedOAuthCache(product, userId || '', cloudId || '', // Read from ref to get the latest store value, not the stale closure snapshot.
            thirdPartyConfigsRef.current || {}, // Mirror the datasource `isUserOAuthed` resolved to, so the connect clears that specific
            // connector rather than flipping every entry for the product.
            datasourceId ?? (0, $gPOtu.getPreferredConnectorDatasource)(product, thirdPartyConfigsRef.current || {})?.datasourceId);
            setThirdPartyConfigs(newOutboundAuthConfigs);
        }
        (0, $dv1ov.searchPageQueryCache).clear();
        retrySearch();
        if (!isBulkConnect && isOnSearchDialog) {
            setQuickFindOpen(false);
            /* TODO: use onNavigate callback once bootstrap store is lifted. Details in https://hello.atlassian.net/wiki/spaces/CASE/pages/4670854655/3P+Discoverability+Bug
      const onNavigateCallback =
      	typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
      onNavigateCallback(
      	generateSearchUrl({
      		...queryParams,
      		text: query,
      		product: product,
      	}),
      	'push',
      );
      */ const searchUrl = generateSearchUrl({
                ...queryParams,
                text: query,
                product: product
            });
            window.location.href = searchUrl;
        }
    };
    //eslint-disable-next-line @typescript-eslint/no-unused-vars
    const onFail = (oAuthSource, error)=>{
        fireOAuthFailedEvent(oAuthSource);
        onFailAction();
        showFlag({
            title: failFlagTitle,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($24dy7))), {
                spacing: "spacious",
                label: "",
                color: "var(--ds-icon-danger, #C9372C)"
            }),
            isAutoDismiss: true
        });
    };
    const onAuthorize = (oAuthSource)=>{
        fireOAuthStartedEvent(oAuthSource);
        (0, $eEPSE.auth)(outboundAuthUrl).then(()=>onSuccess(oAuthSource)).catch((error)=>onFail(oAuthSource, error));
    };
    const onDismiss = ()=>{
        onDismissAction();
    };
    return {
        onAuthorize: onAuthorize,
        onDismiss: onDismiss,
        onSuccess: onSuccess,
        onFail: onFail
    };
};
const $1fd89922a22afd0b$export$e90b3746b95097c9 = (productKey, selectedDatasourceId)=>{
    const [thirdPartyConfigsValue] = (0, $32Eau.useThirdPartyConfigs)();
    return $1fd89922a22afd0b$export$3515cf7f98d16dad(productKey, thirdPartyConfigsValue, selectedDatasourceId);
};
const $1fd89922a22afd0b$export$3515cf7f98d16dad = (productKey, thirdPartyConfigs, selectedDatasourceId)=>{
    let userNeedsOAuth, outboundAuthUrl;
    // Handle Forge connectors first (they're not in is3pProductKey)
    if (productKey && (0, $8fNUp.isForgeConnectorProductKey)(productKey)) {
        const productOutboundAuthConfig = thirdPartyConfigs[productKey];
        if (!productOutboundAuthConfig) return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
        userNeedsOAuth = productOutboundAuthConfig.userNeedsOAuth;
        outboundAuthUrl = productOutboundAuthConfig.outboundAuthUrl;
        return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
    }
    if (!productKey || !(0, $dvVWp.is3pProductKey)(productKey)) return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
    // If datasource is provided, check specific datasource config
    if (selectedDatasourceId) {
        const datasourceOutboundAuthConfig = thirdPartyConfigs[productKey]?.datasources?.find((datasource)=>datasource.datasourceId === selectedDatasourceId);
        if (!datasourceOutboundAuthConfig) return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
        userNeedsOAuth = datasourceOutboundAuthConfig.userNeedsOAuth;
        outboundAuthUrl = datasourceOutboundAuthConfig.outboundAuthUrl;
        return {
            userNeedsOAuth: userNeedsOAuth,
            outboundAuthUrl: outboundAuthUrl
        };
    }
    // When several connectors of differing priority back one product, the merged product config
    // reflects whichever resource was processed last, so prefer the connector that should own the
    // affordance. Resolved here rather than at each call site so every surface — filter pills, header
    // tabs, right rail, Quick Find — is covered without threading a datasourceId through.
    const preferredDatasource = (0, $gPOtu.getPreferredConnectorDatasource)(productKey, thirdPartyConfigs);
    if (preferredDatasource) return {
        userNeedsOAuth: preferredDatasource.userNeedsOAuth,
        outboundAuthUrl: preferredDatasource.outboundAuthUrl
    };
    // If no datasource provided, check base product config
    const productOutboundAuthConfig = thirdPartyConfigs[productKey];
    if (!productOutboundAuthConfig) return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
    userNeedsOAuth = productOutboundAuthConfig.userNeedsOAuth;
    outboundAuthUrl = productOutboundAuthConfig.outboundAuthUrl;
    return {
        userNeedsOAuth: userNeedsOAuth,
        outboundAuthUrl: outboundAuthUrl
    };
};
module.exports["useOAuthHandlers"] = $1fd89922a22afd0b$export$4de3515a937b03f6;
module.exports["useIsUserOAuthed"] = $1fd89922a22afd0b$export$e90b3746b95097c9;
module.exports["isUserOAuthed"] = $1fd89922a22afd0b$export$3515cf7f98d16dad;

});

parcelRegister("51bn2", function(module, exports) {
const $5435a676aa729323$export$e5c324cf2a7795e0 = ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId })=>{
    const relativeSlackUrl = `/gateway/api/third-party-user-auth/slack/user-authed`;
    const baseUrl = absoluteUrl || relativeSlackUrl;
    const url = `${baseUrl}/${cloudId}`;
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
module.exports["sendSlackAuthSuccessRequest"] = $5435a676aa729323$export$e5c324cf2a7795e0;

});

parcelRegister("bFOSn", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");


var $bHHWv = parcelRequire("bHHWv");

const $1b7a3bd80ac34d5e$var$TEAMS_BULK_REST_API_URL = '/gateway/api/v4/teams/withMembers/bulk';
const $1b7a3bd80ac34d5e$var$cache = (0, $bHHWv.inMemoryCache)();
const $1b7a3bd80ac34d5e$export$a4f9b7f788f9e71f = (request)=>{
    const keyObj = {
        teamIds: request.teamIds.sort()
    };
    return (0, $bZF61.generateHashFromVariables)(keyObj);
};
const $1b7a3bd80ac34d5e$export$eb16261a2bb165d4 = async (request, onError)=>{
    return $1b7a3bd80ac34d5e$var$cache.inMemoryDecorator($1b7a3bd80ac34d5e$export$a4f9b7f788f9e71f(request), ()=>fetch($1b7a3bd80ac34d5e$var$TEAMS_BULK_REST_API_URL, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(request)
        }).then((response)=>{
            if (response.ok) return response.json();
            const errorMessage = `Unable to fetch ${$1b7a3bd80ac34d5e$var$TEAMS_BULK_REST_API_URL}. ${response.statusText}`;
            onError?.(errorMessage);
            return Promise.reject({
                teams: [],
                failures: [
                    {
                        teamIds: request.teamIds,
                        description: errorMessage,
                        typeId: 'FETCH_ERROR'
                    }
                ]
            });
        }).catch((error)=>{
            const errorMessage = `Unable to fetch ${$1b7a3bd80ac34d5e$var$TEAMS_BULK_REST_API_URL}. ${error.message}`;
            onError?.(errorMessage);
            return {
                teams: [],
                failures: [
                    {
                        teamIds: request.teamIds,
                        description: errorMessage,
                        typeId: 'FETCH_ERROR'
                    }
                ]
            };
        }));
};
const $1b7a3bd80ac34d5e$export$5a635a8efc086412 = ({ absoluteUrl: absoluteUrl = '', cloudId: cloudId })=>{
    const relativeTeamsUrl = `/gateway/api/third-party-user-auth/teams/user-authed`;
    const baseUrl = absoluteUrl || relativeTeamsUrl;
    const url = `${baseUrl}/${cloudId}`;
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        }
    });
};
module.exports["fetchTeamsBulk"] = $1b7a3bd80ac34d5e$export$eb16261a2bb165d4;
module.exports["sendTeamsAuthSuccessRequest"] = $1b7a3bd80ac34d5e$export$5a635a8efc086412;

});

parcelRegister("5pcom", function(module, exports) {

var $6yu7A = parcelRequire("6yu7A");

const $a28a1ba2d45336f8$export$caa1a4a1a0abbf91 = {
    quickFindFilter: 'quick-find-filter',
    quickFindOAuthBanner: 'quick-find-oauth-banner',
    quickFindBulkConnect: 'quick-find-bulk-connect',
    quickFindGithubTipBanner: 'quick-find-github-tip-banner',
    searchPageFilter: 'search-page-filter',
    searchPageOAuthBanner: 'search-page-oauth-banner',
    searchPageBulkConnect: 'search-page-bulk-connect',
    sainThirdPartyBanner: 'sain-third-party-banner'
};
const $a28a1ba2d45336f8$export$54863d2084195ac7 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yu7A.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yu7A.EVENT_SOURCE),
        action: 'clicked',
        actionSubject: 'thirdPartyOAuth',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'track'
    };
};
const $a28a1ba2d45336f8$export$1caeb8956b6720dc = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yu7A.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yu7A.EVENT_SOURCE),
        action: 'completed',
        actionSubject: 'thirdPartyOAuth',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'track'
    };
};
const $a28a1ba2d45336f8$export$50898fe380812840 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yu7A.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yu7A.EVENT_SOURCE),
        action: 'failed',
        actionSubject: 'thirdPartyOAuth',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'track'
    };
};
const $a28a1ba2d45336f8$export$b6f5ff07ced3e735 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, isOnSearchDialog: isOnSearchDialog, oAuthSource: oAuthSource, isImpersonated: isImpersonated, extraAttributes: extraAttributes })=>{
    return {
        source: isOnSearchDialog ? (0, $6yu7A.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yu7A.EVENT_SOURCE),
        action: 'hovered',
        actionSubject: 'thirdPartyOAuth',
        actionSubjectId: 'thirdPartyOAuthConnectButton',
        attributes: {
            additionalAttributes: {
                ...extraAttributes,
                cloudId: cloudId,
                product: product,
                connectorSource: connectorSource,
                oAuthSource: oAuthSource,
                isImpersonated: isImpersonated
            },
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes,
        eventType: 'ui'
    };
};
module.exports["OAuthSource"] = $a28a1ba2d45336f8$export$caa1a4a1a0abbf91;
module.exports["onOAuthStarted"] = $a28a1ba2d45336f8$export$54863d2084195ac7;
module.exports["onOAuthCompleted"] = $a28a1ba2d45336f8$export$1caeb8956b6720dc;
module.exports["onOAuthFailed"] = $a28a1ba2d45336f8$export$50898fe380812840;
module.exports["onOAuthConnectHovered"] = $a28a1ba2d45336f8$export$b6f5ff07ced3e735;

});

parcelRegister("6yu7A", function(module, exports) {
const $8fae1dff497a873c$export$e8d1ded05852e864 = {
    source: 'source'
};
const $8fae1dff497a873c$export$d1fe2a1199482e6d = {
    release: 'release',
    product: 'product',
    cloudId: 'cloudId',
    userId: 'userId',
    primaryProduct: 'primaryProduct',
    primaryProductFilterString: 'primaryProductFilterString',
    experimentId: 'experimentId',
    experimentLayers: 'experimentLayers',
    frontendExperiments: 'frontendExperiments',
    abTestId: 'abTestId',
    isHello: 'isHello',
    version: 'version',
    mode: 'mode',
    requestId: 'requestId',
    traceId: 'traceId'
};
const $8fae1dff497a873c$export$ed78826c06dd24e3 = 'fabric-elements';
const $8fae1dff497a873c$export$ad44d4a0591d8dba = 'advancedSearchScreen';
const $8fae1dff497a873c$export$1111f6e73bd7b1d8 = 'searchDialog';
const $8fae1dff497a873c$export$98bd2afc08f981ef = 'searchPage';
var $8fae1dff497a873c$export$1118b8908e5d0501 = /*#__PURE__*/ function(OptionIds) {
    OptionIds["TITLE"] = "title";
    OptionIds["ARCHIVED"] = "archived";
    OptionIds["ANCESTOR"] = "ancestor";
    OptionIds["TO"] = "to";
    OptionIds["FROM"] = "from";
    OptionIds["LAST_MODIFIED"] = "lastModified";
    return OptionIds;
}({});
const $8fae1dff497a873c$export$eed19b551669af14 = 'CURRENT';
const $8fae1dff497a873c$export$c936349447a77fe0 = 'ARCHIVED';
const $8fae1dff497a873c$export$a4c5cde0daa9b961 = 'crossProductSearch';
const $8fae1dff497a873c$export$2be5c31192ba8783 = 'all';
const $8fae1dff497a873c$export$cabdc1d3c523c88 = 'fullPageSearchErrorScreen';
var $8fae1dff497a873c$export$15029b2eda44c6a7 = /*#__PURE__*/ function(QueryState) {
    QueryState["POSTQUERY"] = "PostQuery";
    QueryState["PREQUERY"] = "PreQuery";
    return QueryState;
}({});
module.exports["DEFAULT_GAS_CHANNEL"] = $8fae1dff497a873c$export$ed78826c06dd24e3;
module.exports["EVENT_SOURCE"] = $8fae1dff497a873c$export$ad44d4a0591d8dba;
module.exports["SEARCH_DIALOG_EVENT_SOURCE"] = $8fae1dff497a873c$export$1111f6e73bd7b1d8;
module.exports["ACTION_SUBJECT_PREFIX"] = $8fae1dff497a873c$export$98bd2afc08f981ef;
module.exports["OptionIds"] = $8fae1dff497a873c$export$1118b8908e5d0501;
module.exports["CURRENT"] = $8fae1dff497a873c$export$eed19b551669af14;
module.exports["ARCHIVED"] = $8fae1dff497a873c$export$c936349447a77fe0;
module.exports["CROSSPRODUCT_SEARCH_API"] = $8fae1dff497a873c$export$a4c5cde0daa9b961;
module.exports["ALL_PRODUCTS_STRING"] = $8fae1dff497a873c$export$2be5c31192ba8783;
module.exports["ERROR_SCREEN_NAME"] = $8fae1dff497a873c$export$cabdc1d3c523c88;
module.exports["QueryState"] = $8fae1dff497a873c$export$15029b2eda44c6a7;

});

parcelRegister("i28CG", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");

const $56c3f4ee696c4a89$export$b4d0899ce57e542f = (product, thirdPartyConfigs)=>{
    return !!(product && (0, $dvVWp.is3pProductKey)(product) ? thirdPartyConfigs[product]?.impersonationEnabled : false);
};
module.exports["isProductImpersonated"] = $56c3f4ee696c4a89$export$b4d0899ce57e542f;

});

parcelRegister("fIeaC", function(module, exports) {

var $dOgct = parcelRequire("dOgct");


var $8N8EQ = parcelRequire("8N8EQ");


var $fQ7Ra = parcelRequire("fQ7Ra");


var $jyixt = parcelRequire("jyixt");


var $7QpO7 = parcelRequire("7QpO7");

/**
 * Extracts the gateway object from the latest captured Relay extensions
 * for the given query type.
 */ const $cbc0182d59505d21$var$getLatestGateway = (isCQL)=>{
    const extensions = (0, $dOgct.getExtensions)(isCQL ? (0, $jyixt.default).operation.name : (0, $fQ7Ra.default).operation.name)?.slice(-1)[0];
    return extensions?.gateway;
};
function $cbc0182d59505d21$export$4fff3ed4eba4f4ee(isCQL) {
    const gateway = $cbc0182d59505d21$var$getLatestGateway(isCQL);
    const traceId = gateway?.['trace_id'];
    const queryUpdatedAgo = (0, $7QpO7.getQueryUpdatedTime)();
    return {
        traceId: traceId,
        queryUpdatedAgo: queryUpdatedAgo
    };
}
function $cbc0182d59505d21$export$7a619f7611b5a09e(isCQL) {
    const gateway = $cbc0182d59505d21$var$getLatestGateway(isCQL);
    if (!gateway) return undefined;
    return (0, $8N8EQ.extractTraceInfoFromResponse)({
        extensions: {
            gateway: gateway
        }
    });
}
module.exports["getExtensionData"] = $cbc0182d59505d21$export$4fff3ed4eba4f4ee;
module.exports["getRelayNetworkTraceInfo"] = $cbc0182d59505d21$export$7a619f7611b5a09e;

});

parcelRegister("fQ7Ra", function(module, exports) {
/**
 * @generated SignedSource<<f59ed0ec606be713c562f641dbaec2d2>>
 * @relayHash 0937d5e78e6a6edfe16003b70ac21184
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID bccbdd49d816b372aad6090a955295b76ed70b9fd157d7f9c3b16398d55ae46d

var $hd5Dy = parcelRequire("hd5Dy");


var $iK48f = parcelRequire("iK48f");


var $8dp6J = parcelRequire("8dp6J");


var $hFjUk = parcelRequire("hFjUk");


var $4Pgy4 = parcelRequire("4Pgy4");


var $b9kI4 = parcelRequire("b9kI4");

const $b16e14c5cbb2e6b9$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "assetsFilters"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudIdARIs"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "commonFilters"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "compassFilters"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "confluenceFilters"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "disableQueryReplacement"
    }, v7 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "enableHighlighting"
    }, v8 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "entities"
    }, v9 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "expectResult"
    }, v10 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experience"
    }, v11 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentId"
    }, v12 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "experimentLayers"
    }, v13 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "fanoutExperimentCohort"
    }, v14 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeFastJiraHydration"
    }, v15 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeGithubCode"
    }, v16 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeJiraLiteModeFields"
    }, v17 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeNavBoostScore"
    }, v18 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePassionfruitAsk"
    }, v19 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includePositions"
    }, v20 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeReactionsAndCommentCount"
    }, v21 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeRisk"
    }, v22 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "includeThirdPartyId"
    }, v23 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "jiraFilters"
    }, v24 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "limit"
    }, v25 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "matchingLayerExperimentsMetadata"
    }, v26 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "mercuryFilters"
    }, v27 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "query"
    }, v28 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryVersion"
    }, v29 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "searchSessionId"
    }, v30 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sessionId"
    }, v31 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "shadowExperimentId"
    }, v32 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sort"
    }, v33 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "sourceProduct"
    }, v34 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "talentFilters"
    }, v35 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "tenantId"
    }, v36 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "thirdPartyFilters"
    }, v37 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "queryVersion",
                    "variableName": "queryVersion"
                },
                {
                    "kind": "Variable",
                    "name": "searchSessionId",
                    "variableName": "searchSessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sessionId",
                    "variableName": "sessionId"
                },
                {
                    "kind": "Variable",
                    "name": "sourceProduct",
                    "variableName": "sourceProduct"
                }
            ],
            "kind": "ObjectValue",
            "name": "analytics"
        },
        {
            "kind": "Variable",
            "name": "disableQueryReplacement",
            "variableName": "disableQueryReplacement"
        },
        {
            "kind": "Variable",
            "name": "enableHighlighting",
            "variableName": "enableHighlighting"
        },
        {
            "kind": "Variable",
            "name": "expectResult",
            "variableName": "expectResult"
        },
        {
            "kind": "Variable",
            "name": "experience",
            "variableName": "experience"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "experimentId",
                    "variableName": "experimentId"
                },
                {
                    "kind": "Variable",
                    "name": "experimentLayers",
                    "variableName": "experimentLayers"
                },
                {
                    "kind": "Variable",
                    "name": "shadowExperimentId",
                    "variableName": "shadowExperimentId"
                }
            ],
            "kind": "ObjectValue",
            "name": "experimentContext"
        },
        {
            "kind": "Variable",
            "name": "fanoutExperimentCohort",
            "variableName": "fanoutExperimentCohort"
        },
        {
            "fields": [
                {
                    "kind": "Variable",
                    "name": "assetsFilters",
                    "variableName": "assetsFilters"
                },
                {
                    "kind": "Variable",
                    "name": "commonFilters",
                    "variableName": "commonFilters"
                },
                {
                    "kind": "Variable",
                    "name": "compassFilters",
                    "variableName": "compassFilters"
                },
                {
                    "kind": "Variable",
                    "name": "confluenceFilters",
                    "variableName": "confluenceFilters"
                },
                {
                    "kind": "Variable",
                    "name": "entities",
                    "variableName": "entities"
                },
                {
                    "kind": "Variable",
                    "name": "jiraFilters",
                    "variableName": "jiraFilters"
                },
                {
                    "kind": "Variable",
                    "name": "locations",
                    "variableName": "cloudIdARIs"
                },
                {
                    "kind": "Variable",
                    "name": "mercuryFilters",
                    "variableName": "mercuryFilters"
                },
                {
                    "kind": "Variable",
                    "name": "talentFilters",
                    "variableName": "talentFilters"
                },
                {
                    "kind": "Variable",
                    "name": "thirdPartyFilters",
                    "variableName": "thirdPartyFilters"
                }
            ],
            "kind": "ObjectValue",
            "name": "filters"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "limit"
        },
        {
            "kind": "Variable",
            "name": "matchingLayerExperimentsMetadata",
            "variableName": "matchingLayerExperimentsMetadata"
        },
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
        },
        {
            "kind": "Variable",
            "name": "sort",
            "variableName": "sort"
        }
    ], v38 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v39 = {
        "kind": "ScalarField",
        "name": "id"
    }, v40 = {
        "kind": "ScalarField",
        "name": "description"
    }, v41 = {
        "kind": "ScalarField",
        "name": "connectorType"
    }, v42 = {
        "kind": "ScalarField",
        "name": "title"
    }, v43 = {
        "kind": "ScalarField",
        "name": "url"
    }, v44 = {
        "kind": "ScalarField",
        "name": "type"
    }, v45 = {
        "kind": "ScalarField",
        "name": "lastModifiedDate"
    }, v46 = {
        "kind": "ScalarField",
        "name": "subtype"
    }, v47 = {
        "kind": "ScalarField",
        "name": "integrationId"
    }, v48 = {
        "kind": "ScalarField",
        "name": "providerId"
    }, v49 = {
        "kind": "ScalarField",
        "name": "value"
    }, v50 = {
        "kind": "ScalarField",
        "name": "label"
    }, v51 = [
        v50 /*: any*/ 
    ], v52 = {
        "kind": "ScalarField",
        "name": "key"
    }, v53 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v54 = {
        "kind": "ScalarField",
        "name": "name"
    }, v55 = [
        v54 /*: any*/ 
    ], v56 = {
        "kind": "ScalarField",
        "name": "lastModified"
    }, v57 = {
        "kind": "ScalarField",
        "name": "total"
    }, v58 = {
        "kind": "ScalarField",
        "name": "count"
    }, v59 = [
        v39 /*: any*/ 
    ], v60 = {
        "kind": "InlineFragment",
        "selections": v59 /*: any*/ ,
        "type": "Node",
        "abstractKey": "__isNode"
    }, v61 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v62 = {
        "kind": "ScalarField",
        "name": "email"
    }, v63 = [
        {
            "kind": "ScalarField",
            "name": "jobTitle"
        }
    ], v64 = {
        "args": [
            {
                "kind": "Variable",
                "name": "tenantId",
                "variableName": "tenantId"
            }
        ],
        "concreteType": "SocialSignalSearch",
        "kind": "LinkedField",
        "name": "socialSignal",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "signal"
            },
            {
                "kind": "ScalarField",
                "name": "timestamp"
            },
            {
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                    v38 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "accountId"
                    },
                    v54 /*: any*/ ,
                    v61 /*: any*/ ,
                    {
                        "kind": "InlineFragment",
                        "selections": [
                            v62 /*: any*/ ,
                            {
                                "concreteType": "AtlassianAccountUserExtendedProfile",
                                "kind": "LinkedField",
                                "name": "extendedProfile",
                                "plural": false,
                                "selections": v63 /*: any*/ 
                            }
                        ],
                        "type": "AtlassianAccountUser"
                    },
                    v39 /*: any*/ 
                ]
            }
        ]
    }, v65 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v38 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": v55 /*: any*/ ,
                "type": "ExternalRepository"
            },
            v60 /*: any*/ 
        ]
    }, v66 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v67 = {
        "kind": "LinkedField",
        "name": "container",
        "plural": false,
        "selections": [
            v38 /*: any*/ ,
            {
                "kind": "InlineFragment",
                "selections": [
                    v66 /*: any*/ ,
                    v43 /*: any*/ ,
                    v46 /*: any*/ 
                ],
                "type": "ExternalSpace"
            },
            v60 /*: any*/ 
        ]
    }, v68 = [
        {
            "kind": "ScalarField",
            "name": "reactionType"
        },
        v57 /*: any*/ 
    ], v69 = {
        "kind": "ScalarField",
        "name": "externalId"
    }, v70 = {
        "concreteType": "ThirdPartyUserExtendedProfile",
        "kind": "LinkedField",
        "name": "extendedProfile",
        "plural": false,
        "selections": v63 /*: any*/ 
    }, v71 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": [
                    v54 /*: any*/ ,
                    v62 /*: any*/ ,
                    v61 /*: any*/ ,
                    v69 /*: any*/ ,
                    v70 /*: any*/ ,
                    v39 /*: any*/ 
                ]
            }
        ]
    }, v72 = [
        v38 /*: any*/ ,
        v54 /*: any*/ ,
        v61 /*: any*/ ,
        v39 /*: any*/ 
    ], v73 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v72 /*: any*/ 
    }, v74 = {
        "kind": "ScalarField",
        "name": "status"
    }, v75 = {
        "kind": "ScalarField",
        "name": "nickname"
    }, v76 = {
        "concreteType": "ExternalAssociationConnection",
        "kind": "LinkedField",
        "name": "associatedWith",
        "plural": false,
        "selections": [
            {
                "concreteType": "ExternalAssociationEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                    {
                        "concreteType": "ExternalAssociation",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "entity",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v69 /*: any*/ ,
                                            v54 /*: any*/ ,
                                            v75 /*: any*/ ,
                                            v62 /*: any*/ ,
                                            v61 /*: any*/ ,
                                            v70 /*: any*/ ,
                                            v39 /*: any*/ 
                                        ],
                                        "type": "ThirdPartyUser"
                                    },
                                    v60 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            {
                                                "alias": "channelId",
                                                "kind": "ScalarField",
                                                "name": "externalId"
                                            },
                                            v66 /*: any*/ 
                                        ],
                                        "type": "ExternalConversation"
                                    }
                                ]
                            },
                            v39 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v77 = {
        "kind": "ScalarField",
        "name": "thumbnailUrl"
    }, v78 = [
        v39 /*: any*/ ,
        v54 /*: any*/ ,
        v62 /*: any*/ ,
        v61 /*: any*/ ,
        v69 /*: any*/ ,
        v70 /*: any*/ 
    ], v79 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": [
            {
                "concreteType": "ThirdPartyUser",
                "kind": "LinkedField",
                "name": "thirdPartyUser",
                "plural": false,
                "selections": v78 /*: any*/ 
            },
            {
                "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseConnection",
                "kind": "LinkedField",
                "name": "linkedUsers",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "GraphStoreSimplifiedUserLinkedThirdPartyUserInverseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    v38 /*: any*/ ,
                                    {
                                        "kind": "InlineFragment",
                                        "selections": [
                                            v54 /*: any*/ ,
                                            v61 /*: any*/ ,
                                            v39 /*: any*/ 
                                        ],
                                        "type": "AtlassianAccountUser"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v59 /*: any*/ ,
                                        "type": "AppUser"
                                    },
                                    {
                                        "kind": "InlineFragment",
                                        "selections": v59 /*: any*/ ,
                                        "type": "CustomerUser"
                                    }
                                ]
                            },
                            v39 /*: any*/ 
                        ]
                    }
                ]
            }
        ]
    }, v80 = [
        v39 /*: any*/ ,
        v54 /*: any*/ 
    ], v81 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v80 /*: any*/ 
    }, v82 = [
        v81 /*: any*/ 
    ], v83 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": v82 /*: any*/ 
    }, v84 = {
        "kind": "ScalarField",
        "name": "memberCount"
    }, v85 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v86 = [
        v54 /*: any*/ ,
        v39 /*: any*/ 
    ], v87 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "thirdPartyUser",
        "plural": false,
        "selections": v86 /*: any*/ 
    }, v88 = [
        v87 /*: any*/ 
    ], v89 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "owners",
        "plural": true,
        "selections": v88 /*: any*/ 
    }, v90 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v88 /*: any*/ 
    }, v91 = [
        v38 /*: any*/ ,
        v54 /*: any*/ ,
        v39 /*: any*/ 
    ], v92 = {
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": v91 /*: any*/ 
    }, v93 = [
        v38 /*: any*/ ,
        {
            "kind": "InlineFragment",
            "selections": [
                v39 /*: any*/ ,
                v66 /*: any*/ 
            ],
            "type": "ExternalCustomerOrg"
        },
        v60 /*: any*/ 
    ], v94 = {
        "kind": "LinkedField",
        "name": "parent",
        "plural": false,
        "selections": v93 /*: any*/ 
    }, v95 = [
        {
            "kind": "ScalarField",
            "name": "lastActivityAt"
        },
        {
            "kind": "ScalarField",
            "name": "event"
        }
    ], v96 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "assignee",
        "plural": false,
        "selections": v82 /*: any*/ 
    }, v97 = {
        "concreteType": "ExternalUser",
        "kind": "LinkedField",
        "name": "createdBy",
        "plural": false,
        "selections": v82 /*: any*/ 
    }, v98 = {
        "kind": "ScalarField",
        "name": "dueDate"
    }, v99 = {
        "kind": "ScalarField",
        "name": "workspaceName"
    }, v100 = {
        "kind": "ScalarField",
        "name": "excerpt"
    }, v101 = {
        "kind": "ScalarField",
        "name": "eventEndTime"
    }, v102 = {
        "kind": "ScalarField",
        "name": "eventStartTime"
    }, v103 = {
        "kind": "ScalarField",
        "name": "videoMeetingUrl"
    }, v104 = {
        "concreteType": "ThirdPartyUser",
        "kind": "LinkedField",
        "name": "allContributors",
        "plural": true,
        "selections": [
            v54 /*: any*/ ,
            v75 /*: any*/ ,
            v62 /*: any*/ ,
            v61 /*: any*/ ,
            v69 /*: any*/ ,
            v70 /*: any*/ ,
            v39 /*: any*/ 
        ]
    }, v105 = {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": v80 /*: any*/ 
    }, v106 = {
        "kind": "ScalarField",
        "name": "webUrl"
    }, v107 = [
        v53 /*: any*/ ,
        v54 /*: any*/ ,
        v39 /*: any*/ 
    ], v108 = [
        {
            "kind": "Literal",
            "name": "first",
            "value": 5
        }
    ], v109 = [
        {
            "concreteType": "JiraLabelEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "concreteType": "JiraLabel",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": v55 /*: any*/ 
                }
            ]
        }
    ], v110 = [
        v45 /*: any*/ ,
        v53 /*: any*/ 
    ], v111 = [
        v52 /*: any*/ ,
        v66 /*: any*/ ,
        v39 /*: any*/ 
    ], v112 = [
        {
            "kind": "ScalarField",
            "name": "targetDate"
        },
        {
            "kind": "ScalarField",
            "name": "targetDateType"
        }
    ], v113 = [
        v45 /*: any*/ 
    ], v114 = {
        "concreteType": "AssetsLinks",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "web"
            }
        ]
    }, v115 = {
        "concreteType": "AssetsSchema",
        "kind": "LinkedField",
        "name": "objectSchemaEntity",
        "plural": false,
        "selections": [
            v54 /*: any*/ ,
            v66 /*: any*/ ,
            v39 /*: any*/ 
        ]
    }, v116 = [
        {
            "kind": "ScalarField",
            "name": "url48"
        }
    ], v117 = [
        v52 /*: any*/ ,
        v39 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v16 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v19 /*: any*/ ,
                v20 /*: any*/ ,
                v21 /*: any*/ ,
                v22 /*: any*/ ,
                v23 /*: any*/ ,
                v24 /*: any*/ ,
                v25 /*: any*/ ,
                v26 /*: any*/ ,
                v27 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v31 /*: any*/ ,
                v32 /*: any*/ ,
                v33 /*: any*/ ,
                v34 /*: any*/ ,
                v35 /*: any*/ ,
                v36 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "searchResultsAsyncQuery",
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "includeFastJiraHydration",
                            "variableName": "includeFastJiraHydration"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeGithubCode",
                            "variableName": "includeGithubCode"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeJiraLiteModeFields",
                            "variableName": "includeJiraLiteModeFields"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeNavBoostScore",
                            "variableName": "includeNavBoostScore"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePassionfruitAsk",
                            "variableName": "includePassionfruitAsk"
                        },
                        {
                            "kind": "Variable",
                            "name": "includePositions",
                            "variableName": "includePositions"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeReactionsAndCommentCount",
                            "variableName": "includeReactionsAndCommentCount"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeRisk",
                            "variableName": "includeRisk"
                        },
                        {
                            "kind": "Variable",
                            "name": "includeThirdPartyId",
                            "variableName": "includeThirdPartyId"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "searchResults_AtlassianSearchPage_SearchResultsAsyncInner_queryData"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v27 /*: any*/ ,
                v2 /*: any*/ ,
                v35 /*: any*/ ,
                v24 /*: any*/ ,
                v8 /*: any*/ ,
                v28 /*: any*/ ,
                v29 /*: any*/ ,
                v30 /*: any*/ ,
                v3 /*: any*/ ,
                v5 /*: any*/ ,
                v23 /*: any*/ ,
                v1 /*: any*/ ,
                v26 /*: any*/ ,
                v34 /*: any*/ ,
                v4 /*: any*/ ,
                v36 /*: any*/ ,
                v32 /*: any*/ ,
                v33 /*: any*/ ,
                v11 /*: any*/ ,
                v31 /*: any*/ ,
                v12 /*: any*/ ,
                v25 /*: any*/ ,
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v10 /*: any*/ ,
                v7 /*: any*/ ,
                v13 /*: any*/ ,
                v9 /*: any*/ ,
                v19 /*: any*/ ,
                v22 /*: any*/ ,
                v17 /*: any*/ ,
                v18 /*: any*/ ,
                v21 /*: any*/ ,
                v16 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                v20 /*: any*/ ,
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isassetsenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isleadnounenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isleaduserastitleenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isslacktopreactionenabledrelayprovider"
                },
                {
                    "defaultValue": null,
                    "kind": "LocalArgument",
                    "name": "__relay_internal__pv__isprojectrendererenabledrelayprovider"
                }
            ],
            "kind": "Operation",
            "name": "searchResultsAsyncQuery",
            "selections": [
                {
                    "concreteType": "SearchQueryAPI",
                    "kind": "LinkedField",
                    "name": "search",
                    "plural": false,
                    "selections": [
                        {
                            "alias": "search",
                            "args": v37 /*: any*/ ,
                            "concreteType": "SearchItemConnection",
                            "kind": "LinkedField",
                            "name": "asyncSearch",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "isCachedResult"
                                },
                                {
                                    "concreteType": "SearchResultItemEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v38 /*: any*/ ,
                                                v39 /*: any*/ ,
                                                v40 /*: any*/ ,
                                                {
                                                    "concreteType": "SearchLinkedResult",
                                                    "kind": "LinkedField",
                                                    "name": "linkedResults",
                                                    "plural": true,
                                                    "selections": [
                                                        v39 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "category"
                                                        },
                                                        v41 /*: any*/ ,
                                                        v42 /*: any*/ ,
                                                        v43 /*: any*/ ,
                                                        v44 /*: any*/ ,
                                                        v40 /*: any*/ ,
                                                        v45 /*: any*/ ,
                                                        v46 /*: any*/ ,
                                                        v47 /*: any*/ ,
                                                        v48 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isSearchResult"
                                                },
                                                v42 /*: any*/ ,
                                                v44 /*: any*/ ,
                                                v43 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareGoal",
                                                            "kind": "LinkedField",
                                                            "name": "goal",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "TownsquareStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "TownsquareLocalizationField",
                                                                            "kind": "LinkedField",
                                                                            "name": "localizedLabel",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "messageId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        v49 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "score"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "targetDate",
                                                                    "plural": false,
                                                                    "selections": v51 /*: any*/ 
                                                                },
                                                                v39 /*: any*/ ,
                                                                v52 /*: any*/ ,
                                                                v40 /*: any*/ 
                                                            ]
                                                        },
                                                        v53 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultAtlasGoal"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "TownsquareProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isPrivate"
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "dueDate",
                                                                    "plural": false,
                                                                    "selections": v51 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "TownsquareProjectState",
                                                                    "kind": "LinkedField",
                                                                    "name": "state",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v50 /*: any*/ ,
                                                                        v49 /*: any*/ 
                                                                    ]
                                                                },
                                                                v39 /*: any*/ ,
                                                                v52 /*: any*/ 
                                                            ]
                                                        },
                                                        v53 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultAtlasProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "SearchFederatedEmailUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "sender",
                                                                            "plural": false,
                                                                            "selections": v55 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "SearchFederatedEmailEntity"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultFederated"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "tier"
                                                        },
                                                        {
                                                            "concreteType": "CompassComponent",
                                                            "kind": "LinkedField",
                                                            "name": "component",
                                                            "plural": false,
                                                            "selections": [
                                                                v40 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "state"
                                                                },
                                                                v39 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "ownerId"
                                                        }
                                                    ],
                                                    "type": "SearchResultCompassComponent"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v56 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "isVerified"
                                                        },
                                                        v53 /*: any*/ ,
                                                        {
                                                            "concreteType": "SearchConfluenceResultSpace",
                                                            "kind": "LinkedField",
                                                            "name": "space",
                                                            "plural": false,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                v54 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webUiLink"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "confluenceEntity",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ConfluenceCommentCountSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "commentCountSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v57 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ConfluenceLikesSummary",
                                                                            "kind": "LinkedField",
                                                                            "name": "likesSummary",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v58 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ConfluencePage"
                                                                },
                                                                v60 /*: any*/ 
                                                            ]
                                                        },
                                                        v64 /*: any*/ ,
                                                        {
                                                            "condition": "includeNavBoostScore",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "navBoostScore"
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchConfluencePageBlogAttachment"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v53 /*: any*/ ,
                                                        v56 /*: any*/ 
                                                    ],
                                                    "type": "SearchConfluenceSpace"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v48 /*: any*/ ,
                                                        v41 /*: any*/ ,
                                                        v47 /*: any*/ ,
                                                        v46 /*: any*/ ,
                                                        v45 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "permissionLevel"
                                                        },
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v54 /*: any*/ ,
                                                                        v65 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalBranch"
                                                                },
                                                                v60 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v67 /*: any*/ ,
                                                                        {
                                                                            "condition": "includeReactionsAndCommentCount",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ExternalReaction",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "reactionsV2",
                                                                                    "plural": true,
                                                                                    "selections": v68 /*: any*/ 
                                                                                }
                                                                            ]
                                                                        },
                                                                        v71 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalComment"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "author",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v73 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v65 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCommit"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v38 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v66 /*: any*/ ,
                                                                                        v43 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ExternalSpace"
                                                                                },
                                                                                v60 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalReaction",
                                                                            "kind": "LinkedField",
                                                                            "name": "reactions",
                                                                            "plural": true,
                                                                            "selections": v68 /*: any*/ 
                                                                        },
                                                                        v74 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalDocumentType",
                                                                            "kind": "LinkedField",
                                                                            "name": "type",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v53 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalLargeContent",
                                                                            "kind": "LinkedField",
                                                                            "name": "nonIndexableContent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mediaThumbnailUrl"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "parent",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v38 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v66 /*: any*/ 
                                                                                    ],
                                                                                    "type": "ExternalDocument"
                                                                                },
                                                                                v60 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "includeThirdPartyId",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "thirdPartyId"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "condition": "includeReactionsAndCommentCount",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "commentCount"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDocument"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v69 /*: any*/ ,
                                                                        v76 /*: any*/ ,
                                                                        v40 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalAttachment",
                                                                            "kind": "LinkedField",
                                                                            "name": "attachments",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v42 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "mimeType"
                                                                                },
                                                                                v43 /*: any*/ ,
                                                                                v77 /*: any*/ ,
                                                                                v38 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v79 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v38 /*: any*/ ,
                                                                                {
                                                                                    "kind": "InlineFragment",
                                                                                    "selections": [
                                                                                        v66 /*: any*/ ,
                                                                                        v83 /*: any*/ ,
                                                                                        v44 /*: any*/ ,
                                                                                        v39 /*: any*/ ,
                                                                                        v84 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "membershipType"
                                                                                        }
                                                                                    ],
                                                                                    "type": "ExternalConversation"
                                                                                },
                                                                                v60 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastActive"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "reactionCount"
                                                                        }
                                                                    ],
                                                                    "type": "ExternalMessage"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v40 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v84 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "members",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v38 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalConversation"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v74 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "endDate"
                                                                        },
                                                                        v85 /*: any*/ ,
                                                                        v89 /*: any*/ ,
                                                                        v90 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCampaign"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "displayNumber"
                                                                        },
                                                                        v74 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "closedAt"
                                                                        },
                                                                        v85 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "owners",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v87 /*: any*/ ,
                                                                                v92 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v90 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "container",
                                                                            "plural": false,
                                                                            "selections": v93 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCase"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v66 /*: any*/ ,
                                                                        v89 /*: any*/ ,
                                                                        v94 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalCustomerOrgLastActivity",
                                                                            "kind": "LinkedField",
                                                                            "name": "customerOrgLastActivity",
                                                                            "plural": false,
                                                                            "selections": v95 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCustomerOrg"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "stage"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "dealClosedAt"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalDealLastActivity",
                                                                            "kind": "LinkedField",
                                                                            "name": "lastActivity",
                                                                            "plural": false,
                                                                            "selections": v95 /*: any*/ 
                                                                        },
                                                                        v89 /*: any*/ ,
                                                                        v94 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDeal"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v67 /*: any*/ ,
                                                                        v96 /*: any*/ ,
                                                                        v97 /*: any*/ ,
                                                                        v98 /*: any*/ ,
                                                                        v52 /*: any*/ ,
                                                                        v74 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalProject"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v67 /*: any*/ ,
                                                                        v96 /*: any*/ ,
                                                                        v97 /*: any*/ ,
                                                                        v98 /*: any*/ ,
                                                                        v74 /*: any*/ ,
                                                                        v46 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "team"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalWorkItemProject",
                                                                            "kind": "LinkedField",
                                                                            "name": "workItemProject",
                                                                            "plural": false,
                                                                            "selections": v80 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalProvider",
                                                                            "kind": "LinkedField",
                                                                            "name": "provider",
                                                                            "plural": false,
                                                                            "selections": v55 /*: any*/ 
                                                                        }
                                                                    ],
                                                                    "type": "ExternalWorkItem"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v42 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "lastUpdate"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "pullRequestId"
                                                                        },
                                                                        {
                                                                            "alias": "pullRequestStatus",
                                                                            "kind": "ScalarField",
                                                                            "name": "status"
                                                                        },
                                                                        v65 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalPullRequest"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "durationInSeconds"
                                                                        },
                                                                        v77 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "ExternalChapter",
                                                                            "kind": "LinkedField",
                                                                            "name": "chapters",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                v42 /*: any*/ ,
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "startTimeInSeconds"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "createdBy",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v81 /*: any*/ ,
                                                                                v92 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalVideo"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v39 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        v99 /*: any*/ ,
                                                                        v89 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDashboard"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v39 /*: any*/ ,
                                                                        v43 /*: any*/ ,
                                                                        {
                                                                            "alias": "dataTableType",
                                                                            "kind": "ScalarField",
                                                                            "name": "type"
                                                                        },
                                                                        v99 /*: any*/ ,
                                                                        v89 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalDataTable"
                                                                },
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "accountName"
                                                                        },
                                                                        {
                                                                            "concreteType": "ExternalUser",
                                                                            "kind": "LinkedField",
                                                                            "name": "contactUser",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "ThirdPartyUser",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "thirdPartyUser",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v54 /*: any*/ ,
                                                                                        v70 /*: any*/ ,
                                                                                        v39 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalCustomerContact"
                                                                }
                                                            ]
                                                        },
                                                        v100 /*: any*/ ,
                                                        {
                                                            "kind": "LinkedField",
                                                            "name": "entity",
                                                            "plural": false,
                                                            "selections": [
                                                                v38 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        v97 /*: any*/ ,
                                                                        v101 /*: any*/ ,
                                                                        v102 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "recurringEventId"
                                                                        },
                                                                        v103 /*: any*/ 
                                                                    ],
                                                                    "type": "ExternalCalendarEvent"
                                                                },
                                                                v60 /*: any*/ ,
                                                                {
                                                                    "kind": "InlineFragment",
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "ExternalThumbnail",
                                                                            "kind": "LinkedField",
                                                                            "name": "thumbnail",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "externalUrl"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ],
                                                                    "type": "ExternalDesign"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "SearchResultGraphDocument",
                                                            "kind": "LinkedField",
                                                            "name": "linkedEntities",
                                                            "plural": true,
                                                            "selections": [
                                                                v39 /*: any*/ ,
                                                                v42 /*: any*/ ,
                                                                v43 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "entity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v38 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v102 /*: any*/ ,
                                                                                v101 /*: any*/ ,
                                                                                v103 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalCalendarEvent"
                                                                        },
                                                                        v60 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v66 /*: any*/ ,
                                                                                v71 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalComment"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v79 /*: any*/ ,
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "container",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v38 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                v83 /*: any*/ ,
                                                                                                v44 /*: any*/ 
                                                                                            ],
                                                                                            "type": "ExternalConversation"
                                                                                        },
                                                                                        v60 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v69 /*: any*/ ,
                                                                                v76 /*: any*/ ,
                                                                                v40 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalMessage"
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v40 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalConversation"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "parentId"
                                                                },
                                                                v100 /*: any*/ ,
                                                                {
                                                                    "concreteType": "ThirdPartyUser",
                                                                    "kind": "LinkedField",
                                                                    "name": "initialContributors",
                                                                    "plural": true,
                                                                    "selections": v78 /*: any*/ 
                                                                },
                                                                v47 /*: any*/ ,
                                                                v104 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "ThirdPartyUser",
                                                            "kind": "LinkedField",
                                                            "name": "initialContributors",
                                                            "plural": true,
                                                            "selections": [
                                                                v54 /*: any*/ ,
                                                                v61 /*: any*/ ,
                                                                v39 /*: any*/ ,
                                                                v62 /*: any*/ ,
                                                                v69 /*: any*/ ,
                                                                v70 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "concreteType": "SearchResultGraphTab",
                                                            "kind": "LinkedField",
                                                            "name": "tabs",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "tabId"
                                                                },
                                                                v42 /*: any*/ ,
                                                                v43 /*: any*/ ,
                                                                v38 /*: any*/ 
                                                            ]
                                                        },
                                                        v99 /*: any*/ ,
                                                        {
                                                            "concreteType": "SearchResultGraphAttachment",
                                                            "kind": "LinkedField",
                                                            "name": "attachments",
                                                            "plural": true,
                                                            "selections": [
                                                                v42 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "fileType"
                                                                },
                                                                v43 /*: any*/ ,
                                                                v38 /*: any*/ 
                                                            ]
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "containerName"
                                                        },
                                                        {
                                                            "concreteType": "ThirdPartyUser",
                                                            "kind": "LinkedField",
                                                            "name": "allContributors",
                                                            "plural": true,
                                                            "selections": v80 /*: any*/ 
                                                        },
                                                        v104 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "links"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "linkedEntitiesType"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "connectorId"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "connectorProduct"
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "isSharedChannel"
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__isleadnounenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "entity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                v74 /*: any*/ ,
                                                                                v85 /*: any*/ ,
                                                                                {
                                                                                    "condition": "__relay_internal__pv__isleaduserastitleenabledrelayprovider",
                                                                                    "kind": "Condition",
                                                                                    "passingValue": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "ExternalUser",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "leadUser",
                                                                                            "plural": false,
                                                                                            "selections": v88 /*: any*/ 
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v89 /*: any*/ ,
                                                                                v90 /*: any*/ 
                                                                            ],
                                                                            "type": "ExternalLead"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        {
                                                            "condition": "__relay_internal__pv__isslacktopreactionenabledrelayprovider",
                                                            "kind": "Condition",
                                                            "passingValue": true,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SearchSlackReaction",
                                                                    "kind": "LinkedField",
                                                                    "name": "topReaction",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "emojiName"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "emojiUrl"
                                                                        },
                                                                        v58 /*: any*/ 
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultGraphDocument"
                                                },
                                                {
                                                    "condition": "includeGithubCode",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "path"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "language"
                                                                },
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "concreteType": "SearchResultCodeRepository",
                                                                    "kind": "LinkedField",
                                                                    "name": "repository",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v54 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "namespace"
                                                                        },
                                                                        v43 /*: any*/ ,
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultGraphCode"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        v53 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraIssue",
                                                            "kind": "LinkedField",
                                                            "name": "issue",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "condition": "includeFastJiraHydration",
                                                                    "kind": "Condition",
                                                                    "passingValue": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "issueTypeAvatarUrl"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraIssueTypeField",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueTypeField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "issueType",
                                                                                    "plural": false,
                                                                                    "selections": v86 /*: any*/ 
                                                                                },
                                                                                v39 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "ids",
                                                                                    "value": [
                                                                                        "project"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "JiraIssueFieldConnection",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldsById",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraIssueFieldEdge",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "edges",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "LinkedField",
                                                                                            "name": "node",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                v38 /*: any*/ ,
                                                                                                v54 /*: any*/ ,
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        v105 /*: any*/ 
                                                                                                    ],
                                                                                                    "type": "JiraProjectField"
                                                                                                },
                                                                                                v39 /*: any*/ 
                                                                                            ]
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldsById(ids:[\"project\"])"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraSingleSelectUserPickerField",
                                                                            "kind": "LinkedField",
                                                                            "name": "assigneeField",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v73 /*: any*/ ,
                                                                                v39 /*: any*/ 
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v106 /*: any*/ ,
                                                                v52 /*: any*/ ,
                                                                {
                                                                    "condition": "includeFastJiraHydration",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "JiraIssueType",
                                                                            "kind": "LinkedField",
                                                                            "name": "issueType",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                v54 /*: any*/ ,
                                                                                {
                                                                                    "concreteType": "JiraAvatar",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "avatar",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "ScalarField",
                                                                                            "name": "medium"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                v39 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        v105 /*: any*/ ,
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "assignee",
                                                                            "plural": false,
                                                                            "selections": v72 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "condition": "includeJiraLiteModeFields",
                                                                            "kind": "Condition",
                                                                            "passingValue": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": "fastPriority",
                                                                                    "concreteType": "JiraPriority",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "priority",
                                                                                    "plural": false,
                                                                                    "selections": v107 /*: any*/ 
                                                                                },
                                                                                {
                                                                                    "alias": "fastLabels",
                                                                                    "args": v108 /*: any*/ ,
                                                                                    "concreteType": "JiraLabelConnection",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "labels",
                                                                                    "plural": false,
                                                                                    "selections": v109 /*: any*/ ,
                                                                                    "storageKey": "labels(first:5)"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "condition": "includeJiraLiteModeFields",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "condition": "includeFastJiraHydration",
                                                                            "kind": "Condition",
                                                                            "passingValue": false,
                                                                            "selections": [
                                                                                {
                                                                                    "concreteType": "JiraPriorityField",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "priorityField",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "concreteType": "JiraPriority",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "priority",
                                                                                            "plural": false,
                                                                                            "selections": v107 /*: any*/ 
                                                                                        },
                                                                                        v39 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                {
                                                                                    "concreteType": "JiraLabelsField",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "labelsField",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "args": v108 /*: any*/ ,
                                                                                            "concreteType": "JiraLabelConnection",
                                                                                            "kind": "LinkedField",
                                                                                            "name": "selectedLabelsConnection",
                                                                                            "plural": false,
                                                                                            "selections": v109 /*: any*/ ,
                                                                                            "storageKey": "selectedLabelsConnection(first:5)"
                                                                                        },
                                                                                        v39 /*: any*/ 
                                                                                    ]
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                v39 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraIssue"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "projectKey"
                                                        },
                                                        v45 /*: any*/ ,
                                                        v53 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraProject",
                                                            "kind": "LinkedField",
                                                            "name": "project",
                                                            "plural": false,
                                                            "selections": [
                                                                v106 /*: any*/ ,
                                                                {
                                                                    "condition": "includeJiraLiteModeFields",
                                                                    "kind": "Condition",
                                                                    "passingValue": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "LinkedField",
                                                                            "name": "lead",
                                                                            "plural": false,
                                                                            "selections": v72 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "small"
                                                                                }
                                                                            ]
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "projectStyle"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "projectType"
                                                                        },
                                                                        {
                                                                            "concreteType": "JiraProjectCategory",
                                                                            "kind": "LinkedField",
                                                                            "name": "category",
                                                                            "plural": false,
                                                                            "selections": v86 /*: any*/ 
                                                                        }
                                                                    ]
                                                                },
                                                                v39 /*: any*/ 
                                                            ]
                                                        },
                                                        v64 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultJiraProject"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v110 /*: any*/ ,
                                                    "type": "SearchResultJiraPlan"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        v53 /*: any*/ ,
                                                        {
                                                            "concreteType": "JiraBoard",
                                                            "kind": "LinkedField",
                                                            "name": "board",
                                                            "plural": false,
                                                            "selections": [
                                                                v53 /*: any*/ ,
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "boardFrontendUrl"
                                                                },
                                                                v39 /*: any*/ 
                                                            ]
                                                        }
                                                    ],
                                                    "type": "SearchResultJiraBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v110 /*: any*/ ,
                                                    "type": "SearchResultJiraDashboard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v110 /*: any*/ ,
                                                    "type": "SearchResultJiraFilter"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "concreteType": "MercuryFocusArea",
                                                            "kind": "LinkedField",
                                                            "name": "focusArea",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "concreteType": "MercuryFocusAreaStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": v111 /*: any*/ 
                                                                },
                                                                {
                                                                    "concreteType": "MercuryFocusAreaHealth",
                                                                    "kind": "LinkedField",
                                                                    "name": "health",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v52 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "color"
                                                                        },
                                                                        v66 /*: any*/ ,
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "MercuryTargetDate",
                                                                    "kind": "LinkedField",
                                                                    "name": "targetDate",
                                                                    "plural": false,
                                                                    "selections": v112 /*: any*/ 
                                                                },
                                                                v39 /*: any*/ ,
                                                                v54 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MercuryFocusAreaType",
                                                                    "kind": "LinkedField",
                                                                    "name": "focusAreaType",
                                                                    "plural": false,
                                                                    "selections": v80 /*: any*/ 
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "owner",
                                                                    "plural": false,
                                                                    "selections": v91 /*: any*/ 
                                                                }
                                                            ]
                                                        },
                                                        v45 /*: any*/ 
                                                    ],
                                                    "type": "SearchResultMercuryFocusArea"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v45 /*: any*/ ,
                                                        {
                                                            "concreteType": "MercuryFocusArea",
                                                            "kind": "LinkedField",
                                                            "name": "focusArea",
                                                            "plural": false,
                                                            "selections": v86 /*: any*/ 
                                                        }
                                                    ],
                                                    "type": "SearchResultMercuryFocusAreaStatusUpdate"
                                                },
                                                {
                                                    "condition": "includeRisk",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "concreteType": "MercuryRisk",
                                                                    "kind": "LinkedField",
                                                                    "name": "risk",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "MercuryRiskStatus",
                                                                            "kind": "LinkedField",
                                                                            "name": "status",
                                                                            "plural": false,
                                                                            "selections": v111 /*: any*/ 
                                                                        },
                                                                        {
                                                                            "concreteType": "MercuryRiskTargetDate",
                                                                            "kind": "LinkedField",
                                                                            "name": "targetDate",
                                                                            "plural": false,
                                                                            "selections": v112 /*: any*/ 
                                                                        },
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultMercuryRisk"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "includePassionfruitAsk",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "SpfAsk",
                                                                    "kind": "LinkedField",
                                                                    "name": "ask",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v74 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "SpfAskTargetDate",
                                                                            "kind": "LinkedField",
                                                                            "name": "targetDate",
                                                                            "plural": false,
                                                                            "selections": v112 /*: any*/ 
                                                                        },
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                },
                                                                v45 /*: any*/ 
                                                            ],
                                                            "type": "SearchResultSpfAsk"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v113 /*: any*/ ,
                                                    "type": "SearchResultTrelloBoard"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": v113 /*: any*/ ,
                                                    "type": "SearchResultTrelloCard"
                                                },
                                                {
                                                    "condition": "__relay_internal__pv__isassetsenabledrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsSchema",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectSchemaEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v54 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        v114 /*: any*/ ,
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObjectSchema"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                v115 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsObjectType",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectTypeEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v54 /*: any*/ ,
                                                                        v66 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "AssetsIcon",
                                                                            "kind": "LinkedField",
                                                                            "name": "icon",
                                                                            "plural": false,
                                                                            "selections": v116 /*: any*/ 
                                                                        },
                                                                        v114 /*: any*/ ,
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObjectType"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v45 /*: any*/ ,
                                                                v115 /*: any*/ ,
                                                                {
                                                                    "concreteType": "AssetsObject",
                                                                    "kind": "LinkedField",
                                                                    "name": "objectEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "concreteType": "AssetsAvatar",
                                                                            "kind": "LinkedField",
                                                                            "name": "avatar",
                                                                            "plural": false,
                                                                            "selections": v116 /*: any*/ 
                                                                        },
                                                                        v114 /*: any*/ ,
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultAssetsObject"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "condition": "includePositions",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "concreteType": "RadarPosition",
                                                                    "kind": "LinkedField",
                                                                    "name": "position",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v38 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "RadarWorker",
                                                                            "kind": "LinkedField",
                                                                            "name": "worker",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "preferredName"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v38 /*: any*/ ,
                                                                                        v61 /*: any*/ ,
                                                                                        v39 /*: any*/ 
                                                                                    ]
                                                                                },
                                                                                v39 /*: any*/ 
                                                                            ]
                                                                        },
                                                                        {
                                                                            "args": [
                                                                                {
                                                                                    "kind": "Literal",
                                                                                    "name": "fieldIdIsIn",
                                                                                    "value": [
                                                                                        "positionId",
                                                                                        "positionStatus",
                                                                                        "positionJobTitle",
                                                                                        "positionPositionTitle",
                                                                                        "positionKey",
                                                                                        "positionExternalPositionKey",
                                                                                        "positionWorker",
                                                                                        "focusArea"
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "concreteType": "RadarFieldValueIdPair",
                                                                            "kind": "LinkedField",
                                                                            "name": "fieldValues",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "ScalarField",
                                                                                    "name": "fieldId"
                                                                                },
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "fieldValue",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        v38 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "alias": "stringValue",
                                                                                                    "kind": "ScalarField",
                                                                                                    "name": "value"
                                                                                                }
                                                                                            ],
                                                                                            "type": "RadarStringFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "value",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v38 /*: any*/ ,
                                                                                                        {
                                                                                                            "kind": "InlineFragment",
                                                                                                            "selections": [
                                                                                                                v54 /*: any*/ ,
                                                                                                                {
                                                                                                                    "concreteType": "MercuryFocusAreaStatus",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "status",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v117 /*: any*/ 
                                                                                                                },
                                                                                                                {
                                                                                                                    "concreteType": "MercuryFocusAreaHealth",
                                                                                                                    "kind": "LinkedField",
                                                                                                                    "name": "health",
                                                                                                                    "plural": false,
                                                                                                                    "selections": v117 /*: any*/ 
                                                                                                                }
                                                                                                            ],
                                                                                                            "type": "MercuryFocusArea"
                                                                                                        },
                                                                                                        v60 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "RadarAriFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "storageKey": "fieldValues(fieldIdIsIn:[\"positionId\",\"positionStatus\",\"positionJobTitle\",\"positionPositionTitle\",\"positionKey\",\"positionExternalPositionKey\",\"positionWorker\",\"focusArea\"])"
                                                                        },
                                                                        v39 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "SearchResultTalentPosition"
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "SearchQueryInfo",
                                    "kind": "LinkedField",
                                    "name": "queryInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "replacementQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "suggestedQuery"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "originalQueryType"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "confidenceScore"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "shouldTriggerAutocorrectionExperience"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "traceId"
                                },
                                {
                                    "concreteType": "SearchError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "statusCode"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "product"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "integration"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "alias": "search",
                            "args": v37 /*: any*/ ,
                            "filters": [
                                "experience",
                                "enableHighlighting",
                                "query",
                                "sort",
                                "disableQueryReplacement",
                                "fanoutExperimentCohort",
                                "expectResult",
                                "filters",
                                "analytics",
                                "experimentContext",
                                "matchingLayerExperimentsMetadata"
                            ],
                            "handle": "connection",
                            "key": "SearchResultsAsyncPagination__search",
                            "kind": "LinkedHandle",
                            "name": "asyncSearch"
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "bccbdd49d816b372aad6090a955295b76ed70b9fd157d7f9c3b16398d55ae46d",
            "metadata": {},
            "name": "searchResultsAsyncQuery",
            "operationKind": "query",
            "text": null,
            "providedVariables": {
                "__relay_internal__pv__isassetsenabledrelayprovider": (0, $hd5Dy.default),
                "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider": (0, $hFjUk.default),
                "__relay_internal__pv__isleadnounenabledrelayprovider": (0, $iK48f.default),
                "__relay_internal__pv__isleaduserastitleenabledrelayprovider": (0, $8dp6J.default),
                "__relay_internal__pv__isslacktopreactionenabledrelayprovider": (0, $4Pgy4.default),
                "__relay_internal__pv__isprojectrendererenabledrelayprovider": (0, $b9kI4.default)
            }
        }
    };
}();
$b16e14c5cbb2e6b9$var$node.hash = "faa30fa1344274d354a6ac7e4c49b566";
var $b16e14c5cbb2e6b9$export$2e2bcd8739ae039 = $b16e14c5cbb2e6b9$var$node;
module.exports["default"] = $b16e14c5cbb2e6b9$export$2e2bcd8739ae039;

});

parcelRegister("hd5Dy", function(module, exports) {
$parcel$export(module.exports, "default", () => $537e39b311f76645$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");

var $537e39b311f76645$export$2e2bcd8739ae039 = {
    get () {
        return (0, $iDrrr.fg)('assets_rovo_search_all');
    }
};

});

parcelRegister("iK48f", function(module, exports) {
$parcel$export(module.exports, "default", () => $f04067010154282e$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");

var // https://switcheroo.atlassian.com/ui/gates/rovo-fps-3p-ux-salesforce-lead-noun
$f04067010154282e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-lead-noun');
    }
};

});

parcelRegister("8dp6J", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6f58341d7ed5e13$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");

var // https://switcheroo.atlassian.com/ui/gates/rovo_fps_lead_user_as_title
$e6f58341d7ed5e13$export$2e2bcd8739ae039 = {
    get () {
        return (0, $iDrrr.fg)('rovo_fps_lead_user_as_title');
    }
};

});

parcelRegister("hFjUk", function(module, exports) {
$parcel$export(module.exports, "default", () => $760084c5b07c8f2d$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");

var $760084c5b07c8f2d$export$2e2bcd8739ae039 = {
    get () {
        return (0, $iDrrr.fg)('ai_3p_slack_eg_workspace_metadata_enabled');
    }
};

});

parcelRegister("4Pgy4", function(module, exports) {
$parcel$export(module.exports, "default", () => $102dbd473905b15e$export$2e2bcd8739ae039);

var $cJff5 = parcelRequire("cJff5");

var $102dbd473905b15e$export$2e2bcd8739ae039 = {
    get () {
        return (0, $cJff5.serveSlackTopReactionInSearchExperiment)({
            fireExperimentExposure: false
        });
    }
};

});

parcelRegister("b9kI4", function(module, exports) {
$parcel$export(module.exports, "default", () => $32f6f0b1131ac6c0$export$2e2bcd8739ae039);

var $iDrrr = parcelRequire("iDrrr");

var // https://switcheroo.atlassian.com/ui/gates/rovo_fps_servicenow_project_renderer
$32f6f0b1131ac6c0$export$2e2bcd8739ae039 = {
    get () {
        return (0, $iDrrr.fg)('rovo_fps_servicenow_project_renderer');
    }
};

});

parcelRegister("jyixt", function(module, exports) {
/**
 * @generated SignedSource<<403f147e916912fe0c48265692200865>>
 * @relayHash 68a75d183b7539fe986ed18773f1120a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID b5a34acb4d7d17f7799133361703a90caebf20808095b5e29e02fc3b4e0d6a76
const $8392099c2a71c856$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cql"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "kind": "Variable",
        "name": "after",
        "variableName": "after"
    }, v4 = {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
    }, v5 = [
        v3 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "cql",
            "variableName": "cql"
        },
        v4 /*: any*/ 
    ], v6 = {
        "kind": "ScalarField",
        "name": "ari"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "searchResultsCqlQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "searchResultsCql_AtlassianSearchPage"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "searchResultsCqlQuery",
            "selections": [
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "ConfluenceSearchConnection",
                    "kind": "LinkedField",
                    "name": "confluence_search",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "ConfluenceSearchResponseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "concreteType": "ConfluenceSearchResponse",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "url"
                                        },
                                        {
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "content",
                                            "plural": false,
                                            "selections": [
                                                v6 /*: any*/ ,
                                                v7 /*: any*/ ,
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "type"
                                                },
                                                {
                                                    "concreteType": "Space",
                                                    "kind": "LinkedField",
                                                    "name": "space",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "name"
                                                        },
                                                        {
                                                            "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                                                            "kind": "LinkedField",
                                                            "name": "links",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "webui"
                                                                }
                                                            ]
                                                        },
                                                        v7 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "title"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "excerpt"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "lastModified"
                                        },
                                        {
                                            "concreteType": "LinksContextBase",
                                            "kind": "LinkedField",
                                            "name": "links",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "base"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "cursor"
                                }
                            ]
                        },
                        {
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v5 /*: any*/ ,
                    "filters": [
                        "cql"
                    ],
                    "handle": "connection",
                    "key": "SearchResultsCQLPagination__confluence_search",
                    "kind": "LinkedHandle",
                    "name": "confluence_search"
                }
            ]
        },
        "params": {
            "id": "b5a34acb4d7d17f7799133361703a90caebf20808095b5e29e02fc3b4e0d6a76",
            "metadata": {},
            "name": "searchResultsCqlQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$8392099c2a71c856$var$node.hash = "8714af4459ffedbd0699977be49d7cf7";
var $8392099c2a71c856$export$2e2bcd8739ae039 = $8392099c2a71c856$var$node;
module.exports["default"] = $8392099c2a71c856$export$2e2bcd8739ae039;

});

parcelRegister("7QpO7", function(module, exports) {

var $6onJ6 = parcelRequire("6onJ6");

const $deb1c3471472a179$export$fa81019546daea36 = (0, $6onJ6.disposableValue)();
const $deb1c3471472a179$export$821c81800cc5b1e1 = ()=>{
    return $deb1c3471472a179$export$fa81019546daea36.value() || undefined;
};
const $deb1c3471472a179$export$c3c881dbbb056bcd = ()=>{
    $deb1c3471472a179$export$fa81019546daea36.update(Date.now());
};
const $deb1c3471472a179$export$99f330c261037d6f = ()=>{
    $deb1c3471472a179$export$fa81019546daea36.dispose();
};
module.exports["getQueryUpdatedTime"] = $deb1c3471472a179$export$821c81800cc5b1e1;
module.exports["setQueryUpdatedTime"] = $deb1c3471472a179$export$c3c881dbbb056bcd;
module.exports["disposeQueryUpdatedTime"] = $deb1c3471472a179$export$99f330c261037d6f;

});

parcelRegister("dsOco", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6yu7A = parcelRequire("6yu7A");


var $9pcjO = parcelRequire("9pcjO");


var $c11PZ = parcelRequire("c11PZ");


var $32Eau = parcelRequire("32Eau");


var $1i979 = parcelRequire("1i979");





var $dvVWp = parcelRequire("dvVWp");


var $e0v3Z = parcelRequire("e0v3Z");

const $8b685f31f0cb0433$export$fe94072fee8a6976 = ({ searchSessionId: searchSessionId, requestId: requestId, searchQuery: searchQuery, inputQuery: inputQuery, filters: filters, queryUpdatedTime: queryUpdatedTime, productSelected: productSelected, availableProducts: availableProducts, sort: sort, experimentConfig: experimentConfig, applicationMode: applicationMode, productEdition: productEdition, isCQL: isCQL, isLiteMode: isLiteMode })=>{
    const { filterSelections: filterSelections, filters: filterCategories } = filters;
    const has3pProducts = !!availableProducts.find((product)=>(0, $dvVWp.is3pProductKey)(product));
    const { frontendExperiments: frontendExperiments = {} } = experimentConfig;
    const is3pSearch = !!(has3pProducts && !productSelected || productSelected && (0, $dvVWp.is3pProductKey)(productSelected));
    const archivedStatus = filterSelections.some((selection)=>selection.value === (0, $6yu7A.OptionIds).ARCHIVED) ? [
        (0, $6yu7A.CURRENT),
        (0, $6yu7A.ARCHIVED)
    ] : [
        (0, $6yu7A.CURRENT)
    ];
    const commonAttributes = {
        searchSessionId: searchSessionId,
        traceId: requestId,
        productSelected: productSelected || (0, $6yu7A.ALL_PRODUCTS_STRING),
        availableProducts: availableProducts,
        mode: applicationMode,
        has3pProducts: has3pProducts,
        is3pSearch: is3pSearch,
        numberOfTerms: (searchQuery.match(/\w+/g) || []).length,
        queryLength: searchQuery.length,
        inputQueryLength: inputQuery.length,
        queryHash: (0, $e0v3Z.sha256Hash)(searchQuery),
        filters: filterCategories,
        filterSelections: filterSelections,
        containerStatuses: archivedStatus,
        contentStatuses: archivedStatus,
        productEdition: productEdition,
        frontendExperiments: {
            activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
            ...frontendExperiments
        },
        version: 2,
        api: (0, $6yu7A.CROSSPRODUCT_SEARCH_API),
        wordCount: (searchQuery.match(/\w+/g) || []).length,
        isCQL: isCQL ?? false,
        queryUpdatedAgo: queryUpdatedTime ? Date.now() - queryUpdatedTime : undefined,
        sort: sort,
        isSearchPageRelay: true,
        isLiteMode: isLiteMode ?? false
    };
    const nonPrivacySafeAttributes = {
        query: searchQuery,
        inputQuery: inputQuery
    };
    return {
        commonAttributes: commonAttributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};


const $b5cd5ad05ff5fdff$export$e955abb82869dc84 = (props = {})=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // analytics attributes passed in from the product
    const [analyticsAttributes] = (0, $32Eau.useAnalyticsAttributes)();
    const [searchExperience] = (0, $1i979.useSearchExperience)();
    const experiencePayload = (0, $cozmU.useMemo)(()=>{
        // determine experience payload for analytics attributes, defaulting to store value if not provided
        const experience = props.experience || searchExperience;
        const isQuickFind = experience === (0, $9pcjO.SearchExperience).QUICK_FIND;
        const isFullPageSearch = experience === (0, $9pcjO.SearchExperience).SEARCH_PAGE;
        return {
            isFullPageSearch: isFullPageSearch,
            isQuickFind: isQuickFind
        };
    }, [
        props.experience,
        searchExperience
    ]);
    // use this hook to fire UI, track, and operational event types
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: payload.source || (0, $6yu7A.EVENT_SOURCE),
            attributes: {
                ...payload.attributes.commonAttributes,
                ...payload.attributes.additionalAttributes,
                ...analyticsAttributes,
                ...experiencePayload
            }
        }).fire((0, $6yu7A.DEFAULT_GAS_CHANNEL));
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        experiencePayload
    ]);
    // use this hook to fire screen event types
    const fireAnalyticsScreenEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            eventType: 'screen',
            source: (0, $6yu7A.EVENT_SOURCE),
            attributes: {
                ...payload.attributes.commonAttributes,
                ...payload.attributes.additionalAttributes,
                ...analyticsAttributes,
                ...experiencePayload
            }
        }).fire((0, $6yu7A.DEFAULT_GAS_CHANNEL));
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        experiencePayload
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent,
        fireAnalyticsScreenEvent: fireAnalyticsScreenEvent
    };
};
const $b5cd5ad05ff5fdff$export$58bac47385d8e8f4 = ()=>{
    const [searchSessionId] = (0, $32Eau.useSearchSessionId)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [requestId] = (0, $1i979.useResultsRequestId)();
    const [searchQuery] = (0, $1i979.useSearchQuery)();
    const [inputQuery] = (0, $1i979.useInputQuery)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [queryUpdatedTime] = (0, $1i979.useQueryUpdatedTime)();
    const [productSelected] = (0, $1i979.useSelectedProduct)();
    const availableProducts = (0, $32Eau.useAvailableProducts)();
    const [sort] = (0, $1i979.useResultsSort)();
    const [experimentConfig] = (0, $32Eau.useExperimentConfig)();
    const filters = (0, $1i979.useFilterAttributesForTracking)();
    const applicationMode = (0, $32Eau.useApplicationMode)();
    const [productEdition] = (0, $32Eau.useProductEdition)();
    const cqlState = (0, $1i979.useCQL)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const { queryParams: queryParams } = (0, $c11PZ.useAppContext)();
    const [features] = (0, $32Eau.useFeatures)();
    const isLiteMode = features?.lite?.enabled ?? false;
    return (0, $8b685f31f0cb0433$export$fe94072fee8a6976)({
        searchSessionId: searchSessionId,
        requestId: requestId,
        searchQuery: searchQuery,
        inputQuery: inputQuery,
        filters: filters,
        queryUpdatedTime: queryUpdatedTime,
        productSelected: productSelected,
        availableProducts: availableProducts,
        sort: sort,
        experimentConfig: experimentConfig,
        applicationMode: applicationMode,
        productEdition: productEdition,
        isCQL: !!cqlState,
        isLiteMode: isLiteMode,
        primaryProduct: primaryProduct,
        queryParams: queryParams
    });
};
module.exports["useAnalytics"] = $b5cd5ad05ff5fdff$export$e955abb82869dc84;
module.exports["useCommonAndPrivateAttributes"] = $b5cd5ad05ff5fdff$export$58bac47385d8e8f4;

});

parcelRegister("32Eau", function(module, exports) {
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required */ 
var $1UWNP = parcelRequire("1UWNP");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");


var $03RpJ = parcelRequire("03RpJ");


var $5msm2 = parcelRequire("5msm2");


var $2O9Q9 = parcelRequire("2O9Q9");


var $jXCr4 = parcelRequire("jXCr4");


var $imdMF = parcelRequire("imdMF");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $9ekgQ = parcelRequire("9ekgQ");


var $cJff5 = parcelRequire("cJff5");


var $ljBeq = parcelRequire("ljBeq");


var $cn81K = parcelRequire("cn81K");


var $03qcI = parcelRequire("03qcI");


var $biQM6 = parcelRequire("biQM6");


var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $kh8w1 = parcelRequire("kh8w1");























var $ktiKH = parcelRequire("ktiKH");


var $yW9ML = parcelRequire("yW9ML");

const $af0491d427fc090c$export$a607044ff61ed35a = ()=>{
    const staticContext = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    // Unused, clean up when removing rovo-search-remove-rss-bootstrap-fg
    // Here due to type strictness on BootstrapState
    const unusedProps = {
        prevQueryParams: {},
        initialSpaceARIs: []
    };
    // `dynamicContext.thirdPartyConfigs` is only populated when
    // `rovo_fps_use_rovo_config` is ON. When the gate is OFF the dynamic
    // context value is `undefined`, and a naive `{ ...dynamicContext }` spread
    // would overwrite the populated `thirdPartyConfigs` coming from the
    // static context — breaking every consumer that destructures it from
    // `useBootstrap()` (e.g. universal-type filter resolution in the search
    // pipeline). Pick the dynamic value only when it's actually defined.
    // Remove this when rovo_fps_use_rovo_config is cleaned up
    const { thirdPartyConfigs: dynamicThirdPartyConfigs, ...dynamicContextRest } = dynamicContext;
    const mergedThirdPartyConfigs = dynamicThirdPartyConfigs ?? staticContext.thirdPartyConfigs;
    return [
        {
            ...unusedProps,
            ...staticContext,
            ...dynamicContextRest,
            thirdPartyConfigs: mergedThirdPartyConfigs
        }
    ];
};
const $af0491d427fc090c$export$3129106711858d9e = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.applicationMode);
const $af0491d427fc090c$export$8d72fbb40ea96b11 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.linkedCloudARIs);
const $af0491d427fc090c$export$7a947e70298b5de6 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.unitMetadata);
const $af0491d427fc090c$export$42159b7c323c1456 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.initialTextQueryParam);
const $af0491d427fc090c$export$8b362261a7637697 = ()=>{
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    return dynamicContext.referrer;
};
const $af0491d427fc090c$export$f84f93bb6857e6bf = ()=>true;
/**
 * Retrieve third party configs from the static bootstrap store (legacy path).
 *
 * Used by `useThirdPartyConfigsContext` when `rovo_fps_use_rovo_config` is OFF.
 * On the FG-OFF path the value is seeded from `useFetchConfigLegacy` and only
 * mutated by `setThirdPartyConfigs` from the legacy OAuth handler.
 */ const $af0491d427fc090c$var$useThirdPartyConfigsFromStaticContext = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.thirdPartyConfigs);
/**
 * Retrieve third party configs from the dynamic bootstrap context (FG-ON path).
 *
 * Under `rovo_fps_use_rovo_config`, `BootstrapContextProvider` routes
 * `thirdPartyConfigs` into dynamic context so reference changes from
 * `useRovoConfig.onOAuthSuccess` propagate via React's normal context
 * broadcast. Falls back to the static-context default if (somehow) the
 * dynamic value is undefined.
 */ const $af0491d427fc090c$var$useThirdPartyConfigsFromDynamicContext = ()=>{
    const dynamic = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    return dynamic?.thirdPartyConfigs ?? $af0491d427fc090c$var$defaultStaticContextThirdPartyConfigs;
};
const $af0491d427fc090c$var$defaultStaticContextThirdPartyConfigs = {};
const $af0491d427fc090c$export$e2860ebe87e62f0d = ()=>{
    // The dispatch below intentionally calls one of two hooks based on a
    // stable feature-gate value. Per `rovo_fps_use_rovo_config` rollout
    // semantics the gate result does not flip within a session, so the
    // hook call order is stable across renders for a given user — but
    // the react-hooks rule cannot statically prove this, so we disable
    // `rules-of-hooks` for both call sites in the ternary.
    /* eslint-disable react-hooks/rules-of-hooks */ return (0, $kh8w1.isRovoFPSUseRovoConfigEnabled)() ? $af0491d427fc090c$var$useThirdPartyConfigsFromDynamicContext() : $af0491d427fc090c$var$useThirdPartyConfigsFromStaticContext();
/* eslint-enable react-hooks/rules-of-hooks */ };
const $af0491d427fc090c$export$682b612810461522 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.productEdition);
const $af0491d427fc090c$export$b238e8fc41384c76 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>!!ctx.rovoFeatures?.scas);
const $af0491d427fc090c$export$db066d8e499b7f58 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.experimentConfig);
const $af0491d427fc090c$export$414e9503f60ee463 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.multiSiteSearchInRovo);
const $af0491d427fc090c$export$a20db2e6915ac3c5 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.isHello);
const $af0491d427fc090c$export$c3427a530f474eaf = ()=>{
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    return dynamicContext.searchSessionId;
};
const $af0491d427fc090c$export$5abfe064a9321e1 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.nouns);
const $af0491d427fc090c$export$aa1a270414bf62e1 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.products);
const $af0491d427fc090c$export$da4da5285a2fd344 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.analyticsAttributes);
const $af0491d427fc090c$export$f1c90440d6c09079 = ()=>{
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    return dynamicContext.smartLinkUsage;
};
const $af0491d427fc090c$export$4c06a80ce19ae7c8 = ()=>{
    const staticContext = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    return staticContext.isConfigLoaded;
};
const $af0491d427fc090c$export$b79f482a36aed45 = ()=>{
    const staticContext = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    return (0, $cozmU.useMemo)(()=>{
        return staticContext.products != null && staticContext.products.length > 0;
    }, [
        staticContext.products
    ]);
};
const $af0491d427fc090c$export$c8d3ac176f5c521c = ()=>{
    const staticContext = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    return staticContext.experimentConfig.frontendExperiments;
};
const $af0491d427fc090c$export$284401669662f77b = (args)=>{
    const staticContext = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    const { experimentConfig: experimentConfig, productEdition: productEdition, productDataRegions: productDataRegions, experience: experience, cloudId: cloudId, isJiraIssueIndexed: isJiraIssueIndexed, isHello: isHello } = staticContext;
    return (0, $cozmU.useMemo)(()=>{
        return (0, $5msm2.getBackendExperiment)({
            experimentConfig: experimentConfig,
            entities: args.entities,
            productEdition: productEdition,
            isHello: isHello,
            productDataRegions: productDataRegions,
            experience: experience,
            tenantId: cloudId,
            isJiraIssueIndexed: isJiraIssueIndexed,
            thirdPartyFilters: args.thirdPartyFilters
        });
    }, [
        experimentConfig,
        productEdition,
        cloudId,
        productDataRegions,
        experience,
        isJiraIssueIndexed,
        args.entities,
        args.thirdPartyFilters,
        isHello
    ]);
};
const $af0491d427fc090c$export$ce2438226fe8a866 = ()=>{
    const { onSearchCompleted: onSearchCompleted } = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    return onSearchCompleted;
};
const $af0491d427fc090c$export$de591553328a258f = ()=>{
    const { onOAuthSuccess: onOAuthSuccess } = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    return onOAuthSuccess;
};
/**
 * Retrieve BootstrapVariables (with applied callback) from context.
 * Merges static and dynamic context, then applies the callback transformation.
 */ const $af0491d427fc090c$var$_useBootstrapStateContextWithSelector = (cb)=>{
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    const store = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext));
    // Select each field individually so Object.is comparison works on primitives/stable refs.
    // This ensures we only re-render when a field useQueryPlan reads actually changes.
    const cloudId = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.cloudId);
    const primaryProduct = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.primaryProduct);
    const primarySubProduct = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.primarySubProduct);
    // Under `rovo_fps_use_rovo_config`, `thirdPartyConfigs` is routed through
    // dynamic context (see `BootstrapContextProvider`). Pick the appropriate
    // source so that downstream consumers (e.g. useQueryPlan, analytics) see
    // post-OAuth reference changes without depending on the static-lock hack.
    const thirdPartyConfigsFromStatic = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.thirdPartyConfigs);
    const thirdPartyConfigs = (0, $kh8w1.isRovoFPSUseRovoConfigEnabled)() ? dynamicContext?.thirdPartyConfigs ?? $af0491d427fc090c$var$defaultStaticContextThirdPartyConfigs : thirdPartyConfigsFromStatic;
    const experimentConfig = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.experimentConfig);
    const experimentLayers = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.experimentLayers);
    const products = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.products);
    const allFilterExcludedProducts = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.allFilterExcludedProducts);
    const productEdition = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.productEdition);
    const productDataRegions = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.productDataRegions);
    const isJiraIssueIndexed = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.isJiraIssueIndexed);
    const isRovoEnabled = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.isRovoEnabled);
    const user = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.user);
    const nouns = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.nouns);
    const overrides = (0, $yW9ML.useStaticBootstrapSelector)(store, (s)=>s.overrides);
    const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    (0, $cXtTj.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
    const context = (0, $cozmU.useMemo)(()=>{
        return cb({
            cloudId: cloudId,
            primaryProduct: primaryProduct,
            primarySubProduct: primarySubProduct,
            thirdPartyConfigs: thirdPartyConfigs,
            searchSessionId: dynamicContext?.searchSessionId,
            experimentConfig: experimentConfig,
            experimentLayers: experimentLayers,
            products: products,
            allFilterExcludedProducts: allFilterExcludedProducts,
            productEdition: productEdition,
            productDataRegions: productDataRegions,
            isJiraIssueIndexed: isJiraIssueIndexed,
            isRovoEnabled: isRovoEnabled,
            user: user,
            nouns: nouns,
            referrer: dynamicContext?.referrer,
            ...enableRovoSearchOverrides && {
                overrides: overrides
            }
        });
    }, [
        cloudId,
        primaryProduct,
        primarySubProduct,
        thirdPartyConfigs,
        experimentConfig,
        experimentLayers,
        products,
        allFilterExcludedProducts,
        productEdition,
        productDataRegions,
        isJiraIssueIndexed,
        isRovoEnabled,
        user,
        nouns,
        overrides,
        enableRovoSearchOverrides,
        dynamicContext?.searchSessionId,
        dynamicContext?.referrer,
        cb
    ]);
    return context;
};
const $af0491d427fc090c$export$f58a6d0fc9e4868e = $af0491d427fc090c$var$_useBootstrapStateContextWithSelector;
const $af0491d427fc090c$export$38c566c0640fb69a = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.features);
const $af0491d427fc090c$export$4fcccae6c9e96003 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.cloudId);
const $af0491d427fc090c$export$76d8dfaa701293d9 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.orgId);
const $af0491d427fc090c$export$742cda9929e8b50c = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.primaryProduct);
const $af0491d427fc090c$export$e0c045bdef566c47 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.primarySubProduct);
const $af0491d427fc090c$export$8bff48fd870f30 = ()=>{
    return []; // no longer used, remove when cleaning up fg rovo-search-remove-rss-bootstrap-fg
};
const $af0491d427fc090c$export$87c54b525b914dab = ()=>(0, $cn81K.getUser)((0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.user));
const $af0491d427fc090c$export$c7a275b1a627c5f0 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.SAINHostName);
const $af0491d427fc090c$export$6f099dbd230ba66f = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.hasEditOrViewPlanPermission ?? false);
const $af0491d427fc090c$export$9df89e94884205e9 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.isRovoEnabled ?? false);
const $af0491d427fc090c$export$803daaa2f0fbbc6e = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.experimentLayers ?? []);
const $af0491d427fc090c$export$eac498b27b856e7c = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.user?.id);
const $af0491d427fc090c$export$b69f9d68446c9dad = ()=>{
    const staticContext = (0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapContext));
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    const { products: products, primaryProduct: primaryProduct, isRovoEnabled: isRovoEnabled } = staticContext;
    const { product: currentSelectedProduct, cql: currentCql } = dynamicContext.queryParams;
    const applicationMode = (0, $ljBeq.getApplicationMode)({
        isRovoEnabled: isRovoEnabled
    });
    const primaryProductToSelect = (0, $9ekgQ.productKeySchema).safeParse(primaryProduct);
    const shouldAutoSelectPrimaryProduct = !currentSelectedProduct && !currentCql && products && products.length > 0 && applicationMode === (0, $2O9Q9.ApplicationModes).Unified && primaryProductToSelect.success && primaryProductToSelect.data !== (0, $dvVWp.ProductKeys).Atlas;
    if (shouldAutoSelectPrimaryProduct) return primaryProductToSelect.data;
    else return null;
};
const $af0491d427fc090c$export$e3421d27ae244aa = ()=>{
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    return dynamicContext.queryParams?.type === (0, $7ydfN.TypeFilterValueKey).Incident;
};
const $af0491d427fc090c$export$25662b49e6b8f72d = ()=>{
    const dynamicContext = (0, $cozmU.useContext)((0, $ktiKH.DynamicBootstrapContext));
    return dynamicContext.queryParams;
};
const $af0491d427fc090c$export$7061561fd19f7ef1 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.aggregatorHostName);
const $af0491d427fc090c$export$5ff79b6adc9830a0 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.aggAbsoluteUrl);
const $af0491d427fc090c$export$bc37b6cf798ce4a = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.allFilterExcludedProducts);
const $af0491d427fc090c$export$b3275ad39f44e473 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.productDataRegions);
const $af0491d427fc090c$export$7b21d1d3f4e52ac8 = ()=>(0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.isJiraIssueIndexed);














const $6a9abda6e217f991$export$ae43642c556804c9 = (queryParams)=>{
    const hostProductSetQueryParamsCallback = (0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.queryParamsCallback);
    const setQueryParamsCallback = (0, $cozmU.useCallback)((newParams)=>{
        const areEqualQueryParams = (0, $biQM6.areAllEqualQueryParams)(newParams, queryParams ?? {});
        if (areEqualQueryParams) return;
        const rawQueryParams = (0, $biQM6.toQueryParamsRaw)(newParams);
        hostProductSetQueryParamsCallback(rawQueryParams);
    }, [
        queryParams,
        hostProductSetQueryParamsCallback
    ]);
    return setQueryParamsCallback;
};
const $6a9abda6e217f991$export$8eb026c9237da68b = ()=>{
    const refreshSearchSessionId = (0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.refreshSearchSessionId);
    return refreshSearchSessionId;
};
const $6a9abda6e217f991$export$6372fdd1070e00df = ()=>{
    const clearReferrer = (0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.clearReferrer);
    return clearReferrer;
};
const $6a9abda6e217f991$export$b2cdbc1165101e18 = ()=>{
    const setThirdPartyConfigs = (0, $yW9ML.useStaticBootstrapSelector)((0, $cozmU.useContext)((0, $ktiKH.StaticBootstrapStoreContext)), (ctx)=>ctx.setThirdPartyConfigs);
    return setThirdPartyConfigs;
};



var $4BJ6s = parcelRequire("4BJ6s");

const $b56164202d52b555$export$e324594224ef24da = {
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const setThirdPartyConfigs = useSetThirdPartyConfigs()`
   */ setThirdPartyConfigs: (configs)=>({ setState: setState })=>{
            setState({
                thirdPartyConfigs: configs
            });
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const setQueryParams = useSetQueryParams()`
   */ setQueryParams: (queryParam)=>({}, { queryParams: queryParams, queryParamsCallback: queryParamsCallback = ()=>{} })=>{
            const areEqualQueryParams = (0, $biQM6.areAllEqualQueryParams)(queryParam, (0, $biQM6.parseQueryParams)(queryParams ?? {}));
            if (areEqualQueryParams) return;
            queryParamsCallback((0, $biQM6.toQueryParamsRaw)(queryParam));
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   *
   * You should not ever need to call this directly. Open a thread in #help-search-plex and tag @rwasher, @sogrady, @jquach, if you find you need to!
   */ syncQueryParams: ()=>({ setState: setState, getState: getState }, { queryParams: queryParams, queryParamsCallback: queryParamsCallback = ()=>{} })=>{
            // queryParams is the query params coming from the URL or React Router in this case
            const { prevQueryParams: prevQueryParams, // Previously saved query params - this is to prevent infinitely updating queryParams
            queryParams: diffQueryParamsState // The 'internal' query params state
             } = getState();
            const queryParamsURL = (0, $biQM6.parseQueryParams)(queryParams ?? {});
            const prevQueryParamsString = (0, $biQM6.toQueryString)(prevQueryParams);
            const diffQueryParamsURLString = (0, $biQM6.toQueryString)(queryParamsURL);
            const diffQueryParamsStateString = (0, $biQM6.toQueryString)(diffQueryParamsState);
            const allQueryParamsAreEqual = (0, $biQM6.areAllEqualQueryParams)(queryParamsURL, prevQueryParams, diffQueryParamsState);
            if (allQueryParamsAreEqual) return;
            // Any changes from the url takes the highest precedence
            const hasURLQueryParams = !!queryParams;
            if (hasURLQueryParams && prevQueryParamsString !== diffQueryParamsURLString) {
                setState({
                    prevQueryParams: queryParamsURL,
                    queryParams: queryParamsURL
                });
                return;
            }
            if (prevQueryParamsString !== diffQueryParamsStateString) {
                //  NOTE: If you are running the callback and you don't see the query params being updated,
                //  the callback might be sanitising the query parameters. This is the case for Confluence.
                queryParamsCallback((0, $biQM6.toQueryParamsRaw)(diffQueryParamsState));
                setState({
                    prevQueryParams: diffQueryParamsState,
                    queryParams: diffQueryParamsState
                });
                return;
            }
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const refreshSearchSessionId = useRefreshSearchSessionId()`
   */ refreshSearchSessionId: ()=>({ setState: setState })=>{
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            setState({
                searchSessionId: (0, $03RpJ.default)()
            });
        },
    /**
   * @deprecated
   * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
   * Instead use `const clearReferrer = useClearReferrer()`
   */ clearReferrer: ()=>({ setState: setState })=>{
            setState({
                referrer: undefined
            });
        }
};
const $b56164202d52b555$var$buildProducts = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((a, b)=>{
    return [
        ...new Set([
            ...a,
            ...b
        ])
    ];
}, (a, b)=>a.join('') + b.join(''));
// Keep store private and use hooks to access state and actions
const $b56164202d52b555$var$Store = (0, $8s9DV.createStore)({
    initialState: $jXCr4.initialState,
    actions: $b56164202d52b555$export$e324594224ef24da,
    name: 'bootstrap'
});
const $b56164202d52b555$export$543309f9b943a423 = {
    onInit: ()=>({ getState: getState, setState: setState }, { initialProps: initialProps, onSearchCompleted: onSearchCompleted, onOAuthSuccess: onOAuthSuccess, queryParams: queryParams })=>{
            const parsedQueryParams = queryParams && (0, $biQM6.parseQueryParams)(queryParams);
            setState({
                ...getState(),
                ...initialProps,
                ...queryParams && {
                    queryParams: parsedQueryParams
                },
                referrer: parsedQueryParams?.referrer,
                initialTextQueryParam: parsedQueryParams?.text,
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                searchSessionId: initialProps.searchSessionId || (0, $03RpJ.default)(),
                onSearchCompleted: onSearchCompleted,
                onOAuthSuccess: onOAuthSuccess
            });
        },
    onUpdate: ()=>({ setState: setState, getState: getState, dispatch: dispatch }, { initialProps: initialProps, onSearchCompleted: onSearchCompleted, onOAuthSuccess: onOAuthSuccess, queryParams: queryParams })=>{
            const parsedQueryParams = queryParams && (0, $biQM6.parseQueryParams)(queryParams);
            const currentState = getState();
            const products = $b56164202d52b555$var$buildProducts(currentState.products, initialProps?.products ?? []);
            // Merge thirdPartyConfigs so that OAuth-updated entries (set via
            // setThirdPartyConfigs with userNeedsOAuth: false) are not
            // overwritten by the stale consumer-provided value on re-renders,
            // while still picking up new/updated entries from the host app.
            //
            // IMPORTANT: We only create a new object when an actual override is
            // needed. If nothing changed, we preserve the incoming reference to
            // avoid unnecessary re-renders in RSS store subscribers (e.g.
            // useFetchResultsProps depends on thirdPartyConfigs by reference).
            const incomingThirdPartyConfigs = initialProps?.thirdPartyConfigs;
            const currentThirdPartyConfigs = currentState.thirdPartyConfigs;
            let mergedThirdPartyConfigs = incomingThirdPartyConfigs;
            if (incomingThirdPartyConfigs && currentThirdPartyConfigs) {
                // Check whether any entries need to be preserved from the current store
                let hasOverrides = false;
                for (const key of Object.keys(currentThirdPartyConfigs)){
                    const currentEntry = currentThirdPartyConfigs[key];
                    const incomingEntry = incomingThirdPartyConfigs[key];
                    if (currentEntry && incomingEntry && currentEntry.userNeedsOAuth === false && incomingEntry.userNeedsOAuth === true) {
                        hasOverrides = true;
                        break;
                    }
                }
                // Only create a new object if we actually need to override something
                if (hasOverrides) {
                    mergedThirdPartyConfigs = {
                        ...incomingThirdPartyConfigs
                    };
                    for (const key of Object.keys(currentThirdPartyConfigs)){
                        const currentEntry = currentThirdPartyConfigs[key];
                        const incomingEntry = mergedThirdPartyConfigs[key];
                        if (currentEntry && incomingEntry && currentEntry.userNeedsOAuth === false && incomingEntry.userNeedsOAuth === true) mergedThirdPartyConfigs[key] = currentEntry;
                    }
                }
            }
            setState({
                ...currentState,
                ...initialProps,
                ...mergedThirdPartyConfigs !== undefined && {
                    thirdPartyConfigs: mergedThirdPartyConfigs
                },
                onSearchCompleted: onSearchCompleted,
                onOAuthSuccess: onOAuthSuccess,
                products: products,
                referrer: parsedQueryParams?.referrer
            });
            dispatch($b56164202d52b555$export$e324594224ef24da.syncQueryParams());
        }
};
const $b56164202d52b555$export$557bf45c8d0f5bd = (0, $j8on0.createContainer)($b56164202d52b555$var$Store, $b56164202d52b555$export$543309f9b943a423);
const $b56164202d52b555$export$cf715ed8590c209b = (0, $kBr4q.createActionsHook)($b56164202d52b555$var$Store);
/**
 * @deprecated
 * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
 * This is being actively migrated away from in QS-9194
 *
 * Instead use specific per-value accessors from this file, including for actions if they are present
 *
 * e.g. const [{ useCloudId, useQueryParams }, { useSetQueryParams }] = useBootstrap()
 * -> const [cloudId] = useCloudId();
 * -> const [queryParams] = useQueryParams();
 * -> const setQueryParams = useSetQueryParams();
 */ const $b56164202d52b555$var$useBootstrapStore = (0, $kBr4q.createHook)($b56164202d52b555$var$Store);
const $b56164202d52b555$export$9ba1f1f28043c5bf = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $af0491d427fc090c$export$a607044ff61ed35a)() : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$var$useBootstrapStore()[0]
    ];
};
const $b56164202d52b555$export$9ec3accb60f929bc = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $b56164202d52b555$export$610b442bd2bdbce2 = (cb)=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$f58a6d0fc9e4868e)(cb) : $b56164202d52b555$export$9ec3accb60f929bc(cb);
};
const $b56164202d52b555$export$9d56bc2341757114 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.analyticsAttributes
});
const $b56164202d52b555$export$1fd8522aeddaccda = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$da4da5285a2fd344)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$9d56bc2341757114()[0]
    ];
};
const $b56164202d52b555$export$7ea98f64fcaf4bba = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.products
});
const $b56164202d52b555$export$5afbfe6edea8e998 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$aa1a270414bf62e1)() : $b56164202d52b555$export$7ea98f64fcaf4bba();
};
const $b56164202d52b555$export$eac7f1ebb1342f3d = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.nouns
});
const $b56164202d52b555$export$6019aa9111ebc3a2 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$5abfe064a9321e1)() : $b56164202d52b555$export$eac7f1ebb1342f3d();
};
const $b56164202d52b555$export$5668414148ce6645 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.products && state.products.length > 0
});
const $b56164202d52b555$export$9e9836415b9aa240 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$b79f482a36aed45)() : $b56164202d52b555$export$5668414148ce6645();
};
const $b56164202d52b555$export$38f7f3dced53e226 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.products.length === 0
});
const $b56164202d52b555$export$f7c6299b3492081c = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        !(0, $af0491d427fc090c$export$b79f482a36aed45)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$38f7f3dced53e226()[0]
    ];
};
const $b56164202d52b555$export$740fb20e7075dfd2 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.primaryProduct
});
const $b56164202d52b555$export$92c6f3c7c09f3247 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$742cda9929e8b50c)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$740fb20e7075dfd2()[0]
    ];
};
/**
 * @deprecated
 * Do not import directly! https://hello.atlassian.net/wiki/x/bKRdZAE
 * Instead use usePrimarySubProduct in bootstrap/index.tsx
 */ const $b56164202d52b555$var$usePrimarySubProductStore = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.primarySubProduct
});
const $b56164202d52b555$export$baffb23dea1bbe6d = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$e0c045bdef566c47)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$var$usePrimarySubProductStore()
    ];
};
const $b56164202d52b555$export$85911a18814719bc = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.searchSessionId
});
const $b56164202d52b555$export$e1e7a4797df1a656 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$c3427a530f474eaf)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$85911a18814719bc()[0]
    ];
};
const $b56164202d52b555$export$ecbe89dec8c82f9a = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>(0, $03qcI.isHello)(state.cloudId)
});
const $b56164202d52b555$export$1a0be923fb1117e4 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$a20db2e6915ac3c5)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$ecbe89dec8c82f9a()[0]
    ];
};
const $b56164202d52b555$export$ecc663167952d044 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.features
});
const $b56164202d52b555$export$4a39035bacc4ed76 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$38c566c0640fb69a)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$ecc663167952d044()[0]
    ];
};
const $b56164202d52b555$export$766d82ac8f8b178e = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state, args)=>{
        return (0, $5msm2.getBackendExperiment)({
            experimentConfig: state.experimentConfig,
            entities: args.entities,
            productEdition: state.productEdition,
            isHello: (0, $03qcI.isHello)(state.cloudId),
            productDataRegions: state.productDataRegions,
            experience: (0, $imdMF.SEARCH_PAGE),
            tenantId: state.cloudId,
            isJiraIssueIndexed: state.isJiraIssueIndexed,
            thirdPartyFilters: args.thirdPartyFilters
        });
    }
});
const $b56164202d52b555$export$9e89c81d9ff2c758 = (args)=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$284401669662f77b)(args)
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$766d82ac8f8b178e(args)[0]
    ];
};
const $b56164202d52b555$export$76b3461be06c4ce4 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.experimentConfig.frontendExperiments
});
const $b56164202d52b555$export$d2c28b106f1bf70b = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$c8d3ac176f5c521c)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$76b3461be06c4ce4()[0]
    ];
};
const $b56164202d52b555$export$3e826cc2f34e3f9f = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.smartLinkUsage
});
const $b56164202d52b555$export$5016cfcf87c60291 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.unitMetadata
});
const $b56164202d52b555$export$61c62393cc326189 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$f1c90440d6c09079)() : $b56164202d52b555$export$3e826cc2f34e3f9f();
};
const $b56164202d52b555$export$89824387636c5038 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>(0, $cJff5.getMultiSiteSearchInRovo)(state.experimentConfig)
});
const $b56164202d52b555$export$1e668811222ead9b = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$414e9503f60ee463)() : $b56164202d52b555$export$89824387636c5038();
};
const $b56164202d52b555$export$5ecdff6d23ea5c41 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.user?.id
});
const $b56164202d52b555$export$761b9f1acd811a4 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$eac498b27b856e7c)() : $b56164202d52b555$export$5ecdff6d23ea5c41();
};
const $b56164202d52b555$export$7bafc36c74b1b9af = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.experimentConfig
});
const $b56164202d52b555$export$b9e6179ff71a6122 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$db066d8e499b7f58)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$7bafc36c74b1b9af()[0]
    ];
};
/**
 * @deprecated
 * https://hello.atlassian.net/wiki/x/bKRdZAE
 */ const $b56164202d52b555$var$useApplicationModeStore = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.isRovoEnabled
    ], (isRovoEnabled)=>(0, $ljBeq.getApplicationMode)({
            isRovoEnabled: isRovoEnabled
        }))
});
const $b56164202d52b555$export$150d84149ef86e81 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$3129106711858d9e)() : $b56164202d52b555$var$useApplicationModeStore();
};
const $b56164202d52b555$export$ac142617c8f07aa9 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? [
        (0, $af0491d427fc090c$export$8d72fbb40ea96b11)()
    ] : [
        $b56164202d52b555$export$6fa68bea98f6275f()[0]
    ];
};
const $b56164202d52b555$export$37b5bbb85d4e84cc = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$7a947e70298b5de6)() : $b56164202d52b555$export$5016cfcf87c60291();
};
const $b56164202d52b555$export$84529f276bb721c4 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$42159b7c323c1456)() : $b56164202d52b555$export$5b08efe445210431();
};
const $b56164202d52b555$export$e99d08753f6dce85 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? [
        (0, $af0491d427fc090c$export$8b362261a7637697)()
    ] : [
        $b56164202d52b555$export$956b416c80bdc23b()[0]
    ];
};
const $b56164202d52b555$export$cc885caaa8b7ab4e = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>{
        const user = state.user;
        return (0, $cn81K.getUser)(user);
    }
});
const $b56164202d52b555$export$23bbbc4533528f03 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$87c54b525b914dab)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$cc885caaa8b7ab4e()[0]
    ];
};
const $b56164202d52b555$export$956b416c80bdc23b = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.referrer
});
const $b56164202d52b555$export$5b08efe445210431 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.initialTextQueryParam
});
const $b56164202d52b555$export$aef5773142a94889 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.orgId
});
const $b56164202d52b555$export$52a03a3207af3687 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$76d8dfaa701293d9)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$aef5773142a94889()[0]
    ];
};
const $b56164202d52b555$export$d875bd9731f2aec2 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.cloudId
    ], (cloudId)=>cloudId)
});
const $b56164202d52b555$export$9da0f7c65f28ed16 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$4fcccae6c9e96003)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$d875bd9731f2aec2()[0]
    ];
};
const $b56164202d52b555$export$6fa68bea98f6275f = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.linkedCloudARIs
});
const $b56164202d52b555$export$4e035a5c2351d2e5 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.products,
        (state)=>state.primaryProduct,
        (state)=>state.isRovoEnabled,
        (state)=>state.queryParams.product,
        (state)=>state.queryParams.cql
    ], (products, primaryProduct, isRovoEnabled, currentSelectedProduct, currentCql)=>{
        const applicationMode = (0, $ljBeq.getApplicationMode)({
            isRovoEnabled: isRovoEnabled
        });
        const primaryProductToSelect = (0, $9ekgQ.productKeySchema).safeParse(primaryProduct);
        const shouldAutoSelectPrimaryProduct = !currentSelectedProduct && !currentCql && products && products.length > 0 && applicationMode === (0, $2O9Q9.ApplicationModes).Unified && primaryProductToSelect.success && primaryProductToSelect.data !== (0, $dvVWp.ProductKeys).Atlas;
        if (shouldAutoSelectPrimaryProduct) return primaryProductToSelect.data;
        else return null;
    })
});
const $b56164202d52b555$export$c7f4a8f2f4902c5b = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$b69f9d68446c9dad)() : $b56164202d52b555$export$4e035a5c2351d2e5();
};
const $b56164202d52b555$export$cfec170a04b8b09e = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.isConfigLoaded
    ], (isConfigLoaded)=>isConfigLoaded)
});
const $b56164202d52b555$export$dfc6af34d0b0a7e1 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$4c06a80ce19ae7c8)() : $b56164202d52b555$export$cfec170a04b8b09e();
};
const $b56164202d52b555$export$826527619b7a782d = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>!!state.rovoFeatures?.scas
});
const $b56164202d52b555$export$27738d748ac05943 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$b238e8fc41384c76)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$826527619b7a782d()[0]
    ];
};
const $b56164202d52b555$export$479cadf76e337ced = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.productEdition
});
const $b56164202d52b555$export$83e4de12d3240f53 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$682b612810461522)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$479cadf76e337ced()[0]
    ];
};
const $b56164202d52b555$export$7c7bef429afbfd0f = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.queryParams?.type === (0, $7ydfN.TypeFilterValueKey).Incident
});
const $b56164202d52b555$export$98a75a8d27d2d106 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? (0, $af0491d427fc090c$export$e3421d27ae244aa)() : $b56164202d52b555$export$7c7bef429afbfd0f();
};
const $b56164202d52b555$export$d37ccf8bdc15c61 = (0, $kBr4q.createHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.thirdPartyConfigs
});
const $b56164202d52b555$export$a66178d9c618d6dc = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$e2860ebe87e62f0d)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$d37ccf8bdc15c61()[0]
    ];
};
const $b56164202d52b555$export$4470b3b80d2a1efd = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: ()=>true
});
const $b56164202d52b555$export$12942aa91b162c95 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $af0491d427fc090c$export$f84f93bb6857e6bf)() : // eslint-disable-next-line react-hooks/rules-of-hooks
    $b56164202d52b555$export$4470b3b80d2a1efd();
};
const $b56164202d52b555$export$fa705064035366ce = (queryParams)=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    const { setQueryParams: setQueryParamsStore } = $b56164202d52b555$export$cf715ed8590c209b();
    const setQueryParamsContext = (0, $6a9abda6e217f991$export$ae43642c556804c9)(queryParams);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    setQueryParamsContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    setQueryParamsStore;
};
const $b56164202d52b555$export$3b183e08127f60ee = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    const { refreshSearchSessionId: refreshSearchSessionIdStore } = $b56164202d52b555$export$cf715ed8590c209b();
    const refreshSearchSessionIdContext = (0, $6a9abda6e217f991$export$8eb026c9237da68b)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    refreshSearchSessionIdContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    refreshSearchSessionIdStore;
};
const $b56164202d52b555$export$c6dd687c49bf782b = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    const { clearReferrer: clearReferrerStore } = $b56164202d52b555$export$cf715ed8590c209b();
    const clearReferrerContext = (0, $6a9abda6e217f991$export$6372fdd1070e00df)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    clearReferrerContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    clearReferrerStore;
};
const $b56164202d52b555$export$556790c5329d7a06 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    const { setThirdPartyConfigs: setThirdPartyConfigsStore } = $b56164202d52b555$export$cf715ed8590c209b();
    const setThirdPartyConfigsContext = (0, $6a9abda6e217f991$export$b2cdbc1165101e18)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    setThirdPartyConfigsContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    setThirdPartyConfigsStore;
};
const $b56164202d52b555$export$9145e6ed5e8754d7 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.onSearchCompleted
});
const $b56164202d52b555$export$b9665757e0cd2a7 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    const onSearchCompletedStore = $b56164202d52b555$export$9145e6ed5e8754d7();
    const onSearchCompletedContext = (0, $af0491d427fc090c$export$ce2438226fe8a866)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    onSearchCompletedContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    onSearchCompletedStore ?? (()=>{});
};
const $b56164202d52b555$export$8dbc380ce96047bb = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.onOAuthSuccess
});
const $b56164202d52b555$export$d5e98fc55a6be8ab = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    const onOAuthSuccessStore = $b56164202d52b555$export$8dbc380ce96047bb();
    const onOAuthSuccessContext = (0, $af0491d427fc090c$export$de591553328a258f)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    onOAuthSuccessContext : // eslint-disable-next-line react-hooks/rules-of-hooks
    onOAuthSuccessStore;
};
const $b56164202d52b555$export$94c4fbf6686bd545 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.queryParams
});
const $b56164202d52b555$export$b37ee0d76c6d2fbc = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$25662b49e6b8f72d)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$94c4fbf6686bd545()
    ];
};
const $b56164202d52b555$export$6a2137557a0d64b6 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.aggregatorHostName
});
const $b56164202d52b555$export$ee782f3c04c9ae8b = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$7061561fd19f7ef1)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$6a2137557a0d64b6()
    ];
};
const $b56164202d52b555$export$c9561269f12847d9 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.aggAbsoluteUrl
});
const $b56164202d52b555$export$c61c0a9ee44eb20d = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$5ff79b6adc9830a0)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$c9561269f12847d9()
    ];
};
const $b56164202d52b555$export$a622d298cd701527 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.allFilterExcludedProducts
});
const $b56164202d52b555$export$5f38673942a99ffe = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$bc37b6cf798ce4a)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$a622d298cd701527()
    ];
};
const $b56164202d52b555$export$46b088d1cfd71b45 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.productDataRegions
});
const $b56164202d52b555$export$7b2a84178d2593d6 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$b3275ad39f44e473)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$46b088d1cfd71b45()
    ];
};
const $b56164202d52b555$export$34ca8c3e8a50a02f = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.isJiraIssueIndexed
});
const $b56164202d52b555$export$fbf3e851fc33b7ac = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$7b21d1d3f4e52ac8)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$34ca8c3e8a50a02f()
    ];
};
const $b56164202d52b555$export$81f625b5a645837d = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.initialSpaceARIs
});
const $b56164202d52b555$export$dbfb675a6b71c171 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$8bff48fd870f30)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$81f625b5a645837d()
    ];
};
const $b56164202d52b555$export$9f206c50663dec0 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.SAINHostName
});
const $b56164202d52b555$export$3a6ef70862d81412 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$c7a275b1a627c5f0)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$9f206c50663dec0()
    ];
};
const $b56164202d52b555$export$9f9ac629bd95fe42 = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.hasEditOrViewPlanPermission
});
const $b56164202d52b555$export$ef5d8e24d9af554f = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$6f099dbd230ba66f)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$export$9f9ac629bd95fe42() ?? false
    ];
};
const $b56164202d52b555$var$useIsRovoEnabledStore = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.isRovoEnabled
});
const $b56164202d52b555$export$1deffd91058f2ec4 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$9df89e94884205e9)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$var$useIsRovoEnabledStore()
    ];
};
const $b56164202d52b555$var$useExperimentLayersStore = (0, $kBr4q.createStateHook)($b56164202d52b555$var$Store, {
    selector: (state)=>state.experimentLayers
});
const $b56164202d52b555$export$e157d3c129f2f296 = ()=>{
    const serveContext = (0, $4BJ6s.serveBootstrapProviderExp)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return serveContext ? // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        (0, $af0491d427fc090c$export$803daaa2f0fbbc6e)()
    ] : // eslint-disable-next-line react-hooks/rules-of-hooks
    [
        $b56164202d52b555$var$useExperimentLayersStore()
    ];
};
module.exports["BootstrapStoreContainer"] = $b56164202d52b555$export$557bf45c8d0f5bd;
module.exports["useBootstrap"] = $b56164202d52b555$export$9ba1f1f28043c5bf;
module.exports["useBootstrapState"] = $b56164202d52b555$export$610b442bd2bdbce2;
module.exports["useAnalyticsAttributes"] = $b56164202d52b555$export$1fd8522aeddaccda;
module.exports["useAvailableProducts"] = $b56164202d52b555$export$5afbfe6edea8e998;
module.exports["useAvailableNouns"] = $b56164202d52b555$export$6019aa9111ebc3a2;
module.exports["useBootstrapLoading"] = $b56164202d52b555$export$f7c6299b3492081c;
module.exports["usePrimaryProduct"] = $b56164202d52b555$export$92c6f3c7c09f3247;
module.exports["usePrimarySubProduct"] = $b56164202d52b555$export$baffb23dea1bbe6d;
module.exports["useSearchSessionId"] = $b56164202d52b555$export$e1e7a4797df1a656;
module.exports["useIsHello"] = $b56164202d52b555$export$1a0be923fb1117e4;
module.exports["useFeatures"] = $b56164202d52b555$export$4a39035bacc4ed76;
module.exports["useSmartLinkUsage"] = $b56164202d52b555$export$61c62393cc326189;
module.exports["useCurrentUserId"] = $b56164202d52b555$export$761b9f1acd811a4;
module.exports["useExperimentConfig"] = $b56164202d52b555$export$b9e6179ff71a6122;
module.exports["useApplicationMode"] = $b56164202d52b555$export$150d84149ef86e81;
module.exports["useUnitMetadata"] = $b56164202d52b555$export$37b5bbb85d4e84cc;
module.exports["useReferrer"] = $b56164202d52b555$export$e99d08753f6dce85;
module.exports["useUser"] = $b56164202d52b555$export$23bbbc4533528f03;
module.exports["useOrgId"] = $b56164202d52b555$export$52a03a3207af3687;
module.exports["useCloudId"] = $b56164202d52b555$export$9da0f7c65f28ed16;
module.exports["useAutoSelectPrimaryProduct"] = $b56164202d52b555$export$c7f4a8f2f4902c5b;
module.exports["useIsConfigLoaded"] = $b56164202d52b555$export$dfc6af34d0b0a7e1;
module.exports["useProductEdition"] = $b56164202d52b555$export$83e4de12d3240f53;
module.exports["useIsTypeFilteredToIncident"] = $b56164202d52b555$export$98a75a8d27d2d106;
module.exports["useThirdPartyConfigs"] = $b56164202d52b555$export$a66178d9c618d6dc;
module.exports["useFiltersDiscoverability2Enabled"] = $b56164202d52b555$export$12942aa91b162c95;
module.exports["useSetQueryParams"] = $b56164202d52b555$export$fa705064035366ce;
module.exports["useRefreshSearchSessionId"] = $b56164202d52b555$export$3b183e08127f60ee;
module.exports["useClearReferrer"] = $b56164202d52b555$export$c6dd687c49bf782b;
module.exports["useSetThirdPartyConfigs"] = $b56164202d52b555$export$556790c5329d7a06;
module.exports["useOnSearchCompleted"] = $b56164202d52b555$export$b9665757e0cd2a7;
module.exports["useOnOAuthSuccess"] = $b56164202d52b555$export$d5e98fc55a6be8ab;
module.exports["useQueryParams"] = $b56164202d52b555$export$b37ee0d76c6d2fbc;
module.exports["useAggAbsoluteUrl"] = $b56164202d52b555$export$c61c0a9ee44eb20d;
module.exports["useAllFilterExcludedProducts"] = $b56164202d52b555$export$5f38673942a99ffe;
module.exports["useProductDataRegions"] = $b56164202d52b555$export$7b2a84178d2593d6;
module.exports["useIsJiraIssueIndexed"] = $b56164202d52b555$export$fbf3e851fc33b7ac;
module.exports["useInitialSpaceARIs"] = $b56164202d52b555$export$dbfb675a6b71c171;
module.exports["useExperimentLayers"] = $b56164202d52b555$export$e157d3c129f2f296;

});

parcelRegister("2O9Q9", function(module, exports) {
const $9fae4aa188a3fc73$export$f1263520d5e0f007 = {
    Unified: 'unified',
    Rovo: 'rovo'
};
module.exports["ApplicationModes"] = $9fae4aa188a3fc73$export$f1263520d5e0f007;

});

parcelRegister("jXCr4", function(module, exports) {
const $2fb9df04a7909139$export$d4c72bab9d6cc13a = {
    products: [],
    nouns: [],
    allFilterExcludedProducts: [],
    thirdPartyConfigs: {},
    searchSessionId: '',
    queryParams: {},
    prevQueryParams: {},
    overrides: undefined,
    initialSpaceARIs: [],
    experimentConfig: {
        backendExperiment: undefined,
        frontendExperiments: undefined,
        dynamicExperiments: undefined
    },
    experimentLayers: [],
    isRovoEnabled: false,
    isConfigLoaded: false,
    rovoFeatures: {},
    isJiraIssueIndexed: false,
    productEdition: undefined,
    productDataRegions: undefined,
    linkedCloudARIs: undefined,
    unitMetadata: undefined,
    analyticsAttributes: undefined,
    aggAbsoluteUrl: undefined,
    cloudId: undefined,
    aggregatorHostName: undefined,
    SAINHostName: undefined,
    user: undefined,
    primaryProduct: undefined,
    primarySubProduct: undefined,
    orgId: undefined,
    referrer: undefined,
    initialTextQueryParam: undefined,
    features: undefined,
    hasEditOrViewPlanPermission: false,
    onSearchCompleted: undefined,
    onOAuthSuccess: undefined,
    smartLinkUsage: undefined
};
module.exports["initialState"] = $2fb9df04a7909139$export$d4c72bab9d6cc13a;

});

parcelRegister("imdMF", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $cf748a175c344ccf$export$944168d706dc6466 = 'search-page';
module.exports["SEARCH_PAGE"] = $cf748a175c344ccf$export$944168d706dc6466;

});

parcelRegister("7ydfN", function(module, exports) {
const $d0b41f69660db9c4$export$49f6cbb853d30562 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    Repository: 'repository',
    PullRequest: 'pull-request',
    Branch: 'branch',
    Commit: 'commit',
    DevopsWorkItem: 'devops-work-item',
    WebPage: 'web-page',
    Conversation: 'conversation',
    Message: 'message',
    Video: 'video',
    Design: 'design',
    Page: 'page',
    Blogpost: 'blogpost',
    Attachment: 'attachment',
    Space: 'space',
    Whiteboard: 'whiteboard',
    Slide: 'slide',
    Comment: 'comment',
    Database: 'database',
    Embed: 'embed',
    Folder: 'folder',
    Calendar: 'calendar',
    SpaceCalendar: 'space-calendar',
    Question: 'question',
    Answer: 'answer',
    Issue: 'issue',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask',
    Project: 'project',
    Incident: 'incident',
    Filter: 'filter',
    Plan: 'plan',
    Board: 'board',
    Component: 'component',
    Card: 'card',
    Goal: 'goal',
    Tag: 'tag',
    WorkItem: 'work-item',
    FocusArea: 'focus-area',
    Organization: 'organization',
    Ask: 'ask',
    Risk: 'risk',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal',
    Gliffy: 'gliffy',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Type: 'type',
    Schema: 'schema',
    Position: 'position',
    Image: 'image',
    Audio: 'audio',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Code: 'code',
    Archive: 'archive',
    Other: 'other',
    Notebook: 'notebook',
    Form: 'form',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Campaign: 'campaign',
    Case: 'case',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article',
    Lead: 'lead'
};
const $d0b41f69660db9c4$export$e01073b80ff953d5 = Object.values($d0b41f69660db9c4$export$49f6cbb853d30562);
const $d0b41f69660db9c4$export$1f2db89e0caa00c9 = {
    Document: 'document',
    Spreadsheet: 'spreadsheet',
    Presentation: 'presentation',
    File: 'file',
    Database: 'database',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Article: 'article',
    Post: 'post',
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Design: 'design',
    Deal: 'deal',
    Video: 'video',
    Task: 'task',
    Issue: 'issue',
    Space: 'space',
    Project: 'project',
    Repository: 'repository',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Image: 'image',
    Archive: 'archive',
    Audio: 'audio',
    Code: 'code',
    Pdf: 'pdf',
    Other: 'other',
    Software: 'software',
    ServiceDesk: 'service_desk',
    Business: 'business',
    DataTable: 'data-table',
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type',
    Folder: 'folder',
    Notebook: 'notebook',
    Form: 'form',
    Shortcut: 'shortcut',
    Site: 'site',
    Subsite: 'subsite',
    Drive: 'drive',
    Comment: 'comment',
    Incident: 'incident',
    CatalogItem: 'catalog_item',
    RequestedItem: 'requested_item',
    KnowledgeArticle: 'knowledge_article',
    Demand: 'demand',
    NewsArticle: 'news_article',
    Epic: 'epic'
};
module.exports["TypeFilterValueKey"] = $d0b41f69660db9c4$export$49f6cbb853d30562;
module.exports["allTypeFilterValueKeys"] = $d0b41f69660db9c4$export$e01073b80ff953d5;
module.exports["NounSubtypeKey"] = $d0b41f69660db9c4$export$1f2db89e0caa00c9;

});

parcelRegister("ljBeq", function(module, exports) {

var $2O9Q9 = parcelRequire("2O9Q9");

const $bd2b1b749e2898a7$export$daea4e28213a211a = ({ isRovoEnabled: isRovoEnabled })=>{
    if (isRovoEnabled) return (0, $2O9Q9.ApplicationModes).Rovo;
    return (0, $2O9Q9.ApplicationModes).Unified;
};
module.exports["getApplicationMode"] = $bd2b1b749e2898a7$export$daea4e28213a211a;

});

parcelRegister("cn81K", function(module, exports) {

var $2LWYf = parcelRequire("2LWYf");

const $2c79acb9e8948053$export$7cbf767827cd68ba = (user)=>{
    if (!user || !user.id) return {
        status: (0, $2LWYf.UserStatus).Unauthenticated,
        id: null,
        name: null,
        email: null
    };
    if (user.id === 'unidentified') return {
        status: (0, $2LWYf.UserStatus).Anonymous,
        ...user
    };
    return {
        status: (0, $2LWYf.UserStatus).Authenticated,
        ...user
    };
};
module.exports["getUser"] = $2c79acb9e8948053$export$7cbf767827cd68ba;

});

parcelRegister("2LWYf", function(module, exports) {
var $e1b52c1f474013cf$export$a82073022ded66e8 = /*#__PURE__*/ function(UserStatus) {
    UserStatus["Unauthenticated"] = "unauthenticated";
    UserStatus["Anonymous"] = "anonymous";
    UserStatus["Authenticated"] = "authenticated";
    return UserStatus;
}({});
var $e1b52c1f474013cf$export$b259bb7f1faab8ee = /*#__PURE__*/ function(LinkDocContentType) {
    LinkDocContentType["extractedLink"] = "extractedLink";
    LinkDocContentType["boostedLink"] = "boostedLink";
    return LinkDocContentType;
}({});
module.exports["UserStatus"] = $e1b52c1f474013cf$export$a82073022ded66e8;
module.exports["LinkDocContentType"] = $e1b52c1f474013cf$export$b259bb7f1faab8ee;

});

parcelRegister("03qcI", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $0bc560a4e6e1cdc5$export$cbfae22cc278acfc = 'a436116f-02ce-4520-8fbb-7301462a1674';
const $0bc560a4e6e1cdc5$export$8e3fc93123f96c19 = (cloudId)=>cloudId === $0bc560a4e6e1cdc5$export$cbfae22cc278acfc;
module.exports["isHello"] = $0bc560a4e6e1cdc5$export$8e3fc93123f96c19;

});

parcelRegister("3ZYG5", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $cc6x1 = parcelRequire("cc6x1");


var $3XLuW = parcelRequire("3XLuW");


var $5msm2 = parcelRequire("5msm2");


var $7zn5c = parcelRequire("7zn5c");

const $8b075a34b0dc6cb8$export$fd4704975f80304e = (layerName, onErrorFn, shouldNotGetBackendExperiment = false, getLayerValuesFn)=>{
    try {
        if (!layerName) return {
            frontendExperiment: undefined,
            backendExperiment: (0, $5msm2.getBackendExperimentConfig)(onErrorFn, shouldNotGetBackendExperiment, getLayerValuesFn)
        };
        const layer = (0, $cXtTj.default).getLayer(layerName, {
            fireLayerExposure: false
        });
        const frontendExperimentName = layer.get('frontendExperimentName', '');
        if (frontendExperimentName) return {
            frontendExperiment: (0, $7zn5c.getFrontendExperiment)({
                abTestId: frontendExperimentName,
                onError: (error)=>onErrorFn?.(error)
            }),
            backendExperiment: (0, $3XLuW.DEFAULT_STATSIG_EXPERIMENT_CONFIG)
        };
        return {
            frontendExperiment: undefined,
            backendExperiment: (0, $5msm2.getBackendExperimentConfig)(onErrorFn, shouldNotGetBackendExperiment, getLayerValuesFn)
        };
    } catch (error) {
        onErrorFn?.(error);
    }
    return {
        frontendExperiment: undefined,
        backendExperiment: (0, $3XLuW.DEFAULT_STATSIG_EXPERIMENT_CONFIG)
    };
};
const $8b075a34b0dc6cb8$export$42e21c9a86f72c4f = (overrides, layerName, onErrorFn, shouldNotGetBackendExperiment = false, getLayerValuesFn)=>{
    // We should only evaluate the backend experiment here if we are using search experiment overrides functionality
    // backend experiments outside of rovo v rovo are evaluated at request time instead
    const shouldUseSearchExperimentOverrides = (0, $iDrrr.fg)('search-experiment-overrides-backend');
    const shouldNotGetBackendExperimentsForOverrides = shouldUseSearchExperimentOverrides ? false : shouldNotGetBackendExperiment;
    // If the feature gate is enabled or no overrides are provided, return the default experiment.
    if (!shouldUseSearchExperimentOverrides || !overrides || overrides.length === 0) return $8b075a34b0dc6cb8$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides, getLayerValuesFn);
    // Filter for backend experiment from the overrides. only allowing them for now
    const backendOverrideExperiments = overrides.filter((override)=>override.location === 'backend' && override.type === 'experiment');
    if (!backendOverrideExperiments.length) return $8b075a34b0dc6cb8$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides, getLayerValuesFn);
    // Get the base user's experiments from layers.
    const { backendExperiment: backendExperiment, frontendExperiment: frontendExperiment } = $8b075a34b0dc6cb8$export$fd4704975f80304e(layerName, onErrorFn, shouldNotGetBackendExperimentsForOverrides, getLayerValuesFn);
    if (backendExperiment && 'experimentLayers' in backendExperiment) backendExperiment.experimentLayers = backendExperiment?.experimentLayers.map((layer)=>{
        const layerToOverride = backendOverrideExperiments.find((exp)=>{
            return exp.layer && layer.name?.includes(exp.layer === 'qr' ? 'query_expansion' : exp.layer);
        });
        if (!layerToOverride) {
            const { testId: _, ...rest } = layer;
            return rest;
        }
        const statsigOverrideExperiment = (0, $cXtTj.default).getExperiment(layerToOverride?.name);
        // handle case where experiment didnt add testId - for older experiments should be on new ones
        if (!statsigOverrideExperiment.get('testId', null)) {
            const { testId: _, ...rest } = layer;
            return rest;
        }
        return {
            name: layer.name,
            layerId: statsigOverrideExperiment.get('testId', null),
            shadowId: statsigOverrideExperiment.get('shadowId', null),
            // The below values might not be sent to the backend, but we can still track them in the frontend.
            controlId: statsigOverrideExperiment.get('controlId', null),
            abTestId: statsigOverrideExperiment.get('abTestId', null),
            armId: statsigOverrideExperiment.get('armId', null)
        };
    });
    return {
        backendExperiment: backendExperiment,
        frontendExperiment: frontendExperiment
    };
};
const $8b075a34b0dc6cb8$export$dd0548ef3fdfe45a = ({ experimentLayers: experimentLayers, sideBySideExperiment: sideBySideExperiment, statsigLayer: statsigLayer, onError: onError, getLayerValuesFn: getLayerValuesFn })=>{
    const { frontendExperiment: frontendExperiment, backendExperiment: backendExperiment } = $8b075a34b0dc6cb8$export$42e21c9a86f72c4f(sideBySideExperiment, statsigLayer, onError, true, getLayerValuesFn);
    // This experiment can be alternated between mutually exclusive or not.
    const multiSiteSearchInRovoExperiment = (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'multi_site_search_in_rovo',
        onError: onError
    });
    return {
        backendExperiment: backendExperiment,
        frontendExperiments: {
            // the frontend experiment that's mutually exclusive to other BE and FE experiments
            ...frontendExperiment?.abTestId && {
                [frontendExperiment.abTestId]: frontendExperiment
            },
            // add other frontend experiments that can be run alongside backend experiments here
            // NOTE: these aren't mutually exclusive to other BE or FE experiments
            [multiSiteSearchInRovoExperiment.abTestId]: multiSiteSearchInRovoExperiment
        },
        dynamicExperiments: (0, $cc6x1.dynamicExperimentsSchema).safeParse(experimentLayers ?? []).data
    };
};
const $8b075a34b0dc6cb8$export$b9e6179ff71a6122 = (0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { experimentLayers: experimentLayers, sideBySideExperiment: sideBySideExperiment, statsigLayer: statsigLayer, onError: onError } = t0;
    let t1;
    if ($[0] !== experimentLayers || $[1] !== onError || $[2] !== sideBySideExperiment || $[3] !== statsigLayer) {
        t1 = $8b075a34b0dc6cb8$export$dd0548ef3fdfe45a({
            experimentLayers: experimentLayers,
            sideBySideExperiment: sideBySideExperiment,
            statsigLayer: statsigLayer,
            onError: onError
        });
        $[0] = experimentLayers;
        $[1] = onError;
        $[2] = sideBySideExperiment;
        $[3] = statsigLayer;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
} : ({ experimentLayers: experimentLayers, sideBySideExperiment: sideBySideExperiment, statsigLayer: statsigLayer, onError: onError })=>{
    return (0, $cozmU.useMemo)(()=>$8b075a34b0dc6cb8$export$dd0548ef3fdfe45a({
            experimentLayers: experimentLayers,
            sideBySideExperiment: sideBySideExperiment,
            statsigLayer: statsigLayer,
            onError: onError
        }), [
        experimentLayers,
        sideBySideExperiment,
        onError,
        statsigLayer
    ]);
};
module.exports["getMutuallyExclusiveExperiment"] = $8b075a34b0dc6cb8$export$fd4704975f80304e;
module.exports["getExperimentConfig"] = $8b075a34b0dc6cb8$export$dd0548ef3fdfe45a;
module.exports["useExperimentConfig"] = $8b075a34b0dc6cb8$export$b9e6179ff71a6122;

});

parcelRegister("4ysB6", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $dvVWp = parcelRequire("dvVWp");

const $9de4c4eec0b45ac2$export$62fed45313a13eff = 'universalTypeFilter';
const $9de4c4eec0b45ac2$export$64f2f70bb9f8e772 = [
    'lastUpdated',
    $9de4c4eec0b45ac2$export$62fed45313a13eff,
    'contributor',
    'space',
    'createdBy',
    'lastUpdatedBy',
    'owner',
    'opportunityStatus',
    'campaignStatus',
    'caseStatus',
    'documentStatus',
    'calendarType',
    'leadStatus',
    'taskStatus',
    'taskType',
    'closeDate',
    'focusAreaType',
    'focusAreaUnder',
    'assignee',
    'reporter',
    'project',
    'content',
    'label',
    'pageStatus',
    'verified',
    'onlyTitleMatch',
    'archived',
    'statusFilter',
    'compassArchived',
    'assetsSchema',
    'assetsType',
    'watchedByMe',
    'positionFocusArea',
    'positionStatus',
    'positionJobFamily',
    'positionTeam',
    'commentedByMe',
    'positionEmploymentType',
    'salesforceStage',
    'repository',
    'reviewer',
    'pullRequestStatus',
    'slackChannel',
    'workspaceName',
    'hasAttachment'
];
const $9de4c4eec0b45ac2$export$1fd3303b0f1dd4fb = ()=>{
    return $9de4c4eec0b45ac2$export$64f2f70bb9f8e772.filter((filterId)=>{
        if (filterId === 'repository' && !(0, $iDrrr.fg)('rovo_fps_show_repository_filter')) return false;
        if (filterId === 'hasAttachment' && !(0, $iDrrr.fg)('rovo_fps_show_has_attachment_filter')) return false;
        if (filterId === 'workspaceName' && !(0, $iDrrr.fg)('rovo_fps_show_workspace_name_filter')) return false;
        return true;
    });
};
const $9de4c4eec0b45ac2$export$2c1f2e526d05c6ca = 'search-page-hidden-filters-v2';
const $9de4c4eec0b45ac2$export$b6072f70c84313e0 = ()=>{
    return $9de4c4eec0b45ac2$export$2c1f2e526d05c6ca;
};
const $9de4c4eec0b45ac2$export$657c4ea1fb8d25dd = [
    (0, $dvVWp.ProductKeys).Trello,
    (0, $dvVWp.ProductKeys).Gmail,
    (0, $dvVWp.ProductKeys).OutlookMail
];
module.exports["universalTypeFilterId"] = $9de4c4eec0b45ac2$export$62fed45313a13eff;
module.exports["getFilterIdOrdering"] = $9de4c4eec0b45ac2$export$1fd3303b0f1dd4fb;
module.exports["getSearchPageFilterConfigKey"] = $9de4c4eec0b45ac2$export$b6072f70c84313e0;
module.exports["ALL_FILTER_EXCLUDED_PRODUCTS"] = $9de4c4eec0b45ac2$export$657c4ea1fb8d25dd;

});

parcelRegister("eD8r5", function(module, exports) {

var $3X0xX = parcelRequire("3X0xX");


var $cFPRS = parcelRequire("cFPRS");

const $5a252b1cbebb706f$export$f86b2a1a2ce291b3 = async (error, userId, primaryProduct)=>{
    try {
        const SentryClient = await (0, $cFPRS.getSentryClient)();
        if (!SentryClient) return;
        SentryClient.withScope((scope)=>{
            for (const [key, value] of Object.entries((0, $3X0xX.COMMON_TAGS)))scope.setTag(key, value);
            scope.setUser({
                id: userId || (0, $3X0xX.UNKNOWN_TAG)
            });
            scope.setTag('product', primaryProduct || (0, $3X0xX.UNKNOWN_TAG));
            SentryClient.captureException(error, scope);
        });
    } catch (error) {
        // When there was an error with Sentry, just output to console
        // eslint-disable-next-line no-console
        console.error(error);
    }
};
module.exports["logException"] = $5a252b1cbebb706f$export$f86b2a1a2ce291b3;

});

parcelRegister("1i979", function(module, exports) {

var $jg98Q = parcelRequire("jg98Q");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $fjHkB = parcelRequire("fjHkB");

var $8s9DV = parcelRequire("8s9DV");


var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $51pfw = parcelRequire("51pfw");


var $imUxN = parcelRequire("imUxN");


var $3yJeH = parcelRequire("3yJeH");


var $1Qme9 = parcelRequire("1Qme9");


var $6yu7A = parcelRequire("6yu7A");


var $4ysB6 = parcelRequire("4ysB6");


var $e0v3Z = parcelRequire("e0v3Z");

const $0023915a6e6a3533$export$51e3c005021600c8 = new Set([
    'label'
]);
const $0023915a6e6a3533$export$388d8f84295a9ea5 = (filterId)=>$0023915a6e6a3533$export$51e3c005021600c8.has(filterId);
const $0023915a6e6a3533$export$931e138580bca877 = (filterId, value)=>$0023915a6e6a3533$export$388d8f84295a9ea5(filterId) ? (0, $e0v3Z.sha256Hash)(value) : value;



var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $lDiEy = parcelRequire("lDiEy");


var $8fNUp = parcelRequire("8fNUp");


var $9pcjO = parcelRequire("9pcjO");


var $cJff5 = parcelRequire("cJff5");


var $35JNe = parcelRequire("35JNe");

class $c59181be2ffd57d8$export$8ba86dff7c04c14c extends (0, $35JNe.ResultsFetchError) {
    constructor(){
        super('No entities provided to fetch results');
        this.name = 'EmptyEntitiesError';
    }
}



var $fR63l = parcelRequire("fR63l");




const $201f44e4b1c735f8$export$94d61914de4d5edf = [
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Slack,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).Conversation
            ]
        ],
        hiddenFilters: [
            'lastUpdated',
            'contributor'
        ]
    }
];








const $ff46216cbb528f97$export$5a7e3222966d6cdd = [
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).Deal
            ]
        ],
        shownFilters: [
            'salesforceStage',
            'opportunityStatus'
        ]
    },
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).Case
            ]
        ],
        shownFilters: [
            'caseStatus'
        ]
    },
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).Campaign
            ]
        ],
        shownFilters: [
            'campaignStatus'
        ]
    },
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).Document
            ]
        ],
        shownFilters: [
            'documentStatus'
        ]
    },
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).Calendar
            ]
        ],
        shownFilters: [
            'calendarType'
        ]
    },
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).Lead
            ]
        ],
        shownFilters: [
            'leadStatus'
        ]
    },
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).WorkItem
            ]
        ],
        shownFilters: [
            'taskStatus'
        ]
    },
    {
        selectedProduct: (0, $fR63l.ProductKeys3P).Salesforce,
        selectedFilters: [
            [
                'universalTypeFilter',
                (0, $7ydfN.TypeFilterValueKey).WorkItem
            ]
        ],
        shownFilters: [
            'taskType'
        ]
    }
];


/**
 * Extracts the selected values for a given filter from the store's filters map.
 * Select filters store values as `value: string[]`; boolean and other filter
 * types are not expected to appear in rules and return an empty array.
 */ const $4abb27497bf1f895$var$getFilterValues = (filters, filterId)=>{
    const filter = filters[filterId];
    if (filter && 'value' in filter && Array.isArray(filter.value)) return filter.value;
    return [];
};
const $4abb27497bf1f895$export$8848759bd942e213 = (selectedProduct, filters, exclusionRules = (0, $201f44e4b1c735f8$export$94d61914de4d5edf), inclusionRules = (0, $ff46216cbb528f97$export$5a7e3222966d6cdd))=>{
    const excluded = new Set();
    // ── Exclusion rules: hide filters when conditions ARE met ──
    for (const rule of exclusionRules){
        // Check product condition (if specified)
        if (rule.selectedProduct !== undefined && rule.selectedProduct !== selectedProduct) continue;
        // Check all filter selection conditions (AND logic — all must match)
        const allFiltersMatch = rule.selectedFilters.every(([filterId, requiredValue])=>{
            const currentValues = $4abb27497bf1f895$var$getFilterValues(filters, filterId);
            return currentValues.includes(requiredValue);
        });
        if (allFiltersMatch) rule.hiddenFilters.forEach((f)=>{
            // Never hide a filter that currently has active selections — the user
            // may have chosen a value before the exclusion rule activated and the
            // selection is still valid.
            const filterValues = $4abb27497bf1f895$var$getFilterValues(filters, f);
            if (filterValues.length === 0) excluded.add(f);
        });
    }
    // ── Inclusion rules: hide filters when conditions are NOT met ──
    // Step 1: Collect all filter IDs managed by inclusion rules and track which
    // condition filter IDs each managed filter depends on.
    const managedFilters = new Set();
    const satisfiedFilters = new Set();
    const conditionFiltersPerManaged = new Map();
    for (const rule of inclusionRules){
        // Check product condition first — skip rules for other products entirely
        if (rule.selectedProduct !== undefined && rule.selectedProduct !== selectedProduct) continue;
        rule.shownFilters.forEach((f)=>{
            managedFilters.add(f);
            if (!conditionFiltersPerManaged.has(f)) conditionFiltersPerManaged.set(f, new Set());
            rule.selectedFilters.forEach(([filterId])=>conditionFiltersPerManaged.get(f).add(filterId));
        });
        // Check if this rule's conditions are all met
        const allConditionsMet = rule.selectedFilters.every(([filterId, requiredValue])=>{
            const currentValues = $4abb27497bf1f895$var$getFilterValues(filters, filterId);
            return currentValues.includes(requiredValue);
        });
        if (allConditionsMet) rule.shownFilters.forEach((f)=>satisfiedFilters.add(f));
    }
    // Step 2: For each inclusion-managed filter, hide it if:
    // - No inclusion rule matched (filter not satisfied), AND
    // - At least one condition filter has an active selection (the user has made
    //   a choice that makes the filter irrelevant). If no condition filter has a
    //   value yet (e.g. "All" mode), leave the filter visible — don't hide it
    //   prematurely before the user has picked a type.
    for (const filterId of managedFilters)if (!satisfiedFilters.has(filterId)) {
        const conditionFilterIds = conditionFiltersPerManaged.get(filterId) ?? new Set();
        const anyConditionFilterHasValue = [
            ...conditionFilterIds
        ].some((cfId)=>$4abb27497bf1f895$var$getFilterValues(filters, cfId).length > 0);
        if (anyConditionFilterHasValue) // A condition filter has a selection but it doesn't match any rule —
        // hide the managed filter. Unlike exclusion rules, inclusion rules hide
        // even when the managed filter has active selections — the store-level
        // `setSearchStoreState` will clear those selections separately so the
        // store stays in sync with what is applied.
        excluded.add(filterId);
    }
    return excluded;
};



var $c3cgJ = parcelRequire("c3cgJ");


var $biQM6 = parcelRequire("biQM6");


var $c3mkK = parcelRequire("c3mkK");


var $jbIQp = parcelRequire("jbIQp");


var $8JYuM = parcelRequire("8JYuM");


var $ieiUX = parcelRequire("ieiUX");


var $h6X6L = parcelRequire("h6X6L");

const $2b1419bc2c84719c$export$d4c72bab9d6cc13a = {
    abTest: undefined,
    cql: undefined,
    autoCorrection: undefined,
    product: undefined,
    requestId: undefined,
    traceId: undefined,
    // Search Input states
    inputQuery: '',
    searchQuery: '',
    originalQuery: undefined,
    // Product States
    primaryProduct: null,
    // Filter States
    filters: {},
    filterSelectionOrder: [],
    selectedProducts: [],
    selectedDatasource: undefined,
    availableProducts: [],
    allFilterExcludedProducts: [],
    jsmIncidentFilterIds: [],
    // Rest of store states
    resultsSort: {
        field: 'relevance',
        order: 'DESC'
    },
    retryCount: 0,
    queryVersion: 0,
    queryUpdatedTime: undefined,
    isLoading: false,
    isJiraHydrationLoading: false,
    isCompassTeamsLoading: false,
    shownCount: 0,
    results: undefined,
    resultError: undefined,
    productResultCountMap: null,
    paginationTokens: [],
    isLoadingMore: false,
    leapQuery: {
        loading: false,
        candidates: [],
        titleIndex: 0
    },
    requestedBackendExperiments: undefined,
    filterDropdownOpenByQueryParam: false,
    experience: (0, $9pcjO.SearchExperience).SEARCH_PAGE,
    wasContentClearedBySpaceChange: false
};
const $2b1419bc2c84719c$var$getUpdatedFilterSelectionOrder = (previousOrder, newFilterId, selected)=>{
    let filterSelectionOrder = new Set([
        ...previousOrder,
        newFilterId
    ]);
    if (!selected) filterSelectionOrder.delete(newFilterId);
    return [
        ...filterSelectionOrder
    ];
};
// Always `true`. Param kept so the call sites below stay untouched.
const $2b1419bc2c84719c$var$isFiltersDiscoverability2Enabled = (_primaryProduct)=>true;
/**
 * Only these keys can get set before the updateQueryParams loop when updateQueryParams=true in setSearchStoreState
 */ const $2b1419bc2c84719c$var$safeStateKeys = [
    'filterSelectionOrder',
    'resultsSort',
    'retryCount',
    'selectedDatasource',
    'wasContentClearedBySpaceChange'
];
/**
 * Please use setSearchStoreState instead of setState within the Search Store controller.
 *
 * This is because we treat the URL as the source of truth for some state. Filter value states are set in the URL directly and then we listen to URL state changs to represent them in our state.
 *
 * @param newState - state properties to set
 * @param {boolean} options.updateQueryParams - [false] Whether a setState call should trigger an URL update
 *
 * Notes on updateQueryParams:
 *
 * When false, this function acts like a standard setState
 * When true, this function will allow only the {safeStateKeys} to be set and will then use the provided query/filter etc state to set the URL directly, relying on the URL observer to complete the loop
 *
 * Non-url updates should NEVER trigger the setQueryParams callback. Otherwise, this will cause infinite loops or extra render cycles.
 **/ const $2b1419bc2c84719c$var$setSearchStoreState = (newState, options)=>({ getState: getState, setState: setState }, { setQueryParams: setQueryParams, allFilters: allFilters, config: config, availableProducts: availableProducts, primaryProduct: primaryProduct, queryParams: currentQueryParams })=>{
        // TODO future refactoring: we should instead query the newState object for any URL-state changes, then clean up the setState we perform, then update the URL. Then a consumer of this function will not need to care about any of this and can simply pass `newState` as expected
        if (!options?.updateQueryParams) {
            setState({
                ...newState,
                availableProducts: availableProducts
            });
            return;
        }
        // We still want to set variables in state that do NOT participate in the URL
        // Initially we'll allow-list this set, as the set of filters (the disallow set) will grow over time
        const safeNewState = Object.fromEntries(Object.entries(newState).filter(([key])=>$2b1419bc2c84719c$var$safeStateKeys.includes(key)));
        if (Object.keys(safeNewState).length > 0) setState(safeNewState);
        const { searchQuery: newSearchQuery, inputQuery: newInputQuery, filterDropdownOpenByQueryParam: filterDropdownOpenByQueryParam } = newState;
        const { inputQuery: oldInputQuery } = getState();
        const { selectedProducts: selectedProducts, selectedDatasource: selectedDatasource, filters: allFilterStates } = {
            ...getState(),
            ...newState
        };
        // Compute excluded filters via FILTER_EXCLUSION_RULES + FILTER_INCLUSION_RULES (e.g.
        // salesforceStage when type≠deal). Excluded filters do NOT contribute to URL params
        // or the GraphQL query. This is the single source of truth for filter visibility;
        // UI selectors (useFiltersToDisplay, useSelectedFilterCount) apply the same exclusion.
        const excludedFilterIds = (0, $4abb27497bf1f895$export$8848759bd942e213)(selectedProducts[0], allFilterStates);
        const staticFilters = Object.values(allFilters).filter((f)=>{
            if (excludedFilterIds.has(f.id)) return false;
            const filterState = f.getInitialState(config).getState();
            const isSuggestedFilter = f.isSuggestedFilter?.(primaryProduct);
            return (0, $c3cgJ.isAllProductSearch)(selectedProducts) ? filterState.universal || isSuggestedFilter // When there are no selected products, only universal and suggested filters are persisted in state
             : // Forge connectors are registered dynamically and not in filterState.products, so check them separately
            filterState.universal && selectedProducts.some((0, $8fNUp.isForgeConnectorProductKey)) || filterState.products.some((product)=>selectedProducts.includes(product));
        });
        const filterQueryParamValues = staticFilters.map((staticFilter)=>{
            const filterState = allFilterStates[staticFilter.id];
            if (!staticFilter.isCompatible(filterState?.id)) return {};
            return staticFilter.withState(filterState, config).queryParams.get();
        });
        const filterQueryParams = Object.assign({}, ...filterQueryParamValues);
        const text = [
            newSearchQuery,
            newInputQuery,
            oldInputQuery
        ].find(Boolean);
        const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        (0, $cXtTj.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
        // If overrides is already an object (parsed), convert it back to JSON string for parseQueryParams
        const overridesToPreserve = currentQueryParams?.overrides && enableRovoSearchOverrides ? typeof currentQueryParams.overrides === 'string' ? currentQueryParams.overrides : encodeURIComponent(JSON.stringify(currentQueryParams.overrides)) : undefined;
        const paramsToPassToParse = {
            product: selectedProducts[0],
            datasource: selectedDatasource?.datasourceId,
            text: text !== '' ? text : undefined,
            ...$2b1419bc2c84719c$var$isFiltersDiscoverability2Enabled(primaryProduct) && {
                filterDropdownOpen: filterDropdownOpenByQueryParam || undefined
            },
            ...filterQueryParams,
            // Preserve overrides from current query params if enable-rovo_search_overrides is enabled
            ...overridesToPreserve && {
                overrides: overridesToPreserve
            }
        };
        const parsedQueryParams = (0, $biQM6.parseQueryParams)(paramsToPassToParse, {
            commaSeparatedValues: true
        });
        setQueryParams(parsedQueryParams);
    };
const $2b1419bc2c84719c$export$f14fed79ef571627 = $2b1419bc2c84719c$var$setSearchStoreState;
const $2b1419bc2c84719c$var$privateStoreActions = {
    initialiseStore: ()=>async ({ dispatch: dispatch }, { allFilters: allFilters, queryParams: queryParams, config: config, setQueryParams: setQueryParams, availableProducts: availableProducts, allFilterExcludedProducts: allFilterExcludedProducts, primaryProduct: primaryProduct, thirdPartyConfigs: thirdPartyConfigs, experience: experience })=>{
            const { getSelectedProducts: getSelectedProducts, filtersByProduct: filtersByProduct, isMissingProductSelection: isMissingProductSelection } = (0, $ieiUX.FilterUtils)(allFilters, {});
            const selectedProducts = getSelectedProducts(queryParams);
            const cql = queryParams.cql?.toString();
            if (isMissingProductSelection(queryParams)) {
                setQueryParams({
                    ...queryParams,
                    product: selectedProducts[0]
                });
                return;
            }
            const { staticFilterValues: staticFiltersByProduct } = filtersByProduct(selectedProducts, experience, primaryProduct);
            const resolvedQueryParams = await Promise.allSettled(staticFiltersByProduct.map((staticFilter)=>{
                const queryParamsKeys = [
                    staticFilter.queryParams.key
                ];
                if (staticFilter.isSupportCustomValue && staticFilter.customValueFields) queryParamsKeys.push(...staticFilter.customValueFields);
                return staticFilter.getInitialState(config).queryParams.set((0, $biQM6.convertQueryParamsToStringArray)(queryParams, queryParamsKeys));
            }));
            const filterStatesByProduct = resolvedQueryParams.flatMap((promise)=>{
                switch(promise.status){
                    case 'fulfilled':
                        return [
                            promise.value.getState()
                        ];
                    case 'rejected':
                        return [];
                }
            });
            const { filterStates: filterStates } = (0, $ieiUX.FilterUtils)(staticFiltersByProduct, filterStatesByProduct);
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                filters: filterStates,
                selectedProducts: selectedProducts,
                selectedDatasource: (0, $biQM6.getDatasourceFromId)(queryParams.datasource?.toString(), selectedProducts[0], thirdPartyConfigs),
                inputQuery: String(queryParams.text ?? ''),
                searchQuery: String(queryParams.text ?? ''),
                originalQuery: String(queryParams.originalQuery ?? ''),
                ...$2b1419bc2c84719c$var$isFiltersDiscoverability2Enabled(primaryProduct) && {
                    filterDropdownOpenByQueryParam: Boolean(queryParams.filterDropdownOpen)
                },
                availableProducts: availableProducts,
                allFilterExcludedProducts: allFilterExcludedProducts,
                cql: cql,
                primaryProduct: primaryProduct,
                experience: experience
            }, {
                updateQueryParams: false // onInit should not update the query params
            }));
        },
    updateStore: ()=>async ({ dispatch: dispatch, getState: getState }, { allFilters: allFilters, queryParams: queryParams, config: config, availableProducts: availableProducts, primaryProduct: primaryProduct, thirdPartyConfigs: thirdPartyConfigs, experience: experience })=>{
            const { filters: filterStates } = getState();
            const { getSelectedProducts: getSelectedProducts, filtersByProduct: filtersByProduct } = (0, $ieiUX.FilterUtils)(allFilters, filterStates);
            const selectedProducts = getSelectedProducts(queryParams);
            const cql = queryParams.cql?.toString();
            const { staticFilterValues: staticFiltersByProduct, filterStates: filterStatesByProduct } = filtersByProduct(selectedProducts, experience, primaryProduct);
            const resolvedQueryParams = await Promise.allSettled(staticFiltersByProduct.map((staticFilter)=>{
                const filterState = filterStatesByProduct[staticFilter.id];
                const queryParamsKeys = [
                    staticFilter.queryParams.key
                ];
                if (staticFilter.isSupportCustomValue && staticFilter.customValueFields) queryParamsKeys.push(...staticFilter.customValueFields);
                const queryParamStringArray = (0, $biQM6.convertQueryParamsToStringArray)(queryParams, queryParamsKeys);
                if (!staticFilter.isCompatible(filterState?.id)) return staticFilter.getInitialState(config).queryParams.set(queryParamStringArray);
                return staticFilter.withState(filterState, config).queryParams.set(queryParamStringArray);
            }));
            const fullfilledFilterStates = resolvedQueryParams.flatMap((promise)=>{
                switch(promise.status){
                    case 'fulfilled':
                        return [
                            promise.value.getState()
                        ];
                    case 'rejected':
                        return [];
                }
            });
            const { filterStates: resolvedFilterStates } = (0, $ieiUX.FilterUtils)(staticFiltersByProduct, fullfilledFilterStates);
            // In order, ensure all filters with values are added to selection
            // Ensures filters enter selection order from resume-from-url
            // TODO: this should be done with the global ordering, but we don't have that in constants yet
            let { filterSelectionOrder: filterSelectionOrder } = getState();
            const { getFiltersWithSelection: getFiltersWithSelection } = (0, $ieiUX.FilterUtils)(staticFiltersByProduct, resolvedFilterStates);
            getFiltersWithSelection().forEach((filterId)=>{
                filterSelectionOrder = $2b1419bc2c84719c$var$getUpdatedFilterSelectionOrder(filterSelectionOrder, filterId, resolvedFilterStates[filterId]?.hasSelection);
            });
            const querySelectedProducts = getSelectedProducts(queryParams);
            const selectedDatasource = (0, $biQM6.getDatasourceFromId)(queryParams.datasource?.toString(), querySelectedProducts[0], thirdPartyConfigs);
            const nextStateSync = {
                filters: resolvedFilterStates,
                selectedProducts: querySelectedProducts,
                selectedDatasource: selectedDatasource,
                filterSelectionOrder: filterSelectionOrder,
                inputQuery: String(queryParams.text ?? ''),
                searchQuery: String(queryParams.text ?? ''),
                originalQuery: String(queryParams.originalQuery ?? ''),
                ...$2b1419bc2c84719c$var$isFiltersDiscoverability2Enabled(primaryProduct) && {
                    filterDropdownOpenByQueryParam: Boolean(queryParams.filterDropdownOpen)
                },
                availableProducts: availableProducts,
                paginationTokens: [],
                cql: cql,
                primaryProduct: primaryProduct,
                experience: experience
            };
            const stateBeforeSync = getState();
            const prevStateSyncComparable = {
                filters: stateBeforeSync.filters,
                selectedProducts: stateBeforeSync.selectedProducts,
                selectedDatasource: stateBeforeSync.selectedDatasource,
                filterSelectionOrder: stateBeforeSync.filterSelectionOrder,
                inputQuery: stateBeforeSync.inputQuery,
                searchQuery: stateBeforeSync.searchQuery,
                originalQuery: stateBeforeSync.originalQuery,
                ...$2b1419bc2c84719c$var$isFiltersDiscoverability2Enabled(primaryProduct) && {
                    filterDropdownOpenByQueryParam: stateBeforeSync.filterDropdownOpenByQueryParam
                },
                availableProducts: stateBeforeSync.availableProducts,
                paginationTokens: stateBeforeSync.paginationTokens,
                cql: stateBeforeSync.cql,
                primaryProduct: stateBeforeSync.primaryProduct,
                experience: stateBeforeSync.experience
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($jg98Q)))(prevStateSyncComparable, nextStateSync)) dispatch($2b1419bc2c84719c$var$setSearchStoreState(nextStateSync, {
                updateQueryParams: false
            } // onUpdate lifecycle should never update the query params
            ));
        },
    setFilter: (state, options)=>async ({ dispatch: dispatch, getState: getState }, { allFilters: allFilters, config: config })=>{
            // Get the static filter definition
            const staticFilter = allFilters[state.id];
            const { filters: allFiltersState } = getState();
            if (!staticFilter.isCompatible(staticFilter.id)) return;
            const filterWithState = staticFilter.withState(state, config).getState();
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                filters: {
                    ...allFiltersState,
                    [staticFilter.id]: filterWithState
                },
                ...options?.setSelectedProduct ? {
                    selectedProducts: [
                        options?.setSelectedProduct
                    ]
                } : {}
            }, {
                updateQueryParams: options?.shouldSetQueryParams
            }));
        },
    updateFilterSelectionOrder: (filterId, selected)=>async ({ dispatch: dispatch, getState: getState })=>{
            const { filterSelectionOrder: oldSelectionOrder } = getState();
            const newFilterSelectionOrder = $2b1419bc2c84719c$var$getUpdatedFilterSelectionOrder(oldSelectionOrder, filterId, selected);
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                filterSelectionOrder: newFilterSelectionOrder
            }));
        },
    setNewFilterStates: (newFilterStates, setSelectedProduct, filterSelectionOrder)=>async ({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                filters: newFilterStates,
                ...setSelectedProduct !== undefined && {
                    selectedProducts: [
                        setSelectedProduct
                    ]
                },
                ...filterSelectionOrder && {
                    filterSelectionOrder: filterSelectionOrder
                }
            }, {
                updateQueryParams: false
            }));
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({}, {
                updateQueryParams: true
            }));
        }
};
function $2b1419bc2c84719c$var$hasLoadInitialOptions(filter) {
    return typeof filter === 'object' && filter !== null && 'loadInitialOptions' in filter && typeof filter.loadInitialOptions === 'function' && 'getState' in filter && typeof filter.getState === 'function';
}
const $2b1419bc2c84719c$export$e324594224ef24da = {
    loadInitialSelectFilterOptions: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config, thirdPartyConfigs: thirdPartyConfigs })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            const { selectedDatasource: stateSelectedDatasource, selectedProducts: selectedProducts } = getState();
            // When selectedDatasource is not set (e.g. no `datasource=` URL param was present),
            // derive it from thirdPartyConfigs using the selected product. This allows filters
            // that need a datasourceId (e.g. salesforceStage dynamic stage options) to fetch
            // correctly even when the datasource was not explicitly set via URL.
            //
            // Some dynamic 3P filters (those declaring `requiresTopLevel3PDatasource: true` —
            // today: salesforceStage, campaignStatus, caseStatus) read from the top-level
            // thirdPartyConfigs entry directly because it always carries a datasourceId, whereas
            // .datasources?.[0] may only be populated in multi-domain configurations.
            const shouldUseTopLevel3PDatasource = 'requiresTopLevel3PDatasource' in staticSelectFilter && !!staticSelectFilter.requiresTopLevel3PDatasource;
            const selectedDatasource = stateSelectedDatasource ?? (selectedProducts[0] ? shouldUseTopLevel3PDatasource ? thirdPartyConfigs?.[selectedProducts[0]] : thirdPartyConfigs?.[selectedProducts[0]]?.datasources?.[0] : undefined);
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $jbIQp.isSelectFilter)(staticSelectFilter.type)) return;
            // Race-condition guard: dynamic 3P filters require a resolved datasource to
            // fetch their option list. If the bootstrap config hasn't loaded yet,
            // `thirdPartyConfigs` is empty and `selectedDatasource` is undefined — in
            // which case calling `loadInitialOptions` would mark this product as loaded
            // with an empty result and the filter would never retry. Skip the call so the
            // caller (UI effect) can re-trigger once the datasource arrives.
            if (shouldUseTopLevel3PDatasource && !selectedDatasource) return;
            const selectedSpaceAris = Array.isArray(allFiltersState?.space?.value) ? allFiltersState.space.value : config.initialSpaceARIs;
            const selectedContributorAccountIds = Array.isArray(allFiltersState?.contributor?.value) ? allFiltersState.contributor.value : config.contributorAccountIds;
            const extendedConfig = {
                ...config,
                // overriding the intl in config to fix a race condition with initial options and outdated translation messages
                intl: props.intl,
                selectedDatasource: selectedDatasource,
                initialSpaceARIs: selectedSpaceAris,
                contributorAccountIds: selectedContributorAccountIds
            };
            const newFilter = staticSelectFilter.withState(filterState, extendedConfig);
            if ($2b1419bc2c84719c$var$hasLoadInitialOptions(newFilter)) await newFilter.loadInitialOptions((stateChange)=>{
                dispatch($2b1419bc2c84719c$var$privateStoreActions.setFilter(stateChange));
            });
        },
    clearSelectFilterOptions: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $jbIQp.isSelectFilter)(staticSelectFilter.type)) return;
            const newFilterState = staticSelectFilter.withState(filterState, config).clear().getState();
            dispatch($2b1419bc2c84719c$var$privateStoreActions.setFilter(newFilterState, {
                shouldSetQueryParams: true
            }));
            dispatch($2b1419bc2c84719c$var$privateStoreActions.updateFilterSelectionOrder(props.filterId, newFilterState.hasSelection));
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    /**
   * Sets a select filter option.
   *
   * @param validateDependentFilterId - If provided, validates if the dependent filter's containerARI
   *                                    is still in the new selection values and clears it if not.
   */ setSelectFilterOption: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $jbIQp.isSelectFilter)(staticSelectFilter.type)) return;
            const filterWithState = staticSelectFilter.withState(filterState, config);
            if (!('setOption' in filterWithState)) return;
            const newFilterState = filterWithState.setOption(props.optionChange, props.options?.customValue).getState();
            if ((0, $cJff5.serveWebPagesInTypeFilter)() && props.filterId === (0, $4ysB6.universalTypeFilterId)) {
                const { selectedProducts: selectedProducts } = getState();
                const hasWebPageSelected = newFilterState.hasSelection && newFilterState.value?.includes((0, $7ydfN.TypeFilterValueKey).WebPage);
                if (hasWebPageSelected) {
                    // When web-page type is selected, use the same logic as clicking the noun in the right panel to select the product = AtlassianWebCrawler
                    dispatch($2b1419bc2c84719c$export$e324594224ef24da.unsafe_setWebPageType());
                    return;
                }
                if (!newFilterState.hasSelection && selectedProducts?.includes((0, $dvVWp.ProductKeys).AtlassianWebCrawler)) {
                    // Clear the product since type filter has been cleared. This will also clear the type filter
                    // and update filter selection order through selectProductFilter's existing logic
                    dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                        productResultCountMap: null
                    }));
                    dispatch($2b1419bc2c84719c$export$e324594224ef24da.selectProductFilter());
                    return;
                }
            }
            // When the contributor selection changes, the cached `initialOptions` (suggested values
            // shown when a dependent dropdown is opened without typing) on contributor-scoped
            // filters becomes stale: the base select filter short-circuits `loadInitialOptions`
            // when the current product is marked as loaded, so the dropdown keeps showing
            // pre-contributor suggestions until the user actually types. Reset
            // `didMountPerProducts` and clear `initialOptions.options` on each contributor-scoped
            // dependent filter so the next dropdown open re-fetches with the new contributor
            // scope. Behind the same FG that controls the rest of the contributor scoping logic.
            if (props.filterId === 'contributor' && (0, $iDrrr.fg)('rovo_fps_scope_3p_typeahead_by_contributor')) {
                const previousValue = Array.isArray(filterState?.value) ? filterState.value : [];
                const nextValue = Array.isArray(newFilterState.value) ? newFilterState.value : [];
                const contributorSelectionChanged = !(0, (/*@__PURE__*/$parcel$interopDefault($jg98Q)))([
                    ...previousValue
                ].sort(), [
                    ...nextValue
                ].sort());
                if (contributorSelectionChanged) {
                    const contributorScopedDependents = [
                        'content'
                    ];
                    contributorScopedDependents.forEach((dependentId)=>{
                        const dependentStaticFilter = allFilters[dependentId];
                        const dependentFilterState = allFiltersState[dependentId];
                        if (!dependentStaticFilter || !dependentStaticFilter.isCompatible(dependentFilterState?.id) || !(0, $jbIQp.isSelectFilter)(dependentStaticFilter.type)) return;
                        const dependentSelectFilterState = dependentFilterState;
                        if (!dependentSelectFilterState) return;
                        const resetDependentState = {
                            ...dependentSelectFilterState,
                            didMountPerProducts: {},
                            initialOptions: {
                                ...dependentSelectFilterState.initialOptions,
                                options: [],
                                isLoading: false
                            }
                        };
                        dispatch($2b1419bc2c84719c$var$privateStoreActions.setFilter(resetDependentState, {
                            shouldSetQueryParams: false
                        }));
                    });
                }
            }
            // Validate dependent filter if specified (e.g., clear content filter when space changes)
            const dependentFilterId = props.options?.validateDependentFilterId;
            let wasContentCleared = false;
            if (dependentFilterId) {
                const dependentStaticFilter = allFilters[dependentFilterId];
                const dependentFilterState = allFiltersState[dependentFilterId];
                if (dependentStaticFilter?.isCompatible(dependentFilterState?.id) && (0, $jbIQp.isSelectFilter)(dependentStaticFilter.type)) {
                    // Get new values from the updated filter state
                    const newValues = Array.isArray(newFilterState.value) ? newFilterState.value : [];
                    const { selectedProducts: selectedProducts } = getState();
                    const shouldResetLoomFolderWhenSpaceCleared = dependentFilterId === (0, $8JYuM.folderFilterId) && selectedProducts[0] === (0, $dvVWp.ProductKeys).Loom && newValues.length === 0 && (0, $iDrrr.fg)('loom-rovo-search');
                    // Clear the dependent filter whenever the primary filter is explicitly set to a
                    // non-empty selection. Reset the per-product loaded state and clear cached
                    // initialOptions so the next dropdown open re-fetches dependent suggestions
                    // scoped to the new primary selection
                    // instead of showing stale options from the previous selection.
                    // Loom: also reset folder when all spaces are deselected (Drive→content keeps
                    // content when space is empty).
                    if (newValues.length > 0 || shouldResetLoomFolderWhenSpaceCleared) {
                        const clearedDependentState = dependentStaticFilter.withState(dependentFilterState, config).clear().getState();
                        const dependentSelectFilterState = dependentFilterState;
                        const resetDependentState = dependentSelectFilterState ? {
                            ...clearedDependentState,
                            didMountPerProducts: {},
                            initialOptions: {
                                ...dependentSelectFilterState.initialOptions,
                                options: [],
                                isLoading: false
                            },
                            // Reset lookup so stale typeahead results (from typing in the
                            // filter dropdown before space change) don't persist alongside
                            // new space-scoped suggestions when the content dropdown reopens.
                            lookup: {
                                ...dependentSelectFilterState.lookup,
                                options: [],
                                lookupResultOptions: [],
                                input: '',
                                isLoading: false,
                                isActive: false
                            }
                        } : clearedDependentState;
                        dispatch($2b1419bc2c84719c$var$privateStoreActions.setFilter(resetDependentState, {
                            shouldSetQueryParams: false
                        }));
                        dispatch($2b1419bc2c84719c$var$privateStoreActions.updateFilterSelectionOrder(dependentFilterId, false));
                        wasContentCleared = true;
                    }
                }
            }
            dispatch($2b1419bc2c84719c$var$privateStoreActions.setFilter(newFilterState, {
                shouldSetQueryParams: true,
                setSelectedProduct: props.options?.setSelectedProduct
            }));
            dispatch($2b1419bc2c84719c$var$privateStoreActions.updateFilterSelectionOrder(props.filterId, newFilterState.hasSelection));
            // NOTE: Inclusion-rule-driven filters (e.g. salesforceStage when type≠deal) are
            // handled as a derived projection in setSearchStoreState (URL/GraphQL builder),
            // useFiltersToDisplay (UI), and useSelectedFilterCount (badge). Stale selections
            // for excluded filters are cleared by setSearchStoreState in the same write so
            // the store stays in sync with what is visible/applied. No imperative clear is
            // needed here.
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                productResultCountMap: null,
                wasContentClearedBySpaceChange: wasContentCleared
            }));
        },
    setAutoFilters: (filters)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const { filters: allFilterStates } = getState();
            const newFilterStates = {};
            await Promise.all(filters.map(async (filterConfig)=>{
                const staticSelectFilter = allFilters[filterConfig.filterId];
                const filterState = allFilterStates[filterConfig.filterId];
                // We should not automatically apply the filter if it has already been selected
                if (filterState?.hasSelection) return;
                if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $jbIQp.isSelectFilter)(staticSelectFilter.type)) return;
                const filterWithState = staticSelectFilter.withState(filterState, config);
                if (!('setOption' in filterWithState)) return;
                const optionsToChange = Array.isArray(filterConfig.optionChange) ? filterConfig.optionChange : [
                    filterConfig.optionChange
                ];
                const selectedOptions = optionsToChange.filter((o)=>o.isSelected);
                if (selectedOptions.length === 0) return;
                // Build query params object with the filter's key
                const queryParamsKey = staticSelectFilter.queryParams.key;
                const queryParams = {
                    [queryParamsKey]: selectedOptions.map((o)=>o.value)
                };
                // Add custom value fields if provided
                if (filterConfig.options?.customValue) Object.entries(filterConfig.options.customValue).forEach(([key, value])=>{
                    queryParams[key] = [
                        value
                    ];
                });
                // Use queryParams.set which handles option hydration via fetcher
                const hydratedFilter = await filterWithState.queryParams.set(queryParams);
                newFilterStates[filterConfig.filterId] = hydratedFilter.getState();
            }));
            if (Object.keys(newFilterStates).length > 0) {
                const { filterSelectionOrder: currentOrder } = getState();
                // Add new auto-applied filters to the order
                const updatedOrder = Object.keys(newFilterStates).reduce((order, filterId)=>$2b1419bc2c84719c$var$getUpdatedFilterSelectionOrder(order, filterId, newFilterStates[filterId]?.hasSelection), currentOrder);
                dispatch($2b1419bc2c84719c$var$privateStoreActions.setNewFilterStates({
                    ...allFilterStates,
                    ...newFilterStates
                }, undefined, updatedOrder));
            }
        },
    setSelectFilterLookupInput: (props)=>async ({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticSelectFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            const { selectedDatasource: selectedDatasource } = getState();
            if (!staticSelectFilter.isCompatible(filterState?.id) || !(0, $jbIQp.isSelectFilter)(staticSelectFilter.type)) return;
            const selectedSpaceAris = Array.isArray(allFiltersState?.space?.value) ? allFiltersState.space.value : config.initialSpaceARIs;
            const selectedContributorAccountIds = Array.isArray(allFiltersState?.contributor?.value) ? allFiltersState.contributor.value : config.contributorAccountIds;
            const extendedConfig = {
                ...config,
                selectedDatasource: selectedDatasource,
                initialSpaceARIs: selectedSpaceAris,
                contributorAccountIds: selectedContributorAccountIds
            };
            const filterWithState = staticSelectFilter.withState(filterState, extendedConfig);
            if ('setLookupInput' in filterWithState) await filterWithState.setLookupInput(props.query, (stateChange)=>{
                dispatch($2b1419bc2c84719c$var$privateStoreActions.setFilter(stateChange));
            });
        },
    setBooleanFilterValue: (props, privateActions = $2b1419bc2c84719c$var$privateStoreActions)=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticBooleanFilter = allFilters[props.filterId];
            const allFiltersState = getState().filters;
            const filterState = allFiltersState[props.filterId];
            if (!staticBooleanFilter.isCompatible(filterState?.id)) return;
            if (staticBooleanFilter.type !== 'boolean') return;
            const newBooleanFilterState = staticBooleanFilter.withState(filterState, config).setValue(props.value).getState();
            dispatch(privateActions.setFilter(newBooleanFilterState, {
                shouldSetQueryParams: true,
                setSelectedProduct: props.options?.setSelectedProduct
            }));
            dispatch(privateActions.updateFilterSelectionOrder(props.filterId, newBooleanFilterState.hasSelection));
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                productResultCountMap: null
            }));
        },
    clearAllFilters: ()=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const { filters: allFilterStates } = getState();
            const staticFilters = Object.values(allFilters);
            const clearedFilters = $2b1419bc2c84719c$var$clearFilters(allFilterStates, staticFilters, config);
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                filters: clearedFilters,
                selectedProducts: [],
                filterSelectionOrder: [],
                wasContentClearedBySpaceChange: false
            }, {
                updateQueryParams: true
            }));
        },
    clearAllAvailableFilters: ()=>({ getState: getState, dispatch: dispatch }, { allFilters: allFilters, config: config })=>{
            const staticFilters = Object.values(allFilters);
            const { filters: allFilterStates } = getState();
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                filters: $2b1419bc2c84719c$var$clearFilters(allFilterStates, staticFilters, config),
                filterSelectionOrder: [],
                wasContentClearedBySpaceChange: false
            }, {
                updateQueryParams: true
            }));
        },
    // Product filter actions
    selectProductFilter: (productKey, datasource)=>({ getState: getState, dispatch: dispatch }, { thirdPartyConfigs: thirdPartyConfigs, allFilters: allFilters, config: config })=>{
            const { selectedProducts: selectedProducts, selectedDatasource: selectedDatasource, filters: filters, filterSelectionOrder: filterSelectionOrder } = getState();
            // Convert string datasource to object if needed for consistency
            const datasourceObject = typeof datasource === 'string' ? (0, $biQM6.getDatasourceFromId)(datasource, productKey, thirdPartyConfigs) : datasource;
            // Only return early if both product and datasource are the same
            if (productKey && selectedProducts.includes(productKey) && datasourceObject?.datasourceId === selectedDatasource?.datasourceId) return;
            const persistedFilters = {};
            // Persist selected universal filters if they are relevant to the selected product
            for (const [id, filter] of Object.entries(filters)){
                if (!filter) continue;
                if (filter.universal && filter.hasSelection && (!productKey || productKey && filter.products.includes(productKey) || // Universal filters should always be persisted for forge connectors
                productKey && (0, $8fNUp.isForgeConnectorProductKey)(productKey))) persistedFilters[id] = filter;
            }
            // Type is a universal filter, but type needs to be cleared if we're filtering away from Atlas
            // This is because selecting a global noun sets product AND type values
            if (selectedProducts.includes((0, $dvVWp.ProductKeys).Atlas)) delete persistedFilters[0, $4ysB6.universalTypeFilterId];
            const newSelectedProducts = productKey ? [
                productKey
            ] : [];
            // Clear web-page type filter when navigating away from Web Pages
            if ((0, $cJff5.serveWebPagesInTypeFilter)()) {
                const currentTypeFilter = filters[0, $4ysB6.universalTypeFilterId];
                const isWebPageTypeSelected = currentTypeFilter?.type === 'single-select' && currentTypeFilter?.value?.includes((0, $7ydfN.TypeFilterValueKey).WebPage);
                if (isWebPageTypeSelected) // When user clicks "All" or selects any product, clear the web-page type
                delete persistedFilters[0, $4ysB6.universalTypeFilterId];
            }
            // Universal filters being persisted also retain their ordering
            const newFilterSelectionOrder = filterSelectionOrder.filter((f)=>{
                return Object.keys(persistedFilters).includes(f);
            });
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                selectedProducts: newSelectedProducts,
                selectedDatasource: datasourceObject,
                filterSelectionOrder: newFilterSelectionOrder,
                filters: persistedFilters,
                resultsSort: $2b1419bc2c84719c$export$d4c72bab9d6cc13a.resultsSort,
                wasContentClearedBySpaceChange: false
            }, {
                updateQueryParams: true
            }));
        },
    unselectProductFilter: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$export$e324594224ef24da.selectProductFilter(undefined));
        },
    // Search Input Actions
    setInputQuery: (inputQuery)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                inputQuery: inputQuery.trim()
            }));
        },
    setSearchQuery: (searchQuery)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                searchQuery: searchQuery.trim()
            }, {
                updateQueryParams: true
            }));
        },
    triggerSearch: ()=>({ getState: getState, dispatch: dispatch })=>{
            const { inputQuery: inputQuery, searchQuery: searchQuery, retryCount: retryCount, productResultCountMap: productResultCountMap } = getState();
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                productResultCountMap: searchQuery === inputQuery ? productResultCountMap : null,
                wasContentClearedBySpaceChange: false
            }));
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                searchQuery: inputQuery,
                retryCount: searchQuery === inputQuery ? retryCount + 1 : 0
            }, {
                updateQueryParams: true
            }));
        },
    retrySearch: ()=>({ dispatch: dispatch, getState: getState })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                retryCount: getState().retryCount + 1
            }));
        },
    // Sorting actions
    setSortField: (sortField)=>({ dispatch: dispatch, getState: getState })=>{
            const { resultsSort: resultsSort } = getState();
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                resultsSort: {
                    ...resultsSort,
                    field: sortField
                },
                paginationTokens: []
            }));
        },
    setSortOrder: (sortOrder)=>({ dispatch: dispatch, getState: getState })=>{
            const { resultsSort: resultsSort } = getState();
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                resultsSort: {
                    ...resultsSort,
                    order: sortOrder
                },
                paginationTokens: []
            }));
        },
    resetSort: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                resultsSort: $2b1419bc2c84719c$export$d4c72bab9d6cc13a.resultsSort,
                paginationTokens: []
            }));
        },
    // Rest of Search Actions
    setQueryUpdatedTime: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                queryUpdatedTime: Date.now()
            }));
        },
    resetQueryVersion: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                queryVersion: 0
            }));
        },
    incrementQueryVersion: ()=>({ getState: getState, setState: setState })=>{
            const { queryVersion: queryVersion } = getState();
            setState({
                queryVersion: queryVersion + 1
            });
        },
    setIsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                isLoading: isLoading
            }));
        },
    // Results actions
    setResults: (results, error, requestId, traceId)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                isLoading: false,
                results: results,
                resultError: error,
                requestId: requestId,
                traceId: traceId,
                wasContentClearedBySpaceChange: false
            }));
        },
    appendMoreResults: (results)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: currentResults } = getState();
            if (!currentResults || !results) return;
            const currentEdges = currentResults.edges;
            const newEdges = results.edges;
            const newResults = {
                ...currentResults,
                edges: currentEdges.concat(newEdges),
                pageInfo: results?.pageInfo
            };
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                results: newResults,
                isLoadingMore: false
            }));
        },
    setFetchFromCursor: (cursor)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                paginationTokens: [
                    {
                        cursor: cursor
                    }
                ]
            }));
        },
    setIsLoadingMore: (isLoadingMore)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                isLoadingMore: isLoadingMore
            }));
        },
    setJiraIssueFieldsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                isJiraHydrationLoading: isLoading
            }));
        },
    setJiraIssueDetails: (issueData)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: results } = getState();
            let hydratedResults = [];
            if (results?.edges && results.edges.length > 0 && issueData.length > 0) {
                // TODO: fix colorName being passed twice with inconsistent values, see the unit test for context
                hydratedResults = [
                    ...results.edges
                ].map((edge)=>{
                    if ((0, $imUxN.isSearchResultJiraIssue)(edge.node)) {
                        const id = edge.node.id;
                        const hydratedIssue = issueData.find((issue)=>issue.id === id);
                        if (edge.node.status && hydratedIssue) {
                            edge.node.status.name = hydratedIssue.statusField.status.name;
                            edge.node.status.colorName = hydratedIssue.statusField.status.statusCategory?.colorName;
                        }
                    }
                    return edge;
                });
                dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                    results: {
                        ...results,
                        edges: hydratedResults
                    }
                }));
            }
        },
    setCompassTeamsLoading: (isLoading)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                isCompassTeamsLoading: isLoading
            }));
        },
    setCompassTeams: (teamData)=>({ dispatch: dispatch, getState: getState })=>{
            const { results: results } = getState();
            let resultsWithTeamNames = [];
            if (results?.edges && results.edges.length > 0 && teamData.length > 0) {
                resultsWithTeamNames = [
                    ...results.edges
                ].map((edge)=>{
                    if ((0, $51pfw.isSearchCompassPartial)(edge.node)) {
                        const teamId = (0, $c3mkK.getTeamId)(edge.node.ownerId);
                        const team = teamData.find((team)=>team.id === teamId);
                        edge.node.ownerName = team?.displayName;
                    }
                    return edge;
                });
                dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                    results: {
                        ...results,
                        edges: resultsWithTeamNames
                    }
                }));
            }
        },
    resetResults: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                isLoading: false,
                shownCount: 0,
                results: undefined,
                resultError: undefined,
                requestId: undefined,
                wasContentClearedBySpaceChange: false
            }));
        },
    setAutoCorrection: (autoCorrection)=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                autoCorrection: autoCorrection
            }));
        },
    setLeapQuery: ({ candidates: candidates, titleIndex: titleIndex, loading: loading })=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                leapQuery: {
                    loading: loading,
                    candidates: candidates,
                    titleIndex: titleIndex
                }
            }));
        },
    setProductResultCount: (totalCounts)=>({ dispatch: dispatch, getState: getState })=>{
            if (totalCounts === undefined) {
                dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                    productResultCountMap: null
                }));
                return;
            }
            const { filters: filterStates, availableProducts: availableProducts, productResultCountMap: oldProductResultCountMap } = getState();
            const filtersWithSelection = Object.values(filterStates).filter((filter)=>filter?.hasSelection);
            const productsCorrespondingToAllSelectedFilters = filtersWithSelection.length ? availableProducts.filter((product)=>filtersWithSelection.every((filter)=>filter?.products?.includes(product))) : availableProducts;
            const resultsCountsAdjustedForSelectedFilters = totalCounts.map((resultCount)=>{
                if (productsCorrespondingToAllSelectedFilters.includes(resultCount.product)) return resultCount;
                else return {
                    ...resultCount,
                    count: 0
                };
            });
            const productResultCountMap = resultsCountsAdjustedForSelectedFilters.reduce((acc, { product: product, count: count })=>{
                if (product) acc[product] = count;
                return acc;
            }, {});
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                productResultCountMap: {
                    ...oldProductResultCountMap,
                    ...productResultCountMap
                }
            }));
        },
    // For backwards compatibility
    clearHybridFilters: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$export$e324594224ef24da.clearAllFilters());
        },
    /**
   * TODO: QS-9329: Persist auto-applied filters when selecting
   * * Projects (type=project & product=townsquare)
   * * Goals (type=goal & product=townsquare)
   * in the right rail.
   *
   * More information: https://product-fabric.atlassian.net/browse/QS-9329
   *
   * Considered unsafe since it's using queryParams to change the state.
   * Ideally we should set it directly in the state, but that requires introducing a new action.
   * This is because the cooresponding "Type" filter that this selects isn't available or easy to set from outside
   * The product=townsquare&type=project will correctly hydrate the filter from the URL after params are set though!
   *
   * We hope to improve Atlassian Home / global noun handling after GA
   *
   * The last modified and contributors filters are explicitly kept in the query params because they are universal.
   * Type is also a universal filter, but we couple the type with the product to determine which Townsquare results to show.
   *
   * @param value: a noun to be set
   */ unsafe_setAtlasNouns: (value)=>({ dispatch: dispatch }, { queryParams: queryParams, setQueryParams: setQueryParams })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                productResultCountMap: null
            }));
            if (!value) {
                const { product: _, type: __, ...queryParamsWithResetNounFilter } = queryParams;
                setQueryParams({
                    ...queryParamsWithResetNounFilter
                });
            } else {
                const { text: text, originalQuery: originalQuery, lastModified: lastModified, contributors: contributors } = queryParams;
                // We explicitly only keep text, last modified and contributors
                setQueryParams({
                    product: (0, $dvVWp.ProductKeys).Atlas,
                    type: value,
                    text: text,
                    originalQuery: originalQuery,
                    lastModified: lastModified,
                    contributors: contributors
                });
            }
        },
    /**
   * * TODO: QS-9329: Persist auto-applied filters when selecting
   * Web Pages (type=web-page & product=atlassian-web-crawler) in the right rail
   * or type=web-page in horizontal filters.
   *
   * More information: https://product-fabric.atlassian.net/browse/QS-9329
   *
   * Similar to unsafe_setAtlasNouns, this directly manipulates URL query params
   * to set the Type filter to "web-page".
   */ unsafe_setWebPageType: ()=>({ dispatch: dispatch }, { queryParams: queryParams, setQueryParams: setQueryParams })=>{
            if (!(0, $cJff5.serveWebPagesInTypeFilter)()) {
                // Control cohort: use the old behavior by selecting AtlassianWebCrawler product
                dispatch($2b1419bc2c84719c$export$e324594224ef24da.selectProductFilter((0, $dvVWp.ProductKeys).AtlassianWebCrawler));
                return;
            }
            // Test cohort: use the new behavior by setting type = 'web-page' in the URL
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                productResultCountMap: null
            }));
            const { text: text, originalQuery: originalQuery, lastModified: lastModified, contributors: contributors } = queryParams;
            setQueryParams({
                product: (0, $dvVWp.ProductKeys).AtlassianWebCrawler,
                type: (0, $7ydfN.TypeFilterValueKey).WebPage,
                text: text,
                originalQuery: originalQuery,
                lastModified: lastModified,
                contributors: contributors
            });
        },
    setRequestedBackendExperiments: (requestedBackendExperiments)=>({ setState: setState })=>{
            const experimentLayers = requestedBackendExperiments?.experimentLayers?.map((layer)=>{
                const { analyticsDefinitions: analyticsDefinitions, ...rest } = layer;
                return {
                    ...rest,
                    definitions: analyticsDefinitions
                };
            });
            setState({
                requestedBackendExperiments: {
                    experimentLayers: experimentLayers
                }
            });
        },
    setJsmIncidentFilterIds: (jsmIncidentFilterIds)=>({ getState: getState, setState: setState })=>{
            if (getState().jsmIncidentFilterIds === jsmIncidentFilterIds) return;
            setState({
                jsmIncidentFilterIds: jsmIncidentFilterIds
            });
        },
    /*
   * This action is only triggered by QF but the value of filterDropdownOpen is only used by FPS
   * This means we need to update query param to make it available to FPS
   * That's why updateQueryParams is set to 'true'
   *
   * We only call it for clearing and the "set" value would be handled by onNavigate
   * */ unsetFilterDropdownOpen: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$setSearchStoreState({
                filterDropdownOpenByQueryParam: false
            }, {
                updateQueryParams: true
            }));
        }
};
const $2b1419bc2c84719c$var$clearFilters = (allFilterStates, filters, config)=>{
    const clearedFilters = filters.map((filter)=>{
        const filterState = allFilterStates[filter.id];
        // Clear all does not clear the multi-site selector
        if (filter.id === (0, $8JYuM.siteFilterId) && (0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
            primaryProduct: config.primaryProduct,
            fireExperimentExposure: false
        })) return filterState ? [
            filter.id,
            filterState
        ] : [];
        if (!filter.isCompatible(filterState?.id)) return [];
        return [
            filter.id,
            filter.withState(filterState, config).clear().getState()
        ];
    });
    return Object.fromEntries(clearedFilters);
};
// Keep store private and use hooks to access state and actions
const $2b1419bc2c84719c$var$Store = (0, $8s9DV.createStore)({
    initialState: $2b1419bc2c84719c$export$d4c72bab9d6cc13a,
    actions: $2b1419bc2c84719c$export$e324594224ef24da,
    name: 'search'
});
const $2b1419bc2c84719c$export$b8f9c0e048639dd4 = (0, $kBr4q.createActionsHook)($2b1419bc2c84719c$var$Store);
const $2b1419bc2c84719c$export$bf072992274c9fb = (0, $j8on0.createContainer)($2b1419bc2c84719c$var$Store, {
    onInit: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$privateStoreActions.initialiseStore());
        },
    onUpdate: ()=>({ dispatch: dispatch })=>{
            dispatch($2b1419bc2c84719c$var$privateStoreActions.updateStore());
        },
    onCleanup: ()=>({ setState: setState })=>{
            setState($2b1419bc2c84719c$export$d4c72bab9d6cc13a);
        }
});
const $2b1419bc2c84719c$export$bd221a7c56b93941 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store);
const $2b1419bc2c84719c$export$c5a5afdff2ff0385 = (0, $kBr4q.createActionsHook)($2b1419bc2c84719c$var$Store);
const $2b1419bc2c84719c$export$5fd14fa624074d55 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state, cb)=>cb(state)
});
const $2b1419bc2c84719c$export$973ca22476b0e05f = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.filters
});
const $2b1419bc2c84719c$export$da992673b1309795 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.inputQuery
});
const $2b1419bc2c84719c$export$59d1399255ff1d16 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.experience
});
const $2b1419bc2c84719c$export$e985158d10c27e34 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.searchQuery
});
const $2b1419bc2c84719c$export$c2380c4d76e63cc4 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.originalQuery
});
const $2b1419bc2c84719c$export$ba2ad669c5b27bca = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.autoCorrection
});
const $2b1419bc2c84719c$export$140d37088821fcb1 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.retryCount
});
const $2b1419bc2c84719c$export$275c72361969d62c = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.productResultCountMap
});
const $2b1419bc2c84719c$export$14279a3fbdb52451 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.results?.abTest
});
const $2b1419bc2c84719c$export$34418e307d9100b4 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.results?.queryInfo
});
const $2b1419bc2c84719c$export$8a4c65ea4f241b48 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.searchQuery ? (0, $6yu7A.QueryState).POSTQUERY : (0, $6yu7A.QueryState).PREQUERY
});
const $2b1419bc2c84719c$export$a2b38489a4538322 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.queryUpdatedTime
});
const $2b1419bc2c84719c$export$bda9ac73817ceec3 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.results
});
const $2b1419bc2c84719c$export$1c9622ace43d770d = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.resultError
});
const $2b1419bc2c84719c$export$49f5dec896c355cd = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.requestId
});
const $2b1419bc2c84719c$export$944245f24d4ef0b6 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.traceId
});
const $2b1419bc2c84719c$export$4dface15d86304a4 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.isLoading
});
const $2b1419bc2c84719c$export$f59185497e80e274 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.resultsSort
});
const $2b1419bc2c84719c$export$e2d0c00df99a687c = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.queryVersion
});
const $2b1419bc2c84719c$export$5f38673942a99ffe = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.allFilterExcludedProducts
});
const $2b1419bc2c84719c$export$3bc2682926916b14 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.wasContentClearedBySpaceChange
});
const $2b1419bc2c84719c$export$1e51d2073b60bd88 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.results,
        (state)=>state.isLoading,
        (state)=>state.resultError
    ], (results, isLoading, resultError)=>$2b1419bc2c84719c$export$71923aa45c7aa566({
            results: results,
            isLoading: isLoading,
            resultError: resultError
        }))
});
const $2b1419bc2c84719c$export$71923aa45c7aa566 = ({ results: results, isLoading: isLoading, resultError: resultError })=>{
    if (isLoading) return (0, $lDiEy.ResultsStates).IS_LOADING;
    if (results && results.edges && results.edges.length > 0) return (0, $lDiEy.ResultsStates).RESULTS;
    // If there are no entities for a query, an error will throw
    // when no entities for query is equivalent to no results
    if (resultError instanceof (0, $c59181be2ffd57d8$export$8ba86dff7c04c14c) || results && (results.edges ?? []).length === 0) return (0, $lDiEy.ResultsStates).NO_RESULTS;
    if (resultError) return (0, $lDiEy.ResultsStates).ERROR;
    if (!results) return (0, $lDiEy.ResultsStates).INITIAL;
    return (0, $lDiEy.ResultsStates).ERROR;
};
const $2b1419bc2c84719c$export$826bdf756a8bf13a = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.selectedProducts
});
const $2b1419bc2c84719c$export$387e1da2bc9c93cc = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.selectedProducts[0]
});
const $2b1419bc2c84719c$export$e87eda20cc6e50c2 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.selectedDatasource
});
const $2b1419bc2c84719c$export$8c11ef422551818 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.isJiraHydrationLoading
});
const $2b1419bc2c84719c$export$795623048d841bf2 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.isCompassTeamsLoading
});
const $2b1419bc2c84719c$export$8dc083eb9766b48 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.availableProducts && state.availableProducts.length > 0
});
const $2b1419bc2c84719c$export$e80788222dba30a3 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.results?.pageInfo?.endCursor
});
const $2b1419bc2c84719c$export$bedf78a7ab879711 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.paginationTokens[0]?.cursor
});
const $2b1419bc2c84719c$export$f258398dab7c75ba = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.isLoadingMore
});
const $2b1419bc2c84719c$export$964e8498268f0fe3 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.selectedProducts,
        (state)=>state.availableProducts
    ], (selectedProducts, availableProducts)=>{
        return {
            selectedProduct: selectedProducts[0],
            filteredProducts: selectedProducts[0] ? [
                selectedProducts[0]
            ] : availableProducts,
            availableProducts: availableProducts
        };
    })
});
const $2b1419bc2c84719c$export$59086fbf0d8f8d2a = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (0, $fjHkB.createSelector)([
        (state)=>state.availableProducts,
        (state)=>state.selectedProducts,
        (state)=>state.allFilterExcludedProducts,
        (state)=>state.filters[0, $4ysB6.universalTypeFilterId],
        (_, props)=>props
    ], (availableProducts, selectedProducts, allFilterExcludedProducts, typeFilter, props)=>{
        const { thirdPartyConfigs: thirdPartyConfigs } = props;
        // Filter out excluded products from "All" filter
        const allFilterIncludedProducts = availableProducts.filter((product)=>!allFilterExcludedProducts.includes(product));
        const productsToSearch = selectedProducts[0] ? [
            selectedProducts[0]
        ] : allFilterIncludedProducts;
        return (0, $h6X6L.getUniversalTypeEntities)(productsToSearch, typeFilter, thirdPartyConfigs, availableProducts, selectedProducts);
    })
});
const $2b1419bc2c84719c$export$aad641f503e4b4a8 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state, props)=>{
        const filter = state.filters[props.filterId];
        if (filter === undefined) return undefined;
        if (!(filter.type === 'multi-select' || filter.type === 'single-select')) throw new Error('Not a select filter');
        return {
            ...filter,
            selectedProducts: state.selectedProducts,
            availableProducts: state.availableProducts,
            allFilterExcludedProducts: state.allFilterExcludedProducts,
            primaryProduct: state.primaryProduct,
            experience: state.experience
        };
    }
});
const $2b1419bc2c84719c$export$c724ec2cbd2fedce = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state, props)=>{
        const filter = state.filters[props.filterId];
        if (filter === undefined) return undefined;
        if (filter?.type !== 'boolean') throw new Error('Not a boolean filter');
        return {
            ...filter,
            selectedProducts: state.selectedProducts,
            primaryProduct: state.primaryProduct
        };
    }
});
const $2b1419bc2c84719c$export$1c5018e1c1ce99ae = (filters)=>{
    const filterIdOrdering = (0, $4ysB6.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        return filter && filter.universal ? [
            filter
        ] : [];
    });
};
const $2b1419bc2c84719c$export$546f6564ce5d0a17 = (filters, primaryProduct)=>{
    const filterIdOrdering = (0, $4ysB6.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        return filter && filter.products.find((relevantProductFilter)=>relevantProductFilter === primaryProduct) ? [
            filter
        ] : [];
    });
};
const $2b1419bc2c84719c$export$a8734449e402b6ca = (filters, selectedProducts)=>{
    const filterIdOrdering = (0, $4ysB6.getFilterIdOrdering)();
    return filterIdOrdering.flatMap((f)=>{
        const filter = filters[f];
        // Universal filters should always be shown for forge connectors
        // This is needed because forge connectors are dynamically loaded and not in the static products list
        if (filter && filter.universal && selectedProducts.some((0, $8fNUp.isForgeConnectorProductKey))) return [
            filter
        ];
        if (filter && f === 'content' && selectedProducts.includes((0, $dvVWp.ProductKeys).ConfluenceDC)) return (0, $iDrrr.fg)('confluence-dc-content-filter') ? [
            filter
        ] : [];
        else return filter && selectedProducts.some((product)=>filter?.products.includes(product)) ? [
            filter
        ] : [];
    });
};
/**
 * All available filters in the initial ordering
 * Configurable based on the primary product - this is the case for QF filters
 */ const $2b1419bc2c84719c$var$getAllAvailableFilters = (filters, selectedProducts, config)=>{
    if (config?.basedOnPrimaryProduct && config?.primaryProduct) return (0, $c3cgJ.isAllProductSearch)(selectedProducts) ? $2b1419bc2c84719c$export$546f6564ce5d0a17(filters, config?.primaryProduct) : $2b1419bc2c84719c$export$a8734449e402b6ca(filters, selectedProducts);
    return (0, $c3cgJ.isAllProductSearch)(selectedProducts) ? $2b1419bc2c84719c$export$1c5018e1c1ce99ae(filters) : $2b1419bc2c84719c$export$a8734449e402b6ca(filters, selectedProducts);
};
/**
 * All available filters are always returned for inline, but the ordering depends on selection
 * The caller UI is responsible for deciding how many can be rendered by available width
 */ const $2b1419bc2c84719c$var$getFilterIdsForInline = (filters, selectedProducts, filterSelectionOrder, config)=>{
    const allAvailableFilterIds = $2b1419bc2c84719c$var$getAllAvailableFilters(filters, selectedProducts, config).map((a)=>a.id);
    // using the selection order, filter from the available (removes any invalid filters to show)
    const filtersForInline = filterSelectionOrder.filter((f)=>allAvailableFilterIds.includes(f));
    // Filters with no selections can also be prioritised based on the props
    const filtersPrioritised = config?.prioritisedFilterIds?.filter((f)=>allAvailableFilterIds.includes(f)) ?? [];
    // then simply add the rest back (with a set for deduplication)
    const inline = [
        ...new Set([
            ...filtersForInline,
            ...filtersPrioritised,
            ...allAvailableFilterIds
        ])
    ];
    return inline;
};
const $2b1419bc2c84719c$export$94c94f88577d66b2 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: ({ filters: filters, selectedProducts: selectedProducts, filterSelectionOrder: filterSelectionOrder }, config)=>{
        // Apply exclusion + inclusion rules (single source of truth for filter visibility):
        // excluded filters are hidden from both the inline filter row and the dropdown list.
        // setSearchStoreState clears their underlying selection in the same write so the store
        // stays in sync with what is visible/applied to URL/GraphQL/badge count.
        const excludedFilterIds = (0, $4abb27497bf1f895$export$8848759bd942e213)(selectedProducts[0], filters);
        const isExcluded = (id)=>excludedFilterIds.has(id);
        // All filters always show in the dropdown, in order (minus excluded)
        const filtersInDropdown = $2b1419bc2c84719c$var$getAllAvailableFilters(filters, selectedProducts, config).map((f)=>f.id).filter((id)=>!isExcluded(id));
        const filtersInLine = $2b1419bc2c84719c$var$getFilterIdsForInline(filters, selectedProducts, filterSelectionOrder, config).filter((id)=>!isExcluded(id));
        return {
            filtersInDropdown: filtersInDropdown,
            filtersInLine: filtersInLine,
            filterSelectionOrder: filterSelectionOrder
        };
    }
});
const $2b1419bc2c84719c$export$754cc306c2d9241e = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: ({ selectedProducts: selectedProducts, filters: filters, resultsSort: resultsSort, primaryProduct: primaryProduct })=>{
        // Apply exclusion + inclusion rules (single source of truth for filter visibility):
        // excluded filters do not contribute to the badge count. setSearchStoreState
        // clears their underlying selection so the store stays in sync.
        const excludedFilterIds = (0, $4abb27497bf1f895$export$8848759bd942e213)(selectedProducts[0], filters);
        const isMultiSiteSearchEnabled = (0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
            primaryProduct: primaryProduct,
            fireExperimentExposure: false
        });
        const selectedFilters = Object.values(filters).filter((filter)=>filter?.hasSelection).filter((filter)=>filter && !excludedFilterIds.has(filter.id))// The multi-site selector is not part of the filter count (+N badge on the dropdown filter button)
        .filter((filter)=>!(isMultiSiteSearchEnabled && filter?.id === (0, $8JYuM.siteFilterId))).filter((filter)=>{
            const isAtlasSelected = selectedProducts.includes((0, $dvVWp.ProductKeys).Atlas);
            const isTypeFilter = filter?.id === (0, $4ysB6.universalTypeFilterId);
            if ((0, $cJff5.serveWebPagesInTypeFilter)()) // Subtract 1 from selectedFilterCount when Atlas OR WebCrawler is selected as one of the
            // filters won't be displayed to the user
            return !isTypeFilter ? true : !selectedProducts.includes((0, $dvVWp.ProductKeys).Atlas) && !selectedProducts.includes((0, $dvVWp.ProductKeys).AtlassianWebCrawler);
            return isAtlasSelected ? !isTypeFilter : true;
        });
        const { field: field } = resultsSort;
        const isNotSortedByDefault = field !== (0, $3yJeH.SORT_FIELD_KEY).RELEVANCE;
        return {
            selectedFilterCount: selectedFilters.length + (isNotSortedByDefault ? 1 : 0)
        };
    }
});
const $2b1419bc2c84719c$export$a63314038bf0cbf9 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: ({ filters: filters })=>{
        const filterAttributes = Object.values(filters).flatMap((filter)=>{
            return filter ? [
                filter
            ] : [];
        }).map((filter)=>{
            const filterType = filter.type;
            switch(filterType){
                case 'boolean':
                    return {
                        filters: [
                            filter.id
                        ],
                        filterSelections: filter.value ? [
                            {
                                value: (0, $0023915a6e6a3533$export$931e138580bca877)(filter.id, String(filter.value)),
                                isSmartDefault: false,
                                filterId: filter.id
                            }
                        ] : []
                    };
                case 'multi-select':
                case 'single-select':
                    return {
                        filters: [
                            filter.id
                        ],
                        filterSelections: filter.options.filter((filterOption)=>filterOption.isSelected).map((filterOption)=>({
                                value: (0, $0023915a6e6a3533$export$931e138580bca877)(filter.id, filterOption.trackingKey || filterOption.value),
                                isSmartDefault: filterOption.isSuggested,
                                filterId: filter.id
                            }))
                    };
                default:
                    return filterType;
            }
        }).filter((attributes)=>attributes.filterSelections.length).reduce((acc, curr)=>{
            return {
                filters: [
                    ...acc.filters,
                    ...curr.filters
                ],
                filterSelections: [
                    ...acc.filterSelections,
                    ...curr.filterSelections
                ]
            };
        }, {
            filters: [],
            filterSelections: []
        });
        return filterAttributes;
    }
});
const $2b1419bc2c84719c$export$33ca33de08a5b6bb = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: ({ cql: cql })=>cql
});
const $2b1419bc2c84719c$export$210935c1afa2c65c = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: ({ selectedProducts: selectedProducts, filters: filters, primaryProduct: primaryProduct }, props = {
        includeSelectedProduct: true
    })=>{
        const hasSelectedProduct = selectedProducts[0];
        if (hasSelectedProduct && props.includeSelectedProduct) return true;
        const isMultiSiteSearchEnabled = (0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
            primaryProduct: primaryProduct,
            fireExperimentExposure: false
        });
        // Clear all button is not displayed if only the site selector is applied
        return Object.values(filters).some((filter)=>filter?.hasSelection && !(isMultiSiteSearchEnabled && filter?.id === (0, $8JYuM.siteFilterId)));
    }
});
const $2b1419bc2c84719c$export$1f88edaa1bb97b87 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: ({ leapQuery: leapQuery })=>leapQuery
});
const $2b1419bc2c84719c$export$64ea42df9468ccc0 = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>({
            backendExperiments: state.requestedBackendExperiments
        })
});
const $2b1419bc2c84719c$export$5ce42807c47ad171 = (0, $kBr4q.createStateHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>state.jsmIncidentFilterIds
});
const $2b1419bc2c84719c$export$fce7b0e4e0dda8ee = (0, $kBr4q.createHook)($2b1419bc2c84719c$var$Store, {
    selector: (state)=>{
        return state.filterDropdownOpenByQueryParam;
    }
});
module.exports["initialState"] = $2b1419bc2c84719c$export$d4c72bab9d6cc13a;
module.exports["SearchStoreContainer"] = $2b1419bc2c84719c$export$bf072992274c9fb;
module.exports["useSearch"] = $2b1419bc2c84719c$export$bd221a7c56b93941;
module.exports["useSearchActions"] = $2b1419bc2c84719c$export$c5a5afdff2ff0385;
module.exports["useSearchState"] = $2b1419bc2c84719c$export$5fd14fa624074d55;
module.exports["useFilters"] = $2b1419bc2c84719c$export$973ca22476b0e05f;
module.exports["useInputQuery"] = $2b1419bc2c84719c$export$da992673b1309795;
module.exports["useSearchExperience"] = $2b1419bc2c84719c$export$59d1399255ff1d16;
module.exports["useSearchQuery"] = $2b1419bc2c84719c$export$e985158d10c27e34;
module.exports["useRetryCount"] = $2b1419bc2c84719c$export$140d37088821fcb1;
module.exports["useQueryUpdatedTime"] = $2b1419bc2c84719c$export$a2b38489a4538322;
module.exports["useResults"] = $2b1419bc2c84719c$export$bda9ac73817ceec3;
module.exports["useResultsError"] = $2b1419bc2c84719c$export$1c9622ace43d770d;
module.exports["useResultsRequestId"] = $2b1419bc2c84719c$export$49f5dec896c355cd;
module.exports["useIsLoading"] = $2b1419bc2c84719c$export$4dface15d86304a4;
module.exports["useResultsSort"] = $2b1419bc2c84719c$export$f59185497e80e274;
module.exports["useQueryVersion"] = $2b1419bc2c84719c$export$e2d0c00df99a687c;
module.exports["useWasContentClearedBySpaceChange"] = $2b1419bc2c84719c$export$3bc2682926916b14;
module.exports["useResultsState"] = $2b1419bc2c84719c$export$1e51d2073b60bd88;
module.exports["useSelectedProducts"] = $2b1419bc2c84719c$export$826bdf756a8bf13a;
module.exports["useSelectedProduct"] = $2b1419bc2c84719c$export$387e1da2bc9c93cc;
module.exports["useSelectedDatasource"] = $2b1419bc2c84719c$export$e87eda20cc6e50c2;
module.exports["useIsJiraHydrationLoading"] = $2b1419bc2c84719c$export$8c11ef422551818;
module.exports["useIsSearchReady"] = $2b1419bc2c84719c$export$8dc083eb9766b48;
module.exports["useTypeEntities"] = $2b1419bc2c84719c$export$59086fbf0d8f8d2a;
module.exports["useSelectFilterStore"] = $2b1419bc2c84719c$export$aad641f503e4b4a8;
module.exports["useBooleanFilterStore"] = $2b1419bc2c84719c$export$c724ec2cbd2fedce;
module.exports["useFiltersToDisplay"] = $2b1419bc2c84719c$export$94c94f88577d66b2;
module.exports["useSelectedFilterCount"] = $2b1419bc2c84719c$export$754cc306c2d9241e;
module.exports["useFilterAttributesForTracking"] = $2b1419bc2c84719c$export$a63314038bf0cbf9;
module.exports["useCQL"] = $2b1419bc2c84719c$export$33ca33de08a5b6bb;
module.exports["useAnyFilterSelected"] = $2b1419bc2c84719c$export$210935c1afa2c65c;
module.exports["useRequestedBackendExperiments"] = $2b1419bc2c84719c$export$64ea42df9468ccc0;
module.exports["useJsmIncidentFilterIds"] = $2b1419bc2c84719c$export$5ce42807c47ad171;
module.exports["useFilterDropdownOpenByQueryParam"] = $2b1419bc2c84719c$export$fce7b0e4e0dda8ee;

});

parcelRegister("3yJeH", function(module, exports) {
const $2cec2822a71f660c$export$fdf34174678f07b6 = {
    RELEVANCE: 'relevance',
    LAST_MODIFIED_DATE: 'latestModifiedDate',
    CREATED_DATE: 'createdDate'
};
const $2cec2822a71f660c$export$d33cb9b119034d29 = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $2cec2822a71f660c$var$SORT_FIELD_KEY_RELEVANCE_DESC = `${$2cec2822a71f660c$export$fdf34174678f07b6.RELEVANCE}${$2cec2822a71f660c$export$d33cb9b119034d29.DESC}`;
const $2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC = `${$2cec2822a71f660c$export$fdf34174678f07b6.LAST_MODIFIED_DATE}${$2cec2822a71f660c$export$d33cb9b119034d29.DESC}`;
const $2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC = `${$2cec2822a71f660c$export$fdf34174678f07b6.LAST_MODIFIED_DATE}${$2cec2822a71f660c$export$d33cb9b119034d29.ASC}`;
const $2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_DESC = `${$2cec2822a71f660c$export$fdf34174678f07b6.CREATED_DATE}${$2cec2822a71f660c$export$d33cb9b119034d29.DESC}`;
const $2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_ASC = `${$2cec2822a71f660c$export$fdf34174678f07b6.CREATED_DATE}${$2cec2822a71f660c$export$d33cb9b119034d29.ASC}`;
const $2cec2822a71f660c$export$6b492fdcc7e8d1f4 = {
    [$2cec2822a71f660c$var$SORT_FIELD_KEY_RELEVANCE_DESC]: {
        field: $2cec2822a71f660c$export$fdf34174678f07b6.RELEVANCE,
        order: $2cec2822a71f660c$export$d33cb9b119034d29.DESC,
        labelKey: $2cec2822a71f660c$var$SORT_FIELD_KEY_RELEVANCE_DESC,
        selectedLabelKey: `${$2cec2822a71f660c$var$SORT_FIELD_KEY_RELEVANCE_DESC}Selected`,
        drawerOrder: 0
    },
    [$2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC]: {
        field: $2cec2822a71f660c$export$fdf34174678f07b6.LAST_MODIFIED_DATE,
        order: $2cec2822a71f660c$export$d33cb9b119034d29.DESC,
        labelKey: $2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC,
        selectedLabelKey: `${$2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_DESC}Selected`,
        drawerOrder: 1
    },
    [$2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC]: {
        field: $2cec2822a71f660c$export$fdf34174678f07b6.LAST_MODIFIED_DATE,
        order: $2cec2822a71f660c$export$d33cb9b119034d29.ASC,
        labelKey: $2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC,
        selectedLabelKey: `${$2cec2822a71f660c$var$SORT_FIELD_KEY_LAST_MODIFIED_DATE_ASC}Selected`,
        drawerOrder: 2
    },
    [$2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_DESC]: {
        field: $2cec2822a71f660c$export$fdf34174678f07b6.CREATED_DATE,
        order: $2cec2822a71f660c$export$d33cb9b119034d29.DESC,
        labelKey: $2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_DESC,
        selectedLabelKey: `${$2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_DESC}Selected`,
        drawerOrder: 3
    },
    [$2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_ASC]: {
        field: $2cec2822a71f660c$export$fdf34174678f07b6.CREATED_DATE,
        order: $2cec2822a71f660c$export$d33cb9b119034d29.ASC,
        labelKey: $2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_ASC,
        selectedLabelKey: `${$2cec2822a71f660c$var$SORT_FIELD_KEY_CREATED_DATE_ASC}Selected`,
        drawerOrder: 4
    }
};
const $2cec2822a71f660c$export$76673e1b214c1378 = Object.values($2cec2822a71f660c$export$6b492fdcc7e8d1f4).sort((a, b)=>a.drawerOrder - b.drawerOrder);
const $2cec2822a71f660c$export$d3cbda30e53df6f6 = (field, order)=>`${field}${order}`;
module.exports["SORT_FIELD_KEY"] = $2cec2822a71f660c$export$fdf34174678f07b6;
module.exports["SORT_ORDER"] = $2cec2822a71f660c$export$d33cb9b119034d29;
module.exports["RESULTS_SORT_FIELDS"] = $2cec2822a71f660c$export$6b492fdcc7e8d1f4;

});

parcelRegister("1Qme9", function(module, exports) {
/* eslint-disable @atlaskit/platform/use-recommended-utils */ 
var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

/**
 * Products that support multi-site search. Kept as literals rather than importing a product-key
 * enum so that this stays usable from every search package.
 */ const $86b0a51e5ff11063$var$MULTI_SITE_SEARCH_PRODUCTS = [
    'confluence',
    'jira'
];
const $86b0a51e5ff11063$export$feb2c22b30a0e873 = ({ primaryProduct: primaryProduct, fireExperimentExposure: fireExperimentExposure = true } = {})=>{
    if (!primaryProduct || !$86b0a51e5ff11063$var$MULTI_SITE_SEARCH_PRODUCTS.includes(primaryProduct)) return false;
    if (!(0, $iDrrr.fg)('rovo_fps_enable_multi_site_search')) return false;
    return (0, $cXtTj.default).getExperimentValue('rovo_fps_multi_site_search_exp', 'cohort', 'control', {
        fireExperimentExposure: fireExperimentExposure
    }) === 'test';
};
const $86b0a51e5ff11063$export$3428da9dca9c8449 = ({ primaryProduct: primaryProduct } = {})=>{
    if (!primaryProduct || !$86b0a51e5ff11063$var$MULTI_SITE_SEARCH_PRODUCTS.includes(primaryProduct)) return false;
    // The M2 experiment cohort check will be added once the experiment is configured.
    return (0, $iDrrr.fg)('rovo_fps_enable_multi_site_search_m2');
};
module.exports["serveFpsMultiSiteSearchExperiment"] = $86b0a51e5ff11063$export$feb2c22b30a0e873;

});

parcelRegister("e0v3Z", function(module, exports) {

var $eVK28 = parcelRequire("eVK28");

const $e68e3cbc9acf5db8$export$e9131c78c1110376 = (str)=>(0, $eVK28.sha256)(str);
module.exports["sha256Hash"] = $e68e3cbc9acf5db8$export$e9131c78c1110376;

});

parcelRegister("lDiEy", function(module, exports) {
const $d88562a6863f5691$export$cdcda2a8fcb980fa = {
    NO_RESULTS: 'noResults',
    INITIAL: 'initial',
    RESULTS: 'results',
    ERROR: 'error',
    IS_LOADING: 'isLoading'
};
module.exports["ResultsStates"] = $d88562a6863f5691$export$cdcda2a8fcb980fa;

});

parcelRegister("c3mkK", function(module, exports) {

var $iJxD8 = parcelRequire("iJxD8");


var $5AmSa = parcelRequire("5AmSa");

const $4333343926bce73a$export$e8eac31981efe1fb = (ari)=>{
    let teamId = null;
    if (!ari) return teamId;
    const isTeamsAri = (0, $5AmSa.TeamsTeamAri).check(ari);
    const isIdentityTeamsAri = (0, $iJxD8.IdentityTeamAri).check(ari);
    if (isTeamsAri) teamId = (0, $5AmSa.TeamsTeamAri).parse(ari).teamId;
    else if (isIdentityTeamsAri) teamId = (0, $iJxD8.IdentityTeamAri).parse(ari).teamId;
    if (teamId === 'unidentified') teamId = null;
    return teamId;
};
module.exports["getTeamId"] = $4333343926bce73a$export$e8eac31981efe1fb;

});

parcelRegister("8JYuM", function(module, exports) {
/**
 * Lightweight filter ID constants extracted from individual filter modules.
 *
 * These are simple string constants with zero transitive dependencies.
 * Use these instead of importing from the filter barrel file (index.tsx)
 * when you only need the filter ID for keying into a filters record.
 *
 * QS-9423: Breaking the dependency chain that dragged react-sweet-state
 * into the SSR bundle via filter barrel → filter controllers → search store.
 */ const $2ac1b9b51a795567$export$741d3c5ff1600fc4 = 'archived';
const $2ac1b9b51a795567$export$98981f5c8dc7607d = 'compassArchived';
const $2ac1b9b51a795567$export$798f70d5ba74d109 = 'assetsSchema';
const $2ac1b9b51a795567$export$51661d1a93f29640 = 'assetsType';
const $2ac1b9b51a795567$export$9c1e246329cdf939 = 'assignee';
const $2ac1b9b51a795567$export$e32111e9166eaf89 = 'closeDate';
const $2ac1b9b51a795567$export$9af0987cf592f533 = 'commentedByMe';
const $2ac1b9b51a795567$export$6a3fc832c5c25c7d = 'content';
const $2ac1b9b51a795567$export$e03d97f0eaa66910 = 'contributor';
const $2ac1b9b51a795567$export$9ab819519540cfb4 = 'createdBy';
const $2ac1b9b51a795567$export$cd646dbb07979a8d = 'focusAreaType';
const $2ac1b9b51a795567$export$2678e5eb1f9db396 = 'focusAreaUnder';
const $2ac1b9b51a795567$export$623d400c5f880682 = 'label';
const $2ac1b9b51a795567$export$7ecf570078da6b1c = 'lastUpdatedBy';
const $2ac1b9b51a795567$export$11e1218ac07ed03e = 'lastUpdated';
const $2ac1b9b51a795567$export$68c1310fa8b7db62 = 'campaignStatus';
const $2ac1b9b51a795567$export$6598f3f01335d547 = 'caseStatus';
const $2ac1b9b51a795567$export$3ce8ff7a271ec50 = 'documentStatus';
const $2ac1b9b51a795567$export$123079b08beba778 = 'calendarType';
const $2ac1b9b51a795567$export$1334b09cd7315981 = 'leadStatus';
const $2ac1b9b51a795567$export$cffc11c79d20b86c = 'taskStatus';
const $2ac1b9b51a795567$export$1c425911806204b2 = 'taskType';
const $2ac1b9b51a795567$export$4febaaf9b7a72ca9 = 'opportunityStatus';
const $2ac1b9b51a795567$export$c21586a37554cc74 = 'pullRequestStatus';
const $2ac1b9b51a795567$export$2e6de80282206ac4 = 'repository';
const $2ac1b9b51a795567$export$219dbc6f14c3fa64 = 'reviewer';
const $2ac1b9b51a795567$export$f42198825b45f0bf = 'owner';
const $2ac1b9b51a795567$export$bcfaf48394705893 = 'pageStatus';
const $2ac1b9b51a795567$export$713c4dadb56593e7 = 'positionEmploymentType';
const $2ac1b9b51a795567$export$d87a0f934d4a8c3c = 'positionFocusArea';
const $2ac1b9b51a795567$export$19dab386a6b200ee = 'positionJobFamily';
const $2ac1b9b51a795567$export$f75b5006a4fc44bc = 'positionStatus';
const $2ac1b9b51a795567$export$4c1df8b2cfbc878 = 'positionTeam';
const $2ac1b9b51a795567$export$9e360b05ef07f438 = 'project';
const $2ac1b9b51a795567$export$58bc8a3e7def8aea = 'reporter';
const $2ac1b9b51a795567$export$3515d33a163cbcb3 = 'salesforceStage';
const $2ac1b9b51a795567$export$4f9240015ff0684c = 'sort';
const $2ac1b9b51a795567$export$3a6305d8320c16a4 = 'space';
const $2ac1b9b51a795567$export$523eec4c8a60c037 = 'site';
const $2ac1b9b51a795567$export$2a46d5fba7ab443f = 'statusFilter';
const $2ac1b9b51a795567$export$89b94a9f6bd9eece = 'onlyTitleMatch';
const $2ac1b9b51a795567$export$b698e15dd0654a6b = 'verified';
const $2ac1b9b51a795567$export$883e178bcc42a97b = 'watchedByMe';
const $2ac1b9b51a795567$export$26517625dab3ad98 = 'slackChannel';
const $2ac1b9b51a795567$export$c11f86df99674975 = 'folder';
const $2ac1b9b51a795567$export$1bb4d8ad1dbc2bac = 'workspaceName';
const $2ac1b9b51a795567$export$4d0145e3d3f3e249 = 'hasAttachment';
module.exports["archivedFilterId"] = $2ac1b9b51a795567$export$741d3c5ff1600fc4;
module.exports["archivedAndPendingComponentsFilterId"] = $2ac1b9b51a795567$export$98981f5c8dc7607d;
module.exports["assetsSchemaFilterId"] = $2ac1b9b51a795567$export$798f70d5ba74d109;
module.exports["assetsTypeFilterId"] = $2ac1b9b51a795567$export$51661d1a93f29640;
module.exports["assigneeFilterId"] = $2ac1b9b51a795567$export$9c1e246329cdf939;
module.exports["closeDateFilterId"] = $2ac1b9b51a795567$export$e32111e9166eaf89;
module.exports["commentedByMeFilterId"] = $2ac1b9b51a795567$export$9af0987cf592f533;
module.exports["contentFilterId"] = $2ac1b9b51a795567$export$6a3fc832c5c25c7d;
module.exports["contributorFilterId"] = $2ac1b9b51a795567$export$e03d97f0eaa66910;
module.exports["createdByFilterId"] = $2ac1b9b51a795567$export$9ab819519540cfb4;
module.exports["focusAreaTypeFilterId"] = $2ac1b9b51a795567$export$cd646dbb07979a8d;
module.exports["focusAreaUnderFilterId"] = $2ac1b9b51a795567$export$2678e5eb1f9db396;
module.exports["labelFilterId"] = $2ac1b9b51a795567$export$623d400c5f880682;
module.exports["lastUpdatedByFilterId"] = $2ac1b9b51a795567$export$7ecf570078da6b1c;
module.exports["lastUpdatedFilterId"] = $2ac1b9b51a795567$export$11e1218ac07ed03e;
module.exports["campaignStatusFilterId"] = $2ac1b9b51a795567$export$68c1310fa8b7db62;
module.exports["caseStatusFilterId"] = $2ac1b9b51a795567$export$6598f3f01335d547;
module.exports["documentStatusFilterId"] = $2ac1b9b51a795567$export$3ce8ff7a271ec50;
module.exports["calendarTypeFilterId"] = $2ac1b9b51a795567$export$123079b08beba778;
module.exports["leadStatusFilterId"] = $2ac1b9b51a795567$export$1334b09cd7315981;
module.exports["taskStatusFilterId"] = $2ac1b9b51a795567$export$cffc11c79d20b86c;
module.exports["taskTypeFilterId"] = $2ac1b9b51a795567$export$1c425911806204b2;
module.exports["opportunityStatusFilterId"] = $2ac1b9b51a795567$export$4febaaf9b7a72ca9;
module.exports["pullRequestStatusFilterId"] = $2ac1b9b51a795567$export$c21586a37554cc74;
module.exports["repositoryFilterId"] = $2ac1b9b51a795567$export$2e6de80282206ac4;
module.exports["reviewerFilterId"] = $2ac1b9b51a795567$export$219dbc6f14c3fa64;
module.exports["ownerFilterId"] = $2ac1b9b51a795567$export$f42198825b45f0bf;
module.exports["pageStatusFilterId"] = $2ac1b9b51a795567$export$bcfaf48394705893;
module.exports["positionEmploymentTypeFilterId"] = $2ac1b9b51a795567$export$713c4dadb56593e7;
module.exports["positionFocusAreaFilterId"] = $2ac1b9b51a795567$export$d87a0f934d4a8c3c;
module.exports["positionJobFamilyFilterId"] = $2ac1b9b51a795567$export$19dab386a6b200ee;
module.exports["positionStatusFilterId"] = $2ac1b9b51a795567$export$f75b5006a4fc44bc;
module.exports["positionTeamFilterId"] = $2ac1b9b51a795567$export$4c1df8b2cfbc878;
module.exports["projectFilterId"] = $2ac1b9b51a795567$export$9e360b05ef07f438;
module.exports["reporterFilterId"] = $2ac1b9b51a795567$export$58bc8a3e7def8aea;
module.exports["salesforceStageFilterId"] = $2ac1b9b51a795567$export$3515d33a163cbcb3;
module.exports["sortFilterId"] = $2ac1b9b51a795567$export$4f9240015ff0684c;
module.exports["spaceFilterId"] = $2ac1b9b51a795567$export$3a6305d8320c16a4;
module.exports["siteFilterId"] = $2ac1b9b51a795567$export$523eec4c8a60c037;
module.exports["statusFilterId"] = $2ac1b9b51a795567$export$2a46d5fba7ab443f;
module.exports["titleMatchFilterId"] = $2ac1b9b51a795567$export$89b94a9f6bd9eece;
module.exports["verifiedFilterId"] = $2ac1b9b51a795567$export$b698e15dd0654a6b;
module.exports["watchedFilterId"] = $2ac1b9b51a795567$export$883e178bcc42a97b;
module.exports["slackChannelFilterId"] = $2ac1b9b51a795567$export$26517625dab3ad98;
module.exports["folderFilterId"] = $2ac1b9b51a795567$export$c11f86df99674975;
module.exports["workspaceNameFilterId"] = $2ac1b9b51a795567$export$1bb4d8ad1dbc2bac;
module.exports["hasAttachmentFilterId"] = $2ac1b9b51a795567$export$4d0145e3d3f3e249;

});

parcelRegister("hea5O", function(module, exports) {
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $iDrrr = parcelRequire("iDrrr");


var $XRj3F = parcelRequire("XRj3F");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");


var $4wG6Y = parcelRequire("4wG6Y");


var $gPOtu = parcelRequire("gPOtu");


var $cJff5 = parcelRequire("cJff5");

/**
 * Gets 3P products that support a given filter, using the consolidated
 * ThirdPartyConfigs from rovo-connectors-config.
 *
 * This is intentionally in a separate file from filters/index.ts to avoid
 * pulling the 3P configs (and their icon-laden config files) into the
 * generateSearchInputs bundle. This file is only imported by UI filter
 * components, not by the generateSearchInputs call path.
 */ 
var $fd0l2 = parcelRequire("fd0l2");

const $c194c673aa4ee214$export$ef6dfb919b1d7267 = (filterId)=>{
    const productsForFilter = [];
    (0, $fd0l2.ThirdPartyConfigsSync).forEach((config, productKey3P)=>{
        if (config.filters?.includes(filterId)) productsForFilter.push(productKey3P);
    });
    return productsForFilter;
};



var $dEA4Z = parcelRequire("dEA4Z");





const $f7c0c65da85b02e9$var$DEFAULT_ENTITY_SUBTYPES = {
    [(0, $7ydfN.TypeFilterValueKey).Document]: [
        (0, $7ydfN.NounSubtypeKey).Document,
        (0, $7ydfN.NounSubtypeKey).Pdf
    ],
    [(0, $7ydfN.TypeFilterValueKey).Spreadsheet]: [
        (0, $7ydfN.NounSubtypeKey).Spreadsheet
    ],
    [(0, $7ydfN.TypeFilterValueKey).Presentation]: [
        (0, $7ydfN.NounSubtypeKey).Presentation
    ],
    [(0, $7ydfN.TypeFilterValueKey).Video]: [
        (0, $7ydfN.NounSubtypeKey).Video
    ],
    [(0, $7ydfN.TypeFilterValueKey).Design]: [
        (0, $7ydfN.NounSubtypeKey).Design
    ],
    [(0, $7ydfN.TypeFilterValueKey).Conversation]: [],
    [(0, $7ydfN.TypeFilterValueKey).Message]: [],
    // Comment filter should map to the comment subtype to avoid returning unrelated results
    // (e.g. web pages) for products that don't have an explicit typeFilterConfig for comments
    [(0, $7ydfN.TypeFilterValueKey).Comment]: [
        (0, $7ydfN.NounSubtypeKey).Comment
    ],
    [(0, $7ydfN.TypeFilterValueKey).Image]: [
        (0, $7ydfN.NounSubtypeKey).Image
    ],
    [(0, $7ydfN.TypeFilterValueKey).Audio]: [
        (0, $7ydfN.NounSubtypeKey).Audio
    ],
    [(0, $7ydfN.TypeFilterValueKey).Pdf]: [
        (0, $7ydfN.NounSubtypeKey).Pdf
    ],
    [(0, $7ydfN.TypeFilterValueKey).Code]: [
        (0, $7ydfN.NounSubtypeKey).Code
    ],
    [(0, $7ydfN.TypeFilterValueKey).Archive]: [
        (0, $7ydfN.NounSubtypeKey).Archive
    ],
    [(0, $7ydfN.TypeFilterValueKey).Folder]: [
        (0, $7ydfN.NounSubtypeKey).Folder
    ],
    [(0, $7ydfN.TypeFilterValueKey).Shortcut]: [
        (0, $7ydfN.NounSubtypeKey).Shortcut
    ],
    [(0, $7ydfN.TypeFilterValueKey).Form]: [
        (0, $7ydfN.NounSubtypeKey).Form
    ],
    [(0, $7ydfN.TypeFilterValueKey).Notebook]: [
        (0, $7ydfN.NounSubtypeKey).Notebook
    ],
    [(0, $7ydfN.TypeFilterValueKey).Other]: [
        (0, $7ydfN.NounSubtypeKey).Other
    ],
    [(0, $7ydfN.TypeFilterValueKey).WebPage]: [
        (0, $7ydfN.NounSubtypeKey).WebPage
    ],
    [(0, $7ydfN.TypeFilterValueKey).Dashboard]: [
        (0, $7ydfN.NounSubtypeKey).Dashboard
    ],
    [(0, $7ydfN.TypeFilterValueKey).Database]: [
        (0, $7ydfN.NounSubtypeKey).Database
    ]
};
const $f7c0c65da85b02e9$export$b7b676578c62639d = ()=>({
        commonFilters: {},
        confluenceFilters: {
            spacesFilter: [],
            contributorsFilter: [],
            ancestorIdsFilter: [],
            range: [],
            owners: [],
            labelsFilter: [],
            titleMatchOnly: false,
            contentStatuses: [],
            containerStatus: []
        },
        assetsFilters: {
            objectSchemaFilter: {
                schemaARIs: []
            },
            objectTypeFilter: {
                typeARIs: []
            }
        },
        jiraFilters: {
            issueFilter: {
                assigneeARIs: [],
                reporterARIs: [],
                commenterARIs: [],
                projectARIs: [],
                issueTypeIDs: [],
                issueLabels: [],
                issueTypes: [],
                statusCategories: [],
                watcherARIs: []
            }
        },
        mercuryFilters: {
            owners: [],
            focusAreaTypeIds: [],
            ancestorIds: []
        },
        talentFilters: {
            owners: [],
            employmentTypes: [],
            focusAreas: [],
            jobFamilies: [],
            statuses: [],
            teams: []
        },
        compassFilters: {
            componentFilter: {
                componentStates: []
            }
        },
        thirdPartyFilters: {
            titleMatchOnly: false,
            subtypes: [],
            integrations: [],
            createdBy: [],
            lastUpdatedBy: [],
            assignees: [],
            labels: []
        },
        sortFilters: []
    });
const $f7c0c65da85b02e9$var$DATE_RANGE_PRESETS = [
    {
        name: 'today',
        fromOffset: 0,
        toOffset: 0
    },
    {
        name: 'yesterday',
        fromOffset: 1,
        toOffset: 1
    },
    {
        name: 'past7Days',
        fromOffset: 7,
        toOffset: 0
    },
    {
        name: 'past30Days',
        fromOffset: 30,
        toOffset: 0
    },
    {
        name: 'pastYear',
        fromOffset: 365,
        toOffset: 0
    }
];
/**
 * Gets a UTC date string (YYYY-MM-DD) for a given number of days ago.
 * Uses UTC timezone to match backend date calculations.
 */ const $f7c0c65da85b02e9$var$getUTCDateString = (daysAgo)=>{
    const now = new Date();
    const utcDate = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() - daysAgo));
    return utcDate.toISOString().split('T')[0];
};
const $f7c0c65da85b02e9$export$64e54565c5bfc685 = (dateRange)=>{
    if (!dateRange || !dateRange.gt && !dateRange.lt) return 'anytime';
    if (!dateRange.gt) return 'custom';
    const inputGtDate = dateRange.gt.split('T')[0];
    const inputLtDate = dateRange.lt?.split('T')[0];
    for (const preset of $f7c0c65da85b02e9$var$DATE_RANGE_PRESETS){
        const presetGtDate = $f7c0c65da85b02e9$var$getUTCDateString(preset.fromOffset);
        const presetLtDate = $f7c0c65da85b02e9$var$getUTCDateString(preset.toOffset);
        if (inputGtDate === presetGtDate) {
            // If BE has also provided lt, it must match the preset's lt for this to be the preset.
            // E.g. gt='2026-02-01', lt='2026-02-03' is a custom range (Feb 1–3), not past7Days
            if (inputLtDate != null && inputLtDate !== presetLtDate) continue;
            return preset.name;
        }
    }
    return 'custom';
};
const $f7c0c65da85b02e9$var$isSupportedParticipant = (participant)=>{
    const { users: users, combination: combination, type: type } = participant;
    if (type !== 'PRESENCE') return false;
    if (users.length > 1 && combination === 'AND') return false;
    return true;
};
const $f7c0c65da85b02e9$export$ae993d8ff9dd28 = (participants)=>{
    const { items: items, combination: combination } = participants;
    if (items.length > 1 && combination === 'AND') return [];
    if (!items.every($f7c0c65da85b02e9$var$isSupportedParticipant)) return [];
    return Array.from(new Set(items.flatMap(({ users: users })=>users)));
};
const $f7c0c65da85b02e9$export$2703353a19002efe = ()=>{
    return {
        ...(0, $dEA4Z.baseIntegrationARIs)
    };
};
/**
 * Checks the product-specific feature gate for video noun filtering.
 * - Google Drive: controlled by 'rovo_fps_enable_video_noun_filter'
 * - SharePoint: always enabled
 * - Other products: returns false (not supported)
 */ const $f7c0c65da85b02e9$var$isVideoNounFilterEnabled = (product)=>{
    if (product === (0, $4wG6Y.ProductKey).GoogleDrive) return (0, $iDrrr.fg)('rovo_fps_enable_video_noun_filter');
    return product === (0, $4wG6Y.ProductKey).Sharepoint;
};
const $f7c0c65da85b02e9$var$buildGitFilters = (pullRequestStatus, repoName, reviewer)=>{
    if (!pullRequestStatus?.length && !repoName?.length && !reviewer?.length) return undefined;
    return {
        gitFilters: {
            ...pullRequestStatus?.length && {
                pullRequestStatus: pullRequestStatus
            },
            ...repoName?.length && {
                repoName: repoName
            },
            ...reviewer?.length && {
                reviewer: reviewer
            }
        }
    };
};
/**
 * Build MS Teams (`teamsFilters`) wire payload.
 * - `hasAttachment` (boolean): scopes Teams results to messages with attachments.
 * - `workspaceName` (string[]): `teamsFilters.workspaceName` — filters by workspace (team) name.
 *   Gated behind `rovo_fps_show_workspace_name_filter` on the frontend and
 *   `xpsearch-aggregator_teams_workspace_name_filter` on the backend.
 * Returns `undefined` when no Teams filter is set so the caller can spread without sending an empty object.
 */ const $f7c0c65da85b02e9$var$buildTeamsFilters = (hasAttachment, workspaceName)=>{
    if (!hasAttachment && !workspaceName?.length) return undefined;
    return {
        teamsFilters: {
            ...hasAttachment && {
                hasAttachment: true
            },
            ...workspaceName?.length && {
                workspaceName: workspaceName
            }
        }
    };
};
const $f7c0c65da85b02e9$var$filterConnectorSources = (product, isAllProductSearch, thirdPartyConfigs, connectorSources)=>{
    if (product === (0, $4wG6Y.ProductKey).Slack && (0, $cJff5.removeFedSlackFromAllProductSearch)(thirdPartyConfigs, isAllProductSearch)) // When a federated Slack connector exists in all-product search,
    // exclude both 'federated' and 'smartlinks' connector sources so that
    // only the federated connector serves results in that context.
    return connectorSources?.filter((s)=>s !== (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE) && (!(0, $iDrrr.fg)('ai_3p_slack_smartlinks_federated_connector_enabled') || s !== (0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE)));
    return connectorSources;
};
const $f7c0c65da85b02e9$var$getConnectorSourcesForRequest = (product, isAllProductSearch, thirdPartyConfigs, connectorSources)=>{
    const filteredConnectorSources = $f7c0c65da85b02e9$var$filterConnectorSources(product, isAllProductSearch, thirdPartyConfigs, connectorSources);
    const isEligibleGoogleDriveSmartlinksConnector = product === (0, $4wG6Y.ProductKey).GoogleDrive && filteredConnectorSources?.length === 1 && filteredConnectorSources[0] === (0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE) && thirdPartyConfigs[(0, $4wG6Y.ProductKey).GoogleDrive]?.userNeedsOAuth === false;
    if (isEligibleGoogleDriveSmartlinksConnector && (0, $cJff5.enableFederatedSearchForGoogleDrive)()) return [
        ...filteredConnectorSources,
        (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE)
    ];
    return filteredConnectorSources;
};
const $f7c0c65da85b02e9$var$hasConnectorSources = (product, isAllProductSearch, thirdPartyConfigs)=>{
    const connectorSources = thirdPartyConfigs[product]?.connectorSources;
    const filteredConnectorSources = $f7c0c65da85b02e9$var$filterConnectorSources(product, isAllProductSearch, thirdPartyConfigs, connectorSources);
    return (filteredConnectorSources?.length ?? 0) > 0;
};
const $f7c0c65da85b02e9$export$3766c9ce0c94452 = (products, titleMatchValue, // entities is the frontend filtered, already selected values
entities, thirdPartyConfigs, isAllProductSearch = true, range, assignees, containerAris, createdBy, lastUpdatedBy, ancestorAris, labels, additionalTexts, selectedDatasource, salesforceOwners, salesforceStage, salesforceCloseDate, opportunityStatus, pullRequestStatus, repoName, campaignStatuses, caseStatuses, slackChannels, hasAttachment, workspaceName, reviewer, knowledgeArticlePublishStatuses, eventTypes, leadStatuses, taskStatuses, taskTypes)=>{
    if (!products.length || products.some((p)=>(0, $dvVWp.is3pProductKey)(p) || (0, $8fNUp.isForgeConnectorProductKey)(p) || p === (0, $4wG6Y.ProductKey).Bitbucket)) {
        // Conditionally create the dynamic integration ARIs based on the config
        const integrationARIsFromConfig = $f7c0c65da85b02e9$export$2703353a19002efe();
        // Combine static and dynamic integration ARIs
        let productToIntegrationARIMap = integrationARIsFromConfig;
        // Add Forge connector integration ARIs from thirdPartyConfigs
        products.forEach((product)=>{
            if ((0, $8fNUp.isForgeConnectorProductKey)(product) && thirdPartyConfigs[product]) {
                const integrationAri = thirdPartyConfigs[product]?.integrationAri;
                productToIntegrationARIMap[product] = integrationAri;
            }
        });
        // Note: Bitbucket integration ARI is already included in baseIntegrationARIs
        // get the subtypes by looking at each type's subcategories
        let allSubtypes = [];
        let allContainerTypes = [];
        let thirdPartyProducts = [];
        const filteredProducts = products.filter((product)=>((0, $dvVWp.is3pProductKey)(product) || (0, $8fNUp.isForgeConnectorProductKey)(product)) && thirdPartyConfigs[product] !== undefined && (!thirdPartyConfigs[product]?.userNeedsOAuth || $f7c0c65da85b02e9$export$9c38ca92ec6e6d40(product, thirdPartyConfigs) || (0, $gPOtu.hasAdminImportedUserLink)(product, thirdPartyConfigs)) && !thirdPartyConfigs[product]?.isFederated && $f7c0c65da85b02e9$var$hasConnectorSources(product, isAllProductSearch, thirdPartyConfigs)).filter((product)=>{
            return thirdPartyConfigs[product]?.isEnabled?.();
        });
        // Products that support embedded comments (comments are returned as linkedEntities within documents)
        const productsWithEmbeddedComments = [
            (0, $4wG6Y.ProductKey).GoogleDrive,
            (0, $4wG6Y.ProductKey).Sharepoint
        ];
        // Skip code search (Document entity) unless GitHub is the only selected product. Aligned
        // with `includeGithubCode` in services/search-query-generator/index.ts so the entities payload
        // and the Relay `@include(if: $includeGithubCode)` directive can't diverge.
        const isOnlyGithubSelected = products.length === 1 && (0, $dvVWp.GITHUB_PRODUCT_KEYS).includes(products[0]);
        for (let product of filteredProducts){
            const thirdPartyConfig = thirdPartyConfigs[product];
            if (!thirdPartyConfig) continue;
            const isGithubProduct = (0, $dvVWp.GITHUB_PRODUCT_KEYS).includes(product);
            const shouldSkipDocumentForGithub = isGithubProduct && !isOnlyGithubSelected;
            let localSubtypes = [];
            let productEntities = [];
            let connectionIds;
            let linkedEntityGranularity;
            // Check if Comment filter is selected for a product that supports embedded comments.
            // Each product is gated behind its own feature flag so support can be toggled
            // independently:
            //   - Google Drive: enable_3p_embedded_comments_search
            //   - SharePoint:   rovo_fps_sharepoint_embedded_comments
            const isCommentFilterSelected = entities.includes((0, $7ydfN.TypeFilterValueKey).Comment);
            const isEmbeddedCommentsEnabledForProduct = product === (0, $4wG6Y.ProductKey).GoogleDrive && (0, $iDrrr.fg)('enable_3p_embedded_comments_search') || product === (0, $4wG6Y.ProductKey).Sharepoint && (0, $iDrrr.fg)('rovo_fps_sharepoint_embedded_comments');
            const supportsEmbeddedComments = productsWithEmbeddedComments.includes(product);
            if (isCommentFilterSelected && supportsEmbeddedComments && isEmbeddedCommentsEnabledForProduct) // Use ONLY_LINKED_ENTITIES to force match only on comments.
            // Note: linkedEntities input is deprecated and ignored by the aggregator —
            // linkedEntityGranularity alone controls this behaviour.
            linkedEntityGranularity = 'ONLY_LINKED_ENTITIES';
            // Check if the product has specific typeFilterConfig for the requested entities
            let hasMatchingTypeConfig = false;
            thirdPartyConfig.typeFilterConfig?.forEach((entitiesConfig, entityValue)=>{
                if (entities.includes(entityValue)) {
                    localSubtypes = [
                        ...localSubtypes,
                        ...entitiesConfig.subTypes3P
                    ];
                    hasMatchingTypeConfig = true;
                }
            });
            if ((0, $iDrrr.fg)('rovo-search-dynamic-forge-config')) {
                // Extract all entities from typeFilterConfig for this product
                if (thirdPartyConfig.typeFilterConfig) {
                    thirdPartyConfig.typeFilterConfig.forEach((entitiesConfig, entityValue)=>{
                        if (isCommentFilterSelected && supportsEmbeddedComments && isEmbeddedCommentsEnabledForProduct && entityValue === (0, $7ydfN.TypeFilterValueKey).Comment) return;
                        if (shouldSkipDocumentForGithub && entityValue === (0, $7ydfN.TypeFilterValueKey).Document) return;
                        const shouldFilterByType = $f7c0c65da85b02e9$var$isVideoNounFilterEnabled(product) && // entities.length > 0 ensures we only filter when specific types are selected;
                        // when "All" is selected, entities is empty and we fall through to the else branch
                        entities.length > 0;
                        if (shouldFilterByType) {
                            if (entities.includes(entityValue)) productEntities = [
                                ...productEntities,
                                ...entitiesConfig.entities3P
                            ];
                        } else // When entities is empty (All selected), include all entities from the config
                        productEntities = [
                            ...productEntities,
                            ...entitiesConfig.entities3P
                        ];
                    });
                    productEntities = [
                        ...new Set(productEntities)
                    ];
                }
                // Capture connectionId when present (dynamic Forge connectors)
                if (thirdPartyConfig.connectionId) connectionIds = [
                    thirdPartyConfig.connectionId
                ];
            } else if (thirdPartyConfig.typeFilterConfig && $f7c0c65da85b02e9$var$isVideoNounFilterEnabled(product)) {
                // For Google Drive and SharePoint: only include entities from type filter configs that match selected entities
                // This ensures entity ATI is only included when the corresponding type is selected
                thirdPartyConfig.typeFilterConfig.forEach((entitiesConfig, entityValue)=>{
                    if (isCommentFilterSelected && supportsEmbeddedComments && isEmbeddedCommentsEnabledForProduct && entityValue === (0, $7ydfN.TypeFilterValueKey).Comment) return;
                    if (shouldSkipDocumentForGithub && entityValue === (0, $7ydfN.TypeFilterValueKey).Document) return;
                    // Only include entities from type filter configs that match the selected entities
                    if (entities.includes(entityValue)) productEntities = [
                        ...productEntities,
                        ...entitiesConfig.entities3P
                    ];
                });
                productEntities = [
                    ...new Set(productEntities)
                ];
            }
            // If no specific typeFilterConfig matched, use default subtypes for the entities
            if (!hasMatchingTypeConfig && entities.length > 0) entities.forEach((entity)=>{
                const defaultSubtypes = $f7c0c65da85b02e9$var$DEFAULT_ENTITY_SUBTYPES[entity] ?? [];
                if (defaultSubtypes.length > 0) localSubtypes = [
                    ...localSubtypes,
                    ...defaultSubtypes
                ];
            });
            // Add local subtypes to the global subtypes array and remove duplicates
            allSubtypes = [
                ...new Set([
                    ...allSubtypes,
                    ...localSubtypes
                ])
            ];
            const integrationId = thirdPartyConfig.integrationAri;
            const providerId = thirdPartyConfig.providerId;
            const connectorSources = $f7c0c65da85b02e9$var$getConnectorSourcesForRequest(product, isAllProductSearch, thirdPartyConfigs, thirdPartyConfig.connectorSources);
            // Impersonation logging: surface, per connector source, which sources are served via
            // impersonation (user NOT OAuthed AND impersonation enabled for that source) so the
            // aggregator can observe impersonated request success/failure. Resolved per connector
            // source because a product can expose multiple sources where impersonation is only
            // enabled for some of them.
            const connectorSourcesImpersonationEnabled = $f7c0c65da85b02e9$export$9c38ca92ec6e6d40(product, thirdPartyConfigs) ? $f7c0c65da85b02e9$var$getImpersonatedConnectorSources(thirdPartyConfig, connectorSources) : undefined;
            product = product === (0, $4wG6Y.ProductKey).JsmDC ? (0, $4wG6Y.ProductKey).JiraDC : product;
            // Only fan out per-datasource when a specific datasource is selected, OR when
            // getFiltersForSelectedDatasources affects thirdPartyProduct routing (e.g. Jira DC
            // sets a per-instance integrationId/providerId). For webcrawler, when "All" is
            // selected, all datasource entries would be identical (same integrationId, same
            // filters) — causing N duplicate requests to the search backend. Instead, fall
            // through to the single-entry else branch below.
            const shouldFanOut = thirdPartyConfig.datasources && thirdPartyConfig.fanOutConnectorSources && (!!selectedDatasource || product !== (0, $dvVWp.ProductKeys).AtlassianWebCrawler);
            if (shouldFanOut && thirdPartyConfig.datasources) {
                const datasourcesForQuery = selectedDatasource ? thirdPartyConfig.datasources.filter((ds)=>ds.datasourceId === selectedDatasource) : thirdPartyConfig.datasources;
                for (const datasourceConfig of datasourcesForQuery){
                    const datasourceContainerTypes = datasourceConfig.containerTypes || [];
                    allContainerTypes = [
                        ...new Set([
                            ...allContainerTypes,
                            ...datasourceContainerTypes
                        ])
                    ];
                    const thirdPartyProductFilterForThisProduct = {
                        integrationId: integrationId,
                        subtypes: localSubtypes,
                        providerId: providerId,
                        product: product,
                        connectorSources: connectorSources,
                        ...connectorSourcesImpersonationEnabled && {
                            connectorSourcesImpersonationEnabled: connectorSourcesImpersonationEnabled
                        },
                        ...productEntities.length > 0 && {
                            entities: productEntities
                        },
                        ...connectionIds && {
                            connectionIds: connectionIds
                        },
                        ...linkedEntityGranularity && {
                            linkedEntityGranularity: linkedEntityGranularity
                        }
                    };
                    // For webcrawler (flag ON), getFiltersForSelectedDatasources returns only { additionalTexts }
                    // with no thirdPartyProduct key, so allFilters?.thirdPartyProduct is always undefined for
                    // webcrawler — the else branch always runs and additionalTexts is discarded here.
                    // The webcrawler's additionalTexts is correctly accumulated in the datasourceFilters loop below,
                    // making this call a no-op for webcrawler. Only thirdPartyProduct is consumed in this code path.
                    const allFilters = product !== (0, $dvVWp.ProductKeys).AtlassianWebCrawler || (0, $iDrrr.fg)('webcrawler-fanout-ui-sidebar-enabled') ? thirdPartyConfig.getFiltersForSelectedDatasources?.(datasourceConfig, {}) : undefined;
                    if (allFilters?.thirdPartyProduct) thirdPartyProducts.push({
                        ...thirdPartyProductFilterForThisProduct,
                        ...allFilters.thirdPartyProduct
                    });
                    else thirdPartyProducts.push(thirdPartyProductFilterForThisProduct);
                }
            } else thirdPartyProducts.push({
                integrationId: integrationId,
                subtypes: localSubtypes,
                providerId: providerId,
                product: product,
                connectorSources: connectorSources,
                ...connectorSourcesImpersonationEnabled && {
                    connectorSourcesImpersonationEnabled: connectorSourcesImpersonationEnabled
                },
                ...productEntities.length > 0 && {
                    entities: productEntities
                },
                ...connectionIds && {
                    connectionIds: connectionIds
                },
                ...linkedEntityGranularity && {
                    linkedEntityGranularity: linkedEntityGranularity
                }
            });
        }
        if (thirdPartyProducts) {
            // Add Loom and Bitbucket to the thirdPartyProducts filter
            const firstPartyProductsFor3pFilters = [
                (0, $4wG6Y.ProductKey).Loom,
                (0, $4wG6Y.ProductKey).Bitbucket
            ];
            const result = firstPartyProductsFor3pFilters.filter((product)=>products.includes(product) && !thirdPartyProducts?.some((p)=>p.product === product)).map((product)=>({
                    integrationId: productToIntegrationARIMap[product] || '',
                    subtypes: allSubtypes,
                    product: product,
                    connectorSources: [
                        (0, $8fNUp.FULL_CONNECTOR_SOURCE)
                    ]
                }));
            thirdPartyProducts = thirdPartyProducts.concat(result);
        }
        // Slack channels filter — Slack is a federated product, so it is excluded from the
        // `filteredProducts` loop above (federated products are filtered out). To pass selected
        // Slack channels to the aggregator, we attach them to a Slack `thirdPartyProducts` entry
        // here, either by mutating an existing entry (non-federated case) or by adding a new entry.
        if (slackChannels?.length) {
            const slackConfig = thirdPartyConfigs[(0, $4wG6Y.ProductKey).Slack];
            if (slackConfig) {
                const existingSlackEntry = thirdPartyProducts.find((p)=>p.product === (0, $4wG6Y.ProductKey).Slack);
                if (existingSlackEntry) existingSlackEntry.channels = slackChannels;
                else thirdPartyProducts.push({
                    integrationId: slackConfig.integrationAri || '',
                    subtypes: [],
                    providerId: slackConfig.providerId,
                    product: (0, $4wG6Y.ProductKey).Slack,
                    connectorSources: $f7c0c65da85b02e9$var$filterConnectorSources((0, $4wG6Y.ProductKey).Slack, isAllProductSearch, thirdPartyConfigs, slackConfig.connectorSources || []),
                    channels: slackChannels
                });
            }
        }
        const createdByFilterField = {
            createdBy: createdBy || []
        };
        const lastUpdatedByFilterField = {
            lastUpdatedBy: lastUpdatedBy || []
        };
        // Labels filter is only applicable to Confluence (incl. Confluence DC).
        const isConfluenceProduct = products.includes((0, $dvVWp.ProductKeys).Confluence) || products.includes((0, $dvVWp.ProductKeys).ConfluenceDC);
        const labelsFilterField = isConfluenceProduct ? {
            labels: labels || []
        } : {};
        const containerTypes = thirdPartyProducts.length !== 1 ? [] : allContainerTypes;
        const excludeSubtypes = [];
        const isTeamsProduct = products.includes((0, $dvVWp.ProductKeys).Teams);
        const isAttachmentTypeSelected = entities.includes((0, $7ydfN.TypeFilterValueKey).Attachment);
        const teamsFilters = $f7c0c65da85b02e9$var$buildTeamsFilters(isTeamsProduct && (isAttachmentTypeSelected || hasAttachment), isTeamsProduct ? workspaceName : undefined)?.teamsFilters;
        let datasourceFilters = {
            additionalTexts: additionalTexts || []
        };
        if (selectedDatasource) for (const product of filteredProducts){
            const thirdPartyConfig = thirdPartyConfigs[product];
            if (!thirdPartyConfig?.getFiltersForSelectedDatasources || !thirdPartyConfig.fanOutConnectorSources) continue;
            if (thirdPartyConfig.datasources) {
                const datasourceForQuery = thirdPartyConfig.datasources.find((ds)=>ds.datasourceId === selectedDatasource);
                if (datasourceForQuery) {
                    if (product !== (0, $dvVWp.ProductKeys).AtlassianWebCrawler || (0, $iDrrr.fg)('webcrawler-fanout-ui-sidebar-enabled')) datasourceFilters = thirdPartyConfig.getFiltersForSelectedDatasources(datasourceForQuery, datasourceFilters) ?? datasourceFilters;
                }
            }
        }
        const { additionalTexts: mergedAdditionalTexts = [], ...otherDatasourceFilters } = datasourceFilters;
        if (Object.keys(productToIntegrationARIMap).length !== 0) {
            const integrationARIs = products.filter((product)=>// Non-3P products pass through
                !(0, $dvVWp.is3pProductKey)(product) && !(0, $8fNUp.isForgeConnectorProductKey)(product) || // 3P products must be enabled and not require OAuth (or have impersonation)
                thirdPartyConfigs[product]?.isEnabled?.() !== false && (!thirdPartyConfigs[product]?.userNeedsOAuth || $f7c0c65da85b02e9$export$9c38ca92ec6e6d40(product, thirdPartyConfigs) || (0, $gPOtu.hasAdminImportedUserLink)(product, thirdPartyConfigs))).map((product)=>productToIntegrationARIMap[product]).filter((ari)=>!!ari)// remove duplicates (eg sharepoint, teams)
            .filter((ari, pos, arr)=>{
                return arr.indexOf(ari) === pos;
            })// Include Slack integration ARI only when Slack has at least one connector source (after filtering)
            .filter((ari)=>ari !== productToIntegrationARIMap[(0, $4wG6Y.ProductKey).Slack] || $f7c0c65da85b02e9$var$hasConnectorSources((0, $4wG6Y.ProductKey).Slack, isAllProductSearch, thirdPartyConfigs));
            // Build salesforceFilters if applicable
            const salesforceIsClosedValue = opportunityStatus ? (0, $XRj3F.OpportunityStatusFilterValue)[opportunityStatus] : undefined;
            const salesforceFilters = salesforceOwners?.length || salesforceStage?.length || salesforceCloseDate || opportunityStatus || campaignStatuses?.length || caseStatuses?.length || knowledgeArticlePublishStatuses?.length || eventTypes?.length || leadStatuses?.length || taskStatuses?.length || taskTypes?.length ? {
                ...salesforceOwners?.length && {
                    owners: salesforceOwners
                },
                ...salesforceStage?.length && {
                    stage: salesforceStage
                },
                ...salesforceCloseDate ? {
                    closeDate: salesforceCloseDate
                } : {},
                ...salesforceIsClosedValue !== undefined ? {
                    isClosed: salesforceIsClosedValue
                } : {},
                ...campaignStatuses?.length && {
                    campaignStatuses: campaignStatuses
                },
                ...caseStatuses?.length && {
                    caseStatuses: caseStatuses
                },
                ...knowledgeArticlePublishStatuses?.length && {
                    knowledgeArticlePublishStatuses: knowledgeArticlePublishStatuses
                },
                ...eventTypes?.length && {
                    eventTypes: eventTypes
                },
                ...leadStatuses?.length && {
                    leadStatuses: leadStatuses
                },
                ...taskStatuses?.length && {
                    taskStatuses: taskStatuses
                },
                ...taskTypes?.length && {
                    taskTypes: taskTypes
                }
            } : undefined;
            return {
                range: range,
                titleMatchOnly: titleMatchValue,
                subtypes: allSubtypes,
                integrations: integrationARIs,
                thirdPartyProducts: thirdPartyProducts,
                assignees: assignees,
                containerAris: containerAris || [],
                ...createdByFilterField,
                ...lastUpdatedByFilterField,
                ancestorAris: ancestorAris || [],
                ...labelsFilterField,
                additionalTexts: mergedAdditionalTexts.length > 0 ? mergedAdditionalTexts : additionalTexts || [],
                containerTypes: containerTypes,
                ...excludeSubtypes.length > 0 && {
                    excludeSubtypes: excludeSubtypes
                },
                ...salesforceFilters && {
                    salesforceFilters: salesforceFilters
                },
                ...$f7c0c65da85b02e9$var$buildGitFilters(pullRequestStatus, repoName, reviewer),
                ...teamsFilters && {
                    teamsFilters: teamsFilters
                },
                ...otherDatasourceFilters
            };
        } else {
            // Build salesforceFilters if applicable
            const salesforceIsClosedValue = opportunityStatus ? (0, $XRj3F.OpportunityStatusFilterValue)[opportunityStatus] : undefined;
            const salesforceFilters = salesforceOwners?.length || salesforceStage?.length || salesforceCloseDate || opportunityStatus || campaignStatuses?.length || caseStatuses?.length || knowledgeArticlePublishStatuses?.length || eventTypes?.length || leadStatuses?.length || taskStatuses?.length || taskTypes?.length ? {
                ...salesforceOwners?.length && {
                    owners: salesforceOwners
                },
                ...salesforceStage?.length && {
                    stage: salesforceStage
                },
                ...salesforceCloseDate ? {
                    closeDate: salesforceCloseDate
                } : {},
                ...salesforceIsClosedValue !== undefined ? {
                    isClosed: salesforceIsClosedValue
                } : {},
                ...campaignStatuses?.length && {
                    campaignStatuses: campaignStatuses
                },
                ...caseStatuses?.length && {
                    caseStatuses: caseStatuses
                },
                ...knowledgeArticlePublishStatuses?.length && {
                    knowledgeArticlePublishStatuses: knowledgeArticlePublishStatuses
                },
                ...eventTypes?.length && {
                    eventTypes: eventTypes
                },
                ...leadStatuses?.length && {
                    leadStatuses: leadStatuses
                },
                ...taskStatuses?.length && {
                    taskStatuses: taskStatuses
                },
                ...taskTypes?.length && {
                    taskTypes: taskTypes
                }
            } : undefined;
            return {
                range: range,
                titleMatchOnly: titleMatchValue,
                subtypes: allSubtypes,
                integrations: [],
                thirdPartyProducts: thirdPartyProducts,
                assignees: assignees,
                containerAris: containerAris || [],
                ...createdByFilterField,
                ...lastUpdatedByFilterField,
                ancestorAris: ancestorAris || [],
                ...labelsFilterField,
                additionalTexts: mergedAdditionalTexts.length > 0 ? mergedAdditionalTexts : additionalTexts || [],
                containerTypes: containerTypes,
                ...excludeSubtypes.length > 0 && {
                    excludeSubtypes: excludeSubtypes
                },
                ...salesforceFilters && {
                    salesforceFilters: salesforceFilters
                },
                ...$f7c0c65da85b02e9$var$buildGitFilters(pullRequestStatus, repoName, reviewer),
                ...teamsFilters && {
                    teamsFilters: teamsFilters
                },
                ...otherDatasourceFilters
            };
        }
    }
    return {
        titleMatchOnly: false,
        subtypes: [],
        integrations: []
    };
};
var $f7c0c65da85b02e9$export$b367612b2293421c = /*#__PURE__*/ function(DateRangeError) {
    DateRangeError["FROM_AFTER_TO_ERROR"] = "fromAfterToError";
    DateRangeError["FROM_IN_FUTURE_ERROR"] = "fromInFutureError";
    DateRangeError["TO_IN_FUTURE_ERROR"] = "toInFutureError";
    return DateRangeError;
}({});
const $f7c0c65da85b02e9$export$d3eb8baea7b2ff96 = (from, to)=>{
    if (!from && !to) return null;
    const dateFrom = new Date(`${from}${from ? 'T00:00:00' : ''}`);
    const dateTo = new Date(`${to}${to ? 'T00:00:00' : ''}`);
    const now = new Date();
    if (dateFrom > now) return "fromInFutureError";
    if (dateFrom > dateTo) return "fromAfterToError";
    if (dateTo > now) return "toInFutureError";
    return null;
};
const $f7c0c65da85b02e9$export$ef6dfb919b1d7267 = (0, $c194c673aa4ee214$export$ef6dfb919b1d7267);
const $f7c0c65da85b02e9$export$b29ea735dcfba3c1 = (value)=>{
    return value !== null && value !== undefined;
};
const $f7c0c65da85b02e9$export$9c38ca92ec6e6d40 = (product, thirdPartyConfigs)=>{
    const productConfig = thirdPartyConfigs[product];
    const impersonationEnabled = productConfig?.impersonationEnabled;
    return !!(impersonationEnabled && (product === (0, $4wG6Y.ProductKey).GoogleDrive || product === (0, $4wG6Y.ProductKey).Github && (0, $iDrrr.fg)('weaklink-github-fg') || product === (0, $4wG6Y.ProductKey).Teams && (0, $cJff5.serveTeamsImpersonatedSearchExpWithoutExposure)()));
};
/**
 * Derives the single connector source backing a datasource config, mirroring the resolution used
 * when building the product's `connectorSources` list (smartlinks / lite / federated / full).
 */ const $f7c0c65da85b02e9$var$getDatasourceConnectorSource = (datasource)=>{
    const resourceType = datasource.resourceType;
    // Without a resourceType the backing connector source cannot be determined, so contribute
    // nothing rather than guessing. This mirrors rovo-connectors-config's `getConnectorSources`,
    // which early-returns `[]` for this case, keeping both FPS/QF and agent-studio builders in sync.
    if (!resourceType) return undefined;
    if (resourceType.startsWith((0, $8fNUp.SMARTLINKS_RESOURCE_TYPE_PREFIX))) return 0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE;
    if (resourceType.startsWith((0, $8fNUp.LITE_CONNECTOR_SOURCE_PREFIX))) return 0, $8fNUp.LITE_CONNECTOR_SOURCE;
    // Slack federated status is driven by `connectorSyncType` rather than the static `isFederated`
    // flag. Mirror the canonical derivation in controllers/config/utils/third-party-products.ts so a
    // federated Slack datasource resolves to FEDERATED (not FULL). `connectorSyncType` is present on
    // the datasource at runtime (spread from the raw resource) but not on the typed config shape.
    if (datasource.id === (0, $dvVWp.ProductKeys).Slack && (0, $iDrrr.fg)('ai_3p_slack_connector_status_transition_enabled')) {
        const connectorSyncType = datasource.connectorSyncType;
        return connectorSyncType === 'federated' ? (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE) : (0, $8fNUp.FULL_CONNECTOR_SOURCE);
    }
    if (datasource.isFederated) return 0, $8fNUp.FEDERATED_CONNECTOR_SOURCE;
    return 0, $8fNUp.FULL_CONNECTOR_SOURCE;
};
/**
 * Returns the subset of `connectorSources` that are served via impersonation for this product.
 *
 * Impersonation is resolved per connector source (each backing datasource maps to a single
 * connector source) rather than at the product level, because a product can expose multiple
 * connector sources (e.g. `smartlinks` + `full-connector`) where impersonation is only enabled
 * for some of them. A connector source is considered impersonated when its datasource has the
 * user NOT OAuthed (`userNeedsOAuth === true`) AND impersonation enabled (`impersonationEnabled`).
 *
 * The result is restricted to sources actually present in the product's `connectorSources` and is
 * deduped while preserving the order of `connectorSources`. Returns `undefined` when no connector
 * source is impersonated.
 */ const $f7c0c65da85b02e9$var$getImpersonatedConnectorSources = (thirdPartyConfig, connectorSources)=>{
    if (!connectorSources?.length) return undefined;
    const impersonatedSources = new Set();
    const datasources = thirdPartyConfig.datasources?.length ? thirdPartyConfig.datasources : [
        thirdPartyConfig
    ];
    for (const datasource of datasources)if (datasource.userNeedsOAuth && datasource.impersonationEnabled) {
        const source = $f7c0c65da85b02e9$var$getDatasourceConnectorSource(datasource);
        if (source) impersonatedSources.add(source);
    }
    if (!impersonatedSources.size) return undefined;
    const result = connectorSources.filter((source)=>impersonatedSources.has(source));
    return result.length ? result : undefined;
};
module.exports["getEmptySelectedFilters"] = $f7c0c65da85b02e9$export$b7b676578c62639d;
module.exports["getThirdPartyFilters"] = $f7c0c65da85b02e9$export$3766c9ce0c94452;
module.exports["isImpersonationEnabled"] = $f7c0c65da85b02e9$export$9c38ca92ec6e6d40;
module.exports["DateRangeError"] = $f7c0c65da85b02e9$export$b367612b2293421c;
module.exports["getInvalidDateRange"] = $f7c0c65da85b02e9$export$d3eb8baea7b2ff96;
module.exports["getProducts3PFromConfigForFilter"] = $f7c0c65da85b02e9$export$ef6dfb919b1d7267;
module.exports["notEmpty"] = $f7c0c65da85b02e9$export$b29ea735dcfba3c1;

});

parcelRegister("dEA4Z", function(module, exports) {
/**
 * Static integration ARI mapping extracted for SSR bundle isolation.
 * No icon, config, or React imports — just pure string constants.
 *
 * This replaces the dynamic getIntegrationARIsFromConfig() function which
 * iterated ThirdPartyConfigs (pulling in 66 icon-laden config files).
 *
 * The baseIntegrationARIs map is the single source of truth for
 * ProductKey → integration ARI mappings. filters/index.ts imports and
 * re-exports from here.
 */ 
var $4wG6Y = parcelRequire("4wG6Y");

// 3P Integration ARIs
const $b49aac7b02131b1c$var$GOOGLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/google';
const $b49aac7b02131b1c$var$MICROSOFT_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $b49aac7b02131b1c$var$WEB_CRAWLER_INTEGRATION_ARI = 'ari:cloud:platform::integration/atlassian-web-crawler';
const $b49aac7b02131b1c$var$GITHUB_INTEGRATION_ARI = 'ari:cloud:platform::integration/github';
const $b49aac7b02131b1c$var$FIGMA_INTEGRATION_ARI = 'ari:cloud:platform::integration/figma';
const $b49aac7b02131b1c$var$LOOM_INTEGRATION_ARI = 'ari:cloud:platform::integration/loom';
const $b49aac7b02131b1c$var$DROPBOX_INTEGRATION_ARI = 'ari:cloud:platform::integration/dropbox';
const $b49aac7b02131b1c$var$AIRTABLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/airtable';
const $b49aac7b02131b1c$var$SMARTSHEET_INTEGRATION_ARI = 'ari:cloud:platform::integration/smartsheet';
const $b49aac7b02131b1c$var$BITBUCKET_INTEGRATION_ARI = 'ari:cloud:platform::integration/bitbucket';
const $b49aac7b02131b1c$var$NOTION_INTEGRATION_ARI = 'ari:cloud:platform::integration/notion';
const $b49aac7b02131b1c$var$MIRO_INTEGRATION_ARI = 'ari:cloud:platform::integration/miro';
const $b49aac7b02131b1c$var$ZENDESK_INTEGRATION_ARI = 'ari:cloud:platform::integration/zendesk';
const $b49aac7b02131b1c$var$DOCUSIGN_INTEGRATION_ARI = 'ari:cloud:platform::integration/docusign';
const $b49aac7b02131b1c$var$LUCID_INTEGRATION_ARI = 'ari:cloud:platform::integration/lucid';
const $b49aac7b02131b1c$var$MONDAY_INTEGRATION_ARI = 'ari:cloud:platform::integration/monday';
const $b49aac7b02131b1c$var$AZURE_DEVOPS_INTEGRATION_ARI = 'ari:cloud:platform::integration/azure-devops';
const $b49aac7b02131b1c$var$GITLAB_INTEGRATION_ARI = 'ari:cloud:platform::integration/gitlab';
const $b49aac7b02131b1c$var$CONFLUENCE_DC_INTEGRATION_ARI = 'ari:cloud:platform::integration/confluence-dc';
const $b49aac7b02131b1c$var$CANVA_INTEGRATION_ARI = 'ari:cloud:platform::integration/canva';
const $b49aac7b02131b1c$var$ASANA_INTEGRATION_ARI = 'ari:cloud:platform::integration/asana';
const $b49aac7b02131b1c$var$BOX_INTEGRATION_ARI = 'ari:cloud:platform::integration/box';
const $b49aac7b02131b1c$var$GONG_INTEGRATION_ARI = 'ari:cloud:platform::integration/gong';
const $b49aac7b02131b1c$var$ZOOM_INTEGRATION_ARI = 'ari:cloud:platform::integration/zoom';
const $b49aac7b02131b1c$var$ZEPLIN_INTEGRATION_ARI = 'ari:cloud:platform::integration/zeplin';
const $b49aac7b02131b1c$var$SERVICENOW_INTEGRATION_ARI = 'ari:cloud:platform::integration/servicenow';
const $b49aac7b02131b1c$var$FRESHSERVICE_INTEGRATION_ARI = 'ari:cloud:platform::integration/freshservice';
const $b49aac7b02131b1c$var$CLICKUP_INTEGRATION_ARI = 'ari:cloud:platform::integration/clickup';
const $b49aac7b02131b1c$var$AMPLITUDE_INTEGRATION_ARI = 'ari:cloud:platform::integration/amplitude';
const $b49aac7b02131b1c$var$STRIPE_INTEGRATION_ARI = 'ari:cloud:platform::integration/stripe';
const $b49aac7b02131b1c$var$ADOBE_INTEGRATION_ARI = 'ari:cloud:platform::integration/adobe';
const $b49aac7b02131b1c$var$AHA_INTEGRATION_ARI = 'ari:cloud:platform::integration/aha';
const $b49aac7b02131b1c$var$MURAL_INTEGRATION_ARI = 'ari:cloud:platform::integration/mural';
const $b49aac7b02131b1c$var$WEBEX_INTEGRATION_ARI = 'ari:cloud:platform::integration/cisco';
const $b49aac7b02131b1c$var$TODOIST_INTEGRATION_ARI = 'ari:cloud:platform::integration/todoist';
const $b49aac7b02131b1c$var$PAGERDUTY_INTEGRATION_ARI = 'ari:cloud:platform::integration/pagerduty';
const $b49aac7b02131b1c$var$PIPEDRIVE_INTEGRATION_ARI = 'ari:cloud:platform::integration/pipedrive';
const $b49aac7b02131b1c$var$HUBSPOT_INTEGRATION_ARI = 'ari:cloud:platform::integration/hubspot';
const $b49aac7b02131b1c$var$DOVETAIL_INTEGRATION_ARI = 'ari:cloud:platform::integration/dovetail';
const $b49aac7b02131b1c$var$LAUNCHDARKLY_INTEGRATION_ARI = 'ari:cloud:platform::integration/launchdarkly';
const $b49aac7b02131b1c$var$SALESFORCE_INTEGRATION_ARI = 'ari:cloud:platform::integration/salesforce';
const $b49aac7b02131b1c$var$SENTRY_INTEGRATION_ARI = 'ari:cloud:platform::integration/sentry';
const $b49aac7b02131b1c$var$JIRA_DC_INTEGRATION_ARI = 'ari:cloud:platform::integration/jira-dc';
const $b49aac7b02131b1c$var$GITBOOK_INTEGRATION_ARI = 'ari:cloud:platform::integration/graph-test-app';
const $b49aac7b02131b1c$var$DATABRICKS_INTEGRATION_ARI = 'ari:cloud:platform::integration/databricks';
const $b49aac7b02131b1c$export$7df2356c26307b1c = 'ari:cloud:platform::integration/slack';
// Forge Integration ARIs
const $b49aac7b02131b1c$var$FORGE_ADAM_VITAREQ_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/dAkghOClvWGokDftTTaIgNoD6pnNt74z';
const $b49aac7b02131b1c$var$FORGE_ADAM_VITAREQ_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93';
const $b49aac7b02131b1c$var$FORGE_K15T_SCROLL_SITES_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/h1n3NRFAn84v7ECSONVidlCS88qZh8cy';
const $b49aac7b02131b1c$var$FORGE_K15T_SCROLL_SITES_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO';
const $b49aac7b02131b1c$var$FORGE_PIO_AWS_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/HaxJprV0zzjjvwLhGkAN2gDPhHZwXNiL';
const $b49aac7b02131b1c$var$FORGE_PIO_AWS_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/mRcqWRwqkUd4JwapGkvGHUViyySX9MVy';
const $b49aac7b02131b1c$var$FORGE_PIO_CLICKUP_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY';
const $b49aac7b02131b1c$var$FORGE_PIO_CLICKUP_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K';
const $b49aac7b02131b1c$var$FORGE_PIO_GITBOOK_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi';
const $b49aac7b02131b1c$var$FORGE_PIO_GITBOOK_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u';
const $b49aac7b02131b1c$var$FORGE_PIO_GITHUB_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j';
const $b49aac7b02131b1c$var$FORGE_PIO_GITHUB_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI';
const $b49aac7b02131b1c$var$FORGE_PIO_GITLAB_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/psr1wBkasRuKCwsvwi4aTJNhjmlVFebC';
const $b49aac7b02131b1c$var$FORGE_PIO_GITLAB_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL';
const $b49aac7b02131b1c$var$FORGE_PIO_GOOGLE_DRIVE_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq';
const $b49aac7b02131b1c$var$FORGE_PIO_GOOGLE_DRIVE_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/pcIwW04B398CSnilRIyzPJ5v5GevlCCo';
const $b49aac7b02131b1c$var$FORGE_PIO_GURU_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5';
const $b49aac7b02131b1c$var$FORGE_PIO_GURU_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29';
const $b49aac7b02131b1c$var$FORGE_PIO_HELPJUICE_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC';
const $b49aac7b02131b1c$var$FORGE_PIO_HELPJUICE_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/8durapLyclxZeEexKkwxw6ZpCRpBz4dP';
const $b49aac7b02131b1c$var$FORGE_PIO_HUBSPOT_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF';
const $b49aac7b02131b1c$var$FORGE_PIO_HUBSPOT_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J';
const $b49aac7b02131b1c$var$FORGE_PIO_SALESFORCE_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo';
const $b49aac7b02131b1c$var$FORGE_PIO_SALESFORCE_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb';
const $b49aac7b02131b1c$var$FORGE_PIO_SHAREPOINT_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/cl5i3J8L463hTuQiDt7f1mK4vZllsAo0';
const $b49aac7b02131b1c$var$FORGE_PIO_SHAREPOINT_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/7yrzYPlAOcZAif2tIymeDXBUNUAxI95G';
const $b49aac7b02131b1c$var$FORGE_PIO_STACK_OVERFLOW_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3';
const $b49aac7b02131b1c$var$FORGE_PIO_STACK_OVERFLOW_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS';
const $b49aac7b02131b1c$var$FORGE_UTOOLITY_GITBOOK_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5';
const $b49aac7b02131b1c$var$FORGE_UTOOLITY_GITBOOK_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS';
const $b49aac7b02131b1c$var$FORGE_GDRIVE_EUGENE_TEST_DEV_INTEGRATION_ARI = 'ari:cloud:platform::integration/s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua';
const $b49aac7b02131b1c$var$FORGE_GDRIVE_EUGENE_TEST_PROD_INTEGRATION_ARI = 'ari:cloud:platform::integration/bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf';
const $b49aac7b02131b1c$export$d82a82f2333502ad = {
    [(0, $4wG6Y.ProductKey).GoogleDrive]: $b49aac7b02131b1c$var$GOOGLE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Sharepoint]: $b49aac7b02131b1c$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).AtlassianWebCrawler]: $b49aac7b02131b1c$var$WEB_CRAWLER_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Teams]: $b49aac7b02131b1c$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Figma]: $b49aac7b02131b1c$var$FIGMA_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Gitbook]: $b49aac7b02131b1c$var$GITBOOK_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Loom]: $b49aac7b02131b1c$var$LOOM_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).OneDrive]: $b49aac7b02131b1c$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Github]: $b49aac7b02131b1c$var$GITHUB_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Bitbucket]: $b49aac7b02131b1c$var$BITBUCKET_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Airtable]: $b49aac7b02131b1c$var$AIRTABLE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Smartsheet]: $b49aac7b02131b1c$var$SMARTSHEET_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Notion]: $b49aac7b02131b1c$var$NOTION_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Miro]: $b49aac7b02131b1c$var$MIRO_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Zendesk]: $b49aac7b02131b1c$var$ZENDESK_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Docusign]: $b49aac7b02131b1c$var$DOCUSIGN_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Lucid]: $b49aac7b02131b1c$var$LUCID_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Monday]: $b49aac7b02131b1c$var$MONDAY_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).AzureDevops]: $b49aac7b02131b1c$var$AZURE_DEVOPS_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Gitlab]: $b49aac7b02131b1c$var$GITLAB_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ConfluenceDC]: $b49aac7b02131b1c$var$CONFLUENCE_DC_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Canva]: $b49aac7b02131b1c$var$CANVA_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).OutlookCalendar]: $b49aac7b02131b1c$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Asana]: $b49aac7b02131b1c$var$ASANA_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Zeplin]: $b49aac7b02131b1c$var$ZEPLIN_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ServiceNow]: $b49aac7b02131b1c$var$SERVICENOW_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Freshservice]: $b49aac7b02131b1c$var$FRESHSERVICE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).PowerBI]: $b49aac7b02131b1c$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ClickUp]: $b49aac7b02131b1c$var$CLICKUP_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Amplitude]: $b49aac7b02131b1c$var$AMPLITUDE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Stripe]: $b49aac7b02131b1c$var$STRIPE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).AdobeXD]: $b49aac7b02131b1c$var$ADOBE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Aha]: $b49aac7b02131b1c$var$AHA_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).AdobeSign]: $b49aac7b02131b1c$var$ADOBE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Mural]: $b49aac7b02131b1c$var$MURAL_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Webex]: $b49aac7b02131b1c$var$WEBEX_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Todoist]: $b49aac7b02131b1c$var$TODOIST_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).PagerDuty]: $b49aac7b02131b1c$var$PAGERDUTY_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Pipedrive]: $b49aac7b02131b1c$var$PIPEDRIVE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Hubspot]: $b49aac7b02131b1c$var$HUBSPOT_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Dovetail]: $b49aac7b02131b1c$var$DOVETAIL_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).LaunchDarkly]: $b49aac7b02131b1c$var$LAUNCHDARKLY_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Salesforce]: $b49aac7b02131b1c$var$SALESFORCE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Sentry]: $b49aac7b02131b1c$var$SENTRY_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).JiraDC]: $b49aac7b02131b1c$var$JIRA_DC_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).JsmDC]: $b49aac7b02131b1c$var$JIRA_DC_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Box]: $b49aac7b02131b1c$var$BOX_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Gong]: $b49aac7b02131b1c$var$GONG_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Zoom]: $b49aac7b02131b1c$var$ZOOM_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Dropbox]: $b49aac7b02131b1c$var$DROPBOX_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).GoogleCalendar]: $b49aac7b02131b1c$var$GOOGLE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Gmail]: $b49aac7b02131b1c$var$GOOGLE_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Databricks]: $b49aac7b02131b1c$var$DATABRICKS_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).AWSS3]: $b49aac7b02131b1c$var$GITBOOK_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).OutlookMail]: $b49aac7b02131b1c$var$MICROSOFT_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).Slack]: $b49aac7b02131b1c$export$7df2356c26307b1c,
    // Forge Products - Dev and Prod versions
    [(0, $4wG6Y.ProductKey).ForgeAdamVitareqDev]: $b49aac7b02131b1c$var$FORGE_ADAM_VITAREQ_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgeAdamVitareqProd]: $b49aac7b02131b1c$var$FORGE_ADAM_VITAREQ_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgeK15tScrollSitesDev]: $b49aac7b02131b1c$var$FORGE_K15T_SCROLL_SITES_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgeK15tScrollSitesProd]: $b49aac7b02131b1c$var$FORGE_K15T_SCROLL_SITES_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioAwsDev]: $b49aac7b02131b1c$var$FORGE_PIO_AWS_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioAwsProd]: $b49aac7b02131b1c$var$FORGE_PIO_AWS_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioClickupDev]: $b49aac7b02131b1c$var$FORGE_PIO_CLICKUP_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioClickupProd]: $b49aac7b02131b1c$var$FORGE_PIO_CLICKUP_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGitbookDev]: $b49aac7b02131b1c$var$FORGE_PIO_GITBOOK_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGitbookProd]: $b49aac7b02131b1c$var$FORGE_PIO_GITBOOK_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGithubDev]: $b49aac7b02131b1c$var$FORGE_PIO_GITHUB_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGithubProd]: $b49aac7b02131b1c$var$FORGE_PIO_GITHUB_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGitlabDev]: $b49aac7b02131b1c$var$FORGE_PIO_GITLAB_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGitlabProd]: $b49aac7b02131b1c$var$FORGE_PIO_GITLAB_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGoogleDriveDev]: $b49aac7b02131b1c$var$FORGE_PIO_GOOGLE_DRIVE_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGoogleDriveProd]: $b49aac7b02131b1c$var$FORGE_PIO_GOOGLE_DRIVE_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGuruDev]: $b49aac7b02131b1c$var$FORGE_PIO_GURU_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioGuruProd]: $b49aac7b02131b1c$var$FORGE_PIO_GURU_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioHelpjuiceDev]: $b49aac7b02131b1c$var$FORGE_PIO_HELPJUICE_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioHelpjuiceProd]: $b49aac7b02131b1c$var$FORGE_PIO_HELPJUICE_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioHubspotDev]: $b49aac7b02131b1c$var$FORGE_PIO_HUBSPOT_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioHubspotProd]: $b49aac7b02131b1c$var$FORGE_PIO_HUBSPOT_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioSalesforceDev]: $b49aac7b02131b1c$var$FORGE_PIO_SALESFORCE_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioSalesforceProd]: $b49aac7b02131b1c$var$FORGE_PIO_SALESFORCE_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioSharepointDev]: $b49aac7b02131b1c$var$FORGE_PIO_SHAREPOINT_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioSharepointProd]: $b49aac7b02131b1c$var$FORGE_PIO_SHAREPOINT_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioStackOverflowDev]: $b49aac7b02131b1c$var$FORGE_PIO_STACK_OVERFLOW_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgePioStackOverflowProd]: $b49aac7b02131b1c$var$FORGE_PIO_STACK_OVERFLOW_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgeUtoolityGitbookDev]: $b49aac7b02131b1c$var$FORGE_UTOOLITY_GITBOOK_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgeUtoolityGitbookProd]: $b49aac7b02131b1c$var$FORGE_UTOOLITY_GITBOOK_PROD_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgeGdriveEugeneTestDev]: $b49aac7b02131b1c$var$FORGE_GDRIVE_EUGENE_TEST_DEV_INTEGRATION_ARI,
    [(0, $4wG6Y.ProductKey).ForgeGdriveEugeneTestProd]: $b49aac7b02131b1c$var$FORGE_GDRIVE_EUGENE_TEST_PROD_INTEGRATION_ARI
};
const $b49aac7b02131b1c$var$FORGE_CONNECTOR_PREFIX = 'forge-connector-';
const $b49aac7b02131b1c$export$530d1d49b6479256 = (productKey)=>{
    if (!productKey.startsWith($b49aac7b02131b1c$var$FORGE_CONNECTOR_PREFIX)) return undefined;
    const withoutPrefix = productKey.slice($b49aac7b02131b1c$var$FORGE_CONNECTOR_PREFIX.length);
    // Hash is everything before the first hyphen after the prefix
    const hyphenIndex = withoutPrefix.indexOf('-');
    if (hyphenIndex === -1) return undefined;
    const hash = withoutPrefix.slice(0, hyphenIndex);
    return `ari:cloud:platform::integration/${hash}`;
};
const $b49aac7b02131b1c$export$3be99390ed5e95e2 = (productKey)=>{
    // Check static mapping first
    const staticAri = $b49aac7b02131b1c$export$d82a82f2333502ad[productKey];
    if (staticAri !== undefined) return staticAri;
    // Fall back to Forge connector derivation
    return $b49aac7b02131b1c$export$530d1d49b6479256(productKey);
};
module.exports["SLACK_INTEGRATION_ARI"] = $b49aac7b02131b1c$export$7df2356c26307b1c;
module.exports["baseIntegrationARIs"] = $b49aac7b02131b1c$export$d82a82f2333502ad;

});

parcelRegister("7IS25", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");


var $fbOob = parcelRequire("fbOob");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $cZKQq = parcelRequire("cZKQq");


var $hea5O = parcelRequire("hea5O");


var $gPOtu = parcelRequire("gPOtu");


var $2gvXK = parcelRequire("2gvXK");


var $aTy6Z = parcelRequire("aTy6Z");


var $eQwbw = parcelRequire("eQwbw");


var $2uw6T = parcelRequire("2uw6T");


var $bwyoU = parcelRequire("bwyoU");


var $6zZLZ = parcelRequire("6zZLZ");

/** Slides type filter + slide ATI require env rollout and cc-mui-slides-experiment (same as Quick Find supported entities). */ function $8644185c8dc31b93$var$isSlideTypeFilterEnabled() {
    return (0, $fbOob.isContentTypeEnabledInCurrentEnv)('slide') && (0, $cXtTj.default).getExperimentValue('cc-mui-slides-experiment', 'isEnabled', false, {
        fireExperimentExposure: true
    }) === true;
}
const $8644185c8dc31b93$export$860193da8e7fe3cd = ()=>(0, $7ydfN.allTypeFilterValueKeys).filter((key)=>key !== (0, $7ydfN.TypeFilterValueKey).Slide || $8644185c8dc31b93$var$isSlideTypeFilterEnabled());
const $8644185c8dc31b93$export$cf63d35399eb18ae = (query, config)=>{
    const allOptions = $8644185c8dc31b93$export$b220eb3fbdd854af(config);
    const matchingOptions = allOptions.filter((option)=>(0, $bwyoU.lookupMatches)(query, option.label)).map((option)=>({
            label: option.label,
            trackingKey: option.value,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault,
            product: config.product
        }));
    return matchingOptions;
};
const $8644185c8dc31b93$var$combineEntitiesForResultsCountQuery = (selectedEntities, unselectedEntities)=>{
    const entitiesToExclude = [
        'ati:cloud:trello:card',
        ...(0, $2gvXK.CONFLUENCE_COMMENTS_AND_ATTACHMENTS_ENTITIES)
    ];
    return Array.from([
        ...new Set([
            ...selectedEntities,
            ...unselectedEntities
        ])
    ]).filter((entity)=>!entitiesToExclude.includes(entity)).sort();
};
const $8644185c8dc31b93$export$e085e94f90daa6c8 = (products, selectedTypes, thirdPartyConfigs, availableProducts, selectedProducts)=>{
    const selectedTypesFiltered = selectedTypes.filter((t)=>t !== (0, $7ydfN.TypeFilterValueKey).Slide || $8644185c8dc31b93$var$isSlideTypeFilterEnabled());
    if ((0, $iDrrr.fg)('confluence_performance_improve_search_query')) return $8644185c8dc31b93$export$d9f0dc47e74a61d2({
        products: products,
        selectedTypes: selectedTypesFiltered,
        thirdPartyConfigs: thirdPartyConfigs,
        availableProducts: availableProducts,
        selectedProducts: selectedProducts
    });
    const selectedEntities = new Set();
    const unselectedEntities = new Set();
    // Expand types to include all when:
    // 1. No types are selected (show all results), OR
    // 2. Bug fix is enabled AND specific noun product+type combos are selected:
    //    - Atlas + (project OR goal)
    //    - WebCrawler + web-page
    // because despite type being selected (which would usually mean only showing result counts for that type),
    // we want to show all result counts on the right panel to make nouns more consistent with other apps.
    const shouldIncludeAllTypes = selectedTypesFiltered.length === 0 || selectedTypesFiltered.includes((0, $7ydfN.TypeFilterValueKey).Project) && selectedProducts?.includes((0, $dvVWp.ProductKeys).Atlas) || selectedTypesFiltered.includes((0, $7ydfN.TypeFilterValueKey).Goal) && selectedProducts?.includes((0, $dvVWp.ProductKeys).Atlas) || selectedTypesFiltered.includes((0, $7ydfN.TypeFilterValueKey).WebPage) && selectedProducts?.includes((0, $dvVWp.ProductKeys).AtlassianWebCrawler);
    const types = shouldIncludeAllTypes ? $8644185c8dc31b93$export$860193da8e7fe3cd() : selectedTypesFiltered;
    const typeMapping = (0, $2gvXK.getTypeMapping)();
    const otherProducts = availableProducts.filter((product)=>!products.includes(product));
    types.forEach((type)=>{
        const productToEntityMap = typeMapping[type].entities;
        products.forEach((product)=>{
            if ((0, $2uw6T.isProductEntitiesIncluded)(products, product, thirdPartyConfigs)) productToEntityMap[product]?.forEach((ati)=>{
                // Logic specific to Atlas product to ensure projects and goals are not shown together
                // in the search query results since they both belong to the same product, Townsquare
                if (product === (0, $dvVWp.ProductKeys).Atlas && selectedTypesFiltered.length > 0 && !selectedTypesFiltered.includes(type)) {
                    // Add other entities under the same product to unselected so they appear in right panel counts
                    unselectedEntities.add(ati);
                    return;
                }
                if ((0, $eQwbw.isEntityEnabled)(ati, selectedTypesFiltered, selectedProducts)) selectedEntities.add(ati);
            });
        });
        // collect unselected entities
        otherProducts.forEach((product)=>{
            if ((0, $2uw6T.isProductEntitiesIncluded)(otherProducts, product, thirdPartyConfigs)) productToEntityMap[product]?.forEach((ati)=>{
                if (!selectedEntities.has(ati)) unselectedEntities.add(ati);
            });
        });
    });
    /// result count wants all entities for selected type
    const entitiesForResultsCountQuery = $8644185c8dc31b93$var$combineEntitiesForResultsCountQuery(selectedEntities, unselectedEntities);
    // Do not show Atlas goal and tag results when no product is selected
    if (types.includes('project') && products.length > 1) {
        selectedEntities.delete('ati:cloud:townsquare:goal');
        selectedEntities.delete('ati:cloud:townsquare:tag');
    }
    if (types.includes('customer-contact') && !(0, $iDrrr.fg)('afm_customer_contact_search_type')) selectedEntities.delete('ati:cloud:graph:customer-contact');
    if (!$8644185c8dc31b93$var$isSlideTypeFilterEnabled()) selectedEntities.delete('ati:cloud:confluence:slide');
    // Sorting helps a ton in testing
    const entitiesForQuery = Array.from(selectedEntities).sort();
    return {
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $8644185c8dc31b93$var$isProductEntitiesIncludedSimplified = (availableProducts, product, thirdPartyConfigs)=>{
    // Main change from the original code
    if ((0, $dvVWp.is3pProductKey)(product)) return availableProducts.includes(product) && (!thirdPartyConfigs[product]?.userNeedsOAuth || (0, $hea5O.isImpersonationEnabled)(product, thirdPartyConfigs) || (0, $gPOtu.hasAdminImportedUserLink)(product, thirdPartyConfigs));
    return availableProducts.includes(product);
};
const $8644185c8dc31b93$var$getProductsWithEntities = (products, thirdPartyConfigs)=>{
    return products.reduce((acc, product)=>{
        if ($8644185c8dc31b93$var$isProductEntitiesIncludedSimplified(products, product, thirdPartyConfigs)) acc.push(product);
        return acc;
    }, []);
};
const $8644185c8dc31b93$export$d9f0dc47e74a61d2 = ({ products: products, selectedTypes: selectedTypes, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts, selectedProducts: selectedProducts })=>{
    const selectedTypesFiltered = selectedTypes.filter((t)=>t !== (0, $7ydfN.TypeFilterValueKey).Slide || $8644185c8dc31b93$var$isSlideTypeFilterEnabled());
    const otherProducts = availableProducts.filter((product)=>!products.includes(product));
    const productsWithEntities = $8644185c8dc31b93$var$getProductsWithEntities(products, thirdPartyConfigs);
    const otherProductsWithEntities = otherProducts.reduce((acc, otherProduct)=>{
        if ((0, $2uw6T.isProductEntitiesIncluded)(otherProducts, otherProduct, thirdPartyConfigs)) acc.push(otherProduct);
        return acc;
    }, []);
    // Stuff that we can't be cached that easy
    const selectedEntities = new Set();
    const unselectedEntities = new Set();
    // Expand types to include all when:
    // 1. No types are selected (show all results), OR
    // 2. Bug fix is enabled AND specific noun product+type combos are selected:
    //    - Atlas + (project OR goal)
    //    - WebCrawler + web-page
    // because despite type being selected (which would usually mean only showing result counts for that type),
    // we want to show all result counts on the right panel to make nouns more consistent with other apps.
    const shouldIncludeAllTypes = selectedTypesFiltered.length === 0 || selectedTypesFiltered.includes((0, $7ydfN.TypeFilterValueKey).Project) && selectedProducts?.includes((0, $dvVWp.ProductKeys).Atlas) || selectedTypesFiltered.includes((0, $7ydfN.TypeFilterValueKey).Goal) && selectedProducts?.includes((0, $dvVWp.ProductKeys).Atlas) || selectedTypesFiltered.includes((0, $7ydfN.TypeFilterValueKey).WebPage) && selectedProducts?.includes((0, $dvVWp.ProductKeys).AtlassianWebCrawler);
    const types = shouldIncludeAllTypes ? $8644185c8dc31b93$export$860193da8e7fe3cd() : selectedTypesFiltered;
    const typeMapping = (0, $2gvXK.getTypeMapping)();
    // Using normal-loop to reduce overhead and improve performance
    for(let i = 0; i < types.length; i++){
        const type = types[i];
        const productToEntityMap = typeMapping[type].entities;
        for(let h = 0; h < productsWithEntities.length; h++){
            const product = productsWithEntities[h];
            const arr = productToEntityMap[product];
            if (!arr || !Array.isArray(arr)) continue;
            for(let w = 0; w < arr.length; w++){
                const ati = arr[w];
                // Logic specific to Atlas product to ensure projects and goals are not shown together
                // in the search query results since they both belong to the same product, Townsquare
                if (product === (0, $dvVWp.ProductKeys).Atlas && selectedTypesFiltered.length > 0 && !selectedTypesFiltered.includes(type)) {
                    // Add other entities under the same product to unselected so they appear in right panel counts
                    unselectedEntities.add(ati);
                    continue;
                }
                if ((0, $eQwbw.isEntityEnabled)(ati, selectedTypesFiltered, selectedProducts)) selectedEntities.add(ati);
            }
        }
        for(let j = 0; j < otherProductsWithEntities.length; j++){
            const product = otherProductsWithEntities[j];
            const arr = productToEntityMap[product];
            if (!arr || !Array.isArray(arr)) continue;
            for(let w = 0; w < arr.length; w++){
                const ati = arr[w];
                if (!selectedEntities.has(ati)) unselectedEntities.add(ati);
            }
        }
    }
    /// result count wants all entities for selected type
    const entitiesForResultsCountQuery = $8644185c8dc31b93$var$combineEntitiesForResultsCountQuery(selectedEntities, unselectedEntities);
    // Do not show Atlas goal and tag results when no product is selected
    if (types.includes('project') && products.length > 1) {
        selectedEntities.delete('ati:cloud:townsquare:goal');
        selectedEntities.delete('ati:cloud:townsquare:tag');
    }
    if (!$8644185c8dc31b93$var$isSlideTypeFilterEnabled()) selectedEntities.delete('ati:cloud:confluence:slide');
    // Sorting helps a ton in testing
    const entitiesForQuery = Array.from(selectedEntities).sort();
    return {
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery
    };
};
const $8644185c8dc31b93$export$b220eb3fbdd854af = (config)=>{
    const typeMapping = (0, $2gvXK.getTypeMapping)();
    const allOption = {
        products: [],
        label: config.intl?.formatMessage((0, $6zZLZ.typeLabels)['all']) || '',
        value: 'all',
        trackingKey: 'all',
        queryParamValue: (0, $cZKQq.ContentType)['All'],
        isDefault: true,
        product: config.product
    };
    const typeOptions = $8644185c8dc31b93$export$860193da8e7fe3cd().filter((type)=>type !== 'customer-contact' || type === 'customer-contact' && (0, $iDrrr.fg)('afm_customer_contact_search_type')).map((type)=>{
        let messageKey = (0, $aTy6Z.getTypeOptionMessageKey)(type);
        return {
            products: typeMapping[type].products,
            value: type,
            trackingKey: type,
            queryParamValue: type,
            isDefault: false,
            label: config.intl?.formatMessage((0, $6zZLZ.typeLabels)[messageKey]) || '',
            product: config.product
        };
    });
    return [
        allOption,
        ...typeOptions
    ];
};
module.exports["getAllTypeFilterKeysForSearch"] = $8644185c8dc31b93$export$860193da8e7fe3cd;
module.exports["lookupOptions"] = $8644185c8dc31b93$export$cf63d35399eb18ae;
module.exports["getAllTypeOptions"] = $8644185c8dc31b93$export$b220eb3fbdd854af;
module.exports["getEntitiesForQuery"] = $8644185c8dc31b93$export$e085e94f90daa6c8;

});

parcelRegister("2gvXK", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $fd0l2 = parcelRequire("fd0l2");


var $2ePuQ = parcelRequire("2ePuQ");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");

/**
 * A mapping between 1P Products
 * - ProductKey1P e.g. 'confluence'
 *
 * UI values for the type filter
 * - TypeFilterKey e.g. 'Spreadsheet'
 *
 * and entities to request from Aggregator
 *
 * - ATIString[] e.g. ['ati:cloud:confluence:blogpost']
 */ const $0cf7d20479cc2c1f$var$typeFilter1PMapping = new Map([
    [
        (0, $dvVWp.ProductKeys).Confluence,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Document,
                [
                    'ati:cloud:confluence:blogpost',
                    'ati:cloud:confluence:page',
                    'ati:cloud:confluence:attachment'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Page,
                [
                    'ati:cloud:confluence:page'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Blogpost,
                [
                    'ati:cloud:confluence:blogpost'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Attachment,
                [
                    'ati:cloud:confluence:attachment'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Space,
                [
                    'ati:cloud:confluence:space'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Comment,
                [
                    'ati:cloud:confluence:comment'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Whiteboard,
                [
                    'ati:cloud:confluence:whiteboard'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Slide,
                [
                    'ati:cloud:confluence:slide'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Database,
                [
                    'ati:cloud:confluence:database'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Embed,
                [
                    'ati:cloud:confluence:embed'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Folder,
                [
                    'ati:cloud:confluence:folder'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Calendar,
                [
                    (0, $2ePuQ.CONFLUENCE_CALENDAR_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).SpaceCalendar,
                [
                    (0, $2ePuQ.CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Question,
                [
                    (0, $2ePuQ.CONFLUENCE_QUESTION_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Answer,
                [
                    (0, $2ePuQ.CONFLUENCE_ANSWER_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Gliffy,
                [
                    (0, $2ePuQ.CONFLUENCE_GLIFFY_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Jira,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Issue,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Epic,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Bug,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Story,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Task,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Subtask,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Space,
                [
                    (0, $2ePuQ.JIRA_PROJECT_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Filter,
                [
                    (0, $2ePuQ.JIRA_FILTER_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Plan,
                [
                    (0, $2ePuQ.JIRA_PLAN_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Board,
                [
                    (0, $2ePuQ.JIRA_BOARD_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Dashboard,
                [
                    (0, $2ePuQ.JIRA_DASHBOARD_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).JiraProductDiscovery,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Issue,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Space,
                [
                    (0, $2ePuQ.JIRA_PROJECT_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Filter,
                [
                    (0, $2ePuQ.JIRA_FILTER_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Plan,
                [
                    (0, $2ePuQ.JIRA_PLAN_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Board,
                [
                    (0, $2ePuQ.JIRA_BOARD_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Dashboard,
                [
                    (0, $2ePuQ.JIRA_DASHBOARD_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).JiraServiceManagement,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Issue,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Incident,
                [
                    (0, $2ePuQ.JIRA_ISSUE_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Space,
                [
                    (0, $2ePuQ.JIRA_PROJECT_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Filter,
                [
                    (0, $2ePuQ.JIRA_FILTER_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Plan,
                [
                    (0, $2ePuQ.JIRA_PLAN_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Board,
                [
                    (0, $2ePuQ.JIRA_BOARD_ENTITY_ATI)
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Dashboard,
                [
                    (0, $2ePuQ.JIRA_DASHBOARD_ENTITY_ATI)
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Compass,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Component,
                [
                    'ati:cloud:compass:component'
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Focus,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).FocusArea,
                [
                    'ati:cloud:mercury:focus-area',
                    'ati:cloud:mercury:focus-area-status-update'
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Talent,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Position,
                [
                    'ati:cloud:radar:position'
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Trello,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Card,
                [
                    'ati:cloud:trello:card'
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Atlas,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Project,
                [
                    'ati:cloud:townsquare:project'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Goal,
                [
                    'ati:cloud:townsquare:goal'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Tag,
                [
                    'ati:cloud:townsquare:tag'
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Bitbucket,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).Commit,
                [
                    'ati:cloud:graph:commit'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).PullRequest,
                [
                    'ati:cloud:graph:pull-request'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Repository,
                [
                    'ati:cloud:graph:repository'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Branch,
                [
                    'ati:cloud:graph:branch'
                ]
            ]
        ])
    ],
    [
        (0, $dvVWp.ProductKeys).Assets,
        new Map([
            [
                (0, $7ydfN.TypeFilterValueKey).AssetsObject,
                [
                    'ati:cloud:cmdb:object'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Schema,
                [
                    'ati:cloud:cmdb:schema'
                ]
            ],
            [
                (0, $7ydfN.TypeFilterValueKey).Type,
                [
                    'ati:cloud:cmdb:type'
                ]
            ]
        ])
    ]
]);
const $0cf7d20479cc2c1f$export$a185da63aca613f3 = [
    'ati:cloud:confluence:comment',
    'ati:cloud:confluence:attachment'
];
const $0cf7d20479cc2c1f$export$598e74d591895feb = ()=>[
        ...$0cf7d20479cc2c1f$export$a185da63aca613f3
    ];
let $0cf7d20479cc2c1f$export$1a2d7de20763c66f;
const $0cf7d20479cc2c1f$export$4b1ab8c60d2ecbf1 = ()=>{
    $0cf7d20479cc2c1f$export$1a2d7de20763c66f = undefined; // Reset cache
};
const $0cf7d20479cc2c1f$export$a7663ee59d66492f = ()=>{
    if ($0cf7d20479cc2c1f$export$1a2d7de20763c66f) return $0cf7d20479cc2c1f$export$1a2d7de20763c66f;
    const mappings = Object.fromEntries((0, $7ydfN.allTypeFilterValueKeys).map((TypeFilterValueKey)=>{
        const baseMapping = {
            entities: {},
            products: [],
            subCategories: []
        };
        return [
            TypeFilterValueKey,
            baseMapping
        ];
    }));
    // Add all the 1P products
    $0cf7d20479cc2c1f$var$typeFilter1PMapping.forEach((_, productKey1P)=>{
        $0cf7d20479cc2c1f$var$typeFilter1PMapping.get(productKey1P)?.forEach((_, typeFilterValueKey)=>{
            mappings[typeFilterValueKey].products.push(productKey1P);
            mappings[typeFilterValueKey].entities[productKey1P] = $0cf7d20479cc2c1f$var$typeFilter1PMapping.get(productKey1P)?.get(typeFilterValueKey);
        });
    });
    // Conditionally add passionfruit Ask type for Focus product
    if ((0, $iDrrr.fg)('platform_passionfruit_search_onboarding_enabled')) {
        mappings[(0, $7ydfN.TypeFilterValueKey).Ask].products.push((0, $dvVWp.ProductKeys).Focus);
        mappings[(0, $7ydfN.TypeFilterValueKey).Ask].entities[(0, $dvVWp.ProductKeys).Focus] = [
            'ati:cloud:passionfruit:ask'
        ];
    }
    // Conditionally add Mercury Risk type for Focus product so risk entities are only
    // requested from the backend when the risk search UI is enabled.
    if ((0, $iDrrr.fg)('platform_mercury_risk_search_ui_enabled')) {
        mappings[(0, $7ydfN.TypeFilterValueKey).Risk].products.push((0, $dvVWp.ProductKeys).Focus);
        mappings[(0, $7ydfN.TypeFilterValueKey).Risk].entities[(0, $dvVWp.ProductKeys).Focus] = [
            'ati:cloud:mercury:risk'
        ];
    }
    // Add all the 3P products
    (0, $fd0l2.ThirdPartyConfigsSync).forEach((thirdPartyConfig, productKey3P)=>{
        const typeFilterConfigs = thirdPartyConfig?.typeFilterConfig;
        if (!typeFilterConfigs) return;
        typeFilterConfigs.forEach((typeFilterValue3PEntities, typeFilterValueKey)=>{
            mappings[typeFilterValueKey].products.push(productKey3P);
            mappings[typeFilterValueKey].entities[productKey3P] = typeFilterValue3PEntities.entities3P;
            mappings[typeFilterValueKey].subCategories = [
                ...mappings[typeFilterValueKey].subCategories,
                ...typeFilterValue3PEntities.subTypes3P
            ];
            mappings[typeFilterValueKey].subCategories = [
                ...new Set(mappings[typeFilterValueKey].subCategories)
            ]; // dedupe
        });
    });
    $0cf7d20479cc2c1f$export$1a2d7de20763c66f = mappings;
    return mappings;
};
const $0cf7d20479cc2c1f$export$525857063443efa8 = (productKey, typeFilterConfig)=>{
    // Ensure cache is initialized before updating it
    if (!$0cf7d20479cc2c1f$export$1a2d7de20763c66f) $0cf7d20479cc2c1f$export$a7663ee59d66492f();
    if (!typeFilterConfig || typeFilterConfig.size === 0) return;
    typeFilterConfig.forEach((typeFilterValue3PEntities, typeFilterValueKey)=>{
        // Type guard: only process if it's a valid TypeFilterValueKey in our mapping
        if (!(typeFilterValueKey in $0cf7d20479cc2c1f$export$1a2d7de20763c66f)) return;
        // Only add if not already present
        if (!$0cf7d20479cc2c1f$export$1a2d7de20763c66f[typeFilterValueKey].products.includes(productKey)) $0cf7d20479cc2c1f$export$1a2d7de20763c66f[typeFilterValueKey].products.push(productKey);
        $0cf7d20479cc2c1f$export$1a2d7de20763c66f[typeFilterValueKey].entities[productKey] = typeFilterValue3PEntities.entities3P;
        $0cf7d20479cc2c1f$export$1a2d7de20763c66f[typeFilterValueKey].subCategories = [
            ...$0cf7d20479cc2c1f$export$1a2d7de20763c66f[typeFilterValueKey].subCategories,
            ...typeFilterValue3PEntities.subTypes3P
        ];
        $0cf7d20479cc2c1f$export$1a2d7de20763c66f[typeFilterValueKey].subCategories = [
            ...new Set($0cf7d20479cc2c1f$export$1a2d7de20763c66f[typeFilterValueKey].subCategories)
        ]; // dedupe
    });
};
module.exports["CONFLUENCE_COMMENTS_AND_ATTACHMENTS_ENTITIES"] = $0cf7d20479cc2c1f$export$a185da63aca613f3;
module.exports["notRequestedATIsInAllSearch"] = $0cf7d20479cc2c1f$export$598e74d591895feb;
module.exports["getTypeMapping"] = $0cf7d20479cc2c1f$export$a7663ee59d66492f;
module.exports["registerForgeConnectorTypeMapping"] = $0cf7d20479cc2c1f$export$525857063443efa8;

});

parcelRegister("2ePuQ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $8lpY0 = parcelRequire("8lpY0");


var $9T8TZ = parcelRequire("9T8TZ");


var $iiNGz = parcelRequire("iiNGz");


var $c8ES5 = parcelRequire("c8ES5");


























const $c7802849572bf7b6$export$a2818d866ea09b15 = 'ati:cloud:passionfruit:ask';
const $c7802849572bf7b6$export$2d73983fb684eaa8 = 'ati:cloud:mercury:risk';
const $c7802849572bf7b6$export$98b8a39f6a9e8fb2 = 'ati:cloud:mercury:organization';
const $c7802849572bf7b6$export$db327a40079b14ba = 'ati:cloud:mercury:organization-status-update';
const $c7802849572bf7b6$export$e105364f000374dd = ()=>[
        ...(0, $iiNGz.DEFAULT_MERCURY_ENTITY_ATI),
        ...(0, $iDrrr.fg)('platform_passionfruit_search_onboarding_enabled') ? [
            $c7802849572bf7b6$export$a2818d866ea09b15
        ] : [],
        ...(0, $iDrrr.fg)('platform_mercury_risk_search_ui_enabled') ? [
            $c7802849572bf7b6$export$2d73983fb684eaa8
        ] : [],
        ...(0, $iDrrr.fg)('platform_organization_search_onboarding_enabled') ? [
            $c7802849572bf7b6$export$98b8a39f6a9e8fb2,
            $c7802849572bf7b6$export$db327a40079b14ba
        ] : []
    ];
const $c7802849572bf7b6$export$2113db8105db1e2f = 'ati:cloud:confluence:';
const $c7802849572bf7b6$export$fd9583608bfd5225 = 'confluence.com.atlassian.confluence.extra.team-calendars:calendar-content-type';
const $c7802849572bf7b6$export$842fc5f4c9a103cc = 'confluence.com.atlassian.confluence.extra.team-calendars:space-calendars-view-content-type';
const $c7802849572bf7b6$export$85fae06d428ca65d = 'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:answer';
const $c7802849572bf7b6$export$de533c0a50cfcba1 = 'confluence.ac:com.atlassian.confluence.plugins.confluence-questions:question';
const $c7802849572bf7b6$export$bcdd6265f8049b41 = 'confluence.ac:com.gliffy.integration.confluence:gliffy-diagram';
const $c7802849572bf7b6$export$4fb210ecd60bcccb = 'ati:cloud:jira:issue';
const $c7802849572bf7b6$export$2d84b48cf0a2eca6 = 'ati:cloud:jira:project';
const $c7802849572bf7b6$export$68f33db8fcc8984d = 'ati:cloud:jira:filter';
const $c7802849572bf7b6$export$1f91fc8e40b54c58 = 'ati:cloud:jira:dashboard';
const $c7802849572bf7b6$export$b1c20fb509d2d550 = 'ati:cloud:jira:board';
const $c7802849572bf7b6$export$fdd5ab530ffed95b = 'ati:cloud:jira:plan';
const $c7802849572bf7b6$export$b4a7e1c18385196d = [
    $c7802849572bf7b6$export$2d84b48cf0a2eca6,
    $c7802849572bf7b6$export$4fb210ecd60bcccb,
    $c7802849572bf7b6$export$68f33db8fcc8984d,
    $c7802849572bf7b6$export$1f91fc8e40b54c58,
    $c7802849572bf7b6$export$b1c20fb509d2d550,
    $c7802849572bf7b6$export$fdd5ab530ffed95b
];
const $c7802849572bf7b6$export$6ec0530ffade9ab0 = 'ati:third-party:google:email';
const $c7802849572bf7b6$export$dfd3b612305212b4 = 'ati:third-party:microsoft:email';
const $c7802849572bf7b6$export$50adf3273cb5cdeb = [
    $c7802849572bf7b6$export$6ec0530ffade9ab0,
    $c7802849572bf7b6$export$dfd3b612305212b4
];
const $c7802849572bf7b6$export$46827d4f79048f80 = ()=>[
        ...(0, $8lpY0.DEFAULT_ATLAS_ENTITY_ATI),
        ...(0, $9T8TZ.DEFAULT_CONFLUENCE_ENTITY_ATI),
        ...$c7802849572bf7b6$export$b4a7e1c18385196d,
        ...$c7802849572bf7b6$export$e105364f000374dd(),
        ...(0, $c8ES5.DEFAULT_TALENT_ENTITY_ATI)
    ];
const $c7802849572bf7b6$export$423da9b1dcd76b7 = 15;
const $c7802849572bf7b6$export$405ff9c6ee9ee7de = 30;
module.exports["CONFLUENCE_CALENDAR_ENTITY_ATI"] = $c7802849572bf7b6$export$fd9583608bfd5225;
module.exports["CONFLUENCE_SPACE_CALENDAR_ENTITY_ATI"] = $c7802849572bf7b6$export$842fc5f4c9a103cc;
module.exports["CONFLUENCE_ANSWER_ENTITY_ATI"] = $c7802849572bf7b6$export$85fae06d428ca65d;
module.exports["CONFLUENCE_QUESTION_ENTITY_ATI"] = $c7802849572bf7b6$export$de533c0a50cfcba1;
module.exports["CONFLUENCE_GLIFFY_ENTITY_ATI"] = $c7802849572bf7b6$export$bcdd6265f8049b41;
module.exports["JIRA_ISSUE_ENTITY_ATI"] = $c7802849572bf7b6$export$4fb210ecd60bcccb;
module.exports["JIRA_PROJECT_ENTITY_ATI"] = $c7802849572bf7b6$export$2d84b48cf0a2eca6;
module.exports["JIRA_FILTER_ENTITY_ATI"] = $c7802849572bf7b6$export$68f33db8fcc8984d;
module.exports["JIRA_DASHBOARD_ENTITY_ATI"] = $c7802849572bf7b6$export$1f91fc8e40b54c58;
module.exports["JIRA_BOARD_ENTITY_ATI"] = $c7802849572bf7b6$export$b1c20fb509d2d550;
module.exports["JIRA_PLAN_ENTITY_ATI"] = $c7802849572bf7b6$export$fdd5ab530ffed95b;
module.exports["getDefaultEntityAti"] = $c7802849572bf7b6$export$46827d4f79048f80;
module.exports["RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS"] = $c7802849572bf7b6$export$423da9b1dcd76b7;
module.exports["RESULT_LIMIT_FOR_SINGLE_PRODUCT"] = $c7802849572bf7b6$export$405ff9c6ee9ee7de;

});

parcelRegister("7ohhA", function(module, exports) {
const $fd6591e4d2b3206e$export$c28231fcae6448eb = [
    'ati:cloud:graph:repository'
];
module.exports["DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI"] = $fd6591e4d2b3206e$export$c28231fcae6448eb;

});

parcelRegister("5lH3O", function(module, exports) {

var $3u5lg = parcelRequire("3u5lg");


var $kBr4q = parcelRequire("kBr4q");

var $j8on0 = parcelRequire("j8on0");

var $8s9DV = parcelRequire("8s9DV");

const $53cccb73f693e341$export$d4c72bab9d6cc13a = {
    quickFindOpen: false,
    quickFindQuery: '',
    rovoJourneyId: '',
    isFeedbackModalOpen: false,
    retryCount: 0,
    updateRecentQueries: undefined,
    updateZeroQueries: undefined,
    selectedQueryFilters: [],
    openHoverCardId: null,
    searchErrors: []
};
const $53cccb73f693e341$var$actions = {
    setQuickFindOpen: (quickFindOpen)=>({ setState: setState })=>{
            setState({
                quickFindOpen: quickFindOpen
            });
        },
    setQuickFindQuery: (quickFindQuery)=>({ setState: setState })=>{
            setState({
                quickFindQuery: quickFindQuery
            });
        },
    refreshRovoJourneyId: ()=>({ setState: setState })=>{
            setState({
                rovoJourneyId: crypto.randomUUID()
            });
        },
    setRovoJourneyId: (rovoJourneyId)=>({ setState: setState })=>{
            setState({
                rovoJourneyId: rovoJourneyId
            });
        },
    setContent: (content)=>({ setState: setState })=>{
            setState({
                content: content
            });
        },
    setIsFeedbackModalOpen: (isFeedbackModalOpen)=>({ setState: setState })=>{
            setState({
                isFeedbackModalOpen: isFeedbackModalOpen
            });
        },
    setRetryCount: (retryCount)=>({ setState: setState })=>{
            setState({
                retryCount: retryCount
            });
        },
    setFetchSpacesRequestId: (fetchSpacesRequestId)=>({ setState: setState })=>{
            setState({
                fetchSpacesRequestId: fetchSpacesRequestId
            });
        },
    setFetchEntitiesRequestId: (fetchEntitiesRequestId)=>({ setState: setState })=>{
            setState({
                fetchEntitiesRequestId: fetchEntitiesRequestId
            });
        },
    setFetchEntitiesTraceId: (fetchEntitiesTraceId)=>({ setState: setState })=>{
            setState({
                fetchEntitiesTraceId: fetchEntitiesTraceId
            });
        },
    setSearchErrors: (searchErrors)=>({ setState: setState })=>{
            setState({
                searchErrors: searchErrors
            });
        },
    setUpdateRecentQueries: (updateRecentQueries)=>({ setState: setState })=>{
            setState({
                updateRecentQueries: updateRecentQueries
            });
        },
    setUpdateZeroQueries: (updateZeroQueries)=>({ setState: setState })=>{
            setState({
                updateZeroQueries: updateZeroQueries
            });
        },
    addSelectedQueryFilter: (queryFilter)=>({ setState: setState, getState: getState })=>{
            const { selectedQueryFilters: selectedQueryFilters } = getState();
            const duplicate = selectedQueryFilters.find((currentQueryFilter)=>(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(JSON.stringify(currentQueryFilter), JSON.stringify(queryFilter)));
            if (!duplicate) setState({
                selectedQueryFilters: [
                    ...selectedQueryFilters,
                    queryFilter
                ]
            });
        },
    deleteSelectedQueryFilter: (queryFilter)=>({ setState: setState, getState: getState })=>{
            const { selectedQueryFilters: selectedQueryFilters } = getState();
            const newSelectedQueryFilters = selectedQueryFilters.filter((currentQueryFilter)=>!(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(JSON.stringify(currentQueryFilter), JSON.stringify(queryFilter)));
            setState({
                selectedQueryFilters: newSelectedQueryFilters
            });
        },
    resetSelectedQueryFilters: ()=>({ setState: setState })=>{
            setState({
                selectedQueryFilters: []
            });
        },
    setCurrentQueryFilter: (currentQueryFilter)=>({ setState: setState })=>{
            setState({
                currentQueryFilter: currentQueryFilter
            });
        },
    setHoverCardOpen: (itemId, isOpen)=>({ setState: setState, getState: getState })=>{
            const { openHoverCardId: openHoverCardId } = getState();
            if (isOpen) setState({
                openHoverCardId: itemId
            });
            else if (openHoverCardId === itemId) setState({
                openHoverCardId: null
            });
        }
};
const $53cccb73f693e341$var$Store = (0, $8s9DV.createStore)({
    initialState: $53cccb73f693e341$export$d4c72bab9d6cc13a,
    actions: $53cccb73f693e341$var$actions,
    name: 'quick-find'
});
const $53cccb73f693e341$export$5125bb5a97b0c344 = (0, $kBr4q.createActionsHook)($53cccb73f693e341$var$Store);
const $53cccb73f693e341$export$6f7ec6ed84e85154 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.quickFindOpen
});
const $53cccb73f693e341$export$db9af4f90ab0e536 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.quickFindQuery
});
const $53cccb73f693e341$export$65a92c12f81b7ab3 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.rovoJourneyId
});
const $53cccb73f693e341$export$ee83783e2ce4cc63 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.content
});
const $53cccb73f693e341$export$5bdbafc4abc135c7 = (0, $kBr4q.createHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.isFeedbackModalOpen
});
const $53cccb73f693e341$export$140d37088821fcb1 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.retryCount
});
const $53cccb73f693e341$export$e260c85752b77e7c = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.fetchSpacesRequestId
});
const $53cccb73f693e341$export$8d6bc416cb50c4b8 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.fetchEntitiesRequestId
});
const $53cccb73f693e341$export$83bd9ae2aed68ab4 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.fetchEntitiesTraceId
});
const $53cccb73f693e341$export$65391f387dac24a5 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.updateRecentQueries
});
const $53cccb73f693e341$export$4c5c5c3d8a37ed5d = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.updateZeroQueries
});
const $53cccb73f693e341$export$285abcbc8aa402a2 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.selectedQueryFilters
});
const $53cccb73f693e341$export$31b21a5d8580f4a9 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.currentQueryFilter
});
const $53cccb73f693e341$export$d25011725d5aa3a6 = (0, $kBr4q.createStateHook)($53cccb73f693e341$var$Store, {
    selector: (state)=>state.searchErrors || []
});
const $53cccb73f693e341$var$quickFindStoreOnInit = ()=>({ setState: setState }, { initialRovoJourneyId: initialRovoJourneyId, shouldInitializeRovoJourneyId: shouldInitializeRovoJourneyId = false })=>{
        setState({
            rovoJourneyId: initialRovoJourneyId || (shouldInitializeRovoJourneyId ? crypto.randomUUID() : '')
        });
    };
const $53cccb73f693e341$export$3e5bb5570cf53089 = (0, $j8on0.createContainer)($53cccb73f693e341$var$Store, {
    onInit: $53cccb73f693e341$var$quickFindStoreOnInit
});
module.exports["useQuickFindActions"] = $53cccb73f693e341$export$5125bb5a97b0c344;
module.exports["useQuickFindOpen"] = $53cccb73f693e341$export$6f7ec6ed84e85154;
module.exports["useQuickFindQuery"] = $53cccb73f693e341$export$db9af4f90ab0e536;
module.exports["useRovoJourneyId"] = $53cccb73f693e341$export$65a92c12f81b7ab3;
module.exports["useContent"] = $53cccb73f693e341$export$ee83783e2ce4cc63;
module.exports["useIsFeedbackModalOpen"] = $53cccb73f693e341$export$5bdbafc4abc135c7;
module.exports["useFetchSpacesRequestId"] = $53cccb73f693e341$export$e260c85752b77e7c;
module.exports["useFetchEntitiesRequestId"] = $53cccb73f693e341$export$8d6bc416cb50c4b8;
module.exports["useFetchEntitiesTraceId"] = $53cccb73f693e341$export$83bd9ae2aed68ab4;
module.exports["useUpdateRecentQueries"] = $53cccb73f693e341$export$65391f387dac24a5;
module.exports["useUpdateZeroQueries"] = $53cccb73f693e341$export$4c5c5c3d8a37ed5d;
module.exports["useSelectedQueryFilters"] = $53cccb73f693e341$export$285abcbc8aa402a2;
module.exports["useCurrentQueryFilter"] = $53cccb73f693e341$export$31b21a5d8580f4a9;
module.exports["useSearchErrors"] = $53cccb73f693e341$export$d25011725d5aa3a6;
module.exports["QuickFindStoreContainer"] = $53cccb73f693e341$export$3e5bb5570cf53089;

});

parcelRegister("eUI6V", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $lj9HS = parcelRequire("lj9HS");

function $fe7ce83b909ba07b$export$865a2f088c837665() {
    const { canAnimate: canAnimate } = (0, $lj9HS.useConnectAppsCooldown)();
    const suppressAtMount = (0, $cozmU.useRef)(canAnimate());
    return suppressAtMount.current;
}
module.exports["useShouldSuppressBannerForAnimation"] = $fe7ce83b909ba07b$export$865a2f088c837665;

});

parcelRegister("fq2CX", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iDrrr = parcelRequire("iDrrr");


var $esfRg = parcelRequire("esfRg");


var $8fNUp = parcelRequire("8fNUp");


var $bhyuO = parcelRequire("bhyuO");


var $6yu7A = parcelRequire("6yu7A");


var $9pcjO = parcelRequire("9pcjO");

const $0208c4d27a824e4a$export$6244fd8f3fa9025d = ({ cloudId: cloudId, experience: experience, productCount: productCount, usages: usages })=>{
    return {
        action: 'taskSuccess',
        actionSubject: 'smartLinkUsageFetch',
        eventType: 'operational',
        source: experience === (0, $9pcjO.SearchExperience).QUICK_FIND ? (0, $6yu7A.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yu7A.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                cloudId: cloudId,
                productCount: productCount,
                usages: usages ? JSON.stringify(usages) : undefined
            }
        }
    };
};
const $0208c4d27a824e4a$export$973cdfe8c0b26a2b = ({ cloudId: cloudId, experience: experience, reason: reason })=>{
    return {
        action: 'taskFail',
        actionSubject: 'smartLinkUsageFetch',
        eventType: 'operational',
        source: experience === (0, $9pcjO.SearchExperience).QUICK_FIND ? (0, $6yu7A.SEARCH_DIALOG_EVENT_SOURCE) : (0, $6yu7A.EVENT_SOURCE),
        attributes: {
            additionalAttributes: {
                cloudId: cloudId,
                reason: reason
            }
        }
    };
};



var $cJff5 = parcelRequire("cJff5");


var $fd0l2 = parcelRequire("fd0l2");


var $fR63l = parcelRequire("fR63l");


var $dvVWp = parcelRequire("dvVWp");




const $e33ca8d70c8991e5$export$98ca9e3e34f377b = ({ isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts })=>{
    let productOrder = [];
    if (isOnSearchDialog) // TODO: we should consolidate the behaviour of banners between FPS and QF (both order and what products are shown).
    // See https://atlassian.slack.com/archives/C0A8GKLU6PQ/p1770850523754429
    productOrder = [
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        (0, $fR63l.ProductKeys3P).Sharepoint,
        (0, $fR63l.ProductKeys3P).Slack,
        (0, $fR63l.ProductKeys3P).Teams,
        (0, $fR63l.ProductKeys3P).Github,
        (0, $fR63l.ProductKeys3P).Figma,
        (0, $fR63l.ProductKeys3P).Gitbook
    ];
    else {
        const requiredProducts = [];
        (0, $fd0l2.ThirdPartyConfigsSync).forEach((_, productKey3P)=>{
            if ((0, $fd0l2.ThirdPartyConfigsSync).get(productKey3P)?.requiresOauth) requiredProducts.push(productKey3P);
        });
        // Filter and order static products based on PRODUCTS_ORDER
        const staticProducts = (0, $dvVWp.PRODUCTS_ORDER).filter((product)=>requiredProducts.includes(product));
        // Add Forge connectors that need OAuth (ordered after static products)
        const forgeConnectors = availableProducts.filter((product)=>(0, $8fNUp.isForgeConnectorProductKey)(product) && thirdPartyConfigs[product]?.userNeedsOAuth && thirdPartyConfigs[product]?.outboundAuthUrl);
        productOrder = [
            ...staticProducts,
            ...forgeConnectors
        ];
    }
    return productOrder.filter((product)=>availableProducts.includes(product));
};



var $dsOco = parcelRequire("dsOco");


var $32Eau = parcelRequire("32Eau");




const $00a2e817e8110fe9$export$ce0553f0f2dae7c8 = {
    'widely-adopted': 25,
    'mid-adoption': 15,
    niche: 10
};
const $00a2e817e8110fe9$export$b64145217f45680a = {
    'widely-adopted': new Set([
        (0, $fR63l.ProductKeys3P).GoogleDrive,
        (0, $fR63l.ProductKeys3P).Slack,
        (0, $fR63l.ProductKeys3P).Github,
        (0, $fR63l.ProductKeys3P).Figma,
        (0, $fR63l.ProductKeys3P).OneDrive,
        (0, $fR63l.ProductKeys3P).Gitlab,
        (0, $fR63l.ProductKeys3P).AzureDevops,
        (0, $fR63l.ProductKeys3P).Sentry,
        (0, $fR63l.ProductKeys3P).Miro,
        (0, $fR63l.ProductKeys3P).Salesforce,
        (0, $fR63l.ProductKeys3P).Notion,
        (0, $fR63l.ProductKeys3P).Sharepoint
    ]),
    'mid-adoption': new Set([
        (0, $fR63l.ProductKeys3P).Pipedrive,
        (0, $fR63l.ProductKeys3P).Box,
        (0, $fR63l.ProductKeys3P).ClickUp,
        (0, $fR63l.ProductKeys3P).Hubspot,
        (0, $fR63l.ProductKeys3P).Asana
    ]),
    niche: new Set([
        (0, $fR63l.ProductKeys3P).Todoist,
        (0, $fR63l.ProductKeys3P).Zeplin,
        (0, $fR63l.ProductKeys3P).Dropbox,
        (0, $fR63l.ProductKeys3P).Lucid,
        (0, $fR63l.ProductKeys3P).Amplitude,
        (0, $fR63l.ProductKeys3P).Mural,
        (0, $fR63l.ProductKeys3P).Airtable,
        (0, $fR63l.ProductKeys3P).LaunchDarkly,
        (0, $fR63l.ProductKeys3P).Stripe,
        (0, $fR63l.ProductKeys3P).Smartsheet,
        (0, $fR63l.ProductKeys3P).Docusign,
        (0, $fR63l.ProductKeys3P).PagerDuty,
        (0, $fR63l.ProductKeys3P).Teams,
        (0, $fR63l.ProductKeys3P).Dovetail,
        (0, $fR63l.ProductKeys3P).Webex
    ])
};
// Reverse lookup for quicker/easier product → tier resolution.
const $00a2e817e8110fe9$var$CONNECTOR_TO_TIER = new Map(Object.entries($00a2e817e8110fe9$export$b64145217f45680a).flatMap(([tier, products])=>[
        ...products
    ].map((product)=>[
            product,
            tier
        ])));
const $00a2e817e8110fe9$export$bcc396963ce06343 = (product)=>{
    return $00a2e817e8110fe9$var$CONNECTOR_TO_TIER.get(product) ?? 'niche';
};
const $00a2e817e8110fe9$export$fb50a930cc5288bf = (product)=>{
    return $00a2e817e8110fe9$export$ce0553f0f2dae7c8[$00a2e817e8110fe9$export$bcc396963ce06343(product)];
};
const $00a2e817e8110fe9$export$835ec42bc9d6e801 = (product, usagePercent)=>{
    if (usagePercent === undefined) return true;
    const threshold = $00a2e817e8110fe9$export$fb50a930cc5288bf(product);
    return usagePercent >= threshold;
};


const $048ea08a2a4e64ef$export$8e364fc6aecba9a9 = (experience, cloudId)=>{
    const [smartLinkUsage, setSmartLinkUsage] = (0, $cozmU.useState)(undefined);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)({
        experience: experience
    });
    // NO EXPOSURE! Allocate to short-circuit the hook if the experiment is disabled.
    const bannerTargetingCohort = (0, $cJff5.serveImproveBannerTargetingExperiment)({
        fireExperimentExposure: false
    });
    (0, $cozmU.useEffect)(()=>{
        if (bannerTargetingCohort === 'usage-threshold' && cloudId) (0, $esfRg.getTenantSmartlinkUsage)({
            siteId: cloudId
        }).then((usageData)=>{
            setSmartLinkUsage(usageData);
            fireAnalyticsEvent((0, $0208c4d27a824e4a$export$6244fd8f3fa9025d)({
                cloudId: cloudId,
                experience: experience,
                productCount: Object.keys(usageData).length,
                usages: usageData
            }));
        }).catch((error)=>{
            fireAnalyticsEvent((0, $0208c4d27a824e4a$export$973cdfe8c0b26a2b)({
                cloudId: cloudId,
                experience: experience,
                reason: error instanceof Error ? error.message : String(error)
            }));
        });
    }, [
        bannerTargetingCohort,
        cloudId,
        experience,
        fireAnalyticsEvent
    ]);
    return smartLinkUsage;
};
const $048ea08a2a4e64ef$export$7e6da2e188a2a79d = ({ products: products, thirdPartyConfigs: thirdPartyConfigs })=>{
    // NO EXPOSURE! Allocate to short-circuit the hook if the experiment is disabled.
    const cohort = (0, $cJff5.serveImproveBannerTargetingExperiment)({
        fireExperimentExposure: false
    });
    const isUsageThresholdCohort = cohort === 'usage-threshold';
    const isBannerOptedOut = (0, $iDrrr.fg)('rovo_search_3p_banner_opt_out');
    const isActive = isUsageThresholdCohort && !isBannerOptedOut;
    const usageData = (0, $32Eau.useSmartLinkUsage)();
    return (0, $cozmU.useMemo)(()=>{
        if (!isActive || !usageData) return products;
        return products.filter((product)=>{
            const config = thirdPartyConfigs[product];
            const isSmartlinksOnly = config?.connectorSources?.includes((0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE)) && !config?.connectorSources?.includes((0, $8fNUp.FULL_CONNECTOR_SOURCE));
            // The logic to hide banners based on usage is only applicable to smart-link connectors
            // and only if there's no full-connector for the same product.
            if (!isSmartlinksOnly) return true;
            return (0, $00a2e817e8110fe9$export$835ec42bc9d6e801)(product, usageData[product]);
        });
    }, [
        isActive,
        usageData,
        products,
        thirdPartyConfigs
    ]);
};
const $048ea08a2a4e64ef$export$51f63d7c1c9ec5d4 = ({ isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, availableProducts: availableProducts })=>{
    const bannerTargetingCohort = (0, $cJff5.serveImproveBannerTargetingExperiment)();
    const orderedAvailableProducts = (0, $cozmU.useMemo)(()=>(0, $e33ca8d70c8991e5$export$98ca9e3e34f377b)({
            isOnSearchDialog: isOnSearchDialog,
            thirdPartyConfigs: thirdPartyConfigs,
            availableProducts: availableProducts
        }), [
        isOnSearchDialog,
        thirdPartyConfigs,
        availableProducts
    ]);
    const productsWithSufficientUsage = $048ea08a2a4e64ef$export$7e6da2e188a2a79d({
        products: orderedAvailableProducts,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const orderedAvailableProductsAfterUsageFilter = (0, $cozmU.useMemo)(()=>{
        if (bannerTargetingCohort === 'usage-threshold' && productsWithSufficientUsage?.length) return orderedAvailableProducts.filter((p)=>productsWithSufficientUsage.includes(p));
        return orderedAvailableProducts;
    }, [
        orderedAvailableProducts,
        bannerTargetingCohort,
        productsWithSufficientUsage
    ]);
    const enforceMaxDismissals = true;
    return orderedAvailableProductsAfterUsageFilter.filter((product)=>(0, $bhyuO.shouldShowOAuthBanner)(product, enforceMaxDismissals));
};
module.exports["useFetchSmartLinkUsage"] = $048ea08a2a4e64ef$export$8e364fc6aecba9a9;
module.exports["useBannerEligibleProductsOrder"] = $048ea08a2a4e64ef$export$51f63d7c1c9ec5d4;

});

parcelRegister("esfRg", function(module, exports) {

var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");


var $9C63M = parcelRequire("9C63M");


var $3OOLc = parcelRequire("3OOLc");


var $b3qPd = parcelRequire("b3qPd");

const { refreshOnAccessDecorator: $5d1f628fd49a3aa7$var$refreshOnAccessDecoratorSmartlink, get: $5d1f628fd49a3aa7$var$getSmartlinkCache, clear: $5d1f628fd49a3aa7$var$clearSmartlinkCache } = (0, $fyjce.promiseCache)({
    name: (0, $3OOLc.SEARCH_PERSONALIZATION_SMARTLINK_SITE_CACHE_KEY),
    expiration: (0, $3OOLc.SEVEN_DAY_MS_TTL)
});
const $5d1f628fd49a3aa7$var$fetchSiteSmartlinkService = async (siteId)=>{
    const requestUrl = (0, $b3qPd.getSmartlinkSiteTraitsUrl)(siteId);
    const requestOptions = {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    };
    return fetch(requestUrl, requestOptions).then((response)=>{
        if (response.ok) return response.json();
        return Promise.reject({
            code: response.status,
            reason: response.statusText
        });
    });
};
const $5d1f628fd49a3aa7$var$fetchSmartlinkProductUsageRate = async ({ siteId: siteId, analyticsCallback: analyticsCallback, cacheKeySuffix: cacheKeySuffix, degradationCallback: degradationCallback = ()=>{} })=>{
    const key = (0, $bZF61.generateHash)(`${(0, $3OOLc.SEARCH_PERSONALIZATION_SMARTLINK_SITE_CACHE_KEY)}|${siteId}|${cacheKeySuffix}`);
    const supplier = async ()=>{
        const fetchPromise = $5d1f628fd49a3aa7$var$fetchSiteSmartlinkService(siteId).then((data)=>{
            const { attributes: attributes } = data;
            return attributes?.find((t)=>t.name === (0, $3OOLc.SMARTLINK_APP_EXPOSURE_RATE_TRAIT));
        }).catch(()=>undefined); // treat non-200 as empty and avoid caching a rejected promise
        const degrader = new (0, $9C63M.DegradablePromise)(fetchPromise, degradationCallback, 1000); // 1s degrade threshold
        return degrader.promise().catch(async (e)=>{
            // On degrade/timeout, re-set cache entry to resolved undefined with ONE_HOUR_TTL
            // so callers won't hammer the service for the next hour, but will retry after.
            // Since we're in supplier, we can't directly set here without re-entrant complexity.
            // Instead, throw and let refreshOnAccessDecorator store this rejecting promise; after this call,
            // callers should rely on our external code path to clear or retry as needed.
            throw e;
        });
    };
    const existing = $5d1f628fd49a3aa7$var$getSmartlinkCache(key.toString());
    // Choose TTL based on outcome:
    // - success (non-empty trait): default SEVEN_DAY_TTL
    // - empty (undefined): ONE_DAY_TTL
    // - degraded (timeout/reject): ONE_HOUR_TTL
    // We cannot know the outcome until supplier resolves/rejects; so we approximate:
    //   if no existing value, we assume empty path (ONE_HOUR_MS_TTL) to avoid hammering
    //   then, within supplier, we adjust by re-setting the cache on rejection with ONE_HOUR_TTL
    const effectiveExpiration = !existing?.storedValue ? (0, $3OOLc.ONE_HOUR_MS_TTL) : undefined;
    const effectiveOnlyRefreshIfExpired = true;
    // Helper to re-write the cached value with a specific TTL without re-fetching
    const writeBackWithTTL = (value, ttl)=>{
        $5d1f628fd49a3aa7$var$refreshOnAccessDecoratorSmartlink({
            key: key.toString(),
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            // force refresh to apply new TTL
            expiration: ttl
        });
    };
    return $5d1f628fd49a3aa7$var$refreshOnAccessDecoratorSmartlink({
        key: key.toString(),
        supplier: async ()=>{
            try {
                const result = await supplier(); // Trait | undefined (no degrade)
                if (result) writeBackWithTTL(result, (0, $3OOLc.SEVEN_DAY_MS_TTL));
                else writeBackWithTTL(undefined, (0, $3OOLc.ONE_DAY_MS_TTL));
                return result;
            } catch  {
                // On degrade/timeout, return undefined so promiseCache stores an "empty" value
                // and then write back a short TTL to avoid hammering
                writeBackWithTTL(undefined, (0, $3OOLc.ONE_HOUR_MS_TTL));
                return undefined;
            }
        },
        onlyRefreshIfExpired: effectiveOnlyRefreshIfExpired,
        expiration: effectiveExpiration,
        analyticsCallback: analyticsCallback
    });
};
const $5d1f628fd49a3aa7$export$a618d8f3094322c9 = (key)=>$5d1f628fd49a3aa7$var$clearSmartlinkCache(key);
const $5d1f628fd49a3aa7$export$f0ea64eab9ebcb2f = (trait)=>{
    if (trait?.name === (0, $3OOLc.SMARTLINK_APP_EXPOSURE_RATE_TRAIT) && typeof trait?.value === 'string') {
        const result = {};
        const pairs = trait.value.split(',').map((s)=>s.trim());
        for (const pair of pairs){
            const [app, rateStr] = pair.split(':').map((s)=>s.trim());
            if (app && rateStr) {
                const rate = parseInt(rateStr, 10);
                if (!isNaN(rate)) result[app] = rate;
            }
        }
        return result;
    }
    return {};
};
const $5d1f628fd49a3aa7$export$b95bec45d0bca567 = async ({ siteId: siteId, analyticsCallback: analyticsCallback, degradationCallback: degradationCallback })=>{
    if (!siteId) return {};
    const trait = await $5d1f628fd49a3aa7$var$fetchSmartlinkProductUsageRate({
        siteId: siteId,
        analyticsCallback: analyticsCallback,
        degradationCallback: degradationCallback,
        cacheKeySuffix: 'rovo-search-smartlink-usage'
    });
    return $5d1f628fd49a3aa7$export$f0ea64eab9ebcb2f(trait);
};
module.exports["getTenantSmartlinkUsage"] = $5d1f628fd49a3aa7$export$b95bec45d0bca567;

});

parcelRegister("3OOLc", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $7253096097f49bfd$export$34e8837a1913e572 = 'search-personalization-site-user';
const $7253096097f49bfd$export$f80bd7d8a13f050a = 604800000; // 7 days
const $7253096097f49bfd$export$18406d9c8318a338 = 86400000; // 1 day
const $7253096097f49bfd$export$2383b9b3bc711073 = 3600000; // 1 hour
const $7253096097f49bfd$export$d0bbd8e7f2e797 = 'search_user_3p_recommendations_right_panel_v1';
const $7253096097f49bfd$export$330c7df40d69ab27 = 'search-personalization-smartlink-site';
const $7253096097f49bfd$export$15fc832cc21ada61 = 'smartlink_app_exposure_rate';
const $7253096097f49bfd$export$c25c73d04a24471b = 'search-personalization-smartlink-usage-and-top-apps-site';
const $7253096097f49bfd$export$7b7ea824b946adee = 'rovo_nudge_end_user_rendered_smartlinks_percent_and_most_used_apps';
module.exports["SEARCH_PERSONALIZATION_BY_SITE_USER_CACHE_KEY"] = $7253096097f49bfd$export$34e8837a1913e572;
module.exports["SEVEN_DAY_MS_TTL"] = $7253096097f49bfd$export$f80bd7d8a13f050a;
module.exports["ONE_DAY_MS_TTL"] = $7253096097f49bfd$export$18406d9c8318a338;
module.exports["ONE_HOUR_MS_TTL"] = $7253096097f49bfd$export$2383b9b3bc711073;
module.exports["RIGHT_PANEL_TRAIT"] = $7253096097f49bfd$export$d0bbd8e7f2e797;
module.exports["SEARCH_PERSONALIZATION_SMARTLINK_SITE_CACHE_KEY"] = $7253096097f49bfd$export$330c7df40d69ab27;
module.exports["SMARTLINK_APP_EXPOSURE_RATE_TRAIT"] = $7253096097f49bfd$export$15fc832cc21ada61;

});

parcelRegister("bhyuO", function(module, exports) {

var $6dPGs = parcelRequire("6dPGs");

const $8b926be8ea5670fb$var$OAUTH_BANNER_DISMISS_KEY = 'atlassian.unified-search.oauth-banner-dismiss-counts';
const $8b926be8ea5670fb$export$afe8c16e492e553f = (product, enforceMaxDismissals)=>{
    const dismissCounts = $8b926be8ea5670fb$var$getLocalStorageData();
    const hasUserDismissedThisProductBefore = (dismissCounts[product] ?? 0) > 0;
    if (enforceMaxDismissals) return !(hasUserDismissedThisProductBefore || $8b926be8ea5670fb$export$67e3eb5caec4ff4c(dismissCounts));
    return !hasUserDismissedThisProductBefore;
};
/**
 * The max number of times the user dismisses **across products**
 */ const $8b926be8ea5670fb$var$MAX_DISMISSALS = 4;
const $8b926be8ea5670fb$export$67e3eb5caec4ff4c = (dismissCounts)=>{
    const totalDismissalsAcrossProducts = Object.values(dismissCounts).reduce((prev, curr)=>(prev ?? 0) + (curr ?? 0), 0);
    return (totalDismissalsAcrossProducts ?? 0) >= $8b926be8ea5670fb$var$MAX_DISMISSALS;
};
const $8b926be8ea5670fb$export$94f957a0ee1d39c8 = (product)=>{
    const dismissCounts = $8b926be8ea5670fb$var$getLocalStorageData();
    dismissCounts[product] = (dismissCounts[product] ?? 0) + 1;
    $8b926be8ea5670fb$var$saveToLocalStorage(dismissCounts);
};
/**
 * @returns the local storage object that stores products and their dismiss counts
 */ const $8b926be8ea5670fb$var$getLocalStorageData = ()=>{
    const serializedDismissCounts = (0, $6dPGs.getLocalStorageItemAsString)($8b926be8ea5670fb$var$OAUTH_BANNER_DISMISS_KEY);
    if (!serializedDismissCounts) return {};
    let localStorageObject;
    try {
        localStorageObject = JSON.parse(serializedDismissCounts);
    } catch  {
        return {};
    }
    return localStorageObject;
};
/**
 * Saves the local storage object that stores products and their dismiss counts
 */ const $8b926be8ea5670fb$var$saveToLocalStorage = (localStorageObject)=>{
    (0, $6dPGs.setLocalStorageItem)($8b926be8ea5670fb$var$OAUTH_BANNER_DISMISS_KEY, JSON.stringify(localStorageObject));
};
module.exports["shouldShowOAuthBanner"] = $8b926be8ea5670fb$export$afe8c16e492e553f;
module.exports["increaseProductDismissCount"] = $8b926be8ea5670fb$export$94f957a0ee1d39c8;

});

parcelRegister("AgYeH", function(module, exports) {
function $700a8f1c3e364ff2$export$2066b2fdce449999({ atlWorkspaceId: atlWorkspaceId, tenantId: tenantId, product: product }) {
    const atlAttributionHeader = {
        atlWorkspaceId: atlWorkspaceId,
        tenantId: tenantId,
        product: product
    };
    return JSON.stringify(atlAttributionHeader);
}
function $700a8f1c3e364ff2$export$dbbc0a36865f0300({ cloudId: cloudId, product: product = 'platform', activationId: activationId }) {
    if (!cloudId) return undefined;
    const atlWorkspaceId = activationId ? `ari:cloud:${product}:${cloudId}:workspace/${activationId}` : undefined;
    const headerValue = $700a8f1c3e364ff2$export$2066b2fdce449999({
        ...atlWorkspaceId ? {
            atlWorkspaceId: atlWorkspaceId
        } : {},
        tenantId: cloudId,
        product: product
    });
    return {
        'atl-attribution': headerValue
    };
}
module.exports["createAtlAttributionHeaderValue"] = $700a8f1c3e364ff2$export$2066b2fdce449999;
module.exports["buildAtlAttributionHeaders"] = $700a8f1c3e364ff2$export$dbbc0a36865f0300;

});

parcelRegister("1sz28", function(module, exports) {
$parcel$export(module.exports, "CancelError", () => (parcelRequire("ZLNmD")).CancelError);

var $ZLNmD = parcelRequire("ZLNmD");

const $38db88d18aad1515$var$CANCEL_ERROR = new (0, $ZLNmD.CancelError)('Promise is cancelled');
class $38db88d18aad1515$export$5782acf08706f13d {
    static from(promise) {
        return new $38db88d18aad1515$export$5782acf08706f13d(promise);
    }
    constructor(promise){
        this.cancellablePromiseInternal = void 0;
        this.cancelInternal = ()=>{
            // Default throws an error as this should never happen
            throw new Error('Programming error, cancelling promise is not properly rejected');
        };
        this.promise = ()=>this.cancellablePromiseInternal;
        this.cancel = ()=>this.cancelInternal();
        this.cancellablePromiseInternal = Promise.race([
            promise,
            new Promise((_, reject)=>{
                this.cancelInternal = ()=>reject($38db88d18aad1515$var$CANCEL_ERROR);
            })
        ]);
    }
}
module.exports["CancellablePromise"] = $38db88d18aad1515$export$5782acf08706f13d;

});

parcelRegister("ZLNmD", function(module, exports) {
class $3f7ced46b8e6af18$export$d7f5e52d091a66db extends Error {
    constructor(...args){
        super(...args);
        this.isCancelled = true;
    }
}
module.exports["CancelError"] = $3f7ced46b8e6af18$export$d7f5e52d091a66db;

});

parcelRegister("5RzlA", function(module, exports) {
// Pure product key constants imported from product-keys.ts (source of truth).
// Re-exported below so existing consumers continue to work.

var $dvVWp = parcelRequire("dvVWp");

const $9e02b46183d36411$export$ee811373b5708646 = (key)=>!Object.values((0, $dvVWp.ProductKeys1PForAnalytics)).includes(key);
module.exports["is3pProductKeyForAnalytics"] = $9e02b46183d36411$export$ee811373b5708646;

});

parcelRegister("bQ6i3", function(module, exports) {

var $6dPGs = parcelRequire("6dPGs");

const $4b70dfba64774c7f$export$ad9e8f9d9536c33d = ()=>{
    // The key is defined in packages/atlassian-analytics-pipeline/analytics-web-client/src/sessionTracking.ts.
    const LOCAL_STORAGE_KEY = 'awc.session.id';
    try {
        return (0, $6dPGs.getLocalStorageItemAsString)(LOCAL_STORAGE_KEY) ?? undefined;
    } catch (error) {
        return undefined;
    }
};
module.exports["getSessionIdFromLocalStorage"] = $4b70dfba64774c7f$export$ad9e8f9d9536c33d;

});

parcelRegister("jTbFT", function(module, exports) {
const $fd1c8d41c6057873$export$5e8268eaa81797f5 = {
    SEARCH_PAGE_FIRST_PARTY_CONFIG_UX: 'search-page/first-party-config-ux',
    SEARCH_PAGE_FIRST_PARTY_CONFIG_NETWORK: 'search-page/first-party-config-network',
    SEARCH_PAGE_THIRD_PARTY_CONFIG_UX: 'search-page/third-party-config-ux',
    SEARCH_PAGE_THIRD_PARTY_CONFIG_NETWORK: 'search-page/third-party-config-network',
    SEARCH_PAGE_COMBINED_CONFIG_UX: 'search-page/combined-config-ux',
    SEARCH_PAGE_COMBINED_CONFIG_NETWORK: 'search-page/combined-config-network',
    SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_UX: 'search-page/full-page-search-results-ux',
    SEARCH_PAGE_FULL_PAGE_SEARCH_RESULTS_NETWORK: 'search-page/full-page-search-results-network',
    SEARCH_PAGE_FULL_PAGE_SEARCH_ASYNC_SEARCH_RESULTS: 'search-page/full-page-search-async-search-results',
    QUICK_FIND_RECENT_ACTIVITIES_UX: 'quick-find/recent-activities-ux',
    QUICK_FIND_RECENT_ACTIVITIES_NETWORK: 'quick-find/recent-activities-network',
    QUICK_FIND_PRE_QUERY_RESULTS: 'quick-find/prequery-search-results-ux',
    QUICK_FIND_POST_QUERY_UX: 'quick-find/postquery-search-results-ux',
    QUICK_FIND_CONFLUENCE_ENTITIES_NETWORK: 'quick-find/confluence-entities-network',
    QUICK_FIND_CONFLUENCE_SPACES_NETWORK: 'quick-find/confluence-spaces-network',
    QUICK_FIND_LOOM_ENTITIES_NETWORK: 'quick-find/loom-entities-network',
    QUICK_FIND_JIRA_ISSUES_AND_TYPES_NETWORK: 'quick-find/jira-issues-and-types-network',
    QUICK_FIND_JIRA_ENTITIES_NETWORK: 'quick-find/jira-entities-network',
    QUICK_FIND_ATLAS_ENTITIES_NETWORK: 'quick-find/atlas-entities-network',
    QUICK_FIND_MERCURY_ENTITIES_NETWORK: 'quick-find/mercury-entities-network',
    QUICK_FIND_TALENT_ENTITIES_NETWORK: 'quick-find/talent-entities-network',
    QUICK_FIND_ASSETS_ENTITIES_NETWORK: 'quick-find/assets-entities-network',
    QUICK_FIND_INTENT_DETECTION_NETWORK: 'quick-find/intent-detection-network',
    QUICK_FIND_INTENT_DETECTION_UX: 'quick-find/intent-detection-ux'
};
module.exports["TASK_NAMES"] = $fd1c8d41c6057873$export$5e8268eaa81797f5;

});

parcelRegister("hnyex", function(module, exports) {


const $2edf73f89ca55348$var$baseVitalStatsEvent = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, action: action, moreContext: moreContext })=>{
    return {
        action: action,
        actionSubject: 'ui',
        eventType: 'operational',
        attributes: {
            additionalAttributes: {
                task: task,
                taskId: taskId,
                hostname: window.location.hostname,
                searchSessionId: searchSessionId,
                ...moreContext
            }
        }
    };
};
const $2edf73f89ca55348$export$656fa717a09eb821 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $2edf73f89ca55348$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskStart',
        moreContext: moreContext
    });
};
const $2edf73f89ca55348$export$3e9761d670712e50 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $2edf73f89ca55348$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskSuccess',
        moreContext: moreContext
    });
};
const $2edf73f89ca55348$export$2e311f5a2c70a936 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $2edf73f89ca55348$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskFail',
        moreContext: moreContext
    });
};
const $2edf73f89ca55348$export$807d68038784dd59 = ({ searchSessionId: searchSessionId, taskId: taskId, task: task, moreContext: moreContext })=>{
    return $2edf73f89ca55348$var$baseVitalStatsEvent({
        searchSessionId: searchSessionId,
        taskId: taskId,
        task: task,
        action: 'taskAbort',
        moreContext: moreContext
    });
};
module.exports["onTaskStart"] = $2edf73f89ca55348$export$656fa717a09eb821;
module.exports["onTaskSuccess"] = $2edf73f89ca55348$export$3e9761d670712e50;
module.exports["onTaskFail"] = $2edf73f89ca55348$export$2e311f5a2c70a936;
module.exports["onTaskAbort"] = $2edf73f89ca55348$export$807d68038784dd59;

});

parcelRegister("kPgkn", function(module, exports) {
// Modified from platform/packages/search/product-search-dialog/src/extensible/product-router/product/result-provider/faster-search-helpers.ts

var $1b6u9 = parcelRequire("1b6u9");


var $iyIUv = parcelRequire("iyIUv");

function $669765c73535f9bf$export$399f177751711473(searchResults, query, numberOfResultItems = 3, negateTitleHighlight) {
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredResults = searchResults.flatMap((result)=>{
        // 1st pass
        const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
            if (!acc) return acc;
            return result.title.toLowerCase().includes(word.toLowerCase());
        }, true);
        if (doAllWordsMatch) {
            // 2nd and 3rd Pass
            const { highlightedTitle: highlightedTitle, negatedHighlightedTitle: negatedHighlightedTitle, score: score = 0 } = (0, $1b6u9.highlightMatchedText)(result.title, wordsInQuery);
            itemScoreMap[result.title] = score;
            return [
                {
                    ...result,
                    highlightedTitle: negateTitleHighlight ? negatedHighlightedTitle : highlightedTitle
                }
            ];
        }
        return [];
    }).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.title] - itemScoreMap[item.title] : 0).slice(0, numberOfResultItems);
    return filteredResults;
}
function $669765c73535f9bf$export$18f3758fc3685a84(searchResults, query) {
    const wordsInQuery = query.split(' ');
    const itemScoreMap = {};
    const filteredResults = searchResults.flatMap((result)=>{
        // 1st pass
        const doAllWordsMatch = wordsInQuery.reduce((acc, word)=>{
            if (!acc) return acc;
            return result.title.toLowerCase().includes(word.toLowerCase());
        }, true);
        if (doAllWordsMatch) {
            // 2nd and 3rd Pass
            const { score: score = 0 } = (0, $1b6u9.highlightMatchedText)(result.title, wordsInQuery);
            itemScoreMap[result.title] = score;
            return [
                {
                    ...result
                }
            ];
        }
        return [];
    }).sort((item, secondItem)=>item && secondItem ? itemScoreMap[secondItem.title] - itemScoreMap[item.title] : 0);
    return filteredResults;
}
function $669765c73535f9bf$export$bf5c34de39b9bf13(recentActivities, query) {
    const normalizedQuery = (0, $iyIUv.normalizeWorkItemKey)(query);
    // Search by both the normalized key and the literal query, deduplicating by id
    const byNormalized = normalizedQuery && query !== normalizedQuery ? $669765c73535f9bf$export$18f3758fc3685a84(recentActivities, normalizedQuery) : [];
    const byLiteral = $669765c73535f9bf$export$18f3758fc3685a84(recentActivities, query);
    const seen = new Set(byNormalized.map((r)=>r.id));
    return [
        ...byNormalized,
        ...byLiteral.filter((r)=>!seen.has(r.id))
    ];
}
module.exports["filterSearchResultsWithHighlighting"] = $669765c73535f9bf$export$399f177751711473;
module.exports["filterSearchResults"] = $669765c73535f9bf$export$18f3758fc3685a84;
module.exports["filterRecentActivities"] = $669765c73535f9bf$export$bf5c34de39b9bf13;

});

parcelRegister("1b6u9", function(module, exports) {
/**
 * Breakdown of the filtering & ordering logic :
 *
 * 0th pass: if the string has any highlight tags, remove them and continue
 * An alternate could be to exit early, but then we don't have the scoring information from the later passes
 *
 * 1st Pass - Complete match of query broken by words - This checks that all the words of the query must occur somewhere in the Title.
 *    - This is case insensitive.
 *    - This is unordered.
 *    For eg -
 *    Query - "mad max" will NOT let "Nomad" or "Climax" pass through,
 *    but  "Nomad Climax", "Madmax", "max Mad" will pass through
 *
 * 2nd Pass Scoring - Score calculation based on the kind of matches.
 *    There are 3 types - Exact match, StartsWith match & Partial match
 *    For eg -
 *    Exact Match (Score = 100) - Query: "Mad" will score "mad", "mad max" with 100.
 *            Note: Special characters stripped -  "Mad" will score "mad-max", "max-mad" with 100.
 *    StartsWith Match (Score = 10) - Query: "ark" will score "ARKK" and "Arkose Meeting" as 10
 *    Partial Match (Score = 1) - Query: "mad max" will score "Nomad Climax" as 2
 *
 *    Mix of multiple matching scenarios is possible.
 *    For example - "mad max" query will score "Mad Climax" as 100 (Exact) + 1 (Partial) = 101
 *
 * 3rd Pass - Sorting & Highlighting
 *    Sorting happens in the descending order of the score.
 *    Highlighting will match the entered query and inject necessary tags.
 *    Note: if both StartsWith and Partial matching exists in the same word then only StartsWith is highlighted
 *
 *    Two new properties are populated:
 *    1. highlightedText - highlights the query
 *    2. negatedHighlightedText - highights everything except the part that matches the query
 */ const $01f8c86da976ec83$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $01f8c86da976ec83$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $01f8c86da976ec83$var$SPECIAL_CHARACTER_REGEX = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/g;
const $01f8c86da976ec83$var$CONSECUTIVE_START_REGEX = new RegExp(`${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}`, 'g');
const $01f8c86da976ec83$var$CONSECUTIVE_END_REGEX = new RegExp(`${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`, 'g');
const $01f8c86da976ec83$var$CONSECUTIVE_START_END_REGEX = new RegExp(`${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`, 'g');
const $01f8c86da976ec83$var$ESCAPE_SPECIAL_CHARACTERS = /[.*+?^${}()|[\]\\]/g;
const $01f8c86da976ec83$var$cleanStartRegex = new RegExp($01f8c86da976ec83$var$HIGHLIGHT_START_TAG, 'g');
const $01f8c86da976ec83$var$cleanEndRegex = new RegExp($01f8c86da976ec83$var$HIGHLIGHT_END_TAG, 'g');
const $01f8c86da976ec83$export$9f4c92a576b56d82 = (source, matchWords)=>{
    // Remove any previous highlighting and regenerate
    // Supports the use case where we perform this on the frontend, and later the backend starts doing it for us first
    const cleanedSource = source.replace($01f8c86da976ec83$var$cleanStartRegex, '').replace($01f8c86da976ec83$var$cleanEndRegex, '');
    const lowerCaseMatchWords = matchWords.filter((word)=>word !== '').map((word)=>word.toLowerCase());
    const wordsDetails = cleanedSource.split(' ').map((word)=>{
        const lowerCaseWord = word.toLowerCase();
        const alphabetOnlyWord = lowerCaseWord.replace($01f8c86da976ec83$var$SPECIAL_CHARACTER_REGEX, ' ').split(' ');
        let partialCount = 0;
        let startsWithCount = 0;
        let exactMatchCount = 0;
        let exactMatch = '';
        let partialMatch = '';
        let startsWithMatch = '';
        for(let i = 0; i < lowerCaseMatchWords.length; ++i){
            if (lowerCaseWord === lowerCaseMatchWords[i] || alphabetOnlyWord.includes(lowerCaseMatchWords[i])) {
                exactMatchCount++;
                exactMatch = lowerCaseMatchWords[i];
                break;
            }
            if (lowerCaseWord.startsWith(lowerCaseMatchWords[i])) {
                startsWithCount++;
                startsWithMatch = lowerCaseMatchWords[i];
                continue;
            }
            if (lowerCaseWord.includes(lowerCaseMatchWords[i])) {
                partialCount++;
                partialMatch = lowerCaseMatchWords[i];
            }
        }
        const score = 100 * exactMatchCount + 10 * startsWithCount + partialCount;
        if (exactMatchCount > 0 || startsWithCount > 0 || partialCount > 0) {
            const pattern = exactMatchCount > 0 ? exactMatch : startsWithCount > 0 ? startsWithMatch : partialMatch;
            const regExp = new RegExp(`(${pattern.replace($01f8c86da976ec83$var$ESCAPE_SPECIAL_CHARACTERS, '\\$&')})`, 'ig');
            const openingClosingRegExp = new RegExp(`(${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}|${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG})`, 'ig');
            const highlighted = word.replace(regExp, `${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}$1${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`).replace($01f8c86da976ec83$var$CONSECUTIVE_START_END_REGEX, ``);
            const mirror = {
                [`${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}`]: `${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`,
                [`${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`]: `${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}`
            };
            const mirroredHighlighted = highlighted.replace(openingClosingRegExp, (ch)=>mirror[ch]);
            const negatedHighlight = `${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}${mirroredHighlighted}${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`.replace($01f8c86da976ec83$var$CONSECUTIVE_START_REGEX, `${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}`).replace($01f8c86da976ec83$var$CONSECUTIVE_END_REGEX, `${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`).replace($01f8c86da976ec83$var$CONSECUTIVE_START_END_REGEX, '');
            return {
                highlighted: highlighted,
                negatedHighlight: negatedHighlight,
                score: score
            };
        }
        // no match scenario
        return {
            negatedHighlight: `${$01f8c86da976ec83$var$HIGHLIGHT_START_TAG}${word}${$01f8c86da976ec83$var$HIGHLIGHT_END_TAG}`,
            highlighted: word,
            score: score
        };
    });
    const highlightedTitle = wordsDetails.map((wordObj)=>wordObj.highlighted).join(' ');
    const negatedHighlightedTitle = wordsDetails.map((wordObj)=>wordObj.negatedHighlight).join(' ');
    const finalScore = wordsDetails.reduce((acc, word)=>acc + word.score, 0);
    if (highlightedTitle !== '' && highlightedTitle !== cleanedSource) return {
        highlightedTitle: highlightedTitle,
        negatedHighlightedTitle: negatedHighlightedTitle,
        score: finalScore
    };
    return {};
};
module.exports["highlightMatchedText"] = $01f8c86da976ec83$export$9f4c92a576b56d82;

});

parcelRegister("iyIUv", function(module, exports) {
/**
 * Normalizes an issue key query by removing hyphens and spaces so that
 * queries like "AAA34", "AAA 34", and "AAA-34" all match the canonical key "AAA-34".
 * Returns undefined if the value does not look like an issue key.
 */ const $69c994a3660d08f7$export$2c6ff4235668ce91 = (value)=>{
    const normalized = value.replace(/^([a-zA-Z]+)[\s-]?(\d+)$/, '$1-$2').toLowerCase();
    return normalized !== value.toLowerCase() || /^[a-zA-Z]+-\d+$/.test(value) ? normalized : undefined;
};
module.exports["normalizeWorkItemKey"] = $69c994a3660d08f7$export$2c6ff4235668ce91;

});

parcelRegister("krr0S", function(module, exports) {

var $dmqXD = parcelRequire("dmqXD");


var $6onJ6 = parcelRequire("6onJ6");

const $9d711010670eb6ee$export$3d3f5f86906a7f73 = (0, $dmqXD.KnowledgeDiscoveryJiraSearchClassification);
const $9d711010670eb6ee$export$928cec68d7595d16 = (0, $6onJ6.disposableValue)(null);
const $9d711010670eb6ee$export$3d750f4e9f4d0fc8 = {
    Jql: 'JQL'
};
const $9d711010670eb6ee$export$5cd976a4b4b84eb3 = (currentQuery)=>{
    const stored = $9d711010670eb6ee$export$928cec68d7595d16.value();
    if (!stored || stored.patternType !== $9d711010670eb6ee$export$3d750f4e9f4d0fc8.Jql) return false;
    return stored.query.trim() === currentQuery.trim();
};
module.exports["IntentMode"] = $9d711010670eb6ee$export$3d3f5f86906a7f73;
module.exports["INTENT_DETECTION"] = $9d711010670eb6ee$export$928cec68d7595d16;
module.exports["PatternType"] = $9d711010670eb6ee$export$3d750f4e9f4d0fc8;
module.exports["isJqlQueryDetected"] = $9d711010670eb6ee$export$5cd976a4b4b84eb3;

});

parcelRegister("dmqXD", function(module, exports) {
const $4121050074bea17a$export$52027d47033ea8ad = {
    GNIN: 'GNIN',
    FPS: 'FPS'
};
module.exports["KnowledgeDiscoveryJiraSearchClassification"] = $4121050074bea17a$export$52027d47033ea8ad;

});

parcelRegister("9gI1G", function(module, exports) {
/**
 * This file provides the necessary wrappers and utility functions to provide
 * analytics data for Quick Find result positions. Quick Find analytics contains
 * data such as the number of results, the number of sections, and the
 * position / section of a selected result.
 *
 * It does this by using the DOM as the source of truth rather than having to
 * maintain section objects and indexes in the code. This allows rendering
 * display components to be simplified and could prove to be more robust, e.g.
 * if a search result doesn't render due to an error and subsequently hits
 * its error boundary, section and results count remain correct.
 *
 * There is however the requirement that all heading and results components
 * are siblings in the DOM tree.
 */ /* eslint-disable @atlaskit/platform/no-direct-document-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ 
var $cozmU = parcelRequire("cozmU");


var $fNtG8 = parcelRequire("fNtG8");

var $esV19 = parcelRequire("esV19");

var $k5sGX = parcelRequire("k5sGX");

var $c1a3c9ec44435bf6$require$differenceInMinutes = $fNtG8.default;
var $c1a3c9ec44435bf6$require$parseISO = $k5sGX.default;
var $c1a3c9ec44435bf6$require$isValid = $esV19.default;
const $c1a3c9ec44435bf6$export$e7b6022782937b95 = 'search-dialog-heading';
const $c1a3c9ec44435bf6$export$926357658a80ff2a = 'search-dialog-result';
const $c1a3c9ec44435bf6$export$f8cbabfc03558964 = 'bulk-connect-banner';
const $c1a3c9ec44435bf6$var$resultTypes = [
    'peopleAndTeams',
    'recentQueries',
    'recentActivities',
    'queryFilters',
    'searchResults',
    'zeroQueries',
    'autocompleteSuggestions',
    'intentRouter',
    'recommendations',
    'intentRouterWorkItem'
];
const $c1a3c9ec44435bf6$export$8814e97d826fd90d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ children: children, id: id, ...rest }, ref)=>{
    return(// Ignoring this check as class is not being used for styling
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: $c1a3c9ec44435bf6$export$e7b6022782937b95,
        "data-section-id": id,
        "data-testid": "search-dialog-heading-analytics-wrapper",
        ref: ref,
        ...rest
    }, children));
});
const $c1a3c9ec44435bf6$export$e01f22447ddebe43 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ children: children, resultType: resultType, product: product, id: id, connectorType: connectorType, minutesSinceActivityTimestamp: minutesSinceActivityTimestamp, recentActivityEventType: recentActivityEventType, objectType: objectType, zeroQueryType: zeroQueryType, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        // Ignoring this check as class is not being used for styling
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: $c1a3c9ec44435bf6$export$926357658a80ff2a,
        "data-result-type": resultType,
        "data-product": product,
        "data-id": id,
        "data-connector-type": connectorType,
        "data-since-activity-timestamp": minutesSinceActivityTimestamp,
        "data-recent-activity-event-type": recentActivityEventType,
        "data-object-type": objectType,
        "data-zero-query-type": zeroQueryType,
        ref: ref,
        ...rest
    }, children);
});
const $c1a3c9ec44435bf6$export$75fc08fd8853e1c3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef(({ children: children, ...rest }, ref)=>{
    return(// Ignoring this check as class is not being used for styling
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        className: $c1a3c9ec44435bf6$export$f8cbabfc03558964,
        ref: ref,
        ...rest
    }, children));
});
const $c1a3c9ec44435bf6$export$1be6c28d5e945bdf = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$926357658a80ff2a));
    const counts = {};
    for(let i = 0; i < resultNodes.length; i++){
        const product = resultNodes[i].getAttribute('data-product');
        if (!product) continue;
        counts[product] = (counts[product] ?? 0) + 1;
    }
    return counts;
};
const $c1a3c9ec44435bf6$export$e21758a6ca606f0a = ()=>{
    return Object.keys($c1a3c9ec44435bf6$export$1be6c28d5e945bdf());
};
const $c1a3c9ec44435bf6$export$a9cb3c6c659d9dfe = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$926357658a80ff2a));
    const productSet = new Set();
    for(let i = 0; i < resultNodes.length; i++){
        if (resultNodes[i].getAttribute('data-result-type') !== 'recommendations') continue;
        const product = resultNodes[i].getAttribute('data-product');
        product && productSet.add(product);
    }
    return Array.from(productSet);
};
const $c1a3c9ec44435bf6$export$d812a070b2ee9d66 = ()=>{
    const bannerNode = document.querySelector(`.${$c1a3c9ec44435bf6$export$f8cbabfc03558964}`);
    return bannerNode !== null;
};
const $c1a3c9ec44435bf6$var$isNotRecentQuery = (product)=>{
    return Boolean(product);
};
function $c1a3c9ec44435bf6$export$4e2371c785c39b57(compareWithTimeInMs) {
    try {
        if (typeof compareWithTimeInMs !== 'string') return null;
        const startTime = $c1a3c9ec44435bf6$require$parseISO(compareWithTimeInMs);
        if (!$c1a3c9ec44435bf6$require$isValid(startTime)) return null;
        const difference = $c1a3c9ec44435bf6$require$differenceInMinutes(new Date(), startTime, 'floor');
        return difference >= 0 ? difference : null;
    } catch  {
        // Swallowing error, bad timestamp should not throw error
        return null;
    }
}
/**
 * Maps each result's data-id to its sectionId by walking sibling heading/result
 * nodes, mirroring how `ItemsAnalyticsProvider.getItemIndexes` resolves sectionId.
 */ const $c1a3c9ec44435bf6$var$buildResultSectionIdMap = ()=>{
    const map = new Map();
    let allNodes;
    try {
        allNodes = $c1a3c9ec44435bf6$var$getAllHeadingsAndResults().allNodes;
    } catch  {
        return map;
    }
    let currentSectionId = null;
    for (const node of allNodes){
        if ($c1a3c9ec44435bf6$var$isHeading(node)) currentSectionId = node.getAttribute('data-section-id');
        else if ($c1a3c9ec44435bf6$var$isResult(node)) {
            const resultId = node.getAttribute('data-id');
            if (resultId) map.set(resultId, currentSectionId);
        }
    }
    return map;
};
const $c1a3c9ec44435bf6$export$8841f6f549512fc2 = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$926357658a80ff2a));
    const sectionIdMap = $c1a3c9ec44435bf6$var$buildResultSectionIdMap();
    const resultList = [];
    for(let i = 0; i < resultNodes.length; i++){
        const id = resultNodes[i].getAttribute('data-id');
        const product = resultNodes[i].getAttribute('data-product');
        const connectorType = resultNodes[i].getAttribute('data-connector-type');
        const resultType = resultNodes[i].getAttribute('data-result-type');
        const rawMinutesSinceActivityTimestamp = parseInt(resultNodes[i].getAttribute('data-since-activity-timestamp') || '', 10);
        const minutesSinceActivityTimestamp = isNaN(rawMinutesSinceActivityTimestamp) ? null : rawMinutesSinceActivityTimestamp;
        // Missing attribute -> explicit `null` (mirrors `minutesSinceActivityTimestamp`).
        const recentActivityEventType = resultNodes[i].getAttribute('data-recent-activity-event-type') || null;
        // Missing attribute -> `null` here; the field is then omitted from the
        // payload below (see the conditional spread in `metadata`).
        const objectType = resultNodes[i].getAttribute('data-object-type') || null;
        if (id && $c1a3c9ec44435bf6$var$isNotRecentQuery(product)) {
            const resultShown = {
                id: id,
                product: product,
                position: i,
                metadata: {
                    minutesSinceActivityTimestamp: minutesSinceActivityTimestamp,
                    ...connectorType && {
                        connectorType: connectorType
                    },
                    resultType: resultType,
                    sectionId: sectionIdMap.get(id) ?? null,
                    recentActivityEventType: recentActivityEventType,
                    // Omit `objectType` entirely when unknown (absent DOM attribute).
                    ...objectType != null && {
                        objectType: objectType
                    }
                }
            };
            resultList.push(resultShown);
        }
    }
    return resultList;
};
const $c1a3c9ec44435bf6$export$837a07087631b7e0 = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$926357658a80ff2a));
    const zeroQueryNodes = resultNodes.filter((node)=>node.getAttribute('data-result-type') === 'zeroQueries');
    return zeroQueryNodes.map((node, idx)=>({
            zeroQueryType: node.getAttribute('data-zero-query-type') ?? '',
            zeroQueryPosition: idx
        }));
};
const $c1a3c9ec44435bf6$export$334c5c15d40bbec1 = ()=>{
    const resultNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$926357658a80ff2a));
    return $c1a3c9ec44435bf6$var$resultTypes.reduce((o, resultType)=>{
        o[resultType] = resultNodes.filter((node)=>node.getAttribute('data-result-type') === resultType).length || 0;
        return o;
    }, {});
};
const $c1a3c9ec44435bf6$var$getAllHeadingsAndResults = ()=>{
    const headingNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$e7b6022782937b95));
    const resultNodes = Array.from(document.getElementsByClassName($c1a3c9ec44435bf6$export$926357658a80ff2a));
    if (!headingNodes.length || !resultNodes.length) return {
        allNodes: [],
        headingNodes: [],
        resultNodes: []
    };
    const parentNode = headingNodes.length ? headingNodes[0].parentNode : resultNodes.length ? resultNodes[0].parentNode : undefined;
    if (!parentNode) throw new Error('Could not find a parent node for headings and results');
    const allNodes = Array.from(parentNode.children).filter((e)=>$c1a3c9ec44435bf6$var$isHeading(e) || $c1a3c9ec44435bf6$var$isResult(e));
    return {
        allNodes: allNodes,
        headingNodes: headingNodes,
        resultNodes: resultNodes
    };
};
const $c1a3c9ec44435bf6$var$isHeading = (e)=>{
    return e.classList.contains($c1a3c9ec44435bf6$export$e7b6022782937b95);
};
const $c1a3c9ec44435bf6$var$isResult = (e)=>{
    return e.classList.contains($c1a3c9ec44435bf6$export$926357658a80ff2a) || e.querySelector(`.${$c1a3c9ec44435bf6$export$926357658a80ff2a}`) !== null;
};
const $c1a3c9ec44435bf6$export$e9dac44129e02fa9 = ()=>{
    try {
        const { allNodes: allNodes, headingNodes: headingNodes, resultNodes: resultNodes } = $c1a3c9ec44435bf6$var$getAllHeadingsAndResults();
        // If the first node is a result, then we count it as a section
        const sectionCount = allNodes.length ? headingNodes.length + ($c1a3c9ec44435bf6$var$isResult(allNodes[0]) ? 1 : 0) : 0;
        return {
            sectionCount: sectionCount,
            resultCount: resultNodes.length
        };
    } catch  {
        return {};
    }
};
module.exports["SearchDialogHeaderAnalyticsWrapper"] = $c1a3c9ec44435bf6$export$8814e97d826fd90d;
module.exports["SearchDialogResultAnalyticsWrapper"] = $c1a3c9ec44435bf6$export$e01f22447ddebe43;
module.exports["getProductResultCounts"] = $c1a3c9ec44435bf6$export$1be6c28d5e945bdf;
module.exports["getProductsInResults"] = $c1a3c9ec44435bf6$export$e21758a6ca606f0a;
module.exports["getProductsInRecommendations"] = $c1a3c9ec44435bf6$export$a9cb3c6c659d9dfe;
module.exports["getIsBulkConnectBannerShown"] = $c1a3c9ec44435bf6$export$d812a070b2ee9d66;
module.exports["calculateMinuteDifference"] = $c1a3c9ec44435bf6$export$4e2371c785c39b57;
module.exports["getResultsShown"] = $c1a3c9ec44435bf6$export$8841f6f549512fc2;
module.exports["getShownZeroQueries"] = $c1a3c9ec44435bf6$export$837a07087631b7e0;
module.exports["getResultTypeCounts"] = $c1a3c9ec44435bf6$export$334c5c15d40bbec1;
module.exports["getSectionsAndResultsCount"] = $c1a3c9ec44435bf6$export$e9dac44129e02fa9;

});

parcelRegister("1mE5s", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");


var $1hmDb = parcelRequire("1hmDb");


var $bE7SN = parcelRequire("bE7SN");


var $gPOtu = parcelRequire("gPOtu");


const $ac7a146a7f2bdd3b$var$GOOGLE_INTEGRATION_ARI = 'ari:cloud:platform::integration/google';
const $ac7a146a7f2bdd3b$export$e6a288d5cd4cda6 = (partial)=>partial.__typename === 'SearchResultGoogleDocument' || $ac7a146a7f2bdd3b$export$34ee1a2c0a1a45b7(partial) && partial.integrationId === $ac7a146a7f2bdd3b$var$GOOGLE_INTEGRATION_ARI && partial.subtype === 'document';
const $ac7a146a7f2bdd3b$export$34ee1a2c0a1a45b7 = (partial)=>partial.__typename === 'SearchResultGraphDocument';
const $ac7a146a7f2bdd3b$var$SMART_LINK_ENTITY_REGEX = /^ari:.*::remote-link/;
const $ac7a146a7f2bdd3b$export$8cc78980eb89e95d = (resultAri)=>$ac7a146a7f2bdd3b$var$SMART_LINK_ENTITY_REGEX.test(resultAri);
const $ac7a146a7f2bdd3b$export$c5fdbcc9e7462013 = ({ connectorType: connectorType, resultAri: resultAri, eventType: eventType, productKey: productKey, thirdPartyConfigs: thirdPartyConfigs })=>connectorType === (0, $1hmDb.ConnectorSources).Smartlinks || $ac7a146a7f2bdd3b$export$8cc78980eb89e95d(resultAri) || (0, $gPOtu.isProductSmartlink)({
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    }) || eventType === (0, $bE7SN.VIEWED_EVENT).SL_VIEWED || eventType === (0, $bE7SN.VIEWED_EVENT).SL_CLICKED;
const $ac7a146a7f2bdd3b$var$getProduct3PConfig = (productKey, thirdPartyConfigs)=>{
    return productKey && (0, $dvVWp.is3pProductKey)(productKey) ? thirdPartyConfigs[productKey] : null;
};
const $ac7a146a7f2bdd3b$export$15ebd9395cf27aef = ({ connectorType: connectorType, resultNodeId: resultNodeId, eventType: eventType, productKey: productKey, thirdPartyConfigs: thirdPartyConfigs })=>{
    // Return the connectorType if it's already valid
    if ((0, $8fNUp.isConnectorSource)(connectorType)) return connectorType;
    // connectorType will not exist for the following cases:
    // * when search GraphQL response returns null for connectorType
    // * when the given API doesn't return a connectorType. E.g. user documents.
    // as a result, we use fallback logic to determine the connectorType.
    if ($ac7a146a7f2bdd3b$export$c5fdbcc9e7462013({
        connectorType: connectorType,
        resultAri: resultNodeId,
        eventType: eventType,
        productKey: productKey,
        thirdPartyConfigs: thirdPartyConfigs
    })) return (0, $1hmDb.ConnectorSources).Smartlinks;
    const config = $ac7a146a7f2bdd3b$var$getProduct3PConfig(productKey, thirdPartyConfigs);
    // No config found for the product
    if (!config) return undefined;
    if (config.isFederated) return (0, $1hmDb.ConnectorSources).Federated;
    // Return the single connector source if it's valid
    if (config.connectorSources?.length === 1) {
        const source = config.connectorSources[0];
        if ((0, $8fNUp.isConnectorSource)(source)) return source;
    }
    // Default to Full for any other case where config exists
    return (0, $1hmDb.ConnectorSources).Full;
};
module.exports["isResultSmartLink"] = $ac7a146a7f2bdd3b$export$c5fdbcc9e7462013;
module.exports["getResultConnectorSource"] = $ac7a146a7f2bdd3b$export$15ebd9395cf27aef;

});

parcelRegister("bE7SN", function(module, exports) {
// Copied from confluence/next/packages/navigation-search-dialog/src/suppliers/utils/eventTypeMessage.tsx
// Extracted from @atlassian/recent-work-ui activity-event-type-message to create this
// helper function to convert timestamp to readable metadata

var $cozmU = parcelRequire("cozmU");


var $mr7nI = parcelRequire("mr7nI");


var $zxlpF = parcelRequire("zxlpF");


var $P1m33 = parcelRequire("P1m33");


var $kSwu1 = parcelRequire("kSwu1");


var $iC0LJ = parcelRequire("iC0LJ");

var $2NJB3 = parcelRequire("2NJB3");

var $609baf9740b7c579$export$d245b105c09339d8 = /*#__PURE__*/ function(VIEWED_EVENT) {
    VIEWED_EVENT["VIEWED"] = "viewed";
    VIEWED_EVENT["SL_VIEWED"] = "sl-viewed";
    VIEWED_EVENT["SL_CLICKED"] = "sl-clicked";
    VIEWED_EVENT["CLICKED"] = "clicked";
    return VIEWED_EVENT;
}({});
var $609baf9740b7c579$export$eb4e9f525aef1cc3 = /*#__PURE__*/ function(WORKED_EVENT) {
    WORKED_EVENT["COMMENTED"] = "commented";
    WORKED_EVENT["CREATED"] = "created";
    WORKED_EVENT["EDITED"] = "edited";
    WORKED_EVENT["PUBLISHED"] = "published";
    WORKED_EVENT["UPDATED"] = "updated";
    WORKED_EVENT["SHARED"] = "shared";
    return WORKED_EVENT;
}({});
function $609baf9740b7c579$export$e873c799b137eec4(date) {
    return (0, $mr7nI.default)(new Date(date), $609baf9740b7c579$var$startOfOneWeekAgo());
}
function $609baf9740b7c579$var$startOfOneWeekAgo() {
    return (0, $zxlpF.default)((0, $P1m33.default)(new Date(), 1));
}
const $609baf9740b7c579$export$9e4fb3fb50a3c754 = ({ eventType: eventType, timestamp: timestamp, isMyActivityData: isMyActivityData })=>{
    const isAbsolute = $609baf9740b7c579$export$e873c799b137eec4(timestamp);
    const message = (0, $2NJB3.useEventTypeMessage)(eventType, {
        isMyActivityData: isMyActivityData,
        isAbsolute: isAbsolute
    });
    const { value: value, unit: unit } = (0, $iC0LJ.selectUnit)(new Date(timestamp).getTime(), new Date(), {
        day: 7
    });
    const values = isAbsolute ? {
        // Show the absolute time if the activity was more than a week ago
        // e.g: You viewed on January 1, 2021
        absoluteTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedDate), {
            value: timestamp,
            month: "short",
            day: "2-digit",
            year: "numeric"
        })
    } : {
        // Show the relative time if the activity was within a week ago
        // e.g: You viewed 2 hours ago
        relativeTime: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedRelativeTime), {
            value: value,
            unit: unit
        })
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        ...message,
        values: values
    });
};
module.exports["VIEWED_EVENT"] = $609baf9740b7c579$export$d245b105c09339d8;
module.exports["WORKED_EVENT"] = $609baf9740b7c579$export$eb4e9f525aef1cc3;
module.exports["isMoreThanOneWeekAgo"] = $609baf9740b7c579$export$e873c799b137eec4;
module.exports["EventTypeMessage"] = $609baf9740b7c579$export$9e4fb3fb50a3c754;

});

parcelRegister("cRSxF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $55fM8 = parcelRequire("55fM8");

const $856f049156dd2177$export$e70e6da722faba05 = (callback, debounceTime)=>{
    const ref = (0, $cozmU.useRef)();
    (0, $cozmU.useEffect)(()=>{
        ref.current = callback;
    }, [
        callback
    ]);
    const debouncedCallback = (0, $cozmU.useMemo)(()=>{
        const func = ()=>{
            ref.current?.();
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($55fM8)))(func, debounceTime);
    }, [
        debounceTime
    ]);
    return debouncedCallback;
};
module.exports["useDebouncedCallback"] = $856f049156dd2177$export$e70e6da722faba05;

});

parcelRegister("3P0Fk", function(module, exports) {
var $4b89818c31b7a877$export$fb160374438e1cd7 = /*#__PURE__*/ function(SearchConfluenceSubtype) {
    SearchConfluenceSubtype["LIVE"] = "LIVE";
    return SearchConfluenceSubtype;
}({});
module.exports["SearchConfluenceSubtype"] = $4b89818c31b7a877$export$fb160374438e1cd7;

});

parcelRegister("7ta9v", function(module, exports) {

var $bqUaZ = parcelRequire("bqUaZ");

const $9238d4b3c991adc2$var$CONFLUENCE_VALUE_SEPARATOR = '---';
const $9238d4b3c991adc2$var$CONFLUENCE_ATTRIBUTE_SEPARATOR = '___';
const $9238d4b3c991adc2$export$ce6d1d009c92f1be = ({ url: url, query: query, searchSessionId: searchSessionId, additionalAnalytics: additionalAnalytics })=>{
    const urlObject = new URL(url);
    urlObject.searchParams.set('search_id', searchSessionId);
    let events = [];
    if (query) events.push(`queryHash${$9238d4b3c991adc2$var$CONFLUENCE_VALUE_SEPARATOR}${(0, $bqUaZ.hashData)(query)}`);
    if (additionalAnalytics) Object.entries(additionalAnalytics).forEach(([attribute, value])=>{
        events.push(`${attribute}${$9238d4b3c991adc2$var$CONFLUENCE_VALUE_SEPARATOR}${value}`);
    });
    if (events.length === 0) return urlObject.toString();
    const analyticsFormattedForUrlParsing = encodeURIComponent(events.join($9238d4b3c991adc2$var$CONFLUENCE_ATTRIBUTE_SEPARATOR));
    urlObject.searchParams.set('additional_analytics', analyticsFormattedForUrlParsing);
    return urlObject.toString();
};
const $9238d4b3c991adc2$export$2e67c54459604a9 = (additionalAnalytics)=>{
    const formattedEvents = {};
    if (typeof additionalAnalytics !== 'string') return formattedEvents;
    const events = additionalAnalytics?.split($9238d4b3c991adc2$var$CONFLUENCE_ATTRIBUTE_SEPARATOR);
    events.forEach((event)=>{
        const formattedEvent = event?.split($9238d4b3c991adc2$var$CONFLUENCE_VALUE_SEPARATOR);
        const hasProperlyFormattedEvent = formattedEvent.length === 2;
        if (hasProperlyFormattedEvent) formattedEvents[formattedEvent[0]] = formattedEvent[1];
    });
    return formattedEvents;
};
const $9238d4b3c991adc2$export$b780bd7096d811c5 = ({ url: url, searchSessionId: searchSessionId, resultId: resultId, projectId: projectId })=>{
    const jiraResultARIPattern = /^ari:cloud:jira:[a-z0-9-]+:[a-z]+\/[0-9]+$/;
    if (!resultId.match(jiraResultARIPattern)) return url;
    const jiraProjectARIPattern = /^ari:cloud:jira:[a-z0-9-]+:project\/[0-9]+$/;
    if (projectId && !projectId.match(jiraProjectARIPattern)) return url;
    const urlObject = new URL(url);
    urlObject.searchParams.set('searchSessionId', searchSessionId);
    const searchObjectId = resultId.split('/').pop();
    searchObjectId && urlObject.searchParams.set('searchObjectId', searchObjectId);
    const searchContentType = resultId.split('/')[0].split(':').pop();
    searchContentType && urlObject.searchParams.set('searchContentType', searchContentType);
    const searchContainerId = projectId?.split('/').pop();
    searchContainerId && urlObject.searchParams.set('searchContainerId', searchContainerId);
    return urlObject.toString();
};
const $9238d4b3c991adc2$export$a5abc05a86b8de68 = ({ url: url, searchSessionId: searchSessionId, customParams: customParams = new Map([]) })=>{
    const urlObject = new URL(url);
    urlObject.searchParams.set('search_id', searchSessionId);
    customParams.forEach((value, key)=>{
        urlObject.searchParams.set(key || '', value || '');
    });
    return urlObject.toString();
};
module.exports["getConfluenceUrlWithAnalyticsQueryParams"] = $9238d4b3c991adc2$export$ce6d1d009c92f1be;
module.exports["getJiraUrlWithAnalyticsQueryParams"] = $9238d4b3c991adc2$export$b780bd7096d811c5;
module.exports["getGenericUrlWithAnalyticsQueryParams"] = $9238d4b3c991adc2$export$a5abc05a86b8de68;

});

parcelRegister("bqUaZ", function(module, exports) {

var $eVK28 = parcelRequire("eVK28");


var $7Ag9o = parcelRequire("7Ag9o");


var $aNIeI = parcelRequire("aNIeI");


var $5IGsg = parcelRequire("5IGsg");

// copied over from @confluence/hash
const $bd8081de7523fd56$var$hash = (data, asBytes = false)=>{
    const hash = (0, $eVK28.sha256).create();
    hash.update(data);
    if (asBytes) return hash.array();
    return hash.hex();
};
const $bd8081de7523fd56$export$5fdf8c875acfc1b3 = (data)=>{
    return $bd8081de7523fd56$var$hash(data, true);
};
const $bd8081de7523fd56$export$7904c6256691057a = (data)=>{
    return $bd8081de7523fd56$var$hash(data);
};
module.exports["hashData"] = $bd8081de7523fd56$export$7904c6256691057a;

});

parcelRegister("7Ag9o", function(module, exports) {
/**
 * Strip highlight markers from text
 */ const $a2e0e4cc948fc4f0$export$7512fe8206a7f75b = (text)=>text && text.replace(/@@@hl@@@/g, '').replace(/@@@endhl@@@/g, '');
module.exports["cleanExcerpt"] = $a2e0e4cc948fc4f0$export$7512fe8206a7f75b;

});

parcelRegister("aNIeI", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hMCZS = parcelRequire("hMCZS");

const $2ca479284d1e4523$export$451f7a1e7c934f54 = (userId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? (0, $hMCZS.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        },
        cloudId: cloudId,
        hostProduct: 'confluence'
    }).href : `/wiki/people/${userId}`;
    else if (primaryProduct === 'townsquare') return (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? (0, $hMCZS.navigateToTeamsApp)({
        type: 'USER',
        payload: {
            userId: userId
        },
        cloudId: cloudId,
        hostProduct: 'home'
    }).href : `/o/${orgId}/people/${userId}?cloudId=${cloudId}`;
};
module.exports["getUserPath"] = $2ca479284d1e4523$export$451f7a1e7c934f54;

});

parcelRegister("5IGsg", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $hMCZS = parcelRequire("hMCZS");

const $7ea46911e63dbdd0$export$9456a8e088bfede1 = (teamId, primaryProduct, orgId, cloudId)=>{
    if (primaryProduct === 'confluence') return (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? (0, $hMCZS.navigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        },
        cloudId: cloudId,
        hostProduct: 'confluence'
    }).href : `/wiki/people/team/${teamId}`;
    else if (primaryProduct === 'townsquare') return (0, $iDrrr.fg)('platform-adopt-teams-nav-config') ? (0, $hMCZS.navigateToTeamsApp)({
        type: 'TEAM',
        payload: {
            teamId: teamId
        },
        cloudId: cloudId
    }).href : `/o/${orgId}/people/team/${teamId}?cloudId=${cloudId}`;
};
module.exports["getTeamPath"] = $7ea46911e63dbdd0$export$9456a8e088bfede1;

});

parcelRegister("jY1sc", function(module, exports) {

var $5Styu = parcelRequire("5Styu");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $kSwu1 = parcelRequire("kSwu1");

const $6c62c1b8deee893a$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    googleDocsLabel: {
        id: "document-search-result.google-docs-label",
        defaultMessage: "Docs"
    },
    googleSlidesLabel: {
        id: "document-search-result.google-slides-label",
        defaultMessage: "Slides"
    },
    googleSheetsLabel: {
        id: "document-search-result.google-sheets-label",
        defaultMessage: "Sheets"
    },
    msWordLabel: {
        id: "document-search-result.ms-word-label",
        defaultMessage: "Word"
    },
    msPowerpointLabel: {
        id: "document-search-result.ms-powerpoint-label",
        defaultMessage: "PowerPoint"
    },
    msExcelLabel: {
        id: "document-search-result.ms-excel-label",
        defaultMessage: "Excel"
    },
    documentLabel: {
        id: "document.label",
        defaultMessage: "Document"
    },
    spreadsheetLabel: {
        id: "spreadsheet.label",
        defaultMessage: "Spreadsheet"
    },
    presentationLabel: {
        id: "presentation.label",
        defaultMessage: "Presentation"
    },
    fileLabel: {
        id: "file.label",
        defaultMessage: "File"
    },
    databaseLabel: {
        id: "database.label",
        defaultMessage: "Database"
    },
    webPageLabel: {
        id: "web-page.label",
        defaultMessage: "Web Page"
    },
    pageLabel: {
        id: "page.label",
        defaultMessage: "Page"
    },
    blogpostLabel: {
        id: "blogpost.label",
        defaultMessage: "Blogpost"
    },
    dashboardLabel: {
        id: "dashboard.label",
        defaultMessage: "Dashboard"
    },
    invoiceLabel: {
        id: "invoice.label",
        defaultMessage: "Invoice"
    },
    designLabel: {
        id: "design.label",
        defaultMessage: "Design"
    },
    dealLabel: {
        id: "deal.label",
        defaultMessage: "Deal"
    },
    videoLabel: {
        id: "video.label",
        defaultMessage: "Video"
    },
    taskLabel: {
        id: "task.label",
        defaultMessage: "Task"
    },
    issueLabel: {
        id: "issue.label",
        defaultMessage: "Issue"
    },
    spaceLabel: {
        id: "space.label",
        defaultMessage: "Space"
    },
    projectLabel: {
        id: "project.label",
        defaultMessage: "Project"
    },
    repositoryLabel: {
        id: "repository.label",
        defaultMessage: "Repository"
    },
    branchLabel: {
        id: "branch.label",
        defaultMessage: "Branch"
    },
    commitLabel: {
        id: "commit.label",
        defaultMessage: "Commit"
    },
    pullRequestLabel: {
        id: "pull-request.label",
        defaultMessage: "Pull Request"
    },
    workItemLabel: {
        id: "work-item.label",
        defaultMessage: "Work Item"
    },
    customerOrgLabel: {
        id: "customer-org.label",
        defaultMessage: "Customer Org"
    },
    imageLabel: {
        id: "image.label",
        defaultMessage: "Image"
    },
    archiveLabel: {
        id: "archive.label",
        defaultMessage: "Archive"
    },
    audioLabel: {
        id: "audio.label",
        defaultMessage: "Audio"
    },
    pdfLabel: {
        id: "pdf.label",
        defaultMessage: "PDF"
    },
    codeLabel: {
        id: "code.label",
        defaultMessage: "Code"
    },
    channelLabel: {
        id: "channel.label",
        defaultMessage: "Channel"
    },
    knowledgeArticleLabel: {
        id: "3p-result-labeling.knowledge_article.label",
        defaultMessage: "Knowledge article"
    },
    newsArticleLabel: {
        id: "3p-result-labeling.news_article.label",
        defaultMessage: "News article"
    },
    otherLabel: {
        id: "other.label",
        defaultMessage: "Other"
    }
});


const $d3f1af1f92c5a308$export$a47c0c6de01249fd = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const SUBTYPE_DOCUMENT = 'DOCUMENT';
    const SUBTYPE_PRESENTATION = 'PRESENTATION';
    const SUBTYPE_SPREADSHEET = 'SPREADSHEET';
    const GOOGLE_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $6c62c1b8deee893a$export$defe85febe8b728c).googleDocsLabel,
        [SUBTYPE_PRESENTATION]: (0, $6c62c1b8deee893a$export$defe85febe8b728c).googleSlidesLabel,
        [SUBTYPE_SPREADSHEET]: (0, $6c62c1b8deee893a$export$defe85febe8b728c).googleSheetsLabel
    };
    const MICROSOFT_LABELS = {
        [SUBTYPE_DOCUMENT]: (0, $6c62c1b8deee893a$export$defe85febe8b728c).msWordLabel,
        [SUBTYPE_PRESENTATION]: (0, $6c62c1b8deee893a$export$defe85febe8b728c).msPowerpointLabel,
        [SUBTYPE_SPREADSHEET]: (0, $6c62c1b8deee893a$export$defe85febe8b728c).msExcelLabel
    };
    const normalizedSubtype = subtype?.toUpperCase();
    let label;
    if (product === (0, $dvVWp.ProductKeys).Sharepoint || product === (0, $dvVWp.ProductKeys).OneDrive) label = MICROSOFT_LABELS[normalizedSubtype];
    else if (product.includes((0, $dvVWp.ProductKeys).GoogleDrive)) label = GOOGLE_LABELS[normalizedSubtype];
    else if (product.includes((0, $dvVWp.ProductKeys).AtlassianWebCrawler) && // QF returns subtype with underscores, f.e. 'WEB_PAGE', so we need to support both
    subtype.replace('_', '-') === (0, $7ydfN.NounSubtypeKey).WebPage) label = (0, $6c62c1b8deee893a$export$defe85febe8b728c).webPageLabel;
    else if (subtype === (0, $7ydfN.NounSubtypeKey).KnowledgeArticle || // QF returns subtype in uppercase (e.g. 'KNOWLEDGE_ARTICLE'), so we support both casings
    normalizedSubtype === 'KNOWLEDGE_ARTICLE') label = (0, $6c62c1b8deee893a$export$defe85febe8b728c).knowledgeArticleLabel;
    else if (subtype === (0, $7ydfN.NounSubtypeKey).NewsArticle || // QF returns subtype in uppercase (e.g. 'NEWS_ARTICLE'), so we support both casings
    normalizedSubtype === 'NEWS_ARTICLE') label = (0, $6c62c1b8deee893a$export$defe85febe8b728c).newsArticleLabel;
    return label;
};
// Provider-aware label so that e.g. GitHub work items render as "Issue"
// rather than the generic "Work item". Mirrors the providerDefaultLabelMap
// in the full search results page work-item renderer.
const $d3f1af1f92c5a308$var$providerDefaultLabelMap = {
    [(0, $dvVWp.ProductKeys).Github]: (0, $6c62c1b8deee893a$export$defe85febe8b728c).issueLabel
};
const $d3f1af1f92c5a308$export$67bc9d7952cf216d = ({ product: product, subtype: subtype, resourceType: resourceType })=>{
    const documentLabel = $d3f1af1f92c5a308$export$a47c0c6de01249fd({
        product: product,
        subtype: subtype
    });
    if (documentLabel) return documentLabel;
    if (!resourceType) return;
    if (resourceType === (0, $5Styu.ResourceType).VIDEO) return (0, $6c62c1b8deee893a$export$defe85febe8b728c).videoLabel;
    else if (resourceType === (0, $5Styu.ResourceType).REPOSITORY) return (0, $6c62c1b8deee893a$export$defe85febe8b728c).repositoryLabel;
    else if (resourceType === (0, $5Styu.ResourceType).PULL_REQUEST) return (0, $6c62c1b8deee893a$export$defe85febe8b728c).pullRequestLabel;
    else if (resourceType === (0, $5Styu.ResourceType).BRANCH) return (0, $6c62c1b8deee893a$export$defe85febe8b728c).branchLabel;
    else if (resourceType === (0, $5Styu.ResourceType).COMMIT) return (0, $6c62c1b8deee893a$export$defe85febe8b728c).commitLabel;
    else if (resourceType === (0, $5Styu.ResourceType).WORK_ITEM) {
        if (product && $d3f1af1f92c5a308$var$providerDefaultLabelMap[product]) return $d3f1af1f92c5a308$var$providerDefaultLabelMap[product];
        return (0, $6c62c1b8deee893a$export$defe85febe8b728c).workItemLabel;
    }
    return undefined;
};
const $d3f1af1f92c5a308$export$19dc2415a5fa9123 = ({ product: product, subtype: subtype })=>{
    if (!product || !subtype) return;
    const labelKey = `${subtype}Label`;
    if (labelKey in (0, $6c62c1b8deee893a$export$defe85febe8b728c)) return (0, $6c62c1b8deee893a$export$defe85febe8b728c)[labelKey];
    else return (0, $6c62c1b8deee893a$export$defe85febe8b728c).otherLabel;
};
module.exports["getDocumentSubtypeLabel"] = $d3f1af1f92c5a308$export$a47c0c6de01249fd;
module.exports["getSubtypeLabel"] = $d3f1af1f92c5a308$export$67bc9d7952cf216d;
module.exports["getRemoteLinkSubtypeLabel"] = $d3f1af1f92c5a308$export$19dc2415a5fa9123;

});

parcelRegister("dtCp5", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $dinVW = parcelRequire("dinVW");

var $4aRua = parcelRequire("4aRua");


var $lpNn5 = parcelRequire("lpNn5");

const $6bd01af1bd5a238c$var$messages = (0, $kSwu1.defineMessages)({
    displayNameLabel: {
        id: "search-page.common.display-name-tooltip.displayNameLabel",
        defaultMessage: "Display name: {displayName}"
    },
    nameLabel: {
        id: "search-page.common.display-name-tooltip.nameLabel",
        defaultMessage: "Name: {name}"
    }
});
const $6bd01af1bd5a238c$export$2bb992c63b690a64 = ({ displayName: displayName, name: name })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dinVW.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.inverse"
    }, formatMessage($6bd01af1bd5a238c$var$messages.displayNameLabel, {
        displayName: displayName
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
        size: "small",
        color: "color.text.inverse"
    }, formatMessage($6bd01af1bd5a238c$var$messages.nameLabel, {
        name: name
    })));
};
const $6bd01af1bd5a238c$export$35bd5615255f5466 = ({ displayName: displayName, name: name, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($6bd01af1bd5a238c$export$2bb992c63b690a64, {
            displayName: displayName,
            name: name
        }),
        position: "bottom"
    }, children);
module.exports["DisplayNameTooltip"] = $6bd01af1bd5a238c$export$35bd5615255f5466;

});

parcelRegister("6PqYl", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $9KSWX = parcelRequire("9KSWX");




const $f525fcb99dc58070$export$373c576b545d33cb = (0, $kSwu1.defineMessages)({
    open: {
        id: "search-page.common.graph-work-item-status.open",
        defaultMessage: "Open"
    },
    closed: {
        id: "search-page.common.graph-work-item-status.closed",
        defaultMessage: "Closed"
    }
});


/**
 * Map a third-party **work-item** status (e.g. GitHub issue states) onto the
 * appropriate Atlaskit Lozenge appearance.
 *
 * Only the two canonical GitHub work-item states (`OPEN`, `CLOSED`) are
 * supported. Inputs are case-insensitive — callers may pass the value as it
 * comes from the API (`"open"`, `"OPEN"`, …). Anything else falls back to
 * `'neutral'`.
 *
 * Kept separate from `getPullRequestStatusAppearance` so the two domains stay
 * decoupled and additions to either map can't accidentally affect the other.
 */ const $ef348498d1d97321$var$workItemStatusToLozengeMap = {
    OPEN: 'information',
    // blue
    CLOSED: 'success' // green
};
const $ef348498d1d97321$var$getAppearance = (status)=>(status ? $ef348498d1d97321$var$workItemStatusToLozengeMap[status.toUpperCase()] : undefined) ?? 'neutral';
const $ef348498d1d97321$export$c8ca8b382bc642d1 = ({ status: status })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    if (!status) return null;
    const message = (0, $f525fcb99dc58070$export$373c576b545d33cb)[status.toLowerCase()];
    const label = message ? formatMessage(message) : status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
        appearance: $ef348498d1d97321$var$getAppearance(status),
        testId: "graph-work-item-status-lozenge-test-id"
    }, label);
};
module.exports["GraphWorkItemStatusLozenge"] = $ef348498d1d97321$export$c8ca8b382bc642d1;

});

parcelRegister("jL46I", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $kWSTb = parcelRequire("kWSTb");


var $8OpiN = parcelRequire("8OpiN");


var $h1gZq = parcelRequire("h1gZq");


var $fayTW = parcelRequire("fayTW");


var $aOjGz = parcelRequire("aOjGz");


var $gxI48 = parcelRequire("gxI48");


var $4MdqE = parcelRequire("4MdqE");


var $eDtFr = parcelRequire("eDtFr");


var $itpo2 = parcelRequire("itpo2");


var $1LOGx = parcelRequire("1LOGx");


var $7A1BE = parcelRequire("7A1BE");


var $6CsCB = parcelRequire("6CsCB");


var $ipvL3 = parcelRequire("ipvL3");


var $iFXu4 = parcelRequire("iFXu4");


var $ijkxh = parcelRequire("ijkxh");


var $foj7F = parcelRequire("foj7F");


var $iRFKG = parcelRequire("iRFKG");


var $cJ0FD = parcelRequire("cJ0FD");


var $iW3KC = parcelRequire("iW3KC");


var $lFTzz = parcelRequire("lFTzz");


var $hkAs2 = parcelRequire("hkAs2");


var $2qJQZ = parcelRequire("2qJQZ");


var $7pJjg = parcelRequire("7pJjg");


var $aKhvB = parcelRequire("aKhvB");


var $dt415 = parcelRequire("dt415");


var $9NPFC = parcelRequire("9NPFC");


var $dvVWp = parcelRequire("dvVWp");


var $4DhjM = parcelRequire("4DhjM");

const $c8b0f3dfd738db5f$var$isImageDataUrl = (str)=>/^data:image\/[^;]+;base64,/.test(str); /**
                                                                                 * Returns the appropriate icon for a Jira item based on the provided parameters.
                                                                                 *
                                                                                 * @param {string | null | undefined} iconUrl - The URL of the icon image.
                                                                                 * @param {SearchResultType | string} type - The type of the search result (e.g., 'board', 'plan', etc.).
                                                                                 * @param {boolean} isIssue - Flag indicating if the item is an issue.
                                                                                 * @param {'small' | 'medium'} [size='small'] - The size of the icon ('small' or 'medium').
                                                                                 * @returns {React.JSX.Element} The JSX element representing the icon.
                                                                                 */ 
const $c8b0f3dfd738db5f$export$348a13c9e1254ce4 = ({ iconUrl: iconUrl, type: type, isIssue: isIssue, size: size = 'small' })=>{
    const imageSize = size === 'medium' ? 22 : 16; // Use the iconUrl if available
    if (iconUrl) {
        if (isIssue) // wrapper is only needed for issues. Other types don't need the background and padding with iconUrl.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            label: "Work item icon",
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            alt: "Work item icon",
            testId: "jira-entity-icon",
            width: imageSize,
            height: imageSize,
            src: iconUrl
        }));
        return(// The image covers up the whole wrapper
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            isInset: false,
            label: `${type} icon`,
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            alt: `${type} icon`,
            testId: "jira-entity-icon",
            src: iconUrl
        })));
    }
    if (isIssue) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: "Work item icon",
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iRFKG))), {
        spacing: "none",
        size: size,
        label: "work-item-icon"
    }));
    let icon;
    switch(type){
        case 'board':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4MdqE))), {
                spacing: "none",
                size: size,
                label: "board-icon"
            });
            break;
        case 'plan':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ijkxh))), {
                spacing: "none",
                size: size,
                label: "plan-icon"
            });
            break;
        case 'filter':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1LOGx))), {
                spacing: "none",
                size: size,
                label: "filter-icon"
            });
            break;
        case 'dashboard':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($itpo2))), {
                spacing: "none",
                size: size,
                label: "dashboard-icon"
            });
            break;
        case 'project':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aOjGz))), {
                spacing: "none",
                size: size,
                label: "space-icon"
            });
            break;
        case 'incident':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ipvL3))), {
                spacing: "none",
                size: size,
                label: "incident-icon"
            });
            break;
        default:
            // This never happens
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4DhjM.ProductIcon), {
                size: size,
                product: (0, $dvVWp.ProductKeys).Jira
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: `${type} icon`,
        size: size
    }, icon);
};
const $c8b0f3dfd738db5f$export$e375917bfb190d26 = ({ iconUrl: iconUrl, type: type, size: size = 'small', isLiveDoc: isLiveDoc = false })=>{
    try {
        // Use the iconUrl if available, the iconUrl for Confluence entities is usually an absolute URL
        // We only use custom iconUrl for Spaces
        if (type === 'space' && iconUrl && ($c8b0f3dfd738db5f$var$isImageDataUrl(iconUrl) || new URL(iconUrl))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            isInset: false,
            label: `${type} icon`,
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            alt: `${type} icon`,
            src: iconUrl
        }));
    } catch  {} /*
              ** For finding all the Confluence entities look at platform/packages/search/search-page/src/common/utils/filters/constants.ts -> typeFilter1PMapping
              * */ 
    let icon;
    switch(type){
        case 'space':
            // spaces usually have an iconUrl, but if not we fall back to the project icon
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXu4))), {
                size: size,
                label: "space icon"
            });
            break;
        case 'page':
            if (isLiveDoc) icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7pJjg.default), {
                size: size,
                label: "live page icon"
            });
            else icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2qJQZ.default), {
                size: size,
                label: "page icon"
            });
            break;
        case 'blogpost':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iW3KC.default), {
                size: size,
                label: "blogpost icon"
            });
            break;
        case 'attachment':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gxI48))), {
                spacing: "none",
                size: size,
                label: "attachment icon"
            });
            break;
        case 'comment':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eDtFr))), {
                spacing: "none",
                size: size,
                label: "comment icon"
            });
            break;
        case 'whiteboard':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dt415.default), {
                size: size,
                label: "whiteboard icon"
            });
            break;
        case 'slide':
            // CNS-25852: render the slide icon for slides search results so
            // they no longer fall back to the generic Confluence product icon.
            // Imported directly from icon-lab rather than @atlaskit/object
            // because the object codegen entry doesn't exist yet.
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kWSTb))), {
                spacing: "none",
                size: size,
                label: "slide icon",
                color: "var(--ds-icon-accent-green, #22A06B)"
            });
            break;
        case 'database':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hkAs2.default), {
                size: size,
                label: "database icon"
            });
            break;
        case 'question':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $aKhvB.default), {
                size: size,
                label: "question icon"
            });
            break;
        case 'calendar':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lFTzz.default), {
                size: size,
                label: "calendar icon"
            });
            break;
        case 'embed':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($foj7F))), {
                spacing: "none",
                size: size,
                label: "embed icon"
            });
            break;
        case 'folder':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7A1BE))), {
                spacing: "none",
                size: size,
                label: "folder icon"
            });
            break;
        default:
            // fallback to product icon. It has no wrapper
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4DhjM.ProductIcon), {
                label: "confluence icon",
                size: size,
                product: (0, $dvVWp.ProductKeys).Confluence
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: `${type} icon`,
        size: size
    }, icon);
};
const $c8b0f3dfd738db5f$export$397605bdd85a2f89 = ({ iconUrl: iconUrl, type: type, size: size = 'small' })=>{
    try {
        // Use the iconUrl if available, the iconUrl for Atlas entities is usually an absolute URL
        if (iconUrl && ($c8b0f3dfd738db5f$var$isImageDataUrl(iconUrl) || new URL(iconUrl))) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
            isInset: false,
            label: `${type} icon`,
            size: size
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
            alt: `${type} icon`,
            src: iconUrl
        }));
    } catch  {}
    let icon;
    switch(type){
        case 'goal':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6CsCB))), {
                size: size,
                label: "goal icon"
            });
            break;
        case 'project':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iFXu4))), {
                size: size,
                label: "project icon"
            });
            break;
        default:
            // fallback to product icon. It has no wrapper
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4DhjM.ProductIcon), {
                label: "Atlas icon",
                size: size,
                product: (0, $dvVWp.ProductKeys).Atlas
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: `${type} icon`,
        size: size
    }, icon);
}; /**
    * Returns the appropriate icon for a Jira item based on the provided parameters.
    *
    * @param {string | null | undefined} iconUrl - The URL of the icon image.
    * @param {SearchResultType | string} type - The type of the search result (e.g., 'board', 'plan', etc.).
    * @param {boolean} isIssue - Flag indicating if the item is an issue.
    * @param {'small' | 'medium'} [size='small'] - The size of the icon ('small' or 'medium').
    * @returns {React.JSX.Element} The JSX element representing the icon.
    */ 
const $c8b0f3dfd738db5f$export$fbba347fb6ffa903 = ({ iconUrl: iconUrl, type: type, size: size = 'small' })=>{
    // Use the iconUrl if available
    if (iconUrl) return(// The image covers up the whole wrapper
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: `${type} icon`,
        size: size
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cJ0FD.default), {
        alt: "",
        testId: "assets-entity-icon",
        src: iconUrl
    })));
    let icon;
    switch(type){
        case 'schema':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fayTW))), {
                spacing: "none",
                size: size,
                label: "schema-icon"
            });
            break;
        case 'type':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1gZq))), {
                spacing: "none",
                size: size,
                label: "type-icon"
            });
            break;
        case 'object':
            icon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8OpiN))), {
                spacing: "none",
                size: size,
                label: "object-icon"
            });
            break;
        default:
            // This never happens
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4DhjM.ProductIcon), {
                size: size,
                product: (0, $dvVWp.ProductKeys).Assets
            });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9NPFC.default), {
        label: `${type} icon`,
        size: size
    }, icon);
};
module.exports["getJiraEntityIcon"] = $c8b0f3dfd738db5f$export$348a13c9e1254ce4;
module.exports["getConfluenceEntityIcon"] = $c8b0f3dfd738db5f$export$e375917bfb190d26;
module.exports["getAtlasEntityIcon"] = $c8b0f3dfd738db5f$export$397605bdd85a2f89;
module.exports["getAssetsEntityIcon"] = $c8b0f3dfd738db5f$export$fbba347fb6ffa903;

});

parcelRegister("h1gZq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::73fcc89b4639743bc6edde50ed4eb864>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c63fb5735b8a6c27$var$_react = $c63fb5735b8a6c27$var$_interopRequireDefault((parcelRequire("cozmU")));

var $c63fb5735b8a6c27$var$_baseNew = $c63fb5735b8a6c27$var$_interopRequireDefault((parcelRequire("gElAV")));
function $c63fb5735b8a6c27$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AssetsObjectType".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/assets-object-type
 * Usage guidance:
 * Reserved for representing object types in Assets.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c63fb5735b8a6c27$var$AssetsObjectTypeIcon = (props)=>/*#__PURE__*/ $c63fb5735b8a6c27$var$_react.default.createElement($c63fb5735b8a6c27$var$_baseNew.default, Object.assign({
        name: "AssetsObjectTypeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 14.5h3.5V11H11zm-5.5-11a2 2 0 1 0-4 0 2 2 0 0 0 4 0M16 14.625c0 .76-.616 1.375-1.375 1.375h-3.75c-.76 0-1.375-.616-1.375-1.375v-3.75c0-.76.616-1.375 1.375-1.375h3.75c.76 0 1.375.616 1.375 1.375zM7 3.5a3.5 3.5 0 0 1-2.75 3.418V11.5a.5.5 0 0 0 .5.5H8v1.5H4.75a2 2 0 0 1-2-2V6.918A3.5 3.5 0 1 1 7 3.5"/>`
    }, props));
$c63fb5735b8a6c27$var$AssetsObjectTypeIcon.displayName = 'AssetsObjectTypeIcon';
var $c63fb5735b8a6c27$var$_default = module.exports.default = $c63fb5735b8a6c27$var$AssetsObjectTypeIcon;

});

parcelRegister("4DhjM", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $jmUhx = parcelRequire("jmUhx");


var $6TaGl = parcelRequire("6TaGl");


var $kHRmO = parcelRequire("kHRmO");


var $73Hia = parcelRequire("73Hia");


var $8fNUp = parcelRequire("8fNUp");


var $cJff5 = parcelRequire("cJff5");

const $b1a90898fa400b1e$export$1a199e029d5e93d6 = ({ product: product, size: size = 'large', isSelected: isSelected = false, useSearchResultIcon: useSearchResultIcon = false, ...props })=>{
    const products = (0, $73Hia.useProductConfigs)();
    if (product) {
        // First check if it's a Forge connector - prioritize dynamic API icons
        if ((0, $8fNUp.isForgeConnectorProductKey)(product)) {
            const forgeIcon = (0, $8fNUp.getForgeConnectorIcon)(product);
            if (forgeIcon) // Forge connector icons are RovoLogo functions, not React components
            return forgeIcon({
                ...props,
                size: size
            });
        }
        // Fallback to static products map (covers hardcoded Forge connectors and all other products)
        const config = products[product];
        if (config) {
            const Icon = useSearchResultIcon && config.SearchResultIcon || config.Icon;
            if (Icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
                ...props,
                size: size,
                shouldUseNewLogoDesign: true
            });
        }
    }
    // Fallback to AppsIcon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        spacing: "spacious",
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    });
};
const $b1a90898fa400b1e$export$f73e324780005aef = ({ isShowMore: isShowMore, productOrNounKey: productOrNounKey, size: size = 'large', isSelected: isSelected = false, ...props })=>{
    if (isShowMore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))), {
        label: "",
        size: (0, $cJff5.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'small' : 'medium',
        spacing: (0, $cJff5.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'compact' : 'spacious',
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    });
    return $b1a90898fa400b1e$export$fe03eddc92730a5c({
        productOrNounKey: productOrNounKey,
        size: size,
        isSelected: isSelected,
        ...props
    });
};
const $b1a90898fa400b1e$export$fe03eddc92730a5c = ({ productOrNounKey: productOrNounKey, size: size = 'large', isSelected: isSelected = false, ...props })=>{
    const products = (0, $73Hia.useProductConfigs)();
    let Icon;
    if (productOrNounKey) {
        const isNounFilter = (0, $kHRmO.isNounKey)(productOrNounKey);
        if (isNounFilter) Icon = (0, $kHRmO.nouns)[productOrNounKey].Icon;
        else {
            // First check if it's a Forge connector - prioritize dynamic API icons
            if ((0, $8fNUp.isForgeConnectorProductKey)(productOrNounKey)) {
                const forgeIcon = (0, $8fNUp.getForgeConnectorIcon)(productOrNounKey);
                if (forgeIcon) // Forge connector icons are RovoLogo functions, not React components
                return forgeIcon({
                    ...props,
                    size: size
                });
            }
            // Fallback to static products map (covers hardcoded Forge connectors and all other products)
            const productConfig = products[productOrNounKey];
            if (productConfig?.Icon) Icon = productConfig.Icon;
        }
        if (Icon) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            ...props,
            size: size
        });
    }
    // Fallback to AppsIcon
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jmUhx))), {
        label: "",
        size: (0, $cJff5.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'small' : 'medium',
        spacing: (0, $cJff5.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? 'compact' : 'spacious',
        color: isSelected ? "var(--ds-icon-selected, #1868DB)" : "var(--ds-icon, #292A2E)"
    });
};
module.exports["ProductIcon"] = $b1a90898fa400b1e$export$1a199e029d5e93d6;
module.exports["IconDecider"] = $b1a90898fa400b1e$export$f73e324780005aef;
module.exports["ProductOrNounIcon"] = $b1a90898fa400b1e$export$fe03eddc92730a5c;

});

parcelRegister("kHRmO", function(module, exports) {

var $bltJZ = parcelRequire("bltJZ");


var $hAvnk = parcelRequire("hAvnk");

/* custom-link-icon.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $9NPFC = parcelRequire("9NPFC");

function $ee8b2e1789bef4d1$export$5efe8561ca252843({ size: size = 'medium', label: label = '', testId: testId }) {
    return(// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    /*#__PURE__*/ $cozmU.createElement((0, $9NPFC.default), {
        label: label,
        size: size,
        isInset: false,
        backgroundColor: "white",
        testId: testId
    }, /*#__PURE__*/ $cozmU.createElement("svg", {
        height: "100%",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ $cozmU.createElement("rect", {
        //eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        fill: "#dddee1",
        x: "0",
        y: "0",
        width: "24",
        height: "24"
    }), /*#__PURE__*/ $cozmU.createElement("path", {
        fill: "#101214",
        fillRule: "evenodd",
        d: "M19 12a7 7 0 1 0-14 0 7 7 0 0 0 14 0m-9.37 4.625.026.074a5.26 5.26 0 0 1-2.833-3.824h2.136c.069 1.426.306 2.73.67 3.75m1.08-3.75c.068 1.255.278 2.353.567 3.162.179.5.37.841.54 1.042a.6.6 0 0 0 .183.165.7.7 0 0 0 .183-.165c.17-.2.361-.543.54-1.042.288-.809.498-1.907.566-3.162zm2.58-1.75h-2.58c.068-1.255.278-2.353.567-3.162.179-.5.37-.841.54-1.042A.7.7 0 0 1 12 6.756a.6.6 0 0 1 .183.165c.17.2.361.543.54 1.042.288.809.498 1.907.566 3.162m1.751 1.75c-.069 1.426-.306 2.73-.67 3.75l-.027.074a5.26 5.26 0 0 0 2.833-3.824zm2.136-1.75H15.04c-.069-1.426-.306-2.73-.67-3.75l-.027-.074a5.26 5.26 0 0 1 2.833 3.824m-8.218 0H6.823a5.26 5.26 0 0 1 2.833-3.824l-.027.074c-.364 1.02-.601 2.324-.67 3.75",
        clipRule: "evenodd"
    }))));
}



var $kSwu1 = parcelRequire("kSwu1");

const $21b240a73fe078e8$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    webPage: {
        id: "search-page.products.custom-website",
        defaultMessage: "Web page"
    },
    webPages: {
        id: "search-page.products.custom-websites",
        defaultMessage: "Web pages"
    },
    project: {
        id: "search-page.nouns.project",
        defaultMessage: "Project"
    },
    projects: {
        id: "search-page.nouns.projects",
        defaultMessage: "Projects"
    },
    goal: {
        id: "search-page.nouns.goal",
        defaultMessage: "Goal"
    },
    goals: {
        id: "search-page.nouns.goals",
        defaultMessage: "Goals"
    },
    tag: {
        id: "search-page.nouns.tag",
        defaultMessage: "Tag"
    },
    tags: {
        id: "search-page.nouns.tags",
        defaultMessage: "Tags"
    }
});


const $c5ea98c1cf33f481$export$a93cddd79e3ea530 = {
    project: 'project',
    goal: 'goal',
    // tag: 'tag',
    AtlassianWebCrawler: 'atlassian-web-crawler'
};
const $c5ea98c1cf33f481$export$cc6a3ce6b37346b2 = (key)=>{
    return Object.values($c5ea98c1cf33f481$export$a93cddd79e3ea530).includes(key);
};
const $c5ea98c1cf33f481$export$5cb7c19fcb84c9cd = {
    [$c5ea98c1cf33f481$export$a93cddd79e3ea530.project]: {
        displayName: (0, $21b240a73fe078e8$export$defe85febe8b728c).project,
        displayNamePlural: (0, $21b240a73fe078e8$export$defe85febe8b728c).projects,
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $bltJZ.ProjectsIcon), 'Project')
    },
    [$c5ea98c1cf33f481$export$a93cddd79e3ea530.goal]: {
        displayName: (0, $21b240a73fe078e8$export$defe85febe8b728c).goal,
        displayNamePlural: (0, $21b240a73fe078e8$export$defe85febe8b728c).goals,
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $bltJZ.GoalsIcon), 'Goal')
    },
    //Tag Noun has been omitted because it is not currently implemented in FPS and risks visual degradation with the t25 icon update
    //Discussion here: https://atlassian.slack.com/archives/C08HFJLM7J5/p1742856483784089
    // [NounKeys.tag]: {
    // 	displayName: messages.tag,
    // 	displayNamePlural: messages.tags,
    // 	Icon: RovoLogoFromLogo(HashtagIcon, 'Tag'),
    // },
    [$c5ea98c1cf33f481$export$a93cddd79e3ea530.AtlassianWebCrawler]: {
        displayName: (0, $21b240a73fe078e8$export$defe85febe8b728c).webPage,
        displayNamePlural: (0, $21b240a73fe078e8$export$defe85febe8b728c).webPages,
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $ee8b2e1789bef4d1$export$5efe8561ca252843), 'Atlassian Web Crawler')
    }
};
const $c5ea98c1cf33f481$export$341b1567666c2663 = [
    $c5ea98c1cf33f481$export$a93cddd79e3ea530.project,
    $c5ea98c1cf33f481$export$a93cddd79e3ea530.goal,
    // NounKeys.tag,
    $c5ea98c1cf33f481$export$a93cddd79e3ea530.AtlassianWebCrawler // Web Crawler is not a noun, we should improve this
];
module.exports["NounKeys"] = $c5ea98c1cf33f481$export$a93cddd79e3ea530;
module.exports["isNounKey"] = $c5ea98c1cf33f481$export$cc6a3ce6b37346b2;
module.exports["nouns"] = $c5ea98c1cf33f481$export$5cb7c19fcb84c9cd;
module.exports["NOUNS_ORDER"] = $c5ea98c1cf33f481$export$341b1567666c2663;

});

parcelRegister("hAvnk", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ /**
 * A RovoLogo is a subset API that works for both @atlaskit/logo and @atlaskit/icon
 * We use one or the other depending on 1P or 3P and need a consistent API internall
 */ 
var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");





var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

const $fd912e7334a59c73$var$t25IconContainerStyles = {
    small: (0, $buxP3.xcss)({
        width: '16px',
        height: '16px'
    }),
    medium: (0, $buxP3.xcss)({
        width: '24px',
        height: '24px'
    }),
    large: (0, $buxP3.xcss)({
        width: '32px',
        height: '32px'
    }),
    //t25 tile icons do not get bumped up to 40/48px to avoid additional padding
    xlarge: (0, $buxP3.xcss)({
        width: '32x',
        height: '32px'
    })
};
const $fd912e7334a59c73$var$iconStyles = (0, $buxP3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $fd912e7334a59c73$export$1776e6671850176d = ({ glyph: SVG, label: label, size: size })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $fd912e7334a59c73$var$t25IconContainerStyles[size],
            $fd912e7334a59c73$var$iconStyles
        ],
        "aria-label": label || undefined,
        role: label ? 'img' : 'presentation'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(SVG, null));
};


const $e0650b7625faeac1$var$isCorrectableRovoSize = (size)=>{
    return [
        'xxsmall',
        'xsmall',
        'small',
        'medium',
        'large'
    ].includes(size);
};
const $e0650b7625faeac1$var$correctedSize = {
    xxsmall: 'small',
    xsmall: 'small',
    small: 'medium',
    medium: 'large',
    large: 'xlarge'
};
const $e0650b7625faeac1$var$sizeStyles = {
    small: "_39xV02ey7F _0jFU0Vey7F",
    medium: "_39xV02oWWg _0jFU0VoWWg",
    large: "_39xV02Uofl _0jFU0VUofl",
    xlarge: "_39xV02pJKa _0jFU0VpJKa"
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with custom Rovo Icons
    *
    * Internally uses <Icon glyph={glyph} ... />
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $e0650b7625faeac1$export$7b66a86355afbb91 = (Glyph, defaultLabel = '', defaultSize = 'medium')=>{
    return ({ size: size = defaultSize, label: label = defaultLabel, testId: testId })=>{
        const mappedSize = size && $e0650b7625faeac1$var$isCorrectableRovoSize(size) ? $e0650b7625faeac1$var$correctedSize[size] : defaultSize;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            "aria-label": label || undefined,
            "data-testid": testId,
            role: label ? 'img' : 'presentation',
            className: (0, $hekY6.default)([
                $e0650b7625faeac1$var$sizeStyles[mappedSize]
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Glyph, null));
    };
}; /**
    * A wrapper for rendering 3P svg illustrations in a similar way for atlaskit icon components
    *
    * @param {} glyph function returning an SVG as JSX
    * @param defaultLabel an accessible label for the logo
    */ 
const $e0650b7625faeac1$export$dae027fade2c6d1d = (glyph, defaultLabel = '', defaultSize)=>{
    return ({ label: label = defaultLabel, size: size = defaultSize, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $fd912e7334a59c73$export$1776e6671850176d), {
            label: label,
            glyph: glyph,
            size: size && $e0650b7625faeac1$var$isCorrectableRovoSize(size) ? $e0650b7625faeac1$var$correctedSize[size] : 'medium'
        });
}; /**
    * A wrapper for providing an internal \@atlaskit/icon - alike experience for working with \@atlaskit/logo
    *
    * Internally uses <LogoComponent ... />
    *
    * @param {} LogoComponent an import from \@atlaskit/logo
    * @param defaultLabel an accessible label for the logo
    */ 
const $e0650b7625faeac1$export$32db889b380fa03c = (LogoComponent, defaultLabel = '')=>{
    return ({ size: size, label: label, testId: testId })=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(LogoComponent, {
            label: label || defaultLabel,
            testId: testId,
            size: size || 'medium',
            appearance: "brand",
            shouldUseNewLogoDesign: true
        });
    };
}; /**
    * Takes a logo component and returns a new logo component that uses the new logo design.
    */ 
function $e0650b7625faeac1$export$a34cd1871c6541c9(Icon) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            ...props,
            shouldUseNewLogoDesign: true
        });
}
function $e0650b7625faeac1$export$fab9faef3411dc6c(iconGlyph, iconLabel, size) {
    return $e0650b7625faeac1$export$dae027fade2c6d1d(iconGlyph, iconLabel, size);
}
const $e0650b7625faeac1$var$imageStyles = null; /**
                           * Helper function to convert an image URL into a glyph function
                           *
                           * @param imageUrl URL string pointing to the image
                           * @returns A glyph function that returns an img element
                           */ 
const $e0650b7625faeac1$export$f9f7178f66750cba = (imageUrl)=>{
    return ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("img", {
            src: imageUrl,
            alt: "",
            className: (0, $hekY6.default)([
                "_39xV02N91d _0jFU0VN91d _00EA0egIor"
            ])
        });
    };
}; /**
    * Creates a RovoLogo from a URL. Useful for Forge connectors that provide icon URLs.
    * Uses the existing RovoLogoFromSVG infrastructure for consistent handling.
    */ 
function $e0650b7625faeac1$export$97ac28be52c9e29f(iconUrl, iconLabel, size) {
    return $e0650b7625faeac1$export$dae027fade2c6d1d($e0650b7625faeac1$export$f9f7178f66750cba(iconUrl), iconLabel, size);
}
module.exports["RovoLogoFromLogo"] = $e0650b7625faeac1$export$32db889b380fa03c;
module.exports["get3PLogo"] = $e0650b7625faeac1$export$fab9faef3411dc6c;
module.exports["get3PLogoFromURL"] = $e0650b7625faeac1$export$97ac28be52c9e29f;

});

parcelRegister("73Hia", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $NlHoa = parcelRequire("NlHoa");


var $bltJZ = parcelRequire("bltJZ");


var $fd0l2 = parcelRequire("fd0l2");



var $hAvnk = parcelRequire("hAvnk");




const $7e38c84ca82e0760$export$24d355ce80de5803 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        height: "100%",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--tile-color,#ffc716)",
        d: "M0 6a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H6a6 6 0 0 1-6-6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        fillRule: "evenodd",
        d: "M8.34 11.495a3.64 3.64 0 0 0 3.155-3.154h2.3V6.523h-2.537a3.638 3.638 0 1 0-4.735 4.735v2.538H8.34zM7.887 9.25a1.364 1.364 0 1 0 0-2.727 1.364 1.364 0 0 0 0 2.727",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fill: "var(--icon-color, #101214)",
        d: "M19.25 7.43a2.27 2.27 0 1 1-4.54 0 2.27 2.27 0 0 1 4.55 0M7.43 19.25a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m9.55-.01a2.27 2.27 0 1 0 0-4.54 2.27 2.27 0 0 0 0 4.55m-3.18-3.19h-3.18v1.82h3.18zm2.27-5.46v3.18h1.82v-3.18z"
    }));





const $0273546edb01e5e1$export$b0a52366c3fb9b = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18710)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M34.4312 30.4727L21.2001 4.01056C20.9397 3.43756 20.6792 3.33337 20.3667 3.33337C20.1062 3.33337 19.7937 3.43756 19.4811 3.95846C17.6058 6.92764 16.7724 10.3656 16.7724 13.9599C16.7724 18.9606 19.3248 23.6488 23.0754 31.202C23.4921 32.0354 23.8047 32.1917 24.5339 32.1917H33.7019C34.3791 32.1917 34.7437 31.9313 34.7437 31.4103C34.7437 31.1499 34.6916 30.9936 34.4312 30.4727ZM15.2097 17.9709C14.1679 16.4082 13.8553 16.304 13.5949 16.304C13.3344 16.304 13.1781 16.4082 12.7093 17.3458L6.09377 30.5769C5.8854 30.9936 5.83331 31.1499 5.83331 31.3583C5.83331 31.775 6.19795 32.1917 6.97931 32.1917H16.3036C16.9287 32.1917 17.3975 31.6708 17.6579 30.6811C17.9705 29.4309 18.0747 28.337 18.0747 27.0347C18.0747 23.3884 16.4598 19.8462 15.2097 17.9709Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18710"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "28.9104",
        height: "28.8583",
        fill: "white",
        transform: "translate(5.83331 3.33337)"
    }))));





const $c6d4958cc5e5b261$export$4b1b9db11d699ccb = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18698)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M19.5833 19.3159V26.7434H12.1417V19.3159H19.5833V11.8934H6.00833C5.28333 11.8984 4.7 12.4801 4.705 13.1934C4.705 13.1993 4.705 13.2051 4.705 13.2109V32.8876C4.69 33.6009 5.26583 34.1901 5.99 34.2051C5.99583 34.2051 6.0025 34.2051 6.00833 34.2051H25.7033C26.4283 34.2001 27.0117 33.6184 27.0067 32.9051C27.0067 32.8993 27.0067 32.8934 27.0067 32.8876V19.3159H19.5833Z",
        fill: "#1868DB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M19.5833 4.46666V11.8933H27.0425V19.3158H34.4616V5.76666C34.4766 5.05332 33.9008 4.46416 33.1766 4.44916C33.1708 4.44916 33.1641 4.44916 33.1583 4.44916L19.5833 4.46666Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18698"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));





const $bd60ef2a82de5097$export$93ca83db1787dea = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18702)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M32.2106 25.0334C23.981 21.0541 21.5768 20.4595 18.1093 20.4595C14.0407 20.4595 10.5731 22.1519 7.47546 26.9087L6.96689 27.6863C6.55078 28.3267 6.45831 28.5553 6.45831 28.8298C6.45831 29.1042 6.59701 29.3329 7.10559 29.6531L12.33 32.9006C12.6074 33.0835 12.8386 33.175 13.0698 33.175C13.3472 33.175 13.5321 33.0378 13.8095 32.6261L14.6417 31.3454C15.9363 29.3787 17.0921 28.7383 18.5716 28.7383C19.8662 28.7383 21.3919 29.1042 23.2875 30.019L28.7431 32.5804C29.2979 32.8548 29.8989 32.7176 30.1763 32.0773L32.7654 26.4056C33.0428 25.7653 32.8579 25.3536 32.2106 25.0334ZM8.2152 15.0166C16.4448 18.9959 18.849 19.5905 22.3166 19.5905C26.3851 19.5905 29.8527 17.8981 32.9504 13.1413L33.4589 12.3637C33.875 11.7233 33.9675 11.4947 33.9675 11.2202C33.9675 10.9458 33.8288 10.7171 33.3202 10.3969L28.0958 7.14943C27.8184 6.96648 27.5872 6.875 27.3561 6.875C27.0787 6.875 26.8937 7.01222 26.6163 7.42387L25.7841 8.70457C24.4896 10.6713 23.3337 11.3117 21.8542 11.3117C20.5597 11.3117 19.0339 10.9458 17.1384 10.031L11.6827 7.46961C11.1279 7.19517 10.5269 7.33239 10.2495 7.97274L7.6604 13.6444C7.38299 14.2847 7.56793 14.6964 8.2152 15.0166Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18702"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "27.5092",
        height: "26.3",
        fill: "white",
        transform: "translate(6.45831 6.875)"
    }))));





const $278594cad80ad367$export$4d0238652f4b6bc4 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18694)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M37.8564 20.4181C34.509 17.0708 29.0684 17.1063 25.7566 20.4181L22.9696 23.2051C21.4309 24.7439 18.9314 24.7439 17.3927 23.2051L15.0771 20.8895L9.02573 26.9409L11.3413 29.2565C16.2215 34.1367 24.1378 34.1367 29.018 29.2565L37.8564 20.4181ZM2.5 19.5848C5.84737 22.9322 11.2198 22.9648 14.5671 19.6174L17.3897 16.7948C18.9285 15.256 21.4279 15.256 22.9667 16.7948L25.2823 19.1104L31.3336 13.0591L29.018 10.7435C24.1378 5.86326 16.2215 5.86326 11.3413 10.7435L2.50296 19.5818L2.5 19.5848Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18694"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));





const $8e46bad3b7be5e7d$export$1afe31d4b2891d7a = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18700)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M22.0686 7.09728C25.7026 8.16332 29.3723 8.16332 33.0063 7.09728C33.3269 7.02621 33.5407 7.23942 33.4694 7.55923C32.4362 11.2904 32.4362 14.7372 33.4694 18.4683C33.5407 18.7526 33.3269 19.0014 33.0063 18.8948C29.3723 17.8998 25.7026 17.8998 22.0686 18.8948C21.7836 19.0014 21.5342 18.7526 21.6411 18.4683C22.603 14.7372 22.603 11.2904 21.6411 7.55923C21.5342 7.23942 21.7836 7.02621 22.0686 7.09728ZM23.5294 20.3161V20.9202C23.5294 23.7275 21.5698 25.7885 19.1472 25.7885C16.7245 25.7885 14.8006 23.8341 14.8006 21.4177C14.8006 19.0014 16.7601 17.0825 19.5034 17.0825H20.216V8.58973C19.8597 8.5542 19.5034 8.5542 19.1472 8.5542C12.0217 8.5542 6.25 14.3108 6.25 21.4532C6.25 28.5957 12.0217 34.3168 19.1472 34.3168C26.2727 34.3168 32.08 28.5602 32.08 21.4532V20.3161H23.5294Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18700"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "27.2333",
        height: "27.2333",
        fill: "white",
        transform: "translate(6.25 7.08334)"
    }))));





const $797166fcbb90ccba$export$f68d29dbb4f2da82 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18716)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M13.7923 27.2286H11.0183C6.83464 27.2286 3.83331 24.666 3.83331 20.9137H18.749C19.5221 20.9137 20.0223 21.4628 20.0223 22.2407V37.25C16.2934 37.25 13.7923 34.2299 13.7923 30.0199V27.2286ZM21.1592 19.7697H18.3852C14.2015 19.7697 11.2002 17.2529 11.2002 13.5006H26.1159C26.889 13.5006 27.4347 14.0039 27.4347 14.7819V29.7911C23.7058 29.7911 21.1592 26.771 21.1592 22.5611V19.7697ZM28.5715 12.3566H25.7976C21.6139 12.3566 18.6126 9.79401 18.6126 6.04169H33.5283C34.3014 6.04169 34.8016 6.59081 34.8016 7.32297V22.3323C31.0727 22.3323 28.5715 19.3121 28.5715 15.1022V12.3566Z",
        fill: "#1868DB"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18716"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "30.9683",
        height: "31.2083",
        fill: "white",
        transform: "translate(3.83331 6.04169)"
    }))));





const $fe783867988c674e$export$ceeb1de9ca56c2f7 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2230_18708)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M23.4886 16.3121H32.6441C34.0191 16.3121 34.4886 17.62 33.6502 18.6596L19.3301 36.3334C14.702 32.6444 15.138 26.809 18.5252 22.5499L23.4886 16.3121ZM16.4124 23.3547H7.2569C5.8819 23.3547 5.41238 22.0468 6.2508 21.0072L20.5709 3.3334C25.199 7.02243 24.6959 12.7907 21.3423 17.0834L16.4124 23.3547Z",
        fill: "#0C66E4"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2230_18708"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "28.2341",
        height: "33",
        fill: "white",
        transform: "translate(5.83331 3.33334)"
    }))));



var $8r2NN = parcelRequire("8r2NN");




const $950ee89ab585e7f2$export$7221b4e3b691d1b3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2230_18718)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M30.3575 6.41167H9.64252C7.85835 6.41167 6.41168 7.85833 6.41168 9.6425V30.3575C6.41168 32.1417 7.85835 33.5883 9.64252 33.5883H30.3575C32.1417 33.5883 33.5884 32.1417 33.5884 30.3575V9.6425C33.5884 7.85833 32.1417 6.41167 30.3575 6.41167ZM18.1184 25.9858C18.1184 26.5792 17.6375 27.0592 17.045 27.0592H12.5025C11.9092 27.0592 11.4292 26.5783 11.4292 25.9858V12.5025C11.4292 11.9092 11.91 11.4292 12.5025 11.4292H17.045C17.6383 11.4292 18.1184 11.91 18.1184 12.5025V25.9858ZM28.5709 19.7958C28.5709 20.3892 28.09 20.8692 27.4975 20.8692H22.955C22.3617 20.8692 21.8817 20.3883 21.8817 19.7958V12.5025C21.8817 11.9092 22.3625 11.4292 22.955 11.4292H27.4975C28.0909 11.4292 28.5709 11.91 28.5709 12.5025V19.7958Z",
        fill: "#1868DB"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2230_18718"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "40",
        height: "40",
        fill: "white"
    }))));




var $dvVWp = parcelRequire("dvVWp");



const $78ddbe15426907d6$export$2e51523f0c1b4542 = {
    [(0, $dvVWp.ProductKeys).Confluence]: {
        displayName: 'Confluence',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $bltJZ.ConfluenceIcon), 'Confluence'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $bd60ef2a82de5097$export$93ca83db1787dea), 'Confluence', 'large')
    },
    [(0, $dvVWp.ProductKeys).Atlas]: {
        displayName: 'Home',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $NlHoa.AtlassianIcon), 'Home'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $0273546edb01e5e1$export$b0a52366c3fb9b), 'Home', 'large')
    },
    [(0, $dvVWp.ProductKeys).Jira]: {
        displayName: 'Jira',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $bltJZ.JiraIcon), 'Jira'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $797166fcbb90ccba$export$f68d29dbb4f2da82), 'Jira', 'large')
    },
    [(0, $dvVWp.ProductKeys).JiraProductDiscovery]: {
        displayName: 'Jira Product Discovery',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $bltJZ.JiraProductDiscoveryIcon), 'Jira Product Discovery'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $8e46bad3b7be5e7d$export$1afe31d4b2891d7a), 'Jira Product Discovery', 'large')
    },
    [(0, $dvVWp.ProductKeys).JiraServiceManagement]: {
        displayName: 'Jira Service Management',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $bltJZ.JiraServiceManagementIcon), 'Jira Service Management'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $fe783867988c674e$export$ceeb1de9ca56c2f7), 'Jira Service Management', 'large')
    },
    [(0, $dvVWp.ProductKeys).Bitbucket]: {
        displayName: 'Bitbucket',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $bltJZ.BitbucketIcon), 'Bitbucket'),
        SearchResultIcon: (0, $hAvnk.RovoLogoFromLogo)((0, $bltJZ.BitbucketIcon), 'large')
    },
    [(0, $dvVWp.ProductKeys).Trello]: {
        displayName: 'Trello',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $bltJZ.TrelloIcon), 'Trello'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $950ee89ab585e7f2$export$7221b4e3b691d1b3), 'Trello', 'large')
    },
    [(0, $dvVWp.ProductKeys).Compass]: {
        displayName: 'Compass',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $bltJZ.CompassIcon), 'Compass'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $c6d4958cc5e5b261$export$4b1b9db11d699ccb), 'Compass', 'large')
    },
    [(0, $dvVWp.ProductKeys).Focus]: {
        displayName: 'Focus',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $bltJZ.FocusIcon), 'Focus'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $278594cad80ad367$export$4d0238652f4b6bc4), 'Focus', 'large')
    },
    [(0, $dvVWp.ProductKeys).Assets]: {
        displayName: 'Assets',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $bltJZ.AssetsIcon), 'Assets'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $7e38c84ca82e0760$export$24d355ce80de5803), 'Assets', 'large')
    },
    [(0, $dvVWp.ProductKeys).Talent]: {
        displayName: 'Talent',
        Icon: (0, $hAvnk.RovoLogoFromLogo)((0, $bltJZ.TalentIcon), 'Talent'),
        SearchResultIcon: (0, $hAvnk.get3PLogo)((0, $8r2NN.TalentSearchResultIcon), 'Talent', 'large')
    }
};
const $78ddbe15426907d6$var$getProducts3PFromConfig = ()=>{
    // The use of Partial, the if (config) and the cast here are intentional TS gymnastics
    // We KNOW that this returns a config for all the ProductKeys3P, so we cast that
    // The TS compiler can't know that, and we'd be forced to write UI code like:
    //
    // const Icon = configs[productKey].Icon
    // return Icon && <Icon />
    //
    // Because TS can't prove productKey can be guaranteed to index into configs. But we know it can!
    const thirdPartyProducts = (0, $fd0l2.ThirdPartyConfigsSync);
    const configs = {};
    (0, $dvVWp.all3pProductKeys).map((productKey3P)=>{
        const config = thirdPartyProducts.get(productKey3P);
        if (config) configs[productKey3P] = {
            displayName: config.displayName,
            Icon: config.icon,
            IconBorderless: config.iconBorderless,
            is3P: true,
            ...config.searchResultIcon && {
                SearchResultIcon: config.searchResultIcon
            }
        };
    });
    return configs;
};
const $78ddbe15426907d6$export$e2c1afe0b1afaf49 = ()=>{
    return (0, $cozmU.useMemo)(()=>{
        const thirdPartyProducts = $78ddbe15426907d6$var$getProducts3PFromConfig();
        return {
            ...$78ddbe15426907d6$export$2e51523f0c1b4542,
            ...thirdPartyProducts
        };
    }, []);
};
const $78ddbe15426907d6$export$ede9abe489c9321b = (productKey)=>{
    return $78ddbe15426907d6$export$e2c1afe0b1afaf49()[productKey];
};
// Used by SAIN to detrermine knowledge source filtering
var $78ddbe15426907d6$var$KnowledgeSourceTypeValues = /*#__PURE__*/ function(KnowledgeSourceTypeValues) {
    KnowledgeSourceTypeValues["GITHUB"] = "github";
    KnowledgeSourceTypeValues["CONFLUENCE"] = "confluence";
    KnowledgeSourceTypeValues["JIRA"] = "jira";
    KnowledgeSourceTypeValues["ATLAS"] = "atlas";
    KnowledgeSourceTypeValues["HELP_AGGREGATOR"] = "help_aggregator";
    KnowledgeSourceTypeValues["GOOGLE_DRIVE"] = "google_drive";
    KnowledgeSourceTypeValues["MICROSOFT_SHAREPOINT"] = "microsoft_sharepoint";
    KnowledgeSourceTypeValues["SLACK"] = "slack";
    KnowledgeSourceTypeValues["MICROSOFT_TEAMS"] = "teams";
    KnowledgeSourceTypeValues["FIGMA"] = "figma";
    KnowledgeSourceTypeValues["CONFLUENCE_DC"] = "confluence-dc";
    KnowledgeSourceTypeValues["ATLASSIAN_WEB_CRAWLER"] = "atlassian-web-crawler";
    KnowledgeSourceTypeValues["LOOM"] = "loom";
    KnowledgeSourceTypeValues["GOOGLE_CALENDAR"] = "google_calendar";
    KnowledgeSourceTypeValues["ASSETS"] = "cmdb";
    KnowledgeSourceTypeValues["SALESFORCE"] = "salesforce";
    KnowledgeSourceTypeValues["ZENDESK"] = "zendesk";
    KnowledgeSourceTypeValues["SERVICENOW"] = "servicenow";
    return KnowledgeSourceTypeValues;
}($78ddbe15426907d6$var$KnowledgeSourceTypeValues || {});
const $78ddbe15426907d6$export$4fbc006e529fd6c0 = {
    [(0, $dvVWp.ProductKeys).Confluence]: "confluence",
    [(0, $dvVWp.ProductKeys).Github]: "github",
    [(0, $dvVWp.ProductKeys).Jira]: "jira",
    [(0, $dvVWp.ProductKeys).Atlas]: "atlas",
    [(0, $dvVWp.ProductKeys).GoogleDrive]: "google_drive",
    [(0, $dvVWp.ProductKeys).Sharepoint]: "microsoft_sharepoint",
    [(0, $dvVWp.ProductKeys).Slack]: "slack",
    [(0, $dvVWp.ProductKeys).Teams]: "teams",
    [(0, $dvVWp.ProductKeys).Figma]: "figma",
    [(0, $dvVWp.ProductKeys).ConfluenceDC]: "confluence-dc",
    [(0, $dvVWp.ProductKeys).AtlassianWebCrawler]: "atlassian-web-crawler",
    [(0, $dvVWp.ProductKeys).Loom]: "loom",
    [(0, $dvVWp.ProductKeys).GoogleCalendar]: "google_calendar",
    [(0, $dvVWp.ProductKeys).Assets]: "cmdb",
    [(0, $dvVWp.ProductKeys).Salesforce]: "salesforce",
    [(0, $dvVWp.ProductKeys).Zendesk]: "zendesk",
    [(0, $dvVWp.ProductKeys).ServiceNow]: "servicenow"
};
module.exports["products1P"] = $78ddbe15426907d6$export$2e51523f0c1b4542;
module.exports["useProductConfigs"] = $78ddbe15426907d6$export$e2c1afe0b1afaf49;
module.exports["useProductConfig"] = $78ddbe15426907d6$export$ede9abe489c9321b;
module.exports["MapProductToKnowledgeSources"] = $78ddbe15426907d6$export$4fbc006e529fd6c0;

});

parcelRegister("8r2NN", function(module, exports) {
// Copied from packages/search/search-dialog/src/icons/square-return-icon.tsx

var $cozmU = parcelRequire("cozmU");

const $10b6f9203403c8be$export$5427c633f31d110f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("svg", {
        width: "32",
        height: "33",
        viewBox: "0 0 32 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip0_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip1_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("g", {
        clipPath: "url(#clip2_2321_14935)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "#FB9700"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M16.5762 5.00928L19.6123 11.7729L26.9834 12.5708L27.3369 13.6597L21.8418 18.6372L23.3623 25.8931L22.4355 26.5669L16.0039 22.8784L9.57227 26.5669L8.64551 25.8931L10.165 18.6372L4.66992 13.6597L5.02441 12.5708L12.3955 11.7729L15.4316 5.00928H16.5762ZM15.9082 16.9458C14.5408 16.946 13.4326 18.0549 13.4326 19.4224V20.3267C14.1301 20.7301 14.9385 20.964 15.8008 20.9702H15.8711C16.794 20.9636 17.6552 20.696 18.3848 20.2388V19.4224C18.3848 18.0548 17.2758 16.9458 15.9082 16.9458ZM15.9082 12.4341C14.8828 12.4342 14.0519 13.2651 14.0518 14.2905C14.0518 15.3161 14.8827 16.1478 15.9082 16.1479C16.9339 16.1479 17.7656 15.3162 17.7656 14.2905C17.7655 13.265 16.9338 12.4341 15.9082 12.4341Z",
        fill: "#101214"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip0_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip1_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("rect", {
        width: "32",
        height: "32",
        fill: "white",
        transform: "translate(0 0.101562)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("clipPath", {
        id: "clip2_2321_14935"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("path", {
        d: "M0 8.10156C0 3.68328 3.58172 0.101562 8 0.101562H24C28.4183 0.101562 32 3.68328 32 8.10156V24.1016C32 28.5198 28.4183 32.1016 24 32.1016H8C3.58172 32.1016 0 28.5198 0 24.1016V8.10156Z",
        fill: "white"
    }))));
module.exports["TalentSearchResultIcon"] = $10b6f9203403c8be$export$5427c633f31d110f;

});

parcelRegister("kl6Mg", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

const $6d9646ded84ad880$var$HIGHLIGHT_START_TAG = '@@@hl@@@';
const $6d9646ded84ad880$var$HIGHLIGHT_END_TAG = '@@@endhl@@@';
const $6d9646ded84ad880$var$highlightMarkerRE = new RegExp(`${$6d9646ded84ad880$var$HIGHLIGHT_START_TAG}|${$6d9646ded84ad880$var$HIGHLIGHT_END_TAG}`, 'g');
const $6d9646ded84ad880$export$8ebd5c051fe06ad1 = (text)=>text.replace($6d9646ded84ad880$var$highlightMarkerRE, '');
const $6d9646ded84ad880$var$highlightRE = new RegExp(`${$6d9646ded84ad880$var$HIGHLIGHT_START_TAG}(.*?)${$6d9646ded84ad880$var$HIGHLIGHT_END_TAG}.*`);
const $6d9646ded84ad880$var$openingTagRE = new RegExp(`(.*?)${$6d9646ded84ad880$var$HIGHLIGHT_START_TAG}`);
const $6d9646ded84ad880$export$c43ff622b37ceaa9 = (title)=>{
    const enrichedTitle = [];
    // counter added to maintain uniqueness of element key
    // during subsequent rerenders due to query changes
    let counter = 0;
    if (!title.match($6d9646ded84ad880$var$highlightRE)) // if there are no matches then return the title as is
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        as: "span",
        key: title + counter
    }, title);
    while(title){
        const [preMatch, preText] = title.match($6d9646ded84ad880$var$openingTagRE) || [];
        title = title.replace(preText, '');
        if (preText && preText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            key: preText + counter
        }, preText));
        const [boldMatch, highlightText] = title.match($6d9646ded84ad880$var$highlightRE) || [];
        title = title.replace(`${$6d9646ded84ad880$var$HIGHLIGHT_START_TAG}${highlightText}${$6d9646ded84ad880$var$HIGHLIGHT_END_TAG}`, '');
        if (highlightText && highlightText !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "strong",
            key: highlightText + counter
        }, highlightText));
        if (preMatch === undefined && boldMatch === undefined) {
            if (title !== '') enrichedTitle.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                key: title + counter
            }, title));
            break;
        }
        counter++;
    }
    return enrichedTitle;
};
module.exports["stripHighlightMarkers"] = $6d9646ded84ad880$export$8ebd5c051fe06ad1;
module.exports["enrichResultTitle"] = $6d9646ded84ad880$export$c43ff622b37ceaa9;

});

parcelRegister("4g98k", function(module, exports) {
/**
 * Returns true for middle-clicks (button === 1). Right-clicks are excluded to avoid
 * double-counting with onContextMenu.
 */ const $02d4cf935ae99537$export$15213acd7ac7d39a = (e)=>{
    return e.button === 1;
};
module.exports["isAuxClick"] = $02d4cf935ae99537$export$15213acd7ac7d39a;

});

parcelRegister("3MEmE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $buHp0 = parcelRequire("buHp0");


var $9DHhW = parcelRequire("9DHhW");


var $iDrrr = parcelRequire("iDrrr");


var $6yu7A = parcelRequire("6yu7A");


var $4g98k = parcelRequire("4g98k");


var $iuvXK = parcelRequire("iuvXK");

const $137098e641823691$export$8280134f2e1dd939 = (url)=>{
    if (!url) return null;
    try {
        // A base is supplied so relative URLs parse; `generateUrlWithParams` accepts
        // them too, and it is stripped again because only the query is read.
        const { searchParams: searchParams } = new URL(url, 'http://localhost/');
        const encoded = searchParams.get((0, $iuvXK.URL_QUERY_PARAM_INTERACTION_SESSION));
        if (!encoded) return null;
        // `searchParams.get` has already percent-decoded the value.
        const decoded = JSON.parse(atob(encoded));
        if (!decoded?.bridge || !decoded?.id || !decoded?.source) return null;
        return {
            bridge: decoded.bridge,
            id: decoded.id,
            source: decoded.source
        };
    } catch  {
        // Malformed base64, malformed JSON, or an unparseable URL. A corrupt param
        // must not break navigation, so it is treated as absent.
        return null;
    }
};


/**
 * One id for every search result link. `bridge` (from the decoded param) already
 * separates the Search Page from Quick Find, and `destinationApp` already says
 * where the link goes, so a per-surface id would mostly duplicate those while
 * forcing consumers to know the full set of values.
 */ const $e5a2431687918cbd$var$ACTION_SUBJECT_ID = 'searchResultLink';
const $e5a2431687918cbd$export$1ac7aaf3243265d1 = ({ href: href, destinationApp: destinationApp })=>{
    // `fireCustomCrossAppAnalytic` needs the raw `createAnalyticsEvent`, not the
    // `useAnalytics` controller wrapper, so this hook owns the analytics-next
    // dependency. It lives in `common/utils` rather than `controllers/events`
    // because `common/ui` consumes it and must not depend on `controllers`.
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    // Gated on wrapping itself: this reports on wrapped links, so it must not
    // outlive them. The gate is also belt-and-braces against a result URL that
    // arrives from the backend already carrying an `xpis` param — with wrapping
    // off there is no interaction session to attribute such a click to.
    const isEnabled = (0, $iDrrr.fg)('rovo_search_cross_product_url_wrapping');
    const fireCrossAppAnalytic = (0, $cozmU.useCallback)(()=>{
        if (!isEnabled || !destinationApp) return;
        const interactionSession = (0, $137098e641823691$export$8280134f2e1dd939)(href);
        // No usable `xpis` means the link was never wrapped, so there is no
        // cross-product interaction to report.
        if (!interactionSession) return;
        (0, $buHp0.fireCustomCrossAppAnalytic)({
            tags: [
                'navigationExperiences'
            ],
            analyticsEventFireName: (0, $6yu7A.DEFAULT_GAS_CHANNEL),
            destinationApp: destinationApp,
            bridge: interactionSession.bridge,
            source: interactionSession.source,
            actionSubjectId: $e5a2431687918cbd$var$ACTION_SUBJECT_ID,
            createAnalyticsEvent: createAnalyticsEvent
        });
    }, [
        isEnabled,
        href,
        destinationApp,
        createAnalyticsEvent
    ]);
    return (0, $cozmU.useMemo)(()=>({
            onClick: fireCrossAppAnalytic,
            // `auxclick` covers middle-click (button 1) but also right-click (button 2),
            // and opening the context menu is not a navigation, so it must be filtered.
            onAuxClick: (event)=>{
                if ((0, $4g98k.isAuxClick)(event)) fireCrossAppAnalytic();
            }
        }), [
        fireCrossAppAnalytic
    ]);
};
module.exports["useCrossAppLinkHandlers"] = $e5a2431687918cbd$export$1ac7aaf3243265d1;

});

parcelRegister("gUz4r", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $aIlZA = parcelRequire("aIlZA");


var $iDrrr = parcelRequire("iDrrr");


var $dvVWp = parcelRequire("dvVWp");

/**
 * Explicitly OPT IN a non-1P product to cross-product URL wrapping.
 *
 * Use sparingly — most products that should be wrapped are expressible via
 * the 1P default rule. Typed loosely as `Record<string, true>` because, by
 * definition, these keys are not in {@link ProductKeys1P}.
 */ const $e3a66e73ec1fc558$var$ADDITIONAL_WRAPPABLE_PRODUCTS = {
    goals: true,
    projects: true,
    loom: true,
    teams: true
};
/**
 * Explicitly OPT OUT a 1P product from cross-product URL wrapping.
 *
 * Typed against {@link ProductKeys1P} so a stale entry (e.g. after a 1P key
 * is removed from the master `ProductKeys1P` constant) fails the build.
 */ const $e3a66e73ec1fc558$var$NON_WRAPPABLE_1P = {
};
const $e3a66e73ec1fc558$export$4cf40959dee0db9c = (resultProduct)=>{
    if (resultProduct in $e3a66e73ec1fc558$var$NON_WRAPPABLE_1P) return false;
    if (resultProduct in $e3a66e73ec1fc558$var$ADDITIONAL_WRAPPABLE_PRODUCTS) return true;
    return (0, $dvVWp.is1pProductKey)(resultProduct);
};
const $e3a66e73ec1fc558$export$8e7034cb7abd8b0f = {
    ADDITIONAL_WRAPPABLE_PRODUCTS: $e3a66e73ec1fc558$var$ADDITIONAL_WRAPPABLE_PRODUCTS,
    NON_WRAPPABLE_1P: $e3a66e73ec1fc558$var$NON_WRAPPABLE_1P
};
const $e3a66e73ec1fc558$export$2a57f89490774c5c = (args)=>{
    const { bridge: bridge, primaryProduct: primaryProduct, primarySubProduct: primarySubProduct } = args;
    // `useCrossProductUrlWrapper` requires a non-empty `product` string. When
    // `primaryProduct` is undefined the outer guard below short-circuits and
    // the wrapper is never invoked, so this fallback is only there to keep
    // the hook call legal.
    const wrapUrl = (0, $aIlZA.default)({
        bridge: bridge,
        product: primaryProduct ?? 'unknown',
        subProduct: primarySubProduct || undefined
    });
    const isEnabled = (0, $iDrrr.fg)('rovo_search_cross_product_url_wrapping');
    return (0, $cozmU.useMemo)(()=>(url, resultProduct)=>{
            if (!isEnabled || !url || !primaryProduct || !resultProduct) return url;
            if (!$e3a66e73ec1fc558$export$4cf40959dee0db9c(resultProduct)) return url;
            return wrapUrl(url);
        }, [
        wrapUrl,
        primaryProduct,
        isEnabled
    ]);
};
module.exports["useSearchCrossProductUrlWrapper"] = $e3a66e73ec1fc558$export$2a57f89490774c5c;

});

parcelRegister("3zSbE", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $l8Rhq = parcelRequire("l8Rhq");


var $c11PZ = parcelRequire("c11PZ");

const $c757ad1271939867$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $cozmU.forwardRef)((props, ref)=>{
    const { onNavigate: onNavigate } = (0, $c11PZ.useAppContext)();
    const { href: href, onClick: originalOnClick } = props;
    const onClick = (0, $cozmU.useCallback)((event, analyticsEvent)=>{
        originalOnClick?.(event, analyticsEvent);
        // Use onNavigate if
        // - alwaysUseOnLinkClick is true
        // - navigating to the same site and not new tab/window
        const metaPressed = event.ctrlKey || event.metaKey || event.shiftKey;
        const sameOrigin = window.location.origin === new URL(href).origin;
        const onNavigateOverride = typeof onNavigate === 'object' ? onNavigate.options.alwaysUseOnLinkClick : false;
        const useOnNavigate = onNavigateOverride || sameOrigin && !metaPressed;
        if (useOnNavigate) {
            event.preventDefault();
            // Handles SPA navigation if consumer provides their own onNavigate
            const onNavigateCallback = typeof onNavigate === 'function' ? onNavigate : onNavigate.callback;
            onNavigateCallback(href, 'push');
        }
    }, [
        href,
        onNavigate,
        originalOnClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l8Rhq.Anchor), {
        ref: ref,
        ...props,
        onClick: onClick
    });
});
module.exports["Link"] = $c757ad1271939867$export$a6c7ac8248d6e38a;

});

parcelRegister("9S5yN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");

var $kz1Yj = parcelRequire("kz1Yj");

var $buxP3 = parcelRequire("buxP3");


var $73Hia = parcelRequire("73Hia");


var $7pmcn = parcelRequire("7pmcn");


var $6Vsfx = parcelRequire("6Vsfx");


var $bgCtI = parcelRequire("bgCtI");


var $6ShBo = parcelRequire("6ShBo");


var $9ycOp = parcelRequire("9ycOp");

const $0d5eeb69065ed4b2$var$socialMetadataStyles = (0, $buxP3.xcss)({
    alignItems: 'center',
    paddingInlineStart: 'space.050',
    paddingInlineEnd: 'space.050'
});
const $0d5eeb69065ed4b2$var$subheadingStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $0d5eeb69065ed4b2$var$subheadingLeftAreaStyles = (0, $buxP3.xcss)({
    gridArea: 'subheading-left',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '16px',
    overflow: 'hidden'
});
const $0d5eeb69065ed4b2$var$inlineStyles = (0, $buxP3.xcss)({
    flex: '1 0 auto',
    position: 'absolute',
    zIndex: 'card',
    alignItems: 'center'
});
const $0d5eeb69065ed4b2$var$hiddenReferenceInlineStyles = (0, $buxP3.xcss)({
    flex: '1 0 auto',
    visibility: 'hidden',
    position: 'relative',
    zIndex: '1',
    alignItems: 'center'
});
const $0d5eeb69065ed4b2$var$metadataItemStyles = (0, $buxP3.xcss)({
    display: 'inline-flex',
    alignItems: 'center'
});
const $0d5eeb69065ed4b2$var$renderParts = (part, spacer)=>{
    const [key, value] = Array.isArray(part) ? part : [
        part,
        part
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), {
        key: key
    }, value, spacer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6ShBo.Spacer), null));
};
const $0d5eeb69065ed4b2$var$filterPart = (part)=>{
    if (Array.isArray(part)) return !!part[1];
    return !!part;
};
const $0d5eeb69065ed4b2$var$renderSocialMetadata = (defaultSocialParts)=>{
    const socialSignalIndex = defaultSocialParts.findIndex((item)=>Array.isArray(item) && item[1] === 'social-signal');
    const hasBreadcrumb = socialSignalIndex !== -1;
    const parts = defaultSocialParts.filter((_, index)=>index !== socialSignalIndex).filter($0d5eeb69065ed4b2$var$filterPart);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        space: "space.150",
        xcss: $0d5eeb69065ed4b2$var$socialMetadataStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, parts?.map((m)=>$0d5eeb69065ed4b2$var$renderParts(m, false)))), hasBreadcrumb && defaultSocialParts[defaultSocialParts.length - 1]);
};
const $0d5eeb69065ed4b2$var$SearchMetadataWithOverflowObserver = ({ metadataItems: metadataItems, searchResultId: searchResultId, containerRef: containerRef })=>{
    const headerMetadataWithIds = metadataItems.map((item, index)=>{
        const prefix = searchResultId || 'default';
        return {
            id: `metadata-${prefix}-${index}`,
            content: item
        };
    });
    const headerMetadataRefs = (0, $cozmU.useRef)([]);
    headerMetadataRefs.current = headerMetadataWithIds.map((_, i)=>headerMetadataRefs.current[i] ?? /*#__PURE__*/ (0, $cozmU.createRef)());
    const visibleItems = (0, $9ycOp.useOverflowObserver)({
        containerRef: containerRef,
        itemRefs: headerMetadataRefs,
        itemIds: headerMetadataWithIds.map((item)=>item.id)
    });
    const hasHiddenItems = headerMetadataWithIds.length > visibleItems.length;
    const processVisibleItems = ()=>{
        const visibleMetadata = headerMetadataWithIds.filter((item)=>visibleItems.includes(item.id));
        // If we have hidden items, remove spacer from last visible item
        if (hasHiddenItems && visibleMetadata.length > 0) {
            const lastIndex = visibleMetadata.length - 1;
            visibleMetadata[lastIndex] = {
                ...visibleMetadata[lastIndex],
                content: (0, $7pmcn.filterSpacer)(visibleMetadata[lastIndex].content)
            };
        }
        return visibleMetadata;
    };
    const processedVisibleItems = processVisibleItems();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: [
            $0d5eeb69065ed4b2$var$subheadingLeftAreaStyles,
            $0d5eeb69065ed4b2$var$subheadingStyles
        ],
        testId: "search-page-result-metadata"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        xcss: [
            $0d5eeb69065ed4b2$var$hiddenReferenceInlineStyles
        ],
        testId: "search-page-result-metadata-hidden"
    }, headerMetadataWithIds.map((item, index)=>{
        const elementId = `reference:${item.id}`;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            key: elementId,
            id: elementId,
            ref: headerMetadataRefs.current[index],
            xcss: $0d5eeb69065ed4b2$var$metadataItemStyles
        }, item.content);
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kz1Yj.Inline), {
        xcss: [
            $0d5eeb69065ed4b2$var$inlineStyles
        ],
        testId: "search-page-result-metadata-visible"
    }, processedVisibleItems.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            key: `visible-${item.id}`,
            xcss: $0d5eeb69065ed4b2$var$metadataItemStyles
        }, item.content)), hasHiddenItems && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bgCtI.MetadataPopupButton), {
        metadata: headerMetadataWithIds.filter((item)=>!visibleItems.includes(item.id)).map((item)=>item.content),
        isFirstElement: processedVisibleItems.length === 0
    })));
};
const $0d5eeb69065ed4b2$export$8e7fb1f8fe599124 = ({ searchResultId: searchResultId, product: product, productSelected: productSelected, parts: defaultParts = [], socialParts: defaultSocialParts = [], displaySpacer: displaySpacer = true, containerRef: containerRef, selectedSites: selectedSites })=>{
    const products = (0, $73Hia.useProductConfigs)();
    // TODO: Shouldn't need to cast here, need to clean up the stack above this to not pass string around as product
    // Product name is hidden when productSelected=true (i.e. a specific app is selected)
    const productDisplayName = !product || productSelected ? '' : products[product]?.displayName || '';
    const parts = defaultParts.filter($0d5eeb69065ed4b2$var$filterPart);
    const hasSocialParts = defaultSocialParts.filter($0d5eeb69065ed4b2$var$filterPart).length > 0;
    if (hasSocialParts) parts.push([
        'social-metadata',
        $0d5eeb69065ed4b2$var$renderSocialMetadata(defaultSocialParts)
    ]);
    if (productDisplayName) parts.unshift([
        'product-display-name',
        productDisplayName
    ]);
    // More than one site in scope means the search spans sites, so results are worth attributing.
    const siteName = (selectedSites?.size ?? 0) > 1 ? (0, $6Vsfx.getSiteName)(searchResultId, selectedSites) : undefined;
    if (siteName) parts.unshift([
        'site-name',
        siteName
    ]);
    const metadataItems = parts.map((m, i)=>$0d5eeb69065ed4b2$var$renderParts(m, displaySpacer && i < parts.length - 1));
    // If we don't have a containerRef, we don't want to use the overflow observer
    return containerRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($0d5eeb69065ed4b2$var$SearchMetadataWithOverflowObserver, {
        metadataItems: metadataItems,
        searchResultId: searchResultId,
        containerRef: containerRef
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, metadataItems);
};
module.exports["SearchMetadata"] = $0d5eeb69065ed4b2$export$8e7fb1f8fe599124;

});

parcelRegister("7pmcn", function(module, exports) {
/**
 * This file was adapted from confluence/next/packages/search-utils/src/excerpt.tsx
 */ 
var $cozmU = parcelRequire("cozmU");

const $4ee30c55723646c9$export$325faed136549eaf = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(node)) return node;
    // Check if element is a Spacer component
    if (typeof node.type === 'function' && node.type.IS_METADATA_SPACER) return null;
    // If the element has children, filter out spacers
    if (node.props.children) {
        const children = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(node.props.children);
        const filteredChildren = children.filter((child)=>!/*#__PURE__*/ ((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child) && typeof child.type === 'function' && child.type.IS_METADATA_SPACER));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(node, node.props, ...filteredChildren);
    }
    return node;
};
module.exports["filterSpacer"] = $4ee30c55723646c9$export$325faed136549eaf;

});

parcelRegister("6Vsfx", function(module, exports) {

var $7avaU = parcelRequire("7avaU");


var $j2nXD = parcelRequire("j2nXD");

const $c65f2af85e8e4dd6$export$f59daa7c22f639ca = (ari)=>{
    if (!ari) return undefined;
    try {
        return (0, $7avaU.AnyAri).parse(ari).cloudId?.trim() || undefined;
    } catch  {
        return undefined;
    }
};
/**
 * Normalises a raw `?sites=` query param into site ids. The value reaches us unparsed, so it can be
 * a comma-separated string or an already-split array.
 */ const $c65f2af85e8e4dd6$var$toSiteIds = (rawSelectedSites)=>{
    const sites = Array.isArray(rawSelectedSites) ? rawSelectedSites : typeof rawSelectedSites === 'string' ? rawSelectedSites.split(',') : [];
    return sites.map((site)=>site.trim()).filter(Boolean);
};
const $c65f2af85e8e4dd6$export$c096d96d138a38cc = (rawSelectedSites, unitMetadata, currentCloudId)=>{
    const selectedSites = Object.assign(new Map(), {
        availableSitesCount: unitMetadata?.length
    });
    const sitesInScope = new Set($c65f2af85e8e4dd6$var$toSiteIds(rawSelectedSites));
    if (currentCloudId) sitesInScope.add(currentCloudId);
    for (const site of unitMetadata ?? []){
        const siteCloudId = (0, $j2nXD.getSiteCloudId)(site.id);
        if (sitesInScope.has(siteCloudId) && !selectedSites.has(siteCloudId)) selectedSites.set(siteCloudId, site.siteName);
    }
    return selectedSites;
};
const $c65f2af85e8e4dd6$export$99ca96cfa52d5605 = (selectedSites)=>selectedSites?.availableSitesCount;
const $c65f2af85e8e4dd6$export$8789a1de7f140d8d = (resultId, selectedSites)=>{
    const cloudId = $c65f2af85e8e4dd6$export$f59daa7c22f639ca(resultId);
    return cloudId ? selectedSites?.get(cloudId) : undefined;
};
const $c65f2af85e8e4dd6$export$7f9d9b17348c7f29 = (resultId, currentCloudId, selectedSites)=>{
    const availableSitesCount = $c65f2af85e8e4dd6$export$99ca96cfa52d5605(selectedSites);
    // An absent or empty lookup means the search was not site-scoped. Availability is independent of
    // the search scope, so report it when known.
    if (!selectedSites?.size) return availableSitesCount !== undefined ? {
        availableSitesCount: availableSitesCount
    } : {};
    const resultCloudId = $c65f2af85e8e4dd6$export$f59daa7c22f639ca(resultId);
    return {
        selectedSitesCount: selectedSites.size,
        isPrimarySite: currentCloudId && resultCloudId ? resultCloudId === currentCloudId : undefined,
        ...availableSitesCount !== undefined ? {
            availableSitesCount: availableSitesCount
        } : {}
    };
};
module.exports["extractCloudIdFromAri"] = $c65f2af85e8e4dd6$export$f59daa7c22f639ca;
module.exports["buildSelectedSites"] = $c65f2af85e8e4dd6$export$c096d96d138a38cc;
module.exports["getAvailableSitesCount"] = $c65f2af85e8e4dd6$export$99ca96cfa52d5605;
module.exports["getSiteName"] = $c65f2af85e8e4dd6$export$8789a1de7f140d8d;
module.exports["getSiteMetadata"] = $c65f2af85e8e4dd6$export$7f9d9b17348c7f29;

});

parcelRegister("j2nXD", function(module, exports) {
// Multi-site selection caps (QS-9518), shared by SiteSelect and the `site` filter.

var $7avaU = parcelRequire("7avaU");

const $b2f7466bf7ca359e$export$58cd6790f867654e = 5;
const $b2f7466bf7ca359e$export$e7aa807d35b04e85 = (siteId)=>{
    if (!siteId.startsWith('ari:')) return siteId;
    try {
        return (0, $7avaU.AnyAri).parse(siteId).resourceId || siteId;
    } catch  {
        return siteId;
    }
};
module.exports["MAX_SELECTED_SITES"] = $b2f7466bf7ca359e$export$58cd6790f867654e;
module.exports["getSiteCloudId"] = $b2f7466bf7ca359e$export$e7aa807d35b04e85;

});

parcelRegister("bgCtI", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1sCHt = parcelRequire("1sCHt");


var $6TaGl = parcelRequire("6TaGl");


var $4n1IT = parcelRequire("4n1IT");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $7pmcn = parcelRequire("7pmcn");

const $4b9e0a09d5f453aa$var$popupContentContainerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    padding: 'space.200',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 'space.100',
    borderRadius: 'radius.small',
    background: 'elevation.surface.overlay',
    boxShadow: 'elevation.shadow.overlay'
});
const $4b9e0a09d5f453aa$var$subheadingStyles = (0, $buxP3.xcss)({
    color: 'color.text.subtlest',
    font: 'font.body'
});
const $4b9e0a09d5f453aa$var$iconButtonContainerStyles = (0, $buxP3.xcss)({
    margin: 'space.025',
    marginLeft: 'space.075',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $4b9e0a09d5f453aa$var$iconButtonContainerIsFirstElementStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.025'
});
const $4b9e0a09d5f453aa$export$b31e3e19fb9e4d37 = ({ metadata: metadata, isFirstElement: isFirstElement })=>{
    const [isOpen, setIsOpen] = (0, $cozmU.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4n1IT.Popup), {
        isOpen: isOpen,
        onClose: ()=>setIsOpen(false),
        placement: "bottom-start",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: [
                    $4b9e0a09d5f453aa$var$popupContentContainerStyles,
                    $4b9e0a09d5f453aa$var$subheadingStyles
                ]
            }, metadata.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                    key: index
                }, (0, $7pmcn.filterSpacer)(item)))),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
                xcss: [
                    $4b9e0a09d5f453aa$var$iconButtonContainerStyles,
                    isFirstElement && $4b9e0a09d5f453aa$var$iconButtonContainerIsFirstElementStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1sCHt.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: "compact",
                isSelected: isOpen,
                onClick: ()=>setIsOpen(!isOpen),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: "More"
            }))
    });
};
module.exports["MetadataPopupButton"] = $4b9e0a09d5f453aa$export$b31e3e19fb9e4d37;

});

parcelRegister("6ShBo", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");

const $be86f90767df5829$var$metadataSpacerStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});
const $be86f90767df5829$export$d7a54cba636a8cd6 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        as: "span",
        xcss: $be86f90767df5829$var$metadataSpacerStyles
    }, "\u2022");
$be86f90767df5829$export$d7a54cba636a8cd6.IS_METADATA_SPACER = true;
module.exports["Spacer"] = $be86f90767df5829$export$d7a54cba636a8cd6;

});

parcelRegister("9ycOp", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $cozmU = parcelRequire("cozmU");

const $0eca73e86c1e9001$export$c376cfef3a1f950d = ({ containerRef: containerRef, itemRefs: itemRefs, itemIds: itemIds, alwaysVisibleRef: alwaysVisibleRef, enabled: enabled })=>{
    const observerRef = (0, $cozmU.useRef)(null);
    const [visibleItems, setVisibleItems] = (0, $cozmU.useState)(itemIds);
    const rightNavWidth = alwaysVisibleRef ? alwaysVisibleRef.current?.offsetWidth ?? 80 : 0;
    const rootMargin = `0px -${rightNavWidth}px 0px 0px`;
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const target = entry.target;
                const targetId = target.getAttribute('id');
                const isReferenceElement = targetId?.startsWith('reference:');
                if (isReferenceElement && targetId) {
                    const elementId = targetId.split('reference:')[1];
                    // Set visibility for corresponding target element from reference element id
                    if (entry.isIntersecting) setVisibleItems((prev)=>[
                            ...prev.filter((id)=>id !== elementId),
                            elementId
                        ]);
                    else setVisibleItems((prev)=>prev.filter((id)=>id !== elementId));
                }
            });
        }, {
            root: containerRef.current,
            rootMargin: rootMargin,
            threshold: 0.99
        });
        observerRef.current = observer;
        return ()=>{
            observer.disconnect();
        };
    }, [
        containerRef,
        enabled,
        rootMargin
    ]);
    (0, $cozmU.useEffect)(()=>{
        const observer = observerRef.current;
        if (!enabled || !observer) return;
        itemRefs.current.forEach((itemRef)=>{
            if (itemRef?.current) observer.observe(itemRef.current);
        });
    }, [
        enabled,
        itemRefs,
        itemIds
    ]);
    return visibleItems;
};





const $c658a36d3496668c$var$INTERSECTION_THRESHOLD = 1;
// Checks whether two ordered item ID lists are identical so observer updates do not trigger
// unnecessary React renders when the set of visible items has not changed.
const $c658a36d3496668c$var$areItemIdsEqual = (first, second)=>first.length === second.length && first.every((id, index)=>id === second[index]);
// Extracts the item ID from a hidden reference element (for example, "reference:contributor")
// so an IntersectionObserver entry can be associated with the item it is measuring.
const $c658a36d3496668c$var$getReferenceElementId = (element)=>{
    const targetId = element.getAttribute('id');
    return targetId?.startsWith('reference:') ? targetId.slice(10) : undefined;
};
// Reads the layout gap between the dynamic filters and alwaysVisibleRef so the observer reserves
// the same amount of space as the visible row. There is no gap to reserve without a parent.
const $c658a36d3496668c$var$getParentColumnGap = (element)=>{
    if (!element.parentElement) return 0;
    return Number.parseFloat(getComputedStyle(element.parentElement).columnGap || '0') || 0;
};
const $c658a36d3496668c$export$c376cfef3a1f950d = ({ containerRef: containerRef, itemRefs: itemRefs, itemIds: itemIds, alwaysVisibleRef: alwaysVisibleRef, firstRenderVisibility: firstRenderVisibility = 'show', enabled: enabled })=>{
    const [measurement, setMeasurement] = (0, $cozmU.useState)();
    const [alwaysVisibleReservedSpace, setAlwaysVisibleReservedSpace] = (0, $cozmU.useState)(alwaysVisibleRef ? undefined : 0);
    // Tracks which items are being shown and the space reserved for alwaysVisibleRef and its gap.
    const measurementKey = JSON.stringify([
        itemIds,
        alwaysVisibleReservedSpace ?? 'pending'
    ]);
    const itemIdsRef = (0, $cozmU.useRef)(itemIds);
    itemIdsRef.current = itemIds;
    // Measures alwaysVisibleRef and its parent gap, keeping the reserved space updated as its
    // contents change.
    // For example, selecting a filter adds the Clear all control and increases the reserved width.
    (0, $cozmU.useEffect)(()=>{
        if (!enabled) return;
        if (!alwaysVisibleRef) {
            setAlwaysVisibleReservedSpace(0);
            return;
        }
        const element = alwaysVisibleRef.current;
        if (!element) return;
        const updateWidth = ()=>{
            const nextWidth = element.offsetWidth + $c658a36d3496668c$var$getParentColumnGap(element);
            setAlwaysVisibleReservedSpace((currentWidth)=>currentWidth === nextWidth ? currentWidth : nextWidth);
        };
        updateWidth();
        const resizeObserver = new ResizeObserver(updateWidth);
        resizeObserver.observe(element);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        alwaysVisibleRef,
        enabled
    ]);
    // Observes every hidden reference item, publishes visibility only after all items have been
    // measured, and keeps the visible list updated as the available layout space changes.
    (0, $cozmU.useEffect)(()=>{
        if (!enabled || alwaysVisibleReservedSpace === undefined) return;
        let isDisposed = false;
        const intersections = new Map();
        const observer = new IntersectionObserver((entries)=>{
            if (isDisposed) return;
            entries.forEach((entry)=>{
                const elementId = $c658a36d3496668c$var$getReferenceElementId(entry.target);
                if (!elementId || !itemIdsRef.current.includes(elementId)) return;
                intersections.set(elementId, entry.isIntersecting && entry.intersectionRatio >= $c658a36d3496668c$var$INTERSECTION_THRESHOLD);
            });
            const currentItemIds = itemIdsRef.current;
            if (!currentItemIds.every((id)=>intersections.has(id))) return;
            const nextVisibleItems = currentItemIds.filter((id)=>intersections.get(id) === true);
            setMeasurement((previousMeasurement)=>previousMeasurement?.key === measurementKey && $c658a36d3496668c$var$areItemIdsEqual(previousMeasurement.visibleItems, nextVisibleItems) ? previousMeasurement : {
                    key: measurementKey,
                    visibleItems: nextVisibleItems
                });
        }, {
            root: containerRef.current,
            rootMargin: `0px -${alwaysVisibleReservedSpace}px 0px 0px`,
            threshold: $c658a36d3496668c$var$INTERSECTION_THRESHOLD
        });
        itemRefs.current.forEach((itemRef)=>{
            if (itemRef?.current) observer.observe(itemRef.current);
        });
        return ()=>{
            isDisposed = true;
            observer.disconnect();
        };
    }, [
        containerRef,
        enabled,
        itemRefs,
        measurementKey,
        alwaysVisibleReservedSpace
    ]);
    const visibleItems = measurement?.visibleItems ?? itemIds;
    const hasMeasured = itemIds.length === 0 || measurement !== undefined;
    return hasMeasured || firstRenderVisibility === 'show' ? visibleItems : [];
};


const $f3d70ec76b2062a4$export$c376cfef3a1f950d = (props)=>{
    const useNextImplementation = (0, $iDrrr.fg)('rovo_fps_fix_filter_overflow_flash');
    const legacyVisibleItems = (0, $0eca73e86c1e9001$export$c376cfef3a1f950d)({
        ...props,
        enabled: !useNextImplementation
    });
    const nextVisibleItems = (0, $c658a36d3496668c$export$c376cfef3a1f950d)({
        ...props,
        enabled: useNextImplementation
    });
    return useNextImplementation ? nextVisibleItems : legacyVisibleItems;
};
module.exports["useOverflowObserver"] = $f3d70ec76b2062a4$export$c376cfef3a1f950d;

});

parcelRegister("1xRe4", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $3P0Fk = parcelRequire("3P0Fk");


var $7nrkp = parcelRequire("7nrkp");

const $1e114c24d4299a03$export$95cacd63dfd98bee = ({ type: type, defaultMessage: defaultMessage = null, subtype: subtype })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const message = (0, $7nrkp.messages)[type];
    const isLiveDoc = subtype === (0, $3P0Fk.SearchConfluenceSubtype).LIVE && (0, $iDrrr.fg)('confluence_live_pages_open_beta_trait_opted_in');
    if (!message) return defaultMessage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, isLiveDoc ? formatMessage((0, $7nrkp.messages).liveDoc) : formatMessage(message));
};
const $1e114c24d4299a03$export$446974e6d8045139 = (type)=>{
    if (!type || !(0, $7nrkp.messages)[type]) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1e114c24d4299a03$export$95cacd63dfd98bee, {
        type: type
    });
};
module.exports["SearchResultType"] = $1e114c24d4299a03$export$95cacd63dfd98bee;
module.exports["getSearchResultType"] = $1e114c24d4299a03$export$446974e6d8045139;

});

parcelRegister("7nrkp", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $72c471fbf2b42026$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    liveDoc: {
        id: "live_doc_type",
        defaultMessage: "Live Doc"
    },
    page: {
        id: "search_result_type_page",
        defaultMessage: "Page"
    },
    blogpost: {
        id: "search_result_type_blogpost",
        defaultMessage: "Blog Post"
    },
    whiteboard: {
        id: "search_result_type_whiteboard",
        defaultMessage: "Whiteboard"
    },
    slide: {
        id: "search_result_type_slide",
        defaultMessage: "Slides"
    },
    database: {
        id: "search_result_type_database",
        defaultMessage: "Database"
    },
    space: {
        id: "search_result_type_space",
        defaultMessage: "Space"
    },
    attachment: {
        id: "search_result_type_attachment",
        defaultMessage: "Attachment"
    },
    comment: {
        id: "search_result_type_comment",
        defaultMessage: "Comment"
    },
    folder: {
        id: "search_result_type_folder",
        defaultMessage: "Folder"
    },
    calendar: {
        id: "search_result_type_calendar",
        defaultMessage: "Calendar"
    },
    space_calendar: {
        // snake_case returned by the API
        id: "search_result_type_space_calendar",
        defaultMessage: "Space calendar"
    },
    question: {
        id: "search_result_type_question",
        defaultMessage: "Question"
    },
    answer: {
        id: "search_result_type_answer",
        defaultMessage: "Answer"
    },
    embed: {
        id: "search_result_type_embed",
        defaultMessage: "Smart Link"
    },
    board: {
        id: "search_result_type_board",
        defaultMessage: "Board"
    },
    dashboard: {
        id: "search_result_type_dashboard",
        defaultMessage: "Dashboard"
    },
    filter: {
        id: "search_result_type_filter",
        defaultMessage: "Filter"
    },
    issue: {
        id: "search_result_type_issue",
        defaultMessage: "Work item"
    },
    plan: {
        id: "search_result_type_plan",
        defaultMessage: "Plan"
    },
    project: {
        id: "search_result_type_project",
        defaultMessage: "Project"
    },
    goal: {
        id: "search_result_type_goal",
        defaultMessage: "Goal"
    },
    tag: {
        id: "search_result_type_tag",
        defaultMessage: "Tag"
    },
    learning: {
        id: "search_result_type_learning",
        defaultMessage: "Learning"
    },
    unrecognised: {
        id: "search_result_type_unrecognised",
        defaultMessage: "Unrecognised"
    },
    document: {
        id: "search_result_type_document",
        defaultMessage: "Document"
    },
    spreadsheet: {
        id: "search_result_type_spreadsheet",
        defaultMessage: "Spreadsheet"
    },
    presentation: {
        id: "search_result_type_presentation",
        defaultMessage: "Presentation"
    },
    'sharepoint-document': {
        id: "search_result_type_sharepoint_document",
        defaultMessage: "Sharepoint Document"
    },
    message: {
        id: "search_result_type_message",
        defaultMessage: "Message"
    },
    repository: {
        id: "search_result_type_repository",
        defaultMessage: "Repository"
    },
    'pull-request': {
        id: "search_result_type_pull_request",
        defaultMessage: "Pull Request"
    },
    commit: {
        id: "search_result_type_commit",
        defaultMessage: "Commit"
    },
    branch: {
        id: "search_result_type_branch",
        defaultMessage: "Branch"
    },
    file: {
        id: "search_result_type_file",
        defaultMessage: "File"
    },
    channel: {
        id: "search_result_type_channel",
        defaultMessage: "Channel"
    },
    component: {
        id: "search_result_type_component",
        defaultMessage: "Component"
    },
    'work-item': {
        id: "search_result_type_work_item",
        defaultMessage: "Work Item"
    },
    card: {
        id: "search_result_type_card",
        defaultMessage: "Card"
    },
    incident: {
        id: "search_result_type_incident",
        defaultMessage: "Incident"
    },
    focus_area: {
        id: "search_result_type_focus_area",
        defaultMessage: "Focus area"
    },
    focus_area_status_update: {
        id: "search_result_type_focus_area_status_update",
        defaultMessage: "Focus area update"
    },
    organization: {
        id: "search_result_type_organization",
        defaultMessage: "Organization"
    },
    organization_status_update: {
        id: "search_result_type_organization_status_update",
        defaultMessage: "Organization update"
    },
    ask: {
        id: "search_result_type_ask",
        defaultMessage: "Ask"
    },
    risk: {
        id: "search_result_type_risk",
        defaultMessage: "Risk"
    },
    email: {
        id: "search_result_type_email",
        defaultMessage: "Email"
    },
    gliffy: {
        id: "search_result_type_gliffy",
        defaultMessage: "Gliffy Diagram"
    },
    deal: {
        id: "search_result_type_deal",
        defaultMessage: "Deal"
    },
    'customer-org': {
        id: "search_result_type_customer_org",
        defaultMessage: "Customer Organization"
    },
    'data-table': {
        id: "search_result_type_data_table",
        defaultMessage: "Data table"
    },
    'customer-contact': {
        id: "search_result_type_customer_contact",
        defaultMessage: "Customer contact"
    },
    object: {
        id: "search_result_type_object",
        defaultMessage: "Object"
    },
    schema: {
        id: "search_result_type_schema",
        defaultMessage: "Schema"
    },
    type: {
        id: "search_result_type_type",
        defaultMessage: "Object type"
    },
    position: {
        id: "search_result_type_position",
        defaultMessage: "Position"
    },
    video: {
        id: "search_result_type_video",
        defaultMessage: "Video"
    },
    task: {
        id: "search_result_type_task",
        defaultMessage: "Task"
    },
    epic: {
        id: "search_result_type_epic",
        defaultMessage: "Epic"
    },
    bug: {
        id: "search_result_type_bug",
        defaultMessage: "Bug"
    },
    story: {
        id: "search_result_type_story",
        defaultMessage: "Story"
    },
    'sub-task': {
        id: "search_result_type_sub_task",
        defaultMessage: "Sub-task"
    },
    subtask: {
        id: "search_result_type_subtask",
        defaultMessage: "Sub-task"
    },
    improvement: {
        id: "search_result_type_improvement",
        defaultMessage: "Improvement"
    },
    'new feature': {
        id: "search_result_type_new_feature",
        defaultMessage: "New feature"
    },
    change: {
        id: "search_result_type_change",
        defaultMessage: "Change"
    },
    problem: {
        id: "search_result_type_problem",
        defaultMessage: "Problem"
    },
    'service request': {
        id: "search_result_type_service_request",
        defaultMessage: "Service request"
    }
});
module.exports["messages"] = $72c471fbf2b42026$export$defe85febe8b728c;

});

parcelRegister("3Z7rz", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");

const $d66d59d73fe8c0b4$export$b697429ad83cc9eb = (thirdPartyConfigs, providerId)=>{
    if (!thirdPartyConfigs || !providerId) return undefined;
    // Find by providerId (dynamic API adds this field to configs, even for static Forge connectors)
    const [product] = Object.entries(thirdPartyConfigs).find(([, config])=>config?.providerId === providerId) || [];
    // Ensure the product is in our defined set or is a Forge connector so we can cast it safely
    if (product && !(0, $dvVWp.all3pProductKeys).includes(product) && !(0, $8fNUp.isForgeConnectorProductKey)(product)) return undefined;
    return product ? product : undefined;
};
module.exports["getProductFromProviderId"] = $d66d59d73fe8c0b4$export$b697429ad83cc9eb;

});

parcelRegister("7uIpT", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $0e5c4e232a3baf9a$var$pullRequestStatusToLozengeMap = {
    OPEN: 'information',
    // blue
    MERGED: 'success',
    // green
    DECLINED: 'danger',
    // red
    DRAFT: 'neutral' // grey
};
const $0e5c4e232a3baf9a$export$2e2105095afb1fad = (status)=>$0e5c4e232a3baf9a$var$pullRequestStatusToLozengeMap[status] ?? 'neutral';
const $0e5c4e232a3baf9a$export$43932e794c008e49 = (0, $kSwu1.defineMessages)({
    status_open: {
        id: "search-pull-request-result.status.open",
        defaultMessage: "Open"
    },
    status_merged: {
        id: "search-pull-request-result.status.merged",
        defaultMessage: "Merged"
    },
    status_declined: {
        id: "search-pull-request-result.status.declined",
        defaultMessage: "Declined"
    },
    status_draft: {
        id: "search-pull-request-result.status.draft",
        defaultMessage: "Draft"
    },
    status_unknown: {
        id: "search-pull-request-result.status.unknown",
        defaultMessage: "Unknown"
    }
});
const $0e5c4e232a3baf9a$export$d8a08f59b3eb7920 = {
    OPEN: $0e5c4e232a3baf9a$export$43932e794c008e49.status_open,
    MERGED: $0e5c4e232a3baf9a$export$43932e794c008e49.status_merged,
    DECLINED: $0e5c4e232a3baf9a$export$43932e794c008e49.status_declined,
    DRAFT: $0e5c4e232a3baf9a$export$43932e794c008e49.status_draft,
    UNKNOWN: $0e5c4e232a3baf9a$export$43932e794c008e49.status_unknown
};
const $0e5c4e232a3baf9a$export$348ea44fc966c8f3 = (status)=>(status && $0e5c4e232a3baf9a$export$d8a08f59b3eb7920[status]) ?? $0e5c4e232a3baf9a$export$43932e794c008e49.status_unknown;
module.exports["getPullRequestStatusAppearance"] = $0e5c4e232a3baf9a$export$2e2105095afb1fad;
module.exports["pullRequestStatusMessages"] = $0e5c4e232a3baf9a$export$43932e794c008e49;
module.exports["getPullRequestStatusMessage"] = $0e5c4e232a3baf9a$export$348ea44fc966c8f3;

});

parcelRegister("ir4XI", function(module, exports) {
// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $cozmU = parcelRequire("cozmU");


var $eDWBm = parcelRequire("eDWBm");

const $3e6c385b00a79f7b$export$2804e03de329c539 = ({ commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes, failSection: failSection })=>{
    return {
        eventType: 'track',
        source: failSection,
        actionSubject: 'searchPageErrorBoundary',
        action: 'failed',
        attributes: {
            commonAttributes: commonAttributes
        },
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    };
};



var $dsOco = parcelRequire("dsOco");


var $2csHQ = parcelRequire("2csHQ");


const $c19520959e68844c$export$e926676385687eaf = ({ children: children, fallback: fallback, renderWithErrorInfo: renderWithErrorInfo, section: section, onException: customOnException, setErrorBoundaryResetCb: setErrorBoundaryResetCb })=>{
    const logException = (0, $2csHQ.useLogException)();
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $dsOco.useCommonAndPrivateAttributes)();
    const onException = (0, $cozmU.useCallback)((error)=>{
        fireAnalyticsEvent((0, $3e6c385b00a79f7b$export$2804e03de329c539)({
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            failSection: section
        }));
        logException(error);
        // Call custom handler if provided
        customOnException?.(error);
    }, [
        logException,
        fireAnalyticsEvent,
        commonAttributes,
        nonPrivacySafeAttributes,
        section,
        customOnException
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $eDWBm.ErrorBoundary), {
        fallback: fallback,
        renderWithErrorInfo: renderWithErrorInfo,
        onException: onException,
        setErrorBoundaryResetCb: setErrorBoundaryResetCb
    }, children);
};
module.exports["ErrorBoundary"] = $c19520959e68844c$export$e926676385687eaf;

});

parcelRegister("2csHQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $32Eau = parcelRequire("32Eau");


var $eD8r5 = parcelRequire("eD8r5");

const $96947b87cac7f0db$export$67ff3bc9583d7c16 = ()=>{
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const [user] = (0, $32Eau.useUser)();
    // Store data required for logging exceptions in refs to prevent re-renders
    return (0, $cozmU.useCallback)(async (error)=>await (0, $eD8r5.logException)(error, user?.id, primaryProduct), [
        primaryProduct,
        user?.id
    ]);
};
module.exports["useLogException"] = $96947b87cac7f0db$export$67ff3bc9583d7c16;

});

parcelRegister("GHTO7", function(module, exports) {

var $d2hGj = parcelRequire("d2hGj");


var $f6RxU = parcelRequire("f6RxU");


var $lSbhE = parcelRequire("lSbhE");

const $72498c90ccdf0220$export$b0d5f79a828d791e = (durationInSeconds, options)=>{
    if (durationInSeconds === undefined || durationInSeconds === null) return null;
    const date = (0, $d2hGj.default)(new Date(0), durationInSeconds);
    const ONE_HOUR = 3600;
    const ONE_MINUTE = 60;
    const hours = Math.floor(durationInSeconds / ONE_HOUR);
    const minutes = Math.floor(durationInSeconds % ONE_HOUR / ONE_MINUTE);
    const seconds = durationInSeconds % ONE_MINUTE;
    if (options?.readable && options.formatMessage) {
        if (durationInSeconds < ONE_MINUTE) return options.formatMessage((0, $lSbhE.messages).durationInSeconds, {
            seconds: seconds
        });
        else if (durationInSeconds < 3600) return options.formatMessage((0, $lSbhE.messages).durationInMinutes, {
            minutes: minutes
        });
        else return options.formatMessage((0, $lSbhE.messages).durationInHours, {
            hours: hours,
            minutes: minutes
        });
    }
    if (options?.readable) {
        if (durationInSeconds < ONE_MINUTE) return `${seconds} sec`;
        else if (durationInSeconds < 3600) return `${minutes} min`;
        else return `${hours} hour ${minutes} min`;
    }
    if (durationInSeconds < ONE_HOUR) return (0, $f6RxU.default)(date, 'mm:ss');
    return (0, $f6RxU.default)(date, 'HH:mm:ss');
};
module.exports["convertVideoDuration"] = $72498c90ccdf0220$export$b0d5f79a828d791e;

});

parcelRegister("lSbhE", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $e3822027923e034d$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    videoThumbnailAltText: {
        id: "search-graph-video.video-thumbnail-alt-text",
        defaultMessage: "Video thumbnail"
    },
    videoIconLabel: {
        id: "search-graph-video.video-icon-label",
        defaultMessage: "video icon"
    },
    dropdownMessage: {
        id: "search-graph-video.dropdown-message",
        defaultMessage: "{chapterCount, plural, one {# chapter in this video} other {# chapters in this video}}"
    },
    videoType: {
        id: "search-graph-video.video-type",
        defaultMessage: "Video"
    },
    durationInSeconds: {
        id: "search-graph-video.duration.seconds",
        defaultMessage: "{seconds} sec"
    },
    durationInMinutes: {
        id: "search-graph-video.duration.minutes",
        defaultMessage: "{minutes} min"
    },
    durationInHours: {
        id: "search-graph-video.duration.hours",
        defaultMessage: "{hours} hour {minutes} min"
    },
    seeAll: {
        id: "search-graph-video.see-all",
        defaultMessage: "See all"
    },
    pastMeetings: {
        id: "search-graph-video.past-meetings",
        defaultMessage: "Past meetings"
    },
    pastMeetingsUpdated: {
        id: "search-graph-video.past-meetings-updated",
        defaultMessage: "Updated {relativeTime}"
    }
});
module.exports["messages"] = $e3822027923e034d$export$defe85febe8b728c;

});

parcelRegister("hMXVq", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9pcjO = parcelRequire("9pcjO");


var $32Eau = parcelRequire("32Eau");


var $1i979 = parcelRequire("1i979");


var $gDBUP = parcelRequire("gDBUP");

const $2856d9cebc408f96$export$e90e90fddddd8154 = ({ experience: experience = (0, $9pcjO.SearchExperience).SEARCH_PAGE })=>{
    const [search] = (0, $1i979.useSearch)();
    const [selectedDatasource] = (0, $1i979.useSelectedDatasource)();
    const [{ products: products, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs }] = (0, $32Eau.useBootstrap)();
    const currentUserId = (0, $32Eau.useCurrentUserId)();
    const { filters: filters, selectedProducts: selectedProducts, jsmIncidentFilterIds: jsmIncidentFilterIds } = search;
    return (0, $cozmU.useMemo)(()=>{
        return (0, $gDBUP.getSelectedFilters)({
            filters: filters,
            selectedProducts: selectedProducts,
            selectedDatasource: selectedDatasource,
            availableProducts: products,
            allFilterExcludedProducts: allFilterExcludedProducts,
            thirdPartyConfigs: thirdPartyConfigs,
            jsmIncidentFilterIds: jsmIncidentFilterIds,
            experience: experience,
            currentUserId: currentUserId
        });
    }, [
        filters,
        selectedProducts,
        selectedDatasource,
        products,
        allFilterExcludedProducts,
        thirdPartyConfigs,
        jsmIncidentFilterIds,
        experience,
        currentUserId
    ]);
};
module.exports["useSelectedFilters"] = $2856d9cebc408f96$export$e90e90fddddd8154;

});

parcelRegister("gDBUP", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $as9lu = parcelRequire("as9lu");


var $dvVWp = parcelRequire("dvVWp");


var $9pcjO = parcelRequire("9pcjO");


var $hea5O = parcelRequire("hea5O");

const $e448f1dace6eee30$export$68a801b7b3c0bfaa = ({ selectedProducts: selectedProducts, availableProducts: availableProducts })=>{
    const selectedProduct = selectedProducts?.[0];
    const filteredProducts = selectedProduct ? [
        selectedProduct
    ] : availableProducts;
    return {
        selectedProduct: selectedProduct,
        filteredProducts: filteredProducts,
        availableProducts: availableProducts
    };
};



var $c3cgJ = parcelRequire("c3cgJ");


var $gkHoc = parcelRequire("gkHoc");

var $f6RxU = parcelRequire("f6RxU");

var $1xxT0 = parcelRequire("1xxT0");

/**
 * Calendar date in the user's local timezone as YYYY-MM-DD (matches backend
 * {@code ContentSearcherQueryHelper#buildSalesforceCloseDateQuery} contract).
 */ function $a46b99d3f7761005$var$toYmdLocal(d) {
    return (0, $f6RxU.default)(d, 'yyyy-MM-dd');
}
function $a46b99d3f7761005$var$startOfTodayLocal() {
    const n = new Date();
    return new Date(n.getFullYear(), n.getMonth(), n.getDate());
}
const $a46b99d3f7761005$var$ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
function $a46b99d3f7761005$export$63976aebd4b36830(selectedOption, customIsoDate) {
    if (!selectedOption || selectedOption === 'anytime') return undefined;
    if (selectedOption === 'custom') {
        if (!customIsoDate || !$a46b99d3f7761005$var$ISO_DATE.test(customIsoDate)) return undefined;
        return customIsoDate;
    }
    const today = $a46b99d3f7761005$var$startOfTodayLocal();
    const tomorrow = (0, $gkHoc.default)(today, 1);
    switch(selectedOption){
        case 'today':
            return $a46b99d3f7761005$var$toYmdLocal(today);
        case 'last7days':
            return `${$a46b99d3f7761005$var$toYmdLocal((0, $1xxT0.default)(today, 6))}:${$a46b99d3f7761005$var$toYmdLocal(today)}`;
        case 'last30days':
            return `${$a46b99d3f7761005$var$toYmdLocal((0, $1xxT0.default)(today, 29))}:${$a46b99d3f7761005$var$toYmdLocal(today)}`;
        case 'last90days':
            return `${$a46b99d3f7761005$var$toYmdLocal((0, $1xxT0.default)(today, 89))}:${$a46b99d3f7761005$var$toYmdLocal(today)}`;
        case 'last365days':
            return `${$a46b99d3f7761005$var$toYmdLocal((0, $1xxT0.default)(today, 364))}:${$a46b99d3f7761005$var$toYmdLocal(today)}`;
        case 'next7days':
            return `${$a46b99d3f7761005$var$toYmdLocal(tomorrow)}:${$a46b99d3f7761005$var$toYmdLocal((0, $gkHoc.default)(today, 7))}`;
        case 'next30days':
            return `${$a46b99d3f7761005$var$toYmdLocal(tomorrow)}:${$a46b99d3f7761005$var$toYmdLocal((0, $gkHoc.default)(today, 30))}`;
        case 'next90days':
            return `${$a46b99d3f7761005$var$toYmdLocal(tomorrow)}:${$a46b99d3f7761005$var$toYmdLocal((0, $gkHoc.default)(today, 90))}`;
        case 'next365days':
            return `${$a46b99d3f7761005$var$toYmdLocal(tomorrow)}:${$a46b99d3f7761005$var$toYmdLocal((0, $gkHoc.default)(today, 365))}`;
        default:
            // Already-resolved ISO single date or range (e.g. restored from URL)
            if ($a46b99d3f7761005$var$ISO_DATE.test(selectedOption)) return selectedOption;
            if (/^\d{4}-\d{2}-\d{2}:\d{4}-\d{2}-\d{2}$/.test(selectedOption)) return selectedOption;
            return undefined;
    }
}



var $8JYuM = parcelRequire("8JYuM");


var $4ysB6 = parcelRequire("4ysB6");


var $h6X6L = parcelRequire("h6X6L");

const $e1bf37817d38fdbf$export$a50dff3bb8b597ca = ({ availableProducts: availableProducts, filters: filters, selectedProducts: selectedProducts, allFilterExcludedProducts: allFilterExcludedProducts }, { thirdPartyConfigs: thirdPartyConfigs })=>{
    // Filter out excluded products from "All" filter
    const allFilterIncludedProducts = availableProducts.filter((product)=>!allFilterExcludedProducts.includes(product));
    const productsToSearch = selectedProducts[0] ? [
        selectedProducts[0]
    ] : allFilterIncludedProducts;
    const typeFilter = filters[0, $4ysB6.universalTypeFilterId];
    return (0, $h6X6L.getUniversalTypeEntities)(productsToSearch, typeFilter, thirdPartyConfigs, availableProducts, selectedProducts);
};



var $hggbF = parcelRequire("hggbF");

const $028e561f94414f18$export$f6546bb98204a0ca = ({ filters: filters, selectedProducts: selectedProducts, selectedDatasource: selectedDatasource, availableProducts: products, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs, currentUserId: currentUserId, jsmIncidentFilterIds: jsmIncidentFilterIds, experience: experience = (0, $9pcjO.SearchExperience).SEARCH_PAGE })=>{
    const { selectedProduct: selectedProduct, filteredProducts: filteredProducts, availableProducts: availableProducts } = (0, $e448f1dace6eee30$export$68a801b7b3c0bfaa)({
        selectedProducts: selectedProducts,
        availableProducts: products
    });
    const { selectedEntities: selectedEntities, entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery, selectedTypes: selectedTypes } = (0, $e1bf37817d38fdbf$export$a50dff3bb8b597ca)({
        availableProducts: availableProducts,
        filters: filters,
        selectedProducts: selectedProducts,
        allFilterExcludedProducts: allFilterExcludedProducts
    }, {
        thirdPartyConfigs: thirdPartyConfigs
    });
    const watchedByMeValue = (0, $hggbF.getBooleanFilterValue)(filters[0, $8JYuM.watchedFilterId]);
    const titleMatchValue = (0, $hggbF.getBooleanFilterValue)(filters[0, $8JYuM.titleMatchFilterId]);
    const selectedDateRange = (0, $hggbF.getSelectedDateRange)(filters[0, $8JYuM.lastUpdatedFilterId]);
    const filterDateRange = (0, $hggbF.getFilterDateRange)(filters[0, $8JYuM.lastUpdatedFilterId]);
    const commonContributors = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.contributorFilterId]).length ? (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.contributorFilterId]) : undefined;
    const pageStatusValue = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.pageStatusFilterId])[0];
    const assigneeARIValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.assigneeFilterId]).map((assigneeId)=>{
        return `ari:cloud:identity::user/${assigneeId}`;
    });
    const reporterARIValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.reporterFilterId]).map((reporterId)=>{
        return `ari:cloud:identity::user/${reporterId}`;
    });
    const watcherARIValues = (watchedByMeValue && currentUserId ? [
        currentUserId
    ] : []).map((watcherId)=>{
        return `ari:cloud:identity::user/${watcherId}`;
    });
    const commenterARIValues = (0, $hggbF.getBooleanFilterValue)(filters[0, $8JYuM.commentedByMeFilterId]) && currentUserId ? [
        `ari:cloud:identity::user/${currentUserId}`
    ] : [];
    const assignee3PValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.assigneeFilterId]).map((assigneeId)=>{
        if (assigneeId.startsWith('ari:cloud:')) return (0, $as9lu.IdentityUserAri).parse(assigneeId).resourceId;
        return assigneeId;
    });
    const isSelectedThirdPartyProduct = !!selectedProduct && (0, $dvVWp.is3pProductKey)(selectedProduct);
    const selectedSpaceValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.spaceFilterId]);
    const selectedContentValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.contentFilterId]);
    const confluenceOnlyValues = (values)=>isSelectedThirdPartyProduct ? [] : values;
    const thirdPartySpaceValues = selectedProduct === (0, $dvVWp.ProductKeys).GoogleDrive || selectedProduct === (0, $dvVWp.ProductKeys).Sharepoint ? selectedSpaceValues : [];
    const thirdPartyContentValues = isSelectedThirdPartyProduct ? selectedContentValues : [];
    const containerAris = [
        ...(0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.projectFilterId])
    ];
    const createdByValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.createdByFilterId]);
    const labelsValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.labelFilterId]);
    const lastUpdatedByValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.lastUpdatedByFilterId]);
    // When both the primary (space) and dependent (contentUnder) filters are selected, the backend
    // treats ancestorAris with OR logic, which would incorrectly broaden results.
    // Prefer the dependent filter when present since it is more specific; otherwise fall back to
    // the primary filter. The store handles the reverse: when the primary filter is selected after
    // the dependent, it clears the dependent so only the primary is sent.
    const ancestorAris = thirdPartyContentValues.length > 0 ? thirdPartyContentValues : thirdPartySpaceValues;
    const ownerValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.ownerFilterId]);
    const opportunityStatusValue = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.opportunityStatusFilterId])[0];
    const pullRequestStatusValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.pullRequestStatusFilterId]);
    const repositoryValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.repositoryFilterId]);
    const reviewerValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.reviewerFilterId]);
    const campaignStatusValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.campaignStatusFilterId]);
    const caseStatusValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.caseStatusFilterId]);
    const documentStatusValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.documentStatusFilterId]);
    const calendarTypeValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.calendarTypeFilterId]);
    const leadStatusValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.leadStatusFilterId]);
    const taskStatusValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.taskStatusFilterId]);
    const taskTypeValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.taskTypeFilterId]);
    const salesforceStageValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.salesforceStageFilterId]);
    const slackChannelValues = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.slackChannelFilterId]);
    const workspaceNameValues = (0, $iDrrr.fg)('rovo_fps_show_workspace_name_filter') ? (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.workspaceNameFilterId]) : [];
    const hasAttachmentValue = (0, $hggbF.getBooleanFilterValue)(filters[0, $8JYuM.hasAttachmentFilterId]);
    const sortFilters = (0, $hggbF.getSortFilters)(filters[0, $8JYuM.sortFilterId]);
    // Get close date value for Salesforce filter
    const closeDateFilterState = filters[0, $8JYuM.closeDateFilterId];
    const closeDateSelectedOption = (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.closeDateFilterId])[0];
    const closeDateCustomValue = closeDateFilterState && 'customValue' in closeDateFilterState && closeDateFilterState.customValue ? closeDateFilterState.customValue.closeDateVal : undefined;
    const salesforceCloseDate = (0, $a46b99d3f7761005$export$63976aebd4b36830)(closeDateSelectedOption, closeDateSelectedOption === 'custom' ? closeDateCustomValue : undefined);
    const isAllProductsSelected = (0, $c3cgJ.isAllProductSearch)(selectedProducts);
    const selectedFilters = {
        commonFilters: {
            range: {
                lastModified: selectedDateRange
            },
            contributorsFilter: commonContributors
        },
        jiraFilters: {
            issueFilter: {
                projectARIs: (0, $hggbF.omitNonJiraFilterValues)((0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.projectFilterId]), selectedProduct),
                watcherARIs: (0, $hggbF.omitNonJiraFilterValues)(watcherARIValues, selectedProduct),
                assigneeARIs: (0, $hggbF.omitNonJiraFilterValues)(assigneeARIValues, selectedProduct),
                issueTypeIDs: jsmIncidentFilterIds,
                issueLabels: (0, $hggbF.omitNonJiraFilterValues)((0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.labelFilterId]), selectedProduct),
                statusCategories: (0, $hggbF.omitNonJiraFilterValues)((0, $hggbF.getJiraIssueStatusFilterOptions)(filters[0, $8JYuM.statusFilterId]), selectedProduct),
                reporterARIs: (0, $hggbF.omitNonJiraFilterValues)(reporterARIValues, selectedProduct),
                commenterARIs: (0, $hggbF.omitNonJiraFilterValues)(commenterARIValues, selectedProduct),
                issueTypes: (0, $hggbF.getSelectedJiraWorkType)(selectedTypes, selectedProduct)
            },
            projectFilter: {
                projectTypes: experience === (0, $9pcjO.SearchExperience).QUICK_FIND ? [] : (0, $hggbF.getJiraProjectFilter)(selectedProduct)
            }
        },
        assetsFilters: {
            objectSchemaFilter: {
                schemaARIs: (0, $iDrrr.fg)('assets_rovo_search_all') ? (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.assetsSchemaFilterId]) : []
            },
            objectTypeFilter: {
                typeARIs: (0, $iDrrr.fg)('assets_rovo_search_all') ? (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.assetsTypeFilterId]) : []
            }
        },
        confluenceFilters: {
            spacesFilter: confluenceOnlyValues(selectedSpaceValues),
            isVerified: (0, $hggbF.getBooleanFilterValue)(filters[0, $8JYuM.verifiedFilterId]) || undefined,
            contributorsFilter: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.contributorFilterId]),
            ancestorIdsFilter: confluenceOnlyValues(selectedContentValues),
            range: selectedProduct !== (0, $dvVWp.ProductKeys).Confluence ? filterDateRange : [],
            owners: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.ownerFilterId]),
            labelsFilter: selectedProduct === (0, $dvVWp.ProductKeys).Confluence ? (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.labelFilterId]) : [],
            titleMatchOnly: titleMatchValue,
            ...pageStatusValue ? {
                pageStatus: [
                    pageStatusValue
                ]
            } : {},
            contentStatuses: selectedProduct === (0, $dvVWp.ProductKeys).Confluence ? (0, $hggbF.getContentStatusValue)(filters[0, $8JYuM.archivedFilterId]) : [],
            containerStatus: selectedProduct === (0, $dvVWp.ProductKeys).Confluence ? (0, $hggbF.getContainerStatusValue)(filters[0, $8JYuM.archivedFilterId]) : []
        },
        mercuryFilters: {
            owners: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.ownerFilterId]),
            focusAreaTypeIds: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.focusAreaTypeFilterId]),
            ancestorIds: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.focusAreaUnderFilterId])
        },
        ...(0, $iDrrr.fg)('talent_global_search') ? {
            talentFilters: {
                owners: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.ownerFilterId]),
                employmentTypes: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.positionEmploymentTypeFilterId]).map((value)=>decodeURIComponent(value)),
                focusAreas: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.positionFocusAreaFilterId]),
                jobFamilies: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.positionJobFamilyFilterId]).map((value)=>decodeURIComponent(value)),
                statuses: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.positionStatusFilterId]).map((value)=>decodeURIComponent(value)),
                teams: (0, $hggbF.getSelectFilterValue)(filters[0, $8JYuM.positionTeamFilterId])
            }
        } : {},
        compassFilters: {
            componentFilter: {
                componentStates: (0, $hggbF.getArchivedAndPendingComponentsValue)(filters[0, $8JYuM.archivedAndPendingComponentsFilterId])
            }
        },
        thirdPartyFilters: (0, $hea5O.getThirdPartyFilters)(filteredProducts, titleMatchValue, selectedEntities, thirdPartyConfigs, isAllProductsSelected, filterDateRange, assignee3PValues, containerAris, createdByValues, lastUpdatedByValues, ancestorAris, labelsValues, undefined, selectedDatasource?.datasourceId, ownerValues, salesforceStageValues, salesforceCloseDate, opportunityStatusValue, pullRequestStatusValues, repositoryValues, campaignStatusValues, caseStatusValues, slackChannelValues, hasAttachmentValue, workspaceNameValues, reviewerValues, documentStatusValues, calendarTypeValues, leadStatusValues, taskStatusValues, taskTypeValues),
        sortFilters: sortFilters
    };
    const unselectedProductsThirdPartyFilters = (0, $hea5O.getThirdPartyFilters)(availableProducts, titleMatchValue, selectedEntities, thirdPartyConfigs, isAllProductsSelected, filterDateRange, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    const { commonFilters: commonFilters, jiraFilters: jiraFilters, confluenceFilters: confluenceFilters, mercuryFilters: mercuryFilters, compassFilters: compassFilters, thirdPartyFilters: thirdPartyFilters, assetsFilters: assetsFilters, talentFilters: talentFilters } = selectedFilters;
    const isEmpty = !commonFilters.range.lastModified && !commonFilters.contributorsFilter && selectedEntities.length === 0 && confluenceFilters.spacesFilter.length === 0 && !confluenceFilters.isVerified && !confluenceFilters.titleMatchOnly && confluenceFilters.contentStatuses.length === 0 && confluenceFilters.containerStatus.length === 0 && confluenceFilters.contributorsFilter.length === 0 && confluenceFilters.ancestorIdsFilter.length === 0 && confluenceFilters.range.length === 0 && confluenceFilters.owners.length === 0 && confluenceFilters.labelsFilter.length === 0 && (!confluenceFilters.pageStatus || confluenceFilters.pageStatus.length === 0) && jiraFilters.issueFilter.assigneeARIs.length === 0 && jiraFilters.issueFilter.projectARIs.length === 0 && jiraFilters.issueFilter.statusCategories.length === 0 && jiraFilters.issueFilter.reporterARIs.length === 0 && jiraFilters.issueFilter.commenterARIs.length === 0 && mercuryFilters.owners.length === 0 && jiraFilters.issueFilter.issueLabels.length === 0 && (!jiraFilters.issueFilter.issueTypes || jiraFilters.issueFilter.issueTypes?.length === 0) && mercuryFilters.owners.length === 0 && mercuryFilters.focusAreaTypeIds.length === 0 && mercuryFilters.ancestorIds.length === 0 && compassFilters.componentFilter.componentStates.length === 0 && ((0, $iDrrr.fg)('talent_global_search') ? talentFilters?.owners.length === 0 && talentFilters?.employmentTypes.length === 0 && talentFilters?.focusAreas.length === 0 && talentFilters?.jobFamilies.length === 0 && talentFilters?.statuses.length === 0 && talentFilters?.teams.length === 0 : true) && ((0, $iDrrr.fg)('assets_rovo_search_all') ? assetsFilters.objectSchemaFilter.schemaARIs.length === 0 && assetsFilters.objectTypeFilter.typeARIs.length === 0 : true) && (!thirdPartyFilters.range || Object.keys(thirdPartyFilters.range).length === 0) && !thirdPartyFilters.titleMatchOnly && thirdPartyFilters.subtypes.length === 0 && (!thirdPartyFilters.assignees || thirdPartyFilters.assignees?.length === 0) && (!thirdPartyFilters.lastUpdatedBy || thirdPartyFilters.lastUpdatedBy?.length === 0) && (!thirdPartyFilters.createdBy || thirdPartyFilters.createdBy?.length === 0) && (!thirdPartyFilters.ancestorAris || thirdPartyFilters.ancestorAris?.length === 0) && (!thirdPartyFilters.containerAris || thirdPartyFilters.containerAris?.length === 0) && (!thirdPartyFilters.salesforceFilters?.stage || thirdPartyFilters.salesforceFilters.stage.length === 0) && (!thirdPartyFilters.salesforceFilters?.owners || thirdPartyFilters.salesforceFilters.owners.length === 0) && !thirdPartyFilters.salesforceFilters?.closeDate && (!thirdPartyFilters.salesforceFilters?.campaignStatuses || thirdPartyFilters.salesforceFilters.campaignStatuses.length === 0) && (!thirdPartyFilters.salesforceFilters?.caseStatuses || thirdPartyFilters.salesforceFilters.caseStatuses.length === 0) && (!thirdPartyFilters.salesforceFilters?.knowledgeArticlePublishStatuses || thirdPartyFilters.salesforceFilters.knowledgeArticlePublishStatuses.length === 0) && (!thirdPartyFilters.gitFilters?.pullRequestStatus || thirdPartyFilters.gitFilters.pullRequestStatus.length === 0) && (!thirdPartyFilters.gitFilters?.repoName || thirdPartyFilters.gitFilters.repoName.length === 0) && !thirdPartyFilters.teamsFilters?.hasAttachment && !thirdPartyFilters.thirdPartyProducts?.some((p)=>p.product === 'slack' && p.channels && p.channels.length > 0);
    return {
        selectedFilters: selectedFilters,
        unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters,
        selectedEntities: selectedEntities,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery,
        entities: entitiesForQuery,
        hasFiltersSelected: !isEmpty
    };
};
module.exports["getSelectedFilters"] = $028e561f94414f18$export$f6546bb98204a0ca;

});

parcelRegister("hggbF", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $l9zYm = parcelRequire("l9zYm");


var $c9Etd = parcelRequire("c9Etd");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $gNJMT = parcelRequire("gNJMT");


var $i5kPq = parcelRequire("i5kPq");


var $dzatQ = parcelRequire("dzatQ");


var $jbIQp = parcelRequire("jbIQp");


var $kSwu1 = parcelRequire("kSwu1");

const $9ea5e96d5d9820f0$export$c054401256af44b9 = '[System] Incident';
const $9ea5e96d5d9820f0$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    incident: {
        id: "search-client.jira.issue.incident.label",
        defaultMessage: "[System] Incident"
    }
});


const $635420a0a67bc45f$export$1c47b2cd6d3f5b5a = {
    ['showCurrent']: [],
    ['showArchived']: [
        'ARCHIVED',
        'CURRENT'
    ]
};
const $635420a0a67bc45f$export$7069271803c33dc3 = {
    ['showCurrent']: [],
    ['showArchived']: [
        'ARCHIVED',
        'CURRENT',
        'DRAFT'
    ]
};
const $635420a0a67bc45f$export$a240a4826113d43 = (filter)=>{
    const archivedContentOption = $635420a0a67bc45f$export$49b41db8fadc5da(filter);
    return archivedContentOption ? $635420a0a67bc45f$export$7069271803c33dc3['showArchived'] : $635420a0a67bc45f$export$7069271803c33dc3['showCurrent'];
};
const $635420a0a67bc45f$export$b934b4f495e2c091 = (filter)=>{
    const archivedContentOption = $635420a0a67bc45f$export$49b41db8fadc5da(filter);
    return archivedContentOption ? $635420a0a67bc45f$export$1c47b2cd6d3f5b5a['showArchived'] : $635420a0a67bc45f$export$1c47b2cd6d3f5b5a['showCurrent'];
};
const $635420a0a67bc45f$export$fa0dcd7cda441845 = (filter)=>{
    const archivedContentOption = $635420a0a67bc45f$export$49b41db8fadc5da(filter);
    return archivedContentOption ? [
        'ACTIVE',
        'PENDING',
        'ARCHIVED'
    ] : [];
};
const $635420a0a67bc45f$export$ba6044efb2e123e9 = {
    [(0, $dvVWp.ProductKeys).Jira]: [
        'software',
        'business'
    ],
    [(0, $dvVWp.ProductKeys).JiraProductDiscovery]: [
        'product_discovery'
    ],
    [(0, $dvVWp.ProductKeys).JiraServiceManagement]: [
        'service_desk'
    ]
};
const $635420a0a67bc45f$export$e1f376159111dbe6 = (filterValues, selectedProduct)=>{
    // when all products are searched
    if (!selectedProduct) // don't return any values in all product selected mode for assignee and project filters
    return [];
    switch(selectedProduct){
        case (0, $dvVWp.ProductKeys).Jira:
        case (0, $dvVWp.ProductKeys).JiraProductDiscovery:
        case (0, $dvVWp.ProductKeys).JiraServiceManagement:
            return filterValues;
    }
    return [];
};
const $635420a0a67bc45f$export$5c4691ac7ffb1183 = 'DUMMY_JIRA_ISSUE_TYPE_ID';
const $635420a0a67bc45f$export$4df832a1d124a3d4 = async (cloudId, intl, issueType, activationId, primaryProduct)=>{
    if (!cloudId) return $635420a0a67bc45f$export$5c4691ac7ffb1183;
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: activationId,
        product: primaryProduct
    });
    const searchString = intl.formatMessage((0, $9ea5e96d5d9820f0$export$defe85febe8b728c)[issueType]);
    const issueTypes = await (0, $l9zYm.jiraIssueTypeJQLQuery)(cloudId, searchString, headers);
    const ids = issueTypes?.data?.jira.jqlBuilder.fieldValues.edges;
    if (!ids || ids.length === 0) return $635420a0a67bc45f$export$5c4691ac7ffb1183;
    if (ids.length > 1) {
        const issueTypeNode = ids.find((id)=>id.node?.displayName === searchString);
        if (!issueTypeNode) return $635420a0a67bc45f$export$5c4691ac7ffb1183;
        const issueType = issueTypeNode.node?.issueTypes[0];
        return issueType && issueType.issueTypeId ? issueType.issueTypeId : $635420a0a67bc45f$export$5c4691ac7ffb1183;
    } else {
        const node = ids[0].node;
        if (!node) return $635420a0a67bc45f$export$5c4691ac7ffb1183;
        return node.issueTypes[0].issueTypeId || $635420a0a67bc45f$export$5c4691ac7ffb1183;
    }
};
const $635420a0a67bc45f$export$75ec3b8bb22cb14f = (filter)=>{
    return (0, $jbIQp.isSelectFilter)(filter?.type) ? filter.value : [];
};
const $635420a0a67bc45f$export$1800e9d06ef0f63b = (filter)=>{
    return (0, $jbIQp.isSelectFilter)(filter?.type) ? filter.customValue : {};
};
const $635420a0a67bc45f$export$49b41db8fadc5da = (filter)=>{
    return filter?.type === 'boolean' ? filter.value : false;
};
const $635420a0a67bc45f$export$7efdc6b7aa39e72a = (filter)=>{
    const selectedDateOption = $635420a0a67bc45f$export$75ec3b8bb22cb14f(filter)[0];
    if (selectedDateOption && selectedDateOption !== (0, $c9Etd.CUSTOM_OPTION_VALUE)) return (0, $dzatQ.convertLastUpdatedToDateRange)(selectedDateOption);
    else if (selectedDateOption === (0, $c9Etd.CUSTOM_OPTION_VALUE)) {
        const customDateRange = $635420a0a67bc45f$export$1800e9d06ef0f63b(filter);
        if (customDateRange?.from || customDateRange?.to) return (0, $gNJMT.convertCustomDateToRange)(customDateRange.from, customDateRange.to);
    }
    return;
};
const $635420a0a67bc45f$export$9ec55eff3923c72 = (filter)=>{
    const selectedDateOption = $635420a0a67bc45f$export$75ec3b8bb22cb14f(filter)[0];
    if (selectedDateOption && selectedDateOption !== (0, $c9Etd.CUSTOM_OPTION_VALUE)) return [
        (0, $dzatQ.getConfluenceDateOptionValues)(selectedDateOption)
    ];
    else if (selectedDateOption === (0, $c9Etd.CUSTOM_OPTION_VALUE)) {
        const customDateRange = $635420a0a67bc45f$export$1800e9d06ef0f63b(filter);
        if (customDateRange?.from && customDateRange?.to) return [
            (0, $dzatQ.getConfluenceDateOptionFromCustomDates)(customDateRange.from, customDateRange.to)
        ];
    }
    return [];
};
const $635420a0a67bc45f$export$ac0baabacf9504ae = (selectedProduct)=>{
    if (!selectedProduct) return []; // In the BE, it will target all Jira products if the array is empty
    switch(selectedProduct){
        case (0, $dvVWp.ProductKeys).Jira:
        case (0, $dvVWp.ProductKeys).JiraProductDiscovery:
        case (0, $dvVWp.ProductKeys).JiraServiceManagement:
            return $635420a0a67bc45f$export$ba6044efb2e123e9[selectedProduct];
    }
    return [];
};
const $635420a0a67bc45f$export$b8e499230f5115d8 = {
    [(0, $7ydfN.TypeFilterValueKey).Epic]: 'Epic',
    [(0, $7ydfN.TypeFilterValueKey).Bug]: 'Bug',
    [(0, $7ydfN.TypeFilterValueKey).Story]: 'Story',
    [(0, $7ydfN.TypeFilterValueKey).Task]: 'Task',
    [(0, $7ydfN.TypeFilterValueKey).Subtask]: 'Subtask'
};
const $635420a0a67bc45f$export$f548e13b50401f80 = (selectedType, selectedProduct)=>{
    const hasSelectedProductThatIsNotJira = Boolean(selectedProduct) && selectedProduct !== (0, $dvVWp.ProductKeys).Jira;
    if (hasSelectedProductThatIsNotJira || selectedType.length === 0) return [];
    return selectedType.flatMap((typeOption)=>{
        const workType = $635420a0a67bc45f$export$b8e499230f5115d8[typeOption];
        return workType ? [
            workType
        ] : [];
    });
};
const $635420a0a67bc45f$export$7dcf1656cd04caad = [
    'OPEN',
    'NEW',
    'INDETERMINATE',
    'DONE',
    'UNDEFINED'
];
const $635420a0a67bc45f$export$5f47ad4f5e0267c4 = (filter)=>{
    const filterValues = $635420a0a67bc45f$export$75ec3b8bb22cb14f(filter);
    const appliedFilterOptions = filterValues.flatMap((filtervalue)=>{
        const filterOptions = $635420a0a67bc45f$export$7dcf1656cd04caad.filter((status)=>status !== 'OPEN').find((allowedValue)=>filtervalue === allowedValue);
        return filterOptions ? [
            filterOptions
        ] : [];
    });
    return appliedFilterOptions;
};
const $635420a0a67bc45f$export$97dd8d7ab50aafbd = (filter)=>{
    const selectedSortOption = $635420a0a67bc45f$export$75ec3b8bb22cb14f(filter)[0];
    return (0, $i5kPq.convertSortToFilter)(selectedSortOption);
};
module.exports["getContentStatusValue"] = $635420a0a67bc45f$export$a240a4826113d43;
module.exports["getBooleanFilterValue"] = $635420a0a67bc45f$export$49b41db8fadc5da;
module.exports["getContainerStatusValue"] = $635420a0a67bc45f$export$b934b4f495e2c091;
module.exports["getArchivedAndPendingComponentsValue"] = $635420a0a67bc45f$export$fa0dcd7cda441845;
module.exports["JiraProductProjectFilterKey"] = $635420a0a67bc45f$export$ba6044efb2e123e9;
module.exports["omitNonJiraFilterValues"] = $635420a0a67bc45f$export$e1f376159111dbe6;
module.exports["getJiraIssueTypesFilter"] = $635420a0a67bc45f$export$4df832a1d124a3d4;
module.exports["getSelectFilterValue"] = $635420a0a67bc45f$export$75ec3b8bb22cb14f;
module.exports["getSelectedDateRange"] = $635420a0a67bc45f$export$7efdc6b7aa39e72a;
module.exports["getFilterDateRange"] = $635420a0a67bc45f$export$9ec55eff3923c72;
module.exports["getJiraProjectFilter"] = $635420a0a67bc45f$export$ac0baabacf9504ae;
module.exports["getSelectedJiraWorkType"] = $635420a0a67bc45f$export$f548e13b50401f80;
module.exports["allowedJiraIssueStatuses"] = $635420a0a67bc45f$export$7dcf1656cd04caad;
module.exports["getJiraIssueStatusFilterOptions"] = $635420a0a67bc45f$export$5f47ad4f5e0267c4;
module.exports["getSortFilters"] = $635420a0a67bc45f$export$97dd8d7ab50aafbd;

});

parcelRegister("l9zYm", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $e0b09446cd765a75$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME = 'SearchPageJiraIssueTypeQuery';
const $e0b09446cd765a75$var$jqlIssueTypeQueryString = `query ${$e0b09446cd765a75$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME}(
	$cloudId: ID!,
	$first: Int = 10,
	$jqlTerm: String!,
	$jql: String!,
	$searchString: String!) {
		jira {
			jqlBuilder(cloudId: $cloudId) {
				fieldValues (
					first: $first
					jqlTerm: $jqlTerm
					jqlContext: $jql
					searchString: $searchString
				) {
					edges {
						node {
							displayName
							... on JiraJqlIssueTypeFieldValue {
								issueTypes {
									issueTypeId
								}
							}
						}
					}
          		}
			}
		}
	}`;
const $e0b09446cd765a75$export$bd7a9ccdb07f26a6 = (0, $bHHWv.inMemoryCache)();
const $e0b09446cd765a75$export$299504e13b0b41d4 = async (cloudId, searchString, headers)=>{
    return $e0b09446cd765a75$export$bd7a9ccdb07f26a6.inMemoryDecorator(`${cloudId}-${searchString}`, async ()=>{
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $e0b09446cd765a75$var$jqlIssueTypeQueryString,
            variables: {
                cloudId: cloudId,
                jqlTerm: 'type',
                searchString: searchString,
                jql: ''
            },
            operationName: $e0b09446cd765a75$var$GQL_JIRA_ISSUE_TYPE_OPERATION_NAME,
            headers: {
                'X-ExperimentalApi': 'JiraJqlBuilder',
                ...headers
            }
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["jiraIssueTypeJQLQuery"] = $e0b09446cd765a75$export$299504e13b0b41d4;

});

parcelRegister("c9Etd", function(module, exports) {
const $701404cfc7d9161d$export$5ef321009a5b450c = 'custom';
const $701404cfc7d9161d$export$62fed45313a13eff = 'universalTypeFilter';
module.exports["CUSTOM_OPTION_VALUE"] = $701404cfc7d9161d$export$5ef321009a5b450c;
module.exports["universalTypeFilterId"] = $701404cfc7d9161d$export$62fed45313a13eff;

});

parcelRegister("68JhS", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $9DHhW = parcelRequire("9DHhW");


var $6yu7A = parcelRequire("6yu7A");


var $e0v3Z = parcelRequire("e0v3Z");


var $hnDqW = parcelRequire("hnDqW");


var $32Eau = parcelRequire("32Eau");


var $5lH3O = parcelRequire("5lH3O");


var $1i979 = parcelRequire("1i979");

const $bdccd1375bb70356$export$82052fbad762998f = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const fireAnalyticsEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            source: 'searchDialog'
        }).fire((0, $6yu7A.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    const fireAnalyticsScreenEvent = (0, $cozmU.useCallback)((payload)=>{
        createAnalyticsEvent({
            ...payload,
            eventType: 'screen',
            source: 'searchDialog'
        }).fire((0, $6yu7A.DEFAULT_GAS_CHANNEL));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireAnalyticsEvent: fireAnalyticsEvent,
        fireAnalyticsScreenEvent: fireAnalyticsScreenEvent
    };
};
const $bdccd1375bb70356$export$380f10e960af9b57 = ()=>{
    const [searchSessionId] = (0, $32Eau.useSearchSessionId)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const fetchEntitiesRequestId = (0, $5lH3O.useFetchEntitiesRequestId)();
    const fetchSpacesRequestId = (0, $5lH3O.useFetchSpacesRequestId)();
    const rovoJourneyId = (0, $5lH3O.useRovoJourneyId)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [queryUpdatedTime] = (0, $1i979.useQueryUpdatedTime)();
    const quickFindQuery = (0, $5lH3O.useQuickFindQuery)();
    // eslint-disable-next-line @atlassian/search-common/no-use-rss-hooks
    const [queryVersion] = (0, $1i979.useQueryVersion)();
    const [experimentConfig] = (0, $32Eau.useExperimentConfig)();
    const applicationMode = (0, $32Eau.useApplicationMode)();
    const [analyticsAttributes] = (0, $32Eau.useAnalyticsAttributes)();
    const [productSelected] = (0, $1i979.useSelectedProduct)();
    const filters = (0, $1i979.useFilterAttributesForTracking)();
    const [productEdition] = (0, $32Eau.useProductEdition)();
    return (0, $cozmU.useMemo)(()=>{
        const { frontendExperiments: frontendExperiments = {} } = experimentConfig;
        const { filterSelections: filterSelections, filters: filterCategories } = filters;
        const commonAttributes = {
            productEdition: productEdition,
            frontendExperiments: {
                activeExperiments: Object.keys(frontendExperiments).filter((experiment)=>frontendExperiments[experiment]?.serveExperiment),
                ...frontendExperiments
            },
            ...$bdccd1375bb70356$export$e44a494bf5ca923a(quickFindQuery),
            queryUpdatedAgo: queryUpdatedTime ? Date.now() - queryUpdatedTime : undefined,
            queryVersion: queryVersion,
            searchSessionId: searchSessionId,
            fetchEntitiesTraceId: fetchEntitiesRequestId,
            fetchSpacesTraceId: fetchSpacesRequestId,
            isQuickFind: true,
            mode: applicationMode,
            productSelected: productSelected || (0, $6yu7A.ALL_PRODUCTS_STRING),
            filters: filterCategories,
            filterSelections: filterSelections,
            ...analyticsAttributes,
            ...rovoJourneyId && (0, $hnDqW.isRovoJourneyIdEnabled)(primaryProduct) && {
                rovoJourneyId: rovoJourneyId
            }
        };
        const nonPrivacySafeAttributes = {
            query: quickFindQuery
        };
        return {
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes
        };
    }, [
        analyticsAttributes,
        applicationMode,
        experimentConfig,
        fetchEntitiesRequestId,
        fetchSpacesRequestId,
        filters,
        productEdition,
        productSelected,
        primaryProduct,
        queryUpdatedTime,
        queryVersion,
        quickFindQuery,
        rovoJourneyId,
        searchSessionId
    ]);
};
const $bdccd1375bb70356$export$dba3e2bcdbd49da4 = (query)=>(query.match(/\w+/g) || []).length;
const $bdccd1375bb70356$export$e44a494bf5ca923a = (query)=>{
    const wordCount = $bdccd1375bb70356$export$dba3e2bcdbd49da4(query);
    return {
        numberOfTerms: wordCount,
        queryHash: (0, $e0v3Z.sha256Hash)(query),
        queryHashSHA256: (0, $e0v3Z.sha256Hash)(query),
        queryLength: query.length,
        wordCount: wordCount
    };
};
module.exports["useQuickFindAnalytics"] = $bdccd1375bb70356$export$82052fbad762998f;
module.exports["useQuickFindAttributes"] = $bdccd1375bb70356$export$380f10e960af9b57;
module.exports["getCommonQueryAttributes"] = $bdccd1375bb70356$export$e44a494bf5ca923a;
module.exports["getWordCount"] = $bdccd1375bb70356$export$dba3e2bcdbd49da4;

});

parcelRegister("8D0XM", function(module, exports) {

var $8N8EQ = parcelRequire("8N8EQ");


var $hnyex = parcelRequire("hnyex");

const $cbff08791821dd53$export$b551db3ea2671aa7 = (taskId, taskName, searchSessionId, fireAnalyticsEvent, configNetworkTaskStartAt, context)=>{
    const baseParams = {
        taskId: taskId,
        task: taskName,
        searchSessionId: searchSessionId
    };
    return {
        onStart: ()=>{
            fireAnalyticsEvent((0, $hnyex.onTaskStart)({
                ...baseParams,
                moreContext: context
            }));
        },
        onSuccess: (traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $8N8EQ.normaliseTraceInfo)(traceInfo);
            fireAnalyticsEvent((0, $hnyex.onTaskSuccess)({
                ...baseParams,
                moreContext: {
                    ...context,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        },
        onError: (errorName, errorMessage, traceInfo)=>{
            const timeTaken = performance.now() - configNetworkTaskStartAt;
            const tracingHeaders = (0, $8N8EQ.normaliseTraceInfo)(traceInfo);
            fireAnalyticsEvent((0, $hnyex.onTaskFail)({
                ...baseParams,
                moreContext: {
                    ...context,
                    errorName: errorName,
                    errorMessage: errorMessage,
                    timeTaken: timeTaken,
                    ...tracingHeaders
                }
            }));
        }
    };
};
module.exports["createVitalStatsNetworkCallbacks"] = $cbff08791821dd53$export$b551db3ea2671aa7;

});

parcelRegister("emjGn", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");


var $8N8EQ = parcelRequire("8N8EQ");

// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ const $11a667c9caf33b52$export$6635638df40163e1 = 'quick-find-recent-activities';


/* eslint-disable @atlaskit/platform/no-module-level-eval */ 
var $iDrrr = parcelRequire("iDrrr");

const $bac41c75ad7043f0$var$ConfluencePageFragment = `
  fragment ConfluencePageFragment on ConfluencePage {
    __typename
    title
    pageStatus: status
    subtype
    ancestors {
      __typename
      id
      title
    }
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $bac41c75ad7043f0$var$ConfluenceBlogPostFragment = `
  fragment ConfluenceBlogPostFragment on ConfluenceBlogPost {
    __typename
    title
    blogStatus: status
    links {
      __typename
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $bac41c75ad7043f0$var$ConfluenceWhiteboardFragment = `
  fragment ConfluenceWhiteboardFragment on ConfluenceWhiteboard {
    __typename
    title
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $bac41c75ad7043f0$var$ConfluenceSlideFragment = `
  fragment ConfluenceSlideFragment on ConfluenceSlide {
    __typename
    title
    links {
      base
      webUi
    }
    space {
      id
      name
    }
  }
`;
const $bac41c75ad7043f0$var$AtlasProjectFragment = `
  fragment AtlasProjectFragment on TownsquareProject {
    __typename
    key
    name
    url
    iconData
  }
`;
const $bac41c75ad7043f0$var$AtlasGoalFragment = `
  fragment AtlasGoalFragment on TownsquareGoal {
    __typename
    key
    name
    url
    iconData
  }
`;
const $bac41c75ad7043f0$var$JiraSingleIssueLineTextFieldFragment = `
  fragment JiraSingleIssueLineTextFieldFragment on JiraSingleLineTextField {
    text
		issue @include(if: $includeJiraIssueMetadata) {
			projectField {
				project {
					name
				}
			}
			issueTypeField {
				issueType {
					name
				}
			}
		}
  }
`;
const $bac41c75ad7043f0$var$JiraIssueFragment = `
  fragment JiraIssueFragment on JiraIssue {
    __typename
    key
    webUrl
    statusCategory {
      name,
      colorName
    }
    issueType {
      avatar {
        small
      }
    }
    fieldsById(ids: ["summary"]) {
      edges {
        node {
          __typename
          ...JiraSingleIssueLineTextFieldFragment
        }
      }
    }
  }
  ${$bac41c75ad7043f0$var$JiraSingleIssueLineTextFieldFragment}
`;
const $bac41c75ad7043f0$var$GraphDocumentFragment = `
  fragment GraphDocumentFragment on ExternalDocument {
    id
    type {
        category
    }
    displayName
    parent @optIn(to: "ExternalDataDepotQueryV2"){
        ... on ExternalDocument {
            displayName
        }
    }
    url
    provider {
        providerId
    }
  }
`;
const $bac41c75ad7043f0$var$GraphRemoteLinkFragment = `
  fragment GraphRemoteLinkFragment on ExternalRemoteLink {
	  id
		displayName
		category @optIn(to: "ExternalDataDepotQueryV2")
		url
    provider {
			providerId
		}
  }
`;
const $bac41c75ad7043f0$var$LoomVideoFragment = `
  fragment LoomVideoFragment on LoomVideo {
    name
    loomUrl: url
    owner @include(if: $includeLoomVideoMetadata) {
      name
    }
    playableDuration @include(if: $includeLoomVideoMetadata)
  }
`;
const $bac41c75ad7043f0$var$ExternalPullRequestFragment = `
  fragment ExternalPullRequestFragment on ExternalPullRequest {
    id
    displayName
    url
    status
    provider {
      providerId
    }
  }
`;
const $bac41c75ad7043f0$var$ExternalWorkItemFragment = `
  fragment ExternalWorkItemFragment on ExternalWorkItem {
    id
    displayName
    url
    workItemStatus: status
    provider {
      providerId
    }
  }
`;
const $bac41c75ad7043f0$var$AssetsObjectFragment = `
  fragment AssetsObjectFragment on AssetsObject {
    id
		displayTypename @optIn(to: "AssetsApFields")
    links {
      web
    }
    assetsLabel: label
    objectKey
    assetsIcon: avatar {
      url48
    }
    objectType {
      schema {
        name
        ${(0, $iDrrr.fg)('cdm_ga') ? `assetsSchemaDisplayName: displayName` : ''}
      }
    }
  }
`;
const $bac41c75ad7043f0$var$AssetsObjectTypeFragment = `
fragment AssetsObjectTypeFragment on AssetsObjectType {
	id
	displayTypename @optIn(to: "AssetsApFields")
	links {
		web
	}
	assetsLabel: name
	${(0, $iDrrr.fg)('cdm_ga') ? `assetsDisplayName: displayName` : ''}
	assetsIcon: icon {
		url48
	}
	schema {
		assetsSchemaName: name
		${(0, $iDrrr.fg)('cdm_ga') ? `assetsSchemaDisplayName: displayName` : ''}
	}
}
`;
const $bac41c75ad7043f0$var$AssetsSchemaFragment = `
fragment AssetsSchemaFragment on AssetsSchema {
	id
	displayTypename @optIn(to: "AssetsApFields")
	links {
		web
	}
	assetsLabel: name
	${(0, $iDrrr.fg)('cdm_ga') ? `assetsDisplayName: displayName` : ''}
}
`;
const $bac41c75ad7043f0$export$5db520940cf00715 = 'QuickFindActivitiesQuery';
const $bac41c75ad7043f0$export$8a781e50bcd90a75 = `
  query ${$bac41c75ad7043f0$export$5db520940cf00715}(
    $filteredProducts: [String!]
    $filteredObjectTypes: [String!]
    $filteredEventTypes: [String!]
    $itemsLimit: Int!
    $filteredRootContainerIds: [ID!]
    $after: String
    $includeJiraIssueMetadata: Boolean = false
    $includeLoomVideoMetadata: Boolean = false
  ) {
    activity {
      myActivity {
        all(
          filter: {
            arguments: {
              products: $filteredProducts
              objectTypes: $filteredObjectTypes
              eventTypes: $filteredEventTypes
            }
            rootContainerIds: $filteredRootContainerIds
          }
          first: $itemsLimit
          after: $after
        ) {
          __typename
          edges {
            cursor
            __typename
            node {
              __typename
              object {
                __typename
                id
                type
                product
                data {
                  __typename
                  ...ConfluencePageFragment
                  ...ConfluenceBlogPostFragment
                  ...ConfluenceWhiteboardFragment
                  ${(0, $iDrrr.fg)('quick_find_confluence_slide_in_recents') ? `...ConfluenceSlideFragment` : ''}
                  ...AtlasProjectFragment
                  ...AtlasGoalFragment
                  ...JiraIssueFragment
                  ...GraphDocumentFragment
									...GraphRemoteLinkFragment
									...LoomVideoFragment
									...ExternalPullRequestFragment
									...ExternalWorkItemFragment
                  ${(0, $iDrrr.fg)('assets_rovo_search_all') ? `...AssetsObjectFragment` : ''}
									${(0, $iDrrr.fg)('assets_rovo_search_all') ? `...AssetsObjectTypeFragment` : ''}
									${(0, $iDrrr.fg)('assets_rovo_search_all') ? `...AssetsSchemaFragment` : ''}
                }
              }
              event {
                __typename
                eventType
                timestamp
              }
            }
          }
        }
      }
    }
  }
  ${$bac41c75ad7043f0$var$ConfluencePageFragment}
  ${$bac41c75ad7043f0$var$ConfluenceBlogPostFragment}
  ${$bac41c75ad7043f0$var$ConfluenceWhiteboardFragment}
  ${(0, $iDrrr.fg)('quick_find_confluence_slide_in_recents') ? $bac41c75ad7043f0$var$ConfluenceSlideFragment : ''}
  ${$bac41c75ad7043f0$var$AtlasProjectFragment}
  ${$bac41c75ad7043f0$var$AtlasGoalFragment}
  ${$bac41c75ad7043f0$var$JiraIssueFragment}
  ${$bac41c75ad7043f0$var$GraphDocumentFragment}
	${$bac41c75ad7043f0$var$GraphRemoteLinkFragment}
	${$bac41c75ad7043f0$var$LoomVideoFragment}
	${$bac41c75ad7043f0$var$ExternalPullRequestFragment}
	${$bac41c75ad7043f0$var$ExternalWorkItemFragment}
  ${(0, $iDrrr.fg)('assets_rovo_search_all') ? $bac41c75ad7043f0$var$AssetsObjectFragment : ''}
	${(0, $iDrrr.fg)('assets_rovo_search_all') ? $bac41c75ad7043f0$var$AssetsObjectTypeFragment : ''}
	${(0, $iDrrr.fg)('assets_rovo_search_all') ? $bac41c75ad7043f0$var$AssetsSchemaFragment : ''}
`;


const $39e3e5eb4404f224$export$ba6bff93c920ff4a = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers, networkCallbacks: networkCallbacks })=>{
    networkCallbacks?.onStart();
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: (0, $bac41c75ad7043f0$export$8a781e50bcd90a75),
        operationName: $bac41c75ad7043f0$export$5db520940cf00715,
        headers: headers
    }).then((result)=>{
        const traceInfo = (0, $8N8EQ.extractTraceInfoFromResponse)(result);
        networkCallbacks?.onSuccess(traceInfo);
        return result;
    }, (error)=>{
        networkCallbacks?.onError(error?.name || 'UnknownError', error?.message || 'An unknown error occurred');
        throw error;
    });
};
const { refreshOnAccessDecorator: $39e3e5eb4404f224$var$refreshOnAccessDecoratorRecentActivities, clear: $39e3e5eb4404f224$var$clearRecentActivitiesCache } = (0, $fyjce.promiseCache)({
    name: (0, $11a667c9caf33b52$export$6635638df40163e1)
});
const $39e3e5eb4404f224$var$FAILURE_EXPIRATION_MS = 5000; // 5 seconds for failure
const $39e3e5eb4404f224$var$SUCCESS_EXPIRATION_MS = 300000; // 5 minutes for success
const $39e3e5eb4404f224$export$ffce414fbab0f879 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers, expiration: expiration, onlyRefreshIfExpired: onlyRefreshIfExpired, returnExpired: returnExpired, analyticsCallback: analyticsCallback, networkCallbacks: networkCallbacks })=>{
    const cacheKey = (0, $bZF61.generateHash)(`${(0, $11a667c9caf33b52$export$6635638df40163e1)}|${JSON.stringify(variables)}`).toString();
    const writeBackWithTTL = (value, ttl)=>{
        $39e3e5eb4404f224$var$refreshOnAccessDecoratorRecentActivities({
            key: cacheKey,
            supplier: async ()=>value,
            returnExpired: false,
            onlyRefreshIfExpired: false,
            expiration: ttl
        });
    };
    return $39e3e5eb4404f224$var$refreshOnAccessDecoratorRecentActivities({
        key: cacheKey,
        supplier: async ()=>{
            try {
                const result = await (0, $b0Mpu.fetchAgg)({
                    variables: variables,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    graphQuery: (0, $bac41c75ad7043f0$export$8a781e50bcd90a75),
                    operationName: $bac41c75ad7043f0$export$5db520940cf00715,
                    headers: headers
                });
                writeBackWithTTL(result, $39e3e5eb4404f224$var$SUCCESS_EXPIRATION_MS);
                return result;
            } catch (error) {
                // On failure, cache the rejected promise with a short TTL to avoid hammering the service
                // This ensures the error is still thrown when accessed, but prevents immediate retries
                writeBackWithTTL(Promise.reject(error), $39e3e5eb4404f224$var$FAILURE_EXPIRATION_MS);
                // Re-throw the error so the caller knows the request failed
                throw error;
            }
        },
        expiration: expiration,
        onlyRefreshIfExpired: onlyRefreshIfExpired,
        returnExpired: returnExpired,
        analyticsCallback: analyticsCallback,
        networkCallbacks: networkCallbacks
    });
};
const $39e3e5eb4404f224$export$b0de6826751f4fe0 = ({ variables: variables, graphQuery: graphQuery, aggAbsoluteUrl: aggAbsoluteUrl, operationName: operationName, headers: headers })=>{
    return (0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: graphQuery,
        operationName: operationName,
        headers: headers
    });
};
const $39e3e5eb4404f224$export$a13e8bf43a8d56c7 = (key)=>$39e3e5eb4404f224$var$clearRecentActivitiesCache(key);
module.exports["recentActivitiesQuery"] = $39e3e5eb4404f224$export$ba6bff93c920ff4a;
module.exports["cachedRecentActivitiesQuery"] = $39e3e5eb4404f224$export$ffce414fbab0f879;

});

parcelRegister("6h661", function(module, exports) {

var $3Ydx7 = parcelRequire("3Ydx7");

const $313e4b4bb95fb0d7$export$194e5f2c2ebfcf47 = 'quick-find-dialog';
const $313e4b4bb95fb0d7$export$954ad19cca7aaecd = 'quick-find-open';
const $313e4b4bb95fb0d7$export$d73367afdae3e8ef = 'quick-find-close';
const $313e4b4bb95fb0d7$export$529299d30909140a = 'quick-find-post-query';
const $313e4b4bb95fb0d7$export$b1255d59856835f2 = 'quick-find-loading';
const $313e4b4bb95fb0d7$export$90774abdf51eb445 = [
    (0, $3Ydx7.PrimaryProductKeys).Confluence,
    (0, $3Ydx7.PrimaryProductKeys).Jira,
    (0, $3Ydx7.PrimaryProductKeys).Assets,
    (0, $3Ydx7.PrimaryProductKeys).RovoExtension,
    (0, $3Ydx7.PrimaryProductKeys).Talent
];
const $313e4b4bb95fb0d7$export$4551c7df8148d8af = 'atlassian.search-dialog.ai-dialog.referrer';
const $313e4b4bb95fb0d7$export$fffb71ae1a2b6d2f = 2;
module.exports["SEARCH_DIALOG_WIDTH_OBSERVER_ID"] = $313e4b4bb95fb0d7$export$194e5f2c2ebfcf47;
module.exports["QUICK_FIND_OPEN_INTERACTION"] = $313e4b4bb95fb0d7$export$954ad19cca7aaecd;
module.exports["QUICK_FIND_CLOSE_INTERACTION"] = $313e4b4bb95fb0d7$export$d73367afdae3e8ef;
module.exports["QUICK_FIND_POST_QUERY_INTERACTION"] = $313e4b4bb95fb0d7$export$529299d30909140a;
module.exports["QUICK_FIND_LOADING_HOLD"] = $313e4b4bb95fb0d7$export$b1255d59856835f2;
module.exports["PRODUCTS_WITH_INLINE_FILTERS"] = $313e4b4bb95fb0d7$export$90774abdf51eb445;
module.exports["SEARCH_DIALOG_AI_DIALOG_REFERER_KEY"] = $313e4b4bb95fb0d7$export$4551c7df8148d8af;
module.exports["DEFAULT_RECENT_AND_SUGGESTED_QUERY_LIMIT"] = $313e4b4bb95fb0d7$export$fffb71ae1a2b6d2f;

});

parcelRegister("cHss8", function(module, exports) {
/**
 * Generic builder for the `ml_lens` envelope that lets the ML Lens transformer
 * split a single GASv3 event into one metric per logical dimension (e.g. one
 * metric per product/connector).
 *
 * See: https://hello.atlassian.net/wiki/spaces/~93171358/pages/6820686403/
 *   GASv3+Events+Transformation+for+ML+Lens+Metrics+Schema
 *
 * This module is intentionally domain-agnostic: callers provide the namespace,
 * the metric-set base tags and the list of metrics. Surface-specific helpers
 * (e.g. Quick Find post-query, Full Page Search results) live alongside this
 * file and delegate to {@link buildMlLensEnvelope}.
 */ const $6bdcec8d8e221cf0$export$aaa5dab2f0c84de8 = ({ namespace: namespace, baseTags: baseTags, metrics: metrics, userId: userId })=>{
    if (!userId) return null;
    if (metrics.length === 0) return null;
    return {
        version: '1',
        metric_sets: [
            {
                namespace: namespace,
                tags: {
                    ...baseTags,
                    user_id: userId
                },
                metrics: metrics
            }
        ]
    };
};
module.exports["buildMlLensEnvelope"] = $6bdcec8d8e221cf0$export$aaa5dab2f0c84de8;

});

parcelRegister("fnx12", function(module, exports) {
const $783d3b233540dfe9$export$52f97816f69502ce = 'atl-edge-region-hint';
function $783d3b233540dfe9$export$ef0639c0600b3b26(primaryProduct, productDataRegions) {
    const primaryProductDataRegion = primaryProduct ? productDataRegions[primaryProduct]?.[0] : undefined;
    const confluenceDataRegion = productDataRegions['confluence']?.[0];
    const jiraDataRegion = productDataRegions['jira']?.[0];
    const firstDataRegion = Object.entries(productDataRegions)[0]?.[0];
    return primaryProductDataRegion ?? confluenceDataRegion ?? jiraDataRegion ?? firstDataRegion;
}
module.exports["EDGE_REGION_HINT_HEADER"] = $783d3b233540dfe9$export$52f97816f69502ce;
module.exports["getEdgeRegionHint"] = $783d3b233540dfe9$export$ef0639c0600b3b26;

});

parcelRegister("fM05T", function(module, exports) {

var $6dPGs = parcelRequire("6dPGs");

const $2bcec8fe5bd92ace$export$ec4722d39a5031c0 = 'atlassian.unified-search.recent-searches';
const $2bcec8fe5bd92ace$export$c1b7badf23670c19 = 50;
const $2bcec8fe5bd92ace$export$98712b4e855f892c = (item)=>typeof item === 'string' ? {
        query: item
    } : item;
const $2bcec8fe5bd92ace$export$74e99d9695eabee6 = ({ value: value, userId: userId, productId: productId, key: key })=>{
    const recentSearchesRaw = (0, $6dPGs.getLocalStorageItemAsString)(key);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId]) recentSearches[userId] = {};
    let userSearches = recentSearches[userId];
    if (!userSearches[productId]) userSearches[productId] = [];
    let productSearches = userSearches[productId];
    // Normalize the value: if it's a string, trim it; if it's an object, trim the query
    const normalizedValue = typeof value === 'string' ? value.trim() : {
        ...value,
        query: value.query.trim()
    };
    // Pop the last value of the array if it is too long
    if (productSearches.length === $2bcec8fe5bd92ace$export$c1b7badf23670c19) productSearches.pop();
    // If the given value is a duplicate (based on query), remove it from the array
    const { query: normalizedQuery } = $2bcec8fe5bd92ace$export$98712b4e855f892c(normalizedValue);
    productSearches = productSearches.filter((v)=>$2bcec8fe5bd92ace$export$98712b4e855f892c(v).query !== normalizedQuery);
    productSearches.unshift(normalizedValue);
    recentSearches[userId][productId] = productSearches;
    (0, $6dPGs.setLocalStorageItem)(key, JSON.stringify(recentSearches));
};
const $2bcec8fe5bd92ace$export$1216255791599668 = ({ userId: userId, productId: productId, key: key })=>{
    const recentSearchesRaw = (0, $6dPGs.getLocalStorageItemAsString)(key);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    const userSearches = recentSearches[userId] || {};
    return userSearches[productId] || [];
};
const $2bcec8fe5bd92ace$export$6adb2cc1366d1e30 = ({ value: value, userId: userId, productId: productId, key: key })=>{
    const recentSearchesRaw = (0, $6dPGs.getLocalStorageItemAsString)(key);
    const recentSearches = recentSearchesRaw ? JSON.parse(recentSearchesRaw) : {};
    if (!recentSearches[userId] || !recentSearches[userId][productId]) return [];
    const { query: queryToRemove } = $2bcec8fe5bd92ace$export$98712b4e855f892c(value);
    recentSearches[userId][productId] = recentSearches[userId][productId].filter((v)=>$2bcec8fe5bd92ace$export$98712b4e855f892c(v).query !== queryToRemove);
    (0, $6dPGs.setLocalStorageItem)(key, JSON.stringify(recentSearches));
    return recentSearches[userId][productId];
};
module.exports["RECENT_SEARCH_KEY"] = $2bcec8fe5bd92ace$export$ec4722d39a5031c0;
module.exports["getRecentQueryObject"] = $2bcec8fe5bd92ace$export$98712b4e855f892c;
module.exports["addRecentSearch"] = $2bcec8fe5bd92ace$export$74e99d9695eabee6;
module.exports["getRecentSearches"] = $2bcec8fe5bd92ace$export$1216255791599668;
module.exports["removeRecentSearch"] = $2bcec8fe5bd92ace$export$6adb2cc1366d1e30;

});

parcelRegister("50CxG", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $a1L5E = parcelRequire("a1L5E");


var $7zn5c = parcelRequire("7zn5c");


var $3ZYG5 = parcelRequire("3ZYG5");


var $dvVWp = parcelRequire("dvVWp");


var $9pcjO = parcelRequire("9pcjO");


var $cJff5 = parcelRequire("cJff5");


var $9NmsO = parcelRequire("9NmsO");


var $fq2CX = parcelRequire("fq2CX");





var $7SkLu = parcelRequire("7SkLu");


var $hCtla = parcelRequire("hCtla");


var $AgYeH = parcelRequire("AgYeH");


var $kQgL7 = parcelRequire("kQgL7");


var $kh8w1 = parcelRequire("kh8w1");


var $dv1ov = parcelRequire("dv1ov");


var $6yu7A = parcelRequire("6yu7A");


var $kHRmO = parcelRequire("kHRmO");





var $73Hia = parcelRequire("73Hia");

const $17f714e6aec73e0c$export$e98932ab9e22c265 = ({ dependency: dependency, searchSessionId: searchSessionId, reason: reason, source: source })=>{
    return {
        source: source,
        action: 'degradedDependency',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                degradedDependency: dependency,
                reason: reason,
                searchSessionId: searchSessionId
            }
        }
    };
};


const $b8d00dcc62437b77$export$7199f2d13e6ae9f7 = ({ dependency: dependency, searchSessionId: searchSessionId, source: source, moreContext: moreContext })=>{
    return {
        source: source,
        action: 'failedDependency',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                failedDependency: dependency,
                searchSessionId: searchSessionId,
                ...moreContext || {}
            }
        }
    };
};


const $f68f5b4eef793981$export$786813d6840571a0 = ({ requestName: requestName, searchSessionId: searchSessionId, cacheHit: cacheHit, refreshTriggered: refreshTriggered, source: source })=>{
    return {
        source: source,
        action: 'requestCacheAccess',
        actionSubject: 'searchPage',
        eventType: 'track',
        attributes: {
            additionalAttributes: {
                requestName: requestName,
                cacheHit: cacheHit,
                refreshTriggered: refreshTriggered,
                searchSessionId: searchSessionId
            }
        }
    };
};



var $jTbFT = parcelRequire("jTbFT");


var $hnyex = parcelRequire("hnyex");


var $2gvXK = parcelRequire("2gvXK");


var $8D0XM = parcelRequire("8D0XM");


var $dsOco = parcelRequire("dsOco");


var $2csHQ = parcelRequire("2csHQ");


var $32Eau = parcelRequire("32Eau");

const $bafee2afb26ee146$var$mapProductInfoToDataRegions = (productInfo)=>{
    if (!productInfo || productInfo.length === 0) return undefined;
    return productInfo.reduce((acc, info)=>{
        if (!info?.name || !info.dataRegion) return acc;
        acc[info.name] = Array.isArray(info.dataRegion) ? info.dataRegion : [
            info.dataRegion
        ];
        return acc;
    }, {});
};
const $bafee2afb26ee146$var$mapProductEdition = (productEdition, firstPartyProducts)=>{
    if (!productEdition || !firstPartyProducts || firstPartyProducts.length === 0) return undefined;
    return firstPartyProducts.reduce((acc, product)=>{
        acc[product.name] = productEdition;
        return acc;
    }, {});
};
const $bafee2afb26ee146$var$mapSiteMetadata = (siteMetadata, cloudId, firstPartyProducts)=>{
    if (!siteMetadata) return [];
    return [
        {
            siteId: cloudId || '',
            siteName: siteMetadata.siteName || '',
            isNounsAvailable: false,
            isRovoEnabled: siteMetadata.isRovoEnabled ?? false,
            isJiraIssueIndexed: siteMetadata.isJiraIssueIndexed ?? false,
            productEdition: $bafee2afb26ee146$var$mapProductEdition(siteMetadata.productEdition, firstPartyProducts),
            productDataRegions: $bafee2afb26ee146$var$mapProductInfoToDataRegions(siteMetadata.productInfo),
            rovoFeatures: undefined
        }
    ];
};
const $bafee2afb26ee146$var$mapFirstPartyProductsToResources = (firstPartyProducts, cloudId, siteName)=>{
    return firstPartyProducts.map((product)=>({
            id: `ari:cloud:${product.name}::site/${cloudId || ''}`,
            baseUrl: '',
            siteName: siteName || ''
        }));
};
const $bafee2afb26ee146$var$mapThirdPartyProductsToResources = (thirdPartyProducts)=>{
    return thirdPartyProducts.map((product)=>({
            type: product.name,
            outboundAuthUrl: product.outboundAuthUrl || '',
            isUserOAuthed: product.isUserOAuthed,
            providerId: product.providerId || '',
            connectionId: product.connectionId ?? undefined,
            isImpersonationAuthEnabled: product.isImpersonationAuthEnabled ?? undefined,
            authResolutionMode: product.authResolutionMode ?? undefined,
            integrationId: product.integrationARI ? product.integrationARI : undefined,
            workspaceName: product.workspaceName ?? undefined,
            workspaceUrl: product.workspaceUrl ?? undefined,
            datasourceId: product.datasourceId ?? undefined,
            connectorSyncType: product.connectorSyncType ?? undefined,
            connectorCreatedAt: product.connectorCreatedAt ?? undefined,
            lightIcon: product.lightIcon ?? undefined,
            entityTypes: product.entityTypes ?? undefined,
            environmentType: product.environmentType ?? undefined
        }));
};
const $bafee2afb26ee146$export$160fbca21b53d78a = (configuration, cloudId)=>{
    const firstPartyProducts = configuration.firstPartyProducts || [];
    const thirdPartyProducts = configuration.thirdPartyProducts || [];
    const siteMetadata = configuration.siteMetadata;
    return {
        firstPartyConfig: {
            resources: $bafee2afb26ee146$var$mapFirstPartyProductsToResources(firstPartyProducts, cloudId, siteMetadata?.siteName || ''),
            // Unused by search-page — `TSearchConfigAPIResponse` still requires the field.
            intercomHmac: '',
            siteMetadata: $bafee2afb26ee146$var$mapSiteMetadata(siteMetadata, cloudId, firstPartyProducts)
        },
        thirdPartyConfig: $bafee2afb26ee146$var$mapThirdPartyProductsToResources(thirdPartyProducts)
    };
};


/**
 * Site-metadata helper functions used by `useFetchConfig`.
 *
 * These helpers each have **two implementations**, switched by the
 * `rovo_fps_use_rovo_config` feature gate:
 *
 * - **On** — delegate to the canonical implementation in
 *   `@atlassian/rovo-connectors-config/utils/site-metadata-helpers`. This is
 *   the path that will become the sole implementation once the gate is
 *   fully ramped and `useFetchConfig` is replaced by `useRovoConfig`.
 * - **Off** — run the original inline logic. Preserves verbatim behaviour
 *   for everyone not on the gate.
 *
 * Both branches must return identical results for any given input — see
 * `__tests__/site-metadata-helpers-equivalence.test.ts` for the `ffTest.both`
 * coverage that enforces this.
 *
 * **Not exported from the package.** Lives at
 * `controllers/config/site-metadata-helpers.ts` and is intentionally absent
 * from `package.json` `"exports"`. External consumers should keep going
 * through the `./use-fetch-config` subpath.
 */ 
var $9XgN6 = parcelRequire("9XgN6");




/** Matches `ari:cloud:<product>::<resource-type>/<cloudId>` and captures the cloudId. */ const $c608e301114d7356$var$EXTRACT_CLOUD_ID = /ari:cloud:.*?\/(.*)/;
const $c608e301114d7356$export$c1871fdf674a03c4 = (firstPartyResponse)=>{
    if ((0, $kh8w1.isRovoFPSUseRovoConfigEnabled)()) return (0, $9XgN6.getFirstCloudId)(firstPartyResponse);
    const match = firstPartyResponse.resources[0]?.id.match($c608e301114d7356$var$EXTRACT_CLOUD_ID);
    const extractedCloudId = match ? match[1] : '';
    return extractedCloudId;
};
const $c608e301114d7356$export$243c13f4da40a98e = (firstPartyResponse, cloudId)=>{
    if ((0, $kh8w1.isRovoFPSUseRovoConfigEnabled)()) return (0, $9XgN6.isRovoEnabledForSite)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isRovoEnabled;
};
const $c608e301114d7356$export$37c9c6a3ae5f363c = (firstPartyResponse, cloudId)=>{
    if ((0, $kh8w1.isRovoFPSUseRovoConfigEnabled)()) return (0, $9XgN6.getJiraIssueIndexedForTenant)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return false;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId)?.isJiraIssueIndexed;
};
const $c608e301114d7356$export$53e066a63a960439 = (firstPartyResponse, cloudId)=>{
    if ((0, $kh8w1.isRovoFPSUseRovoConfigEnabled)()) return (0, $9XgN6.getProductEdition)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productEdition)?.productEdition;
};
const $c608e301114d7356$export$c635d3296555e2da = (firstPartyResponse, cloudId)=>{
    if ((0, $kh8w1.isRovoFPSUseRovoConfigEnabled)()) return (0, $9XgN6.getProductDataRegions)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.productDataRegions)?.productDataRegions;
};
const $c608e301114d7356$export$2a1c0662041ee0a3 = (firstPartyResponse, cloudId)=>{
    if ((0, $kh8w1.isRovoFPSUseRovoConfigEnabled)()) return (0, $9XgN6.getRovoFeatures)(firstPartyResponse, cloudId);
    if (!cloudId || !firstPartyResponse || !firstPartyResponse.siteMetadata) return undefined;
    return firstPartyResponse.siteMetadata.find((metadata)=>metadata.siteId === cloudId && !!metadata.rovoFeatures)?.rovoFeatures;
};


/**
 * Helper functions to parse the search combined config response. Ideally
 * this file should exist in the search-client package, however there are
 * too many 3P types defined in search-page.
 */ 










var $iDrrr = parcelRequire("iDrrr");


var $fd0l2 = parcelRequire("fd0l2");


var $hAvnk = parcelRequire("hAvnk");





var $8fNUp = parcelRequire("8fNUp");


var $7ydfN = parcelRequire("7ydfN");

/**
 * Maps CloudGraph ATI to TypeFilterValueKey
 */ const $60ad9faf99641d2c$var$ATI_TO_TYPE_FILTER_KEY_MAP = {
    'ati:cloud:graph:document': (0, $7ydfN.TypeFilterValueKey).Document,
    'ati:cloud:graph:message': (0, $7ydfN.TypeFilterValueKey).Message,
    'ati:cloud:graph:conversation': (0, $7ydfN.TypeFilterValueKey).Conversation,
    'ati:cloud:graph:design': (0, $7ydfN.TypeFilterValueKey).Design,
    'ati:cloud:graph:video': (0, $7ydfN.TypeFilterValueKey).Video,
    'ati:cloud:graph:space': (0, $7ydfN.TypeFilterValueKey).Space,
    'ati:cloud:graph:comment': (0, $7ydfN.TypeFilterValueKey).Comment,
    'ati:cloud:graph:repository': (0, $7ydfN.TypeFilterValueKey).Repository,
    'ati:cloud:graph:pull-request': (0, $7ydfN.TypeFilterValueKey).PullRequest,
    'ati:cloud:graph:commit': (0, $7ydfN.TypeFilterValueKey).Commit,
    'ati:cloud:graph:branch': (0, $7ydfN.TypeFilterValueKey).Branch,
    'ati:cloud:graph:calendar-event': (0, $7ydfN.TypeFilterValueKey).Calendar,
    'ati:cloud:graph:work-item': (0, $7ydfN.TypeFilterValueKey).WorkItem,
    'ati:cloud:graph:project': (0, $7ydfN.TypeFilterValueKey).Project,
    'ati:cloud:graph:deal': (0, $7ydfN.TypeFilterValueKey).Deal,
    'ati:cloud:graph:customer-org': (0, $7ydfN.TypeFilterValueKey).CustomerOrg,
    'ati:cloud:graph:dashboard': (0, $7ydfN.TypeFilterValueKey).Dashboard,
    'ati:cloud:graph:data-table': (0, $7ydfN.TypeFilterValueKey).DataTable
};
/**
 * Checks if an ATI string is a CloudGraph ATI
 */ const $60ad9faf99641d2c$var$isCloudGraphAti = (ati)=>{
    return ati.startsWith('ati:cloud:graph:');
};
function $60ad9faf99641d2c$export$770175465f396551(atis) {
    const typeFilterConfig = new Map();
    // Group ATIs by their corresponding TypeFilterValueKey
    const atisByTypeKey = new Map();
    for (const ati of atis)if ($60ad9faf99641d2c$var$isCloudGraphAti(ati)) {
        const typeKey = $60ad9faf99641d2c$var$ATI_TO_TYPE_FILTER_KEY_MAP[ati];
        if (typeKey) {
            if (!atisByTypeKey.has(typeKey)) atisByTypeKey.set(typeKey, []);
            atisByTypeKey.get(typeKey).push(ati);
        }
    }
    // Convert to TypeFilterConfig3P format
    for (const [typeKey, entityAtis] of atisByTypeKey)typeFilterConfig.set(typeKey, {
        entities3P: entityAtis,
        subTypes3P: []
    });
    return typeFilterConfig;
}






var $95n8y = parcelRequire("95n8y");

const $79d324e98214d5e7$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS = new Set([
    'servicenow',
    'zendesk'
]);
const $79d324e98214d5e7$var$mapForgeConnectorToThirdPartyConfig = (forgeConnector)=>{
    // Validate required fields
    if (!forgeConnector.lightIcon || !forgeConnector.workspaceName) return undefined;
    const icon = (0, $hAvnk.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.workspaceName, 'medium');
    const searchResultIcon = (0, $hAvnk.get3PLogoFromURL)(forgeConnector.lightIcon, forgeConnector.providerId, 'large');
    const productKey = forgeConnector.type;
    // Register the icon in the registry so ProductOrNounIcon can access it without props
    (0, $8fNUp.registerForgeConnectorIcon)(productKey, icon);
    // Build type filter config
    const typeFilterConfig = forgeConnector.entityTypes ? (0, $60ad9faf99641d2c$export$770175465f396551)(forgeConnector.entityTypes) : new Map();
    // Register the type mapping in the cache so universal type filter can use it
    if ((0, $iDrrr.fg)('rovo-search-dynamic-forge-config')) (0, $2gvXK.registerForgeConnectorTypeMapping)(productKey, typeFilterConfig);
    const config = {
        id: forgeConnector.type,
        displayName: forgeConnector.environmentType ? `${forgeConnector.workspaceName} (${forgeConnector.environmentType})` : forgeConnector.workspaceName,
        resourceType: forgeConnector.type,
        datasourceId: forgeConnector.datasourceId,
        connectionId: forgeConnector.connectionId,
        providerId: forgeConnector.providerId,
        outboundAuthUrl: forgeConnector.outboundAuthUrl,
        integrationAri: forgeConnector.integrationId ? forgeConnector.integrationId : `ari:cloud:platform::integration/${forgeConnector.providerId}`,
        filters: [
            'lastUpdated',
            'universalTypeFilter'
        ],
        displayWorkspaceNameAsProductName: true,
        isEnabled: ()=>true,
        userNeedsOAuth: !forgeConnector.isUserOAuthed,
        requiresOauth: !forgeConnector.isUserOAuthed && !forgeConnector.outboundAuthUrl ? false : true,
        icon: icon,
        searchResultIcon: searchResultIcon,
        typeFilterConfig: typeFilterConfig,
        workspaceName: forgeConnector.workspaceName,
        connectorSources: [
            (0, $8fNUp.FULL_CONNECTOR_SOURCE)
        ]
    };
    return config;
};
const $79d324e98214d5e7$export$4cb8ef4a677c563c = (resources)=>{
    const THIRD_PARTY_TYPES = (0, $95n8y.getThirdPartyTypes)();
    // Use a map to track connector sources for each providerId
    // This is useful for deduping search results for providers that are hybrid smartlink and full connectors
    const connectorSourceMap = new Map();
    let productKeys = [];
    let thirdPartyConfigsWithAPIResponse = {};
    resources.forEach((resource)=>{
        // Handle Forge connectors first (if feature flag enabled)
        if ((0, $8fNUp.isForgeConnectorProductKey)(resource.type) && (0, $iDrrr.fg)('rovo-search-dynamic-forge-config')) {
            const config = $79d324e98214d5e7$var$mapForgeConnectorToThirdPartyConfig(resource);
            if (config) {
                const productKey = resource.type;
                productKeys.push(productKey);
                thirdPartyConfigsWithAPIResponse[productKey] = config;
            }
            return; // Early return for Forge connectors
        }
        // Handle hardcoded connectors (existing logic)
        const productKey = THIRD_PARTY_TYPES[resource.type] || '';
        if (!productKey) return;
        const { providerId: providerId, datasourceId: datasourceId } = resource;
        productKeys.push(productKey);
        let config = {};
        const staticConfig = (0, $fd0l2.ThirdPartyConfigsSync).get(productKey);
        if (staticConfig) {
            const isSlackConnectorSyncTypeEnabled = (0, $iDrrr.fg)('ai_3p_slack_connector_status_transition_enabled') && productKey === 'slack';
            const isFederatedNoOAuthConnector = $79d324e98214d5e7$var$FEDERATED_NO_OAUTH_PRODUCT_KEYS.has(productKey) && resource.connectorSyncType === (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE);
            let sourceType;
            if (resource.type.startsWith((0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE))) sourceType = (0, $8fNUp.SMARTLINKS_CONNECTOR_SOURCE);
            else if (resource.type.startsWith((0, $8fNUp.LITE_CONNECTOR_SOURCE))) sourceType = (0, $8fNUp.LITE_CONNECTOR_SOURCE);
            else if (isFederatedNoOAuthConnector) sourceType = (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE);
            else if (isSlackConnectorSyncTypeEnabled) sourceType = resource.connectorSyncType === 'federated' ? (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE) : (0, $8fNUp.FULL_CONNECTOR_SOURCE);
            else if (staticConfig.isFederated) sourceType = (0, $8fNUp.FEDERATED_CONNECTOR_SOURCE);
            else sourceType = (0, $8fNUp.FULL_CONNECTOR_SOURCE);
            connectorSourceMap.set(providerId, (connectorSourceMap.get(providerId) || new Set()).add(sourceType));
            const existingConfig = thirdPartyConfigsWithAPIResponse[productKey];
            const isExistingConfigFullConnectorSource = existingConfig?.connectorSources?.includes((0, $8fNUp.FULL_CONNECTOR_SOURCE)) || false;
            const outboundAuthUrl = isFederatedNoOAuthConnector ? '' : isExistingConfigFullConnectorSource && existingConfig?.outboundAuthUrl ? existingConfig.outboundAuthUrl : resource.outboundAuthUrl;
            const userNeedsOAuth = isFederatedNoOAuthConnector ? false : isExistingConfigFullConnectorSource && existingConfig ? existingConfig.userNeedsOAuth : !resource.isUserOAuthed;
            config = {
                ...staticConfig,
                outboundAuthUrl: outboundAuthUrl,
                userNeedsOAuth: userNeedsOAuth,
                providerId: providerId,
                datasourceId: datasourceId,
                connectionId: resource.connectionId,
                workspaceName: resource.workspaceName,
                workspaceUrl: resource.workspaceUrl,
                connectorSources: Array.from(connectorSourceMap.get(providerId) || []),
                impersonationEnabled: resource.isImpersonationAuthEnabled,
                authResolutionMode: resource.authResolutionMode,
                connectorCreatedAt: resource.connectorCreatedAt
            };
            const datasourceList = [];
            // Add the main config without the nested datasources
            // eslint-disable-next-line no-unused-vars
            const { datasources: datasources, ...configWithoutDatasources } = config;
            configWithoutDatasources.datasourceId = resource.datasourceId;
            configWithoutDatasources.connectionId = resource.connectionId;
            // TODO: Leave config level logic at the root of the datasource itself and datasource specific logic in the datasources -> https://hello.jira.atlassian.cloud/browse/DCCNT-1386
            const datasource = {
                ...configWithoutDatasources,
                ...resource,
                outboundAuthUrl: isFederatedNoOAuthConnector ? '' : resource.outboundAuthUrl,
                userNeedsOAuth: isFederatedNoOAuthConnector ? false : !resource.isUserOAuthed,
                integrationAri: resource.integrationId || configWithoutDatasources.integrationAri
            };
            datasourceList.push(datasource);
            // Add third-party configs, also without the nested datasources
            const extraDatasources = thirdPartyConfigsWithAPIResponse[productKey]?.datasources || [];
            const cleanedExtraDatasources = extraDatasources.map(// eslint-disable-next-line no-unused-vars
            ({ datasources: datasources, ...configWithoutDatasources })=>configWithoutDatasources);
            datasourceList.push(...cleanedExtraDatasources);
            // Assign the cleaned datasourceList back to the main config
            config.datasources = datasourceList;
            thirdPartyConfigsWithAPIResponse[productKey] = config;
        }
    });
    // Filter product keys to only include valid ones.
    // Note: Only filter hardcoded product keys, Forge connectors use their own type as product key
    const filteredProductKeys = productKeys.filter((productKey)=>{
        if ((0, $8fNUp.isForgeConnectorProductKey)(productKey)) return true; // Forge connectors are always valid
        // For hardcoded 3P connectors, check if they're in allProductKeys
        return (0, $dvVWp.getAllProductKeys)().includes(productKey);
    });
    // Deduplicate product keys.
    // Multiple raw resources can map to the same product key (e.g. smartlinks-connector-gdrive
    // and google-drive-connector both map to 'drive'). While thirdPartyConfigs is an object
    // and naturally deduplicates, productKeys is an array that accumulates duplicates.
    // Without dedup, SSR produces different query variables than SPA (which accidentally
    // deduplicates via buildProducts in the bootstrap store's onUpdate handler).
    const deduplicatedProductKeys = [
        ...new Set(filteredProductKeys)
    ];
    return {
        productKeys: deduplicatedProductKeys,
        thirdPartyConfigs: thirdPartyConfigsWithAPIResponse
    };
};


const $c01ed8b87fffede0$export$fc6c3173f0bc0482 = ({ configuration: configuration })=>{
    if (configuration.firstPartyProducts) {
        const firstPartyProducts = configuration.firstPartyProducts.map((product)=>product.name);
        const accessibleNouns = firstPartyProducts.filter((product)=>product in (0, $kHRmO.nouns));
        return accessibleNouns;
    } else return [];
};
const $c01ed8b87fffede0$export$b38c0215344366f7 = ({ configuration: configuration, primaryProduct: primaryProduct, cloudId: cloudId })=>{
    let accessibleProducts = [];
    // TODO: QS-9614 Stop having to convert back to legacy 1P/3P config types
    const { thirdPartyConfig: thirdPartyConfig } = (0, $bafee2afb26ee146$export$160fbca21b53d78a)(configuration, cloudId);
    // Add first party products to the array (deduplicated — multiple resource ARIs
    // can map to the same product key, e.g. bitbucket::site and bitbucket::workspace)
    if (configuration.firstPartyProducts) {
        const knownProductKeys = (0, $dvVWp.getAllProductKeys)();
        const firstPartyProducts = [
            ...new Set(configuration.firstPartyProducts.map((product)=>product.name).filter((product)=>knownProductKeys.includes(product)))
        ];
        accessibleProducts.push(...firstPartyProducts);
    }
    // Add Atlas to the array if there is more than one accessible noun
    const accessibleNouns = $c01ed8b87fffede0$export$fc6c3173f0bc0482({
        configuration: configuration,
        primaryProduct: primaryProduct,
        cloudId: cloudId
    });
    if (accessibleNouns.length > 1) accessibleProducts.push((0, $dvVWp.ProductKeys).Atlas);
    // Add third party products to the array
    if (configuration?.siteMetadata?.isRovoEnabled) {
        const { productKeys: thirdPartyProductKeys } = (0, $79d324e98214d5e7$export$4cb8ef4a677c563c)(thirdPartyConfig);
        accessibleProducts.push(...thirdPartyProductKeys);
    }
    // Always ensure the primary product is in the list, even if the config
    // response doesn't include it (e.g. resources only contain other products).
    if (!accessibleProducts.includes(primaryProduct)) accessibleProducts.unshift(primaryProduct);
    return accessibleProducts;
};
const $c01ed8b87fffede0$export$c635d3296555e2da = ({ configuration: configuration })=>{
    if (configuration?.siteMetadata?.productInfo?.length) {
        const entries = configuration.siteMetadata.productInfo.reduce((acc, product)=>{
            if (product.name) {
                const dataRegion = Array.isArray(product.dataRegion) ? product.dataRegion : typeof product.dataRegion === 'string' ? [
                    product.dataRegion
                ] : [];
                acc.push([
                    product.name,
                    dataRegion
                ]);
            }
            return acc;
        }, []);
        return Object.fromEntries(entries);
    } else return undefined;
};
const $c01ed8b87fffede0$export$53e066a63a960439 = ({ configuration: configuration })=>{
    const productEdition = configuration?.siteMetadata?.productEdition;
    if (typeof productEdition === 'string' && productEdition) return {
        confluence: productEdition
    };
    else return undefined;
};
const $c01ed8b87fffede0$export$37755e2ec7a40bc1 = ({ configuration: configuration, cloudId: cloudId })=>{
    if (configuration?.siteMetadata?.isRovoEnabled) // TODO: QS-9614 Stop having to convert back to legacy 1P/3P config types
    return (0, $79d324e98214d5e7$export$4cb8ef4a677c563c)((0, $bafee2afb26ee146$export$160fbca21b53d78a)(configuration, cloudId).thirdPartyConfig).thirdPartyConfigs;
    else return {};
};
const $c01ed8b87fffede0$export$5a5f668a90736418 = (args)=>{
    const { configuration: configuration } = args;
    const accessibleProducts = $c01ed8b87fffede0$export$b38c0215344366f7(args);
    return {
        accessibleNouns: $c01ed8b87fffede0$export$fc6c3173f0bc0482(args),
        accessibleProducts: accessibleProducts,
        isJiraIssueIndexed: Boolean(configuration?.siteMetadata?.isJiraIssueIndexed),
        isRovoEnabled: Boolean(configuration?.siteMetadata?.isRovoEnabled),
        productDataRegions: $c01ed8b87fffede0$export$c635d3296555e2da(args),
        productEdition: $c01ed8b87fffede0$export$53e066a63a960439(args),
        rovoFeatures: undefined,
        thirdPartyConfigs: $c01ed8b87fffede0$export$37755e2ec7a40bc1(args),
        supportedAccessibleProducts: (0, $9NmsO.getAccessibleProducts)({
            supportedProducts: (0, $dvVWp.getAllProductKeys)(),
            accessibleProducts: accessibleProducts
        })
    };
};



const $4136576e659ad67d$var$EXTRACT_PRODUCT = /ari:cloud:(.*)?::/;
const $4136576e659ad67d$var$EMPTY_RESPONSE = [];
/**
 * Public `useFetchConfig` hook consumed by `BootstrapStoreProvider` and
 * (transitively) the rest of the search-page bootstrap pipeline.
 *
 * RAOC-22: this hook is now a thin **dispatcher** between two
 * implementations, gated by `rovo_fps_use_rovo_config`:
 *
 * The FG dispatch lives **inside** the public hook (not at the call
 * site) so that consumers see a single, stable `useFetchConfig`
 * interface and rules-of-hooks are upheld: each branch is itself a
 * hook, and the FG value is stable for the component lifetime
 * (Statsig SDK semantics).
 */ const $4136576e659ad67d$var$reportConfigCacheState = (state)=>{
    (0, $7SkLu.addUFOCustomCohortData)('configCacheState', state);
};
const $4136576e659ad67d$export$2b0ac18f7cd43e19 = (props)=>{
    // These return the same type and are like for like replacements, this is the easiest way to safely FG without generating extra network calls.
    /* eslint-disable react-hooks/rules-of-hooks */ return (0, $kh8w1.isRovoFPSUseRovoConfigEnabled)() ? $4136576e659ad67d$export$d8e38f995daf9dc5(props) : $4136576e659ad67d$export$757ae11853c85282(props);
/* eslint-enable react-hooks/rules-of-hooks */ };
const $4136576e659ad67d$export$757ae11853c85282 = ({ cloudId: cloudIdProp, configFetchAbsoluteUrl: configFetchAbsoluteUrl, aggregatorHostName: aggregatorHostName, userId: userId, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, experience: experience, activationId: activationId, preloadDataProvider: preloadDataProvider })=>{
    const supportedProducts = (0, $73Hia.useProductConfigs)();
    // Unnecessary, should be removed to save react cycles
    const [firstPartyResponse, setFirstPartyResponse] = (0, $cozmU.useState)();
    const [isConfigLoaded, setIsConfigLoaded] = (0, $cozmU.useState)(false);
    // Unnecessary, should be removed to save react cycles
    const [combinedThirdPartyResponse, setCombinedThirdPartyResponse] = (0, $cozmU.useState)({});
    // Rovo Multiple Site Search
    const [linkedCloudARIs, setLinkedCloudARIs] = (0, $cozmU.useState)(undefined);
    // Combined Config Response
    const [combinedConfigResponse, setCombinedConfigResponse] = (0, $cozmU.useState)();
    // Unnecessary, should be removed to save react cycles
    const [accessibleProductsConfig, setAccessibleProductsConfig] = (0, $cozmU.useState)({
        nouns: []
    });
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)({
        experience: experience
    });
    const [searchSessionId] = (0, $32Eau.useSearchSessionId)();
    const logException = (0, $2csHQ.useLogException)();
    const firstCloudId = (0, $cozmU.useMemo)(()=>{
        if (!cloudIdProp && firstPartyResponse) return (0, $c608e301114d7356$export$c1871fdf674a03c4)(firstPartyResponse);
        return '';
    }, [
        firstPartyResponse,
        cloudIdProp
    ]);
    const thirdPartyResponse = combinedThirdPartyResponse;
    const atlAttributionHeaders = (0, $cozmU.useMemo)(()=>(0, $AgYeH.buildAtlAttributionHeaders)({
            cloudId: cloudIdProp,
            activationId: activationId,
            product: primaryProduct
        }), [
        cloudIdProp,
        activationId,
        primaryProduct
    ]);
    // Rovo Multiple Site Search - Store linked site ARIs in state
    (0, $cozmU.useEffect)(()=>{
        const cloudId = cloudIdProp || firstCloudId;
        if (cloudId && multiSiteSearchInRovo) (0, $dv1ov.searchLinkedSitesQuery)({
            variables: {
                id: `ari:cloud:confluence::site/${cloudId}`
            },
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: atlAttributionHeaders
        }).then((response)=>{
            const edges = response?.data?.collabContext_workspaceIsConnectedToWorkspace?.edges ?? [];
            const linkedARIs = edges.map((edge)=>edge.node.id);
            // Move current cloudId to index 0 if it exists and isn't already there
            // This is a temporary solution for multiple site search in rovo with correct CloudIdARIs sequence
            const currentCloudIdARI = `ari:cloud:confluence::site/${cloudId}`;
            const currentIndex = linkedARIs.findIndex((ari)=>ari === currentCloudIdARI);
            if (currentIndex > 0) {
                // Remove from current position and add to beginning
                linkedARIs.splice(currentIndex, 1);
                linkedARIs.unshift(currentCloudIdARI);
            }
            setLinkedCloudARIs(linkedARIs);
        }).catch((error)=>{
            logException(error);
        });
    }, [
        cloudIdProp,
        firstCloudId,
        multiSiteSearchInRovo,
        logException,
        aggAbsoluteUrl,
        atlAttributionHeaders
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!firstPartyResponse) {
            if (!cloudIdProp) return;
            if (combinedThirdPartyResponse.productKeys) return;
            /**
       * Combined config caching strategy shared across both:
       * - network fetch path (`getCombinedSearchConfig`)
       * - SSR-preloaded network seed path (`seedCombinedConfigCacheEntry`)
       *
       * Strategy:
       * - refresh only when cached data is expired
       * - return cached value even if expired
       */ const combinedConfigTTL = 60000; // 1 minute
            const fetchCombinedConfig = ()=>{
                const uxTaskId = crypto.randomUUID();
                const taskStartAt = performance.now();
                const baseUXVitalStatsParams = {
                    searchSessionId: searchSessionId,
                    taskId: uxTaskId,
                    task: (0, $jTbFT.TASK_NAMES).SEARCH_PAGE_COMBINED_CONFIG_UX
                };
                // DegradedDependency may not be visible to the end-user due to request caching. This is a health metric for our BE
                const degradationCallback = (reason)=>{
                    fireAnalyticsEvent((0, $17f714e6aec73e0c$export$e98932ab9e22c265)({
                        dependency: 'search-combined-config',
                        searchSessionId: searchSessionId,
                        reason: reason,
                        source: (0, $6yu7A.EVENT_SOURCE)
                    }));
                };
                const cacheAnalyticsCallback = async (state)=>{
                    $4136576e659ad67d$var$reportConfigCacheState((0, $hCtla.toConfigCacheState)(state));
                    fireAnalyticsEvent((0, $f68f5b4eef793981$export$786813d6840571a0)({
                        requestName: 'search-combined-config',
                        searchSessionId: searchSessionId,
                        cacheHit: state.hit,
                        refreshTriggered: state.refreshTriggered,
                        source: (0, $6yu7A.EVENT_SOURCE)
                    }));
                };
                // Create network callbacks for tracking network requests
                const configNetworkTaskId = crypto.randomUUID();
                const networkCallbacks = (0, $8D0XM.createVitalStatsNetworkCallbacks)(configNetworkTaskId, (0, $jTbFT.TASK_NAMES).SEARCH_PAGE_COMBINED_CONFIG_NETWORK, searchSessionId, fireAnalyticsEvent, taskStartAt, {
                    uxTaskId: uxTaskId
                });
                const searchConfigParams = {
                    cloudId: cloudIdProp,
                    userId: userId,
                    aggAbsoluteUrl: aggAbsoluteUrl,
                    degradationCallback: degradationCallback,
                    cacheAnalyticsCallback: cacheAnalyticsCallback,
                    expiration: combinedConfigTTL,
                    returnExpired: true,
                    onlyRefreshIfExpired: true,
                    networkCallbacks: networkCallbacks,
                    headers: atlAttributionHeaders
                };
                // Fire task start for UX tracking
                fireAnalyticsEvent((0, $hnyex.onTaskStart)(baseUXVitalStatsParams));
                (0, $kQgL7.getCombinedSearchConfig)(searchConfigParams).then((configuration)=>{
                    setCombinedConfigResponse(configuration);
                    const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $bafee2afb26ee146$export$160fbca21b53d78a)(configuration, cloudIdProp);
                    setFirstPartyResponse(firstPartyConfig);
                    setCombinedThirdPartyResponse((0, $79d324e98214d5e7$export$4cb8ef4a677c563c)(thirdPartyConfig));
                    // Fire user experience metric - user got data (success from UX perspective)
                    fireAnalyticsEvent((0, $hnyex.onTaskSuccess)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                }).catch((error)=>{
                    logException(error);
                    // FailedDependency is visible to the end-user. This is a health metric for our UX
                    fireAnalyticsEvent((0, $b8d00dcc62437b77$export$7199f2d13e6ae9f7)({
                        dependency: 'search-combined-config',
                        searchSessionId: searchSessionId,
                        source: (0, $6yu7A.EVENT_SOURCE)
                    }));
                    // Fire user experience metric - user did not get data (failure from UX perspective)
                    fireAnalyticsEvent((0, $hnyex.onTaskFail)({
                        ...baseUXVitalStatsParams,
                        moreContext: {
                            error: error.name,
                            timeTaken: performance.now() - taskStartAt
                        }
                    }));
                    setFirstPartyResponse({
                        resources: [],
                        // Unused by search-page — `TSearchConfigAPIResponse` still requires the field.
                        intercomHmac: '',
                        siteMetadata: []
                    });
                    setCombinedThirdPartyResponse({
                        productKeys: $4136576e659ad67d$var$EMPTY_RESPONSE,
                        thirdPartyConfigs: {}
                    });
                });
            };
            // We skip trying to access the config from the preload provider if
            // the preload came from Quick Find. The reason for this is that the
            // combined config call will have already been cached in memory and
            // there's no reason to pipe it through the preload provider.
            let isPreloadFromQuickFind = false;
            try {
                const preloadedSearch = preloadDataProvider?.getPreloadedSearch({
                    cloudId: cloudIdProp
                });
                isPreloadFromQuickFind = Boolean(preloadedSearch && preloadedSearch.source === 'quick-find');
            } catch  {
            // Reading the preload provider should never throw, but be defensive
            // — a bad lookup must not block config loading.
            }
            if (preloadDataProvider && !isPreloadFromQuickFind) {
                try {
                    const preloadedSearch = preloadDataProvider.getPreloadedSearch({
                        cloudId: cloudIdProp
                    });
                    if (preloadedSearch && preloadedSearch.config) {
                        const preloadUxTaskId = crypto.randomUUID();
                        const preloadTaskStartAt = performance.now();
                        const preloadMoreContext = {
                            isSSREvent: true,
                            isConfigFromCache: Boolean(preloadedSearch.isConfigFromCache)
                        };
                        const preloadBaseUXVitalStatsParams = {
                            searchSessionId: searchSessionId,
                            taskId: preloadUxTaskId,
                            task: (0, $jTbFT.TASK_NAMES).SEARCH_PAGE_COMBINED_CONFIG_UX,
                            moreContext: preloadMoreContext
                        };
                        fireAnalyticsEvent((0, $hnyex.onTaskStart)(preloadBaseUXVitalStatsParams));
                        try {
                            setCombinedConfigResponse(preloadedSearch.config);
                            const { firstPartyConfig: firstPartyConfig, thirdPartyConfig: thirdPartyConfig } = (0, $bafee2afb26ee146$export$160fbca21b53d78a)(preloadedSearch.config, cloudIdProp);
                            setFirstPartyResponse(firstPartyConfig);
                            setCombinedThirdPartyResponse((0, $79d324e98214d5e7$export$4cb8ef4a677c563c)(thirdPartyConfig));
                            if (!preloadedSearch.isConfigFromCache) (0, $kQgL7.seedCombinedConfigCacheEntry)({
                                cloudId: cloudIdProp,
                                userId: userId,
                                config: preloadedSearch.config,
                                expiration: combinedConfigTTL
                            }).catch((seedError)=>{
                                logException(seedError);
                            });
                            fireAnalyticsEvent((0, $hnyex.onTaskSuccess)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            if (preloadedSearch.isConfigFromCache) // Preload gives immediate UI data, but we still run the normal combined-config
                            // path so cache TTL rules can trigger a network refresh when the entry is expired.
                            fetchCombinedConfig();
                            return; // Code smell, code is poorly structured, difficult to glean logic
                        } catch (error) {
                            logException(error);
                            fireAnalyticsEvent((0, $hnyex.onTaskFail)({
                                ...preloadBaseUXVitalStatsParams,
                                moreContext: {
                                    ...preloadMoreContext,
                                    error: error instanceof Error ? error.name : 'unknown',
                                    timeTaken: performance.now() - preloadTaskStartAt
                                }
                            }));
                            fetchCombinedConfig();
                            return; // Code smell, code is poorly structured, difficult to glean logic
                        }
                    }
                    if (preloadedSearch && !preloadedSearch.config) fireAnalyticsEvent((0, $b8d00dcc62437b77$export$7199f2d13e6ae9f7)({
                        dependency: 'search-config-ssr',
                        searchSessionId: searchSessionId,
                        source: (0, $6yu7A.EVENT_SOURCE),
                        moreContext: {
                            cacheFailReason: preloadedSearch.cacheFailReason ?? 'none',
                            configFailReason: preloadedSearch.configFailReason ?? 'none',
                            preloadPayloadWithoutConfig: true
                        }
                    }));
                    fetchCombinedConfig();
                } catch (error) {
                    logException(error);
                    fetchCombinedConfig();
                }
                return;
            }
            fetchCombinedConfig();
        }
    }, [
        firstPartyResponse,
        combinedThirdPartyResponse.productKeys,
        cloudIdProp,
        userId,
        aggAbsoluteUrl,
        logException,
        fireAnalyticsEvent,
        searchSessionId,
        atlAttributionHeaders,
        preloadDataProvider
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (thirdPartyResponse.productKeys && firstPartyResponse && !accessibleProductsConfig.products) {
            let allAccessibleProducts = [];
            const firstPartyProducts = [
                ...new Set(firstPartyResponse.resources.flatMap((resource)=>{
                    const { id: id } = resource;
                    const match = id.match($4136576e659ad67d$var$EXTRACT_PRODUCT);
                    if (match && match.length >= 2 && match[1] in supportedProducts) return [
                        match[1]
                    ];
                    return [];
                }))
            ];
            if (firstPartyProducts.length === 0 && primaryProduct) // Use the primary product if the 1P Search Config request fails
            allAccessibleProducts.push(primaryProduct);
            else allAccessibleProducts.push(...firstPartyProducts);
            // Always ensure the primary product is in the list, even if the config
            // response doesn't include it (e.g. resources only contain other products).
            // This mirrors the error fallback behavior where the primary product is
            // always available so users can search within their hosting product.
            if (primaryProduct && !allAccessibleProducts.includes(primaryProduct)) allAccessibleProducts.unshift(primaryProduct);
            // Goal and Project nouns are now returned via the first party product list in the combined config response.
            const accessibleNouns = firstPartyResponse.resources.flatMap((resource)=>{
                const { id: id } = resource;
                const match = id.match($4136576e659ad67d$var$EXTRACT_PRODUCT);
                if (match && match.length >= 2 && match[1] in (0, $kHRmO.nouns)) return [
                    match[1]
                ];
                return [];
            });
            // If nouns are available we also need to add Townsquare to the list of accessible products.
            // This way Projects will be fetched by default when no filters are selected.
            if (accessibleNouns.length > 0) allAccessibleProducts.push((0, $dvVWp.ProductKeys).Atlas);
            // with combined config, bitbucket is handled in the BE
            // Allow 3P products only if a user has Rovo enabled.
            // Long-term it won't be needed if the 3p-configuration check ensures Rovo eligibility.
            // See https://hello.atlassian.net/wiki/spaces/SEARCH/pages/4469899124.
            const doesUserHaveRovo = (0, $c608e301114d7356$export$243c13f4da40a98e)(firstPartyResponse, cloudIdProp);
            if (doesUserHaveRovo) {
                const thirdPartyProductKeys = thirdPartyResponse.productKeys || [];
                allAccessibleProducts.push(...thirdPartyProductKeys);
                setAccessibleProductsConfig({
                    products: allAccessibleProducts,
                    nouns: accessibleNouns,
                    thirdPartyConfigs: thirdPartyResponse.thirdPartyConfigs
                });
            } else setAccessibleProductsConfig({
                products: allAccessibleProducts,
                nouns: accessibleNouns,
                thirdPartyConfigs: {}
            });
            setIsConfigLoaded(true);
        }
    }, [
        thirdPartyResponse,
        firstPartyResponse,
        setAccessibleProductsConfig,
        primaryProduct,
        fireAnalyticsEvent,
        logException,
        cloudIdProp,
        accessibleProductsConfig.products,
        supportedProducts
    ]);
    const accessibleProducts = accessibleProductsConfig.products;
    const parsedConfigFromNewCombinedConfigParser = (0, $cozmU.useMemo)(()=>{
        if (primaryProduct && cloudIdProp && combinedConfigResponse) {
            const parsedCombinedConfig = (0, $c01ed8b87fffede0$export$5a5f668a90736418)({
                configuration: combinedConfigResponse,
                primaryProduct: primaryProduct,
                cloudId: cloudIdProp
            });
            return {
                ...parsedCombinedConfig,
                firstCloudId: '',
                isConfigLoaded: // cloudId must always exist when using the combined endpoint, hence we don't infer one
                isConfigLoaded,
                linkedCloudARIs: linkedCloudARIs,
                onOAuthSuccess: undefined
            };
        }
        return null;
    }, [
        primaryProduct,
        cloudIdProp,
        combinedConfigResponse,
        isConfigLoaded,
        linkedCloudARIs
    ]);
    if (parsedConfigFromNewCombinedConfigParser) return parsedConfigFromNewCombinedConfigParser;
    return {
        accessibleProducts: accessibleProducts,
        accessibleNouns: accessibleProductsConfig.nouns,
        thirdPartyConfigs: accessibleProductsConfig.thirdPartyConfigs,
        firstCloudId: firstCloudId,
        isRovoEnabled: (0, $c608e301114d7356$export$243c13f4da40a98e)(firstPartyResponse, cloudIdProp),
        isJiraIssueIndexed: (0, $c608e301114d7356$export$37c9c6a3ae5f363c)(firstPartyResponse, cloudIdProp),
        productEdition: (0, $c608e301114d7356$export$53e066a63a960439)(firstPartyResponse, cloudIdProp),
        productDataRegions: (0, $c608e301114d7356$export$c635d3296555e2da)(firstPartyResponse, cloudIdProp),
        rovoFeatures: (0, $c608e301114d7356$export$2a1c0662041ee0a3)(firstPartyResponse, cloudIdProp),
        isConfigLoaded: isConfigLoaded,
        linkedCloudARIs: linkedCloudARIs,
        onOAuthSuccess: undefined
    };
};
const $4136576e659ad67d$export$d8e38f995daf9dc5 = ({ cloudId: cloudId, primaryProduct: primaryProduct, aggAbsoluteUrl: aggAbsoluteUrl, multiSiteSearchInRovo: multiSiteSearchInRovo, preloadDataProvider: preloadDataProvider })=>{
    const rovoConfig = (0, $hCtla.useRovoConfig)({
        cloudId: cloudId,
        aggAbsoluteUrl: aggAbsoluteUrl,
        multiSiteSearchInRovo: multiSiteSearchInRovo,
        // `SearchPreloadDataProvider` (search-page) is a structural
        // superset of `RovoConfigPreloadProvider`
        // (rovo-connectors-config). Both have the same
        // `getPreloadedSearch` / `clearPreloadedSearch` contract; the
        // search-page provider just exposes more fields on
        // `SearchPreloadData` than the narrow `RovoConfigPreloadData`
        // type references.
        preloadDataProvider: preloadDataProvider,
        shouldBypassPreloadProvider: (preloaded)=>preloaded?.source === 'quick-find',
        onForgeConnectorTypeMapping: (0, $2gvXK.registerForgeConnectorTypeMapping),
        onConfigCacheState: $4136576e659ad67d$var$reportConfigCacheState
    });
    return (0, $cozmU.useMemo)(()=>{
        // `intercomHmac` is still returned by the shared rovo-connectors-config hook but
        // is no longer consumed by search-page, so it is dropped here.
        const { combinedConfigResponse: _ignored, intercomHmac: _intercomHmac, accessibleProducts: accessibleProducts, ...rest } = rovoConfig;
        const list = accessibleProducts ?? [];
        /**
     * Primary product fallback logic:
     * - If `primaryProduct` is not set or config has not loaded, do nothing (return the list as-is, even if empty).
     * - Otherwise, ensure the primary product is in the list (add it if missing).
     */ if (!primaryProduct || !rest.isConfigLoaded) return {
            ...rest,
            accessibleProducts: accessibleProducts
        };
        if (list.includes(primaryProduct)) return {
            ...rest,
            accessibleProducts: list
        };
        return {
            ...rest,
            accessibleProducts: [
                primaryProduct,
                ...list
            ]
        };
    }, [
        rovoConfig,
        primaryProduct
    ]);
};






var $ktiKH = parcelRequire("ktiKH");





var $4BJ6s = parcelRequire("4BJ6s");

const $b2f65cdcd3ba2b31$export$8a525a626086c807 = ({ children: children, experience: experience = (0, $9pcjO.SearchExperience).SEARCH_PAGE, ...props })=>{
    const { cloudId: cloudId, configFetchAbsoluteUrl: configFetchAbsoluteUrl, user: user, primaryProduct: primaryProduct, primarySubProduct: primarySubProduct, aggAbsoluteUrl: aggAbsoluteUrl, SAINHostName: SAINHostName, aggregatorHostName: aggregatorHostName, preloadDataProvider: preloadDataProvider, orgId: orgId, analyticsAttributes: analyticsAttributes, products: products, queryParams: queryParams, features: features, searchSessionId: searchSessionId, callbacks: callbacks, experimentLayers: experimentLayers, hasEditOrViewPlanPermission: hasEditOrViewPlanPermission } = props;
    const onError = (0, $2csHQ.useLogException)();
    const bootstrapProviderExp = (0, $4BJ6s.serveBootstrapProviderExp)();
    const smartLinkUsage = (0, $fq2CX.useFetchSmartLinkUsage)(experience, cloudId);
    // Under rovo-search-remove-rss-bootstrap-fg, experimentConfig is computed in StaticContextProvider
    // via getExperimentConfig. We still call useExperimentConfig unconditionally (rules of hooks) but don't
    // pass the result through initialProps on the FG-on path.
    // Keep in sync with: bootstrap-context-provider/static-context-provider/index.tsx
    const experimentConfig = (0, $3ZYG5.useExperimentConfig)({
        experimentLayers: experimentLayers ?? [],
        sideBySideExperiment: features?.sideBySide?.experiments,
        statsigLayer: undefined,
        onError: onError
    });
    // Compute multiSiteSearchInRovo independently for useFetchConfig.
    // Under FG-on, we avoid depending on experimentConfig for this value since experimentConfig
    // will be owned by StaticContextProvider. This direct Statsig call is pure and side-effect-free.
    const multiSiteSearchInRovo = (0, $4BJ6s.serveBootstrapProviderExp)() ? (0, $7zn5c.getFrontendExperiment)({
        abTestId: 'multi_site_search_in_rovo',
        onError: onError
    }).cohort === 'test' : (0, $cJff5.getMultiSiteSearchInRovo)(experimentConfig);
    const { accessibleProducts: accessibleProducts, accessibleNouns: accessibleNouns, thirdPartyConfigs: thirdPartyConfigs, firstCloudId: firstCloudId, isRovoEnabled: isRovoEnabled, isJiraIssueIndexed: isJiraIssueIndexed, productEdition: productEdition, productDataRegions: productDataRegions, rovoFeatures: rovoFeatures, isConfigLoaded: isConfigLoaded, linkedCloudARIs: linkedCloudARIs, unitMetadata: unitMetadata, onOAuthSuccess: onOAuthSuccess } = (0, $4136576e659ad67d$export$2b0ac18f7cd43e19)({
        cloudId: cloudId,
        configFetchAbsoluteUrl: configFetchAbsoluteUrl,
        aggregatorHostName: aggregatorHostName,
        preloadDataProvider: preloadDataProvider,
        userId: user?.id,
        primaryProduct: primaryProduct,
        aggAbsoluteUrl: aggAbsoluteUrl,
        multiSiteSearchInRovo: multiSiteSearchInRovo,
        experience: experience,
        activationId: analyticsAttributes?.activationId
    });
    const allFilterExcludedProducts = (0, $cozmU.useMemo)(()=>[
            (0, $dvVWp.ProductKeys).Trello,
            (0, $dvVWp.ProductKeys).Gmail,
            (0, $dvVWp.ProductKeys).OutlookMail
        ], []);
    const getInitialProps = (0, $cozmU.useCallback)(()=>{
        let storeContainerInitialProps = {
            cloudId: cloudId ?? firstCloudId,
            aggAbsoluteUrl: aggAbsoluteUrl,
            SAINHostName: SAINHostName,
            aggregatorHostName: aggregatorHostName,
            user: user,
            primaryProduct: primaryProduct,
            primarySubProduct: primarySubProduct,
            orgId: orgId,
            analyticsAttributes: analyticsAttributes,
            features: features,
            // Under rovo-search-remove-rss-bootstrap-fg, experimentConfig is computed
            // in StaticContextProvider via getExperimentConfig instead of being passed through here.
            ...!(0, $4BJ6s.serveBootstrapProviderExp)() && {
                experimentConfig: experimentConfig
            },
            experimentLayers: experimentLayers,
            isRovoEnabled: isRovoEnabled,
            isJiraIssueIndexed: isJiraIssueIndexed,
            isConfigLoaded: isConfigLoaded,
            // Under rovo-search-remove-rss-bootstrap-fg, getAccessibleProducts is computed
            // in StaticContextProvider instead of here. Pass raw products through.
            products: (0, $4BJ6s.serveBootstrapProviderExp)() ? products : (0, $9NmsO.getAccessibleProducts)({
                supportedProducts: (0, $dvVWp.getAllProductKeys)(),
                products: products,
                accessibleProducts: accessibleProducts
            }),
            nouns: accessibleNouns,
            allFilterExcludedProducts: allFilterExcludedProducts,
            productEdition: productEdition,
            productDataRegions: productDataRegions,
            rovoFeatures: rovoFeatures,
            linkedCloudARIs: linkedCloudARIs,
            unitMetadata: unitMetadata,
            hasEditOrViewPlanPermission: hasEditOrViewPlanPermission,
            smartLinkUsage: smartLinkUsage
        };
        if (searchSessionId) storeContainerInitialProps.searchSessionId = searchSessionId;
        if (accessibleProducts) storeContainerInitialProps.thirdPartyConfigs = thirdPartyConfigs;
        return storeContainerInitialProps;
    }, [
        cloudId,
        firstCloudId,
        aggAbsoluteUrl,
        SAINHostName,
        aggregatorHostName,
        user,
        primaryProduct,
        primarySubProduct,
        orgId,
        analyticsAttributes,
        features,
        experimentConfig,
        isRovoEnabled,
        isJiraIssueIndexed,
        isConfigLoaded,
        products,
        accessibleProducts,
        accessibleNouns,
        allFilterExcludedProducts,
        productEdition,
        productDataRegions,
        searchSessionId,
        thirdPartyConfigs,
        rovoFeatures,
        linkedCloudARIs,
        unitMetadata,
        experimentLayers,
        hasEditOrViewPlanPermission,
        smartLinkUsage
    ]);
    if (bootstrapProviderExp) {
        const initialProps = getInitialProps();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
            name: "bootstrap-context"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ktiKH.BootstrapContextProvider), {
            initialProps: initialProps,
            queryParams: queryParams,
            queryParamsCallback: callbacks?.updateQueryParameters,
            getSpaceIdsFromSpaceKeys: callbacks?.getSpaceIdsFromSpaceKeys,
            onSearchCompleted: callbacks?.onSearchCompleted,
            onOAuthSuccess: onOAuthSuccess,
            experience: experience,
            accessibleProducts: accessibleProducts
        }, children));
    } else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a1L5E.default), {
        name: "bootstrap-rss"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $32Eau.BootstrapStoreContainer), {
        initialProps: getInitialProps(),
        queryParams: queryParams,
        queryParamsCallback: callbacks?.updateQueryParameters,
        getSpaceIdsFromSpaceKeys: callbacks?.getSpaceIdsFromSpaceKeys,
        onSearchCompleted: callbacks?.onSearchCompleted,
        onOAuthSuccess: onOAuthSuccess
    }, children));
};
module.exports["BootstrapStoreProvider"] = $b2f65cdcd3ba2b31$export$8a525a626086c807;

});

parcelRegister("c7Prm", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $1Qme9 = parcelRequire("1Qme9");


var $6Vsfx = parcelRequire("6Vsfx");


var $32Eau = parcelRequire("32Eau");

// See [Barrel File Removal FAQ](https://hello.atlassian.net/wiki/x/KJT2aAE)
/* eslint-disable no-barrel-files/no-barrel-files */ 
var $4ysB6 = parcelRequire("4ysB6");


var $j4DTV = parcelRequire("j4DTV");


var $hjUvm = parcelRequire("hjUvm");


var $janH5 = parcelRequire("janH5");


var $01yWw = parcelRequire("01yWw");


var $cPezr = parcelRequire("cPezr");


var $cP0Ja = parcelRequire("cP0Ja");


var $2u3Wd = parcelRequire("2u3Wd");


var $bN0jv = parcelRequire("bN0jv");


var $gNxm1 = parcelRequire("gNxm1");


var $8Q2g1 = parcelRequire("8Q2g1");


var $cRSiy = parcelRequire("cRSiy");


var $a4K4k = parcelRequire("a4K4k");


var $dpRDk = parcelRequire("dpRDk");


var $7TxDU = parcelRequire("7TxDU");


var $epN5B = parcelRequire("epN5B");


var $MFQTE = parcelRequire("MFQTE");


var $kIkSt = parcelRequire("kIkSt");


var $i2Y2N = parcelRequire("i2Y2N");


var $EICUN = parcelRequire("EICUN");


var $ikbkS = parcelRequire("ikbkS");


var $5h8lq = parcelRequire("5h8lq");


var $9rMWc = parcelRequire("9rMWc");


var $AmZkX = parcelRequire("AmZkX");


var $2BHso = parcelRequire("2BHso");


var $8NYi4 = parcelRequire("8NYi4");


var $2sAXF = parcelRequire("2sAXF");


var $8BOly = parcelRequire("8BOly");


var $dkj04 = parcelRequire("dkj04");


var $5m4QA = parcelRequire("5m4QA");


var $9XbyR = parcelRequire("9XbyR");


var $1y2K1 = parcelRequire("1y2K1");


var $fV4vp = parcelRequire("fV4vp");


var $j9kbz = parcelRequire("j9kbz");


var $dhhWM = parcelRequire("dhhWM");


var $2iqMh = parcelRequire("2iqMh");


var $5gx32 = parcelRequire("5gx32");


var $fFs6O = parcelRequire("fFs6O");


var $b5q9t = parcelRequire("b5q9t");


var $jQaFd = parcelRequire("jQaFd");


var $6uMwK = parcelRequire("6uMwK");


var $4LpMn = parcelRequire("4LpMn");


var $hw9HX = parcelRequire("hw9HX");


var $hewHt = parcelRequire("hewHt");


var $lgtmw = parcelRequire("lgtmw");


var $9AliR = parcelRequire("9AliR");


var $5QRIQ = parcelRequire("5QRIQ");


var $bI3lU = parcelRequire("bI3lU");


var $clTf7 = parcelRequire("clTf7");

const $1fb49ee34de0aa72$export$d8428ac7d93fb69a = Object.freeze({
    [(0, $ikbkS.filter).id]: (0, $ikbkS.filter),
    [(0, $a4K4k.filter).id]: (0, $a4K4k.filter),
    [(0, $6uMwK.filter).id]: (0, $6uMwK.filter),
    [(0, $fFs6O.filter).id]: (0, $fFs6O.filter),
    [(0, $bI3lU.filter).id]: (0, $bI3lU.filter),
    [(0, $5QRIQ.filter).id]: (0, $5QRIQ.filter),
    [(0, $cPezr.filter).id]: (0, $cPezr.filter),
    [(0, $j9kbz.filter).id]: (0, $j9kbz.filter),
    [(0, $8Q2g1.filter).id]: (0, $8Q2g1.filter),
    [(0, $1y2K1.filter).id]: (0, $1y2K1.filter),
    [(0, $4ysB6.universalTypeFilterId)]: (0, $9AliR.filter),
    [(0, $cRSiy.filter).id]: (0, $cRSiy.filter),
    [(0, $lgtmw.filter).id]: (0, $lgtmw.filter),
    [(0, $2BHso.filter).id]: (0, $2BHso.filter),
    [(0, $dpRDk.filter).id]: (0, $dpRDk.filter),
    [(0, $EICUN.filter).id]: (0, $EICUN.filter),
    [(0, $epN5B.filter).id]: (0, $epN5B.filter),
    [(0, $MFQTE.filter).id]: (0, $MFQTE.filter),
    [(0, $8NYi4.filter).id]: (0, $8NYi4.filter),
    [(0, $j4DTV.filter).id]: (0, $j4DTV.filter),
    [(0, $5h8lq.filter).id]: (0, $5h8lq.filter),
    [(0, $4LpMn.filter).id]: (0, $4LpMn.filter),
    [(0, $hjUvm.filter).id]: (0, $hjUvm.filter),
    [(0, $janH5.filter).id]: (0, $janH5.filter),
    [(0, $01yWw.filter).id]: (0, $01yWw.filter),
    [(0, $5m4QA.filter).id]: (0, $5m4QA.filter),
    [(0, $2sAXF.filter).id]: (0, $2sAXF.filter),
    [(0, $dkj04.filter).id]: (0, $dkj04.filter),
    [(0, $9XbyR.filter).id]: (0, $9XbyR.filter),
    [(0, $8BOly.filter).id]: (0, $8BOly.filter),
    [(0, $AmZkX.filter).id]: (0, $AmZkX.filter),
    [(0, $2u3Wd.filter).id]: (0, $2u3Wd.filter),
    [(0, $bN0jv.filter).id]: (0, $bN0jv.filter),
    [(0, $7TxDU.filter).id]: (0, $7TxDU.filter),
    [(0, $cP0Ja.filter).id]: (0, $cP0Ja.filter),
    [(0, $9rMWc.filter).id]: (0, $9rMWc.filter),
    [(0, $hw9HX.filter).id]: (0, $hw9HX.filter),
    [(0, $hewHt.filter).id]: (0, $hewHt.filter),
    [(0, $jQaFd.filter).id]: (0, $jQaFd.filter),
    [(0, $5gx32.filter).id]: (0, $5gx32.filter),
    [(0, $dhhWM.filter).id]: (0, $dhhWM.filter),
    [(0, $2iqMh.filter).id]: (0, $2iqMh.filter),
    [(0, $gNxm1.filter).id]: (0, $gNxm1.filter),
    [(0, $fV4vp.filter).id]: (0, $fV4vp.filter),
    [(0, $b5q9t.filter).id]: (0, $b5q9t.filter),
    [(0, $kIkSt.filter).id]: (0, $kIkSt.filter),
    [(0, $clTf7.filter).id]: (0, $clTf7.filter),
    [(0, $i2Y2N.filter).id]: (0, $i2Y2N.filter)
});



var $1i979 = parcelRequire("1i979");

const $691d9b258a9d3e65$export$3776ece9f99ed2df = ({ children: children, experience: experience = 'search-page' })=>{
    const [shouldAutoSelectPrimaryProduct, setShouldAutoSelectPrimaryProduct] = (0, $cozmU.useState)(true);
    const intl = (0, $kSwu1.useIntl)();
    const [queryParams] = (0, $32Eau.useQueryParams)();
    const [cloudId] = (0, $32Eau.useCloudId)();
    const [aggAbsoluteUrl] = (0, $32Eau.useAggAbsoluteUrl)();
    const [initialSpaceARIs] = (0, $32Eau.useInitialSpaceARIs)();
    const [user] = (0, $32Eau.useUser)();
    const products = (0, $32Eau.useAvailableProducts)();
    const [allFilterExcludedProducts] = (0, $32Eau.useAllFilterExcludedProducts)();
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const [experimentConfig] = (0, $32Eau.useExperimentConfig)();
    const [productEdition] = (0, $32Eau.useProductEdition)();
    const [productDataRegions] = (0, $32Eau.useProductDataRegions)();
    const [thirdPartyConfigs] = (0, $32Eau.useThirdPartyConfigs)();
    const [orgId] = (0, $32Eau.useOrgId)();
    const unitMetadata = (0, $32Eau.useUnitMetadata)();
    const [analyticsAttributes] = (0, $32Eau.useAnalyticsAttributes)();
    const setQueryParams = (0, $32Eau.useSetQueryParams)(queryParams);
    const applicationMode = (0, $32Eau.useApplicationMode)();
    const primaryProductToAutoSelect = (0, $32Eau.useAutoSelectPrimaryProduct)();
    // Gates here so consumers can treat `selectedCloudIds` as already gated. The current site is
    // listed first and is always present: `buildSelectedSites` only returns sites it can find in
    // `unitMetadata`, which is empty until that metadata loads.
    const selectedCloudIds = (0, $cozmU.useMemo)(()=>[
            cloudId,
            ...(0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
                primaryProduct: primaryProduct,
                fireExperimentExposure: false
            }) ? (0, $6Vsfx.buildSelectedSites)(queryParams?.sites, unitMetadata, cloudId).keys() : []
        ].filter((id, index, all)=>Boolean(id) && all.indexOf(id) === index), [
        primaryProduct,
        queryParams?.sites,
        unitMetadata,
        cloudId
    ]);
    const config = (0, $cozmU.useMemo)(()=>({
            aggAbsoluteUrl: aggAbsoluteUrl,
            ari: '',
            cloudId: cloudId,
            selectedCloudIds: selectedCloudIds,
            experimentConfig: experimentConfig,
            initialSpaceARIs: initialSpaceARIs,
            // Default to an empty array so downstream `Array.isArray(config.contributorAccountIds)`
            // checks (in 3p Space / Content Under typeahead queries) succeed before any
            // contributor selection has been merged into the config by
            // loadInitialSelectFilterOptions / setSelectFilterLookupInput. The actions
            // downstream replace this with the live `allFiltersState.contributor.value` when a
            // contributor is selected.
            contributorAccountIds: [],
            intl: intl,
            productDataRegions: productDataRegions,
            productEdition: productEdition,
            userId: user?.id || '',
            product: queryParams?.product,
            primaryProduct: primaryProduct,
            orgId: orgId,
            thirdPartyConfigs: thirdPartyConfigs,
            unitMetadata: unitMetadata,
            activationId: analyticsAttributes?.activationId
        }), [
        aggAbsoluteUrl,
        cloudId,
        selectedCloudIds,
        experimentConfig,
        initialSpaceARIs,
        intl,
        productDataRegions,
        productEdition,
        user?.id,
        queryParams?.product,
        primaryProduct,
        orgId,
        thirdPartyConfigs,
        unitMetadata,
        analyticsAttributes?.activationId
    ]);
    const queryParamsInUse = (0, $cozmU.useMemo)(()=>{
        const { lastModified_lt: _lastModified_lt, lastModified_gt: _lastModified_gt, ...queryParamsInUse } = queryParams;
        return queryParamsInUse;
    }, [
        queryParams
    ]);
    // primaryProductToAutoSelect will be set to the primary product if the user is in unified search
    // and no product is selected
    // This is to ensure that the primary product is selected by default for unified search
    (0, $cozmU.useEffect)(()=>{
        if (products && products.length > 0) {
            if (shouldAutoSelectPrimaryProduct && primaryProductToAutoSelect) setQueryParams({
                ...queryParams,
                product: primaryProductToAutoSelect
            });
            setShouldAutoSelectPrimaryProduct(false);
        }
    }, [
        applicationMode,
        primaryProduct,
        primaryProductToAutoSelect,
        products,
        queryParams,
        setQueryParams,
        shouldAutoSelectPrimaryProduct
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1i979.SearchStoreContainer), {
        queryParams: queryParamsInUse,
        allFilters: (0, $1fb49ee34de0aa72$export$d8428ac7d93fb69a),
        config: config,
        setQueryParams: setQueryParams,
        availableProducts: products,
        allFilterExcludedProducts: allFilterExcludedProducts,
        applicationMode: applicationMode,
        primaryProduct: primaryProduct,
        thirdPartyConfigs: thirdPartyConfigs,
        experience: experience
    }, children);
};
module.exports["SearchStoreProvider"] = $691d9b258a9d3e65$export$3776ece9f99ed2df;

});

parcelRegister("j4DTV", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $6uNXh = parcelRequire("6uNXh");

const $e93dec2575cca0b8$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Confluence
];
const $e93dec2575cca0b8$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('archived');
const $e93dec2575cca0b8$export$3dea766d36a8935f = (0, $6uNXh.createBooleanFilter)({
    id: 'archived',
    queryParams: {
        key: 'archived'
    },
    products: [
        ...$e93dec2575cca0b8$var$productKeys1P,
        ...$e93dec2575cca0b8$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $e93dec2575cca0b8$export$3dea766d36a8935f;

});

parcelRegister("hjUvm", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $6uNXh = parcelRequire("6uNXh");

const $b5d9860a7c877929$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Compass
];
const $b5d9860a7c877929$export$3dea766d36a8935f = (0, $6uNXh.createBooleanFilter)({
    id: 'compassArchived',
    queryParams: {
        key: 'compassArchived'
    },
    products: $b5d9860a7c877929$var$productKeys1P,
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $b5d9860a7c877929$export$3dea766d36a8935f;

});

parcelRegister("janH5", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $cYapu = parcelRequire("cYapu");


var $AgYeH = parcelRequire("AgYeH");


var $eoapi = parcelRequire("eoapi");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

const $27ab78745da1423f$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Assets
];
const $27ab78745da1423f$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'assetsSchema',
    products: $27ab78745da1423f$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'assetsSchema',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const allSchemas = await (0, $eoapi.assetsSchemasQuery)(queryParams, headers);
            const hydratedSchemaOptions = allSchemas.data?.assets_schemasByIds?.map((schema)=>{
                return {
                    trackingKey: schema.id,
                    value: schema.id,
                    queryParamValue: schema.id,
                    label: (0, $iDrrr.fg)('cdm_ga') ? schema.displayName || '' : schema.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false,
                    metadata: {
                        internalName: schema.name
                    }
                };
            });
            return hydratedSchemaOptions ?? [];
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            const suggestedSchemas = await (0, $cYapu.searchAssetsSchemas)();
            const recommendedSchemaOptions = suggestedSchemas.map((schema)=>{
                return {
                    trackingKey: schema.ari,
                    value: schema.ari,
                    queryParamValue: schema.ari,
                    label: (0, $iDrrr.fg)('cdm_ga') ? schema.displayName || '' : schema.name || '',
                    product: config.product,
                    isSuggested: true,
                    isSelected: false,
                    metadata: {
                        internalName: schema.name
                    }
                };
            });
            return recommendedSchemaOptions;
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            const resultSchemas = await (0, $cYapu.searchAssetsSchemas)(query);
            const searchSchemaOptions = resultSchemas.map((schema)=>{
                return {
                    trackingKey: schema.ari,
                    value: schema.ari,
                    queryParamValue: schema.ari,
                    label: (0, $iDrrr.fg)('cdm_ga') ? schema.displayName || '' : schema.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false,
                    metadata: {
                        internalName: schema.name
                    }
                };
            });
            return searchSchemaOptions;
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $dvVWp.ProductKeys).Assets
});
module.exports["filter"] = $27ab78745da1423f$export$3dea766d36a8935f;

});

parcelRegister("cYapu", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");


var $bZF61 = parcelRequire("bZF61");


var $fyjce = parcelRequire("fyjce");

const $1f1da1a2d0d7fbde$export$3317731fce42efc4 = 'assets-workspace-id';
const { refreshOnAccessDecorator: $1f1da1a2d0d7fbde$var$refreshOnAccessDecoratorAssets } = (0, $fyjce.promiseCache)({
    name: $1f1da1a2d0d7fbde$export$3317731fce42efc4,
    expiration: 86400000 // 24 hours
});
async function $1f1da1a2d0d7fbde$export$7397855f2e1b36a6() {
    const url = '/rest/servicedesk/cmdb/latest/workspace';
    const options = {
        requestInit: {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }
    };
    const key = (0, $bZF61.generateHash)($1f1da1a2d0d7fbde$export$3317731fce42efc4);
    const supplier = ()=>(0, $gABt9.utils).requestService({
            url: url
        }, options);
    const response = await $1f1da1a2d0d7fbde$var$refreshOnAccessDecoratorAssets({
        key: key.toString(),
        supplier: supplier,
        returnExpired: false,
        onlyRefreshIfExpired: true
    });
    const ids = response.results ?? [];
    return ids.length ? ids[0].id : null;
}
async function $1f1da1a2d0d7fbde$export$54126e20e262ab6a(query = '', maxResults = 3) {
    const workspaceId = await $1f1da1a2d0d7fbde$export$7397855f2e1b36a6();
    if (!workspaceId) // returning empty array as fallback
    return [];
    const url = `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/objectschema/list?maxResults=${maxResults}&includeCounts=false${query ? `&query=${query}` : ''}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const responseData = await response.json();
        const schemas = responseData.values ?? [];
        const transformedSchemas = schemas.map((schema)=>({
                ...schema,
                schemaLabel: schema.name,
                ari: `ari:cloud:cmdb::schema/${workspaceId}/${schema.id}`
            }));
        return transformedSchemas;
    } catch (error) {
        // fire analytics event
        return [];
    }
}
async function $1f1da1a2d0d7fbde$export$ba9ddace9845bd14(query = '', maxResults = 3) {
    const workspaceId = await $1f1da1a2d0d7fbde$export$7397855f2e1b36a6();
    if (!workspaceId) // returning empty array as fallback
    return [];
    const url = `/gateway/api/jsm/assets/workspace/${workspaceId}/v1/objecttype/all/list?pageSize=${maxResults}${query ? `&filterBy=${query}` : ''}`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const responseData = await response.json();
        const types = responseData.data ?? [];
        const transformedTypes = types.map((type)=>({
                ...type,
                ari: `ari:cloud:cmdb::type/${workspaceId}/${type.id}`
            }));
        return transformedTypes;
    } catch (error) {
        // fire analytics event
        return [];
    }
}
module.exports["searchAssetsSchemas"] = $1f1da1a2d0d7fbde$export$54126e20e262ab6a;
module.exports["searchAssetsTypes"] = $1f1da1a2d0d7fbde$export$ba9ddace9845bd14;

});

parcelRegister("eoapi", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $1d9e251b755db171$var$GQL_ASSETS_SCHEMAS_NAME = 'SearchPageAssetsSchemasQuery';
const $1d9e251b755db171$var$getAssetsSchemasQueryString = ()=>`query ${$1d9e251b755db171$var$GQL_ASSETS_SCHEMAS_NAME}(
	$schemaARIs: [ID!]!) {
		assets_schemasByIds(ids: $schemaARIs) {
    		id
    		key
    		name
    		${(0, $iDrrr.fg)('cdm_ga') ? 'displayName' : ''}
    		sequentialId @optIn(to: "AssetsApFields")
  		}
	}`;
const $1d9e251b755db171$export$2ab52cbd1429b72b = (0, $bHHWv.inMemoryCache)();
const $1d9e251b755db171$export$3c3ad61134eb56ad = async (schemaARIs, headers)=>{
    return $1d9e251b755db171$export$2ab52cbd1429b72b.inMemoryDecorator(`${schemaARIs}`, async ()=>{
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $1d9e251b755db171$var$getAssetsSchemasQueryString(),
            variables: {
                schemaARIs: schemaARIs
            },
            headers: {
                'X-ExperimentalApi': 'AssetsSchemas',
                ...headers
            }
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["assetsSchemasQuery"] = $1d9e251b755db171$export$3c3ad61134eb56ad;

});

parcelRegister("01yWw", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $cYapu = parcelRequire("cYapu");


var $AgYeH = parcelRequire("AgYeH");


var $92z1S = parcelRequire("92z1S");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

const $5035981be15551ae$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Assets
];
const $5035981be15551ae$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'assetsType',
    products: $5035981be15551ae$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'assetsType',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const allTypes = await (0, $92z1S.assetsObjectTypesQuery)(queryParams, headers);
            const hydratedTypeOptions = allTypes.data?.assets_objectTypesByIds?.map((type)=>{
                return {
                    trackingKey: type.id,
                    value: type.id,
                    queryParamValue: type.id,
                    label: (0, $iDrrr.fg)('cdm_ga') ? type.displayName || '' : type.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false,
                    avatarUrl: type.icon.url16,
                    metadata: {
                        schemaName: (0, $iDrrr.fg)('cdm_ga') ? type.schema.displayName || '' : type.schema.name,
                        internalName: type.name,
                        schemaInternalName: type.schema.name
                    }
                };
            });
            return hydratedTypeOptions ?? [];
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            const suggestedTypes = await (0, $cYapu.searchAssetsTypes)();
            const recommendedTypeOptions = suggestedTypes.map((type)=>{
                return {
                    trackingKey: type.ari,
                    value: type.ari,
                    queryParamValue: type.ari,
                    label: (0, $iDrrr.fg)('cdm_ga') ? type.displayName || '' : type.name || '',
                    product: config.product,
                    isSuggested: true,
                    isSelected: false,
                    avatarUrl: type.icon.url16,
                    metadata: {
                        schemaName: (0, $iDrrr.fg)('cdm_ga') ? type.schemaDisplayLabel || '' : type.schemaLabel,
                        internalName: type.name,
                        schemaInternalName: type.schemaLabel
                    }
                };
            });
            return recommendedTypeOptions;
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            const resultTypes = await (0, $cYapu.searchAssetsTypes)(query);
            const searchTypeOptions = resultTypes.map((type)=>{
                return {
                    trackingKey: type.ari,
                    value: type.ari,
                    queryParamValue: type.ari,
                    label: (0, $iDrrr.fg)('cdm_ga') ? type.displayName || '' : type.name || '',
                    product: config.product,
                    isSuggested: false,
                    isSelected: false,
                    avatarUrl: type.icon.url16,
                    metadata: {
                        schemaName: (0, $iDrrr.fg)('cdm_ga') ? type.schemaDisplayLabel || '' : type.schemaLabel,
                        internalName: type.name,
                        schemaInternalName: type.schemaLabel
                    }
                };
            });
            return searchTypeOptions;
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $dvVWp.ProductKeys).Assets
});
module.exports["filter"] = $5035981be15551ae$export$3dea766d36a8935f;

});

parcelRegister("92z1S", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $1aee25a5ef1bf06f$var$GQL_ASSETS_OBJECT_TYPES_NAME = 'SearchPageAssetsObjectTypesQuery';
const $1aee25a5ef1bf06f$var$getAssetsObjectTypesQueryString = ()=>`query ${$1aee25a5ef1bf06f$var$GQL_ASSETS_OBJECT_TYPES_NAME}(
	$objectTypeARIs: [ID!]!) {
		assets_objectTypesByIds(ids: $objectTypeARIs) {
    		id
    		name
    		${(0, $iDrrr.fg)('cdm_ga') ? 'displayName' : ''}
    		sequentialId @optIn(to: "AssetsApFields")
    		icon {
      			url16
    		}
    		schema {
      			name
      			${(0, $iDrrr.fg)('cdm_ga') ? 'displayName' : ''}
    		}
  		}
	}`;
const $1aee25a5ef1bf06f$export$4b370fc8e83d008b = (0, $bHHWv.inMemoryCache)();
const $1aee25a5ef1bf06f$export$b573ef4e7e3425c7 = async (objectTypeARIs, headers)=>{
    return $1aee25a5ef1bf06f$export$4b370fc8e83d008b.inMemoryDecorator(`${objectTypeARIs}`, async ()=>{
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $1aee25a5ef1bf06f$var$getAssetsObjectTypesQueryString(),
            variables: {
                objectTypeARIs: objectTypeARIs
            },
            operationName: $1aee25a5ef1bf06f$var$GQL_ASSETS_OBJECT_TYPES_NAME,
            headers: {
                'X-ExperimentalApi': 'AssetsObjectTypes',
                ...headers
            }
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["assetsObjectTypesQuery"] = $1aee25a5ef1bf06f$export$b573ef4e7e3425c7;

});

parcelRegister("cPezr", function(module, exports) {

var $99hPJ = parcelRequire("99hPJ");


var $AgYeH = parcelRequire("AgYeH");


var $fCd3b = parcelRequire("fCd3b");


var $6Zvcd = parcelRequire("6Zvcd");


var $j5Usq = parcelRequire("j5Usq");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $82ADO = parcelRequire("82ADO");


var $3e0Ll = parcelRequire("3e0Ll");

const $50410043a9055ce6$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $50410043a9055ce6$var$loadInitialOptions = async (config)=>{
    if (config.product === (0, $dvVWp.ProductKeys).JiraDC || config.product === (0, $dvVWp.ProductKeys).JsmDC) return (0, $3e0Ll.loadRecommendedUsers)(config);
    return $50410043a9055ce6$var$searchJiraCloudAssignee('', config, {
        initialOptions: true
    });
};
const $50410043a9055ce6$var$searchAssignee = async (query, config)=>{
    if (config.product === (0, $dvVWp.ProductKeys).JiraDC || config.product === (0, $dvVWp.ProductKeys).JsmDC) return $50410043a9055ce6$var$searchAssignees3P(query, config);
    return $50410043a9055ce6$var$searchJiraCloudAssignee(query, config);
};
const $50410043a9055ce6$var$searchAssignees3P = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const response = await (0, $99hPJ.getAssignees)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: (0, $82ADO.getUrsProductKey)(config.primaryProduct),
        maxNumberOfResults: $50410043a9055ce6$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((assignee)=>({
            trackingKey: assignee.id,
            value: assignee.id,
            label: assignee.name,
            avatarUrl: assignee.avatarUrl,
            queryParamValue: assignee.id,
            product: config.product
        }));
};
const $50410043a9055ce6$var$searchJiraCloudAssignee = async (query, config, options)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialUsersQuery = config.userId && options?.initialOptions ? (0, $j5Usq.usersQuery)([
        config.userId
    ], headers) : Promise.resolve({
        data: {
            users: []
        }
    });
    const searchClient = (0, $fCd3b.createClient)({
        cloudId: config.cloudId || ''
    });
    const searchAssigneeQuery = searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $6Zvcd.Scope).People
        ],
        // Omitted for a single site so those requests stay unchanged.
        ...(config.selectedCloudIds?.length ?? 0) > 1 ? {
            sites: config.selectedCloudIds
        } : {},
        analytics: {
            identifier: 'search-page'
        }
    });
    const [initialUsersResponse, searchAssigneeReponse] = await Promise.all([
        initialUsersQuery,
        searchAssigneeQuery
    ]);
    const searchAssigneeResults = searchAssigneeReponse.response.rawData.scopes[0]?.results ?? [];
    const allAssignees = [
        // The current user is always first
        ...initialUsersResponse.data?.users.map((user)=>({
                ...user,
                id: user.accountId
            })) ?? [],
        ...searchAssigneeResults.map((user)=>({
                picture: user.avatarUrl,
                name: user.name,
                id: user.id,
                accountId: user.id
            }))
    ];
    const userIds = new Set();
    const assigneeOptions = allAssignees.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
    .map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId,
            product: config.product
        }));
    return assigneeOptions;
};
const $50410043a9055ce6$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Jira,
    (0, $dvVWp.ProductKeys).JiraProductDiscovery,
    (0, $dvVWp.ProductKeys).JiraServiceManagement
];
const $50410043a9055ce6$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('assignee');
const $50410043a9055ce6$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'assignee',
    products: [
        ...$50410043a9055ce6$var$productKeys1P,
        ...$50410043a9055ce6$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'jAssignee',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $j5Usq.usersQuery)(queryParams, headers);
            const allAssignees = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const assigneeOptions = allAssignees.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return assigneeOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $50410043a9055ce6$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $50410043a9055ce6$var$searchAssignee(query, config);
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $dvVWp.ProductKeys).Jira || primaryProduct === (0, $dvVWp.ProductKeys).JiraDC || primaryProduct === (0, $dvVWp.ProductKeys).JsmDC || primaryProduct === (0, $dvVWp.ProductKeys).JiraServiceManagement || primaryProduct === (0, $dvVWp.ProductKeys).JiraProductDiscovery
});
module.exports["filter"] = $50410043a9055ce6$export$3dea766d36a8935f;

});

parcelRegister("99hPJ", function(module, exports) {

var $b9heI = parcelRequire("b9heI");

const $b15045c6e382f404$export$83f72e15d115a0e7 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'assignee',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $b9heI.default)(requestParams, intl);
};
module.exports["getAssignees"] = $b15045c6e382f404$export$83f72e15d115a0e7;

});

parcelRegister("j5Usq", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $697023b8b47eb551$export$69a3209f1a06c04d = (0, $bHHWv.inMemoryCache)();
const $697023b8b47eb551$var$GQL_OPERATION_NAME = 'SearchPageUserQuery';
const $697023b8b47eb551$var$getUserQuery = ()=>`
query ${$697023b8b47eb551$var$GQL_OPERATION_NAME}($accountId: ID!) {
  user(accountId: $accountId) {
    id
    accountId
    name
    picture
  }
}
`;
const $697023b8b47eb551$export$25f4d46d5dabadfc = (accountId, headers)=>{
    return $697023b8b47eb551$export$69a3209f1a06c04d.inMemoryDecorator(accountId, async ()=>{
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $697023b8b47eb551$var$getUserQuery(),
            variables: {
                accountId: accountId
            },
            operationName: $697023b8b47eb551$var$GQL_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
const $697023b8b47eb551$export$c3d7afa7f49d431e = (0, $bHHWv.inMemoryCache)();
const $697023b8b47eb551$var$GQL_USERS_OPERATION_NAME = 'SearchPageUsersQuery';
const $697023b8b47eb551$var$getUsersQuery = ()=>`
query ${$697023b8b47eb551$var$GQL_USERS_OPERATION_NAME}($accountIds: [ID!]!) {
  users(accountIds: $accountIds) {
    id
    name
    picture
    accountId
  }
}
`;
const $697023b8b47eb551$export$ef7fb495aeba8901 = (accountIds, headers)=>{
    return $697023b8b47eb551$export$c3d7afa7f49d431e.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per user id
    accountIds.join(','), async ()=>{
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $697023b8b47eb551$var$getUsersQuery(),
            variables: {
                accountIds: accountIds
            },
            operationName: $697023b8b47eb551$var$GQL_USERS_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["usersQuery"] = $697023b8b47eb551$export$ef7fb495aeba8901;

});

parcelRegister("6yWnN", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bZF61 = parcelRequire("bZF61");


var $bHHWv = parcelRequire("bHHWv");

const $8bbf0973c124500e$var$operationName = 'FPSConfluenceSmartUsersQuery';
const $8bbf0973c124500e$var$SmartsRecommendedUserQuery = `
query ${$8bbf0973c124500e$var$operationName}($userId: String!, $tenantId: String!, $maxNumberOfResults: Int!) {
  smarts {
    results: recommendedUser(
      recommendationsQuery: {
        context: {
          userId: $userId
          tenantId: $tenantId
          product: "confluence"
        },
        modelRequestParams: {
          caller: "full-page-search"
          experience: "CgUserNearbyUser"
        }
        requestingUserId: $userId
        maxNumberOfResults: $maxNumberOfResults
      }
    ) {
      id
      user {
        accountId
        name
        picture
      }
    }
  }
}
`;
const $8bbf0973c124500e$export$69a3209f1a06c04d = (0, $bHHWv.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $8bbf0973c124500e$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    const { results: results } = data.smarts;
    return !results || results.length === 0;
};
const $8bbf0973c124500e$export$74adda2a74e06fa9 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>$8bbf0973c124500e$export$69a3209f1a06c04d.inMemoryDecorator((0, $bZF61.generateHashFromVariables)(variables), ()=>(0, $b0Mpu.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $8bbf0973c124500e$var$SmartsRecommendedUserQuery,
            operationName: $8bbf0973c124500e$var$operationName,
            headers: headers
        }), $8bbf0973c124500e$var$expireWhen);
module.exports["smartsRecommendedUserQuery"] = $8bbf0973c124500e$export$74adda2a74e06fa9;

});

parcelRegister("cP0Ja", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $2205c26033fd60d7$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $2205c26033fd60d7$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('calendarType');
const $2205c26033fd60d7$var$calendarTypeProducts = Array.from(new Set([
    ...$2205c26033fd60d7$var$salesforceProducts,
    ...$2205c26033fd60d7$var$products3PFromConfig
]));
const $2205c26033fd60d7$var$fetchDynamicCalendarTypeOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const eventTypes = result.filters.find((f)=>f.name === 'eventTypes');
        if (!eventTypes || eventTypes.values.length === 0) return [];
        return eventTypes.values.map((eventType)=>({
                value: eventType.name,
                trackingKey: eventType.name,
                queryParamValue: eventType.name,
                isDefault: false,
                label: eventType.label ?? eventType.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch (e) {
        return [];
    }
};
const $2205c26033fd60d7$var$fetchCalendarTypeOptions = async (config)=>{
    return $2205c26033fd60d7$var$fetchDynamicCalendarTypeOptions(config);
};
const $2205c26033fd60d7$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $2205c26033fd60d7$var$fetchCalendarTypeOptions(config);
    const selected = new Set(queryParams);
    const result = allOptions.filter((option)=>selected.has(option.queryParamValue));
    return result;
};
const $2205c26033fd60d7$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'calendarType',
    requiresTopLevel3PDatasource: true,
    products: $2205c26033fd60d7$var$calendarTypeProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'eventTypes',
        fetcher: async (queryParams, config)=>{
            return $2205c26033fd60d7$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $2205c26033fd60d7$var$fetchCalendarTypeOptions(config);
        }
    }
});
module.exports["filter"] = $2205c26033fd60d7$export$3dea766d36a8935f;

});

parcelRegister("dYKlp", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");

const $43211b550670686b$export$c5dfc39e7764783c = 'searchThirdPartyFilterOptions';
const $43211b550670686b$export$417982613a1b9ae2 = `
query ${$43211b550670686b$export$c5dfc39e7764783c}($cloudId: ID!, $datasourceId: String!, $orgId: String) {
  search {
    configuration(cloudId: $cloudId) {
      thirdPartyFilterOptions(datasourceId: $datasourceId, orgId: $orgId) {
        filters {
          name
          values {
            name
            label
          }
        }
      }
    }
  }
}`;
const $43211b550670686b$export$cbfaf396d242dba9 = ()=>$43211b550670686b$export$417982613a1b9ae2;


const $06d01c2d88ae5cdf$export$cd224500ea4a2de1 = async ({ cloudId: cloudId, datasourceId: datasourceId, orgId: orgId, aggAbsoluteUrl: aggAbsoluteUrl })=>{
    try {
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: (0, $43211b550670686b$export$cbfaf396d242dba9)(),
            variables: {
                cloudId: cloudId,
                datasourceId: datasourceId,
                orgId: orgId != null && orgId !== '' ? orgId : null
            },
            operationName: (0, $43211b550670686b$export$c5dfc39e7764783c),
            aggAbsoluteUrl: aggAbsoluteUrl
        });
        const filterOptions = response.data?.search?.configuration?.thirdPartyFilterOptions ?? null;
        if (response.errors?.length) {
            console.warn(`[${(0, $43211b550670686b$export$c5dfc39e7764783c)}] GraphQL errors for datasource "${datasourceId}":`, response.errors);
            if (!filterOptions) throw new Error(`[${(0, $43211b550670686b$export$c5dfc39e7764783c)}] GraphQL errors prevented loading third-party filter options for datasource "${datasourceId}"`);
        }
        return filterOptions;
    } catch (error) {
        console.error(`[${(0, $43211b550670686b$export$c5dfc39e7764783c)}] Failed to fetch third-party filter options for datasource "${datasourceId}":`, error);
        throw error;
    }
};
module.exports["getThirdPartyFilterOptions"] = $06d01c2d88ae5cdf$export$cd224500ea4a2de1;

});

parcelRegister("2u3Wd", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $691ecec8618d84b5$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $691ecec8618d84b5$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('campaignStatus');
const $691ecec8618d84b5$var$campaignStatusProducts = Array.from(new Set([
    ...$691ecec8618d84b5$var$salesforceProducts,
    ...$691ecec8618d84b5$var$products3PFromConfig
]));
const $691ecec8618d84b5$var$fetchDynamicCampaignStatusOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const campaignStatuses = result.filters.find((f)=>f.name === 'campaignStatuses');
        if (!campaignStatuses || campaignStatuses.values.length === 0) return [];
        return campaignStatuses.values.map((status)=>({
                value: status.name,
                trackingKey: status.name,
                queryParamValue: status.name,
                isDefault: false,
                label: status.label ?? status.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch  {
        return [];
    }
};
const $691ecec8618d84b5$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $691ecec8618d84b5$var$fetchDynamicCampaignStatusOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $691ecec8618d84b5$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'campaignStatus',
    requiresTopLevel3PDatasource: true,
    products: $691ecec8618d84b5$var$campaignStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'campaignStatuses',
        fetcher: async (queryParams, config)=>{
            return $691ecec8618d84b5$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $691ecec8618d84b5$var$fetchDynamicCampaignStatusOptions(config);
        }
    }
});
module.exports["filter"] = $691ecec8618d84b5$export$3dea766d36a8935f;

});

parcelRegister("bN0jv", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $3296e6ecef6e4ed3$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $3296e6ecef6e4ed3$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('caseStatus');
const $3296e6ecef6e4ed3$var$caseStatusProducts = Array.from(new Set([
    ...$3296e6ecef6e4ed3$var$salesforceProducts,
    ...$3296e6ecef6e4ed3$var$products3PFromConfig
]));
const $3296e6ecef6e4ed3$var$fetchDynamicCaseStatusOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const caseStatuses = result.filters.find((f)=>f.name === 'caseStatuses');
        if (!caseStatuses || caseStatuses.values.length === 0) return [];
        return caseStatuses.values.map((status)=>({
                value: status.name,
                trackingKey: status.name,
                queryParamValue: status.name,
                isDefault: false,
                label: status.label ?? status.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch  {
        return [];
    }
};
const $3296e6ecef6e4ed3$var$fetchCaseStatusOptions = async (config)=>{
    return $3296e6ecef6e4ed3$var$fetchDynamicCaseStatusOptions(config);
};
const $3296e6ecef6e4ed3$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $3296e6ecef6e4ed3$var$fetchCaseStatusOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $3296e6ecef6e4ed3$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'caseStatus',
    requiresTopLevel3PDatasource: true,
    products: $3296e6ecef6e4ed3$var$caseStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'caseStatuses',
        fetcher: async (queryParams, config)=>{
            return $3296e6ecef6e4ed3$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $3296e6ecef6e4ed3$var$fetchCaseStatusOptions(config);
        }
    }
});
module.exports["filter"] = $3296e6ecef6e4ed3$export$3dea766d36a8935f;

});

parcelRegister("gNxm1", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $m6ow8 = parcelRequire("m6ow8");


var $kSwu1 = parcelRequire("kSwu1");

const $e1d34701a254563e$export$95ac8a541f7029bb = (0, $kSwu1.defineMessages)({
    anytime: {
        id: "search-page.filter.close.date.anytime",
        defaultMessage: "Anytime"
    },
    today: {
        id: "search-page.filter.close.date.today",
        defaultMessage: "Today"
    },
    last7days: {
        id: "search-page.filter.close.date.last7days",
        defaultMessage: "Last 7 days"
    },
    last30days: {
        id: "search-page.filter.close.date.last30days",
        defaultMessage: "Last 30 days"
    },
    last90days: {
        id: "search-page.filter.close.date.last90days",
        defaultMessage: "Last 90 days"
    },
    last365days: {
        id: "search-page.filter.close.date.last365days",
        defaultMessage: "Last 365 days"
    },
    next7days: {
        id: "search-page.filter.close.date.next7days",
        defaultMessage: "Next 7 days"
    },
    next30days: {
        id: "search-page.filter.close.date.next30days",
        defaultMessage: "Next 30 days"
    },
    next90days: {
        id: "search-page.filter.close.date.next90days",
        defaultMessage: "Next 90 days"
    },
    next365days: {
        id: "search-page.filter.close.date.next365days",
        defaultMessage: "Next 365 days"
    },
    custom: {
        id: "search-page.filter.close.date.custom",
        defaultMessage: "Specific date"
    }
});


const $22e8bbe85fc9ffba$var$CLOSE_DATE_VALUES = [
    'anytime',
    'today',
    'last7days',
    'last30days',
    'last90days',
    'last365days',
    'next7days',
    'next30days',
    'next90days',
    'next365days',
    'custom'
];
const $22e8bbe85fc9ffba$var$isIsoDate = (str)=>{
    if (!str) return false;
    if (!/\d{4}-\d{2}-\d{2}/.test(str)) return false;
    const d = new Date(str);
    return !isNaN(d.getTime());
};
const $22e8bbe85fc9ffba$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $22e8bbe85fc9ffba$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('closeDate');
const $22e8bbe85fc9ffba$var$closeDateProducts = Array.from(new Set([
    ...$22e8bbe85fc9ffba$var$salesforceProducts,
    ...$22e8bbe85fc9ffba$var$products3PFromConfig
]));
const $22e8bbe85fc9ffba$export$3dea766d36a8935f = (0, $m6ow8.createSingleWithCustomOptionSelectFilter)({
    id: 'closeDate',
    products: $22e8bbe85fc9ffba$var$closeDateProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'closeDate',
        fetcher: async (values, config)=>{
            return $22e8bbe85fc9ffba$var$CLOSE_DATE_VALUES.filter((value)=>values.includes(value)).map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $e1d34701a254563e$export$95ac8a541f7029bb)[value]) || (0, $e1d34701a254563e$export$95ac8a541f7029bb)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        },
        customValueParser: (queryParams)=>{
            const { closeDateVal: closeDateVal } = queryParams;
            const isDateValid = $22e8bbe85fc9ffba$var$isIsoDate(closeDateVal?.[0]);
            const dateVal = isDateValid && closeDateVal?.[0] ? closeDateVal[0] : '';
            if (dateVal) return {
                closeDateVal: dateVal
            };
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $22e8bbe85fc9ffba$var$CLOSE_DATE_VALUES.map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $e1d34701a254563e$export$95ac8a541f7029bb)[value]) || (0, $e1d34701a254563e$export$95ac8a541f7029bb)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        }
    },
    customValueFields: [
        'closeDateVal'
    ]
});
module.exports["filter"] = $22e8bbe85fc9ffba$export$3dea766d36a8935f;

});

parcelRegister("8Q2g1", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $6uNXh = parcelRequire("6uNXh");

const $600b0700f5709c84$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Jira,
    (0, $dvVWp.ProductKeys).JiraProductDiscovery,
    (0, $dvVWp.ProductKeys).JiraServiceManagement
];
const $600b0700f5709c84$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('commentedByMe');
const $600b0700f5709c84$export$3dea766d36a8935f = (0, $6uNXh.createBooleanFilter)({
    id: 'commentedByMe',
    queryParams: {
        key: 'jCommentedByMe'
    },
    products: [
        ...$600b0700f5709c84$var$productKeys1P,
        ...$600b0700f5709c84$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $600b0700f5709c84$export$3dea766d36a8935f;

});

parcelRegister("cRSiy", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $AgYeH = parcelRequire("AgYeH");


var $e6Tv8 = parcelRequire("e6Tv8");


var $evHnc = parcelRequire("evHnc");


var $dv1ov = parcelRequire("dv1ov");


var $S6W9B = parcelRequire("S6W9B");


var $gByuu = parcelRequire("gByuu");


var $7Ag9o = parcelRequire("7Ag9o");


var $fOh5X = parcelRequire("fOh5X");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $kZdMI = parcelRequire("kZdMI");

const $421fbacd3d5c29a7$var$getContentId = (ari)=>{
    const EXTRACT_ID = /ari:.*?:.*?:.*?:.*?\/(.*)?.*/;
    const matches = ari.match(EXTRACT_ID);
    // content id of the ari
    return matches && matches.length > 1 ? matches[1] : '';
};
const $421fbacd3d5c29a7$var$searchContent = async (query, config)=>{
    const location = `ari:cloud:confluence::site/${config.cloudId}`;
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const product = config.product;
    const selectedSpaceAris = $421fbacd3d5c29a7$var$getSelectedSpaceAris(config);
    if ($421fbacd3d5c29a7$var$isThirdPartyProductWithContentUnder(product)) {
        const selectedSpaceAri = selectedSpaceAris[0];
        const datasource = config.selectedDatasource ?? config.thirdPartyConfigs?.[product];
        if (!datasource?.integrationAri) return [];
        const spaceFilter = selectedSpaceAri ? {
            ancestorAris: [
                selectedSpaceAri
            ]
        } : {};
        const contributorAccountIds = (0, $iDrrr.fg)('rovo_fps_scope_3p_typeahead_by_contributor') ? $421fbacd3d5c29a7$var$getSelectedContributorAccountIds(config) : [];
        const commonFilters = contributorAccountIds.length > 0 ? {
            contributorsFilter: contributorAccountIds
        } : undefined;
        const response = await (0, $evHnc.searchEntitiesQuery)({
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            variables: {
                query: query,
                first: 10,
                experience: 'search-page',
                filters: {
                    entities: (0, $fOh5X.DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI),
                    locations: [
                        location
                    ],
                    ...commonFilters && {
                        commonFilters: commonFilters
                    },
                    thirdPartyFilters: {
                        titleMatchOnly: true,
                        ...spaceFilter,
                        thirdPartyProducts: [
                            {
                                product: product,
                                integrationId: datasource.integrationAri,
                                subtypes: $421fbacd3d5c29a7$var$getThirdPartyContentUnderSubtypes(product)
                            }
                        ]
                    }
                }
            },
            headers: headers,
            includeContainerId: true
        });
        const results = response.data?.search?.results.edges.map((content)=>{
            // Access entity.containerId for cross-filter validation (folder belongs to which drive/space)
            const containerId = content.node.entity?.containerId;
            const option = {
                trackingKey: content.node.id,
                value: content.node.id,
                label: content.node.title,
                queryParamValue: content.node.id,
                product: config.product,
                ...containerId && {
                    metadata: {
                        containerARI: containerId
                    }
                }
            };
            return option;
        }) || [];
        return results;
    }
    let contentPagesResponse;
    if (product === (0, $dvVWp.ProductKeys).ConfluenceDC) {
        contentPagesResponse = await (0, $dv1ov.confluenceDcContentFilterOptionsQuery)({
            variables: {
                query: query,
                cloudIdARI: location,
                limit: 10,
                entities: [
                    'ati:cloud:graph:document'
                ],
                product: product
            },
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            headers: headers
        });
        return contentPagesResponse.data?.search?.search?.edges.map((content)=>({
                trackingKey: content.node.id,
                value: content.node.id,
                label: (0, $7Ag9o.cleanExcerpt)(content.node.title),
                queryParamValue: content.node.id,
                product: config.product
            })) || [];
    }
    // `locations` is already an array on the backend, so every selected site is read in one query
    // instead of fanning out per site.
    const [currentCloudId = '', ...additionalCloudIds] = config.selectedCloudIds ?? [];
    const locations = (0, $S6W9B.getCloudIdARIs)(currentCloudId, config.primaryProduct, additionalCloudIds);
    contentPagesResponse = await (0, $evHnc.searchEntitiesQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            query: query,
            first: 10,
            filters: {
                entities: [
                    'ati:cloud:confluence:page'
                ],
                locations: locations
            }
        },
        headers: headers
    });
    const allContentPages = contentPagesResponse.data?.search?.results.edges.map((content)=>({
            title: content.node.title,
            id: content.node.id
        })) || [];
    const contentOptions = allContentPages.map((content)=>{
        const contentId = $421fbacd3d5c29a7$var$getContentId(content.id);
        return {
            trackingKey: contentId,
            value: contentId,
            label: content.title,
            queryParamValue: contentId,
            product: config.product
        };
    });
    // Page ids are only unique within a site, and the selection is sent downstream as a plain
    // `ancestorIdsFilter` id, so the same id coming back from two sites is one option.
    return (0, $gByuu.mergeAndDedupeOptions)([
        contentOptions
    ]);
};
const $421fbacd3d5c29a7$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Confluence
];
const $421fbacd3d5c29a7$var$getProducts3PFromConfig = ()=>(0, $hea5O.getProducts3PFromConfigForFilter)('content');
const $421fbacd3d5c29a7$var$getFilterProducts = ()=>[
        ...$421fbacd3d5c29a7$var$productKeys1P,
        ...$421fbacd3d5c29a7$var$getProducts3PFromConfig()
    ];
const $421fbacd3d5c29a7$var$THIRD_PARTY_CONTENT_UNDER_SUBTYPES = {
    [(0, $dvVWp.ProductKeys).GoogleDrive]: [
        (0, $7ydfN.NounSubtypeKey).Folder
    ],
    [(0, $dvVWp.ProductKeys).Sharepoint]: [
        (0, $7ydfN.NounSubtypeKey).Drive,
        (0, $7ydfN.NounSubtypeKey).Folder
    ]
};
const $421fbacd3d5c29a7$var$isThirdPartyProductWithContentUnder = (product)=>!!product && product in $421fbacd3d5c29a7$var$THIRD_PARTY_CONTENT_UNDER_SUBTYPES && $421fbacd3d5c29a7$var$getProducts3PFromConfig().includes(product);
const $421fbacd3d5c29a7$var$getThirdPartyContentUnderSubtypes = (product)=>$421fbacd3d5c29a7$var$THIRD_PARTY_CONTENT_UNDER_SUBTYPES[product] ?? [];
const $421fbacd3d5c29a7$var$getSelectedSpaceAris = (config)=>Array.isArray(config.initialSpaceARIs) ? config.initialSpaceARIs.filter(Boolean) : [];
const $421fbacd3d5c29a7$var$getSelectedContributorAccountIds = (config)=>Array.isArray(config.contributorAccountIds) ? config.contributorAccountIds.filter(Boolean) : [];
const $421fbacd3d5c29a7$var$withCurrentProducts = (state)=>({
        ...state,
        products: $421fbacd3d5c29a7$var$getFilterProducts()
    });
const $421fbacd3d5c29a7$var$withCurrentProductsFilter = (filter)=>({
        ...filter,
        getState: ()=>$421fbacd3d5c29a7$var$withCurrentProducts(filter.getState()),
        queryParams: {
            ...filter.queryParams,
            set: async (queryParams, onStateChange)=>$421fbacd3d5c29a7$var$withCurrentProductsFilter(await filter.queryParams.set(queryParams, onStateChange && ((state)=>onStateChange($421fbacd3d5c29a7$var$withCurrentProducts(state)))))
        },
        loadInitialOptions: async (onStateChange)=>$421fbacd3d5c29a7$var$withCurrentProductsFilter(await filter.loadInitialOptions(onStateChange && ((state)=>onStateChange($421fbacd3d5c29a7$var$withCurrentProducts(state))))),
        setOption: (option, customValue)=>$421fbacd3d5c29a7$var$withCurrentProductsFilter(filter.setOption(option, customValue)),
        clearOptions: ()=>$421fbacd3d5c29a7$var$withCurrentProductsFilter(filter.clearOptions()),
        setLookupInput: async (query, onStateChange)=>$421fbacd3d5c29a7$var$withCurrentProductsFilter(await filter.setLookupInput(query, onStateChange && ((state)=>onStateChange($421fbacd3d5c29a7$var$withCurrentProducts(state))))),
        clear: ()=>$421fbacd3d5c29a7$var$withCurrentProductsFilter(filter.clear())
    });
const $421fbacd3d5c29a7$var$baseFilter = (0, $kZdMI.createSingleSelectFilter)({
    id: 'content',
    products: $421fbacd3d5c29a7$var$getFilterProducts(),
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'ancestor',
        fetcher: async (queryParams, config)=>{
            const product = config.product;
            const location = `ari:cloud:confluence::site/${config.cloudId}`;
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            if ($421fbacd3d5c29a7$var$isThirdPartyProductWithContentUnder(product)) {
                const contentResponse = await (0, $dv1ov.documentARIEntitiesQuery)({
                    variables: {
                        ids: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                return contentResponse.data?.external_entities?.document?.map((content)=>({
                        trackingKey: content.id,
                        value: content.id,
                        label: content.displayName,
                        queryParamValue: content.id,
                        product: config.product,
                        ...content.container?.id && {
                            metadata: {
                                containerARI: content.container.id
                            }
                        }
                    })) || [];
            }
            if (product === (0, $dvVWp.ProductKeys).ConfluenceDC) {
                const contentPagesResponse = await (0, $dv1ov.confluenceDcPagesQuery)({
                    variables: {
                        query: '',
                        cloudIdARI: location,
                        limit: 10,
                        entities: [
                            'ati:cloud:graph:document'
                        ],
                        product: product,
                        ancestorIds: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                return contentPagesResponse.data?.external_entities?.document?.map((content)=>({
                        trackingKey: content.id,
                        value: content.id,
                        label: content.displayName,
                        queryParamValue: content.id,
                        product: config.product
                    })) || [];
            }
            const initialContentARIs = queryParams.map((contentId)=>`ari:cloud:confluence:${config.cloudId}:page/${contentId}`);
            const initialContentResponse = await (0, $e6Tv8.confluencePagesQuery)(initialContentARIs, headers);
            const allContentPages = initialContentResponse.data?.confluence.pages.map((page)=>({
                    title: page.title,
                    id: page.id
                })) || [];
            const contentOptions = allContentPages.map((content)=>{
                const contentId = $421fbacd3d5c29a7$var$getContentId(content.id);
                return {
                    trackingKey: contentId,
                    value: contentId,
                    label: content.title,
                    queryParamValue: contentId,
                    product: config.product
                };
            });
            return contentOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $421fbacd3d5c29a7$var$searchContent('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $421fbacd3d5c29a7$var$searchContent(query, config);
        }
    }
});
const $421fbacd3d5c29a7$export$3dea766d36a8935f = {
    ...$421fbacd3d5c29a7$var$baseFilter,
    queryParams: {
        ...$421fbacd3d5c29a7$var$baseFilter.queryParams,
        getState: (queryParams, cloudId)=>$421fbacd3d5c29a7$var$withCurrentProducts($421fbacd3d5c29a7$var$baseFilter.queryParams.getState(queryParams, cloudId))
    },
    get products () {
        return $421fbacd3d5c29a7$var$getFilterProducts();
    },
    withState: (state, config)=>$421fbacd3d5c29a7$var$withCurrentProductsFilter($421fbacd3d5c29a7$var$baseFilter.withState({
            ...state,
            products: $421fbacd3d5c29a7$var$getFilterProducts()
        }, config)),
    getInitialState: (config)=>$421fbacd3d5c29a7$var$withCurrentProductsFilter($421fbacd3d5c29a7$var$baseFilter.getInitialState(config))
};
module.exports["filter"] = $421fbacd3d5c29a7$export$3dea766d36a8935f;

});

parcelRegister("e6Tv8", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $aff2d6af91e5ade1$export$fe2cce9cc2f02a10 = (0, $bHHWv.inMemoryCache)();
const $aff2d6af91e5ade1$var$GQL_CF_PAGES_OPERATION_NAME = 'SearchPageConfluencePagesQuery';
const $aff2d6af91e5ade1$var$getConfluencePagesQuery = ()=>`
query ${$aff2d6af91e5ade1$var$GQL_CF_PAGES_OPERATION_NAME}($pageIds: [ID]!) {
  confluence {
    pages(ids: $pageIds) {
      id
      title
      type
      links {
        base
      }
    }
  }
}
`;
const $aff2d6af91e5ade1$export$eeab7469706cab80 = (pageIds, headers)=>{
    return $aff2d6af91e5ade1$export$fe2cce9cc2f02a10.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per page id
    pageIds.join(','), async ()=>{
        if (pageIds.length === 0) return {
            data: {
                confluence: {
                    pages: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $aff2d6af91e5ade1$var$getConfluencePagesQuery(),
            variables: {
                pageIds: pageIds
            },
            operationName: $aff2d6af91e5ade1$var$GQL_CF_PAGES_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluencePagesQuery"] = $aff2d6af91e5ade1$export$eeab7469706cab80;

});

parcelRegister("evHnc", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bZF61 = parcelRequire("bZF61");


var $bHHWv = parcelRequire("bHHWv");

const $1d4baeadb938847e$var$operationName = 'SearchEntitiesQuery';
const $1d4baeadb938847e$var$getSearchEntitiesQuery = ({ includeSpaceKey: includeSpaceKey, includeContainerId: includeContainerId })=>{
    const SearchConfluenceSpace = `
    ... on SearchConfluenceSpace {
      key
    }
  `;
    // containerId is available on ExternalDocument entity (3P documents like Google Drive folders)
    const ContainerIdFragment = `
    ... on SearchResultGraphDocument {
      entity {
        ... on ExternalDocument {
          containerId
        }
      }
    }
  `;
    return `
  query ${$1d4baeadb938847e$var$operationName}(
		$experience: String!, 
		$query: String!, 
		$first: Int, 
		$filters: SearchFilterInput!
		$experimentId: String
		$shadowExperimentId: String
		$experimentLayers: [SearchExperimentLayer]
	) {
    search {
      results: search(
        experience: $experience
        query: $query
        first: $first
        filters: $filters
				experimentContext: {
					experimentId: $experimentId
					shadowExperimentId: $shadowExperimentId
					experimentLayers: $experimentLayers
				}
      ) {
        edges {
          node {
            id
            title
            type
            url
            iconUrl
            ${includeSpaceKey ? SearchConfluenceSpace : ``}
            ${includeContainerId ? ContainerIdFragment : ``}
          }
        }
      }
    }
  }
  `;
};
const $1d4baeadb938847e$export$69a3209f1a06c04d = (0, $bHHWv.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $1d4baeadb938847e$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    return data.search?.results.edges.length === 0;
};
const $1d4baeadb938847e$export$98f1867fd4cb2c65 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers, includeSpaceKey: includeSpaceKey, includeContainerId: includeContainerId })=>$1d4baeadb938847e$export$69a3209f1a06c04d.inMemoryDecorator((0, $bZF61.generateHashFromVariables)(variables), ()=>(0, $b0Mpu.fetchAgg)({
            variables: {
                first: 20,
                experience: '',
                ...variables
            },
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $1d4baeadb938847e$var$getSearchEntitiesQuery({
                includeSpaceKey: includeSpaceKey,
                includeContainerId: includeContainerId
            }),
            operationName: $1d4baeadb938847e$var$operationName,
            headers: headers
        }), $1d4baeadb938847e$var$expireWhen);
module.exports["searchEntitiesQuery"] = $1d4baeadb938847e$export$98f1867fd4cb2c65;

});

parcelRegister("a4K4k", function(module, exports) {

var $fR63l = parcelRequire("fR63l");


var $AgYeH = parcelRequire("AgYeH");


var $YTPUb = parcelRequire("YTPUb");


var $j5Usq = parcelRequire("j5Usq");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");


var $82ADO = parcelRequire("82ADO");


var $3e0Ll = parcelRequire("3e0Ll");

const $7d2151fd53dc4ada$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
// Each site still returns MAX_SEARCHED_OPTIONS_RESULTS, so five sites could otherwise surface 25.
const $7d2151fd53dc4ada$var$MAX_MULTI_SITE_SEARCHED_OPTIONS_RESULTS = 10;
const $7d2151fd53dc4ada$export$a4d01c087c4a6f1c = [
    '@',
    'contributor:'
];
// Filter out Trello for milestone 1 (QS-4733)
// Focus does not have contributor field
const $7d2151fd53dc4ada$var$productKeys1P = (0, $dvVWp.all1pProductKeys).filter((key)=>key !== (0, $dvVWp.ProductKeys).Trello && key !== (0, $dvVWp.ProductKeys).Focus && key !== (0, $dvVWp.ProductKeys).Talent);
const $7d2151fd53dc4ada$var$fetchContributorOptionsForSite = async (query, config, cloudId)=>{
    if (!config.intl) return [];
    const response = await (0, $YTPUb.getContributors)({
        query: query,
        cloudId: cloudId,
        userId: config.userId || '',
        productKey: (0, $82ADO.getUrsProductKey)(config.primaryProduct),
        maxNumberOfResults: $7d2151fd53dc4ada$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) // TODO: log not found somewhere
    return [];
    return response.map((contributor)=>({
            trackingKey: contributor.id,
            value: contributor.id,
            label: contributor.name,
            avatarUrl: contributor.avatarUrl,
            queryParamValue: contributor.id,
            product: config.product
        }));
};
// Figma doesn't support contributor
// https://atlassian.slack.com/archives/C07P3MD2U9Z/p1733868616441159?thread_ts=1733866616.102409&cid=C07P3MD2U9Z
const $7d2151fd53dc4ada$var$all3pProductKeysExceptFigma = (0, $dvVWp.all3pProductKeys).filter((key)=>key !== (0, $fR63l.ProductKeys3P).Figma);
const $7d2151fd53dc4ada$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'contributor',
    // 1P only for now (excluding Trello)
    products: [
        ...$7d2151fd53dc4ada$var$productKeys1P,
        ...$7d2151fd53dc4ada$var$all3pProductKeysExceptFigma
    ],
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'contributors',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersReponse = await (0, $j5Usq.usersQuery)([
                ...queryParams
            ], headers);
            const allRecommendedUsers = initialUsersReponse.data?.users ?? [];
            const recommendedUserOptions = allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return recommendedUserOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return (0, $3e0Ll.loadRecommendedUsers)(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return []; // base on existing interface, can only query contributors with intl
            const options = await (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$7d2151fd53dc4ada$var$fetchContributorOptionsForSite(query, config, cloudId));
            return options.slice(0, $7d2151fd53dc4ada$var$MAX_MULTI_SITE_SEARCHED_OPTIONS_RESULTS);
        }
    }
});
module.exports["filter"] = $7d2151fd53dc4ada$export$3dea766d36a8935f;

});

parcelRegister("YTPUb", function(module, exports) {

var $b9heI = parcelRequire("b9heI");

const $11c8f4518d873306$export$f63f2da3517cdf9c = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'contributors',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $b9heI.default)(requestParams, intl);
};
module.exports["getContributors"] = $11c8f4518d873306$export$f63f2da3517cdf9c;

});

parcelRegister("dpRDk", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $5yReE = parcelRequire("5yReE");


var $j5Usq = parcelRequire("j5Usq");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $82ADO = parcelRequire("82ADO");


var $3e0Ll = parcelRequire("3e0Ll");

const $b9457923c85e0a77$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $b9457923c85e0a77$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('createdBy');
const $b9457923c85e0a77$var$loadInitialOptions = async (config)=>{
    return (0, $3e0Ll.loadRecommendedUsers)(config);
};
const $b9457923c85e0a77$var$searchCreatedBy = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const response = await (0, $5yReE.getCreatedBy)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: (0, $82ADO.getUrsProductKey)(config.primaryProduct),
        maxNumberOfResults: $b9457923c85e0a77$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.avatarUrl,
            queryParamValue: user.id,
            product: config.product
        }));
};
const $b9457923c85e0a77$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'createdBy',
    products: [
        ...$b9457923c85e0a77$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'createdBy',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $j5Usq.usersQuery)(queryParams, headers);
            const allCreatedBy = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const createdByOptions = allCreatedBy.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return createdByOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $b9457923c85e0a77$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $b9457923c85e0a77$var$searchCreatedBy(query, config);
        }
    }
});
module.exports["filter"] = $b9457923c85e0a77$export$3dea766d36a8935f;

});

parcelRegister("5yReE", function(module, exports) {

var $b9heI = parcelRequire("b9heI");

const $c1765f354c88eda7$export$cc8468b84430954 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'createdBy',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $b9heI.default)(requestParams, intl);
};
module.exports["getCreatedBy"] = $c1765f354c88eda7$export$cc8468b84430954;

});

parcelRegister("7TxDU", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $a7280eb61b4b3796$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $a7280eb61b4b3796$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('documentStatus');
const $a7280eb61b4b3796$var$documentStatusProducts = Array.from(new Set([
    ...$a7280eb61b4b3796$var$salesforceProducts,
    ...$a7280eb61b4b3796$var$products3PFromConfig
]));
const $a7280eb61b4b3796$var$fetchDynamicDocumentStatusOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const knowledgeArticlePublishStatuses = result.filters.find((f)=>f.name === 'knowledgeArticlePublishStatuses');
        if (!knowledgeArticlePublishStatuses || knowledgeArticlePublishStatuses.values.length === 0) return [];
        return knowledgeArticlePublishStatuses.values.map((status)=>({
                value: status.name,
                trackingKey: status.name,
                queryParamValue: status.name,
                isDefault: false,
                label: status.label ?? status.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch (e) {
        return [];
    }
};
const $a7280eb61b4b3796$var$fetchDocumentStatusOptions = async (config)=>{
    return $a7280eb61b4b3796$var$fetchDynamicDocumentStatusOptions(config);
};
const $a7280eb61b4b3796$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $a7280eb61b4b3796$var$fetchDocumentStatusOptions(config);
    const selected = new Set(queryParams);
    const result = allOptions.filter((option)=>selected.has(option.queryParamValue));
    return result;
};
const $a7280eb61b4b3796$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'documentStatus',
    requiresTopLevel3PDatasource: true,
    products: $a7280eb61b4b3796$var$documentStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'knowledgeArticleStatuses',
        fetcher: async (queryParams, config)=>{
            return $a7280eb61b4b3796$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $a7280eb61b4b3796$var$fetchDocumentStatusOptions(config);
        }
    }
});
module.exports["filter"] = $a7280eb61b4b3796$export$3dea766d36a8935f;

});

parcelRegister("epN5B", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $kfEW5 = parcelRequire("kfEW5");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

/**
 * Queries all focus area types from graphQL and returns all options as suggested but unselected
 * @param config
 * @returns
 */ const $b625ac9cc3d1cd87$var$getFocusAreaTypeOptionsForSite = async (config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreaTypesResponse = await (0, $kfEW5.mercuryFocusAreaTypesQuery)(cloudId, headers);
    const focusAreaTypes = focusAreaTypesResponse.data?.mercury.focusAreaTypes ?? [];
    return focusAreaTypes.map((focusAreaType)=>({
            trackingKey: focusAreaType.id,
            label: focusAreaType.name,
            value: focusAreaType.id,
            queryParamValue: focusAreaType.id,
            product: config.product
        }));
};
const $b625ac9cc3d1cd87$var$getInitialOptions = async (config)=>{
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$b625ac9cc3d1cd87$var$getFocusAreaTypeOptionsForSite(config, cloudId));
};
/**
 * Queries all focus area types from graphQL and returns all options as suggested and query params are suggested
 * @param queryParams
 * @param config
 * @returns
 */ const $b625ac9cc3d1cd87$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const focusAreaTypeOptions = await $b625ac9cc3d1cd87$var$getInitialOptions(config);
    return focusAreaTypeOptions.filter((option)=>queryParams.includes(option.value));
};
/**
 * Queries all focus area types from graphQL and filters out options that do not match the text query
 * @param query
 * @param config
 * @returns
 */ const $b625ac9cc3d1cd87$var$getOptionsFilteredByTextQuery = async (query, config)=>{
    const focusAreaTypeOptions = await $b625ac9cc3d1cd87$var$getInitialOptions(config);
    return focusAreaTypeOptions.filter((option)=>option.label.toLowerCase().includes(query.toLowerCase()));
};
const $b625ac9cc3d1cd87$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Focus
];
const $b625ac9cc3d1cd87$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'focusAreaType',
    products: $b625ac9cc3d1cd87$var$productKeys1P,
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'focusAreaTypes',
        fetcher: $b625ac9cc3d1cd87$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: $b625ac9cc3d1cd87$var$getInitialOptions
    },
    lookup: {
        fetcher: $b625ac9cc3d1cd87$var$getOptionsFilteredByTextQuery
    }
});
module.exports["filter"] = $b625ac9cc3d1cd87$export$3dea766d36a8935f;

});

parcelRegister("kfEW5", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $52cd1dbde71c9335$export$fb16ff36c6030271 = (0, $bHHWv.inMemoryCache)();
const $52cd1dbde71c9335$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME = 'FocusAreaTypes';
const $52cd1dbde71c9335$var$mercuryFocusAreaTypesQueryString = `query ${$52cd1dbde71c9335$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME}($cloudId: ID!) {
  mercury {
    focusAreaTypes(cloudId: $cloudId) @optIn(to: "Mercury") {
      id
      name
      hierarchyLevel
    }
  }
}`;
const $52cd1dbde71c9335$export$780cc3f06f467bfe = (cloudId, headers)=>{
    return $52cd1dbde71c9335$export$fb16ff36c6030271.inMemoryDecorator(cloudId, async ()=>{
        if (!cloudId) return {
            data: {
                mercury: {
                    focusAreaTypes: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $52cd1dbde71c9335$var$mercuryFocusAreaTypesQueryString,
            variables: {
                cloudId: cloudId
            },
            operationName: $52cd1dbde71c9335$var$GQL_MERCURY_FOCUS_AREA_TYPES_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["mercuryFocusAreaTypesQuery"] = $52cd1dbde71c9335$export$780cc3f06f467bfe;

});

parcelRegister("MFQTE", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $imRpm = parcelRequire("imRpm");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

// Number of results returned in dropdown
const $7b0395d16d6ecff3$var$FOCUS_AREA_RESULTS_LIMIT = 20;
const $7b0395d16d6ecff3$var$mapFocusAreaResult = (focusArea, product)=>{
    return {
        trackingKey: focusArea.node?.uuid || '',
        label: focusArea.node?.name || '',
        value: focusArea.node?.uuid || '',
        queryParamValue: focusArea.node?.uuid || '',
        metadata: {
            type: focusArea.node?.focusAreaType.name,
            owner: focusArea.node?.owner?.name,
            status: focusArea.node?.status?.key,
            health: focusArea.node?.health?.key
        },
        product: product
    };
};
/**
 * Queries focus areas by search term
 * @param query
 * @param config
 * @returns
 */ const $7b0395d16d6ecff3$var$searchFocusAreasForSite = async (query, config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreasResponse = await (0, $imRpm.mercuryFocusAreasQuery)(cloudId, query, $7b0395d16d6ecff3$var$FOCUS_AREA_RESULTS_LIMIT, undefined, headers);
    const focusAreas = focusAreasResponse.data?.mercury.focusAreas.edges ?? [];
    return focusAreas.map((focusArea)=>$7b0395d16d6ecff3$var$mapFocusAreaResult(focusArea, config.product));
};
const $7b0395d16d6ecff3$var$searchFocusAreas = async (query, config)=>{
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$7b0395d16d6ecff3$var$searchFocusAreasForSite(query, config, cloudId));
};
/**
 * Queries all selected focus areas by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $7b0395d16d6ecff3$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const mqlQuery = `(${queryParams.map((id)=>`id = '${id}'`).join(' OR ')})`;
    return $7b0395d16d6ecff3$var$searchFocusAreas(mqlQuery, config);
};
const $7b0395d16d6ecff3$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Focus
];
const $7b0395d16d6ecff3$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'focusAreaUnder',
    products: $7b0395d16d6ecff3$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'focusAreaUnder',
        fetcher: $7b0395d16d6ecff3$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $7b0395d16d6ecff3$var$searchFocusAreas(`(search LIKE '')`, config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>$7b0395d16d6ecff3$var$searchFocusAreas(`(search LIKE '${query}')`, config)
    }
});
module.exports["filter"] = $7b0395d16d6ecff3$export$3dea766d36a8935f;

});

parcelRegister("imRpm", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $7280c1ea62400160$export$7e54d23e8f945514 = (0, $bHHWv.inMemoryCache)();
const $7280c1ea62400160$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME = 'FocusAreas';
const $7280c1ea62400160$var$mercuryFocusAreasQueryString = `query ${$7280c1ea62400160$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME}($cloudId: ID!, $q: String, $first: Int, $sort: [MercuryFocusAreaSort]) {
  mercury {
    focusAreas(cloudId: $cloudId, q: $q, first: $first, sort: $sort) @optIn(to: "Mercury") {
      edges {
        node {
          id
          uuid
          name
          status {
		    key            
          }
          health {
            key
          }
          focusAreaType {
		  	name
            hierarchyLevel
          }
		  owner {
            name
          }
        }
      }
    }
  }
}`;
const $7280c1ea62400160$var$MercuryFocusAreaSortField = {
    Budget: 'BUDGET',
    FocusAreaType: 'FOCUS_AREA_TYPE',
    HasParent: 'HAS_PARENT',
    HierarchyLevel: 'HIERARCHY_LEVEL',
    LastUpdated: 'LAST_UPDATED',
    Name: 'NAME',
    Spend: 'SPEND',
    Status: 'STATUS',
    TargetDate: 'TARGET_DATE',
    Watching: 'WATCHING'
};
const $7280c1ea62400160$var$MercuryFocusAreaSortOrder = {
    ASC: 'ASC',
    DESC: 'DESC'
};
const $7280c1ea62400160$export$f9d9785ff9cc54a6 = (cloudId, q, first = 20, sort = [
    {
        field: $7280c1ea62400160$var$MercuryFocusAreaSortField.FocusAreaType,
        order: $7280c1ea62400160$var$MercuryFocusAreaSortOrder['ASC']
    },
    {
        field: $7280c1ea62400160$var$MercuryFocusAreaSortField.Name,
        order: $7280c1ea62400160$var$MercuryFocusAreaSortOrder['ASC']
    }
], headers)=>{
    return $7280c1ea62400160$export$7e54d23e8f945514.inMemoryDecorator(`${cloudId}-${q}-${first}-${JSON.stringify(sort)}`, async ()=>{
        if (!cloudId) return {
            data: {
                mercury: {
                    focusAreas: {
                        edges: []
                    }
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $7280c1ea62400160$var$mercuryFocusAreasQueryString,
            variables: {
                cloudId: cloudId,
                q: q,
                first: first,
                sort: sort
            },
            operationName: $7280c1ea62400160$var$GQL_MERCURY_FOCUS_AREAS_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["mercuryFocusAreasQuery"] = $7280c1ea62400160$export$f9d9785ff9cc54a6;

});

parcelRegister("i2Y2N", function(module, exports) {

var $hea5O = parcelRequire("hea5O");


var $6uNXh = parcelRequire("6uNXh");

const $ff0afb98e1d1ef83$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('hasAttachment');
const $ff0afb98e1d1ef83$export$3dea766d36a8935f = (0, $6uNXh.createBooleanFilter)({
    id: 'hasAttachment',
    queryParams: {
        key: 'hasAttachment'
    },
    products: [
        ...$ff0afb98e1d1ef83$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $ff0afb98e1d1ef83$export$3dea766d36a8935f;

});

parcelRegister("EICUN", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $6qPRO = parcelRequire("6qPRO");


var $7MX1N = parcelRequire("7MX1N");


var $AgYeH = parcelRequire("AgYeH");


var $gMpbY = parcelRequire("gMpbY");


var $iviWm = parcelRequire("iviWm");




const $7d52788c8ba69304$var$fetchLabelsForSite = async (config, cloudId, query)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const response = await (0, $gMpbY.confluenceLabelsQuery)(cloudId, query, 10, headers);
    const suggestedLabels = response.data?.confluence.searchLabels.suggestedLabels || [];
    const otherLabels = response.data?.confluence.searchLabels.otherLabels || [];
    return [
        ...suggestedLabels,
        ...otherLabels
    ].map((label)=>({
            trackingKey: label.label || '',
            value: label.label || '',
            queryParamValue: label.label || '',
            label: label.label || '',
            product: config.product
        }));
};
const $7d52788c8ba69304$export$1825bdcb0c5952b8 = async (query, config)=>{
    if (!config.intl || config.cloudId === undefined) // base on existing interface, can only query contributors with intl
    return [];
    const product = config.product;
    if (product === (0, $dvVWp.ProductKeys).ConfluenceDC) return [
        {
            trackingKey: query,
            value: query,
            label: query,
            queryParamValue: query,
            product: config.product
        }
    ];
    // Labels are plain strings, so the same label on two sites is one option that filters both.
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$7d52788c8ba69304$var$fetchLabelsForSite(config, cloudId, query));
};
const $7d52788c8ba69304$export$ae59602b611675bf = async (queryParams)=>{
    return queryParams.map((label)=>({
            trackingKey: label,
            value: label,
            queryParamValue: label,
            label: label
        }));
};



var $li5ty = parcelRequire("li5ty");

const $5609f10a8a4040cb$export$218f28c8d8799e97 = async (config)=>{
    if (!window) return []; // SSR Safety
    const hostname = window.location.origin;
    const response = await (0, $li5ty.getSuggestedJiraLabels)({
        absoluteUrl: hostname
    });
    return response.suggestions.map((suggestion)=>({
            trackingKey: suggestion.label,
            value: suggestion.label,
            queryParamValue: suggestion.label,
            isDefault: false,
            label: suggestion.label,
            isSelected: false,
            isSuggested: true,
            product: config.product
        }));
};
const $5609f10a8a4040cb$export$9a3d32e397d14cdf = async (query, config)=>{
    if (!window) return []; // SSR Safety
    const hostname = window.location.origin;
    const response = await (0, $li5ty.getSuggestedJiraLabels)({
        query: query,
        absoluteUrl: hostname
    });
    return response.suggestions.map((suggestion)=>({
            trackingKey: suggestion.label,
            value: suggestion.label,
            queryParamValue: suggestion.label,
            isDefault: false,
            label: suggestion.label,
            isSelected: false,
            isSuggested: false,
            product: config.product
        }));
};
const $5609f10a8a4040cb$export$eea6e8b7edaba18f = async (queryParams, config)=>{
    const options = queryParams.map((queryParam)=>({
            trackingKey: queryParam,
            value: queryParam,
            queryParamValue: queryParam,
            isDefault: false,
            label: queryParam,
            isSelected: true,
            isSuggested: false,
            product: config.product
        }));
    return options;
};


const $c073a91cfc096268$var$getProducts1P = ()=>{
    return [
        (0, $dvVWp.ProductKeys).Confluence,
        (0, $dvVWp.ProductKeys).Jira,
        (0, $dvVWp.ProductKeys).JiraProductDiscovery,
        (0, $dvVWp.ProductKeys).JiraServiceManagement
    ];
};
const $c073a91cfc096268$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'label',
    products: [
        ...$c073a91cfc096268$var$getProducts1P()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'labels',
        fetcher: async (queryParams, config)=>{
            if (config.product === (0, $dvVWp.ProductKeys).Confluence || config.product === (0, $dvVWp.ProductKeys).ConfluenceDC || config.primaryProduct === (0, $dvVWp.ProductKeys).Confluence) return (0, $7d52788c8ba69304$export$ae59602b611675bf)(queryParams, config);
            const safePrimaryProduct = (0, $dvVWp.isProductKey)(config.primaryProduct) ? config.primaryProduct : undefined;
            if ((0, $6qPRO.isJiraProduct)(config.product) || (0, $6qPRO.isJiraProduct)(safePrimaryProduct)) return (0, $5609f10a8a4040cb$export$eea6e8b7edaba18f)(queryParams, config);
            // Not supported in other products
            return [];
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            const safePrimaryProduct = (0, $dvVWp.isProductKey)(config.primaryProduct) ? config.primaryProduct : undefined;
            if ((0, $6qPRO.isJiraProduct)(config.product) || (0, $6qPRO.isJiraProduct)(safePrimaryProduct)) return (0, $5609f10a8a4040cb$export$218f28c8d8799e97)(config);
            return [];
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (config.product === (0, $dvVWp.ProductKeys).Confluence || config.product === (0, $dvVWp.ProductKeys).ConfluenceDC || config.primaryProduct === (0, $dvVWp.ProductKeys).Confluence) return (0, $7d52788c8ba69304$export$1825bdcb0c5952b8)(query, config);
            const safePrimaryProduct = (0, $dvVWp.isProductKey)(config.primaryProduct) ? config.primaryProduct : undefined;
            if ((0, $6qPRO.isJiraProduct)(config.product) || (0, $6qPRO.isJiraProduct)(safePrimaryProduct)) return (0, $5609f10a8a4040cb$export$9a3d32e397d14cdf)(query, config);
            return [];
        }
    }
});
module.exports["filter"] = $c073a91cfc096268$export$3dea766d36a8935f;

});

parcelRegister("6qPRO", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");

const $246f35dff0a837bd$export$ecb101fddedffa32 = (product, includeDC = false)=>{
    const jiraProducts = includeDC ? [
        (0, $dvVWp.ProductKeys).Jira,
        (0, $dvVWp.ProductKeys).JiraDC,
        (0, $dvVWp.ProductKeys).JiraProductDiscovery,
        (0, $dvVWp.ProductKeys).JiraServiceManagement
    ] : [
        (0, $dvVWp.ProductKeys).Jira,
        (0, $dvVWp.ProductKeys).JiraProductDiscovery,
        (0, $dvVWp.ProductKeys).JiraServiceManagement
    ];
    return Boolean(jiraProducts.find((jiraProduct)=>jiraProduct === product));
};
module.exports["isJiraProduct"] = $246f35dff0a837bd$export$ecb101fddedffa32;

});

parcelRegister("gMpbY", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $96dc2a6c1e3b1c9f$export$a8f449a3d81f3a4c = (0, $bHHWv.inMemoryCache)();
const $96dc2a6c1e3b1c9f$var$GQL_CF_LABEL_OPERATION_NAME = 'SearchLabelsQuery';
const $96dc2a6c1e3b1c9f$var$getConfluenceLabelsQuery = ()=>`
query ${$96dc2a6c1e3b1c9f$var$GQL_CF_LABEL_OPERATION_NAME}($cloudId: ID! $searchText: String!, $limit: Int) {
  confluence {
    searchLabels(cloudId: $cloudId, searchText: $searchText, limit: $limit) @optIn(to: "ConfluenceExperimentalSearchLabels") {
	  otherLabels {
        label
      }
      suggestedLabels {
        label
      }
    }
  }
}
`;
const $96dc2a6c1e3b1c9f$export$b9ea4761dac8a473 = (cloudId, searchText, limit, headers)=>{
    // Key includes cloudId: multi-site fan-out issues one call per site with the same searchText.
    return $96dc2a6c1e3b1c9f$export$a8f449a3d81f3a4c.inMemoryDecorator(`${cloudId}::${searchText}`, async ()=>{
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $96dc2a6c1e3b1c9f$var$getConfluenceLabelsQuery(),
            variables: {
                cloudId: cloudId,
                searchText: searchText,
                limit: limit
            },
            operationName: $96dc2a6c1e3b1c9f$var$GQL_CF_LABEL_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluenceLabelsQuery"] = $96dc2a6c1e3b1c9f$export$b9ea4761dac8a473;

});

parcelRegister("li5ty", function(module, exports) {

var $gABt9 = parcelRequire("gABt9");

const $006a7e2c64c5f888$export$eddac1daa475a197 = async ({ query: query = '', absoluteUrl: absoluteUrl })=>{
    const options = {
        path: 'rest/api/1.0/labels/suggest',
        queryParams: {
            query: query
        },
        requestInit: {
            method: 'GET',
            headers: {
                accept: 'application/json',
                'x-atlassian-capability': 'ROVO_FULL_PAGE_SEARCH'
            }
        }
    };
    return (0, $gABt9.utils).requestService({
        url: absoluteUrl
    }, options);
};
module.exports["getSuggestedJiraLabels"] = $006a7e2c64c5f888$export$eddac1daa475a197;

});

parcelRegister("ikbkS", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $cZKQq = parcelRequire("cZKQq");


var $hea5O = parcelRequire("hea5O");


var $m6ow8 = parcelRequire("m6ow8");


var $kSwu1 = parcelRequire("kSwu1");

const $4734bd722a21269b$export$3f164da8f895a853 = (0, $kSwu1.defineMessages)({
    anytime: {
        id: "search-page.filter.last.updated.anytime",
        defaultMessage: "Anytime"
    },
    today: {
        id: "search-page.filter.last.updated.today",
        defaultMessage: "Today"
    },
    yesterday: {
        id: "search-page.filter.last.updated.yesterday",
        defaultMessage: "Yesterday"
    },
    past7Days: {
        id: "search-page.filter.last.updated.past7Days",
        defaultMessage: "Past 7 days"
    },
    past30Days: {
        id: "search-page.filter.last.updated.past30Days",
        defaultMessage: "Past 30 days"
    },
    pastYear: {
        id: "search-page.filter.last.updated.pastYear",
        defaultMessage: "Past year"
    },
    custom: {
        id: "search-page.filter.last.updated.custom",
        defaultMessage: "Custom"
    }
});



var $iaii4 = parcelRequire("iaii4");

const $5d3e7fabbed11965$var$LAST_UPDATED_VALUES = [
    'today',
    'yesterday',
    'past7Days',
    'past30Days',
    'pastYear',
    'custom'
];
const $5d3e7fabbed11965$var$sortCompareFn = (a, b)=>{
    return $5d3e7fabbed11965$var$LAST_UPDATED_VALUES.indexOf(a.value) - $5d3e7fabbed11965$var$LAST_UPDATED_VALUES.indexOf(b.value);
};
const $5d3e7fabbed11965$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Atlas,
    (0, $dvVWp.ProductKeys).Confluence,
    (0, $dvVWp.ProductKeys).Focus,
    (0, $dvVWp.ProductKeys).Jira,
    (0, $dvVWp.ProductKeys).JiraProductDiscovery,
    (0, $dvVWp.ProductKeys).JiraServiceManagement,
    (0, $dvVWp.ProductKeys).Compass,
    (0, $dvVWp.ProductKeys).Trello,
    (0, $dvVWp.ProductKeys).Bitbucket
];
const $5d3e7fabbed11965$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('lastUpdated');
const $5d3e7fabbed11965$export$3dea766d36a8935f = (0, $m6ow8.createSingleWithCustomOptionSelectFilter)({
    id: 'lastUpdated',
    products: [
        ...$5d3e7fabbed11965$var$productKeys1P,
        ...$5d3e7fabbed11965$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'lastModified',
        fetcher: async (_, config)=>{
            return $5d3e7fabbed11965$var$LAST_UPDATED_VALUES.map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $4734bd722a21269b$export$3f164da8f895a853)[value]) || (0, $4734bd722a21269b$export$3f164da8f895a853)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        },
        customValueParser: $iaii4.customValueParser,
        generateQueryParamsGetState: $iaii4.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return [
                {
                    trackingKey: 'anytime',
                    label: config.intl?.formatMessage((0, $4734bd722a21269b$export$3f164da8f895a853)['anytime']) || (0, $4734bd722a21269b$export$3f164da8f895a853)['anytime'].defaultMessage,
                    value: 'anytime',
                    isDefault: true,
                    queryParamValue: (0, $cZKQq.LastModified).Anytime,
                    product: config.product
                },
                ...$5d3e7fabbed11965$var$LAST_UPDATED_VALUES.map((value)=>({
                        trackingKey: value,
                        label: config.intl?.formatMessage((0, $4734bd722a21269b$export$3f164da8f895a853)[value]) || (0, $4734bd722a21269b$export$3f164da8f895a853)[value].defaultMessage,
                        value: value,
                        queryParamValue: value,
                        product: config.product
                    }))
            ];
        }
    },
    sortCompareFn: $5d3e7fabbed11965$var$sortCompareFn,
    customValueFields: [
        'to',
        'from'
    ]
});
module.exports["filter"] = $5d3e7fabbed11965$export$3dea766d36a8935f;

});

parcelRegister("5h8lq", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $8pAq5 = parcelRequire("8pAq5");


var $j5Usq = parcelRequire("j5Usq");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");


var $82ADO = parcelRequire("82ADO");


var $3e0Ll = parcelRequire("3e0Ll");

const $5717633a044a584d$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
const $5717633a044a584d$var$loadInitialOptions = async (config)=>{
    return (0, $3e0Ll.loadRecommendedUsers)(config);
};
const $5717633a044a584d$var$searchlastUpdatedBy = async (query, config)=>{
    if (!config.intl) return []; // base on existing interface, can only query with intl
    const productKey = (0, $82ADO.getUrsProductKey)(config.primaryProduct);
    const response = await (0, $8pAq5.getLastUpdatedBy)({
        query: query,
        cloudId: config.cloudId || '',
        userId: config.userId || '',
        productKey: productKey,
        maxNumberOfResults: $5717633a044a584d$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) return [];
    return response.map((user)=>({
            trackingKey: user.id,
            value: user.id,
            label: user.name,
            avatarUrl: user.avatarUrl,
            queryParamValue: user.id,
            product: config.product
        }));
};
const $5717633a044a584d$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'lastUpdatedBy',
    products: [
        (0, $dvVWp.ProductKeys).Salesforce,
        (0, $dvVWp.ProductKeys).Hubspot
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'lastUpdatedBy',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $j5Usq.usersQuery)(queryParams, headers);
            const allLastUpdatedBy = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            const lastUpdatedByOptions = allLastUpdatedBy.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return lastUpdatedByOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $5717633a044a584d$var$loadInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $5717633a044a584d$var$searchlastUpdatedBy(query, config);
        }
    }
});
module.exports["filter"] = $5717633a044a584d$export$3dea766d36a8935f;

});

parcelRegister("8pAq5", function(module, exports) {

var $b9heI = parcelRequire("b9heI");

const $6d8429c7aa46b5f0$export$5fc95d9e84e12fd3 = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'lastUpdatedBy',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $b9heI.default)(requestParams, intl);
};
module.exports["getLastUpdatedBy"] = $6d8429c7aa46b5f0$export$5fc95d9e84e12fd3;

});

parcelRegister("9rMWc", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $25a6065339ecd514$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $25a6065339ecd514$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('leadStatus');
const $25a6065339ecd514$var$leadStatusProducts = Array.from(new Set([
    ...$25a6065339ecd514$var$salesforceProducts,
    ...$25a6065339ecd514$var$products3PFromConfig
]));
const $25a6065339ecd514$var$fetchDynamicLeadStatusOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const leadStatuses = result.filters.find((f)=>f.name === 'leadStatuses');
        if (!leadStatuses || leadStatuses.values.length === 0) return [];
        return leadStatuses.values.map((leadStatus)=>({
                value: leadStatus.name,
                trackingKey: leadStatus.name,
                queryParamValue: leadStatus.name,
                isDefault: false,
                label: leadStatus.label ?? leadStatus.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch (e) {
        return [];
    }
};
const $25a6065339ecd514$var$fetchLeadStatusOptions = async (config)=>{
    return $25a6065339ecd514$var$fetchDynamicLeadStatusOptions(config);
};
const $25a6065339ecd514$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $25a6065339ecd514$var$fetchLeadStatusOptions(config);
    const selected = new Set(queryParams);
    const result = allOptions.filter((option)=>selected.has(option.queryParamValue));
    return result;
};
const $25a6065339ecd514$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'leadStatus',
    requiresTopLevel3PDatasource: true,
    products: $25a6065339ecd514$var$leadStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'leadStatuses',
        fetcher: async (queryParams, config)=>{
            return $25a6065339ecd514$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $25a6065339ecd514$var$fetchLeadStatusOptions(config);
        }
    }
});
module.exports["filter"] = $25a6065339ecd514$export$3dea766d36a8935f;

});

parcelRegister("AmZkX", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $kZdMI = parcelRequire("kZdMI");


var $XRj3F = parcelRequire("XRj3F");


var $kSwu1 = parcelRequire("kSwu1");

const $89688ada5362bb20$export$815fbd192b2af8a4 = (0, $kSwu1.defineMessages)({
    all: {
        id: "search-page.filter.opportunityStatus.all",
        defaultMessage: "Any"
    },
    open: {
        id: "search-page.filter.opportunityStatus.open",
        defaultMessage: "Open"
    },
    closed: {
        id: "search-page.filter.opportunityStatus.closed",
        defaultMessage: "Closed"
    }
});


const $2b4edcc5a5aed134$export$2fbe3998cc101414 = (config)=>{
    const allOption = {
        value: 'all',
        trackingKey: 'all',
        queryParamValue: 'all',
        isDefault: true,
        label: config.intl?.formatMessage((0, $89688ada5362bb20$export$815fbd192b2af8a4)['all']) ?? '',
        product: config.product
    };
    const opportunityStatusOptions = (0, $XRj3F.allOpportunityStatusFilterValueKeys).map((key)=>({
            value: key,
            trackingKey: key,
            queryParamValue: key,
            isDefault: false,
            label: config.intl?.formatMessage((0, $89688ada5362bb20$export$815fbd192b2af8a4)[key]) ?? '',
            product: config.product
        }));
    return [
        allOption,
        ...opportunityStatusOptions
    ];
};


const $81b199ef174fc1a5$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $81b199ef174fc1a5$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('opportunityStatus');
const $81b199ef174fc1a5$var$opportunityStatusProducts = Array.from(new Set([
    ...$81b199ef174fc1a5$var$salesforceProducts,
    ...$81b199ef174fc1a5$var$products3PFromConfig
]));
const $81b199ef174fc1a5$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $2b4edcc5a5aed134$export$2fbe3998cc101414)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            ...option,
            product: config.product
        }));
};
const $81b199ef174fc1a5$var$getInitialOptions = (config)=>{
    const allOptions = (0, $2b4edcc5a5aed134$export$2fbe3998cc101414)(config);
    return allOptions.map((option)=>({
            ...option,
            product: config.product
        }));
};
const $81b199ef174fc1a5$export$3dea766d36a8935f = (0, $kZdMI.createSingleSelectFilter)({
    id: 'opportunityStatus',
    products: $81b199ef174fc1a5$var$opportunityStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'opportunityStatus',
        fetcher: async (queryParams, config)=>{
            return $81b199ef174fc1a5$var$loadQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $81b199ef174fc1a5$var$getInitialOptions(config);
        }
    }
});
module.exports["filter"] = $81b199ef174fc1a5$export$3dea766d36a8935f;

});

parcelRegister("2BHso", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $f530N = parcelRequire("f530N");


var $6yWnN = parcelRequire("6yWnN");


var $j5Usq = parcelRequire("j5Usq");


var $iviWm = parcelRequire("iviWm");


var $gByuu = parcelRequire("gByuu");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $82ADO = parcelRequire("82ADO");

const $1d0369792cfc05e0$var$MAX_SMART_DEFAULT_OPTIONS = 5;
const $1d0369792cfc05e0$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
// Each site still returns MAX_SEARCHED_OPTIONS_RESULTS, so five sites could otherwise surface 25.
const $1d0369792cfc05e0$var$MAX_MULTI_SITE_SEARCHED_OPTIONS_RESULTS = 10;
// Same reasoning for the zero-query recommendations, which return MAX_SMART_DEFAULT_OPTIONS a site.
const $1d0369792cfc05e0$var$MAX_MULTI_SITE_SMART_DEFAULT_OPTIONS = 10;
const $1d0369792cfc05e0$var$toRecommendedUserOption = (config, user)=>({
        trackingKey: user.accountId,
        value: user.accountId,
        label: user.name,
        avatarUrl: user.picture,
        queryParamValue: user.accountId,
        product: config.product
    });
// URS only accepts a scalar `siteId`, so multi-site search fans out one request per site.
const $1d0369792cfc05e0$var$fetchOwnerOptionsForSite = async (query, config, cloudId)=>{
    if (!config.intl) return [];
    const response = await (0, $f530N.getOwners)({
        query: query,
        cloudId: cloudId,
        userId: config.userId || '',
        productKey: (0, $82ADO.getUrsProductKey)(config.primaryProduct),
        maxNumberOfResults: $1d0369792cfc05e0$var$MAX_SEARCHED_OPTIONS_RESULTS,
        intl: config.intl
    });
    if (!response) // TODO: log not found somewhere
    return [];
    return response.map((owner)=>({
            trackingKey: owner.id,
            value: owner.id,
            label: owner.name,
            avatarUrl: owner.avatarUrl,
            queryParamValue: owner.id,
            product: config.product
        }));
};
// `smarts.recommendedUser` takes a scalar `tenantId`, so recommendations fan out one query a site.
const $1d0369792cfc05e0$var$fetchRecommendedOwnerOptionsForSite = async (config, cloudId)=>{
    const response = await (0, $6yWnN.smartsRecommendedUserQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: cloudId,
            maxNumberOfResults: $1d0369792cfc05e0$var$MAX_SMART_DEFAULT_OPTIONS
        },
        // Attribution is per-site, so these headers cannot be hoisted out of the fan-out.
        headers: (0, $AgYeH.buildAtlAttributionHeaders)({
            cloudId: cloudId,
            activationId: config.activationId,
            product: config.primaryProduct
        })
    });
    const recommendedUsers = (response.data?.smarts.results ?? []).flatMap((recommendedUser)=>!!recommendedUser && !!recommendedUser.user ? {
            id: recommendedUser.id,
            ...recommendedUser.user
        } : []);
    return recommendedUsers.map((user)=>$1d0369792cfc05e0$var$toRecommendedUserOption(config, user));
};
const $1d0369792cfc05e0$var$loadRecommendedOwner = async (config)=>{
    // The current user leads the list and is not site-specific, so this stays a single query —
    // fanning it out would just return the same person once per site.
    const initialUsersQuery = (0, $j5Usq.usersQuery)([
        ...config.userId ? [
            config.userId
        ] : [] // The current user should always be the first recommended user
    ], (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    }));
    const cloudIds = config.selectedCloudIds?.length ? config.selectedCloudIds : [
        config.cloudId || ''
    ];
    const [initialUsersResponse, recommendedOwnerOptions] = await Promise.all([
        initialUsersQuery,
        (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$1d0369792cfc05e0$var$fetchRecommendedOwnerOptionsForSite(config, cloudId))
    ]);
    const currentUserOptions = (initialUsersResponse.data?.users ?? []).map((user)=>$1d0369792cfc05e0$var$toRecommendedUserOption(config, user));
    if (cloudIds.length === 1) return [
        ...currentUserOptions,
        ...recommendedOwnerOptions
    ];
    // The current user leads the round-robin, so they stay first and are not duplicated by a site
    // that also recommends them.
    return (0, $gByuu.mergeAndDedupeOptions)([
        currentUserOptions,
        recommendedOwnerOptions
    ]).slice(0, $1d0369792cfc05e0$var$MAX_MULTI_SITE_SMART_DEFAULT_OPTIONS);
};
const $1d0369792cfc05e0$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Confluence,
    (0, $dvVWp.ProductKeys).Focus
];
const $1d0369792cfc05e0$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('owner');
const $1d0369792cfc05e0$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'owner',
    products: [
        ...$1d0369792cfc05e0$var$productKeys1P,
        ...$1d0369792cfc05e0$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'owners',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersReponse = await (0, $j5Usq.usersQuery)([
                ...queryParams
            ], headers);
            const allRecommendedUsers = initialUsersReponse.data?.users ?? [];
            const recommendedUserOptions = allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
            return recommendedUserOptions;
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $1d0369792cfc05e0$var$loadRecommendedOwner(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return [];
            const options = await (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$1d0369792cfc05e0$var$fetchOwnerOptionsForSite(query, config, cloudId));
            return options.slice(0, $1d0369792cfc05e0$var$MAX_MULTI_SITE_SEARCHED_OPTIONS_RESULTS);
        }
    }
});
module.exports["filter"] = $1d0369792cfc05e0$export$3dea766d36a8935f;

});

parcelRegister("f530N", function(module, exports) {

var $b9heI = parcelRequire("b9heI");

const $3a062b7ee0ab8ca2$export$148de59b68ce26ae = ({ query: query, userId: userId, cloudId: cloudId, productKey: productKey, maxNumberOfResults: maxNumberOfResults, intl: intl })=>{
    const requestParams = {
        context: {
            contextType: 'owners',
            principalId: userId,
            productAttributes: {
                isEntitledConfluenceExternalCollaborator: true
            },
            productKey: productKey,
            siteId: cloudId
        },
        includeGroups: false,
        includeTeams: false,
        includeUsers: true,
        maxNumberOfResults: maxNumberOfResults,
        performSearchQueryOnly: false,
        query: query
    };
    return (0, $b9heI.default)(requestParams, intl);
};
module.exports["getOwners"] = $3a062b7ee0ab8ca2$export$148de59b68ce26ae;

});

parcelRegister("8NYi4", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $kZdMI = parcelRequire("kZdMI");


var $2bNdD = parcelRequire("2bNdD");


var $1Fy3P = parcelRequire("1Fy3P");


var $kSwu1 = parcelRequire("kSwu1");

const $7b4cda44e30068e9$export$29ee4a15a943675b = (0, $kSwu1.defineMessages)({
    all: {
        id: "search-page.filter.pageStatus.all",
        defaultMessage: "All"
    },
    roughDraft: {
        id: "search-page.filter.pageStatus.roughDraft",
        defaultMessage: "Rough draft"
    },
    inProgress: {
        id: "search-page.filter.pageStatus.inProgress",
        defaultMessage: "In progress"
    },
    readyForReview: {
        id: "search-page.filter.pageStatus.readyForReview",
        defaultMessage: "Ready for review"
    },
    verified: {
        id: "search-page.filter.pageStatus.verified",
        defaultMessage: "Verified"
    }
});


const $ad6e803698b1e20f$export$3195c4e56ca4af29 = (config)=>{
    const allOption = {
        value: 'all',
        trackingKey: 'all',
        queryParamValue: 'all',
        isDefault: true,
        label: config.intl?.formatMessage((0, $7b4cda44e30068e9$export$29ee4a15a943675b)['all']) ?? '',
        product: config.product
    };
    const pageStatusOptions = (0, $1Fy3P.allPageStatusFilterValueKeys).map((key)=>({
            value: (0, $1Fy3P.PageStatusFilterValue)[key],
            trackingKey: key,
            queryParamValue: key,
            isDefault: false,
            label: config.intl?.formatMessage((0, $7b4cda44e30068e9$export$29ee4a15a943675b)[key]) ?? '',
            product: config.product
        }));
    return [
        allOption,
        ...pageStatusOptions
    ];
};


const $632362e36b9f63c9$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Confluence
];
const $632362e36b9f63c9$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('pageStatus');
const $632362e36b9f63c9$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $ad6e803698b1e20f$export$3195c4e56ca4af29)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            ...option,
            product: config.product
        }));
};
const $632362e36b9f63c9$var$getInitialOptions = (config)=>{
    const allOptions = (0, $ad6e803698b1e20f$export$3195c4e56ca4af29)(config);
    return allOptions.map((option)=>({
            ...option,
            product: config.product
        }));
};
const $632362e36b9f63c9$export$3dea766d36a8935f = (0, $kZdMI.createSingleSelectFilter)({
    id: 'pageStatus',
    products: [
        ...$632362e36b9f63c9$var$productKeys1P,
        ...$632362e36b9f63c9$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'pageStatus',
        fetcher: async (queryParams, config)=>{
            return $632362e36b9f63c9$var$loadQueryParams(queryParams, config);
        },
        generateQueryParamsGetState: $2bNdD.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $632362e36b9f63c9$var$getInitialOptions(config);
        }
    }
});
module.exports["filter"] = $632362e36b9f63c9$export$3dea766d36a8935f;

});

parcelRegister("2sAXF", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $bxIiJ = parcelRequire("bxIiJ");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

// Number of results returned in dropdown
const $8489f1d5f3a8c9c3$var$LIMIT = 20;
const $8489f1d5f3a8c9c3$var$EmploymentTypeMapping = {
    Contingent: 'contingent',
    Employee: 'employee',
    Contractor: 'contractor'
};
const $8489f1d5f3a8c9c3$var$ReverseEmploymentTypeMapping = Object.fromEntries(Object.entries($8489f1d5f3a8c9c3$var$EmploymentTypeMapping).map(([key, value])=>[
        value,
        key
    ]));
const $8489f1d5f3a8c9c3$export$3362d5a8d7ac6a7b = (positionEmploymentType, product)=>{
    const value = $8489f1d5f3a8c9c3$var$EmploymentTypeMapping[positionEmploymentType.node.stringValue || ''] || 'unrecognized';
    return {
        trackingKey: value,
        label: positionEmploymentType.node.stringValue || '',
        value: value,
        queryParamValue: value,
        product: product
    };
};
/**
 * Queries position employment types by search term
 * @param query
 * @param config
 * @returns
 */ const $8489f1d5f3a8c9c3$var$fetchPositionEmploymentTypesForSite = async (rqlQuery, config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionEmploymentTypesResponse = await (0, $bxIiJ.positionEmploymentTypesQuery)(cloudId, rqlQuery, $8489f1d5f3a8c9c3$var$LIMIT, undefined, headers);
    const positionEmploymentTypes = positionEmploymentTypesResponse.data?.radar_fieldValues.edges ?? [];
    return positionEmploymentTypes.map((positionEmploymentType)=>$8489f1d5f3a8c9c3$export$3362d5a8d7ac6a7b(positionEmploymentType, config.product));
};
const $8489f1d5f3a8c9c3$var$fetchPositionEmploymentTypes = async (rqlQuery, config)=>{
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$8489f1d5f3a8c9c3$var$fetchPositionEmploymentTypesForSite(rqlQuery, config, cloudId));
};
const $8489f1d5f3a8c9c3$var$searchPositionEmploymentTypes = async (query, config)=>{
    const rqlQuery = `employmentType ~ '${query}'`;
    return $8489f1d5f3a8c9c3$var$fetchPositionEmploymentTypes(rqlQuery, config);
};
/**
 * Queries all selected focus areas by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $8489f1d5f3a8c9c3$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `employmentType in ('${queryParams.map((param)=>$8489f1d5f3a8c9c3$var$ReverseEmploymentTypeMapping[param || 'unrecognized']).filter(Boolean).join("', '")}')`;
    return $8489f1d5f3a8c9c3$var$fetchPositionEmploymentTypes(rqlQuery, config);
};
const $8489f1d5f3a8c9c3$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Talent
];
const $8489f1d5f3a8c9c3$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'positionEmploymentType',
    products: $8489f1d5f3a8c9c3$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionEmploymentTypes',
        fetcher: $8489f1d5f3a8c9c3$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $8489f1d5f3a8c9c3$var$searchPositionEmploymentTypes('', config);
        }
    },
    lookup: {
        fetcher: $8489f1d5f3a8c9c3$var$searchPositionEmploymentTypes
    }
});
module.exports["filter"] = $8489f1d5f3a8c9c3$export$3dea766d36a8935f;

});

parcelRegister("bxIiJ", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $d142e9aafa48423e$export$77f684104cbf1994 = (0, $bHHWv.inMemoryCache)();
const $d142e9aafa48423e$var$QUERY_NAME = 'PositionEmploymentTypes';
const $d142e9aafa48423e$var$positionEmploymentTypesQueryString = `query ${$d142e9aafa48423e$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on RadarStringFieldValue {
          __typename
          isRestricted
          stringValue: value
        }
      }
    }
  }
}`;
const $d142e9aafa48423e$export$66f27dc417575281 = (cloudId, rql, first = 20, after, headers)=>{
    const fieldId = 'positionEmploymentType';
    return $d142e9aafa48423e$export$77f684104cbf1994.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $d142e9aafa48423e$var$positionEmploymentTypesQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $d142e9aafa48423e$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionEmploymentTypesQuery"] = $d142e9aafa48423e$export$66f27dc417575281;

});

parcelRegister("8BOly", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $imRpm = parcelRequire("imRpm");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

// Number of results returned in dropdown
const $8c726a43af8bc8ca$var$FOCUS_AREA_RESULTS_LIMIT = 20;
const $8c726a43af8bc8ca$var$mapFocusAreaResult = (focusArea, product)=>{
    return {
        trackingKey: focusArea.node?.uuid || '',
        label: focusArea.node?.name || '',
        value: focusArea.node?.uuid || '',
        queryParamValue: focusArea.node?.uuid || '',
        metadata: {
            type: focusArea.node?.focusAreaType.name,
            owner: focusArea.node?.owner?.name,
            status: focusArea.node?.status?.key,
            health: focusArea.node?.health?.key
        },
        product: product
    };
};
const $8c726a43af8bc8ca$var$fetchPositionFocusAreasForSite = async (mqlQuery, config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const focusAreasResponse = await (0, $imRpm.mercuryFocusAreasQuery)(cloudId, mqlQuery, $8c726a43af8bc8ca$var$FOCUS_AREA_RESULTS_LIMIT, undefined, headers);
    const focusAreas = focusAreasResponse.data?.mercury.focusAreas.edges ?? [];
    return focusAreas.map((focusArea)=>$8c726a43af8bc8ca$var$mapFocusAreaResult(focusArea, config.product));
};
const $8c726a43af8bc8ca$var$fetchPositionFocusAreas = async (mqlQuery, config)=>{
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$8c726a43af8bc8ca$var$fetchPositionFocusAreasForSite(mqlQuery, config, cloudId));
};
/**
 * Queries focus areas by search term
 * @param query
 * @param config
 * @returns
 */ const $8c726a43af8bc8ca$var$searchPositionFocusAreas = async (query, config)=>{
    return $8c726a43af8bc8ca$var$fetchPositionFocusAreas(`(search LIKE '${query}')`, config);
};
/**
 * Queries all selected focus areas by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $8c726a43af8bc8ca$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const mqlQuery = `(${queryParams.map((id)=>`id = '${id}'`).join(' OR ')})`;
    return $8c726a43af8bc8ca$var$fetchPositionFocusAreas(mqlQuery, config);
};
const $8c726a43af8bc8ca$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Talent
];
const $8c726a43af8bc8ca$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'positionFocusArea',
    products: $8c726a43af8bc8ca$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionFocusAreas',
        fetcher: $8c726a43af8bc8ca$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $8c726a43af8bc8ca$var$searchPositionFocusAreas('', config);
        }
    },
    lookup: {
        fetcher: $8c726a43af8bc8ca$var$searchPositionFocusAreas
    }
});
module.exports["filter"] = $8c726a43af8bc8ca$export$3dea766d36a8935f;

});

parcelRegister("dkj04", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $jZtm2 = parcelRequire("jZtm2");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

// Number of results returned in dropdown
const $209dbf838e771ca9$var$LIMIT = 20;
const $209dbf838e771ca9$var$mapPositionJobFamilyResult = (positionJobFamily, product)=>{
    const encodedValue = encodeURIComponent(positionJobFamily.node.stringValue);
    return {
        trackingKey: encodedValue || '',
        label: positionJobFamily.node.stringValue || '',
        value: encodedValue || '',
        queryParamValue: encodedValue || '',
        product: product
    };
};
/**
 * Queries position job families by search term
 * @param query
 * @param config
 * @returns
 */ const $209dbf838e771ca9$var$fetchPositionJobFamiliesForSite = async (rqlQuery, config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionJobFamiliesResponse = await (0, $jZtm2.positionJobFamiliesQuery)(cloudId, $209dbf838e771ca9$var$LIMIT, rqlQuery, undefined, headers);
    const positionJobFamilies = positionJobFamiliesResponse.data?.radar_fieldValues.edges ?? [];
    return positionJobFamilies.map((positionJobFamily)=>$209dbf838e771ca9$var$mapPositionJobFamilyResult(positionJobFamily, config.product));
};
const $209dbf838e771ca9$var$fetchPositionJobFamilies = async (rqlQuery, config)=>{
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$209dbf838e771ca9$var$fetchPositionJobFamiliesForSite(rqlQuery, config, cloudId));
};
const $209dbf838e771ca9$var$searchPositionJobFamilies = async (query, config)=>{
    const rqlQuery = `jobFamily ~ '${query}'`;
    return $209dbf838e771ca9$var$fetchPositionJobFamilies(rqlQuery, config);
};
/**
 * Queries all selected job families by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $209dbf838e771ca9$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `jobFamily in ('${queryParams.map((param)=>decodeURIComponent(param)).join("', '")}')`;
    return $209dbf838e771ca9$var$fetchPositionJobFamilies(rqlQuery, config);
};
const $209dbf838e771ca9$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Talent
];
const $209dbf838e771ca9$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'positionJobFamily',
    products: $209dbf838e771ca9$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionJobFamilies',
        fetcher: $209dbf838e771ca9$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $209dbf838e771ca9$var$searchPositionJobFamilies('', config);
        }
    },
    lookup: {
        fetcher: $209dbf838e771ca9$var$searchPositionJobFamilies
    }
});
module.exports["filter"] = $209dbf838e771ca9$export$3dea766d36a8935f;

});

parcelRegister("jZtm2", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $a11a0d42712a0ff2$export$5918017b3202b827 = (0, $bHHWv.inMemoryCache)();
const $a11a0d42712a0ff2$var$QUERY_NAME = 'PositionJobFamilies';
const $a11a0d42712a0ff2$var$positionJobFamiliesQueryString = `query ${$a11a0d42712a0ff2$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on RadarStringFieldValue {
          __typename
          isRestricted
          stringValue: value
        }
      }
    }
  }
}`;
const $a11a0d42712a0ff2$export$9573cb9936eb57f3 = (cloudId, first = 20, rql, after, headers)=>{
    const fieldId = 'positionJobFamily';
    return $a11a0d42712a0ff2$export$5918017b3202b827.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $a11a0d42712a0ff2$var$positionJobFamiliesQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $a11a0d42712a0ff2$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionJobFamiliesQuery"] = $a11a0d42712a0ff2$export$9573cb9936eb57f3;

});

parcelRegister("5m4QA", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $50e7e = parcelRequire("50e7e");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

// Number of results returned in dropdown
const $b256ce03128dfe3b$var$LIMIT = 20;
const $b256ce03128dfe3b$var$StatusMapping = {
    Filled: 'filled',
    'Not filled': 'unfilled'
};
const $b256ce03128dfe3b$var$ReverseStatusMapping = Object.fromEntries(Object.entries($b256ce03128dfe3b$var$StatusMapping).map(([key, value])=>[
        value,
        key
    ]));
const $b256ce03128dfe3b$export$aa60679002fe2884 = (positionStatus, product)=>{
    const value = $b256ce03128dfe3b$var$StatusMapping[positionStatus.node.statusValue || ''] || 'unrecognized';
    return {
        trackingKey: value,
        label: positionStatus.node.statusDisplayValue || '',
        value: value,
        queryParamValue: value,
        product: product
    };
};
/**
 * Queries position statuses by search term
 * @param query
 * @param config
 * @returns
 */ const $b256ce03128dfe3b$var$fetchPositionStatusesForSite = async (rqlQuery, config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionStatusesResponse = await (0, $50e7e.positionStatusesQuery)(cloudId, $b256ce03128dfe3b$var$LIMIT, rqlQuery, undefined, headers);
    const positionStatuses = positionStatusesResponse.data?.radar_fieldValues.edges ?? [];
    return positionStatuses.map((positionStatus)=>$b256ce03128dfe3b$export$aa60679002fe2884(positionStatus, config.product));
};
const $b256ce03128dfe3b$var$fetchPositionStatuses = async (rqlQuery, config)=>{
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$b256ce03128dfe3b$var$fetchPositionStatusesForSite(rqlQuery, config, cloudId));
};
const $b256ce03128dfe3b$var$searchPositionStatuses = async (query, config)=>{
    const rqlQuery = `status ~ '${query}'`;
    return $b256ce03128dfe3b$var$fetchPositionStatuses(rqlQuery, config);
};
/**
 * Queries all selected position statuses by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $b256ce03128dfe3b$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `status in ('${queryParams.map((param)=>$b256ce03128dfe3b$var$ReverseStatusMapping[param || 'unrecognized']).filter(Boolean).join("', '")}')`;
    return $b256ce03128dfe3b$var$fetchPositionStatuses(rqlQuery, config);
};
const $b256ce03128dfe3b$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Talent
];
const $b256ce03128dfe3b$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'positionStatus',
    products: $b256ce03128dfe3b$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionStatuses',
        fetcher: $b256ce03128dfe3b$var$getOptionsWithSelectionsFromQueryParams
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $b256ce03128dfe3b$var$searchPositionStatuses('', config);
        }
    },
    lookup: {
        fetcher: $b256ce03128dfe3b$var$searchPositionStatuses
    }
});
module.exports["filter"] = $b256ce03128dfe3b$export$3dea766d36a8935f;

});

parcelRegister("50e7e", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $1c9dfd67ee1bf436$export$9030a66c314dd4f9 = (0, $bHHWv.inMemoryCache)();
const $1c9dfd67ee1bf436$var$QUERY_NAME = 'PositionStatuses';
const $1c9dfd67ee1bf436$var$positionStatusesQueryString = `query ${$1c9dfd67ee1bf436$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        ... on RadarStatusFieldValue {
          __typename
          isRestricted
          statusValue: value
          statusDisplayValue: displayValue
          appearance
        }
      }
    }
  }
}`;
const $1c9dfd67ee1bf436$export$edd0381f12f6ff4d = (cloudId, first = 20, rql, after, headers)=>{
    const fieldId = 'positionStatus';
    return $1c9dfd67ee1bf436$export$9030a66c314dd4f9.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $1c9dfd67ee1bf436$var$positionStatusesQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $1c9dfd67ee1bf436$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionStatusesQuery"] = $1c9dfd67ee1bf436$export$edd0381f12f6ff4d;

});

parcelRegister("9XbyR", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $6UNGx = parcelRequire("6UNGx");


var $iviWm = parcelRequire("iviWm");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");


var $26LZ9 = parcelRequire("26LZ9");

// Number of results returned in dropdown
const $0d2452782e4fdfb3$var$LIMIT = 20;
const $0d2452782e4fdfb3$var$mapPositionTeamResult = (positionTeam, product)=>{
    return {
        trackingKey: positionTeam.node.ari || '',
        label: positionTeam.node.value?.displayName || '',
        value: positionTeam.node.ari || '',
        queryParamValue: encodeURIComponent(positionTeam.node.ari) || '',
        product: product,
        avatarUrl: positionTeam.node.value?.smallAvatarImageUrl || ''
    };
};
/**
 * Queries position teams by search term
 * @param query
 * @param config
 * @returns
 */ const $0d2452782e4fdfb3$var$fetchPositionTeamsForSite = async (rqlQuery, config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const positionTeamsResponse = await (0, $6UNGx.positionTeamsQuery)(cloudId, $0d2452782e4fdfb3$var$LIMIT, rqlQuery, undefined, headers);
    const positionTeams = positionTeamsResponse.data?.radar_fieldValues.edges ?? [];
    return positionTeams.map((positionTeam)=>$0d2452782e4fdfb3$var$mapPositionTeamResult(positionTeam, config.product));
};
const $0d2452782e4fdfb3$var$fetchPositionTeams = async (rqlQuery, config)=>{
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$0d2452782e4fdfb3$var$fetchPositionTeamsForSite(rqlQuery, config, cloudId));
};
const $0d2452782e4fdfb3$var$searchPositionTeams = async (query, config)=>{
    const rqlQuery = `team ~ '${query}'`;
    return $0d2452782e4fdfb3$var$fetchPositionTeams(rqlQuery, config);
};
/**
 * Queries all selected position teams by id from query params
 * @param queryParams
 * @param config
 * @returns
 */ const $0d2452782e4fdfb3$var$getOptionsWithSelectionsFromQueryParams = async (queryParams, config)=>{
    const rqlQuery = `team in ('${queryParams.map((param)=>decodeURIComponent(param)).join("', '")}')`;
    return $0d2452782e4fdfb3$var$fetchPositionTeams(rqlQuery, config);
};
const $0d2452782e4fdfb3$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Talent
];
const $0d2452782e4fdfb3$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'positionTeam',
    products: $0d2452782e4fdfb3$var$productKeys1P,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'positionTeams',
        fetcher: $0d2452782e4fdfb3$var$getOptionsWithSelectionsFromQueryParams,
        generateQueryParamsGetState: $26LZ9.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $0d2452782e4fdfb3$var$searchPositionTeams('', config);
        }
    },
    lookup: {
        fetcher: $0d2452782e4fdfb3$var$searchPositionTeams
    }
});
module.exports["filter"] = $0d2452782e4fdfb3$export$3dea766d36a8935f;

});

parcelRegister("6UNGx", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $864bd9bcea253ed9$export$7e7f4c6c4a157b2d = (0, $bHHWv.inMemoryCache)();
const $864bd9bcea253ed9$var$QUERY_NAME = 'PositionTeams';
const $864bd9bcea253ed9$var$positionTeamsQueryString = `query ${$864bd9bcea253ed9$var$QUERY_NAME}($cloudId: ID!, $fieldId: ID!, $rql: String, $after: String, $first: Int) {
  radar_fieldValues(
    cloudId: $cloudId
    uniqueFieldId: $fieldId
    rql: $rql
    first: $first
    after: $after
  ) { 
    totalCount
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      cursor
      node {
        __typename
        __isRadarFieldValue: __typename
        ... on RadarAriFieldValue {
          __typename
          isRestricted
          ari
          value {
            __typename
            ... on TeamV2 {
              __typename
              displayName
              id
              organizationId
              smallAvatarImageUrl
            }
          }
        }
      }
    }
  }
}`;
const $864bd9bcea253ed9$export$ed23ff9c143a4269 = (cloudId, first = 20, rql, after, headers)=>{
    const fieldId = 'team';
    return $864bd9bcea253ed9$export$7e7f4c6c4a157b2d.inMemoryDecorator([
        cloudId,
        first,
        rql,
        fieldId,
        after
    ].filter(Boolean).join('-'), async ()=>{
        if (!cloudId) return {
            data: {
                radar_fieldValues: {
                    edges: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $864bd9bcea253ed9$var$positionTeamsQueryString,
            variables: {
                cloudId: cloudId,
                first: first,
                rql: rql,
                fieldId: fieldId,
                after: after
            },
            operationName: $864bd9bcea253ed9$var$QUERY_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["positionTeamsQuery"] = $864bd9bcea253ed9$export$ed23ff9c143a4269;

});

parcelRegister("1y2K1", function(module, exports) {

var $7avaU = parcelRequire("7avaU");


var $fd0l2 = parcelRequire("fd0l2");


var $AgYeH = parcelRequire("AgYeH");


var $fCd3b = parcelRequire("fCd3b");


var $6Zvcd = parcelRequire("6Zvcd");


var $7uPDr = parcelRequire("7uPDr");


var $dv1ov = parcelRequire("dv1ov");


var $iviWm = parcelRequire("iviWm");


var $gFWyZ = parcelRequire("gFWyZ");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $2UU5O = parcelRequire("2UU5O");

const $e5eefd7608991b9e$var$projectIdToARI = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $e5eefd7608991b9e$export$c4acd5097f11a5c9 = ({ projectKey: projectKey, name: name })=>{
    if (!projectKey) return name;
    const key = `(${projectKey})`;
    if (name.toLowerCase().includes(key.toLowerCase())) return name;
    return `${name} ${key}`;
};
const $e5eefd7608991b9e$var$searchProjectsForSite = async (query, config, cloudId)=>{
    const searchClient = (0, $fCd3b.createClient)({
        cloudId: cloudId
    });
    const searchProjectsResponse = await searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $6Zvcd.Scope).JiraProject
        ],
        sites: [
            cloudId
        ],
        analytics: {
            identifier: 'search-page'
        }
    });
    const scopes = searchProjectsResponse.response.rawData.scopes;
    const searchedProjects = scopes.length > 0 ? scopes[0].results.map((projectResult)=>({
            projectId: projectResult.id,
            name: projectResult.name,
            projectKey: projectResult.attributes.projectKey,
            avatar: {
                small: 'url' in projectResult.attributes.avatar ? projectResult.attributes.avatar.url : undefined
            }
        })) : [];
    // Results carry no cloudId, so attribute them to the site this call was made against.
    return searchedProjects.map((project)=>{
        const projectARI = $e5eefd7608991b9e$var$projectIdToARI(cloudId, project.projectId);
        return {
            trackingKey: projectARI,
            value: projectARI,
            label: $e5eefd7608991b9e$export$c4acd5097f11a5c9(project),
            avatarUrl: project.avatar?.small,
            // The ARI names the site, so hydration can query it directly instead of asking every site.
            queryParamValue: projectARI,
            product: config.product
        };
    });
};
const $e5eefd7608991b9e$var$searchProject = async (query, config)=>{
    const product = config.product;
    if (product === (0, $dvVWp.ProductKeys).JiraDC || product === (0, $dvVWp.ProductKeys).JsmDC) {
        const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
            cloudId: config.cloudId,
            activationId: config.activationId,
            product: config.primaryProduct
        });
        const searchProjectsResponse = await (0, $dv1ov.jiraDcProjectFilterOptionsQuery)({
            variables: {
                query: query,
                cloudIdARI: `ari:cloud:confluence::site/${config.cloudId}`,
                limit: 5,
                entities: (0, $gFWyZ.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
                product: (0, $dvVWp.ProductKeys).JiraDC,
                integration: config.selectedDatasource?.integrationAri,
                containerTypes: (0, $fd0l2.ThirdPartyConfigsSync).get(product)?.containerTypes
            },
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            headers: headers
        });
        return searchProjectsResponse?.data?.search?.search?.edges?.map((edge)=>({
                trackingKey: edge.node.entity.id,
                value: edge.node.entity.id,
                label: $e5eefd7608991b9e$export$c4acd5097f11a5c9({
                    projectKey: edge.node.entity.key,
                    name: edge.node.entity.displayName
                }),
                avatarUrl: edge?.node?.entity?.icon?.url,
                queryParamValue: edge.node.entity.id,
                product: config.product
            })) || [];
    }
    return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$e5eefd7608991b9e$var$searchProjectsForSite(query, config, cloudId));
};
const $e5eefd7608991b9e$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Jira,
    (0, $dvVWp.ProductKeys).JiraProductDiscovery,
    (0, $dvVWp.ProductKeys).JiraServiceManagement
];
const $e5eefd7608991b9e$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('project');
const $e5eefd7608991b9e$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'project',
    products: [
        ...$e5eefd7608991b9e$var$productKeys1P,
        ...$e5eefd7608991b9e$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'jProject',
        fetcher: async (queryParams, config)=>{
            if (config.product === (0, $dvVWp.ProductKeys).JiraDC || config.product === (0, $dvVWp.ProductKeys).JsmDC) {
                const initialProjectsResponse = await (0, $dv1ov.spaceARIEntitiesQuery)({
                    variables: {
                        ids: queryParams
                    }
                });
                const projectOptions = initialProjectsResponse.data?.external_entities?.space?.map((space)=>({
                        trackingKey: space.id,
                        value: space.id,
                        label: space.displayName,
                        avatarUrl: space.icon?.url || '',
                        queryParamValue: space.id,
                        product: config.product
                    }));
                return projectOptions || [];
            } else {
                // Query params hold ARIs, which name their own site. Links predating that hold bare
                // project ids and still have to be looked up on every selected site.
                // TODO QS-10359: drop the bare id branch, and the fan-out it forces, once pre-ARI
                // links have aged out. This outlives the serveFpsMultiSiteSearchExperiment cleanup.
                const cloudIds = config.selectedCloudIds ?? [];
                const initialProjectARIs = queryParams.flatMap((queryParamValue)=>(0, $7avaU.AnyAri).check(queryParamValue) ? [
                        queryParamValue
                    ] : cloudIds.map((cloudId)=>$e5eefd7608991b9e$var$projectIdToARI(cloudId, queryParamValue)));
                const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                    cloudId: config.cloudId,
                    activationId: config.activationId,
                    product: config.primaryProduct
                });
                const initialProjectsResponse = await (0, $7uPDr.jiraProjectsQuery)(initialProjectARIs, headers);
                const initialProjects = initialProjectsResponse.data?.jira.jiraProjects ?? [];
                // The returned ARI names the site the project actually lives on. Without it a project
                // cannot be attributed, and guessing the current site would select the wrong project.
                const requested = new Set(queryParams);
                return initialProjects.flatMap((project)=>project.id && (0, $7avaU.AnyAri).check(project.id) ? [
                        {
                            trackingKey: project.id,
                            value: project.id,
                            label: project.name,
                            avatarUrl: project.avatar?.small,
                            // Echo back whichever form the URL used so the option stays selected.
                            queryParamValue: requested.has(project.id) ? project.id : project.projectId,
                            product: config.product
                        }
                    ] : []);
            }
        },
        generateQueryParamsGetState: $2UU5O.generateQueryParamsGetState
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $e5eefd7608991b9e$var$searchProject('', config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $e5eefd7608991b9e$var$searchProject(query, config);
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $dvVWp.ProductKeys).Jira || primaryProduct === (0, $dvVWp.ProductKeys).JiraDC || primaryProduct === (0, $dvVWp.ProductKeys).JsmDC || primaryProduct === (0, $dvVWp.ProductKeys).JiraServiceManagement || primaryProduct === (0, $dvVWp.ProductKeys).JiraProductDiscovery
});
module.exports["filter"] = $e5eefd7608991b9e$export$3dea766d36a8935f;

});

parcelRegister("7uPDr", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $849aa335edd3427b$export$56d694fb8fe349ab = (0, $bHHWv.inMemoryCache)();
const $849aa335edd3427b$var$GQL_JIRA_PROJECTS_OPERATION_NAME = 'SearchPageJiraProjectQuery';
const $849aa335edd3427b$var$jiraProjectsQueryString = `query ${$849aa335edd3427b$var$GQL_JIRA_PROJECTS_OPERATION_NAME}($projectIds: [ID!]!) {
  jira {
    jiraProjects(ids: $projectIds) {
			id
			projectId
      name
      avatar {
        small
      }
    }
  }
}`;
const $849aa335edd3427b$export$fd1d4a933080bfe2 = (projectIds, headers)=>{
    return $849aa335edd3427b$export$56d694fb8fe349ab.inMemoryDecorator(projectIds.join(','), async ()=>{
        if (projectIds.length === 0) return {
            data: {
                jira: {
                    jiraProjects: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $849aa335edd3427b$var$jiraProjectsQueryString,
            variables: {
                projectIds: projectIds
            },
            operationName: $849aa335edd3427b$var$GQL_JIRA_PROJECTS_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return $849aa335edd3427b$var$filterProjectsWithoutId(response);
    });
};
const $849aa335edd3427b$var$filterProjectsWithoutId = (response)=>{
    const filteredProjects = response.data?.jira.jiraProjects?.filter((project)=>project.projectId);
    return {
        ...response,
        data: {
            jira: {
                jiraProjects: filteredProjects
            }
        }
    };
};
module.exports["jiraProjectsQuery"] = $849aa335edd3427b$export$fd1d4a933080bfe2;

});

parcelRegister("fV4vp", function(module, exports) {

var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $kSwu1 = parcelRequire("kSwu1");

const $da1834def4ab0830$export$9baa81d83dcf973 = [
    'open',
    'merged',
    'declined',
    'draft',
    'unknown'
];
const $da1834def4ab0830$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    open: {
        id: "search-page.filter.pull-request-status.open",
        defaultMessage: "Open"
    },
    merged: {
        id: "search-page.filter.pull-request-status.merged",
        defaultMessage: "Merged"
    },
    declined: {
        id: "search-page.filter.pull-request-status.declined",
        defaultMessage: "Declined"
    },
    draft: {
        id: "search-page.filter.pull-request-status.draft",
        defaultMessage: "Draft"
    },
    unknown: {
        id: "search-page.filter.pull-request-status.unknown",
        defaultMessage: "Unknown"
    }
});


const $30268aa033c8cbc3$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('pullRequestStatus');
const $30268aa033c8cbc3$var$getAllPullRequestStatusOptions = (config)=>{
    const options = (0, $da1834def4ab0830$export$9baa81d83dcf973).map((status)=>({
            value: status,
            trackingKey: status,
            queryParamValue: status,
            isDefault: false,
            label: config.intl?.formatMessage((0, $da1834def4ab0830$export$a7357cdd1f0b0168)[status]) ?? '',
            product: config.product,
            isSelected: false,
            isSuggested: false
        }));
    return options;
};
const $30268aa033c8cbc3$var$fetchQueryParams = (queryParams, config)=>{
    const allOptions = $30268aa033c8cbc3$var$getAllPullRequestStatusOptions(config);
    return allOptions.filter((option)=>queryParams.find((queryParam)=>option.value === queryParam));
};
const $30268aa033c8cbc3$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'pullRequestStatus',
    products: [
        'bitbucket',
        ...$30268aa033c8cbc3$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'pullRequestStatus',
        fetcher: async (queryParams, config)=>{
            return $30268aa033c8cbc3$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $30268aa033c8cbc3$var$getAllPullRequestStatusOptions(config);
        }
    }
});
module.exports["filter"] = $30268aa033c8cbc3$export$3dea766d36a8935f;

});

parcelRegister("j9kbz", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $fCd3b = parcelRequire("fCd3b");


var $6Zvcd = parcelRequire("6Zvcd");


var $j5Usq = parcelRequire("j5Usq");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");

const $0652ecb4ad9b4f5a$var$searchJiraCloudReporter = async (query, config, options)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialUsersQuery = config.userId && options?.initialOptions ? (0, $j5Usq.usersQuery)([
        config.userId
    ], headers) : Promise.resolve({
        data: {
            users: []
        }
    });
    const searchClient = (0, $fCd3b.createClient)({
        cloudId: config.cloudId || ''
    });
    const searchReporterQuery = searchClient.search({
        query: query,
        resultLimit: 5,
        scopes: [
            (0, $6Zvcd.Scope).People
        ],
        // Omitted for a single site so those requests stay unchanged.
        ...(config.selectedCloudIds?.length ?? 0) > 1 ? {
            sites: config.selectedCloudIds
        } : {},
        analytics: {
            identifier: 'search-page'
        }
    });
    const [initialUsersResponse, searchReporterReponse] = await Promise.all([
        initialUsersQuery,
        searchReporterQuery
    ]);
    const searchReporterResults = searchReporterReponse.response.rawData.scopes[0]?.results ?? [];
    const allReporters = [
        // The current user is always first
        ...initialUsersResponse.data?.users.map((user)=>({
                ...user,
                id: user.accountId
            })) ?? [],
        ...searchReporterResults.map((user)=>({
                picture: user.avatarUrl,
                name: user.name,
                id: user.id,
                accountId: user.id
            }))
    ];
    const userIds = new Set();
    return allReporters.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
    .map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId,
            product: config.product
        }));
};
const $0652ecb4ad9b4f5a$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Jira,
    (0, $dvVWp.ProductKeys).JiraProductDiscovery,
    (0, $dvVWp.ProductKeys).JiraServiceManagement
];
const $0652ecb4ad9b4f5a$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('reporter');
const $0652ecb4ad9b4f5a$var$getProducts = ()=>[
        ...$0652ecb4ad9b4f5a$var$productKeys1P,
        ...$0652ecb4ad9b4f5a$var$products3PFromConfig
    ];
const $0652ecb4ad9b4f5a$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'reporter',
    products: $0652ecb4ad9b4f5a$var$getProducts(),
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'jReporter',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $j5Usq.usersQuery)(queryParams, headers);
            const allReporters = initialUsersResponse.data?.users ?? [];
            const userIds = new Set();
            return allReporters.filter((user)=>!userIds.has(user.accountId) && userIds.add(user.accountId)) // Remove duplicates
            .map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $0652ecb4ad9b4f5a$var$searchJiraCloudReporter('', config, {
                initialOptions: true
            });
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $0652ecb4ad9b4f5a$var$searchJiraCloudReporter(query, config);
        }
    }
});
module.exports["filter"] = $0652ecb4ad9b4f5a$export$3dea766d36a8935f;

});

parcelRegister("dhhWM", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $fd0l2 = parcelRequire("fd0l2");


var $AgYeH = parcelRequire("AgYeH");


var $dv1ov = parcelRequire("dv1ov");


var $S6W9B = parcelRequire("S6W9B");


var $7ohhA = parcelRequire("7ohhA");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");

const $bcdb0eaa6cf70577$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('repository');
const $bcdb0eaa6cf70577$var$FETCH_LIMIT = 30;
/**
 * Calls AGG to fetch the user's accessible repositories for the currently-selected 3P datasource.
 */ const $bcdb0eaa6cf70577$var$fetchRepositoryOptions = async (config, query = '')=>{
    if (!(0, $iDrrr.fg)('rovo_fps_show_repository_filter')) return [];
    const { cloudId: cloudId, product: product, primaryProduct: primaryProduct, activationId: activationId } = config;
    const integrationAri = config.selectedDatasource?.integrationAri ?? (product && (0, $dvVWp.is3pProductKey)(product) ? (0, $fd0l2.ThirdPartyConfigsSync).get(product)?.integrationAri : undefined);
    if (!cloudId || !product || !integrationAri) return [];
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: activationId,
        product: primaryProduct
    });
    const response = await (0, $dv1ov.thirdPartyRepositoryFilterOptionsQuery)({
        variables: {
            query: query,
            cloudIdARI: (0, $S6W9B.getCloudIdARIs)(cloudId, primaryProduct),
            limit: $bcdb0eaa6cf70577$var$FETCH_LIMIT,
            entities: (0, $7ohhA.DEFAULT_CLOUD_GRAPH_DEVINFO_REPOSITORY_ENTITY_ATI),
            product: product,
            integration: integrationAri,
            subtypes: [
                (0, $7ydfN.NounSubtypeKey).Repository
            ]
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return response?.data?.search?.search?.edges?.map(({ node: node })=>{
        const name = node.entity?.name;
        if (!name) return undefined;
        return {
            value: name,
            trackingKey: name,
            queryParamValue: name,
            label: name,
            product: config.product,
            isDefault: false,
            isSelected: false,
            isSuggested: false
        };
    }).filter((option)=>option !== undefined) ?? [];
};
/**
 * Initial / pre-query options shown when the filter dropdown is first opened.
 */ const $bcdb0eaa6cf70577$var$getInitialOptions = async (config)=>$bcdb0eaa6cf70577$var$fetchRepositoryOptions(config);
/**
 * URL-hydration fetch. Resolves `?repository=...` values into
 * `SelectFilterOption`.
 */ const $bcdb0eaa6cf70577$var$fetchQueryParams = async (queryParams, config)=>{
    if (queryParams.length === 0 || !(0, $iDrrr.fg)('rovo_fps_show_repository_filter')) return [];
    const allOptions = await $bcdb0eaa6cf70577$var$fetchRepositoryOptions(config, queryParams.join(' '));
    const matched = allOptions.filter((option)=>queryParams.some((queryParam)=>option.value === queryParam)).map((option)=>({
            ...option,
            isSelected: true
        }));
    if (matched.length === queryParams.length) return matched;
    const matchedValues = new Set(matched.map((option)=>option.value));
    const fallback = queryParams.filter((queryParam)=>!matchedValues.has(queryParam)).map((queryParam)=>({
            value: queryParam,
            trackingKey: queryParam,
            queryParamValue: queryParam,
            isDefault: false,
            label: queryParam,
            product: config.product,
            isSelected: true,
            isSuggested: false
        }));
    return [
        ...matched,
        ...fallback
    ];
};
/**
 * Lookup (typeahead) fetcher.
 */ const $bcdb0eaa6cf70577$var$fetchLookupOptions = async (input, config)=>{
    if (!(0, $iDrrr.fg)('rovo_fps_show_repository_filter') || !input) return [];
    return $bcdb0eaa6cf70577$var$fetchRepositoryOptions(config, input);
};
const $bcdb0eaa6cf70577$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'repository',
    products: $bcdb0eaa6cf70577$var$products3PFromConfig,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'repository',
        fetcher: $bcdb0eaa6cf70577$var$fetchQueryParams
    },
    initialOptions: {
        fetcher: $bcdb0eaa6cf70577$var$getInitialOptions
    },
    lookup: {
        fetcher: $bcdb0eaa6cf70577$var$fetchLookupOptions
    }
});
module.exports["filter"] = $bcdb0eaa6cf70577$export$3dea766d36a8935f;

});

parcelRegister("2iqMh", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $YTPUb = parcelRequire("YTPUb");


var $j5Usq = parcelRequire("j5Usq");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $82ADO = parcelRequire("82ADO");


var $3e0Ll = parcelRequire("3e0Ll");

const $53db1c4a24decd00$var$MAX_SEARCHED_OPTIONS_RESULTS = 5;
// GitHub-only filter — the AGG `gitFilters.reviewer` field accepts an array of reviewer AAIDs.
// Internal naming uses `reviewer` (URL key, folder, i18n) while the wire-level key remains
// `reviewer` per the AGG `SearchGitFilters` schema contract. Options are URS-backed (same
// resolver as the Confluence `contributor` people-picker).
const $53db1c4a24decd00$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('reviewer');
const $53db1c4a24decd00$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'reviewer',
    products: $53db1c4a24decd00$var$products3PFromConfig,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'reviewer',
        fetcher: async (queryParams, config)=>{
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const initialUsersResponse = await (0, $j5Usq.usersQuery)([
                ...queryParams
            ], headers);
            const allRecommendedUsers = initialUsersResponse.data?.users ?? [];
            return allRecommendedUsers.map((user)=>({
                    trackingKey: user.accountId,
                    value: user.accountId,
                    label: user.name,
                    avatarUrl: user.picture,
                    queryParamValue: user.accountId,
                    product: config.product
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return (0, $3e0Ll.loadRecommendedUsers)(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if (!config.intl) return []; // base on existing interface, can only query reviewers with intl
            const response = await (0, $YTPUb.getContributors)({
                query: query,
                cloudId: config.cloudId || '',
                userId: config.userId || '',
                productKey: (0, $82ADO.getUrsProductKey)(config.primaryProduct),
                maxNumberOfResults: $53db1c4a24decd00$var$MAX_SEARCHED_OPTIONS_RESULTS,
                intl: config.intl
            });
            if (!response) return [];
            return response.map((reviewer)=>({
                    trackingKey: reviewer.id,
                    value: reviewer.id,
                    label: reviewer.name,
                    avatarUrl: reviewer.avatarUrl,
                    queryParamValue: reviewer.id,
                    product: config.product
                }));
        }
    }
});
module.exports["filter"] = $53db1c4a24decd00$export$3dea766d36a8935f;

});

parcelRegister("5gx32", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $1b66d940a8c8a7d5$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $1b66d940a8c8a7d5$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('salesforceStage');
const $1b66d940a8c8a7d5$var$fetchDynamicStageOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const opportunityStages = result.filters.find((f)=>f.name === 'opportunityStages');
        if (!opportunityStages || opportunityStages.values.length === 0) return [];
        return opportunityStages.values.map((stage)=>({
                value: stage.name,
                trackingKey: stage.name,
                queryParamValue: stage.name,
                isDefault: false,
                label: stage.label ?? stage.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch  {
        return [];
    }
};
/**
 * Returns stage options — dynamic when the feature flag is on, and
 * an empty list when the feature flag is off.
 */ const $1b66d940a8c8a7d5$var$getStageOptions = async (config)=>{
    if ((0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-dynamic-stage-filter')) return $1b66d940a8c8a7d5$var$fetchDynamicStageOptions(config);
    return [];
};
const $1b66d940a8c8a7d5$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $1b66d940a8c8a7d5$var$getStageOptions(config);
    const matched = allOptions.filter((option)=>queryParams.find((queryParam)=>option.value === queryParam));
    // If the API fetch returned no options (e.g. datasource not yet initialised on
    // initial URL load), fall back to synthetic options built from the raw query param
    // values so the store reflects hasSelection=true and shows the selected label in
    // the UI before the async fetch resolves.
    // Only apply this fallback when the flag is on — when off, the filter is disabled
    // and should not hydrate any state from query params.
    if (matched.length === 0 && queryParams.length > 0 && (0, $iDrrr.fg)('rovo-fps-3p-ux-salesforce-dynamic-stage-filter')) return queryParams.map((queryParam)=>({
            value: queryParam,
            trackingKey: queryParam,
            queryParamValue: queryParam,
            isDefault: false,
            label: queryParam,
            isSelected: true,
            isSuggested: false,
            product: config.product
        }));
    return matched;
};
const $1b66d940a8c8a7d5$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'salesforceStage',
    requiresTopLevel3PDatasource: true,
    products: [
        ...$1b66d940a8c8a7d5$var$salesforceProducts,
        ...$1b66d940a8c8a7d5$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'salesforceStages',
        fetcher: async (queryParams, config)=>{
            return $1b66d940a8c8a7d5$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $1b66d940a8c8a7d5$var$getStageOptions(config);
        }
    }
});
module.exports["filter"] = $1b66d940a8c8a7d5$export$3dea766d36a8935f;

});

parcelRegister("b5q9t", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $b0Mpu = parcelRequire("b0Mpu");

const $34dabb57a028edd9$export$c5dfc39e7764783c = 'searchSlackChannels';
const $34dabb57a028edd9$export$c94f0ac2580f3d4 = `
query ${$34dabb57a028edd9$export$c5dfc39e7764783c}($cloudId: ID!, $limit: Int) {
  search {
    configuration(cloudId: $cloudId) {
      thirdPartySlackChannels(limit: $limit) {
        channels {
          id
          name
          isPrivate
        }
        nextCursor
      }
    }
  }
}`;
const $34dabb57a028edd9$export$4b8a3f4aff3d6261 = ()=>$34dabb57a028edd9$export$c94f0ac2580f3d4;


const $b8cda7fef19cd30b$export$74d737bad7014c80 = async ({ cloudId: cloudId, limit: limit, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    try {
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: (0, $34dabb57a028edd9$export$4b8a3f4aff3d6261)(),
            variables: {
                cloudId: cloudId,
                ...limit !== undefined && {
                    limit: limit
                }
            },
            operationName: (0, $34dabb57a028edd9$export$c5dfc39e7764783c),
            aggAbsoluteUrl: aggAbsoluteUrl,
            headers: headers
        });
        const payload = response.data?.search?.configuration?.thirdPartySlackChannels ?? null;
        if (response.errors?.length) {
            console.warn(`[${(0, $34dabb57a028edd9$export$c5dfc39e7764783c)}] GraphQL errors for cloudId "${cloudId}":`, response.errors);
            if (!payload) throw new Error(`[${(0, $34dabb57a028edd9$export$c5dfc39e7764783c)}] GraphQL errors prevented loading Slack channels for cloudId "${cloudId}"`);
        }
        return payload;
    } catch (error) {
        console.error(`[${(0, $34dabb57a028edd9$export$c5dfc39e7764783c)}] Failed to fetch Slack channels:`, error);
        throw error;
    }
};



var $hea5O = parcelRequire("hea5O");


var $aCR6W = parcelRequire("aCR6W");


var $7MX1N = parcelRequire("7MX1N");

const $97eff50800a111ac$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('slackChannel');
// 200 recommended by Slack as the max per request
// Select Filter does not support pagination, but the backend API does via cursor
// This filter can be enhanced in the future to support pagination on scroll/search if needed
const $97eff50800a111ac$var$MAX_CHANNELS_TO_FETCH = 200;
/**
 * Session-level cache: maps cloudId → in-flight or resolved promise of channel options.
 * This deduplicates concurrent and repeated calls (e.g. queryParams.fetcher + initialOptions.fetcher
 * both fire on page load when a channel is pre-selected via URL param).
 * The cache is module-level so it persists for the browser session but resets on page navigation.
 */ const $97eff50800a111ac$var$channelOptionsCache = new Map();
const $97eff50800a111ac$export$687cc7f9972f010f = ()=>$97eff50800a111ac$var$channelOptionsCache.clear();
async function $97eff50800a111ac$var$doFetchSlackChannels(config) {
    const { cloudId: cloudId } = config;
    if (!cloudId) throw new Error('Cloud ID is required to fetch Slack channels');
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    try {
        const payload = await (0, $b8cda7fef19cd30b$export$74d737bad7014c80)({
            cloudId: cloudId,
            limit: $97eff50800a111ac$var$MAX_CHANNELS_TO_FETCH,
            aggAbsoluteUrl: config.aggAbsoluteUrl,
            headers: headers
        });
        return (payload?.channels ?? []).map((channel)=>({
                value: channel.name,
                trackingKey: channel.id,
                queryParamValue: channel.name,
                label: channel.name,
                isDefault: false,
                isSelected: false,
                isSuggested: false,
                product: config.product
            }));
    } catch  {
        return [];
    }
}
const $97eff50800a111ac$var$fetchSlackChannelOptions = (config)=>{
    const { cloudId: cloudId } = config;
    if (!cloudId) return Promise.resolve([]);
    // Return cached promise (handles both in-flight dedup and session-level caching).
    // If the fetch returns an empty result (e.g. network blip, auth error — doFetchSlackChannels
    // catches internally and returns []) or rejects unexpectedly, remove the cache entry so a
    // subsequent open/retry can attempt a fresh fetch rather than returning stale empty results.
    if (!$97eff50800a111ac$var$channelOptionsCache.has(cloudId)) {
        const promise = $97eff50800a111ac$var$doFetchSlackChannels(config);
        $97eff50800a111ac$var$channelOptionsCache.set(cloudId, promise);
        promise.then((channels)=>{
            if (channels.length === 0) $97eff50800a111ac$var$channelOptionsCache.delete(cloudId);
        }).catch(()=>{
            $97eff50800a111ac$var$channelOptionsCache.delete(cloudId);
        });
    }
    return $97eff50800a111ac$var$channelOptionsCache.get(cloudId);
};
const $97eff50800a111ac$var$fetchQueryParams = async (queryParams, config)=>{
    // Hydrate selected channel names from URL params by client-side filtering
    // the full fetched list — no extra API call needed.
    const allOptions = await $97eff50800a111ac$var$fetchSlackChannelOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $97eff50800a111ac$var$lookupChannels = async (query, config)=>{
    const allOptions = await $97eff50800a111ac$var$fetchSlackChannelOptions(config);
    if (!query) return allOptions;
    return (0, $aCR6W.fuzzyFilter)(query, allOptions, (option)=>option.label);
};
const $97eff50800a111ac$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'slackChannel',
    products: $97eff50800a111ac$var$products3PFromConfig,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'slackChannels',
        fetcher: async (queryParams, config)=>{
            return $97eff50800a111ac$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $97eff50800a111ac$var$fetchSlackChannelOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $97eff50800a111ac$var$lookupChannels(query, config);
        }
    }
});
module.exports["filter"] = $97eff50800a111ac$export$3dea766d36a8935f;

});

parcelRegister("jQaFd", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $cZKQq = parcelRequire("cZKQq");


var $kZdMI = parcelRequire("kZdMI");


var $kSwu1 = parcelRequire("kSwu1");

const $85abfd322db30634$export$b351dad7e43554a2 = (0, $kSwu1.defineMessages)({
    relevance: {
        id: "relevance",
        defaultMessage: "Relevance"
    },
    updatedNewest: {
        id: "updatedNewest",
        defaultMessage: "Updated (newest)"
    },
    updatedOldest: {
        id: "updatedOldest",
        defaultMessage: "Updated (oldest)"
    },
    createdNewest: {
        id: "createdNewest",
        defaultMessage: "Created (newest)"
    },
    createdOldest: {
        id: "createdOldest",
        defaultMessage: "Created (oldest)"
    }
});


const $e4011984b6740259$var$SORT_VALUES = [
    'updatedNewest',
    'updatedOldest',
    'createdNewest',
    'createdOldest'
];
const $e4011984b6740259$var$sortCompareFn = (a, b)=>{
    return $e4011984b6740259$var$SORT_VALUES.indexOf(a.queryParamValue) - $e4011984b6740259$var$SORT_VALUES.indexOf(b.queryParamValue);
};
const $e4011984b6740259$var$products = [
    (0, $dvVWp.ProductKeys).Confluence,
    (0, $dvVWp.ProductKeys).Jira
];
const $e4011984b6740259$export$3dea766d36a8935f = (0, $kZdMI.createSingleSelectFilter)({
    id: 'sort',
    products: $e4011984b6740259$var$products,
    alwaysVisible: true,
    universal: false,
    queryParams: {
        key: 'sort',
        fetcher: async (_, config)=>{
            return $e4011984b6740259$var$SORT_VALUES.map((value)=>({
                    trackingKey: value,
                    label: config.intl?.formatMessage((0, $85abfd322db30634$export$b351dad7e43554a2)[value]) || (0, $85abfd322db30634$export$b351dad7e43554a2)[value].defaultMessage,
                    value: value,
                    queryParamValue: value,
                    product: config.product
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return [
                {
                    trackingKey: (0, $cZKQq.Sort).Relevance,
                    label: config.intl?.formatMessage((0, $85abfd322db30634$export$b351dad7e43554a2)[(0, $cZKQq.Sort).Relevance]) || (0, $85abfd322db30634$export$b351dad7e43554a2)[(0, $cZKQq.Sort).Relevance].defaultMessage,
                    value: (0, $cZKQq.Sort).Relevance,
                    isDefault: true,
                    queryParamValue: (0, $cZKQq.Sort).Relevance,
                    product: config.product
                },
                ...$e4011984b6740259$var$SORT_VALUES.map((value)=>({
                        trackingKey: value,
                        label: config.intl?.formatMessage((0, $85abfd322db30634$export$b351dad7e43554a2)[value]) || (0, $85abfd322db30634$export$b351dad7e43554a2)[value].defaultMessage,
                        value: value,
                        queryParamValue: value,
                        product: config.product
                    }))
            ];
        }
    },
    sortCompareFn: $e4011984b6740259$var$sortCompareFn,
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $dvVWp.ProductKeys).Jira || primaryProduct === (0, $dvVWp.ProductKeys).Confluence
});
module.exports["filter"] = $e4011984b6740259$export$3dea766d36a8935f;

});

parcelRegister("6uMwK", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $fd0l2 = parcelRequire("fd0l2");


var $AgYeH = parcelRequire("AgYeH");


var $gfZaP = parcelRequire("gfZaP");


var $evHnc = parcelRequire("evHnc");


var $b0Mpu = parcelRequire("b0Mpu");

const $dbe7ebdea6f4550c$var$LOOM_SPACES_BY_IDS_OPERATION_NAME = 'LoomRovoSpacesByIdsQuery';
const $dbe7ebdea6f4550c$var$loomSpacesByIdsQuery = `
	query ${$dbe7ebdea6f4550c$var$LOOM_SPACES_BY_IDS_OPERATION_NAME}($ids: [ID!]!) {
		loom_spaces(ids: $ids) {
			id
			name
			url
		}
	}
`;
const $dbe7ebdea6f4550c$export$d3c2717269e16428 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>(0, $b0Mpu.fetchAgg)({
        variables: variables,
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $dbe7ebdea6f4550c$var$loomSpacesByIdsQuery,
        operationName: $dbe7ebdea6f4550c$var$LOOM_SPACES_BY_IDS_OPERATION_NAME,
        headers: headers
    });





const $cd2b541f50707893$var$LOOM_SPACES_SEARCH_OPERATION_NAME = 'LoomRovoSpacesSearchQuery';
const $cd2b541f50707893$var$loomSpacesSearchQuery = `
	query ${$cd2b541f50707893$var$LOOM_SPACES_SEARCH_OPERATION_NAME}($siteId: ID!, $query: String) {
		loom_spacesSearch(siteId: $siteId, query: $query) {
			id
			name
			url
		}
	}
`;
const $cd2b541f50707893$var$trimToLimit = (result, limit)=>typeof limit === 'number' ? {
        ...result,
        data: result.data ? {
            ...result.data,
            loom_spacesSearch: result.data.loom_spacesSearch.slice(0, limit)
        } : result.data
    } : result;
const $cd2b541f50707893$export$79bd8211418f2310 = async ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const { siteId: siteId, query: query, limit: limit } = variables;
    const response = await (0, $b0Mpu.fetchAgg)({
        variables: {
            siteId: siteId,
            query: query
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $cd2b541f50707893$var$loomSpacesSearchQuery,
        operationName: $cd2b541f50707893$var$LOOM_SPACES_SEARCH_OPERATION_NAME,
        headers: headers
    });
    return $cd2b541f50707893$var$trimToLimit(response, limit);
};



var $dv1ov = parcelRequire("dv1ov");


var $kGvYo = parcelRequire("kGvYo");


var $hZCfd = parcelRequire("hZCfd");


var $iviWm = parcelRequire("iviWm");


var $S6W9B = parcelRequire("S6W9B");


var $gByuu = parcelRequire("gByuu");


var $7Ag9o = parcelRequire("7Ag9o");


var $5msm2 = parcelRequire("5msm2");


var $gFWyZ = parcelRequire("gFWyZ");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $03qcI = parcelRequire("03qcI");


var $7MX1N = parcelRequire("7MX1N");


var $kZdMI = parcelRequire("kZdMI");

// TODO: Add Loom in 1P product when backend is ready
const $fd1dea4454c91600$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Confluence
];
const $fd1dea4454c91600$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('space');
const $fd1dea4454c91600$var$getProducts3PFromConfig = ()=>$fd1dea4454c91600$var$products3PFromConfig;
const $fd1dea4454c91600$var$LOOKUP_ENTITIES = [
    'ati:cloud:confluence:space'
];
const $fd1dea4454c91600$var$DEFAULT_LOOM_SPACE_INITIAL_LIMIT = 15;
const $fd1dea4454c91600$var$DEFAULT_LOOM_SPACE_LOOKUP_LIMIT = 15;
const $fd1dea4454c91600$var$isLoomSpaceProduct = (product)=>product === (0, $dvVWp.ProductKeys).Loom && (0, $iDrrr.fg)('loom-rovo-search');
const $fd1dea4454c91600$var$fetchRecommendedSpaceOptionsForSite = async (config, cloudId)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const recommendedSpacesResponse = await (0, $gfZaP.smartsRecommendedContainerQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: cloudId
        },
        headers: headers
    });
    const allRecommendedSpaces = recommendedSpacesResponse.data?.smarts.results?.flatMap(({ container: container })=>{
        if (!(container && container.key)) return [];
        return [
            {
                key: container.key,
                name: container.name,
                ari: container.id,
                avatarUrl: container.links?.base && container.icon?.path ? `${container.links.base}${container.icon.path}` : ''
            }
        ];
    }) || [];
    return allRecommendedSpaces.map((space)=>({
            trackingKey: space.ari,
            value: space.key,
            queryParamValue: space.key,
            avatarUrl: space.avatarUrl,
            label: space.name || '',
            product: config.product
        }));
};
const $fd1dea4454c91600$var$isSingleSelectSpaceProduct = (product)=>(0, $dvVWp.is3pProductKey)(product ?? '') && !$fd1dea4454c91600$var$isLoomSpaceProduct(product);
async function $fd1dea4454c91600$var$searchDcSpaces(query, config) {
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    let spacesResponse = await (0, $dv1ov.confluenceDcSpaceFilterOptionsQuery)({
        variables: {
            query: query,
            cloudIdARI: `ari:cloud:confluence::site/${config.cloudId}`,
            limit: 5,
            entities: (0, $gFWyZ.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
            product: (0, $dvVWp.ProductKeys).ConfluenceDC
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return spacesResponse?.data?.search?.search?.edges?.map(({ node: node })=>({
            trackingKey: node.entity.id,
            value: node.entity.id,
            queryParamValue: node.entity.id,
            avatarUrl: node.entity?.icon?.url,
            label: (0, $7Ag9o.cleanExcerpt)(node.entity.displayName),
            product: config.product
        })) ?? [];
}
async function $fd1dea4454c91600$var$searchThirdPartySpaceOptions(config, query = '') {
    const cloudId = config.cloudId;
    const product = config.product;
    // Get integrationAri from the static ThirdPartyConfigs using the product key.
    // This avoids the dependency on selectedDatasource being populated in the store,
    // which was causing lookup/search to fail when selectedDatasource was undefined.
    const integrationAri = config.selectedDatasource?.integrationAri ?? (0, $fd0l2.ThirdPartyConfigsSync).get(product)?.integrationAri;
    if (!cloudId || !product || !integrationAri) return [];
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const subtypes = product === (0, $dvVWp.ProductKeys).Sharepoint ? [
        (0, $7ydfN.NounSubtypeKey).Site,
        (0, $7ydfN.NounSubtypeKey).Subsite
    ] : [
        (0, $7ydfN.NounSubtypeKey).Space
    ];
    let spacesResponse = await (0, $dv1ov.thirdPartySpaceFilterOptionsQuery)({
        variables: {
            query: query,
            cloudIdARI: [
                `ari:cloud:confluence::site/${cloudId}`
            ],
            limit: 15,
            entities: (0, $gFWyZ.DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI),
            product: product,
            integration: integrationAri,
            subtypes: subtypes
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return spacesResponse?.data?.search?.search?.edges?.map(({ node: node })=>({
            value: node.entity.id,
            trackingKey: node.entity.id,
            queryParamValue: node.entity.id,
            avatarUrl: node.entity?.icon?.url,
            label: (0, $7Ag9o.cleanExcerpt)(node.entity.displayName),
            product: product
        })) ?? [];
}
async function $fd1dea4454c91600$var$fetchLoomSpaceOptions(config, { query: query = '', limit: limit = $fd1dea4454c91600$var$DEFAULT_LOOM_SPACE_INITIAL_LIMIT } = {}) {
    const cloudId = config.cloudId;
    if (!cloudId) return [];
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const spacesResponse = await (0, $cd2b541f50707893$export$79bd8211418f2310)({
        variables: {
            query: query || undefined,
            siteId: cloudId,
            limit: limit
        },
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return spacesResponse?.data?.loom_spacesSearch?.map((space)=>({
            value: space.id,
            trackingKey: space.id,
            queryParamValue: space.id,
            avatarUrl: undefined,
            label: (0, $7Ag9o.cleanExcerpt)(space.name),
            product: (0, $dvVWp.ProductKeys).Loom
        })) ?? [];
}
const $fd1dea4454c91600$var$spaceFilterInitial = {
    id: 'space',
    products: [
        ...$fd1dea4454c91600$var$productKeys1P,
        ...$fd1dea4454c91600$var$getProducts3PFromConfig()
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'spaces',
        fetcher: async (queryParams, config)=>{
            if ($fd1dea4454c91600$var$isLoomSpaceProduct(config.product)) {
                const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                    cloudId: config.cloudId,
                    activationId: config.activationId,
                    product: config.primaryProduct
                });
                const spacesResponse = await (0, $dbe7ebdea6f4550c$export$d3c2717269e16428)({
                    variables: {
                        ids: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                const spacesOptions = spacesResponse?.data?.loom_spaces?.map((space)=>({
                        trackingKey: space.id,
                        value: space.id,
                        label: space.name,
                        avatarUrl: undefined,
                        queryParamValue: space.id,
                        product: config.product
                    }));
                return spacesOptions || [];
            }
            if (config.product === (0, $dvVWp.ProductKeys).ConfluenceDC || config.product === (0, $dvVWp.ProductKeys).GoogleDrive || config.product === (0, $dvVWp.ProductKeys).Sharepoint) {
                const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                    cloudId: config.cloudId,
                    activationId: config.activationId,
                    product: config.primaryProduct
                });
                const spacesResponse = await (0, $dv1ov.spaceARIEntitiesQuery)({
                    variables: {
                        ids: queryParams
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                });
                const spacesOptions = spacesResponse.data?.external_entities?.space?.map((space)=>({
                        trackingKey: space.id,
                        value: space.id,
                        label: space.displayName,
                        avatarUrl: space.icon?.url || '',
                        queryParamValue: space.id,
                        product: config.product
                    }));
                return spacesOptions || [];
            }
            const cloudId = config.cloudId;
            // Practically cloudId should always be present, but we need to satisfy the type checker
            if (!cloudId) return [];
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const response = await (0, $hZCfd.confluenceSpaceKeysToIdsQuery)({
                spaceKeys: queryParams,
                cloudId: cloudId,
                headers: headers
            });
            const spaceIds = response.data?.spaces?.nodes?.map((node)=>node?.id).filter((0, $hea5O.notEmpty)) ?? [];
            const spaceARIs = spaceIds.map((id)=>`ari:cloud:confluence:${cloudId}:space/${id}`);
            const initialSpacesResponse = await (0, $kGvYo.confluenceSpacesQuery)(spaceARIs, headers);
            const allRecommendedSpaces = initialSpacesResponse.data?.confluence.spaces.map((space)=>({
                    key: space.key,
                    name: space.name,
                    ari: space.id,
                    avatarUrl: space.links?.base && space.icon?.path ? `${space.links.base}${space.icon.path}` : ''
                })) || [];
            return allRecommendedSpaces.map((space)=>({
                    trackingKey: space.ari,
                    value: space.key,
                    queryParamValue: space.key,
                    avatarUrl: space.avatarUrl,
                    label: space.name || '',
                    product: config.product
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            if ($fd1dea4454c91600$var$isLoomSpaceProduct(config.product)) return $fd1dea4454c91600$var$fetchLoomSpaceOptions(config, {
                limit: $fd1dea4454c91600$var$DEFAULT_LOOM_SPACE_INITIAL_LIMIT
            });
            if (config.product === (0, $dvVWp.ProductKeys).ConfluenceDC) {
                const spaces = await $fd1dea4454c91600$var$searchDcSpaces('', config);
                return spaces;
            }
            if (config.product === (0, $dvVWp.ProductKeys).GoogleDrive || config.product === (0, $dvVWp.ProductKeys).Sharepoint) return $fd1dea4454c91600$var$searchThirdPartySpaceOptions(config);
            return (0, $iviWm.fetchOptionsAcrossSites)(config, (cloudId)=>$fd1dea4454c91600$var$fetchRecommendedSpaceOptionsForSite(config, cloudId));
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            if ($fd1dea4454c91600$var$isLoomSpaceProduct(config.product)) return $fd1dea4454c91600$var$fetchLoomSpaceOptions(config, {
                query: query,
                limit: $fd1dea4454c91600$var$DEFAULT_LOOM_SPACE_LOOKUP_LIMIT
            });
            if (config.product === (0, $dvVWp.ProductKeys).ConfluenceDC) return $fd1dea4454c91600$var$searchDcSpaces(query, config);
            if (config.product === (0, $dvVWp.ProductKeys).GoogleDrive || config.product === (0, $dvVWp.ProductKeys).Sharepoint) return $fd1dea4454c91600$var$searchThirdPartySpaceOptions(config, query);
            const backendExperiment = config.experimentConfig && (0, $5msm2.getBackendExperiment)({
                experimentConfig: config.experimentConfig,
                entities: $fd1dea4454c91600$var$LOOKUP_ENTITIES,
                productEdition: config.productEdition,
                isHello: (0, $03qcI.isHello)(config.cloudId),
                productDataRegions: config.productDataRegions,
                experience: 'search-page-space-filter',
                tenantId: config.cloudId
            });
            const { experimentLayers: experimentLayers, experimentId: experimentId, shadowExperimentId: shadowExperimentId } = backendExperiment || {};
            const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
                cloudId: config.cloudId,
                activationId: config.activationId,
                product: config.primaryProduct
            });
            const [currentCloudId = '', ...additionalCloudIds] = config.selectedCloudIds ?? [];
            const response = await (0, $evHnc.searchEntitiesQuery)({
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                variables: {
                    query: query,
                    first: 15,
                    filters: {
                        entities: [
                            'ati:cloud:confluence:space'
                        ],
                        // get ARIs for each cloud id
                        locations: (0, $S6W9B.getCloudIdARIs)(currentCloudId, config.primaryProduct, additionalCloudIds)
                    },
                    experience: 'full-page-search-space-filter',
                    experimentId: experimentId,
                    shadowExperimentId: shadowExperimentId,
                    experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                            name: name,
                            layerId: layerId,
                            shadowId: shadowId,
                            definitions: definitions
                        }))
                },
                includeSpaceKey: true,
                headers: headers
            });
            const { data: data } = response;
            if (!data) return [];
            const lookupOptions = data.search?.results.edges.map(({ node: node })=>({
                    trackingKey: node.id || '',
                    value: node.key || '',
                    queryParamValue: node.key ?? '',
                    avatarUrl: node.iconUrl || undefined,
                    label: node.title,
                    product: config.product
                })) ?? [];
            // A space key can repeat across sites (personal spaces share `~<aaid>`), so collapse them
            // into a single option.
            return (0, $gByuu.mergeAndDedupeOptions)([
                lookupOptions
            ]);
        }
    },
    isSuggestedFilter: (primaryProduct)=>primaryProduct === (0, $dvVWp.ProductKeys).Confluence
};
/**
 * Builds the raw (unwrapped) monad for the given state and config, choosing
 * SingleSelectFilter for 3P products and MultiSelectFilter for 1P. Used internally
 * so that withSelectTypeFilter can wrap exactly once — calling filter.withState would
 * double-wrap because filter.withState itself calls withSelectTypeFilter for 3P.
 */ const $fd1dea4454c91600$var$buildSelectFilter = (state, config)=>{
    if ($fd1dea4454c91600$var$isSingleSelectSpaceProduct(config.product)) return (0, $kZdMI.SingleSelectFilter)({
        initial: $fd1dea4454c91600$var$spaceFilterInitial,
        state: {
            ...state,
            type: 'single-select'
        },
        config: config
    });
    return (0, $7MX1N.MultiSelectFilter)({
        initial: $fd1dea4454c91600$var$spaceFilterInitial,
        state: {
            ...state,
            type: 'multi-select'
        },
        config: config
    });
};
/**
 * Ensures every chained monad operation re-dispatches through buildSelectFilter so the
 * correct select type (SingleSelectFilter for 3P, MultiSelectFilter for 1P) is preserved
 * throughout the chain. Without this, base-select-filter operations (loadInitialOptions,
 * setQueryParams, etc.) return a plain SelectFilter monad that always uses multi-select
 * setOption. buildSelectFilter is used instead of filter.withState to avoid double-wrapping:
 * filter.withState for 3P already calls withSelectTypeFilter internally.
 */ const $fd1dea4454c91600$var$withSelectTypeFilter = (spaceFilter, config)=>({
        ...spaceFilter,
        loadInitialOptions: async (onStateChange)=>$fd1dea4454c91600$var$withSelectTypeFilter($fd1dea4454c91600$var$buildSelectFilter((await spaceFilter.loadInitialOptions(onStateChange)).getState(), config), config),
        setOption: (option, customValue)=>$fd1dea4454c91600$var$withSelectTypeFilter($fd1dea4454c91600$var$buildSelectFilter(spaceFilter.setOption(option, customValue).getState(), config), config),
        clearOptions: ()=>$fd1dea4454c91600$var$withSelectTypeFilter($fd1dea4454c91600$var$buildSelectFilter(spaceFilter.clearOptions().getState(), config), config),
        setLookupInput: async (query, onStateChange)=>$fd1dea4454c91600$var$withSelectTypeFilter($fd1dea4454c91600$var$buildSelectFilter((await spaceFilter.setLookupInput(query, onStateChange)).getState(), config), config),
        clear: ()=>$fd1dea4454c91600$var$withSelectTypeFilter($fd1dea4454c91600$var$buildSelectFilter(spaceFilter.clear().getState(), config), config),
        queryParams: {
            ...spaceFilter.queryParams,
            set: async (queryParams, onStateChange)=>$fd1dea4454c91600$var$withSelectTypeFilter($fd1dea4454c91600$var$buildSelectFilter((await spaceFilter.queryParams.set(queryParams, onStateChange)).getState(), config), config)
        }
    });
// Used only for its static shape (id, type, products, queryParams.key, etc.) via the
// spread below. withState and getInitialState are overridden to dispatch per product.
const $fd1dea4454c91600$var$baseFilter = (0, $7MX1N.createMultiSelectFilter)($fd1dea4454c91600$var$spaceFilterInitial);
const $fd1dea4454c91600$export$3dea766d36a8935f = {
    ...$fd1dea4454c91600$var$baseFilter,
    withState: (state, config)=>{
        // buildSelectFilter is the single source of truth for monad construction.
        // For 3P, wrap with withSelectTypeFilter to preserve single-select dispatch
        // through every chained operation; 1P uses MultiSelectFilter directly.
        const monad = $fd1dea4454c91600$var$buildSelectFilter(state, config);
        return $fd1dea4454c91600$var$isSingleSelectSpaceProduct(config.product) ? $fd1dea4454c91600$var$withSelectTypeFilter(monad, config) : monad;
    },
    getInitialState: (config)=>{
        return $fd1dea4454c91600$export$3dea766d36a8935f.withState($fd1dea4454c91600$var$baseFilter.getInitialState(config).getState(), config);
    }
};
module.exports["filter"] = $fd1dea4454c91600$export$3dea766d36a8935f;

});

parcelRegister("gfZaP", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bZF61 = parcelRequire("bZF61");


var $bHHWv = parcelRequire("bHHWv");

const $d12651f8742916d8$var$operationName = 'SmartsRecommendedContainerQuery';
const $d12651f8742916d8$var$SmartsRecommendedContainerQuery = `
query ${$d12651f8742916d8$var$operationName}($userId: String!, $tenantId: String!) {
  smarts {
    results: recommendedContainer(
      recommendationsQuery: {
        context: {
          userId: $userId,
          tenantId: $tenantId,
          product: "confluence"
        },
        modelRequestParams: {
          caller: "full-page-search",
          experience: "CgContainerNearbyUser"
        },
        requestingUserId: $userId
      }
    ) {
      id
      score
      container {
        createdDate
        id
        key
        name
        spaceId
        status
        type
        links {
          base
        }
        icon {
          path
        }
      }
    }
  }
}
`;
const $d12651f8742916d8$export$69a3209f1a06c04d = (0, $bHHWv.inMemoryCache)();
// Expire the cache if there are errors or edges are empty
const $d12651f8742916d8$var$expireWhen = (result)=>{
    const { data: data, errors: errors } = result;
    if (!data || errors && errors.length > 0) return true;
    const { results: results } = data.smarts;
    return !results || results.length === 0;
};
const $d12651f8742916d8$export$9d6625cf80401405 = ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>$d12651f8742916d8$export$69a3209f1a06c04d.inMemoryDecorator((0, $bZF61.generateHashFromVariables)(variables), ()=>(0, $b0Mpu.fetchAgg)({
            variables: variables,
            aggAbsoluteUrl: aggAbsoluteUrl,
            graphQuery: $d12651f8742916d8$var$SmartsRecommendedContainerQuery,
            operationName: $d12651f8742916d8$var$operationName,
            headers: headers
        }), $d12651f8742916d8$var$expireWhen);
module.exports["smartsRecommendedContainerQuery"] = $d12651f8742916d8$export$9d6625cf80401405;

});

parcelRegister("kGvYo", function(module, exports) {

var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $24a422ec0db16ecd$export$f400862b5c7e6c62 = (0, $bHHWv.inMemoryCache)();
const $24a422ec0db16ecd$var$GQL_CF_SPACES_OPERATION_NAME = 'SearchPageConfluenceSpacesQuery';
const $24a422ec0db16ecd$var$getConfluenceSpacesQuery = ()=>`
query ${$24a422ec0db16ecd$var$GQL_CF_SPACES_OPERATION_NAME}($spaceIds: [ID]!) {
  confluence {
    spaces(ids: $spaceIds) {
      id
      spaceId
      name
      key
      links {
        base
      }
      icon {
        path
      }
    }
  }
}
`;
const $24a422ec0db16ecd$export$d8fbf668d55936f8 = (spaceIds, headers)=>{
    return $24a422ec0db16ecd$export$f400862b5c7e6c62.inMemoryDecorator(// TODO: >>>> Limit this to a max string length
    // TODO: Refactor so that it can cache per page id
    spaceIds.join(','), async ()=>{
        if (spaceIds.length === 0) return {
            data: {
                confluence: {
                    spaces: []
                }
            }
        };
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $24a422ec0db16ecd$var$getConfluenceSpacesQuery(),
            variables: {
                spaceIds: spaceIds
            },
            operationName: $24a422ec0db16ecd$var$GQL_CF_SPACES_OPERATION_NAME,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluenceSpacesQuery"] = $24a422ec0db16ecd$export$d8fbf668d55936f8;

});

parcelRegister("hZCfd", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $b0Mpu = parcelRequire("b0Mpu");


var $bHHWv = parcelRequire("bHHWv");

const $185f2d8a8f5258a3$var$spacesCache = (0, $bHHWv.inMemoryCache)();
const $185f2d8a8f5258a3$var$GRAPHQL_OPERATION_NAME = 'ConfluenceSpaceKeysToIdsQuery';
const $185f2d8a8f5258a3$var$getConfluenceSpaceKeysToIdsQuery = (useAgg)=>useAgg ? `
query ${$185f2d8a8f5258a3$var$GRAPHQL_OPERATION_NAME}($cloudId: ID!, $spaceKeys: [String]) {
  spaces(cloudId: $cloudId, spaceKeys: $spaceKeys) {
    nodes {
      id
    }
  }
}
` : `
query ${$185f2d8a8f5258a3$var$GRAPHQL_OPERATION_NAME}($spaceKeys: [String]) {
  spaces(spaceKeys: $spaceKeys) {
    nodes {
      id
    }
  }
}
`;
const $185f2d8a8f5258a3$export$726cc5bea9d2607e = ({ spaceKeys: spaceKeys, cloudId: cloudId, headers: headers })=>{
    return $185f2d8a8f5258a3$var$spacesCache.inMemoryDecorator(`${spaceKeys.join(',')}-${cloudId}`, async ()=>{
        const useAgg = (0, $iDrrr.fg)('rovo_search_confluence_graphql_via_agg');
        const response = await (0, $b0Mpu.fetchAgg)({
            graphQuery: $185f2d8a8f5258a3$var$getConfluenceSpaceKeysToIdsQuery(useAgg),
            variables: useAgg ? {
                cloudId: cloudId,
                spaceKeys: spaceKeys
            } : {
                spaceKeys: spaceKeys
            },
            operationName: $185f2d8a8f5258a3$var$GRAPHQL_OPERATION_NAME,
            // AGG serves Confluence GraphQL from the default gateway endpoint. When the gate is off we
            // override the URL to cc-graphql, which carries `cloudId` in the path instead.
            aggAbsoluteUrl: useAgg ? undefined : `/gateway/api/ex/confluence/${cloudId}/graphql`,
            headers: headers
        });
        const hasErrors = response.errors?.some((error)=>error);
        if (hasErrors) return Promise.reject(response);
        return response;
    });
};
module.exports["confluenceSpaceKeysToIdsQuery"] = $185f2d8a8f5258a3$export$726cc5bea9d2607e;

});

parcelRegister("4LpMn", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $hggbF = parcelRequire("hggbF");


var $7MX1N = parcelRequire("7MX1N");


var $kSwu1 = parcelRequire("kSwu1");

const $88db50376767ed86$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    OPEN: {
        id: "search-page.filter.status.open",
        defaultMessage: "Open"
    },
    DONE: {
        id: "search-page.filter.status.done",
        defaultMessage: "Done"
    },
    INDETERMINATE: {
        id: "search-page.filter.status.indeterminate",
        defaultMessage: "In Progress (Open)"
    },
    UNDEFINED: {
        id: "search-page.filter.status.undefined",
        defaultMessage: "Other"
    },
    NEW: {
        id: "search-page.filter.status.new",
        defaultMessage: "To Do (Open)"
    }
});


const $ced47b91345aac9d$var$getProductKeys1P = ()=>{
    return [
        (0, $dvVWp.ProductKeys).Jira,
        (0, $dvVWp.ProductKeys).JiraProductDiscovery,
        (0, $dvVWp.ProductKeys).JiraServiceManagement
    ];
};
const $ced47b91345aac9d$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('statusFilter');
const $ced47b91345aac9d$var$getAllIssueStatusOptions = (config)=>{
    // Only use allowedJiraIssueStatuses values for Jira issue statuses or else it will be ignored in
    // the GraphQL query request. See the getJiraIssueStatusFilterOptions function.
    const options = (0, $hggbF.allowedJiraIssueStatuses).filter((status)=>status !== 'OPEN').map((issueStatus)=>({
            value: issueStatus,
            trackingKey: issueStatus,
            queryParamValue: issueStatus,
            isDefault: false,
            label: config.intl?.formatMessage((0, $88db50376767ed86$export$a7357cdd1f0b0168)[issueStatus]) ?? '',
            product: config.product,
            isSelected: false,
            isSuggested: false
        }));
    return options;
};
const $ced47b91345aac9d$var$fetchQueryParams = (queryParams, config)=>{
    const allOptions = $ced47b91345aac9d$var$getAllIssueStatusOptions(config);
    return allOptions.filter((option)=>queryParams.find((queryParam)=>option.value === queryParam));
};
const $ced47b91345aac9d$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'statusFilter',
    // This also sets the `id=statusFilter` attribute and unfortunately `id=status` contains a global CSS target
    products: [
        ...$ced47b91345aac9d$var$getProductKeys1P(),
        ...$ced47b91345aac9d$var$products3PFromConfig
    ],
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'status',
        fetcher: async (queryParams, config)=>{
            return $ced47b91345aac9d$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $ced47b91345aac9d$var$getAllIssueStatusOptions(config);
        }
    }
});
module.exports["filter"] = $ced47b91345aac9d$export$3dea766d36a8935f;

});

parcelRegister("hw9HX", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $618e602ad32f1056$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $618e602ad32f1056$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('taskStatus');
const $618e602ad32f1056$var$taskStatusProducts = Array.from(new Set([
    ...$618e602ad32f1056$var$salesforceProducts,
    ...$618e602ad32f1056$var$products3PFromConfig
]));
const $618e602ad32f1056$var$fetchDynamicTaskStatusOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const taskStatuses = result.filters.find((f)=>f.name === 'taskStatuses');
        if (!taskStatuses || taskStatuses.values.length === 0) return [];
        return taskStatuses.values.map((taskStatus)=>({
                value: taskStatus.name,
                trackingKey: taskStatus.name,
                queryParamValue: taskStatus.name,
                isDefault: false,
                label: taskStatus.label ?? taskStatus.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch (e) {
        return [];
    }
};
const $618e602ad32f1056$var$fetchTaskStatusOptions = async (config)=>{
    return $618e602ad32f1056$var$fetchDynamicTaskStatusOptions(config);
};
const $618e602ad32f1056$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $618e602ad32f1056$var$fetchTaskStatusOptions(config);
    const selected = new Set(queryParams);
    const result = allOptions.filter((option)=>selected.has(option.queryParamValue));
    return result;
};
const $618e602ad32f1056$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'taskStatus',
    requiresTopLevel3PDatasource: true,
    products: $618e602ad32f1056$var$taskStatusProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'taskStatuses',
        fetcher: async (queryParams, config)=>{
            return $618e602ad32f1056$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $618e602ad32f1056$var$fetchTaskStatusOptions(config);
        }
    }
});
module.exports["filter"] = $618e602ad32f1056$export$3dea766d36a8935f;

});

parcelRegister("hewHt", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $7MX1N = parcelRequire("7MX1N");


var $ekeCA = parcelRequire("ekeCA");

const $52505079f37c2302$var$salesforceProducts = [
    (0, $dvVWp.ProductKeys).Salesforce
];
const $52505079f37c2302$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('taskType');
const $52505079f37c2302$var$taskTypeProducts = Array.from(new Set([
    ...$52505079f37c2302$var$salesforceProducts,
    ...$52505079f37c2302$var$products3PFromConfig
]));
const $52505079f37c2302$var$fetchDynamicTaskTypeOptions = async (config)=>{
    const cloudId = config.cloudId;
    const datasourceId = config.selectedDatasource?.datasourceId;
    if (!cloudId || !datasourceId) return [];
    try {
        const result = await (0, $ekeCA.getCachedThirdPartyFilterOptions)(config);
        if (!result) return [];
        const taskTypes = result.filters.find((f)=>f.name === 'taskTypes');
        if (!taskTypes || taskTypes.values.length === 0) return [];
        return taskTypes.values.map((taskType)=>({
                value: taskType.name,
                trackingKey: taskType.name,
                queryParamValue: taskType.name,
                isDefault: false,
                label: taskType.label ?? taskType.name,
                product: config.product,
                isSelected: false,
                isSuggested: false
            }));
    } catch (e) {
        return [];
    }
};
const $52505079f37c2302$var$fetchQueryParams = async (queryParams, config)=>{
    const allOptions = await $52505079f37c2302$var$fetchDynamicTaskTypeOptions(config);
    const selected = new Set(queryParams);
    const result = allOptions.filter((option)=>selected.has(option.queryParamValue));
    return result;
};
const $52505079f37c2302$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'taskType',
    requiresTopLevel3PDatasource: true,
    products: $52505079f37c2302$var$taskTypeProducts,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'taskTypes',
        fetcher: async (queryParams, config)=>{
            return $52505079f37c2302$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $52505079f37c2302$var$fetchDynamicTaskTypeOptions(config);
        }
    }
});
module.exports["filter"] = $52505079f37c2302$export$3dea766d36a8935f;

});

parcelRegister("lgtmw", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $6uNXh = parcelRequire("6uNXh");

const $ef172d69004c3216$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Confluence
];
const $ef172d69004c3216$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('onlyTitleMatch');
const $ef172d69004c3216$export$3dea766d36a8935f = (0, $6uNXh.createBooleanFilter)({
    id: 'onlyTitleMatch',
    queryParams: {
        key: 'titleMatch'
    },
    products: [
        ...$ef172d69004c3216$var$productKeys1P,
        ...$ef172d69004c3216$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $ef172d69004c3216$export$3dea766d36a8935f;

});

parcelRegister("5QRIQ", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $6uNXh = parcelRequire("6uNXh");

const $200179514a8b8d5f$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Confluence
];
const $200179514a8b8d5f$var$products3PFromConfig = (0, $hea5O.getProducts3PFromConfigForFilter)('verified');
const $200179514a8b8d5f$export$3dea766d36a8935f = (0, $6uNXh.createBooleanFilter)({
    id: 'verified',
    queryParams: {
        key: 'verified'
    },
    products: [
        ...$200179514a8b8d5f$var$productKeys1P,
        ...$200179514a8b8d5f$var$products3PFromConfig
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $200179514a8b8d5f$export$3dea766d36a8935f;

});

parcelRegister("bI3lU", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $6uNXh = parcelRequire("6uNXh");

const $547f24803e7bddf5$var$productKeys1P = [
    (0, $dvVWp.ProductKeys).Jira,
    (0, $dvVWp.ProductKeys).JiraProductDiscovery,
    (0, $dvVWp.ProductKeys).JiraServiceManagement
];
const $547f24803e7bddf5$export$3dea766d36a8935f = (0, $6uNXh.createBooleanFilter)({
    id: 'watchedByMe',
    queryParams: {
        key: 'jWatchedByMe'
    },
    products: [
        ...$547f24803e7bddf5$var$productKeys1P
    ],
    alwaysVisible: true,
    universal: false
});
module.exports["filter"] = $547f24803e7bddf5$export$3dea766d36a8935f;

});

parcelRegister("clTf7", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $b0Mpu = parcelRequire("b0Mpu");


var $bDWrn = parcelRequire("bDWrn");

// Computed once at module load — the query string has no dynamic parts
const $6fd4f3728c8eee10$var$TEAMS_WORKSPACE_GRAPH_QUERY = (0, $bDWrn.teamsWorkspaceFilterOptionsQueryGenerator)();
const $6fd4f3728c8eee10$var$TEAMS_INTEGRATION_ARI = 'ari:cloud:platform::integration/microsoft';
const $6fd4f3728c8eee10$var$TEAMS_CONVERSATION_ENTITY_ATI = 'ati:cloud:graph:conversation';
const $6fd4f3728c8eee10$var$MAX_WORKSPACE_RESULTS = 30;
const $6fd4f3728c8eee10$export$2bb68a7d2eeb3442 = async ({ cloudId: cloudId, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    const response = await (0, $b0Mpu.fetchAgg)({
        graphQuery: $6fd4f3728c8eee10$var$TEAMS_WORKSPACE_GRAPH_QUERY,
        operationName: (0, $bDWrn.teamsWorkspaceFilterOptionsOperationName),
        variables: {
            query: '',
            cloudIdARI: [
                `ari:cloud:confluence::site/${cloudId}`
            ],
            limit: $6fd4f3728c8eee10$var$MAX_WORKSPACE_RESULTS,
            entities: [
                $6fd4f3728c8eee10$var$TEAMS_CONVERSATION_ENTITY_ATI
            ],
            product: 'teams',
            integration: $6fd4f3728c8eee10$var$TEAMS_INTEGRATION_ARI,
            subtypes: [
                'space'
            ]
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        headers: headers
    });
    if (response.errors?.length) throw new Error(`[${(0, $bDWrn.teamsWorkspaceFilterOptionsOperationName)}] GraphQL errors prevented loading MS Teams workspaces`);
    const seen = new Set();
    return response?.data?.search?.search?.edges?.flatMap(({ node: node })=>{
        const workspace = node?.entity?.workspace;
        if (!workspace || seen.has(workspace)) return [];
        seen.add(workspace);
        const result = {
            name: workspace,
            ...node?.entity?.id !== undefined && {
                id: node.entity.id
            }
        };
        return [
            result
        ];
    }) ?? [];
};



var $aCR6W = parcelRequire("aCR6W");


var $bHPvH = parcelRequire("bHPvH");


var $7MX1N = parcelRequire("7MX1N");

/**
 * `workspaceName` filter — maps to `teamsFilters.workspaceName` in the AGG GraphQL schema.
 * Filters Microsoft Teams search results by workspace (team) name.
 *
 * The internal filter id, URL key, folder, and AGG wire field are all `workspaceName`
 * (per the naming convention agreed with the backend — PR 7086 in alexander/xpsearch-aggregator).
 *
 * Team name options are fetched from AGG's `search.configuration.thirdPartyMSTeamsWorkspaces`
 * endpoint (the same pattern as Slack channels via `thirdPartySlackChannels`).
 * Gated behind `rovo_fps_show_workspace_name_filter` (frontend) and
 * `xpsearch-aggregator_teams_team_name_filter` (backend).
 */ const $6e3687d31b29b791$var$products3PFromConfig = (0, $bHPvH.getProducts3PFromConfigForFilter)('workspaceName');
/**
 * Session-level cache: maps cloudId → in-flight or resolved promise of workspace options.
 * This deduplicates concurrent and repeated calls (e.g. queryParams.fetcher + initialOptions.fetcher
 * both fire on page load when a team is pre-selected via URL param).
 * The cache is module-level so it persists for the browser session but resets on page navigation.
 */ const $6e3687d31b29b791$var$workspaceOptionsCache = new Map();
const $6e3687d31b29b791$export$c6346c315d8aa4eb = ()=>$6e3687d31b29b791$var$workspaceOptionsCache.clear();
async function $6e3687d31b29b791$var$doFetchMSTeamsWorkspaces(config, cloudId) {
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        product: config.primaryProduct,
        cloudId: cloudId,
        activationId: config.activationId
    });
    const workspaces = await (0, $6fd4f3728c8eee10$export$2bb68a7d2eeb3442)({
        cloudId: cloudId,
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        headers: headers
    });
    return workspaces.map((workspace)=>({
            value: workspace.name,
            trackingKey: workspace.id ?? workspace.name,
            queryParamValue: workspace.name,
            label: workspace.name,
            isDefault: false,
            isSelected: false,
            isSuggested: false,
            product: config.product
        }));
}
const $6e3687d31b29b791$var$fetchWorkspaceOptions = (config)=>{
    const { cloudId: cloudId } = config;
    if (!cloudId) return Promise.resolve([]);
    // Return cached promise (handles both in-flight dedup and session-level caching).
    // If the fetch returns an empty result or rejects, remove the cache entry so a
    // subsequent open/retry can attempt a fresh fetch rather than returning stale empty results.
    if (!$6e3687d31b29b791$var$workspaceOptionsCache.has(cloudId)) {
        const promise = $6e3687d31b29b791$var$doFetchMSTeamsWorkspaces(config, cloudId);
        $6e3687d31b29b791$var$workspaceOptionsCache.set(cloudId, promise);
        promise.then((workspaces)=>{
            if (workspaces.length === 0) $6e3687d31b29b791$var$workspaceOptionsCache.delete(cloudId);
        }).catch(()=>{
            $6e3687d31b29b791$var$workspaceOptionsCache.delete(cloudId);
        });
    }
    return $6e3687d31b29b791$var$workspaceOptionsCache.get(cloudId);
};
const $6e3687d31b29b791$var$fetchQueryParams = async (queryParams, config)=>{
    // Hydrate selected team names from URL params by client-side filtering
    // the full fetched list — no extra API call needed.
    const allOptions = await $6e3687d31b29b791$var$fetchWorkspaceOptions(config);
    const selected = new Set(queryParams);
    return allOptions.filter((option)=>selected.has(option.queryParamValue));
};
const $6e3687d31b29b791$var$lookupWorkspaces = async (query, config)=>{
    const allOptions = await $6e3687d31b29b791$var$fetchWorkspaceOptions(config);
    if (!query) return allOptions;
    return (0, $aCR6W.fuzzyFilter)(query, allOptions, (option)=>option.label);
};
const $6e3687d31b29b791$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'workspaceName',
    products: $6e3687d31b29b791$var$products3PFromConfig,
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'workspaceName',
        fetcher: async (queryParams, config)=>{
            return $6e3687d31b29b791$var$fetchQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $6e3687d31b29b791$var$fetchWorkspaceOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            return $6e3687d31b29b791$var$lookupWorkspaces(query, config);
        }
    }
});
module.exports["filter"] = $6e3687d31b29b791$export$3dea766d36a8935f;

});

parcelRegister("5sEiG", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v2.0.0 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $4ez2K = parcelRequire("4ez2K");


var $fR63l = parcelRequire("fR63l");


var $3Ydx7 = parcelRequire("3Ydx7");


var $dvVWp = parcelRequire("dvVWp");


var $73Hia = parcelRequire("73Hia");


var $32Eau = parcelRequire("32Eau");

const $35b383f41d621682$var$styles = {
    container: "_2mHwu81Y8M _3iDTPbQ4SZ _0hPCNLDIqT",
    iconBox: "_4bt5LAnQyn _2WAcuGnQyn _0bjKvDKxmn _3iDTPbQ4SZ _0hPCNLDIqT _37wbyuDIqT _39xV02ey7F _0jFU0Vey7F _3YEZNOdnbC"
};
const $35b383f41d621682$export$a9ec35d044cf4cf = ()=>{
    const [primaryProduct] = (0, $32Eau.usePrimaryProduct)();
    const productConfigs = (0, $73Hia.useProductConfigs)();
    const FirstPartyIcon = primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira ? productConfigs[(0, $dvVWp.ProductKeys).Confluence]?.Icon : productConfigs[(0, $dvVWp.ProductKeys).Jira]?.Icon;
    const icons = [
        FirstPartyIcon,
        productConfigs[(0, $fR63l.ProductKeys3P).GoogleDrive]?.Icon,
        productConfigs[(0, $fR63l.ProductKeys3P).Slack]?.Icon
    ].filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4ez2K.Flex), {
        role: "presentation",
        "aria-hidden": "true",
        xcss: $35b383f41d621682$var$styles.container
    }, icons.map((Icon, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            key: index,
            xcss: $35b383f41d621682$var$styles.iconBox
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Icon, {
            size: "xxsmall"
        }))));
};
module.exports["AllAppsIcon"] = $35b383f41d621682$export$a9ec35d044cf4cf;

});

parcelRegister("18jLb", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7akNQ = parcelRequire("7akNQ");


var $fodiz = parcelRequire("fodiz");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $lDUCP = parcelRequire("lDUCP");


var $gPOtu = parcelRequire("gPOtu");


var $32Eau = parcelRequire("32Eau");


var $73Hia = parcelRequire("73Hia");


var $cJff5 = parcelRequire("cJff5");


var $4d3Vs = parcelRequire("4d3Vs");


var $3NbcK = parcelRequire("3NbcK");

const $b5e85212d9d69ad9$var$infoIconStyles = (0, $buxP3.xcss)({
    marginLeft: 'space.050',
    cursor: 'pointer'
});
const $b5e85212d9d69ad9$var$popupTriggerStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
});
const $b5e85212d9d69ad9$var$connectButtonStyles = (0, $buxP3.xcss)({
    marginLeft: 'auto',
    right: 'space.200',
    display: 'flex',
    flexDirection: 'column'
});
const $b5e85212d9d69ad9$var$sidebarStyles = (0, $buxP3.xcss)({
    width: '100%'
});
const $b5e85212d9d69ad9$var$connectTextStyles = (0, $buxP3.xcss)({
    color: 'color.link',
    font: 'font.body',
    fontWeight: 'font.weight.medium',
    ':hover': {
        color: 'color.link.pressed',
        textDecoration: 'underline'
    }
});
const $b5e85212d9d69ad9$var$singleSelectConnectTextStyles = (0, $buxP3.xcss)({
    color: 'color.link',
    font: 'font.body.small',
    fontWeight: 'font.weight.medium',
    ':hover': {
        color: 'color.link.pressed',
        textDecoration: 'underline'
    }
});
const $b5e85212d9d69ad9$export$14011507d36518b5 = ({ product: product, isInline: isInline, trigger: trigger, isOnSearchDialog: isOnSearchDialog, searchQuery: searchQuery, useOAuthHandlers: useOAuthHandlers, useIsUserOAuthed: useIsUserOAuthed, option: option, postAuthAction: postAuthAction, oAuthSource: oAuthSource, datasourceId: datasourceId, thirdPartyConfigs: thirdPartyConfigs, onAppFilterClick: onAppFilterClick })=>{
    const products = (0, $73Hia.useProductConfigs)();
    const [{ cloudId: cloudId }] = (0, $32Eau.useBootstrap)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { userNeedsOAuth: userNeedsOAuth, outboundAuthUrl: outboundAuthUrl } = useIsUserOAuthed(product, datasourceId);
    const fireOAuthHovered = (0, $lDUCP.useFireOAuthHovered)({
        cloudId: cloudId || '',
        product: product || '',
        isOnSearchDialog: isOnSearchDialog,
        thirdPartyConfigs: thirdPartyConfigs || {}
    });
    // For Forge connectors, use workspaceName from thirdPartyConfigs
    const workspaceName = thirdPartyConfigs ? (0, $4d3Vs.getWorkspaceNameFromProduct)(product, thirdPartyConfigs) : undefined;
    const productString = product && workspaceName || product && products[product]?.displayName || '';
    const { onAuthorize: onAuthorize } = useOAuthHandlers({
        product: product,
        successFlagTitle: formatMessage((0, $3NbcK.messages).authorizationSuccess, {
            product: productString
        }),
        failFlagTitle: formatMessage((0, $3NbcK.messages).authorizationFail, {
            product: productString
        }),
        outboundAuthUrl: outboundAuthUrl || '',
        onCompletedAction: ()=>{
            option?.showFilter();
            option?.onSelect();
            postAuthAction?.();
        },
        isOnSearchDialog: isOnSearchDialog,
        query: searchQuery,
        datasourceId: datasourceId
    });
    // This component is a functional wrapper that turns the trigger prop into a connect trigger.
    // if no warning is needed, we just render the trigger
    const isAdminImported = (0, $gPOtu.hasAdminImportedUserLink)(product, thirdPartyConfigs ?? {});
    if (!product || !userNeedsOAuth || !outboundAuthUrl || isAdminImported) return trigger({
        isDisabled: false
    });
    // One-click 3P connect: authorize immediately when the user clicks the trigger.
    const handleClickConnect = ()=>{
        onAppFilterClick?.();
        onAuthorize(oAuthSource);
    };
    const handleConnectHover = ()=>{
        setTimeout(()=>{
            fireOAuthHovered(oAuthSource);
        }, 1000);
    };
    const connectButton = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $b5e85212d9d69ad9$var$connectButtonStyles,
            onMouseEnter: handleConnectHover
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: (0, $cJff5.getUnifiedSearchRightRailEnhancementsExpValue)() === 'single-select' ? $b5e85212d9d69ad9$var$singleSelectConnectTextStyles : $b5e85212d9d69ad9$var$connectTextStyles
        }, formatMessage((0, $3NbcK.messages).connect)));
    };
    const oAuthWarning = isInline ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $b5e85212d9d69ad9$var$infoIconStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fodiz))), {
        label: "oauth warning",
        color: "var(--ds-icon-brand, #1868DB)",
        size: "small"
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, connectButton());
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        onClick: handleClickConnect,
        onMouseEnter: handleConnectHover,
        xcss: [
            $b5e85212d9d69ad9$var$popupTriggerStyles,
            !isInline && !isOnSearchDialog && $b5e85212d9d69ad9$var$sidebarStyles
        ]
    }, trigger({
        oAuthWarning: oAuthWarning,
        isDisabled: true
    })));
};
const $b5e85212d9d69ad9$export$3415e5401c1f1ae1 = (props)=>{
    return props.isOnSearchDialog || props.skipFlagsProvider ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b5e85212d9d69ad9$export$14011507d36518b5, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7akNQ.FlagsProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($b5e85212d9d69ad9$export$14011507d36518b5, props));
};
module.exports["OAuthWarningWrapper"] = $b5e85212d9d69ad9$export$3415e5401c1f1ae1;

});

parcelRegister("4d3Vs", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");

const $2b5540a240ad455b$export$ee0bd2121a6df2d5 = (product, thirdPartyConfigs)=>{
    let workspaceName;
    if (product && thirdPartyConfigs) {
        // Check if it's a 3P product or Forge connector
        const is3POrForge = (0, $dvVWp.is3pProductKey)(product) || (0, $8fNUp.isForgeConnectorProductKey)(product);
        if (is3POrForge) {
            const config = thirdPartyConfigs[product];
            const shouldDisplayWorkspaceName = config?.displayWorkspaceNameAsProductName;
            const shouldUseFanOutConnector = config?.fanOutConnectorSources;
            if (shouldDisplayWorkspaceName || shouldUseFanOutConnector) workspaceName = config?.workspaceName;
        }
    }
    return workspaceName;
};
module.exports["getWorkspaceNameFromProduct"] = $2b5540a240ad455b$export$ee0bd2121a6df2d5;

});

parcelRegister("3NbcK", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $dd0e54d48a3704f9$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    dismiss: {
        id: "sidebar-oauth-warning-dismiss",
        defaultMessage: "Dismiss"
    },
    authorize: {
        id: "sidebar-oauth-warning-authorize",
        defaultMessage: "Authorize"
    },
    authorizationFail: {
        id: "sidebar-oauth-warning.authorization-fail",
        defaultMessage: "Failed to connect to {product}."
    },
    authorizationSuccess: {
        id: "sidebar-oauth-warning.authorization-success",
        defaultMessage: "Successfully connected to {product}."
    },
    connect: {
        id: "sidebar-oauth-warning.connect",
        defaultMessage: "Connect"
    },
    appFilterTooltipContent: {
        id: "sidebar-oauth-warning.app-filter-tooltip-content",
        defaultMessage: "Connect your account to see missing results, including documents only you have access to."
    },
    appFilterTooltipContentAlternate: {
        id: "sidebar-oauth-warning.app-filter-tooltip-content-alternate",
        defaultMessage: "Connect your account to see missing results, including content only you have access to."
    }
});
module.exports["messages"] = $dd0e54d48a3704f9$export$defe85febe8b728c;

});

parcelRegister("2MNU9", function(module, exports) {
const $d83e8fbab81fac23$export$abf7f7ce81b5b4bb = ({ action: action, actionSubjectId: actionSubjectId, attributes: attributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes })=>({
        eventType: 'track',
        action: action,
        actionSubject: 'appSelector',
        actionSubjectId: actionSubjectId,
        attributes: attributes,
        nonPrivacySafeAttributes: nonPrivacySafeAttributes
    });
module.exports["onAppFilterSelect"] = $d83e8fbab81fac23$export$abf7f7ce81b5b4bb;

});

parcelRegister("iUD7b", function(module, exports) {
const $516ef5a78afb181c$export$ba5ea5559df2d439 = {
    DROPDOWN: 'dropdown',
    INLINE: 'inline',
    DROPDOWN_FPS: 'dropdown-search-page',
    INLINE_FPS: 'inline-search-page',
    INLINE_FPS_SUGGESTION: 'inline-search-page-suggestion'
};
const $516ef5a78afb181c$export$ef6638e4a0319a7a = ({ attributes: attributes, action: action, location: location, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: action,
        actionSubject: 'filter',
        actionSubjectId: actionSubjectId,
        attributes: {
            ...attributes,
            location: location
        }
    });
const $516ef5a78afb181c$export$37ec8c521d184f25 = ({ attributes: attributes, action: action, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: action,
        actionSubject: 'filterDropdown',
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
const $516ef5a78afb181c$export$9c0c40377c27961c = ({ attributes: attributes, location: location, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: 'clear',
        actionSubject: 'filter',
        actionSubjectId: actionSubjectId,
        attributes: {
            ...attributes,
            location: location
        }
    });
const $516ef5a78afb181c$export$5e2091b35b0526ca = ({ attributes: attributes, location: location, actionSubjectId: actionSubjectId })=>({
        eventType: 'ui',
        action: 'clear',
        actionSubject: 'filter',
        actionSubjectId: actionSubjectId,
        attributes: {
            ...attributes,
            location: location
        }
    });
module.exports["FILTER_CHANGE_LOCATION"] = $516ef5a78afb181c$export$ba5ea5559df2d439;
module.exports["onFilterSelection"] = $516ef5a78afb181c$export$ef6638e4a0319a7a;
module.exports["onFilterDropdown"] = $516ef5a78afb181c$export$37ec8c521d184f25;
module.exports["onFilterClear"] = $516ef5a78afb181c$export$9c0c40377c27961c;
module.exports["onSingleFilterClear"] = $516ef5a78afb181c$export$5e2091b35b0526ca;

});

parcelRegister("59z6f", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $3izAL = parcelRequire("3izAL");

var $buxP3 = parcelRequire("buxP3");


var $l9ukq = parcelRequire("l9ukq");

const $db9abd3eac45bf16$var$boxStyles = (0, $buxP3.xcss)({
    borderRadius: 'radius.small',
    boxSizing: 'border-box'
});
const $db9abd3eac45bf16$export$7a7fa4424cb20976 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, props.selectProps.isSearchable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        paddingInline: "space.100",
        paddingBlockStart: "space.100",
        xcss: $db9abd3eac45bf16$var$boxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).Control, props)));
module.exports["Control"] = $db9abd3eac45bf16$export$7a7fa4424cb20976;

});

parcelRegister("hJSVF", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");

var $kh0hi = parcelRequire("kh0hi");

var $buxP3 = parcelRequire("buxP3");


var $l9ukq = parcelRequire("l9ukq");


var $h97BQ = parcelRequire("h97BQ");




const $088d3ebf631e3239$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    searchClearFilterLabel: {
        id: "search-page.filter.clear.filter.label",
        defaultMessage: "Clear filter"
    }
});


const $3d1cb7e3c0b71576$var$clearFilterOptionsButtonStyles = (0, $buxP3.xcss)({
    background: "var(--ds-background-input, #FFFFFF)",
    color: 'color.text.subtle',
    border: 'none',
    paddingLeft: 'space.250',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '36px',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.input.hovered'
    },
    ':disabled': {
        color: 'color.text.accent.gray',
        cursor: 'default'
    }
});
const $3d1cb7e3c0b71576$var$ClearFilterOptionsButton = ({ onClick: onClick, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
        onClick: onClick,
        xcss: $3d1cb7e3c0b71576$var$clearFilterOptionsButtonStyles
    }, children);
};
const $3d1cb7e3c0b71576$var$menuFooterStyles = (0, $buxP3.xcss)({
    borderTop: `${"var(--ds-border, #0B120E24)"} solid ${"var(--ds-border-width, 1px)"}`
});
const $3d1cb7e3c0b71576$export$383d5f7db11e21ca = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).MenuList, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $3d1cb7e3c0b71576$var$menuFooterStyles
    }, props.selectProps.canClearFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($3d1cb7e3c0b71576$var$ClearFilterOptionsButton, {
        onClick: ()=>props.selectProps.onClearOptions()
    }, formatMessage((0, $088d3ebf631e3239$export$a7357cdd1f0b0168).searchClearFilterLabel))));
};
const $3d1cb7e3c0b71576$export$d1b6a8b216735e8c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l9ukq.components).MenuList, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $3d1cb7e3c0b71576$var$menuFooterStyles
    }, props.selectProps.canClearFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h97BQ.default), {
        onClick: ()=>props.selectProps.onClearOptions()
    })));
};
module.exports["MenuListWithClearFilterOptionLabel"] = $3d1cb7e3c0b71576$export$383d5f7db11e21ca;
module.exports["MenuListWithoutClearFilterOptionLabel"] = $3d1cb7e3c0b71576$export$d1b6a8b216735e8c;

});

parcelRegister("h97BQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $kh0hi = parcelRequire("kh0hi");

var $6Pqow = parcelRequire("6Pqow");

var $buxP3 = parcelRequire("buxP3");




const $d4f2f1e3dea3bfde$export$defe85febe8b728c = (0, $kSwu1.defineMessages)({
    clearFilterButtonLabel: {
        id: "search-page.common.ui.clear-filter-button.label",
        defaultMessage: "Clear filter"
    }
});


const $4adc7ddcca943e4e$var$ClearFilterButton = ({ text: text = (0, $d4f2f1e3dea3bfde$export$defe85febe8b728c).clearFilterButtonLabel, xcss: xcss, ...props })=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kh0hi.Pressable), {
        ...props,
        xcss: [
            $4adc7ddcca943e4e$var$clearFilterOptionsButtonStyles,
            xcss
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.Text), null, formatMessage(text)));
};
var $4adc7ddcca943e4e$export$2e2bcd8739ae039 = $4adc7ddcca943e4e$var$ClearFilterButton;
const $4adc7ddcca943e4e$var$clearFilterOptionsButtonStyles = (0, $buxP3.xcss)({
    background: "var(--ds-background-input, #FFFFFF)",
    color: 'color.text.subtle',
    border: 'none',
    paddingLeft: 'space.250',
    font: 'inherit',
    cursor: 'pointer',
    outline: 'inherit',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '36px',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.input.hovered'
    },
    ':disabled': {
        color: 'color.text.accent.gray',
        cursor: 'default'
    }
});
module.exports["default"] = $4adc7ddcca943e4e$export$2e2bcd8739ae039;

});

parcelRegister("dr3fs", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $arQY7 = parcelRequire("arQY7");


var $3izAL = parcelRequire("3izAL");

var $kA6Zo = parcelRequire("kA6Zo");

var $2wCqQ = parcelRequire("2wCqQ");

var $buxP3 = parcelRequire("buxP3");


var $aHeLI = parcelRequire("aHeLI");

const $2998698cd9cb315b$var$optionTextWrapperStyles = (0, $buxP3.xcss)({
    font: 'font.body',
    marginLeft: 'space.100',
    color: 'color.text',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $2998698cd9cb315b$var$renderOptionLabelText = (label)=>typeof label === 'string' ? (0, $aHeLI.enrichExcerpt)(label) : label;
const $2998698cd9cb315b$export$2cf7ef1e2dd6c6b1 = ({ option: option, state: state, children: children })=>{
    const renderedLabel = $2998698cd9cb315b$var$renderOptionLabelText(option.label);
    if (state.context === 'menu' || state.context === 'value') {
        const spaces = {
            menu: 'space.050',
            value: undefined
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.Stack), {
            space: spaces[state.context]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kA6Zo.Flex), {
            alignItems: "center"
        }, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
            xcss: $2998698cd9cb315b$var$optionTextWrapperStyles
        }, renderedLabel)));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.Box), {
        xcss: $2998698cd9cb315b$var$optionTextWrapperStyles
    }, renderedLabel);
};
const $2998698cd9cb315b$export$100d0de045bdee7c = (Component)=>(option, state)=>{
        const props = {
            option: option,
            state: state
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2998698cd9cb315b$export$2cf7ef1e2dd6c6b1, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(Component, props));
    };
const $2998698cd9cb315b$var$AvatarOptionLabel = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $arQY7.default), {
        src: props.option.avatarUrl,
        appearance: "circle",
        size: "small",
        borderColor: "none"
    });
const $2998698cd9cb315b$export$aaa1dc33930567f9 = $2998698cd9cb315b$export$100d0de045bdee7c($2998698cd9cb315b$var$AvatarOptionLabel);
module.exports["createOptionLabelFormatter"] = $2998698cd9cb315b$export$100d0de045bdee7c;
module.exports["formatAvatarOptionLabel"] = $2998698cd9cb315b$export$aaa1dc33930567f9;

});

parcelRegister("aHeLI", function(module, exports) {
/**
 * This file was adapted from confluence/next/packages/search-utils/src/excerpt.tsx
 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");

var $4aRua = parcelRequire("4aRua");


var $4eSGu = parcelRequire("4eSGu");


var $3Z7rz = parcelRequire("3Z7rz");


var $fZV6T = parcelRequire("fZV6T");


var $dTqCf = parcelRequire("dTqCf");


var $480dC = parcelRequire("480dC");


var $7Rtv4 = parcelRequire("7Rtv4");










const $47aad1046588c982$var$SPECIAL_CHARS_REGEX = /^[!#$%^&*() ,.<>?\/\[\]_\-+=`~\|:;{}\\]+/;
const $47aad1046588c982$var$MAX_EXCERPT_LENGTH = 80;
const $47aad1046588c982$export$16c2ab98757b54d6 = (excerpt, noLeadingEllipsis, prefix)=>{
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: "empty"
        }, '')
    ];
    excerpt = (0, $fZV6T.replaceHtmlEntities)(excerpt).trim();
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: "empty"
        }, '')
    ];
    const beginsWithHighlight = excerpt.slice(0, 8) === '@@@hl@@@';
    const beginsWithUrl = excerpt.slice(0, 4) === 'http' || beginsWithHighlight && excerpt.slice(8, 12) === 'http';
    // Strip leading special characters unless the excerpt begins with a highlight
    if (!beginsWithHighlight) excerpt = excerpt.replace($47aad1046588c982$var$SPECIAL_CHARS_REGEX, '');
    // Add ellipsis prefix if beginning of excerpt isn't a URL and excerpt length is greater than 80
    if (!noLeadingEllipsis && !beginsWithUrl && excerpt.length > $47aad1046588c982$var$MAX_EXCERPT_LENGTH) excerpt = '...'.concat(excerpt);
    // Add ellipsis suffix if excerpt doesn't end with ending punctuation and if length is greater than 80
    if (excerpt.length > $47aad1046588c982$var$MAX_EXCERPT_LENGTH && !excerpt.slice(-1).match(/[.!?]/)) excerpt = excerpt.concat('...');
    // Replace line breaks with separators
    excerpt = excerpt.replace(/\n+/g, " \xb7 ");
    return $47aad1046588c982$export$b847312d69858d61(excerpt, prefix);
};
// Utility function to insert zero-width space every N characters
const $47aad1046588c982$var$insertZeroWidthSpace = (str, interval)=>{
    let result = '';
    for(let i = 0; i < str.length; i++){
        result += str[i];
        if ((i + 1) % interval === 0) result += '\u200B';
    }
    return result;
};
const $47aad1046588c982$export$ca7c2d622a259944 = (segment)=>{
    return segment.split(' ').map((word)=>{
        if (word.length > 20) return $47aad1046588c982$var$insertZeroWidthSpace(word, 5);
        return word;
    }).join(' ');
};
const $47aad1046588c982$export$b847312d69858d61 = (excerpt, prefix)=>{
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: "empty"
        }, '')
    ];
    excerpt = (0, $fZV6T.replaceHtmlEntities)(excerpt).trim();
    if (!excerpt) return [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
            key: "empty"
        }, '')
    ];
    const res = [];
    let pre, textMatch;
    let i = 0;
    while(excerpt){
        const match = excerpt.match(RegExp("(.*?)@@@hl@@@(.*?)@@@endhl@@@(.*)", "s"));
        if (!match) {
            res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
                as: "span",
                key: excerpt
            }, $47aad1046588c982$export$ca7c2d622a259944(excerpt)));
            break;
        }
        [, pre, textMatch, excerpt] = match;
        if (pre) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "span",
            key: `pre-${i}`
        }, $47aad1046588c982$export$ca7c2d622a259944(pre)));
        if (textMatch) res.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
            as: "strong",
            key: `textMatch-${i}`
        }, $47aad1046588c982$export$ca7c2d622a259944(textMatch)));
        i++;
    }
    return(// NOTE: wrapping these in <div> previously broke focus rings
    // in search results
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Fragment, null, prefix, res));
};
const $47aad1046588c982$export$fdcae512e9fdc5ad = (timestamp)=>{
    return $47aad1046588c982$export$96e2a37e068d7fac($47aad1046588c982$export$7e0fd00186ff29c6(timestamp));
};
const $47aad1046588c982$export$7e0fd00186ff29c6 = (timestamp)=>{
    if (!timestamp) timestamp = new Date();
    const secondsPast = (0, $dTqCf.secondsSinceDate)(timestamp);
    const timeUnits = {
        seconds: secondsPast,
        minutes: secondsPast / 60,
        hours: secondsPast / 3600,
        days: secondsPast / 86400,
        months: secondsPast / 2592000,
        years: secondsPast / 31536000
    };
    return {
        seconds: Math.floor(timeUnits.seconds),
        minutes: Math.floor(timeUnits.minutes),
        hours: Math.floor(timeUnits.hours),
        days: Math.floor(timeUnits.days),
        months: Math.floor(timeUnits.months),
        years: Math.floor(timeUnits.years)
    };
};
const $47aad1046588c982$export$96e2a37e068d7fac = ({ seconds: seconds, minutes: minutes, hours: hours, days: days, months: months, years: years })=>{
    return $47aad1046588c982$export$3e6e07f5a5b9cd48(seconds, minutes, hours, days, months, years);
};
const $47aad1046588c982$export$3e6e07f5a5b9cd48 = (seconds, minutes, hours, days, months, years)=>{
    if (years > 0) return {
        unit: 'year',
        value: years
    };
    else if (months > 0) return {
        unit: 'month',
        value: months
    };
    else if (days > 0) return {
        unit: 'day',
        value: days
    };
    else if (hours > 0) return {
        unit: 'hour',
        value: hours
    };
    else if (minutes > 0) return {
        unit: 'minute',
        value: minutes
    };
    else return {
        unit: 'second',
        value: seconds
    };
};
const $47aad1046588c982$export$596e547f4ce626bc = (integrationId, user)=>{
    if (!integrationId || !user) return;
    const isSlack = integrationId === 'ari:cloud:platform::integration/slack';
    const isMsTeams = integrationId === 'ari:cloud:platform::integration/microsoft';
    if (isSlack) {
        const openDmUrl = $47aad1046588c982$export$9eb522d6e073fba0(user);
        if (openDmUrl) return {
            integration: 'slack',
            openDmUrl: openDmUrl
        };
    } else if (isMsTeams) {
        const openDmUrl = $47aad1046588c982$export$198aa8f5b10ebb27(user);
        if (openDmUrl) return {
            integration: 'ms-teams',
            openDmUrl: openDmUrl
        };
    }
};
const $47aad1046588c982$export$9eb522d6e073fba0 = (user)=>{
    const externalId = user?.externalId;
    if (!externalId) return;
    return `https://slack.com/app_redirect?channel=${externalId}`;
};
const $47aad1046588c982$export$198aa8f5b10ebb27 = (user)=>{
    const email = user?.email;
    if (!email) return;
    return `https://teams.microsoft.com/l/chat/0/0?users=${email}`;
};
const $47aad1046588c982$export$3856aba7736e125f = 'microsoft';
const $47aad1046588c982$export$c60276faecd0e082 = (integrationKey, resourceType)=>{
    if (integrationKey !== $47aad1046588c982$export$3856aba7736e125f || !resourceType) return undefined;
    if ((0, $480dC.SHAREPOINT_RESOURCE_TYPES).includes(resourceType)) return 'sharepoint';
    if ((0, $7Rtv4.TEAMS_RESOURCE_TYPES).includes(resourceType)) return 'teams';
    return undefined;
};
const $47aad1046588c982$export$42f00afbb84516be = ({ thirdPartyConfigs: thirdPartyConfigs, providerId: providerId, integrationId: integrationId, resourceType: resourceType })=>{
    const integrationKey = (0, $4eSGu.getIntegrationKey)(integrationId);
    return(// Last-resort fallback: returns the raw integration key (e.g. 'slack', 'github').
    // For Microsoft products without a matching resourceType (e.g. OneDrive), this returns
    // 'microsoft' which has no displayName — intentional, as we can't disambiguate further.
    (0, $3Z7rz.getProductFromProviderId)(thirdPartyConfigs, providerId) || $47aad1046588c982$export$c60276faecd0e082(integrationKey, resourceType) || integrationKey);
};
module.exports["processExcerpt"] = $47aad1046588c982$export$16c2ab98757b54d6;
module.exports["enrichExcerpt"] = $47aad1046588c982$export$b847312d69858d61;
module.exports["getRelativeTimeSince"] = $47aad1046588c982$export$fdcae512e9fdc5ad;
module.exports["getExternalMessageDmIntegrationInfo"] = $47aad1046588c982$export$596e547f4ce626bc;
module.exports["MICROSOFT_INTEGRATION_KEY"] = $47aad1046588c982$export$3856aba7736e125f;
module.exports["getProductFromMicrosoftResourceType"] = $47aad1046588c982$export$c60276faecd0e082;
module.exports["get3PProductFromProviderIdOrIntegrationId"] = $47aad1046588c982$export$42f00afbb84516be;

});

parcelRegister("4eSGu", function(module, exports) {

var $4UwFu = parcelRequire("4UwFu");

const $be776f71a1b59fdb$export$fb63ba58603395b8 = (integrationId)=>{
    try {
        const integrationKey = integrationId ? (0, $4UwFu.PlatformIntegrationAri).parse(integrationId).integrationKey : undefined;
        if (integrationKey === 'jira-dc-secondary' || integrationKey === 'jira-dc-tertiary') return 'jira-dc';
        return integrationKey;
    } catch  {
        // TODO QS-7368 log exception for invalid integration IDs
        return undefined;
    }
};
module.exports["getIntegrationKey"] = $be776f71a1b59fdb$export$fb63ba58603395b8;

});

parcelRegister("4PFuU", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");


var $iDrrr = parcelRequire("iDrrr");


var $7ydfN = parcelRequire("7ydfN");


var $dvVWp = parcelRequire("dvVWp");


var $cJff5 = parcelRequire("cJff5");


var $1i979 = parcelRequire("1i979");


var $6zZLZ = parcelRequire("6zZLZ");


var $bL3N3 = parcelRequire("bL3N3");





var $9pcjO = parcelRequire("9pcjO");

const $898f39b25c1cf4af$export$6d20082d2748aae3 = (params)=>{
    if (params.selectedProducts.length > 0) return params.selectedProducts;
    const primaryProduct = params.primaryProduct ?? '';
    const safePrimaryProduct = (0, $dvVWp.isProductKey)(primaryProduct) ? [
        primaryProduct
    ] : undefined;
    if (params.experience === (0, $9pcjO.SearchExperience).QUICK_FIND) return safePrimaryProduct ?? params.availableProducts;
    return params.availableProducts;
};


const $2df3b5a7051df39d$export$ac822ab68badd883 = ({ filterId: filterId, optionValuesToExclude: optionValuesToExclude })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [state, storeActions] = (0, $1i979.useSelectFilterStore)({
        filterId: filterId
    });
    const isDeactivatedContributorEnabled = filterId === 'contributor' && (0, $cJff5.serveAppendDeactivatedAccountToContributorList)();
    const viewActions = {
        setOption: (option, customValue, setSelectedProduct, validateDependentFilterId)=>{
            const options = Array.isArray(option) ? option : [
                option
            ];
            const optionChange = options.map((option)=>({
                    value: option.value,
                    isSelected: !option.isSelected,
                    // Preserve display fields for client-only options (see SelectFilterOptionChange)
                    // so a mined deactivated contributor keeps its label/avatar/metadata once the
                    // store persists it.
                    ...isDeactivatedContributorEnabled ? {
                        label: option.label,
                        avatarUrl: option.avatarUrl,
                        trackingKey: option.trackingKey,
                        queryParamValue: option.queryParamValue,
                        metadata: option.metadata
                    } : {}
                }));
            const productToSelect = (0, $bL3N3.getProductToSelect)({
                isUniversal: state?.universal,
                primaryProduct: state?.primaryProduct ?? undefined,
                productToSet: setSelectedProduct,
                selectedProduct: state?.selectedProducts[0],
                experience: state?.experience
            });
            const customOptions = {
                customValue: customValue,
                setSelectedProduct: productToSelect,
                validateDependentFilterId: validateDependentFilterId
            };
            return storeActions.setSelectFilterOption({
                filterId: filterId,
                optionChange: optionChange,
                ...Object.values(customOptions).some((customOption)=>customOption !== undefined) ? {
                    options: customOptions
                } : {}
            });
        },
        loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                intl: intl,
                filterId: filterId
            }),
        setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: query
            }),
        clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: ''
            }),
        clearOptions: ()=>storeActions.clearSelectFilterOptions({
                filterId: filterId
            })
    };
    if (!state) return [
        ,
        viewActions
    ];
    const filteredOptions = state.options.filter((option)=>{
        if (optionValuesToExclude) return !optionValuesToExclude.includes(option.value);
        return true;
    });
    const selectedOptionsCount = state.selectedOptions.length;
    const viewState = {
        defaultIsOpen: state.alwaysVisible === false,
        isLookupDefined: state.lookup.isDefined,
        isLoading: state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading,
        lookupInput: state.lookup.input,
        options: filteredOptions,
        suggestedOptions: filteredOptions.filter((option)=>!option.isSelected && option.isSuggested),
        selectedOptions: state.selectedOptions,
        isLookupActive: state.lookup.isActive,
        alwaysVisible: state.alwaysVisible,
        customValue: state.customValue,
        badgeLabel: selectedOptionsCount > 1 ? `+${selectedOptionsCount - 1}` : undefined,
        firstSelectedOptionLabel: state.selectedOptions[0]?.label
    };
    return [
        viewState,
        viewActions
    ];
};
const $2df3b5a7051df39d$export$eb312ee1d3a7a748 = ({ filterId: filterId, optionsToProducts: optionsToProducts })=>{
    const intl = (0, $kSwu1.useIntl)();
    const [state, storeActions] = (0, $1i979.useSelectFilterStore)({
        filterId: filterId
    });
    const viewActions = {
        setOption: (option)=>{
            const options = Array.isArray(option) ? option : [
                option
            ];
            const optionChange = options.map((option)=>({
                    value: option.value,
                    isSelected: !option.isSelected
                }));
            const productToSelect = (0, $bL3N3.getProductToSelect)({
                isUniversal: state?.universal,
                primaryProduct: state?.primaryProduct ?? undefined,
                selectedProduct: state?.selectedProducts[0],
                experience: state?.experience
            });
            return storeActions.setSelectFilterOption({
                filterId: filterId,
                optionChange: optionChange,
                options: {
                    setSelectedProduct: productToSelect
                }
            });
        },
        loadInitialOptions: ()=>storeActions.loadInitialSelectFilterOptions({
                filterId: filterId,
                intl: intl
            }),
        setLookupInput: (query)=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: query
            }),
        clearLookupInput: ()=>storeActions.setSelectFilterLookupInput({
                filterId: filterId,
                query: ''
            }),
        clearOptions: ()=>storeActions.clearSelectFilterOptions({
                filterId: filterId
            })
    };
    if (!state) return [
        ,
        viewActions
    ];
    const selectedProductsAvailable = state.selectedProducts.length > 0;
    const productsNew = (0, $898f39b25c1cf4af$export$6d20082d2748aae3)({
        selectedProducts: state.selectedProducts,
        primaryProduct: state.primaryProduct ?? undefined,
        experience: state.experience,
        availableProducts: state.availableProducts
    });
    const products = productsNew;
    const filteredOptions = state.options.filter((option)=>option.isDefault || option.isSelected || optionsToProducts[option.value]?.some((product)=>products.includes(product)))// This is a temporary hack to filter out Atlas specific types, unless Atlas is the selected product
    .filter((option)=>!(state.selectedProducts[0] !== (0, $dvVWp.ProductKeys).Atlas && (option.value === 'goal' || option.value === 'tag')))// Filtering out all options that are tied exclusively to allFilterExcludedProducts for universal types
    .filter((option)=>!selectedProductsAvailable && optionsToProducts[option.value]?.length ? optionsToProducts[option.value].some((product)=>!state.allFilterExcludedProducts.includes(product)) : true);
    const selectedOptions = state.selectedOptions.map((option)=>({
            ...option
        }));
    if (products.length === 1 && products[0] === (0, $dvVWp.ProductKeys).ConfluenceDC && (0, $iDrrr.fg)('confluence_live_pages_open_beta_trait_opted_in')) {
        const isPageOption = (option)=>option.value === (0, $7ydfN.TypeFilterValueKey).Page;
        // Update both filtered and selected options that match Page type
        [
            filteredOptions,
            selectedOptions
        ].flatMap((options)=>options.filter(isPageOption)).forEach((option)=>{
            option.label = intl.formatMessage((0, $6zZLZ.typeLabels).page);
        });
    }
    const viewState = {
        defaultIsOpen: state.alwaysVisible === false,
        isLookupDefined: state.lookup.isDefined,
        isLoading: state.queryParams.isLoading || state.initialOptions.isLoading || state.lookup.isLoading,
        lookupInput: state.lookup.input,
        options: filteredOptions,
        suggestedOptions: filteredOptions.filter((option)=>!option.isSelected && option.isSuggested),
        selectedOptions: selectedOptions,
        isLookupActive: state.lookup.isActive,
        alwaysVisible: state.alwaysVisible
    };
    return [
        viewState,
        viewActions
    ];
};
module.exports["useSelectFilter"] = $2df3b5a7051df39d$export$ac822ab68badd883;
module.exports["useUniversalSelectFilter"] = $2df3b5a7051df39d$export$eb312ee1d3a7a748;

});

parcelRegister("bL3N3", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $9pcjO = parcelRequire("9pcjO");

const $98123a8b5da55e9b$export$a415be24ece1d149 = (params)=>{
    if (params.productToSet || params.isUniversal && // Universal Filters on Quick Find selects the primaryProduct until we do cross product search
    //https://atlassian.slack.com/archives/C050EC6FM28/p1763330594902229?thread_ts=1763092320.695409&cid=C050EC6FM28
    params.experience !== (0, $9pcjO.SearchExperience).QUICK_FIND) return params.productToSet;
    const productToSelect = params.selectedProduct ?? params.primaryProduct ?? '';
    const safeProductKey = (0, $dvVWp.isProductKey)(productToSelect) ? productToSelect : undefined;
    return safeProductKey;
};
module.exports["getProductToSelect"] = $98123a8b5da55e9b$export$a415be24ece1d149;

});

parcelRegister("2xMvQ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $bltJZ = parcelRequire("bltJZ");


var $3Ydx7 = parcelRequire("3Ydx7");




const $c1ca65ed6e8ac22a$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    confluenceIconLabel: {
        id: "rovo-search.confluence.filter.icon.label",
        defaultMessage: "Confluence filter"
    },
    jiraIconLabel: {
        id: "rovo-search.jira.filter.icon.label",
        defaultMessage: "Jira filter"
    },
    assetsIconLabel: {
        id: "rovo-search.assets.filter.icon.label",
        defaultMessage: "Assets filter"
    },
    talentIconLabel: {
        id: "rovo-search.talent.filter.icon.label",
        defaultMessage: "Talent filter"
    }
});


const $a35b0c9ab8dfd460$export$5d27b8605be74adf = (props)=>{
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const { showPrimaryProductIcon: showPrimaryProductIcon, primaryProduct: primaryProduct } = props;
    if (!showPrimaryProductIcon || !primaryProduct) return null;
    if (primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Confluence) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.ConfluenceIcon), {
        shouldUseNewLogoDesign: true,
        label: formatMessage((0, $c1ca65ed6e8ac22a$export$a7357cdd1f0b0168).confluenceIconLabel),
        size: "xxsmall"
    });
    if (primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.JiraIcon), {
        shouldUseNewLogoDesign: true,
        label: formatMessage((0, $c1ca65ed6e8ac22a$export$a7357cdd1f0b0168).jiraIconLabel),
        size: "xxsmall"
    });
    if (primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Assets) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.AssetsIcon), {
        shouldUseNewLogoDesign: true,
        label: formatMessage((0, $c1ca65ed6e8ac22a$export$a7357cdd1f0b0168).assetsIconLabel),
        size: "xxsmall"
    });
    if (primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Talent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bltJZ.TalentIcon), {
        shouldUseNewLogoDesign: true,
        label: formatMessage((0, $c1ca65ed6e8ac22a$export$a7357cdd1f0b0168).talentIconLabel),
        size: "xxsmall"
    });
    // Add more primary product icons here
    return null;
};
module.exports["FilterProductIcon"] = $a35b0c9ab8dfd460$export$5d27b8605be74adf;

});

parcelRegister("5cu3N", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $as9lu = parcelRequire("as9lu");


var $g66Hr = parcelRequire("g66Hr");


var $jZ9Hw = parcelRequire("jZ9Hw");

const $10250bb52907579a$export$4e07a927e22bed0a = ({ query: query, projectARIs: projectARIs, accountARIs: accountARIs })=>{
    let text;
    if (query) {
        // If the query looks like an issue key, use issueKey instead of textfields
        if ((0, $jZ9Hw.isQueryLikeWorkItemKey)(query)) text = `issuekey ~ "${encodeURIComponent(query)}*"`;
        else text = `textfields ~ "${encodeURIComponent(query)}*"`;
    }
    const projectIds = projectARIs.map($10250bb52907579a$var$getProjectIdFromProjectAri).filter(Boolean);
    const projectJQL = projectARIs.length > 0 ? `project IN (${encodeURIComponent(projectIds.join(','))})` : undefined;
    const accountIds = accountARIs.map($10250bb52907579a$var$getAccountIdFromUserAri).filter(Boolean);
    const assigneeClause = accountIds.length > 0 ? `assignee IN (${encodeURIComponent(accountIds.join(','))})` : undefined;
    return [
        text,
        projectJQL,
        assigneeClause
    ].filter(Boolean).join(' AND ');
};
function $10250bb52907579a$var$getProjectIdFromProjectAri(projectAri) {
    try {
        return projectAri ? (0, $g66Hr.JiraProjectAri).parse(projectAri).projectId : undefined;
    } catch  {
        return undefined;
    }
}
function $10250bb52907579a$var$getAccountIdFromUserAri(userAri) {
    try {
        return userAri ? (0, $as9lu.IdentityUserAri).parse(userAri).userId : undefined;
    } catch  {
        return undefined;
    }
}
const $10250bb52907579a$export$23c957892b92c4a0 = ({ query: query, jiraFilters: jiraFilters, generateSearchUrl: generateSearchUrl, queryParams: queryParams = {}, issueKeyLookup: issueKeyLookup, isQueryJql: isQueryJql = false })=>{
    const trimmedQuery = query.trim();
    let jql;
    if (isQueryJql) jql = trimmedQuery;
    else if (trimmedQuery !== '' && (jiraFilters.issueFilter.projectARIs.length !== 0 || jiraFilters.issueFilter.assigneeARIs.length !== 0)) /* If query is empty we don't need to build jql as it will be ignored by generateSearchUrl
		 ** Otherwise, we pass the JQL to be redirected to work items page */ jql = $10250bb52907579a$export$4e07a927e22bed0a({
        query: trimmedQuery,
        accountARIs: jiraFilters.issueFilter.assigneeARIs,
        projectARIs: jiraFilters.issueFilter.projectARIs
    });
    /* generateSearchUrl takes care of navigating to a signle work item page in case the query is a work item key
	 * Otherwise, it'll take the user to work items page.
	 * */ return generateSearchUrl({
        ...queryParams,
        text: query,
        ...jql && {
            jql: jql
        }
    }, true, undefined, undefined, issueKeyLookup);
};
const $10250bb52907579a$export$ddc03b5bf54ec4ae = (query)=>`/jira/search?searchString=${encodeURIComponent(query)}`;
const $10250bb52907579a$export$9b8240b7fc8c64cd = (params)=>{
    const trimmedQuery = params.query.trim();
    if (trimmedQuery === '') return [];
    // Issue-key queries submit to /browse/<KEY> (resolved by backend quicksearch),
    // which can't be prewarmed; prefetching only adds contention to the issue-view load.
    if ((0, $jZ9Hw.isQueryLikeWorkItemKey)(trimmedQuery) && (0, $iDrrr.fg)('quick_find_prefetch_issuekey_guard')) return [];
    const jqlUrl = $10250bb52907579a$export$23c957892b92c4a0({
        ...params,
        query: trimmedQuery,
        issueKeyLookup: false
    });
    return [
        jqlUrl,
        $10250bb52907579a$export$ddc03b5bf54ec4ae(trimmedQuery)
    ];
};
module.exports["buildJql"] = $10250bb52907579a$export$4e07a927e22bed0a;
module.exports["getWorkItemPageUrl"] = $10250bb52907579a$export$23c957892b92c4a0;
module.exports["getWorkItemPrefetchUrls"] = $10250bb52907579a$export$9b8240b7fc8c64cd;

});

parcelRegister("jZ9Hw", function(module, exports) {
const $ceb46d9b15e1a17c$export$e43472a3ada71740 = (query)=>/^[A-Z0-9]{2,}-\d+$/i.test(query.trim());
const $ceb46d9b15e1a17c$var$ISSUE_NAVIGATOR_URL = `/issues/?jql=${encodeURIComponent('created >= -30d order by created DESC')}`;
const $ceb46d9b15e1a17c$var$buildJiraJqlUrl = (jql, query)=>`/issues/?jql=${encodeURIComponent(jql)}&text=${encodeURIComponent(query)}`;
const $ceb46d9b15e1a17c$var$buildJiraSearchUrl = (searchString, issueKeyLookup)=>{
    if (!issueKeyLookup) {
        const clauseField = $ceb46d9b15e1a17c$export$e43472a3ada71740(searchString) ? 'issuekey' : 'textfields';
        return `/issues/?jql=${clauseField} ~ "${encodeURIComponent(searchString)}*"`;
    }
    return `/jira/search?${new URLSearchParams({
        searchString: searchString
    }).toString()}`;
};
const $ceb46d9b15e1a17c$export$772e48b507423c7c = (query, jql, issueKeyLookup)=>{
    const trimmedQuery = query.trim();
    if (jql) return $ceb46d9b15e1a17c$var$buildJiraJqlUrl(jql, query);
    if (trimmedQuery) return $ceb46d9b15e1a17c$var$buildJiraSearchUrl(trimmedQuery, issueKeyLookup);
    return $ceb46d9b15e1a17c$var$ISSUE_NAVIGATOR_URL;
};
const $ceb46d9b15e1a17c$var$buildRovoSearchUrl = (siteUrl)=>{
    const path = '/jira/rovo-search';
    if (!siteUrl) return path;
    return new URL(path, siteUrl || '').href;
};
const $ceb46d9b15e1a17c$export$48bdb02c221fe04 = (urlQueryParams, isSecondaryLink, customParams, issueKeyLookup = true)=>{
    const searchParams = new URLSearchParams(customParams || {});
    // This function assumes the text is in sync with JQL text field
    let queryString = searchParams.get('text') || urlQueryParams.text?.toString() || '';
    const jql = searchParams.get('jql') || !isSecondaryLink && urlQueryParams.jql?.toString() || '';
    // remove jql from params as it's already picked up
    searchParams.delete('jql');
    if (!isSecondaryLink) Object.entries(urlQueryParams).forEach(([key, value])=>{
        // add current params if they are not in custom search params
        if (value !== undefined && value !== null && !searchParams.has(key)) searchParams.set(key, String(value));
    });
    let url = isSecondaryLink ? $ceb46d9b15e1a17c$export$772e48b507423c7c(queryString, jql, issueKeyLookup) : $ceb46d9b15e1a17c$var$buildRovoSearchUrl();
    const params = searchParams.toString();
    if (params) url = url.concat(url.includes('?') ? '&' : '?').concat(params);
    return url;
};
module.exports["isQueryLikeWorkItemKey"] = $ceb46d9b15e1a17c$export$e43472a3ada71740;
module.exports["generateJiraSearchUrl"] = $ceb46d9b15e1a17c$export$48bdb02c221fe04;

});

parcelRegister("8nTVT", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $1Qme9 = parcelRequire("1Qme9");


var $S6W9B = parcelRequire("S6W9B");


var $fnx12 = parcelRequire("fnx12");


var $2ePuQ = parcelRequire("2ePuQ");


var $4ysB6 = parcelRequire("4ysB6");


var $dvVWp = parcelRequire("dvVWp");


var $cJff5 = parcelRequire("cJff5");


var $03qcI = parcelRequire("03qcI");


var $6qPRO = parcelRequire("6qPRO");


var $hggbF = parcelRequire("hggbF");

const $21d1cc4e299beef1$export$62c31c0f13603e08 = (jiraFilters, availableProducts)=>{
    const allAvailableJiraProductTypes = Object.keys((0, $hggbF.JiraProductProjectFilterKey)).reduce((acc, productKey)=>{
        const jiraProductKey = productKey;
        if (!availableProducts || availableProducts.includes(jiraProductKey)) acc.push(...(0, $hggbF.JiraProductProjectFilterKey)[jiraProductKey]);
        return acc;
    }, []);
    return {
        ...jiraFilters,
        projectFilter: {
            ...jiraFilters.projectFilter,
            projectTypes: allAvailableJiraProductTypes
        }
    };
};


// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $03RpJ = parcelRequire("03RpJ");


var $518WI = parcelRequire("518WI");


// DJB2 hash function for JSON objects
function $b5a3e357e30a85ab$var$hashJsonObjectDJB2(jsonObject) {
    // Convert the JSON object to a string
    const jsonString = JSON.stringify(jsonObject);
    // Initialize hash value
    let hash = 5381;
    // Iterate over each character in the string
    for(let i = 0; i < jsonString.length; i++){
        const char = jsonString.charCodeAt(i);
        hash = hash * 33 ^ char; // XOR and multiply by 33
    }
    // Ensure the hash is a positive 32-bit integer
    return (hash >>> 0).toString(16);
}
const $b5a3e357e30a85ab$var$sessionIdsMap = new Map();
function $b5a3e357e30a85ab$export$8b9832780ea0337b(variables) {
    if ($b5a3e357e30a85ab$var$sessionIdsMap.size > 1000) $b5a3e357e30a85ab$var$sessionIdsMap.clear();
    const { sessionId: sessionId, searchSessionId: searchSessionId, ...vars } = variables;
    const queryKey = $b5a3e357e30a85ab$var$hashJsonObjectDJB2(vars);
    const existingSession = $b5a3e357e30a85ab$var$sessionIdsMap.get(queryKey);
    if (existingSession) return existingSession;
    $b5a3e357e30a85ab$var$sessionIdsMap.set(queryKey, [
        sessionId,
        searchSessionId
    ]);
    return [
        sessionId,
        searchSessionId
    ];
}
function $b5a3e357e30a85ab$export$77a5fc99991cbb57() {
    $b5a3e357e30a85ab$var$sessionIdsMap.clear();
}
const $b5a3e357e30a85ab$export$966bb5e577b5d521 = (forceUpdate = false)=>{
    const sessionId = (0, $518WI.SEARCH_SESSION_ID).value();
    if (!sessionId || forceUpdate) // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    (0, $518WI.SEARCH_SESSION_ID).update((0, $03RpJ.default)());
};






var $5msm2 = parcelRequire("5msm2");


var $3ZYG5 = parcelRequire("3ZYG5");

const $5311b2f8ca23af19$export$8c6fefe9b6b2ccd8 = (props)=>{
    const experimentConfig = (0, $3ZYG5.getExperimentConfig)({
        experimentLayers: props.experimentLayers,
        sideBySideExperiment: undefined,
        statsigLayer: undefined,
        onError: props.onError,
        getLayerValuesFn: props.getLayerValuesFn
    });
    const backendExperiment = (0, $5msm2.getBackendExperiment)({
        experimentConfig: experimentConfig,
        entities: props.entities,
        productEdition: props.productEdition,
        isHello: props.isHello,
        productDataRegions: props.productDataRegions,
        experience: props.experienceLayer,
        tenantId: props.cloudId,
        isJiraIssueIndexed: props.isJiraIssueIndexed,
        thirdPartyFilters: props.thirdPartyFilters,
        backendExperimentOverrides: props.backendExperimentOverrides,
        getLayerValuesFn: props.getLayerValuesFn
    });
    const { experimentId: experimentId, shadowExperimentId: shadowExperimentId, experimentLayers: experimentLayers, matchingLayerExperimentsMetadata: matchingLayerExperimentsMetadata } = backendExperiment || {};
    return {
        experimentId: experimentId,
        experimentLayers: experimentLayers,
        matchingLayerExperimentsMetadata: (0, $iDrrr.fg)('search_experiment_layer_metadata') ? matchingLayerExperimentsMetadata : undefined,
        shadowExperimentId: shadowExperimentId,
        fanoutExperimentCohort: 'enable-v2',
        backendExperiment: backendExperiment
    };
};



var $gDBUP = parcelRequire("gDBUP");


var $epRE1 = parcelRequire("epRE1");

const $e3a18b26227074f0$export$8a04e6ddedd0bb29 = ({ queryParams: queryParams, cloudId: cloudId, availableProducts: availableProducts, allFilterExcludedProducts: allFilterExcludedProducts, thirdPartyConfigs: thirdPartyConfigs, currentUserId: currentUserId, jsmIncidentFilterIds: jsmIncidentFilterIds, primaryProduct: primaryProduct })=>{
    const { filters: filters, selectedProducts: selectedProducts, selectedDatasource: selectedDatasource, sites: sites } = (0, $epRE1.getSearchConfig)({
        cloudId: cloudId,
        queryParams: queryParams,
        thirdPartyConfigs: thirdPartyConfigs,
        primaryProduct: primaryProduct
    });
    const selectedFilters = (0, $gDBUP.getSelectedFilters)({
        filters: filters,
        selectedProducts: selectedProducts,
        selectedDatasource: selectedDatasource,
        availableProducts: availableProducts,
        allFilterExcludedProducts: allFilterExcludedProducts,
        thirdPartyConfigs: thirdPartyConfigs,
        currentUserId: currentUserId,
        jsmIncidentFilterIds: jsmIncidentFilterIds
    });
    return {
        selectedProducts: selectedProducts,
        sites: sites,
        ...selectedFilters
    };
};


const $c1b18402330cc36d$export$cd3c83311f418ff4 = ({ queryParams: queryParams })=>{
    if (!queryParams) return {
        searchQuery: '',
        originalQuery: undefined
    };
    const searchQuery = queryParams?.text ?? '';
    const originalQuery = queryParams?.originalQuery;
    return {
        searchQuery: searchQuery,
        originalQuery: originalQuery
    };
};


/**
 * Utility for resolving the `__relay_internal__pv__*` provided variables
 * required by the search-results persisted query.
 *
 * Non-Relay callers (e.g. SSR preload helpers that POST persisted queries
 * directly to AGG) must include these variables in their request body to
 * satisfy the gateway's `Boolean!` NonNull declarations. Historically those
 * callers duplicated the keys as a static map, which silently drifts from
 * the live `.relayprovider` evaluations performed inside the Relay
 * environment.
 *
 * This module is the single source of truth for that resolution. It calls
 * each provider's `get()` at invocation time so feature-gate / experiment
 * results are picked up at runtime (including during SSR, on the
 * assumption that the underlying feature gates are SSR-evaluable). The
 * shape of the returned map is pinned to the generated query artifact by
 * `index.relay-provided-variables.test.ts`.
 *
 * SSR Safety: This function is synchronous, contains no React hooks, and
 * does not touch browser-only globals directly. Each provider's `get()`
 * implementation must uphold the same contract.
 */ 
var $hd5Dy = parcelRequire("hd5Dy");


var $iK48f = parcelRequire("iK48f");


var $8dp6J = parcelRequire("8dp6J");


var $4Pgy4 = parcelRequire("4Pgy4");


var $hFjUk = parcelRequire("hFjUk");


var $b9kI4 = parcelRequire("b9kI4");

const $fb8d04ee47c1bab9$export$722bffef5ff5d4b4 = ()=>({
        __relay_internal__pv__isassetsenabledrelayprovider: (0, $hd5Dy.default).get(),
        __relay_internal__pv__isleadnounenabledrelayprovider: (0, $iK48f.default).get(),
        __relay_internal__pv__isleaduserastitleenabledrelayprovider: (0, $8dp6J.default).get(),
        __relay_internal__pv__isprojectrendererenabledrelayprovider: (0, $b9kI4.default).get(),
        __relay_internal__pv__isslacktopreactionenabledrelayprovider: (0, $4Pgy4.default).get(),
        __relay_internal__pv__isslackworkspacemetadataenabledrelayprovider: (0, $hFjUk.default).get()
    });


const $41b899904a7901a9$export$b83d7680b0db727d = ({ backendExperimentOverrides: backendExperimentOverrides, cloudId: cloudId, experimentLayers: rawExperimentLayers, experience: experience, isJiraIssueIndexed: isJiraIssueIndexed, jsmIncidentFilterIds: jsmIncidentFilterIds, primaryProduct: primaryProduct, productDataRegions: productDataRegions, productEdition: productEdition, products: products, queryParams: queryParams, sessionId: rawSessionId, searchSessionId: rawSearchSessionId, thirdPartyConfigs: thirdPartyConfigs, user: user, onError: onError, getLayerValuesFn: getLayerValuesFn, expectResult: expectResult = true, isLiteMode: isLiteMode = false })=>{
    const { originalQuery: originalQuery, searchQuery: searchQuery } = (0, $c1b18402330cc36d$export$cd3c83311f418ff4)({
        queryParams: queryParams
    });
    const searchableProducts = $41b899904a7901a9$var$getSearchableProducts(searchQuery, products);
    const { entities: entities, entitiesForResultsCountQuery: entitiesForResultsCountQuery, selectedFilters: selectedFilters, selectedProducts: selectedProducts, sites: sites, unselectedProductsThirdPartyFilters: unselectedProductsThirdPartyFilters } = (0, $e3a18b26227074f0$export$8a04e6ddedd0bb29)({
        allFilterExcludedProducts: (0, $4ysB6.ALL_FILTER_EXCLUDED_PRODUCTS),
        availableProducts: products,
        cloudId: cloudId,
        currentUserId: user?.id,
        jsmIncidentFilterIds: jsmIncidentFilterIds,
        primaryProduct: primaryProduct,
        queryParams: queryParams,
        thirdPartyConfigs: thirdPartyConfigs
    });
    const { assetsFilters: assetsFilters, commonFilters: commonFilters, compassFilters: compassFilters, confluenceFilters: confluenceFilters, jiraFilters: jiraFilters, mercuryFilters: mercuryFilters, sortFilters: sortFilters, talentFilters: talentFilters, thirdPartyFilters: thirdPartyFilters } = selectedFilters;
    const { experimentId: experimentId, experimentLayers: experimentLayers, matchingLayerExperimentsMetadata: matchingLayerExperimentsMetadata, shadowExperimentId: shadowExperimentId, fanoutExperimentCohort: fanoutExperimentCohort, backendExperiment: backendExperiment } = (0, $5311b2f8ca23af19$export$8c6fefe9b6b2ccd8)({
        backendExperimentOverrides: backendExperimentOverrides,
        cloudId: cloudId,
        entities: entities,
        experimentLayers: rawExperimentLayers,
        experienceLayer: experience,
        isHello: (0, $03qcI.isHello)(cloudId),
        isJiraIssueIndexed: isJiraIssueIndexed,
        onError: onError,
        productDataRegions: productDataRegions,
        productEdition: productEdition,
        thirdPartyFilters: selectedFilters.thirdPartyFilters,
        getLayerValuesFn: getLayerValuesFn
    });
    const requestHeaders = {
        [(0, $fnx12.EDGE_REGION_HINT_HEADER)]: primaryProduct && productDataRegions ? (0, $fnx12.getEdgeRegionHint)(primaryProduct, productDataRegions) : undefined
    };
    const additionalSites = (0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
        primaryProduct: primaryProduct,
        fireExperimentExposure: false
    }) ? sites : [];
    const cloudIdARIs = (0, $S6W9B.getCloudIdARIs)(cloudId, primaryProduct, additionalSites);
    // Fast Jira value-field hydration experiment. Evaluate the experiment ONCE so we only fire a
    // single exposure event.
    const hasJiraProduct = products.some((product)=>(0, $6qPRO.isJiraProduct)(product, true));
    const fastJiraHydrationEnabled = hasJiraProduct && (0, $cJff5.serveFastJiraHydrationExperiment)();
    const sharedQueryVariables = {
        commonFilters: commonFilters,
        compassFilters: compassFilters,
        confluenceFilters: confluenceFilters,
        disableQueryReplacement: !!originalQuery,
        entities: entities,
        experience: experience,
        jiraFilters: jiraFilters,
        limit: $41b899904a7901a9$var$getLimit(entities),
        mercuryFilters: mercuryFilters,
        query: searchQuery,
        queryVersion: 1,
        searchSessionId: rawSearchSessionId,
        sessionId: rawSessionId,
        sort: sortFilters,
        sourceProduct: primaryProduct,
        tenantId: cloudId,
        thirdPartyFilters: thirdPartyFilters,
        ...(0, $iDrrr.fg)('assets_rovo_search_all') ? {
            assetsFilters: assetsFilters
        } : {},
        ...(0, $iDrrr.fg)('talent_global_search') ? {
            talentFilters: talentFilters
        } : {}
    };
    const searchResultsQueryVariables = {
        ...sharedQueryVariables,
        cloudIdARIs: cloudIdARIs,
        expectResult: expectResult,
        /**
		 * Highlighting is only useful for results
		 */ enableHighlighting: true,
        experimentId: /**
		 * Experimentation is only valid in results section. Note that experiments
		 * can differ based on selected entites/products, so if we include experiments
		 * in counts, the counts will change as filters change
		 */ experimentId,
        experimentLayers: experimentLayers?.map(({ name: name, layerId: layerId, shadowId: shadowId, definitions: definitions })=>({
                name: name,
                layerId: layerId,
                shadowId: shadowId,
                definitions: definitions
            })),
        ...matchingLayerExperimentsMetadata ? {
            matchingLayerExperimentsMetadata: matchingLayerExperimentsMetadata
        } : {},
        fanoutExperimentCohort: fanoutExperimentCohort,
        includeGithubCode: selectedProducts.length === 1 && (0, $dvVWp.GITHUB_PRODUCT_KEYS).includes(selectedProducts[0]) && (0, $iDrrr.fg)('rovo_github_code_search'),
        includeJiraLiteModeFields: isLiteMode && selectedProducts.some((product)=>(0, $6qPRO.isJiraProduct)(product, true)),
        // Fast Jira value-field hydration experiment. Enrolled whenever a Jira product is among
        // the products being searched (`products` = available/queried products, which is what is
        // sent as the outgoing `selectedProducts` variable and drives the entities). We do NOT use
        // the filter-selection `selectedProducts` here: that is empty on the default "All apps"
        // search, which would wrongly skip enrolment even though Jira results are shown (e.g. when
        // searching Jira from Confluence). When on, the query selects the lighter
        // issueType/assignee/project/priority/labels value fields instead of the higher-cost
        // *Field variants (see searchJiraIssue_AtlassianSearchPage).
        includeFastJiraHydration: fastJiraHydrationEnabled,
        includeNavBoostScore: (0, $iDrrr.fg)('kd_enable_nav_boost_score'),
        includePassionfruitAsk: (0, $iDrrr.fg)('platform_passionfruit_search_onboarding_enabled'),
        includeRisk: (0, $iDrrr.fg)('platform_mercury_risk_search_ui_enabled'),
        includePositions: (0, $iDrrr.fg)('talent_global_search'),
        includeThirdPartyId: (0, $cJff5.serve3PClickIngestionExperiment)(thirdPartyConfigs, {
            fireExperimentExposure: false
        }),
        includeReactionsAndCommentCount: (0, $iDrrr.fg)('rovo_fps_graph_like_comment_count'),
        shadowExperimentId: shadowExperimentId,
        thirdPartyFilters: thirdPartyFilters
    };
    const rightPanelQueryVariables = {
        ...sharedQueryVariables,
        // Right-panel count query expects a single ARI string.
        cloudIdARI: (0, $S6W9B.getCloudIdARI)(cloudId, primaryProduct),
        expectResult: expectResult,
        /**
		 * Counts searches for approx all entities (see getSelectedFilters for edge cases)
		 */ entities: entitiesForResultsCountQuery,
        /**
		 * We need to search for all Jira product types to support counts in Jira/JSM/JPD correctly
		 */ jiraFilters: (0, $21d1cc4e299beef1$export$62c31c0f13603e08)(jiraFilters, searchableProducts),
        limit: 0,
        sort: [],
        thirdPartyFilters: unselectedProductsThirdPartyFilters
    };
    /**
	 * Relay uses the entire variables objects as a cache key. For this reason,
	 * when making the same search request, we need to ensure we retrieve the
	 * same sessionId and searchSessionId. We do this by caching these ids
	 * and retrieving them using the variables object excluding the ids as a cache key.
	 */ const [searchResultsQuerySessionId, searchResultsQuerySearchSessionId] = (0, $b5a3e357e30a85ab$export$8b9832780ea0337b)(searchResultsQueryVariables);
    searchResultsQueryVariables.sessionId = searchResultsQuerySessionId;
    searchResultsQueryVariables.searchSessionId = searchResultsQuerySearchSessionId;
    const [rightPanelQuerySessionId, rightPanelQuerySearchSessionId] = (0, $b5a3e357e30a85ab$export$8b9832780ea0337b)(rightPanelQueryVariables);
    rightPanelQueryVariables.sessionId = rightPanelQuerySessionId;
    rightPanelQueryVariables.searchSessionId = rightPanelQuerySearchSessionId;
    const searchResultsQueryRelayProvidedVariables = (0, $fb8d04ee47c1bab9$export$722bffef5ff5d4b4)();
    return {
        backendExperiment: backendExperiment,
        requestHeaders: requestHeaders,
        rightPanelQueryVariables: rightPanelQueryVariables,
        searchResultsQueryRelayProvidedVariables: searchResultsQueryRelayProvidedVariables,
        searchResultsQueryVariables: searchResultsQueryVariables
    };
};
const $41b899904a7901a9$var$getLimit = (entities)=>{
    return entities.length === (0, $2ePuQ.getDefaultEntityAti)().length ? (0, $2ePuQ.RESULT_LIMIT_FOR_MULTIPLE_PRODUCTS) : (0, $2ePuQ.RESULT_LIMIT_FOR_SINGLE_PRODUCT);
};
const $41b899904a7901a9$var$getSearchableProducts = (searchQuery, products)=>{
    const isEmptyQuery = !searchQuery || searchQuery.trim() === '';
    return products.filter((product)=>!isEmptyQuery || (0, $dvVWp.productsSupportingEmptyQuery).includes(product));
};
module.exports["generateSearchInputs"] = $41b899904a7901a9$export$b83d7680b0db727d;

});

parcelRegister("518WI", function(module, exports) {

var $6onJ6 = parcelRequire("6onJ6");

const $e416c75d0c35adf1$export$e9ddc0ee913bbcbd = (0, $6onJ6.disposableValue)();
module.exports["SEARCH_SESSION_ID"] = $e416c75d0c35adf1$export$e9ddc0ee913bbcbd;

});

parcelRegister("epRE1", function(module, exports) {

var $1Qme9 = parcelRequire("1Qme9");


var $biQM6 = parcelRequire("biQM6");

/**
 * Lightweight filter data for query generation.
 * Constructs minimal filter objects without importing filter definition files,
 * avoiding transitive deps on smart-user-picker, @atlaskit/select, react-dom etc.
 *
 *
 */ 
var $fR63l = parcelRequire("fR63l");


var $dvVWp = parcelRequire("dvVWp");


var $bHPvH = parcelRequire("bHPvH");


var $6uNXh = parcelRequire("6uNXh");


var $7MX1N = parcelRequire("7MX1N");


var $kZdMI = parcelRequire("kZdMI");


var $iaii4 = parcelRequire("iaii4");


var $2bNdD = parcelRequire("2bNdD");


var $26LZ9 = parcelRequire("26LZ9");


var $2UU5O = parcelRequire("2UU5O");

// Helper product arrays
const $2f888f9fa31c2db5$var$confluenceProducts = [
    (0, $dvVWp.ProductKeys).Confluence
];
const $2f888f9fa31c2db5$var$jiraProducts = [
    (0, $dvVWp.ProductKeys).Jira,
    (0, $dvVWp.ProductKeys).JiraProductDiscovery,
    (0, $dvVWp.ProductKeys).JiraServiceManagement
];
const $2f888f9fa31c2db5$var$assetsProducts = [
    (0, $dvVWp.ProductKeys).Assets
];
const $2f888f9fa31c2db5$var$mercuryProducts = [
    (0, $dvVWp.ProductKeys).Focus
];
const $2f888f9fa31c2db5$var$talentProducts = [
    (0, $dvVWp.ProductKeys).Talent
];
const $2f888f9fa31c2db5$var$contributorProducts = (0, $dvVWp.all1pProductKeys).filter((key)=>key !== (0, $dvVWp.ProductKeys).Trello && key !== (0, $dvVWp.ProductKeys).Focus && key !== (0, $dvVWp.ProductKeys).Talent);
const $2f888f9fa31c2db5$var$contributor3P = (0, $dvVWp.all3pProductKeys).filter((key)=>key !== (0, $fR63l.ProductKeys3P).Figma);
const $2f888f9fa31c2db5$export$e8343e733de21ab3 = {
    lastUpdated: (0, $7MX1N.createMultiSelectFilter)({
        id: 'lastUpdated',
        products: [
            (0, $dvVWp.ProductKeys).Atlas,
            (0, $dvVWp.ProductKeys).Confluence,
            (0, $dvVWp.ProductKeys).Focus,
            (0, $dvVWp.ProductKeys).Jira,
            (0, $dvVWp.ProductKeys).JiraProductDiscovery,
            (0, $dvVWp.ProductKeys).JiraServiceManagement,
            (0, $dvVWp.ProductKeys).Compass,
            (0, $dvVWp.ProductKeys).Trello,
            (0, $dvVWp.ProductKeys).Bitbucket,
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('lastUpdated')
        ],
        alwaysVisible: true,
        universal: true,
        queryParams: {
            key: 'lastModified',
            generateQueryParamsGetState: (0, $iaii4.generateQueryParamsGetState)
        }
    }),
    contributor: (0, $7MX1N.createMultiSelectFilter)({
        id: 'contributor',
        products: [
            ...$2f888f9fa31c2db5$var$contributorProducts,
            ...$2f888f9fa31c2db5$var$contributor3P
        ],
        alwaysVisible: true,
        universal: true,
        queryParams: {
            key: 'contributors'
        }
    }),
    space: (0, $7MX1N.createMultiSelectFilter)({
        id: 'space',
        products: [
            ...$2f888f9fa31c2db5$var$confluenceProducts,
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('space')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'spaces'
        }
    }),
    site: (0, $7MX1N.createMultiSelectFilter)({
        id: 'site',
        products: [
            ...(0, $dvVWp.all1pProductKeys),
            ...(0, $dvVWp.all3pProductKeys)
        ],
        alwaysVisible: false,
        universal: true,
        queryParams: {
            key: 'sites'
        }
    }),
    watchedByMe: (0, $6uNXh.createBooleanFilter)({
        id: 'watchedByMe',
        products: [
            (0, $dvVWp.ProductKeys).Jira,
            (0, $dvVWp.ProductKeys).JiraProductDiscovery,
            (0, $dvVWp.ProductKeys).JiraServiceManagement
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'jWatchedByMe'
        }
    }),
    verified: (0, $6uNXh.createBooleanFilter)({
        id: 'verified',
        products: [
            ...$2f888f9fa31c2db5$var$confluenceProducts,
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('verified')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'verified'
        }
    }),
    assignee: (0, $7MX1N.createMultiSelectFilter)({
        id: 'assignee',
        products: [
            ...$2f888f9fa31c2db5$var$jiraProducts,
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('assignee')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'jAssignee'
        }
    }),
    reporter: (0, $7MX1N.createMultiSelectFilter)({
        id: 'reporter',
        products: [
            ...$2f888f9fa31c2db5$var$jiraProducts,
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('reporter')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'jReporter'
        }
    }),
    commentedByMe: (0, $6uNXh.createBooleanFilter)({
        id: 'commentedByMe',
        products: [
            (0, $dvVWp.ProductKeys).Jira,
            (0, $dvVWp.ProductKeys).JiraProductDiscovery,
            (0, $dvVWp.ProductKeys).JiraServiceManagement,
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('commentedByMe')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'jCommentedByMe'
        }
    }),
    project: (0, $7MX1N.createMultiSelectFilter)({
        id: 'project',
        products: [
            ...$2f888f9fa31c2db5$var$jiraProducts,
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('project')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'jProject',
            generateQueryParamsGetState: (0, $2UU5O.generateQueryParamsGetState)
        }
    }),
    universalTypeFilter: (0, $kZdMI.createSingleSelectFilter)({
        id: 'universalTypeFilter',
        products: [
            ...(0, $dvVWp.all1pProductKeys),
            ...(0, $dvVWp.all3pProductKeys)
        ],
        alwaysVisible: true,
        universal: true,
        queryParams: {
            key: 'type'
        }
    }),
    content: (0, $7MX1N.createMultiSelectFilter)({
        id: 'content',
        products: [
            ...$2f888f9fa31c2db5$var$confluenceProducts,
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('content')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'ancestor'
        }
    }),
    onlyTitleMatch: (0, $6uNXh.createBooleanFilter)({
        id: 'onlyTitleMatch',
        products: [
            ...$2f888f9fa31c2db5$var$confluenceProducts,
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('onlyTitleMatch')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'titleMatch'
        }
    }),
    owner: (0, $7MX1N.createMultiSelectFilter)({
        id: 'owner',
        products: [
            (0, $dvVWp.ProductKeys).Confluence,
            (0, $dvVWp.ProductKeys).Focus,
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('owner')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'owners'
        }
    }),
    createdBy: (0, $7MX1N.createMultiSelectFilter)({
        id: 'createdBy',
        products: [
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('createdBy')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'createdBy'
        }
    }),
    label: (0, $7MX1N.createMultiSelectFilter)({
        id: 'label',
        products: [
            (0, $dvVWp.ProductKeys).Confluence,
            (0, $dvVWp.ProductKeys).Jira,
            (0, $dvVWp.ProductKeys).JiraProductDiscovery,
            (0, $dvVWp.ProductKeys).JiraServiceManagement
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'labels'
        }
    }),
    focusAreaType: (0, $7MX1N.createMultiSelectFilter)({
        id: 'focusAreaType',
        products: [
            ...$2f888f9fa31c2db5$var$mercuryProducts
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'focusAreaTypes'
        }
    }),
    focusAreaUnder: (0, $7MX1N.createMultiSelectFilter)({
        id: 'focusAreaUnder',
        products: [
            ...$2f888f9fa31c2db5$var$mercuryProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'focusAreaUnder'
        }
    }),
    pageStatus: (0, $7MX1N.createMultiSelectFilter)({
        id: 'pageStatus',
        products: [
            ...$2f888f9fa31c2db5$var$confluenceProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'pageStatus',
            generateQueryParamsGetState: (0, $2bNdD.generateQueryParamsGetState)
        }
    }),
    archived: (0, $6uNXh.createBooleanFilter)({
        id: 'archived',
        products: [
            ...$2f888f9fa31c2db5$var$confluenceProducts,
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('archived')
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'archived'
        }
    }),
    lastUpdatedBy: (0, $7MX1N.createMultiSelectFilter)({
        id: 'lastUpdatedBy',
        products: [
            (0, $dvVWp.ProductKeys).Salesforce,
            (0, $dvVWp.ProductKeys).Hubspot
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'lastUpdatedBy'
        }
    }),
    statusFilter: (0, $7MX1N.createMultiSelectFilter)({
        id: 'statusFilter',
        products: [
            (0, $dvVWp.ProductKeys).Jira,
            (0, $dvVWp.ProductKeys).JiraProductDiscovery,
            (0, $dvVWp.ProductKeys).JiraServiceManagement,
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('statusFilter')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'status'
        }
    }),
    compassArchived: (0, $6uNXh.createBooleanFilter)({
        id: 'compassArchived',
        products: [
            (0, $dvVWp.ProductKeys).Compass
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'compassArchived'
        }
    }),
    assetsSchema: (0, $7MX1N.createMultiSelectFilter)({
        id: 'assetsSchema',
        products: [
            ...$2f888f9fa31c2db5$var$assetsProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'assetsSchema'
        }
    }),
    assetsType: (0, $7MX1N.createMultiSelectFilter)({
        id: 'assetsType',
        products: [
            ...$2f888f9fa31c2db5$var$assetsProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'assetsType'
        }
    }),
    positionStatus: (0, $7MX1N.createMultiSelectFilter)({
        id: 'positionStatus',
        products: [
            ...$2f888f9fa31c2db5$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionStatuses'
        }
    }),
    positionEmploymentType: (0, $7MX1N.createMultiSelectFilter)({
        id: 'positionEmploymentType',
        products: [
            ...$2f888f9fa31c2db5$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionEmploymentTypes'
        }
    }),
    positionJobFamily: (0, $7MX1N.createMultiSelectFilter)({
        id: 'positionJobFamily',
        products: [
            ...$2f888f9fa31c2db5$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionJobFamilies'
        }
    }),
    positionTeam: (0, $7MX1N.createMultiSelectFilter)({
        id: 'positionTeam',
        products: [
            ...$2f888f9fa31c2db5$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionTeams',
            generateQueryParamsGetState: (0, $26LZ9.generateQueryParamsGetState)
        }
    }),
    positionFocusArea: (0, $7MX1N.createMultiSelectFilter)({
        id: 'positionFocusArea',
        products: [
            ...$2f888f9fa31c2db5$var$talentProducts
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'positionFocusAreas'
        }
    }),
    opportunityStatus: (0, $7MX1N.createMultiSelectFilter)({
        id: 'opportunityStatus',
        products: [
            (0, $dvVWp.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'opportunityStatus'
        }
    }),
    campaignStatus: (0, $7MX1N.createMultiSelectFilter)({
        id: 'campaignStatus',
        products: [
            (0, $dvVWp.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'campaignStatuses'
        }
    }),
    caseStatus: (0, $7MX1N.createMultiSelectFilter)({
        id: 'caseStatus',
        products: [
            (0, $dvVWp.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'caseStatuses'
        }
    }),
    documentStatus: (0, $7MX1N.createMultiSelectFilter)({
        id: 'documentStatus',
        products: [
            (0, $dvVWp.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'knowledgeArticleStatuses'
        }
    }),
    calendarType: (0, $7MX1N.createMultiSelectFilter)({
        id: 'calendarType',
        products: [
            (0, $dvVWp.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'eventTypes'
        }
    }),
    leadStatus: (0, $7MX1N.createMultiSelectFilter)({
        id: 'leadStatus',
        products: [
            (0, $dvVWp.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'leadStatuses'
        }
    }),
    taskStatus: (0, $7MX1N.createMultiSelectFilter)({
        id: 'taskStatus',
        products: [
            (0, $dvVWp.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'taskStatuses'
        }
    }),
    taskType: (0, $7MX1N.createMultiSelectFilter)({
        id: 'taskType',
        products: [
            (0, $dvVWp.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'taskTypes'
        }
    }),
    sort: (0, $kZdMI.createSingleSelectFilter)({
        id: 'sort',
        products: [
            (0, $dvVWp.ProductKeys).Confluence,
            (0, $dvVWp.ProductKeys).Jira
        ],
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'sort'
        }
    }),
    salesforceStage: (0, $7MX1N.createMultiSelectFilter)({
        id: 'salesforceStage',
        products: [
            (0, $dvVWp.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'salesforceStages'
        }
    }),
    closeDate: (0, $kZdMI.createSingleSelectFilter)({
        id: 'closeDate',
        products: [
            (0, $dvVWp.ProductKeys).Salesforce
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'closeDate'
        }
    }),
    pullRequestStatus: (0, $7MX1N.createMultiSelectFilter)({
        id: 'pullRequestStatus',
        products: [
            (0, $dvVWp.ProductKeys).Bitbucket,
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('pullRequestStatus')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'pullRequestStatus'
        }
    }),
    repository: (0, $7MX1N.createMultiSelectFilter)({
        id: 'repository',
        products: [
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('repository')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'repository'
        }
    }),
    reviewer: (0, $7MX1N.createMultiSelectFilter)({
        id: 'reviewer',
        products: [
            ...(0, $bHPvH.getProducts3PFromConfigForFilter)('reviewer')
        ],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'reviewer'
        }
    }),
    slackChannel: (0, $7MX1N.createMultiSelectFilter)({
        id: 'slackChannel',
        products: (0, $bHPvH.getProducts3PFromConfigForFilter)('slackChannel'),
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'slackChannels'
        }
    }),
    folder: (0, $7MX1N.createMultiSelectFilter)({
        id: 'folder',
        // TODO: Add Loom product when end-to-end is ready
        products: [],
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'folders'
        }
    }),
    workspaceName: (0, $7MX1N.createMultiSelectFilter)({
        id: 'workspaceName',
        products: (0, $bHPvH.getProducts3PFromConfigForFilter)('workspaceName'),
        alwaysVisible: false,
        universal: false,
        queryParams: {
            key: 'workspaceName'
        }
    }),
    hasAttachment: (0, $6uNXh.createBooleanFilter)({
        id: 'hasAttachment',
        products: (0, $bHPvH.getProducts3PFromConfigForFilter)('hasAttachment'),
        alwaysVisible: true,
        universal: false,
        queryParams: {
            key: 'hasAttachment'
        }
    })
};



var $ieiUX = parcelRequire("ieiUX");

const $8f45aa0a73d663f1$export$2e9655e8b4177582 = ({ cloudId: cloudId, queryParams: queryParams, thirdPartyConfigs: thirdPartyConfigs, primaryProduct: primaryProduct })=>{
    // Parse query params so they're typed more strongly
    const parsedQueryParams = (0, $biQM6.parseQueryParams)(queryParams);
    const { lastModified_lt: _, lastModified_gt: __, ...parsedQueryParamsInUse } = parsedQueryParams;
    const queryParamsWithValuesAsStringArray = (0, $biQM6.convertQueryParamsToStringArray)(parsedQueryParamsInUse, Object.keys(parsedQueryParams));
    // Get utilities for processing query params into filters
    const { getSelectedProducts: getSelectedProducts } = (0, $ieiUX.FilterUtils)((0, $2f888f9fa31c2db5$export$e8343e733de21ab3), {});
    // Get selected products from query params
    const selectedProducts = getSelectedProducts(queryParams);
    // Get minimal filters object containing selected values based on query params
    const filters = Object.fromEntries(Object.entries((0, $2f888f9fa31c2db5$export$e8343e733de21ab3)).map(([filterId, filter])=>{
        return [
            filterId,
            filter.queryParams.getState(queryParamsWithValuesAsStringArray, cloudId)
        ];
    }));
    // Get selected datasource
    const selectedDatasource = (0, $biQM6.getDatasourceFromId)(parsedQueryParams.datasource, selectedProducts[0], thirdPartyConfigs);
    return {
        cql: parsedQueryParams.cql,
        searchQuery: parsedQueryParams.text || '',
        originalQuery: parsedQueryParams.originalQuery,
        filters: filters,
        selectedProducts: selectedProducts,
        selectedDatasource: selectedDatasource,
        // Gated by the multi-site experiment so `sites` is only populated for eligible users.
        sites: (0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
            primaryProduct: primaryProduct,
            fireExperimentExposure: false
        }) ? parsedQueryParams.sites ?? [] : []
    };
};
module.exports["getSearchConfig"] = $8f45aa0a73d663f1$export$2e9655e8b4177582;

});

parcelRegister("23j2F", function(module, exports) {

var $3Ydx7 = parcelRequire("3Ydx7");

const $a6b891e4fc5c2845$export$f09e972bbd9c2e = ({ cloudId: cloudId, primaryProduct: primaryProduct, activationId: activationId, locale: locale, orgId: orgId, query: query })=>{
    const product = primaryProduct || '';
    const siteId = primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira ? `ari:cloud:jira-software::site/${cloudId}` : `ari:cloud:${product}::site/${cloudId}`;
    const workspaceId = activationId ? `ari:cloud:${product}:${cloudId}:workspace/${activationId}` : '';
    return {
        query: query,
        siteId: siteId,
        locale: locale,
        orgId: orgId ?? '',
        workspaceId: workspaceId,
        cloudId: cloudId,
        product: product
    };
};
module.exports["buildIntentDetectionVariables"] = $a6b891e4fc5c2845$export$f09e972bbd9c2e;

});

parcelRegister("7KnRQ", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $7AtIp = parcelRequire("7AtIp");


var $i5c0A = parcelRequire("i5c0A");


var $cuvLu = parcelRequire("cuvLu");


var $zzZbq = parcelRequire("zzZbq");







function $f4c8592a99c48782$export$7542d9981bb876f9(query) {
    const lowercaseQuery = query.toLowerCase();
    if (/^[a-z][a-z0-9_]+-\d+$/.test(lowercaseQuery) && (0, $iDrrr.fg)('kd_restrict_jira_issue_query_intent')) return {
        queryIntent: (0, $zzZbq.QueryIntent).JIRA_ISSUE,
        transformedQuery: query
    };
    if (/\w+-\d+/.test(lowercaseQuery) && !(0, $iDrrr.fg)('kd_restrict_jira_issue_query_intent')) return {
        queryIntent: (0, $zzZbq.QueryIntent).JIRA_ISSUE,
        transformedQuery: query
    };
    if (lowercaseQuery.endsWith(' agent') || lowercaseQuery.endsWith(' agents')) return {
        queryIntent: (0, $zzZbq.QueryIntent).AGENT,
        transformedQuery: query.replace(' agent', '').replace(' Agent', '')
    };
}





const $b0caf69c721de740$export$6c52de753cb858f8 = 'KnowledgeDiscoveryIntentDetectionQuery';
const $b0caf69c721de740$export$12788ba4bf4fbd92 = `
    ... on KnowledgeDiscoveryBookmarkIntent {
        __typename
        bookmark {
            id
            url
            title
            description
            keyPhrase
            bookmarkState
            lastModifierAccountId
            lastModifiedTimestamp
            parentAdminhubBookmarkId
        }
    }
`;
const $b0caf69c721de740$export$6f87cad788b6beba = `
	... on KnowledgeDiscoveryPersonIntent {
		__typename
		persons {
			accountId
			name
			email
			picture
			jobTitle
			department
			organization
			location
			zoneInfo
		}
	}
`;
const $b0caf69c721de740$export$fbbcc7a6fd1b5b3 = `
	originalIntent
	elsTraceId
	prefilterEntities {
		entityType
		id
		name
		mention
		confidenceScore
		clarificationLevel
	}
`;
const $b0caf69c721de740$export$5cc310960e46a388 = `
	... on KnowledgeDiscoveryNavContentIntent {
		__typename
		url
		title
		createdAt
	}
`;
const $b0caf69c721de740$export$8145deeb4e892b30 = ()=>`
	query KnowledgeDiscoveryIntentDetectionQuery(
		$siteId: String!
		$query: String!
		$locale: String!
		$orgId: String!
	) {
		knowledgeDiscovery {
			intentDetection(locale: $locale, orgId: $orgId, query: $query, siteId: $siteId) {
				... on KnowledgeDiscoveryIntentDetectionSuccess {
					__typename
					errors {
						errorType
						statusCode
					}
					detectionMetadata {
						cacheHit
						latencyMs
						method
						model
						timestamp
						entityMetadata {
							entityCount
							entityType
						}
						${(0, $iDrrr.fg)('kd_fe_persons_intent_detection_els') ? $b0caf69c721de740$export$fbbcc7a6fd1b5b3 : ''}
					}
					intent {
						classification
						detectionType
						subTypes
						transformedQuery
						... on KnowledgeDiscoveryJiraIntent {
							__typename
						}
						... on KnowledgeDiscoveryKeywordOrAcronymIntent {
							__typename
						}
						... on KnowledgeDiscoveryNaturalLanguageIntent {
							__typename
						}
						... on KnowledgeDiscoveryNoneIntent {
							__typename
						}
						... on KnowledgeDiscoveryPersonIntent {
							__typename
						}
						... on KnowledgeDiscoveryTeamIntent {
							__typename
						}
						... on KnowledgeDiscoveryTopicIntent {
							__typename
						}
						... on KnowledgeDiscoveryNavigationalIntent {
							__typename
						}
						... on KnowledgeDiscoveryOrgChartIntent {
							__typename
						}
						${(0, $iDrrr.fg)('kd_enable_sain_hero_nav') ? $b0caf69c721de740$export$5cc310960e46a388 : ''}
						${(0, $iDrrr.fg)('kd_bookmark_query_intent') ? $b0caf69c721de740$export$12788ba4bf4fbd92 : ''}
						${(0, $iDrrr.fg)('kd_fe_persons_intent_detection_els') ? $b0caf69c721de740$export$6f87cad788b6beba : ''}
					}
				}
			}
		}
	}
`;


// Jira-family product keys that support NL→JQL (jira, jira-product-discovery, jira-servicedesk).
// Used to guard against over-triggering JIRA_NATURAL_LANGUAGE_QUERY on non-Jira surfaces.
const $87641ab558a8c326$var$JIRA_FAMILY_APP_IDS = new Set([
    'jira',
    'jira-product-discovery',
    'jira-servicedesk'
]);
const $87641ab558a8c326$export$c16051a8e758ff55 = async ({ query: query, siteId: siteId, locale: locale, metadata: metadata, cloudId: cloudId, orgId: orgId, workspaceId: workspaceId, product: product, selectedProduct: selectedProduct, setQueryIntent: setQueryIntent, setTransformedQuery: setTransformedQuery, setIntentData: setIntentData, setRequestId: setRequestId, setTraceId: setTraceId, setIntentDetectionMetadata: setIntentDetectionMetadata, onError: onError })=>{
    const handleError = (error)=>{
        setQueryIntent((0, $zzZbq.QueryIntent).NONE);
        setTransformedQuery('');
        onError?.(error);
        (0, $cuvLu.logger).error({
            error: error,
            functionName: 'getQueryIntent: handleError'
        });
    };
    try {
        const frontendQueryIntent = (0, $f4c8592a99c48782$export$7542d9981bb876f9)(query);
        // Intent from the frontend has a higher priority than the BE
        // Add any experiment and gate exclusion logic in `getFrontendQueryIntent` to prevent messy conditionals in this function
        if (!!frontendQueryIntent) {
            setQueryIntent(frontendQueryIntent.queryIntent);
            setTransformedQuery(frontendQueryIntent.transformedQuery);
            return;
        }
        const aggResponse = await (0, $i5c0A.fetchAggResponse)({
            graphQuery: (0, $b0caf69c721de740$export$8145deeb4e892b30)(),
            variables: {
                query: query,
                siteId: siteId,
                locale: locale,
                orgId: orgId,
                ...metadata ? {
                    metadata: metadata
                } : {}
            },
            operationName: (0, $b0caf69c721de740$export$6c52de753cb858f8),
            // we're using the cache to make sure the number of calls remain the same
            // make sure the cache key format is different from the actual intent detection call
            cache: {
                ttl: 300000,
                key: `shadow-intent-detection-${query}`
            },
            headers: (0, $7AtIp.createAtlAttributionHeader)({
                atlWorkspaceId: workspaceId,
                tenantId: cloudId,
                product: product
            })
        });
        // Trace / request IDs from the gateway HTTP response (for analytics and debugging).
        const gatewayTracingHeaders = aggResponse.gatewayTracingHeaders ?? {};
        const response = aggResponse?.data?.knowledgeDiscovery.intentDetection;
        if (!response || !aggResponse?.data || aggResponse?.errors && aggResponse?.errors.length > 0 || response?.errors && response?.errors.length > 0) {
            // errors show up at the top level or in the response
            let errorMessage = aggResponse?.errors?.[0]?.message;
            if (response?.errors && response?.errors.length > 0) errorMessage = response?.errors?.[0]?.message;
            const error = errorMessage ? new Error(errorMessage) : new Error('getQueryIntent error');
            handleError(error);
            return;
        }
        // Intent from the BE
        let queryIntent = response.intent?.classification;
        if (queryIntent === (0, $zzZbq.QueryIntent).VISUAL && !(0, $iDrrr.fg)('hybrid_orchestrator_enable_image_search')) queryIntent = (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY;
        if ((queryIntent === (0, $zzZbq.QueryIntent).JIRA_NATURAL_LANGUAGE_QUERY || queryIntent === (0, $zzZbq.QueryIntent).JIRA_NLQ_KEYWORD) && selectedProduct && !$87641ab558a8c326$var$JIRA_FAMILY_APP_IDS.has(selectedProduct) && (0, $iDrrr.fg)('kd_fix_sain_jira_nql_query_intent_overtriggering')) queryIntent = (0, $zzZbq.QueryIntent).NATURAL_LANGUAGE_QUERY;
        setQueryIntent(queryIntent);
        setTransformedQuery(response.intent?.transformedQuery);
        setIntentData?.(response.intent);
        if (response.detectionMetadata) setIntentDetectionMetadata?.(response.detectionMetadata);
        setRequestId(gatewayTracingHeaders['atl-request-id'] ?? '');
        setTraceId?.(gatewayTracingHeaders['x-trace-id'] ?? '');
    } catch (error) {
        handleError(error);
    }
};
module.exports["getQueryIntent"] = $87641ab558a8c326$export$c16051a8e758ff55;

});

parcelRegister("3LDzU", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $e1bacc011ec444be$export$b6ea13c37acfe578 = ()=>{
    return (0, $cozmU.useMemo)(()=>({
            getPreloadedSearch: ({ cloudId: cloudId })=>{
                // The payload is returned regardless of route transition state, and remains
                // readable until it is explicitly cleared. Both matter for the Quick Find async
                // preload: a Quick Find→search-page navigation is a client-side transition, so
                // bailing out during transitions would discard the payload Quick Find just
                // warmed. The consumer (search-page) owns clearing it at the right time.
                const preloadedSearch = window.__PRELOADED_SEARCH__;
                if (!preloadedSearch || preloadedSearch.cloudId !== cloudId) return null;
                return preloadedSearch;
            },
            clearPreloadedSearch: ({ cloudId: cloudId })=>{
                const preloadedSearch = window.__PRELOADED_SEARCH__;
                // Destructive by design: freeing the global stops any consumer that bypasses
                // this provider from reading stale data, and lets Quick Find re-warm it on the
                // next search-page transition.
                if (preloadedSearch?.cloudId === cloudId) window.__PRELOADED_SEARCH__ = undefined;
            }
        }), []);
};
module.exports["usePreloadDataProvider"] = $e1bacc011ec444be$export$b6ea13c37acfe578;

});

parcelRegister("95n8y", function(module, exports) {

var $fd0l2 = parcelRequire("fd0l2");

const $90cef935646eff28$export$6750011b01164bda = ()=>{
    // old sharepoint product key is put here (kept for backwards compatibility), as the new one is in the config
    const oldThirdPartyTypes = {
        'ai-3p-connector:sharepoint-domain': `sharepoint`,
        'ai-3p-connector:google-workspace': `drive`
    };
    const thirdPartyTypes = {
        ...oldThirdPartyTypes,
        // add third party types for dual connectors
        'lite-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive': `drive`,
        'smartlinks-connector-gdrive-rsl': `drive`,
        'smartlinks-connector-salesforce': `salesforce`,
        'smartlinks-connector-airtable': `airtable`,
        'smartlinks-connector-figma': `figma`,
        'smartlinks-connector-gitlab': `gitlab`,
        'smartlinks-connector-miro': `miro`,
        'smartlinks-connector-asana': `asana`,
        'smartlinks-connector-smartsheet': `smartsheet`,
        'smartlinks-connector-dropbox': `dropbox`,
        'smartlinks-connector-box': `box`,
        'smartlinks-connector-lucid': `lucid`,
        'smartlinks-connector-hubspot': `hubspot`,
        'smartlinks-connector-docusign': `docusign`,
        'smartlinks-connector-slack': `slack`,
        'smartlinks-connector-teams': `teams`,
        'smartlinks-connector-azure-devops': `azure-devops`,
        'smartlinks-connector-notion': `notion`,
        'smartlinks-connector-onedrive': `onedrive`,
        'smartlinks-connector-sharepoint': `sharepoint`
    };
    (0, $fd0l2.ThirdPartyConfigsSync).forEach((config)=>{
        if (config.resourceType) thirdPartyTypes[config.resourceType] = config.id;
    });
    return thirdPartyTypes;
};
module.exports["getThirdPartyTypes"] = $90cef935646eff28$export$6750011b01164bda;

});

parcelRegister("9ekgQ", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");


var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");

const $95637c076bd712f6$export$1cbda5ccc2e23e06 = (0, $87Lnp.z).union([
    (0, $87Lnp.z).nativeEnum((0, $dvVWp.ProductKeys)),
    (0, $87Lnp.z).string().refine((0, $8fNUp.isForgeConnectorProductKey), (val)=>({
            message: `${val} is not a valid product key`
        }))
]);
module.exports["productKeySchema"] = $95637c076bd712f6$export$1cbda5ccc2e23e06;

});

parcelRegister("iYHGy", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $4492018f58b7cb34$export$7a844b7429919d2 = (0, $87Lnp.z).nativeEnum({
    All: 'all'
});
module.exports["allContentTypeSchema"] = $4492018f58b7cb34$export$7a844b7429919d2;

});

parcelRegister("1T3zR", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $0442ab6bf6c52ce6$export$578ac6cc3cc5997a = (0, $87Lnp.z).nativeEnum({
    WorkItem: 'work-item'
});
module.exports["asanaContentTypeSchema"] = $0442ab6bf6c52ce6$export$578ac6cc3cc5997a;

});

parcelRegister("fEMyR", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $b80a2edbef32607a$export$36d574e92bf2f0fc = (0, $87Lnp.z).nativeEnum({
    AssetsObject: 'object',
    Schema: 'schema',
    Type: 'type'
});
module.exports["assetsContentTypeSchema"] = $b80a2edbef32607a$export$36d574e92bf2f0fc;

});

parcelRegister("5sbmC", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $90dfc11b6e89a136$export$ddfc756f87e8324d = (0, $87Lnp.z).nativeEnum({
    Goal: 'goal',
    Learning: 'learning',
    Project: 'project',
    Tag: 'tag'
});
module.exports["atlasContentTypeSchema"] = $90dfc11b6e89a136$export$ddfc756f87e8324d;

});

parcelRegister("cQ704", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $a43729b80b3b0c13$export$ffa5bf38ea9a76ee = (0, $87Lnp.z).enum([
    'true',
    'false'
]).transform((x)=>x === 'true');
module.exports["booleanSchema"] = $a43729b80b3b0c13$export$ffa5bf38ea9a76ee;

});

parcelRegister("4ktA3", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $1ab0bf18e8c978d1$export$236bfa8a18b6097 = (0, $87Lnp.z).string().transform((x)=>x.split(','));
module.exports["commaSeparatedArraySchema"] = $1ab0bf18e8c978d1$export$236bfa8a18b6097;

});

parcelRegister("04Vsl", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $b79d5bbf4e2bebeb$export$e3c670f5c4b4df75 = (0, $87Lnp.z).nativeEnum({
    Component: 'component'
});
module.exports["compassContentTypeSchema"] = $b79d5bbf4e2bebeb$export$e3c670f5c4b4df75;

});

parcelRegister("esQrd", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $c5b71ba557825190$export$d872f0aa011c3a9d = (0, $87Lnp.z).nativeEnum({
    Answer: 'answer',
    Attachment: 'attachment',
    Blogpost: 'blogpost',
    Calendar: 'calendar',
    Comment: 'comment',
    Database: 'database',
    Document: 'document',
    Embed: 'embed',
    Folder: 'folder',
    Gliffy: 'gliffy',
    Page: 'page',
    Question: 'question',
    Space: 'space',
    SpaceCalendar: 'space-calendar',
    Whiteboard: 'whiteboard',
    Slide: 'slide'
});
module.exports["confluenceContentTypeSchema"] = $c5b71ba557825190$export$d872f0aa011c3a9d;

});

parcelRegister("bvXTU", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $af3d14f8bce3c227$export$374297d3e3f8ca0c = (0, $87Lnp.z).nativeEnum({
    Dashboard: 'dashboard',
    DataTable: 'data-table'
});
module.exports["databricksContentTypeSchema"] = $af3d14f8bce3c227$export$374297d3e3f8ca0c;

});

parcelRegister("3L25R", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $dccb0e84ab51df02$export$dbec9fc36dbba98b = (0, $87Lnp.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet'
});
module.exports["dropboxContentTypeSchema"] = $dccb0e84ab51df02$export$dbec9fc36dbba98b;

});

parcelRegister("ai4mL", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $152f6816a74182d8$export$f4b8db47840ea062 = (0, $87Lnp.z).nativeEnum({
    Design: 'design'
});
module.exports["figmaContentTypeSchema"] = $152f6816a74182d8$export$f4b8db47840ea062;

});

parcelRegister("kvUqR", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $6617c84c20a13493$export$3d532d345dacbf34 = (0, $87Lnp.z).nativeEnum({
    Repository: 'repository',
    PullRequest: 'pull-request',
    Commit: 'commit',
    Branch: 'branch',
    DevopsWorkItem: 'devops-work-item'
});
module.exports["githubContentTypeSchema"] = $6617c84c20a13493$export$3d532d345dacbf34;

});

parcelRegister("4IMl4", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $2c2b419fdbac4f66$export$340da7d4450f4487 = (0, $87Lnp.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet',
    Video: 'video',
    Image: 'image',
    Folder: 'folder',
    Audio: 'audio',
    Pdf: 'pdf',
    Code: 'code',
    Form: 'form',
    Notebook: 'notebook',
    WebPage: 'web-page',
    Other: 'other'
});
module.exports["googleContentTypeSchema"] = $2c2b419fdbac4f66$export$340da7d4450f4487;

});

parcelRegister("41SDB", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $c71f738dedbb8cb1$export$f63d577c43feca48 = (0, $87Lnp.z).nativeEnum({
    Deal: 'deal',
    CustomerOrg: 'customer-org'
});
module.exports["hubspotContentTypeSchema"] = $c71f738dedbb8cb1$export$f63d577c43feca48;

});

parcelRegister("gcyCs", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $1104058c93aa818e$export$e31a67e5bb829f5c = (0, $87Lnp.z).nativeEnum({
    Project: 'project',
    Incident: 'incident',
    Issue: 'issue',
    Filter: 'filter',
    Dashboard: 'dashboard',
    Board: 'board',
    Plan: 'plan',
    Epic: 'epic',
    Bug: 'bug',
    Story: 'story',
    Task: 'task',
    Subtask: 'subtask'
});
module.exports["jiraContentTypeSchema"] = $1104058c93aa818e$export$e31a67e5bb829f5c;

});

parcelRegister("hAGDy", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $a6c4b3fa9ff27424$export$7c078c2ec2ab4e93 = (0, $87Lnp.z).nativeEnum({
    Anytime: 'anytime',
    Today: 'today',
    Yesterday: 'yesterday',
    Past7Days: 'past7Days',
    Past30Days: 'past30Days',
    PastYear: 'pastYear',
    Custom: 'custom'
});
module.exports["lastModifiedValueSchema"] = $a6c4b3fa9ff27424$export$7c078c2ec2ab4e93;

});

parcelRegister("fZYb4", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $b986069ddb074892$export$915266ba4ee70164 = (0, $87Lnp.z).nativeEnum({
    Video: 'video'
});
module.exports["loomContentTypeSchema"] = $b986069ddb074892$export$915266ba4ee70164;

});

parcelRegister("cVMuZ", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $2b95107f8200b6a2$export$3f35493c0e1fe9ec = (0, $87Lnp.z).nativeEnum({
    FocusArea: 'focus-area',
    Ask: 'ask',
    Organization: 'organization',
    Risk: 'risk'
});
module.exports["mercuryContentTypeSchema"] = $2b95107f8200b6a2$export$3f35493c0e1fe9ec;

});

parcelRegister("QaUQl", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $cb83f2a02b0453d5$export$2d13808294fd047f = (0, $87Lnp.z).nativeEnum({
    Document: 'document',
    Presentation: 'presentation',
    Spreadsheet: 'spreadsheet',
    Image: 'image',
    Folder: 'folder',
    Video: 'video',
    Pdf: 'pdf',
    Shortcut: 'shortcut',
    Archive: 'archive',
    WebPage: 'web-page',
    Page: 'page',
    Blogpost: 'blogpost',
    Notebook: 'notebook',
    Other: 'other'
});
module.exports["microsoftContentTypeSchema"] = $cb83f2a02b0453d5$export$2d13808294fd047f;

});

parcelRegister("4wG6Y", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");


var $dvVWp = parcelRequire("dvVWp");

const $4f4db9d032f19672$export$f3a53bd43617a593 = (0, $87Lnp.z).nativeEnum((0, $dvVWp.ProductKeys)).enum;
module.exports["ProductKey"] = $4f4db9d032f19672$export$f3a53bd43617a593;

});

parcelRegister("eV6Wt", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $4d84593fcdfe288c$export$e7eef498de91d92 = (0, $87Lnp.z).nativeEnum({
    Deal: 'deal',
    CustomerContact: 'customer-contact',
    CustomerOrg: 'customer-org',
    Campaign: 'campaign',
    Case: 'case',
    Lead: 'lead'
});
module.exports["salesforceContentTypeSchema"] = $4d84593fcdfe288c$export$e7eef498de91d92;

});

parcelRegister("86rIn", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $996d55aa57ff23c5$export$2414dbe41633e9e4 = (0, $87Lnp.z).nativeEnum({
    WorkItem: 'work-item',
    Document: 'document',
    Comment: 'comment',
    Incident: 'incident',
    Epic: 'epic',
    CatalogItem: 'catalog-item',
    RequestedItem: 'requested-item',
    Project: 'project',
    Demand: 'demand',
    KnowledgeArticle: 'knowledge-article',
    NewsArticle: 'news-article'
});
module.exports["servicenowContentTypeSchema"] = $996d55aa57ff23c5$export$2414dbe41633e9e4;

});

parcelRegister("kI7H0", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $99e1f7285a86480d$export$78ff7f7a3ef7dca8 = (0, $87Lnp.z).nativeEnum({
    Message: 'message',
    Conversation: 'conversation'
});
module.exports["slackContentTypeSchema"] = $99e1f7285a86480d$export$78ff7f7a3ef7dca8;

});

parcelRegister("k4X5q", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $61c0a437c106ee0b$export$ff8ed9d399173456 = (0, $87Lnp.z).nativeEnum({
    Dashboard: 'dashboard',
    Invoice: 'invoice',
    Deal: 'deal'
});
module.exports["smartLinksContentTypeSchema"] = $61c0a437c106ee0b$export$ff8ed9d399173456;

});

parcelRegister("f8JMS", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $706d3f74e53afbd4$export$c7be2dbb4ce58b0d = (0, $87Lnp.z).nativeEnum({
    Relevance: 'relevance',
    UpdatedNewest: 'updatedNewest',
    UpdatedOldest: 'updatedOldest',
    CreatedNewest: 'createdNewest',
    CreatedOldest: 'createdOldest'
});
module.exports["sortSchema"] = $706d3f74e53afbd4$export$c7be2dbb4ce58b0d;

});

parcelRegister("9efpj", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $c54848f8d126b153$export$78a2f7ec9c09bf3b = (0, $87Lnp.z).nativeEnum({
    Position: 'position'
});
module.exports["talentContentTypeSchema"] = $c54848f8d126b153$export$78a2f7ec9c09bf3b;

});

parcelRegister("8maTJ", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $6c9ed91850d398e4$export$e362a3dbc1368cf2 = (0, $87Lnp.z).nativeEnum({
    Message: 'message',
    Conversation: 'conversation',
    Video: 'video',
    Attachment: 'attachment'
});
module.exports["teamsContentTypeSchema"] = $6c9ed91850d398e4$export$e362a3dbc1368cf2;

});

parcelRegister("clVfp", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $9cba60a7d383da66$export$15f07c0375d70d62 = (0, $87Lnp.z).nativeEnum({
    Board: 'board',
    Card: 'card'
});
module.exports["trelloContentTypeSchema"] = $9cba60a7d383da66$export$15f07c0375d70d62;

});

parcelRegister("iRUkk", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $d1d8b156dce8692d$export$c30d3299c2899a1f = (0, $87Lnp.z).nativeEnum({
    WebPage: 'web-page'
});
module.exports["webPageContentTypeSchema"] = $d1d8b156dce8692d$export$c30d3299c2899a1f;

});

parcelRegister("e63Cm", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");

const $b0ec7b4533eaff23$export$8669b3074569e564 = (0, $87Lnp.z).nativeEnum({
    WorkItem: 'work-item',
    Document: 'document',
    Article: 'article',
    Post: 'post',
    Ticket: 'ticket',
    Comment: 'comment'
});
module.exports["zendeskContentTypeSchema"] = $b0ec7b4533eaff23$export$8669b3074569e564;

});

parcelRegister("35JNe", function(module, exports) {
class $e8efd61979a1a404$export$94cd2e6f39615373 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResultsFetchError';
    }
}
module.exports["ResultsFetchError"] = $e8efd61979a1a404$export$94cd2e6f39615373;

});

parcelRegister("biQM6", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $dvVWp = parcelRequire("dvVWp");


var $cZKQq = parcelRequire("cZKQq");

const $c4b729d0e5d2e8d2$export$17d9a81ce3c86a85 = (urlSearchParams)=>{
    const queryParamsObject = Array.from(urlSearchParams.entries()).reduce((paramsObject, [paramKey, value])=>{
        return {
            ...paramsObject,
            [paramKey]: value
        };
    }, {});
    return queryParamsObject;
};
const $c4b729d0e5d2e8d2$export$67c4cee80a3410cd = (queryParams, options)=>{
    const filteredParsedQueryParamEntries = Object.entries((0, $cZKQq.searchQueryParamsBaseSchema).shape).map(([key, schema])=>{
        const queryParamValue = queryParams[key];
        const parsedRawValue = schema.safeParse(queryParamValue);
        if (parsedRawValue.success || !options?.commaSeparatedValues) return [
            key,
            parsedRawValue.data
        ];
        const commaSeparatedString = Array.isArray(queryParamValue) && queryParamValue.length ? queryParamValue.join(',') : undefined;
        const parsedString = schema.safeParse(commaSeparatedString);
        return [
            key,
            parsedString.success ? parsedString.data : null
        ];
    }).filter(([_, value])=>!(value === null || value === undefined));
    const parsedQueryParams = Object.fromEntries(filteredParsedQueryParamEntries);
    const validatedQueryParams = (0, $cZKQq.searchQueryParamsValidators).reduce((queryParams, validator)=>validator(queryParams), parsedQueryParams);
    // remove assets filters
    if ((0, $iDrrr.fg)('asset_rovo_search_remove_filters')) {
        if ((validatedQueryParams.product === (0, $dvVWp.ProductKeys).Assets || validatedQueryParams.assetsSchema || validatedQueryParams.assetsType) && !(0, $iDrrr.fg)('assets_rovo_search_all')) {
            if (validatedQueryParams.product === (0, $dvVWp.ProductKeys).Assets) validatedQueryParams.product = undefined;
            validatedQueryParams.assetsSchema = undefined;
            validatedQueryParams.assetsType = undefined;
        }
    }
    return validatedQueryParams;
};
const $c4b729d0e5d2e8d2$export$60eb5b58f94d0071 = (oldQueryParams, newQueryParams)=>{
    const oldQueryParamEntries = Object.entries(oldQueryParams).filter(([_, value])=>!Array.isArray(value));
    const newQueryParamEntries = Object.entries(newQueryParams).filter(([_, value])=>!Array.isArray(value));
    const oldQueryParamArrayEntries = Object.entries(oldQueryParams).filter(([_, value])=>Array.isArray(value));
    const newQueryParamArrayEntries = Object.entries(newQueryParams).filter(([_, value])=>Array.isArray(value));
    const mergedQueryStringParamKeys = [
        ...new Set([
            ...oldQueryParamArrayEntries,
            ...newQueryParamArrayEntries
        ].map(([key])=>key))
    ];
    const mergedSearchQueryArrays = mergedQueryStringParamKeys.map((key)=>{
        return [
            key,
            [
                ...new Set([
                    ...oldQueryParams[key] ?? [],
                    ...newQueryParams[key] ?? []
                ])
            ]
        ];
    });
    return {
        ...Object.fromEntries(oldQueryParamEntries),
        ...Object.fromEntries(newQueryParamEntries),
        ...Object.fromEntries(mergedSearchQueryArrays)
    };
};
const $c4b729d0e5d2e8d2$export$fc8e8d0c43c32316 = (queryParams)=>{
    return Object.entries(queryParams).flatMap((queryParam)=>{
        const [key, value] = queryParam;
        if (Array.isArray(value)) return [
            [
                key,
                value.join(',')
            ]
        ];
        return [
            [
                key,
                value
            ]
        ];
    });
};
const $c4b729d0e5d2e8d2$export$17404cc52c459484 = (queryParams)=>{
    const queryParamRawEntries = Object.entries(queryParams).flatMap((queryParam)=>{
        const [paramKey, value] = queryParam;
        if (value instanceof Date) {
            const dateFormatOptions = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit'
            };
            const dateFormatter = new Intl.DateTimeFormat('en-US', dateFormatOptions);
            const { month: month, day: day, year: year } = Object.fromEntries(dateFormatter.formatToParts(value).map((part)=>[
                    part.type,
                    part.value
                ]));
            return [
                [
                    paramKey,
                    `${year}-${month}-${day}`
                ]
            ];
        }
        if (value === false || value === true) return [
            [
                paramKey,
                String(value)
            ]
        ];
        if (Array.isArray(value)) return [
            [
                paramKey,
                value.join(',')
            ]
        ];
        // Some query params (e.g. `overrides`) are stored as structured objects in
        // `SearchQueryStringParams` (parsed via Zod). When converting back to raw query params /
        // query string, we must serialize them.
        if (value && typeof value === 'object') return [
            [
                paramKey,
                encodeURIComponent(JSON.stringify(value))
            ]
        ];
        return [
            [
                paramKey,
                value
            ]
        ];
    }).sort(([firstKey], [secondKey])=>firstKey < secondKey ? 1 : -1);
    return Object.fromEntries(queryParamRawEntries);
};
const $c4b729d0e5d2e8d2$export$249cc09c933c4d7a = (queryParams)=>{
    const sanitizedQueryParams = Object.fromEntries(Object.entries(queryParams).filter(([_, value])=>value !== undefined));
    return new URLSearchParams($c4b729d0e5d2e8d2$export$fc8e8d0c43c32316($c4b729d0e5d2e8d2$export$17404cc52c459484(sanitizedQueryParams))).toString();
};
const $c4b729d0e5d2e8d2$export$f30b1e6bbcaec160 = (queryParams)=>{
    return Object.fromEntries($c4b729d0e5d2e8d2$export$fc8e8d0c43c32316($c4b729d0e5d2e8d2$export$17404cc52c459484(queryParams)));
};
const $c4b729d0e5d2e8d2$export$e247f217269cd2eb = (...queryParamArray)=>{
    const queryParamStrings = queryParamArray.map((queryParams)=>$c4b729d0e5d2e8d2$export$249cc09c933c4d7a(queryParams));
    const allQueryParamsAreEqual = new Set(queryParamStrings).size === 1;
    return allQueryParamsAreEqual;
};
const $c4b729d0e5d2e8d2$export$11c3edcbebb03988 = (queryParams, keys)=>{
    return keys.reduce((acc, key)=>{
        if (queryParams[key] === undefined) return acc;
        if (Array.isArray(queryParams[key])) return {
            ...acc,
            [key]: queryParams[key]
        };
        if (typeof queryParams[key] === 'string' || typeof queryParams[key] === 'boolean') return {
            ...acc,
            [key]: [
                queryParams[key].toString()
            ]
        };
        return acc;
    }, {});
};
const $c4b729d0e5d2e8d2$export$ac30e2047efa6738 = (datasourceId, selectedProduct, thirdPartyConfigs)=>{
    if (!datasourceId || !selectedProduct || !thirdPartyConfigs) return undefined;
    const productConfig = thirdPartyConfigs[selectedProduct];
    if (!productConfig?.datasources) return undefined;
    return productConfig.datasources.find((ds)=>ds.datasourceId === datasourceId);
};
module.exports["parseQueryParams"] = $c4b729d0e5d2e8d2$export$67c4cee80a3410cd;
module.exports["toQueryString"] = $c4b729d0e5d2e8d2$export$249cc09c933c4d7a;
module.exports["toQueryParamsRaw"] = $c4b729d0e5d2e8d2$export$f30b1e6bbcaec160;
module.exports["areAllEqualQueryParams"] = $c4b729d0e5d2e8d2$export$e247f217269cd2eb;
module.exports["convertQueryParamsToStringArray"] = $c4b729d0e5d2e8d2$export$11c3edcbebb03988;
module.exports["getDatasourceFromId"] = $c4b729d0e5d2e8d2$export$ac30e2047efa6738;

});

parcelRegister("h6X6L", function(module, exports) {

var $7IS25 = parcelRequire("7IS25");

const $0059f11b86c7a931$export$6466dd1b74ba3dff = (productsToSearch, typeFilter, thirdPartyConfigs, availableProducts, selectedProducts)=>{
    // This early return is to appease Typescript. The typeFilter is always defined and is always single select.
    if (!typeFilter || !(typeFilter.type === 'single-select')) return {
        selectedEntities: [],
        entitiesForQuery: [],
        entitiesForResultsCountQuery: [],
        selectedTypes: []
    };
    const defaultOptionValue = typeFilter.options?.find((option)=>option.isDefault)?.value;
    const selectedTypes = typeFilter.value.filter((value)=>value !== defaultOptionValue).filter(Boolean);
    const { entitiesForQuery: entitiesForQuery, entitiesForResultsCountQuery: entitiesForResultsCountQuery } = (0, $7IS25.getEntitiesForQuery)(productsToSearch, selectedTypes, thirdPartyConfigs, availableProducts, selectedProducts);
    return {
        selectedEntities: selectedTypes,
        entitiesForQuery: entitiesForQuery,
        entitiesForResultsCountQuery: entitiesForResultsCountQuery,
        selectedTypes: selectedTypes
    };
};
module.exports["getUniversalTypeEntities"] = $0059f11b86c7a931$export$6466dd1b74ba3dff;

});

parcelRegister("gNJMT", function(module, exports) {
const $e31d6ff2cb09b363$export$79cd775d0d5c2a2 = (from, to)=>{
    const fromDate = from ? new Date(from) : new Date();
    const startOfTheFromDate = new Date(fromDate.getFullYear(), fromDate.getMonth(), fromDate.getDate(), 0, 0, 0, 0);
    const toDate = to ? new Date(to) : new Date();
    const endOfTheToDate = new Date(toDate.getFullYear(), toDate.getMonth(), toDate.getDate(), 23, 59, 59, 999);
    return {
        gt: from ? startOfTheFromDate.toISOString().split('Z')[0] : undefined,
        lt: to ? endOfTheToDate.toISOString().split('Z')[0] : undefined
    };
};
module.exports["convertCustomDateToRange"] = $e31d6ff2cb09b363$export$79cd775d0d5c2a2;

});

parcelRegister("eIazx", function(module, exports) {
// considering the user's locale-based definition of start OR end of day
const $7b8c0c52f4503ae1$export$8db446d8af54b4b5 = (fromOffset, toOffset)=>{
    const currentDate = new Date();
    return {
        gt: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()).getTime() - fromOffset * 86400000).toISOString().split('Z')[0],
        lt: new Date(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999).getTime() - toOffset * 86400000).toISOString().split('Z')[0]
    };
};
module.exports["getUTCDateRange"] = $7b8c0c52f4503ae1$export$8db446d8af54b4b5;

});

parcelRegister("dzatQ", function(module, exports) {
/**
 * Pure date and sort utility functions for filters.
 * Extracted from filters barrel to avoid importing ThirdPartyConfigs.
 *
 */ 
var $gNJMT = parcelRequire("gNJMT");


var $eIazx = parcelRequire("eIazx");


const $2ee72c5a01a78f84$export$50da93f10cdc6a84 = (lastUpdated)=>{
    let dateRangeValues;
    switch(lastUpdated){
        case 'today':
            dateRangeValues = (0, $eIazx.getUTCDateRange)(0, 0);
            break;
        case 'yesterday':
            dateRangeValues = (0, $eIazx.getUTCDateRange)(1, 1);
            break;
        case 'past7Days':
            dateRangeValues = (0, $eIazx.getUTCDateRange)(7, 0);
            break;
        case 'past30Days':
            dateRangeValues = (0, $eIazx.getUTCDateRange)(30, 0);
            break;
        case 'pastYear':
            dateRangeValues = (0, $eIazx.getUTCDateRange)(365, 0);
            break;
        default:
            dateRangeValues = {
                gt: '',
                lt: ''
            };
    }
    return dateRangeValues;
};
const $2ee72c5a01a78f84$export$e048252fb7949a77 = (from, to)=>{
    const { gt: gt, lt: lt } = (0, $gNJMT.convertCustomDateToRange)(from, to);
    return {
        field: 'LASTMODIFIED',
        gt: gt,
        lt: lt
    };
};
const $2ee72c5a01a78f84$export$405f2efecb6f5de6 = (selectedDateOption)=>{
    const dateRangeValues = $2ee72c5a01a78f84$export$50da93f10cdc6a84(selectedDateOption);
    const { gt: gt, lt: lt } = dateRangeValues;
    return {
        field: 'LASTMODIFIED',
        gt: gt,
        lt: lt
    };
};
module.exports["convertLastUpdatedToDateRange"] = $2ee72c5a01a78f84$export$50da93f10cdc6a84;
module.exports["getConfluenceDateOptionFromCustomDates"] = $2ee72c5a01a78f84$export$e048252fb7949a77;
module.exports["getConfluenceDateOptionValues"] = $2ee72c5a01a78f84$export$405f2efecb6f5de6;

});

parcelRegister("cZKQq", function(module, exports) {

var $87Lnp = parcelRequire("87Lnp");


var $1Fy3P = parcelRequire("1Fy3P");


var $7ydfN = parcelRequire("7ydfN");


var $iYHGy = parcelRequire("iYHGy");


var $1T3zR = parcelRequire("1T3zR");


var $fEMyR = parcelRequire("fEMyR");


var $5sbmC = parcelRequire("5sbmC");


var $cQ704 = parcelRequire("cQ704");


var $4ktA3 = parcelRequire("4ktA3");


var $04Vsl = parcelRequire("04Vsl");


var $esQrd = parcelRequire("esQrd");


var $bvXTU = parcelRequire("bvXTU");


var $3L25R = parcelRequire("3L25R");


var $ai4mL = parcelRequire("ai4mL");


var $kvUqR = parcelRequire("kvUqR");


var $4IMl4 = parcelRequire("4IMl4");


var $41SDB = parcelRequire("41SDB");


var $gcyCs = parcelRequire("gcyCs");


var $hAGDy = parcelRequire("hAGDy");


var $fZYb4 = parcelRequire("fZYb4");


var $cVMuZ = parcelRequire("cVMuZ");


var $QaUQl = parcelRequire("QaUQl");


var $4wG6Y = parcelRequire("4wG6Y");


var $9ekgQ = parcelRequire("9ekgQ");


var $eV6Wt = parcelRequire("eV6Wt");


var $86rIn = parcelRequire("86rIn");


var $kI7H0 = parcelRequire("kI7H0");


var $k4X5q = parcelRequire("k4X5q");


var $f8JMS = parcelRequire("f8JMS");


var $9efpj = parcelRequire("9efpj");


var $8maTJ = parcelRequire("8maTJ");


var $clVfp = parcelRequire("clVfp");


var $iRUkk = parcelRequire("iRUkk");


var $e63Cm = parcelRequire("e63Cm");

const $76d59471cda7f035$export$ec20ab1a5eb36014 = (0, $iYHGy.allContentTypeSchema).enum;
const $76d59471cda7f035$export$48b648eee115c3e5 = (0, $5sbmC.atlasContentTypeSchema).enum;
const $76d59471cda7f035$export$721015a6e24d06a0 = (0, $1T3zR.asanaContentTypeSchema).enum;
const $76d59471cda7f035$export$98ac9eece9e68319 = (0, $esQrd.confluenceContentTypeSchema).enum;
const $76d59471cda7f035$export$bcc0874ed7743007 = (0, $4IMl4.googleContentTypeSchema).enum;
const $76d59471cda7f035$export$847712e479ca402d = (0, $QaUQl.microsoftContentTypeSchema).enum;
const $76d59471cda7f035$export$8c76eb96ebfefeac = (0, $3L25R.dropboxContentTypeSchema).enum;
const $76d59471cda7f035$export$e3ddf72248eaf972 = (0, $gcyCs.jiraContentTypeSchema).enum;
const $76d59471cda7f035$export$39271a5a1b74da02 = (0, $04Vsl.compassContentTypeSchema).enum;
const $76d59471cda7f035$export$145fdb32ff1a4acf = (0, $cVMuZ.mercuryContentTypeSchema).enum;
const $76d59471cda7f035$export$d493ea6967abef56 = (0, $9efpj.talentContentTypeSchema).enum;
const $76d59471cda7f035$export$309520b897e0c0b = (0, $clVfp.trelloContentTypeSchema).enum;
const $76d59471cda7f035$export$d51b5367809bb96 = (0, $kI7H0.slackContentTypeSchema).enum;
const $76d59471cda7f035$export$c69d59ad598aee72 = (0, $8maTJ.teamsContentTypeSchema).enum;
const $76d59471cda7f035$export$8de16d71f5b0d410 = (0, $kvUqR.githubContentTypeSchema).enum;
const $76d59471cda7f035$export$bf86d9f770860253 = (0, $iRUkk.webPageContentTypeSchema).enum;
const $76d59471cda7f035$export$66f84ff942de6e1f = (0, $ai4mL.figmaContentTypeSchema).enum;
const $76d59471cda7f035$export$56591a3ad34d704b = (0, $fZYb4.loomContentTypeSchema).enum;
const $76d59471cda7f035$export$fd3bdf5548c7bf84 = (0, $e63Cm.zendeskContentTypeSchema).enum;
const $76d59471cda7f035$export$6b45e4ca3151b046 = (0, $k4X5q.smartLinksContentTypeSchema).enum;
const $76d59471cda7f035$export$9325d29d4a9658a4 = (0, $eV6Wt.salesforceContentTypeSchema).enum;
const $76d59471cda7f035$export$92229a634de6b0ae = (0, $bvXTU.databricksContentTypeSchema).enum;
const $76d59471cda7f035$export$7c597234a357d5f7 = (0, $41SDB.hubspotContentTypeSchema).enum;
const $76d59471cda7f035$export$7f83273171d63901 = (0, $86rIn.servicenowContentTypeSchema).enum;
const $76d59471cda7f035$export$a08d1bf234105c9c = (0, $fEMyR.assetsContentTypeSchema).enum;
const $76d59471cda7f035$export$593c74387f9db963 = (0, $87Lnp.z).nativeEnum({
    ...$76d59471cda7f035$export$ec20ab1a5eb36014,
    ...$76d59471cda7f035$export$721015a6e24d06a0,
    ...$76d59471cda7f035$export$48b648eee115c3e5,
    ...$76d59471cda7f035$export$98ac9eece9e68319,
    ...$76d59471cda7f035$export$bcc0874ed7743007,
    ...$76d59471cda7f035$export$847712e479ca402d,
    ...$76d59471cda7f035$export$e3ddf72248eaf972,
    ...$76d59471cda7f035$export$39271a5a1b74da02,
    ...$76d59471cda7f035$export$145fdb32ff1a4acf,
    ...$76d59471cda7f035$export$309520b897e0c0b,
    ...$76d59471cda7f035$export$d51b5367809bb96,
    ...$76d59471cda7f035$export$c69d59ad598aee72,
    ...$76d59471cda7f035$export$66f84ff942de6e1f,
    ...$76d59471cda7f035$export$8de16d71f5b0d410,
    ...$76d59471cda7f035$export$56591a3ad34d704b,
    ...$76d59471cda7f035$export$bf86d9f770860253,
    ...$76d59471cda7f035$export$8c76eb96ebfefeac,
    ...$76d59471cda7f035$export$fd3bdf5548c7bf84,
    ...$76d59471cda7f035$export$6b45e4ca3151b046,
    ...$76d59471cda7f035$export$9325d29d4a9658a4,
    ...$76d59471cda7f035$export$7c597234a357d5f7,
    ...$76d59471cda7f035$export$92229a634de6b0ae,
    ...$76d59471cda7f035$export$a08d1bf234105c9c,
    ...$76d59471cda7f035$export$d493ea6967abef56,
    ...$76d59471cda7f035$export$7f83273171d63901
});
const $76d59471cda7f035$export$4f29dba8e623c3d1 = (0, $87Lnp.z).nativeEnum({
    ...(0, $7ydfN.TypeFilterValueKey),
    ...$76d59471cda7f035$export$ec20ab1a5eb36014
});
const $76d59471cda7f035$export$e2e108cbe2e4f865 = $76d59471cda7f035$export$4f29dba8e623c3d1.enum;
const $76d59471cda7f035$export$8a9f7fff0151f0f7 = (0, $87Lnp.z).nativeEnum({
    ...(0, $1Fy3P.PageStatusFilterValueKey),
    ...$76d59471cda7f035$export$ec20ab1a5eb36014
});
const $76d59471cda7f035$export$e6747eee8f26f8c0 = (0, $hAGDy.lastModifiedValueSchema).enum;
const $76d59471cda7f035$export$d43f91ac58cde147 = (0, $f8JMS.sortSchema).enum;
const $76d59471cda7f035$var$jsonEncodedSchema = (schema)=>(0, $87Lnp.z).preprocess((value)=>{
        // Expected format: URL encoded JSON string
        if (typeof value === 'string') {
            let decoded = value;
            try {
                decoded = decodeURIComponent(value);
            } catch  {
            // ignore decoding errors; schema will fail if JSON is invalid
            }
            try {
                return JSON.parse(decoded);
            } catch  {
                return value;
            }
        }
        return value;
    }, schema);
const $76d59471cda7f035$export$37bdef1e194c0e7e = $76d59471cda7f035$var$jsonEncodedSchema((0, $87Lnp.z).object({
    sourceProduct: (0, $87Lnp.z).string().min(1).optional(),
    frontendFeatureGates: (0, $87Lnp.z).array((0, $87Lnp.z).object({
        name: (0, $87Lnp.z).string().min(1),
        value: (0, $87Lnp.z).boolean()
    })).optional(),
    frontendExperiments: (0, $87Lnp.z).array((0, $87Lnp.z).object({
        name: (0, $87Lnp.z).string().min(1),
        value: (0, $87Lnp.z).record((0, $87Lnp.z).union([
            (0, $87Lnp.z).string(),
            (0, $87Lnp.z).boolean()
        ]))
    })).optional(),
    backendExperiments: (0, $87Lnp.z).array((0, $87Lnp.z).object({
        name: (0, $87Lnp.z).enum([
            'search_platform_layer_l1',
            'search_platform_layer_l2',
            'search_platform_layer_l3',
            'search_platform_layer_query_expansion'
        ]),
        analyticsDefinitions: (0, $87Lnp.z).array((0, $87Lnp.z).object({
            layerId: (0, $87Lnp.z).string().nullable().optional(),
            shadowId: (0, $87Lnp.z).string().nullable().optional(),
            entity: (0, $87Lnp.z).string().nullable().optional(),
            subEntity: (0, $87Lnp.z).string().nullable().optional(),
            abTestId: (0, $87Lnp.z).string().nullable(),
            armId: (0, $87Lnp.z).string().nullable().optional(),
            controlId: (0, $87Lnp.z).string().nullable()
        }).passthrough()).optional()
    }).passthrough()).optional()
}).passthrough());
const $76d59471cda7f035$export$7b58b3b9a7b83d61 = (0, $87Lnp.z).object({
    text: (0, $87Lnp.z).optional((0, $87Lnp.z).string().max(200)),
    originalQuery: (0, $87Lnp.z).optional((0, $87Lnp.z).string().max(200)),
    product: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe((0, $9ekgQ.productKeySchema))),
    datasource: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    type: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe($76d59471cda7f035$export$4f29dba8e623c3d1)),
    filterDropdownOpen: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema)),
    // Last Modified
    lastModified: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe((0, $hAGDy.lastModifiedValueSchema))),
    lastModified_lt: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe((0, $87Lnp.z).coerce.date())),
    lastModified_gt: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe((0, $87Lnp.z).coerce.date())),
    from: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    to: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    sort: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe((0, $f8JMS.sortSchema))),
    titleMatch: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema)),
    // Confluence filters
    contributors: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    owners: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    ancestor: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    // Salesforce Filters
    campaignStatuses: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    caseStatuses: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    knowledgeArticleStatuses: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    eventTypes: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    leadStatuses: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    taskStatuses: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    taskTypes: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    isAutoApplied: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    salesforceStages: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    spaces: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    sites: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    verified: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema)),
    labels: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    pageStatus: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe($76d59471cda7f035$export$8a9f7fff0151f0f7)),
    archived: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema)),
    // Jira Filters
    jAssignee: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    jReporter: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    jCommentedByMe: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema)),
    jProject: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    jWatchedByMe: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema)),
    // Assets Filters
    assetsSchema: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    assetsType: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Mercury Filters
    focusAreaTypes: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    focusAreaUnder: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Talent Filters
    positionEmploymentTypes: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    positionFocusAreas: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    positionJobFamilies: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    positionStatuses: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    positionTeams: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Compass Filters
    compassArchived: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema)),
    createdBy: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    lastUpdatedBy: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Salesforce Close Date filter
    closeDate: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    closeDateVal: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    // Salesforce Opportunity Status filter
    opportunityStatus: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    referrer: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    /**
	 * Quick Find chat-convergence routing decision that sent the user to this search, when there was
	 * one. Read once on bootstrap and passed down to Search AI answers, which surfaces it on
	 * `aiResult viewed` (QS-10491).
	 */ rovoJourneyId: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    /**
	 * URL encoded JSON string used to override feature gates/experiments for debugging.
	 */ overrides: (0, $87Lnp.z).optional((0, $87Lnp.z).string().pipe($76d59471cda7f035$export$37bdef1e194c0e7e)),
    cql: (0, $87Lnp.z).optional((0, $87Lnp.z).string()),
    status: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Pull Request Status filter (GitHub, Bitbucket, GitLab)
    pullRequestStatus: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Repository filter (GitHub)
    repository: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Reviewer filter (GitHub)
    reviewer: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Slack Channel filter
    slackChannels: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // Loom folder filter (Quick Find, multi-select)
    folders: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // MS Teams Team (workspace) filter
    workspaceName: (0, $87Lnp.z).optional((0, $4ktA3.commaSeparatedArraySchema)),
    // MS Teams Has Attachment filter
    hasAttachment: (0, $87Lnp.z).optional((0, $cQ704.booleanSchema))
});
const $76d59471cda7f035$export$f374b5430ac28f4c = $76d59471cda7f035$export$7b58b3b9a7b83d61.keyof().enum;
const $76d59471cda7f035$export$ff67c0a0b67bb249 = [
    (queryParams)=>{
        if (queryParams.lastModified !== 'custom') {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { lastModified_gt: lastModified_gt, lastModified_lt: lastModified_lt, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    },
    (queryParams)=>{
        const { lastModified_lt: lastModified_lt, lastModified_gt: lastModified_gt } = queryParams;
        if (lastModified_lt && lastModified_gt && lastModified_lt > lastModified_gt) {
            const { lastModified: _, lastModified_gt: __, lastModified_lt: ___, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    },
    // If closeDate is not 'custom', strip out closeDateVal
    (queryParams)=>{
        if (queryParams.closeDate !== 'custom') {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { closeDateVal: closeDateVal, ...restQueryParams } = queryParams;
            return restQueryParams;
        }
        return queryParams;
    }
];
const $76d59471cda7f035$export$83efce6e50d7c43b = (0, $87Lnp.z).nativeEnum({
    ...(0, $4wG6Y.ProductKey),
    ...$76d59471cda7f035$export$e2e108cbe2e4f865,
    ...$76d59471cda7f035$export$e6747eee8f26f8c0,
    ...$76d59471cda7f035$export$f374b5430ac28f4c
});
const $76d59471cda7f035$export$3d21d7040623da50 = $76d59471cda7f035$export$83efce6e50d7c43b.enum;
module.exports["ContentType"] = $76d59471cda7f035$export$e2e108cbe2e4f865;
module.exports["LastModified"] = $76d59471cda7f035$export$e6747eee8f26f8c0;
module.exports["Sort"] = $76d59471cda7f035$export$d43f91ac58cde147;
module.exports["searchQueryParamsBaseSchema"] = $76d59471cda7f035$export$7b58b3b9a7b83d61;
module.exports["searchQueryParamsValidators"] = $76d59471cda7f035$export$ff67c0a0b67bb249;

});

parcelRegister("aTy6Z", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");

const $03884dd74e450530$export$48804b5672e75138 = (type)=>{
    let messageKey = type;
    if (type === 'page' && (0, $iDrrr.fg)('confluence_live_pages_open_beta_trait_opted_in')) messageKey = 'pageAndLiveDoc';
    return messageKey;
};
module.exports["getTypeOptionMessageKey"] = $03884dd74e450530$export$48804b5672e75138;

});

parcelRegister("eQwbw", function(module, exports) {

var $2gvXK = parcelRequire("2gvXK");


var $c3cgJ = parcelRequire("c3cgJ");

const $892857c04cbb329d$export$c0b4470d000520ff = (ati, selectedTypes, selectedProducts)=>{
    // In the "all products" and "all types" search, we drop some entities for relevance
    // If types are selected (e.g. "All products" + "Page") or a product is selected ("Confluence" + "all types"), we don't drop any entities
    if (selectedTypes.length === 0 && selectedProducts && (0, $c3cgJ.isAllProductSearch)(selectedProducts)) return !(0, $2gvXK.notRequestedATIsInAllSearch)().includes(ati);
    return true;
};
module.exports["isEntityEnabled"] = $892857c04cbb329d$export$c0b4470d000520ff;

});

parcelRegister("2uw6T", function(module, exports) {

var $dvVWp = parcelRequire("dvVWp");


var $hea5O = parcelRequire("hea5O");


var $gPOtu = parcelRequire("gPOtu");

const $d7764986caf8206f$export$521c196d70b6785e = (availableProducts, product, thirdPartyConfigs)=>{
    if ((0, $dvVWp.is3pProductKey)(product)) return availableProducts.includes(product) && (!thirdPartyConfigs[product]?.userNeedsOAuth || (0, $hea5O.isImpersonationEnabled)(product, thirdPartyConfigs) || (0, $gPOtu.hasAdminImportedUserLink)(product, thirdPartyConfigs));
    else return availableProducts.includes(product);
};
module.exports["isProductEntitiesIncluded"] = $d7764986caf8206f$export$521c196d70b6785e;

});

parcelRegister("bwyoU", function(module, exports) {
const $8f7cb3f6ffa1ca7d$export$e902a1c7f3216533 = (query, label)=>{
    return label.toLowerCase().includes(query.toLowerCase());
};
module.exports["lookupMatches"] = $8f7cb3f6ffa1ca7d$export$e902a1c7f3216533;

});

parcelRegister("8lpY0", function(module, exports) {
const $e6ab925b95dff3cb$export$c87d62ed9387fa60 = [
    'ati:cloud:townsquare:project',
    'ati:cloud:townsquare:goal',
    'ati:cloud:townsquare:tag'
];
module.exports["DEFAULT_ATLAS_ENTITY_ATI"] = $e6ab925b95dff3cb$export$c87d62ed9387fa60;

});

parcelRegister("9T8TZ", function(module, exports) {
const $dd0438d540e6ed33$export$c07a1c127052b557 = [
    'ati:cloud:confluence:page',
    'ati:cloud:confluence:blogpost',
    'ati:cloud:confluence:attachment',
    'ati:cloud:confluence:space',
    'ati:cloud:confluence:whiteboard'
];
module.exports["DEFAULT_CONFLUENCE_ENTITY_ATI"] = $dd0438d540e6ed33$export$c07a1c127052b557;

});

parcelRegister("iiNGz", function(module, exports) {
const $176c80251568190d$export$e5280e1b46081838 = [
    'ati:cloud:mercury:focus-area',
    'ati:cloud:mercury:focus-area-status-update'
];
module.exports["DEFAULT_MERCURY_ENTITY_ATI"] = $176c80251568190d$export$e5280e1b46081838;

});

parcelRegister("c8ES5", function(module, exports) {
const $52cf8ddfd20396ba$export$368c06447ee18b39 = [
    'ati:cloud:radar:position'
];
module.exports["DEFAULT_TALENT_ENTITY_ATI"] = $52cf8ddfd20396ba$export$368c06447ee18b39;

});

parcelRegister("b3qPd", function(module, exports) {
const $22b8243cc01c6b6d$export$3f8022b7bd277557 = (siteId)=>`/gateway/api/tap-delivery/api/v3/personalization/site/${siteId}`;
module.exports["getSmartlinkSiteTraitsUrl"] = $22b8243cc01c6b6d$export$3f8022b7bd277557;

});

parcelRegister("6onJ6", function(module, exports) {
/**
 * Interface representing a disposable resource.
 */ function $91e2827df3c23738$export$e29d65b7eabdc6dd(value) {
    return typeof value === 'object' && value !== null && typeof value.dispose === 'function';
}
function $91e2827df3c23738$export$79eba17614bd018c(initialValue, optionsOrDisposeFn) {
    let currentValue = initialValue ?? null;
    // if second param is a function, treat it as disposeFn
    const options = typeof optionsOrDisposeFn === 'function' ? {
        disposeFn: optionsOrDisposeFn,
        disposeOnUpdate: true
    } : {
        disposeOnUpdate: true,
        ...optionsOrDisposeFn
    };
    const { disposeFn: disposeFn, disposeOnUpdate: disposeOnUpdate = true } = options;
    const disposeCurrentValue = ()=>{
        if (disposeFn) disposeFn(currentValue);
        else if ($91e2827df3c23738$export$e29d65b7eabdc6dd(currentValue)) currentValue.dispose();
    };
    return {
        update: (nextValue)=>{
            if (disposeOnUpdate) disposeCurrentValue();
            currentValue = nextValue;
        },
        value: ()=>currentValue,
        dispose: ()=>{
            disposeCurrentValue();
            currentValue = null;
        }
    };
}
function $91e2827df3c23738$export$bd7305966afe1e62(disposeFn, initialValue, disposeOnUpdate = true) {
    return $91e2827df3c23738$export$79eba17614bd018c(initialValue, {
        disposeFn: disposeFn,
        disposeOnUpdate: disposeOnUpdate
    });
}
function $91e2827df3c23738$export$c86c752d0542be0d(initialValues, optionsOrDisposeFn) {
    let currentValues = initialValues ?? null;
    // if second param is a function, treat it as disposeFn
    const options = typeof optionsOrDisposeFn === 'function' ? {
        disposeFn: optionsOrDisposeFn,
        disposeOnUpdate: true
    } : {
        disposeOnUpdate: true,
        ...optionsOrDisposeFn
    };
    const { disposeFn: disposeFn, disposeOnUpdate: disposeOnUpdate = true } = options;
    const disposeCurrentValues = ()=>{
        if (disposeFn) disposeFn(currentValues);
        else currentValues?.forEach((value)=>{
            if ($91e2827df3c23738$export$e29d65b7eabdc6dd(value)) value.dispose();
        });
    };
    return {
        update: (nextValues)=>{
            if (disposeOnUpdate) disposeCurrentValues();
            currentValues = nextValues;
        },
        value: ()=>currentValues,
        dispose: ()=>{
            disposeCurrentValues();
            currentValues = null;
        }
    };
}
module.exports["disposableValue"] = $91e2827df3c23738$export$79eba17614bd018c;

});

parcelRegister("c3cgJ", function(module, exports) {
const $378379b88c60c6f4$export$49b588d87f72a4a8 = (selectedProducts)=>selectedProducts.length === 0;
module.exports["isAllProductSearch"] = $378379b88c60c6f4$export$49b588d87f72a4a8;

});

parcelRegister("i5kPq", function(module, exports) {
/**
 * Pure date and sort utility functions for filters.
 * Extracted from filters barrel to avoid importing ThirdPartyConfigs.
 *
 */ 
var $3yJeH = parcelRequire("3yJeH");


var $cZKQq = parcelRequire("cZKQq");

const $2d612f146acf804b$export$5b3e7019b3acc145 = (value)=>{
    switch(value){
        case (0, $cZKQq.Sort).Relevance:
            return [];
        case (0, $cZKQq.Sort).UpdatedNewest:
            return [
                {
                    field: (0, $3yJeH.SORT_FIELD_KEY).LAST_MODIFIED_DATE,
                    order: (0, $3yJeH.SORT_ORDER).DESC
                }
            ];
        case (0, $cZKQq.Sort).UpdatedOldest:
            return [
                {
                    field: (0, $3yJeH.SORT_FIELD_KEY).LAST_MODIFIED_DATE,
                    order: (0, $3yJeH.SORT_ORDER).ASC
                }
            ];
        case (0, $cZKQq.Sort).CreatedNewest:
            return [
                {
                    field: (0, $3yJeH.SORT_FIELD_KEY).CREATED_DATE,
                    order: (0, $3yJeH.SORT_ORDER).DESC
                }
            ];
        case (0, $cZKQq.Sort).CreatedOldest:
            return [
                {
                    field: (0, $3yJeH.SORT_FIELD_KEY).CREATED_DATE,
                    order: (0, $3yJeH.SORT_ORDER).ASC
                }
            ];
        default:
            return [];
    }
};
module.exports["convertSortToFilter"] = $2d612f146acf804b$export$5b3e7019b3acc145;

});

parcelRegister("jbIQp", function(module, exports) {
const $ed54167fae0bcfaa$export$8e6bea29334a2099 = (type)=>{
    return type === 'single-select' || type === 'multi-select';
};
module.exports["isSelectFilter"] = $ed54167fae0bcfaa$export$8e6bea29334a2099;

});

parcelRegister("9NmsO", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $fd0l2 = parcelRequire("fd0l2");


var $6jeRt = parcelRequire("6jeRt");


var $kh8w1 = parcelRequire("kh8w1");


var $dvVWp = parcelRequire("dvVWp");


var $8fNUp = parcelRequire("8fNUp");

const $94b8c9fa1b18d88d$export$b38c0215344366f7 = ({ supportedProducts: supportedProducts, products: products, accessibleProducts: accessibleProducts })=>{
    // Facade: when rovo_fps_use_rovo_config is enabled, delegate to the
    // canonical implementation in @atlassian/rovo-connectors-config so that
    // search-page and other consumers share a single source of truth.
    // When disabled, fall through to the inline legacy implementation below.
    if ((0, $kh8w1.isRovoFPSUseRovoConfigEnabled)()) return (0, $6jeRt.getSupportedAccessibleProducts)({
        supportedProducts: supportedProducts,
        products: products,
        accessibleProducts: accessibleProducts
    });
    if (!accessibleProducts) return [];
    const fgControlledProducts = {
        [(0, $dvVWp.ProductKeys).Talent]: (0, $iDrrr.fg)('talent_global_search')
    };
    const disabledProducts3PFromConfig = [];
    (0, $fd0l2.ThirdPartyConfigsSync).forEach((config, productKey3P)=>{
        if (config && !config.isEnabled()) disabledProducts3PFromConfig.push(productKey3P);
    });
    const accessibleAndSupportedProducts = accessibleProducts.filter((productKey)=>!disabledProducts3PFromConfig.find((featureGatedProduct)=>featureGatedProduct === productKey) && (productKey in fgControlledProducts ? fgControlledProducts[productKey] : true)).filter((productKey)=>{
        // Forge connectors are dynamically added and won't be in supportedProducts
        if ((0, $8fNUp.isForgeConnectorProductKey)(productKey) && (0, $iDrrr.fg)('rovo-search-dynamic-forge-config')) return true;
        // For hardcoded products, check if they're in supportedProducts
        return supportedProducts.includes(productKey);
    });
    if (products) {
        const allowedProducts = products.filter((product)=>accessibleAndSupportedProducts.includes(product));
        return allowedProducts;
    } else {
        if (//TODO: move this logic to xpsearch aggregator before release with the correct conditions
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        accessibleAndSupportedProducts.includes((0, $dvVWp.ProductKeys).JiraServiceManagement) && (0, $iDrrr.fg)('assets_rovo_search_all') && // add assets as a product if JSM license is present, but this is until assets becomes a platform
        !(0, $iDrrr.fg)('aurum-assets-as-a-platform') // disable this when assets becomes a platform and we will start getting assets as its product
        ) return [
            ...accessibleAndSupportedProducts,
            (0, $dvVWp.ProductKeys).Assets
        ];
        return accessibleAndSupportedProducts;
    }
};
module.exports["getAccessibleProducts"] = $94b8c9fa1b18d88d$export$b38c0215344366f7;

});

parcelRegister("ktiKH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $kh8w1 = parcelRequire("kh8w1");


var $biQM6 = parcelRequire("biQM6");


var $a14M2 = parcelRequire("a14M2");


var $yW9ML = parcelRequire("yW9ML");


var $bYMyf = parcelRequire("bYMyf");

const $b0de8a9155c475f6$export$b676c7d6baea13e9 = ({ children: children, experience: experience, accessibleProducts: accessibleProducts, ...props })=>{
    const { thirdPartyConfigs: initialThirdPartyConfigsProp, searchSessionId: searchSessionIdProp, smartLinkUsage: smartLinkUsageProp } = props.initialProps || {};
    const safeQueryParams = props.queryParams && (0, $biQM6.parseQueryParams)(props.queryParams);
    /**
   * searchSessionId is generated on the client and does not change frequently, but can be refreshed with refreshSearchSessionId
   *
   * This is effectively a global so can't be drilled much deeper than search-page-relay
   */ const [searchSessionId, setSearchSessionId] = (0, $cozmU.useState)(searchSessionIdProp ?? crypto.randomUUID());
    const refreshSearchSessionId = (0, $cozmU.useCallback)(()=>{
        const newSearchSessionId = crypto.randomUUID();
        setSearchSessionId(newSearchSessionId);
    }, []);
    /**
   * Initial ?referrer=X paramater for analytics
   * Referrer is actually static for a single page load once, but is cleaned up after use so it isn't re-used in analytics events
   *
   * This is effectively a global so can't be drilled much deeper than search-page-relay
   */ const [referrer, setReferrer] = (0, $cozmU.useState)(safeQueryParams?.referrer);
    const clearReferrer = (0, $cozmU.useCallback)(()=>{
        setReferrer(undefined);
    }, []);
    /**
   * Initial ?text=X parameter for search store
   *
   * I think this is only used in search-page when checking referrer (not relay) and can be cleaned up with `search-page-relay`
   */ const [initialText] = (0, $cozmU.useState)(safeQueryParams?.text);
    const staticProps = {
        refreshSearchSessionId: refreshSearchSessionId,
        clearReferrer: clearReferrer,
        initialText: initialText,
        initialThirdPartyConfigs: (0, $kh8w1.isRovoFPSUseRovoConfigEnabled)() ? {} : initialThirdPartyConfigsProp || {},
        experience: experience,
        accessibleProducts: accessibleProducts
    };
    const dynamicProps = {
        searchSessionId: searchSessionId,
        referrer: referrer,
        smartLinkUsage: smartLinkUsageProp,
        ...(0, $kh8w1.isRovoFPSUseRovoConfigEnabled)() && {
            thirdPartyConfigs: initialThirdPartyConfigsProp || {}
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bYMyf.StaticContextProvider), {
        ...props,
        ...staticProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a14M2.DynamicContextProvider), {
        ...props,
        ...dynamicProps
    }, children));
};
const $b0de8a9155c475f6$export$dada99aabcba96f5 = /*#__PURE__*/ (0, $cozmU.createContext)((0, $bYMyf.defaultStaticContext));
const $b0de8a9155c475f6$export$64067c351da2da1b = /*#__PURE__*/ (0, $cozmU.createContext)((0, $yW9ML.createStaticBootstrapStore)((0, $bYMyf.defaultStaticContext)));
const $b0de8a9155c475f6$export$7925fbd6de082b5c = /*#__PURE__*/ (0, $cozmU.createContext)((0, $a14M2.defaultDynamicContext));
module.exports["BootstrapContextProvider"] = $b0de8a9155c475f6$export$b676c7d6baea13e9;
module.exports["StaticBootstrapContext"] = $b0de8a9155c475f6$export$dada99aabcba96f5;
module.exports["StaticBootstrapStoreContext"] = $b0de8a9155c475f6$export$64067c351da2da1b;
module.exports["DynamicBootstrapContext"] = $b0de8a9155c475f6$export$7925fbd6de082b5c;

});

parcelRegister("4BJ6s", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");


var $iDrrr = parcelRequire("iDrrr");

const $69f0b6cf42752fd8$export$1a5e9086021cdce5 = ()=>{
    // This FG is used to force enable the context store code path for e2e testing purposes
    if ((0, $iDrrr.fg)('rovo-search-remove-rss-bootstrap-fg')) return true;
    return (0, $cXtTj.default).getExperimentValue('rovo-search-remove-rss-bootstrap-exp', 'cohort', 'control', {
        fireExperimentExposure: true
    }) === 'test';
};
module.exports["serveBootstrapProviderExp"] = $69f0b6cf42752fd8$export$1a5e9086021cdce5;

});

parcelRegister("kIkSt", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $AgYeH = parcelRequire("AgYeH");


var $b0Mpu = parcelRequire("b0Mpu");

const $cd384567b55f9b2c$var$LOOM_FOLDERS_SEARCH_OPERATION_NAME = 'LoomRovoFoldersSearchQuery';
const $cd384567b55f9b2c$var$loomFoldersSearchGraphQuery = `
	query ${$cd384567b55f9b2c$var$LOOM_FOLDERS_SEARCH_OPERATION_NAME}(
		$siteId: ID!
		$query: String
		$spaceId: ID
		$includeDefaultFolders: Boolean
	) {
		loom_foldersSearch(
			siteId: $siteId
			query: $query
			spaceId: $spaceId
			includeDefaultFolders: $includeDefaultFolders
		) {
			id
			name
			parentSpaceId
		}
	}
`;
const $cd384567b55f9b2c$var$trimToLimit = (result, limit)=>typeof limit === 'number' ? {
        ...result,
        data: result.data ? {
            ...result.data,
            loom_foldersSearch: result.data.loom_foldersSearch.slice(0, limit)
        } : result.data
    } : result;
const $cd384567b55f9b2c$export$4be1bdb8e3aa7332 = async ({ variables: variables, aggAbsoluteUrl: aggAbsoluteUrl, headers: headers })=>{
    // `limit` is not sent to AGG: `loom_foldersSearch` has no limit variable in the GraphQL schema,
    // so we request the full result set and cap length client-side in `trimToLimit` below.
    const { siteId: siteId, query: query, spaceId: spaceId, includeDefaultFolders: includeDefaultFolders, limit: limit } = variables;
    const response = await (0, $b0Mpu.fetchAgg)({
        variables: {
            siteId: siteId,
            query: query,
            spaceId: spaceId,
            includeDefaultFolders: includeDefaultFolders
        },
        aggAbsoluteUrl: aggAbsoluteUrl,
        graphQuery: $cd384567b55f9b2c$var$loomFoldersSearchGraphQuery,
        operationName: $cd384567b55f9b2c$var$LOOM_FOLDERS_SEARCH_OPERATION_NAME,
        headers: headers
    });
    return $cd384567b55f9b2c$var$trimToLimit(response, limit);
};



var $7Ag9o = parcelRequire("7Ag9o");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

const $2679b162acbc1f52$var$DEFAULT_LOOM_FOLDER_INITIAL_LIMIT = 15;
const $2679b162acbc1f52$var$DEFAULT_LOOM_FOLDER_LOOKUP_LIMIT = 15;
/** Max concurrent AGG `loom_foldersSearch` calls (1 default + N per selected space share this pool). */ const $2679b162acbc1f52$var$LOOM_FOLDER_AGG_CONCURRENCY = 5;
async function $2679b162acbc1f52$var$runWithConcurrencyLimit(tasks, concurrency) {
    if (tasks.length === 0) return [];
    const safeConcurrency = Math.max(1, Math.floor(concurrency));
    const results = new Array(tasks.length);
    let nextIndex = 0;
    const worker = async ()=>{
        for(;;){
            const index = nextIndex++;
            if (index >= tasks.length) return;
            const [outcome] = await Promise.allSettled([
                tasks[index]()
            ]);
            results[index] = outcome.status === 'fulfilled' ? outcome.value : undefined;
        }
    };
    const workerCount = Math.min(safeConcurrency, tasks.length);
    await Promise.allSettled(Array.from({
        length: workerCount
    }, ()=>worker()));
    return results;
}
const $2679b162acbc1f52$var$isLoomFolderProduct = (product)=>product === (0, $dvVWp.ProductKeys).Loom && (0, $iDrrr.fg)('loom-rovo-search');
const $2679b162acbc1f52$var$getSelectedSpaceAris = (config)=>Array.isArray(config.initialSpaceARIs) ? config.initialSpaceARIs.filter(Boolean) : [];
const $2679b162acbc1f52$var$mapFolderNodeToOption = (folder)=>({
        trackingKey: folder.id,
        value: folder.id,
        label: (0, $7Ag9o.cleanExcerpt)(folder.name),
        queryParamValue: folder.id,
        product: (0, $dvVWp.ProductKeys).Loom,
        isDefault: false,
        isSelected: false,
        isSuggested: true,
        ...folder.parentSpaceId ? {
            metadata: {
                parentSpaceId: folder.parentSpaceId
            }
        } : {}
    });
async function $2679b162acbc1f52$var$fetchLoomFolderOptions(config, { query: query = '', limit: limit = $2679b162acbc1f52$var$DEFAULT_LOOM_FOLDER_INITIAL_LIMIT } = {}) {
    if (!$2679b162acbc1f52$var$isLoomFolderProduct(config.product)) return [];
    const cloudId = config.cloudId;
    if (!cloudId) return [];
    const spaceAris = $2679b162acbc1f52$var$getSelectedSpaceAris(config);
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const queryVariables = {
        siteId: cloudId,
        query: query || undefined,
        limit: limit
    };
    // Workspace / personal default folders (Personal Library, Archived, …) require no spaceId.
    // Run all folder fetches with bounded concurrency so many selected Loom spaces do not fan out
    // unbounded parallel AGG calls (see `LOOM_FOLDER_AGG_CONCURRENCY`).
    const folderFetchTasks = [
        ()=>(0, $cd384567b55f9b2c$export$4be1bdb8e3aa7332)({
                variables: {
                    ...queryVariables,
                    includeDefaultFolders: true
                },
                aggAbsoluteUrl: config.aggAbsoluteUrl,
                headers: headers
            }),
        ...spaceAris.map((spaceId)=>()=>(0, $cd384567b55f9b2c$export$4be1bdb8e3aa7332)({
                    variables: {
                        ...queryVariables,
                        spaceId: spaceId,
                        includeDefaultFolders: false
                    },
                    aggAbsoluteUrl: config.aggAbsoluteUrl,
                    headers: headers
                }))
    ];
    const responses = await $2679b162acbc1f52$var$runWithConcurrencyLimit(folderFetchTasks, $2679b162acbc1f52$var$LOOM_FOLDER_AGG_CONCURRENCY);
    const seenFolderIds = new Set();
    const folderOptions = [];
    for (const response of responses){
        if (response === undefined) continue;
        for (const folder of response.data?.loom_foldersSearch ?? []){
            if (seenFolderIds.has(folder.id)) continue;
            seenFolderIds.add(folder.id);
            folderOptions.push($2679b162acbc1f52$var$mapFolderNodeToOption(folder));
        }
    }
    return folderOptions;
}
const $2679b162acbc1f52$var$getInitialOptions = async (config)=>$2679b162acbc1f52$var$fetchLoomFolderOptions(config, {
        query: '',
        limit: $2679b162acbc1f52$var$DEFAULT_LOOM_FOLDER_INITIAL_LIMIT
    });
const $2679b162acbc1f52$var$fetchLookupOptions = async (input, config)=>{
    if (!$2679b162acbc1f52$var$isLoomFolderProduct(config.product)) return [];
    return $2679b162acbc1f52$var$fetchLoomFolderOptions(config, {
        query: input,
        limit: $2679b162acbc1f52$var$DEFAULT_LOOM_FOLDER_LOOKUP_LIMIT
    });
};
const $2679b162acbc1f52$var$getFilterProducts = ()=>(0, $iDrrr.fg)('loom-rovo-search') ? [
        (0, $dvVWp.ProductKeys).Loom
    ] : [];
const $2679b162acbc1f52$var$baseFilter = (0, $7MX1N.createMultiSelectFilter)({
    id: 'folder',
    products: $2679b162acbc1f52$var$getFilterProducts(),
    alwaysVisible: false,
    universal: false,
    queryParams: {
        key: 'folders'
    },
    initialOptions: {
        fetcher: $2679b162acbc1f52$var$getInitialOptions
    },
    lookup: {
        fetcher: $2679b162acbc1f52$var$fetchLookupOptions
    }
});
const $2679b162acbc1f52$var$canFetchLoomFoldersForConfig = (config)=>$2679b162acbc1f52$var$isLoomFolderProduct(config.product) && Boolean(config.cloudId);
const $2679b162acbc1f52$var$withLoomFolderScopedLoading = (monad, config)=>({
        ...monad,
        loadInitialOptions: async (onStateChange)=>{
            if (!$2679b162acbc1f52$var$canFetchLoomFoldersForConfig(config)) return monad;
            return monad.loadInitialOptions(onStateChange);
        },
        setLookupInput: async (query, onStateChange)=>{
            if (!$2679b162acbc1f52$var$canFetchLoomFoldersForConfig(config)) return monad;
            return monad.setLookupInput(query, onStateChange);
        }
    });
const $2679b162acbc1f52$export$3dea766d36a8935f = {
    ...$2679b162acbc1f52$var$baseFilter,
    withState: (state, config)=>$2679b162acbc1f52$var$withLoomFolderScopedLoading($2679b162acbc1f52$var$baseFilter.withState(state, config), config),
    getInitialState: (config)=>$2679b162acbc1f52$var$withLoomFolderScopedLoading($2679b162acbc1f52$var$baseFilter.getInitialState(config), config),
    get products () {
        return $2679b162acbc1f52$var$getFilterProducts();
    }
};
module.exports["filter"] = $2679b162acbc1f52$export$3dea766d36a8935f;

});

parcelRegister("fFs6O", function(module, exports) {

var $j2nXD = parcelRequire("j2nXD");


var $dvVWp = parcelRequire("dvVWp");


var $7MX1N = parcelRequire("7MX1N");

const $905d93f73911b710$export$3dea766d36a8935f = (0, $7MX1N.createMultiSelectFilter)({
    id: 'site',
    products: [
        ...(0, $dvVWp.all1pProductKeys),
        ...(0, $dvVWp.all3pProductKeys)
    ],
    alwaysVisible: false,
    universal: true,
    queryParams: {
        key: 'sites',
        fetcher: async (queryParams, config)=>{
            return (config.unitMetadata ?? []).map((site)=>({
                    cloudId: (0, $j2nXD.getSiteCloudId)(site.id),
                    siteName: site.siteName
                })).filter(({ cloudId: cloudId })=>cloudId !== config.cloudId && // Excludes the current site (injected as display-only)
                queryParams.includes(cloudId)).map(({ cloudId: cloudId, siteName: siteName })=>({
                    trackingKey: cloudId,
                    value: cloudId,
                    label: siteName,
                    queryParamValue: cloudId,
                    isSelected: true
                }));
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return (config.unitMetadata ?? []).map((site)=>({
                    cloudId: (0, $j2nXD.getSiteCloudId)(site.id),
                    siteName: site.siteName
                })).filter(({ cloudId: cloudId })=>cloudId !== config.cloudId // Excludes the current site (injected as display-only)
            ).map(({ cloudId: cloudId, siteName: siteName })=>({
                    trackingKey: cloudId,
                    value: cloudId,
                    label: siteName,
                    queryParamValue: cloudId
                }));
        }
    }
});
module.exports["filter"] = $905d93f73911b710$export$3dea766d36a8935f;

});

parcelRegister("9AliR", function(module, exports) {

var $4ysB6 = parcelRequire("4ysB6");


var $dvVWp = parcelRequire("dvVWp");


var $kZdMI = parcelRequire("kZdMI");


var $7IS25 = parcelRequire("7IS25");

const $f17bc3a8bd0f04dd$var$loadQueryParams = (queryParams, config)=>{
    const allOptions = (0, $7IS25.getAllTypeOptions)(config);
    return allOptions.filter((option)=>!option.isDefault).filter((option)=>queryParams.includes(option.queryParamValue)).map((option)=>({
            trackingKey: option.value,
            label: option.label,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault,
            product: config.product
        }));
};
const $f17bc3a8bd0f04dd$var$getInitialOptions = (config)=>{
    const allOptions = (0, $7IS25.getAllTypeOptions)(config);
    return allOptions.map((option)=>({
            trackingKey: option.value,
            label: option.label,
            value: option.value,
            queryParamValue: option.queryParamValue,
            isDefault: option.isDefault,
            product: config.product
        }));
};
const $f17bc3a8bd0f04dd$var$sortCompareFn = (a, b)=>{
    const allOption = (0, $7IS25.getAllTypeOptions)({
        intl: undefined
    });
    return allOption.findIndex((option)=>option.queryParamValue === a.queryParamValue) - allOption.findIndex((option)=>option.queryParamValue === b.queryParamValue);
};
const $f17bc3a8bd0f04dd$export$3dea766d36a8935f = (0, $kZdMI.createSingleSelectFilter)({
    id: (0, $4ysB6.universalTypeFilterId),
    products: (0, $dvVWp.allProductKeys),
    alwaysVisible: true,
    universal: true,
    queryParams: {
        key: 'type',
        fetcher: async (queryParams, config)=>{
            return $f17bc3a8bd0f04dd$var$loadQueryParams(queryParams, config);
        }
    },
    initialOptions: {
        fetcher: async (config)=>{
            return $f17bc3a8bd0f04dd$var$getInitialOptions(config);
        }
    },
    lookup: {
        fetcher: async (query, config)=>{
            // NOTE: this is the first step of filtering options
            //  the store does product specific filtering
            return (0, $7IS25.lookupOptions)(query, config);
        }
    },
    sortCompareFn: $f17bc3a8bd0f04dd$var$sortCompareFn
});
module.exports["filter"] = $f17bc3a8bd0f04dd$export$3dea766d36a8935f;

});

parcelRegister("gwa0N", function(module, exports) {
const $ea4d5fa2e98920cc$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        const booleanValue = queryParamValue?.[0] === 'true' ? true : false;
        return {
            ...initialState,
            value: booleanValue || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $ea4d5fa2e98920cc$export$64e49a0c7bd6f7a0;

});

parcelRegister("6uNXh", function(module, exports) {

var $gwa0N = parcelRequire("gwa0N");

const $c827cef6a94b859d$export$2963583aeb05fcae = (initial)=>{
    const initialState = {
        ...initial,
        type: 'boolean',
        value: false,
        hasSelection: false,
        universal: initial.universal
    };
    return {
        id: initial.id,
        type: initialState.type,
        products: initial.products,
        universal: initial.universal,
        queryParams: {
            key: initialState.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $gwa0N.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$c827cef6a94b859d$export$cd193ee4357dee7f({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$c827cef6a94b859d$export$cd193ee4357dee7f({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false,
        isSuggestedFilter: initial.isSuggestedFilter
    };
};
const $c827cef6a94b859d$export$cd193ee4357dee7f = ({ initial: initial, state: state, config: config })=>{
    const filterState = {
        ...state,
        hasSelection: state.value
    };
    return {
        ...filterState,
        setValue: $c827cef6a94b859d$var$setValue({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: ()=>filterState.value,
        getState: ()=>filterState,
        queryParams: {
            key: initial.queryParams.key,
            get: $c827cef6a94b859d$var$getQueryParams({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $c827cef6a94b859d$var$setQueryParams({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        clear: $c827cef6a94b859d$var$clear({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $c827cef6a94b859d$var$setValue = ({ initial: initial, state: state, config: config })=>{
    return (value)=>{
        const newState = {
            ...state,
            value: value,
            hasSelection: value
        };
        return $c827cef6a94b859d$export$cd193ee4357dee7f({
            initial: initial,
            state: newState,
            config: config
        });
    };
};
const $c827cef6a94b859d$var$getQueryParams = ({ initial: initial, state: state })=>{
    return ()=>({
            [initial.queryParams.key]: state.value === true ? [
                'true'
            ] : undefined
        });
};
const $c827cef6a94b859d$var$setQueryParams = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams)=>{
        const queryParamValue = queryParams[initial.queryParams.key];
        const booleanValue = queryParamValue?.[0] === 'true' ? true : false;
        return $c827cef6a94b859d$export$cd193ee4357dee7f({
            initial: initial,
            state: {
                ...state,
                value: booleanValue,
                hasSelection: booleanValue
            },
            config: config
        });
    };
};
const $c827cef6a94b859d$var$clear = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $c827cef6a94b859d$export$cd193ee4357dee7f({
            initial: initial,
            state: state,
            config: config
        });
        return filter.setValue(false);
    };
};
module.exports["createBooleanFilter"] = $c827cef6a94b859d$export$2963583aeb05fcae;

});

parcelRegister("7Nao2", function(module, exports) {

var $cJff5 = parcelRequire("cJff5");


var $4NJNH = parcelRequire("4NJNH");

const $2293d7b5f5f2f478$export$d2312e68e1f5ad00 = ({ initial: initial, state: state, config: config })=>{
    return (options)=>{
        const isDeactivatedContributorEnabled = initial.id === 'contributor' && (0, $cJff5.serveAppendDeactivatedAccountToContributorList)();
        const productBasedOptionsFilter = (option)=>option.product === (0, $4NJNH.getProductForFilterOption)({
                config: config,
                isUniversal: initial.universal
            });
        const allSelectedValues = new Set([
            ...state.queryParams.options.filter(productBasedOptionsFilter).filter((option)=>option.isSelected).map((option)=>option.value),
            ...state.initialOptions.options.filter(productBasedOptionsFilter).filter((option)=>option.isSelected).map((option)=>option.value),
            ...state.lookup.options.filter(productBasedOptionsFilter).filter((lookupOption)=>lookupOption.isSelected).map((option)=>option.value)
        ]);
        if (options.isLookupActive) {
            const withPersistedSelectedOptions = ()=>{
                const lookupResultValues = new Set(state.lookup.lookupResultOptions.map((option)=>option.value));
                const persistedSelectedOptions = [
                    ...state.queryParams.options,
                    ...state.initialOptions.options,
                    ...state.lookup.options
                ].filter(productBasedOptionsFilter).filter((option)=>allSelectedValues.has(option.value) && !lookupResultValues.has(option.value));
                const selectedPersistedDuplicates = new Set();
                return [
                    ...persistedSelectedOptions.filter((option)=>!selectedPersistedDuplicates.has(option.value) && selectedPersistedDuplicates.add(option.value)),
                    ...state.lookup.lookupResultOptions
                ];
            };
            const lookupResults = (isDeactivatedContributorEnabled ? withPersistedSelectedOptions() : state.lookup.lookupResultOptions).map((option)=>({
                    ...option,
                    isSelected: allSelectedValues.has(option.value)
                })).sort((option1, option2)=>Number(option2.isSelected) - Number(option1.isSelected));
            return lookupResults;
        }
        const duplicateOptions = new Set();
        const newOptions = [
            ...state.queryParams.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // The 'interacted' options are persisted in  state.lookup.options
            ...state.lookup.options,
            ...state.initialOptions.options
        ].filter(productBasedOptionsFilter).filter((option)=>!duplicateOptions.has(option.value) && duplicateOptions.add(option.value)).map((option)=>({
                ...option,
                isSelected: allSelectedValues.has(option.value)
            }));
        if (initial.sortCompareFn) return newOptions.sort(initial.sortCompareFn);
        return newOptions;
    };
};
module.exports["getOptions"] = $2293d7b5f5f2f478$export$d2312e68e1f5ad00;

});

parcelRegister("7MX1N", function(module, exports) {

var $7ir7l = parcelRequire("7ir7l");


var $1E0hA = parcelRequire("1E0hA");


var $7Nao2 = parcelRequire("7Nao2");

const $d5b625e2e95a5452$export$9c05e038f495cba8 = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'multi-select',
        didMountPerProducts: {},
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $1E0hA.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$d5b625e2e95a5452$export$63027158d47e5479({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$d5b625e2e95a5452$export$63027158d47e5479({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false,
        isSuggestedFilter: initial.isSuggestedFilter,
        requiresTopLevel3PDatasource: initial.requiresTopLevel3PDatasource
    };
};
const $d5b625e2e95a5452$export$63027158d47e5479 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $7ir7l.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: (0, $7ir7l.getQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: (0, $7ir7l.setQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $7ir7l.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: (0, $7ir7l.setOption)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $7ir7l.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $7ir7l.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $7Nao2.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $7ir7l.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $7ir7l.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
module.exports["createMultiSelectFilter"] = $d5b625e2e95a5452$export$9c05e038f495cba8;
module.exports["MultiSelectFilter"] = $d5b625e2e95a5452$export$63027158d47e5479;

});

parcelRegister("ekeCA", function(module, exports) {

var $dYKlp = parcelRequire("dYKlp");

/**
 * Module-level cache of in-flight (or resolved) promises for
 * `getThirdPartyFilterOptions`, keyed by `${cloudId}::${datasourceId}`.
 *
 * The endpoint returns **all** custom filters for an integration in a single
 * response, so multiple filters that share the same datasource (e.g. campaign
 * status, case status, deal stage) can reuse one promise instead of each
 * issuing an independent network request.
 *
 * Cache lifetime: a typical session has at most O(connected integrations)
 * entries (usually 1–5), so no eviction strategy is needed.  The cache is
 * intentionally kept for the lifetime of the page — filter-option data is
 * static per datasource within a search session.
 *
 * Rejection handling: failed entries are removed so subsequent callers can
 * retry rather than receive a permanently-stuck rejected promise.
 *
 * Cache key: `cloudId::datasourceId::orgId` so different orgs do not share a cached response.
 * `aggAbsoluteUrl` is
 * intentionally excluded — it is constant for a given (cloudId, datasourceId) pair within a
 * session and so cannot disambiguate entries.
 */ const $dfc58da14dd3ac6c$var$cache = new Map();
const $dfc58da14dd3ac6c$export$92d46a4d5ee2716c = (config)=>{
    const { cloudId: cloudId } = config;
    const datasourceId = config.selectedDatasource?.datasourceId;
    // Defensive guard: do not invoke (or cache) without a complete key.
    // Callers in filter index files are expected to short-circuit before this.
    if (!cloudId || !datasourceId) return Promise.resolve(null);
    const orgId = config.orgId;
    const orgSegment = config.orgId ?? '';
    const fetchOptions = {
        cloudId: cloudId,
        datasourceId: datasourceId,
        orgId: orgId,
        aggAbsoluteUrl: config.aggAbsoluteUrl
    };
    const key = `${cloudId}::${datasourceId}::${orgSegment}`;
    let promise = $dfc58da14dd3ac6c$var$cache.get(key);
    if (!promise) {
        promise = (0, $dYKlp.getThirdPartyFilterOptions)(fetchOptions);
        // Evict on failure so the next call can retry.
        promise.catch(()=>$dfc58da14dd3ac6c$var$cache.delete(key));
        $dfc58da14dd3ac6c$var$cache.set(key, promise);
    }
    return promise;
};
const $dfc58da14dd3ac6c$export$a54b0e43665cba85 = ()=>{
    $dfc58da14dd3ac6c$var$cache.clear();
};
module.exports["getCachedThirdPartyFilterOptions"] = $dfc58da14dd3ac6c$export$92d46a4d5ee2716c;

});

parcelRegister("7ir7l", function(module, exports) {

var $cJff5 = parcelRequire("cJff5");


var $7Nao2 = parcelRequire("7Nao2");


var $4NJNH = parcelRequire("4NJNH");


const $e70b761ee131722b$export$639eaf0f64f8fe4 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: $e70b761ee131722b$export$50fdfeece43146fd({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: $e70b761ee131722b$export$e2de15bbd9edf9c6({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $e70b761ee131722b$export$7755017099c85a0d({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: $e70b761ee131722b$export$ad6c12f692e14555({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $e70b761ee131722b$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: $e70b761ee131722b$export$69017055aa8b346e({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: $e70b761ee131722b$export$92164aa84e23cd67({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $7Nao2.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: $e70b761ee131722b$export$bf7199a9ebcb84a9({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: $e70b761ee131722b$export$d0f857db6e3e26d7({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $e70b761ee131722b$export$50fdfeece43146fd = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const allOptions = filter.getOptions({
            isLookupActive: false
        });
        const newOptions = filter.getOptions({
            isLookupActive: state.lookup.isActive
        });
        const selectedOptions = allOptions.filter((option)=>option.isSelected);
        const newState = {
            ...state,
            options: newOptions,
            selectedOptions: selectedOptions,
            hasSelection: selectedOptions.length > 0,
            value: filter.getValue()
        };
        return newState;
    };
};
const $e70b761ee131722b$export$7755017099c85a0d = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams, onStateChange)=>{
        const queryParamValues = queryParams[initial.queryParams.key];
        const filter = $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        if (!queryParamValues) {
            const clearedOptions = filter.clearOptions();
            onStateChange?.(clearedOptions.getState());
            return clearedOptions;
        }
        const allCurrentOptions = filter.getOptions({
            isLookupActive: false
        });
        const allQueryParamValues = allCurrentOptions.map((option)=>option.queryParamValue);
        const queryParamsToHydrate = queryParamValues.filter((value)=>!allQueryParamValues.includes(value));
        if (queryParamsToHydrate.length === 0) {
            const newOptions = allCurrentOptions.map((option)=>({
                    isSelected: queryParamValues.includes(option.queryParamValue),
                    value: option.value
                }));
            const filterWithNewOptions = filter.setOption(newOptions);
            onStateChange?.(filterWithNewOptions.getState());
            return filterWithNewOptions;
        }
        // At this point we need to hydrate the filters with new options from
        // the query params
        const newQueryParamOptions = [
            ...state.queryParams.options
        ];
        const fetcher = initial.queryParams.fetcher;
        if (fetcher) {
            onStateChange?.({
                ...state,
                queryParams: {
                    ...state.queryParams,
                    isLoading: true
                }
            });
            const fetchedOptions = await fetcher(queryParamsToHydrate, config);
            fetchedOptions.forEach((option)=>{
                const mappedOption = {
                    isSelected: true,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata,
                    product: (0, $4NJNH.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    })
                };
                newQueryParamOptions.push(mappedOption);
            });
        }
        const selectedOptionsFromQueryParams = newQueryParamOptions.map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const selectedInitialOptionsFromQueryParams = [
            ...state.initialOptions.options
        ].map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const hydratedQueryParams = $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    options: selectedOptionsFromQueryParams,
                    isLoading: false
                },
                initialOptions: {
                    ...state.initialOptions,
                    options: selectedInitialOptionsFromQueryParams
                }
            },
            config: config
        });
        onStateChange?.(hydratedQueryParams.getState());
        return hydratedQueryParams;
    };
};
const $e70b761ee131722b$export$e2de15bbd9edf9c6 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const queryParamValue = $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        }).filter((option)=>option.isSelected).map((option)=>option.queryParamValue);
        return {
            [initial.queryParams.key]: queryParamValue
        };
    };
};
const $e70b761ee131722b$export$ad6c12f692e14555 = ({ initial: initial, state: state, config: config })=>{
    return async (onStateChange)=>{
        const didMountForProduct = state.didMountPerProducts[(0, $4NJNH.getProductForFilterOption)({
            config: config,
            isUniversal: initial.universal
        })];
        if (didMountForProduct) // Already loaded — return the current monad without dispatching a state change.
        // Calling onStateChange here would cause a no-op store write (new object identity
        // for the same data), which makes downstream selectors that return derived references
        // (e.g. useFilters() consumers that compute new arrays/Sets) re-render. When the
        // caller is a useEffect that depends on derived values, this can trigger an
        // infinite render loop. The store should only change when something actually changed.
        return $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const newOptions = [
            ...state.initialOptions.options
        ];
        const fetcher = initial.initialOptions?.fetcher;
        if (fetcher) {
            const fetchingInitialOptionsState = {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    isLoading: true
                }
            };
            onStateChange?.(fetchingInitialOptionsState);
            try {
                const fetchedOptions = await fetcher(config);
                fetchedOptions.forEach((option)=>{
                    const mappedOption = {
                        isSelected: false,
                        trackingKey: option.trackingKey,
                        value: option.value,
                        queryParamValue: option.queryParamValue,
                        isSuggested: true,
                        isDefault: option.isDefault ?? false,
                        avatarUrl: option.avatarUrl,
                        label: option.label,
                        metadata: option.metadata,
                        product: (0, $4NJNH.getProductForFilterOption)({
                            config: config,
                            isUniversal: initial.universal
                        })
                    };
                    newOptions.push(mappedOption);
                });
            } catch  {
                const fetchFailedState = {
                    ...state,
                    initialOptions: {
                        ...state.initialOptions,
                        isLoading: false
                    }
                };
                onStateChange?.(fetchFailedState);
            }
        }
        const newInitialOptionsState = {
            ...state,
            didMountPerProducts: {
                ...state.didMountPerProducts,
                [(0, $4NJNH.getProductForFilterOption)({
                    config: config,
                    isUniversal: initial.universal
                })]: true
            },
            initialOptions: {
                ...state.initialOptions,
                options: newOptions,
                isLoading: false
            }
        };
        onStateChange?.(newInitialOptionsState);
        return $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: newInitialOptionsState,
            config: config
        });
    };
};
const $e70b761ee131722b$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option)=>{
        const isDeactivatedContributorEnabled = initial.id === 'contributor' && (0, $cJff5.serveAppendDeactivatedAccountToContributorList)();
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const optionsToChangeRecord = Object.fromEntries(optionsToChange.map((option)=>[
                option.value,
                option
            ]));
        const allExistingValues = new Set([
            ...state.queryParams.options.map((o)=>o.value),
            ...state.initialOptions.options.map((o)=>o.value),
            ...state.lookup.options.map((o)=>o.value),
            ...state.lookup.lookupResultOptions.map((o)=>o.value)
        ]);
        // Options being selected that don't exist in any list yet (e.g. dynamic async-loaded options
        // selected before the store has been populated) are added directly to queryParams.options so
        // they participate in URL param generation immediately.
        const newQueryParamOptions = optionsToChange.filter((o)=>o.isSelected && !allExistingValues.has(o.value)).map((o)=>({
                value: o.value,
                ...isDeactivatedContributorEnabled ? {
                    queryParamValue: o.queryParamValue ?? o.value,
                    trackingKey: o.trackingKey ?? o.value,
                    label: o.label ?? o.value,
                    avatarUrl: o.avatarUrl,
                    metadata: o.metadata
                } : {
                    queryParamValue: o.value,
                    trackingKey: o.value,
                    label: o.value
                },
                isSelected: true,
                isSuggested: false,
                isDefault: false,
                product: (0, $4NJNH.getProductForFilterOption)({
                    config: config,
                    isUniversal: initial.universal
                })
            }));
        const queryParamOptions = [
            ...state.queryParams.options.map((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value && (0, $4NJNH.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    }) === option.product)) return option;
                return {
                    ...option,
                    isSelected: optionsToChangeRecord[option.value]?.isSelected ?? false
                };
            }),
            ...newQueryParamOptions
        ];
        const initialOptions = state.initialOptions.options.map((option)=>{
            if (!optionsToChange.find((x)=>x.value === option.value && (0, $4NJNH.getProductForFilterOption)({
                    config: config,
                    isUniversal: initial.universal
                }) === option.product)) return option;
            return {
                ...option,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? false
            };
        });
        const duplicateOptions = new Set();
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // The 'interacted' options are persisted in  state.lookup.options
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].filter((option)=>!duplicateOptions.has(option.value) && duplicateOptions.add(option.value)).map((option)=>({
                ...option,
                isSuggested: true,
                isSelected: optionsToChangeRecord[option.value]?.isSelected ?? option.isSelected
            }));
        return $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
const $e70b761ee131722b$export$69017055aa8b346e = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const queryParamOptions = state.queryParams.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        const initialOptions = state.initialOptions.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        const lookupOptions = state.lookup.options.map((option)=>({
                ...option,
                isSelected: false
            }));
        return $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
const $e70b761ee131722b$export$92164aa84e23cd67 = ({ initial: initial, state: state, config: config })=>{
    return async (query, onStateChange)=>{
        if (!initial.lookup || query.length === 0 || state.lookup.input === query) {
            const noQueryState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    isLoading: false,
                    isActive: false
                }
            };
            onStateChange?.(noQueryState);
            return $e70b761ee131722b$export$639eaf0f64f8fe4({
                initial: initial,
                state: noQueryState,
                config: config
            });
        }
        const fetchingLookupOptionsState = {
            ...state,
            lookup: {
                ...state.lookup,
                input: query,
                isLoading: true,
                isActive: true
            }
        };
        onStateChange?.(fetchingLookupOptionsState);
        try {
            const fetchedLookupOptions = await initial.lookup.fetcher(query, config);
            const newLookupOptions = fetchedLookupOptions.map((option)=>{
                const mappedOption = {
                    isSelected: false,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata,
                    product: (0, $4NJNH.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    })
                };
                return mappedOption;
            });
            const newLookupOptionsState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    lookupResultOptions: newLookupOptions,
                    isLoading: false,
                    isActive: true
                }
            };
            onStateChange?.(newLookupOptionsState);
            return $e70b761ee131722b$export$639eaf0f64f8fe4({
                initial: initial,
                state: newLookupOptionsState,
                config: config
            });
        } catch  {
            const failedLookupOptionsState = {
                ...state,
                lookup: {
                    ...state.lookup,
                    input: query,
                    isLoading: false,
                    isActive: true
                }
            };
            onStateChange?.(failedLookupOptionsState);
            return $e70b761ee131722b$export$639eaf0f64f8fe4({
                initial: initial,
                state: failedLookupOptionsState,
                config: config
            });
        }
    };
};
const $e70b761ee131722b$export$bf7199a9ebcb84a9 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const value = $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        }).filter((option)=>option.isSelected).map((option)=>option.value);
        return value;
    };
};
const $e70b761ee131722b$export$d0f857db6e3e26d7 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const filter = $e70b761ee131722b$export$639eaf0f64f8fe4({
            initial: initial,
            state: state,
            config: config
        });
        const allOptions = [
            ...filter.getOptions({
                isLookupActive: true
            }),
            ...filter.getOptions({
                isLookupActive: false
            })
        ].map((option)=>({
                value: option.value,
                isSelected: false
            }));
        return filter.setOption(allOptions);
    };
};
module.exports["getState"] = $e70b761ee131722b$export$50fdfeece43146fd;
module.exports["getQueryParams"] = $e70b761ee131722b$export$e2de15bbd9edf9c6;
module.exports["setQueryParams"] = $e70b761ee131722b$export$7755017099c85a0d;
module.exports["loadInitialOptions"] = $e70b761ee131722b$export$ad6c12f692e14555;
module.exports["setOption"] = $e70b761ee131722b$export$b2a7969df3fe0aa3;
module.exports["clearOptions"] = $e70b761ee131722b$export$69017055aa8b346e;
module.exports["setLookupInput"] = $e70b761ee131722b$export$92164aa84e23cd67;
module.exports["getValue"] = $e70b761ee131722b$export$bf7199a9ebcb84a9;
module.exports["deselectOptions"] = $e70b761ee131722b$export$d0f857db6e3e26d7;

});

parcelRegister("1E0hA", function(module, exports) {
const $3494f3f137fe420a$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        return {
            ...initialState,
            value: queryParamValue || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $3494f3f137fe420a$export$64e49a0c7bd6f7a0;

});

parcelRegister("4NJNH", function(module, exports) {
const $50ea31049167f9c5$export$dc0a6726495eccc1 = (params)=>{
    if (params.isUniversal) return 'all';
    return(// If a product is selected, the filter option will be tied to the selected product
    params.config.product ?? // If no product is selected, such as the 'all' state it will use the primary product. This is the case for suggested space filters.
    // All suggested filters are sets the primary product as the product selected after a filter option selection.
    params.config.primaryProduct ?? 'all' // config.primaryProduct should always be defined but 'all' is used as a catch-all
    );
};
module.exports["getProductForFilterOption"] = $50ea31049167f9c5$export$dc0a6726495eccc1;

});

parcelRegister("fOh5X", function(module, exports) {
const $a6b73fbb01a0c4a5$export$d520529b4595d46c = [
    'ati:cloud:graph:document'
];
module.exports["DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI"] = $a6b73fbb01a0c4a5$export$d520529b4595d46c;

});

parcelRegister("gByuu", function(module, exports) {
/**
 * Merges filter option lists fetched per site into one list, round-robin so every site is fairly
 * represented, and drops repeats. Options are deduped by `value`, falling back to `trackingKey`;
 * options carrying neither are dropped.
 */ const $100acfa2cdd80a38$export$2fda76ee2696f1c5 = (optionLists)=>{
    const seen = new Set();
    const merged = [];
    const longest = optionLists.reduce((max, options)=>Math.max(max, options.length), 0);
    for(let index = 0; index < longest; index++)for (const options of optionLists){
        const option = options[index];
        if (!option) continue;
        // `||` not `??`: an empty-string value is not a usable key, so fall back to trackingKey.
        const dedupeKey = option.value || option.trackingKey;
        if (!dedupeKey || seen.has(dedupeKey)) continue;
        seen.add(dedupeKey);
        merged.push(option);
    }
    return merged;
};
module.exports["mergeAndDedupeOptions"] = $100acfa2cdd80a38$export$2fda76ee2696f1c5;

});

parcelRegister("82ADO", function(module, exports) {

var $3Ydx7 = parcelRequire("3Ydx7");

const $0b0d92b98afd7ee4$export$6dbf555668213f9e = (primaryProduct)=>{
    // URS (User Recommendation Service) only supports 'confluence' and 'jira' as product keys.
    // Other values (e.g. 'townsquare', 'mercury') cause a 400 deserialization error.
    // Default to 'confluence' when the primary product is not one of these two.
    return primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Jira || primaryProduct === (0, $3Ydx7.PrimaryProductKeys).Confluence ? primaryProduct : (0, $3Ydx7.PrimaryProductKeys).Confluence;
};
module.exports["getUrsProductKey"] = $0b0d92b98afd7ee4$export$6dbf555668213f9e;

});

parcelRegister("3e0Ll", function(module, exports) {

var $AgYeH = parcelRequire("AgYeH");


var $6yWnN = parcelRequire("6yWnN");


var $j5Usq = parcelRequire("j5Usq");

const $e64642fc2aa68e63$var$MAX_SMART_DEFAULT_OPTIONS = 5;
const $e64642fc2aa68e63$export$8e839a938752e935 = async (config)=>{
    const headers = (0, $AgYeH.buildAtlAttributionHeaders)({
        cloudId: config.cloudId,
        activationId: config.activationId,
        product: config.primaryProduct
    });
    const initialUsersQuery = (0, $j5Usq.usersQuery)([
        ...config.userId ? [
            config.userId
        ] : []
    ], headers);
    const recommendedUserQuery = (0, $6yWnN.smartsRecommendedUserQuery)({
        aggAbsoluteUrl: config.aggAbsoluteUrl,
        variables: {
            userId: config.userId || '',
            tenantId: config.cloudId || '',
            maxNumberOfResults: $e64642fc2aa68e63$var$MAX_SMART_DEFAULT_OPTIONS
        },
        headers: headers
    });
    const [initialUsersReponse, smartsRecommendedUserResponse] = await Promise.all([
        initialUsersQuery,
        recommendedUserQuery
    ]);
    const recommendedUsersResults = smartsRecommendedUserResponse.data?.smarts.results ?? [];
    const allRecommendedUsers = [
        ...initialUsersReponse.data?.users ?? [],
        ...recommendedUsersResults.flatMap((recommendedUsers)=>!!recommendedUsers && !!recommendedUsers.user ? {
                id: recommendedUsers.id,
                ...recommendedUsers.user
            } : [])
    ];
    const recommendedUserOptions = allRecommendedUsers.map((user)=>({
            trackingKey: user.accountId,
            value: user.accountId,
            label: user.name,
            avatarUrl: user.picture,
            queryParamValue: user.accountId,
            product: config.product
        }));
    return recommendedUserOptions;
};
module.exports["loadRecommendedUsers"] = $e64642fc2aa68e63$export$8e839a938752e935;

});

parcelRegister("iviWm", function(module, exports) {

var $gByuu = parcelRequire("gByuu");

const $e344f009f1c191eb$export$51337de818d0aa1c = async (config, fetchOptionsForSite)=>{
    // TODO: Use selectedCloudIds exclusively once the multi-site search experiment is cleaned up.
    const cloudIds = config.selectedCloudIds?.length ? config.selectedCloudIds : [
        config.cloudId || ''
    ];
    if (cloudIds.length === 1) return fetchOptionsForSite(cloudIds[0]);
    const settledPerSite = await Promise.allSettled(cloudIds.map((cloudId)=>fetchOptionsForSite(cloudId)));
    const succeeded = settledPerSite.filter((result)=>result.status === 'fulfilled');
    // One unhealthy site should not blank out the whole filter; only fail if every site failed.
    if (succeeded.length === 0) throw settledPerSite[0].reason;
    return (0, $gByuu.mergeAndDedupeOptions)(succeeded.map((result)=>result.value));
};
module.exports["fetchOptionsAcrossSites"] = $e344f009f1c191eb$export$51337de818d0aa1c;

});

parcelRegister("m6ow8", function(module, exports) {

var $c9Etd = parcelRequire("c9Etd");


var $7ir7l = parcelRequire("7ir7l");


var $1E0hA = parcelRequire("1E0hA");


var $7Nao2 = parcelRequire("7Nao2");


var $4NJNH = parcelRequire("4NJNH");

const $498f338ea1866e3a$export$711b0a1d273f9525 = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'single-select',
        didMountPerProducts: {},
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $1E0hA.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$498f338ea1866e3a$export$44d389225cc01eb5({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$498f338ea1866e3a$export$44d389225cc01eb5({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: true,
        isSuggestedFilter: initial.isSuggestedFilter,
        requiresTopLevel3PDatasource: initial.requiresTopLevel3PDatasource
    };
};
const $498f338ea1866e3a$export$e2de15bbd9edf9c6 = ({ initial: initial, state: state, config: config })=>{
    return ()=>{
        const options = $498f338ea1866e3a$export$44d389225cc01eb5({
            initial: initial,
            state: state,
            config: config
        }).getOptions({
            isLookupActive: false
        });
        const selectedOptions = options.filter((option)=>option.isSelected);
        const queryParamValue = selectedOptions.map((option)=>option.queryParamValue);
        const isCustomOptionSelected = selectedOptions.find((option)=>option.value === (0, $c9Etd.CUSTOM_OPTION_VALUE));
        const customValueQueryParam = isCustomOptionSelected && state.customValue ? state.customValue : {};
        return {
            [initial.queryParams.key]: queryParamValue,
            ...customValueQueryParam
        };
    };
};
const $498f338ea1866e3a$export$7755017099c85a0d = ({ initial: initial, state: state, config: config })=>{
    return async (queryParams, onStateChange)=>{
        const queryParamValues = queryParams[initial.queryParams.key];
        const filter = $498f338ea1866e3a$export$44d389225cc01eb5({
            initial: initial,
            state: state,
            config: config
        });
        if (!queryParamValues) {
            const clearedOptions = filter.clearOptions();
            onStateChange?.(clearedOptions.getState());
            return clearedOptions;
        }
        const allCurrentOptions = filter.getOptions({
            isLookupActive: false
        });
        const allQueryParamValues = allCurrentOptions.map((option)=>option.queryParamValue);
        const queryParamsToHydrate = queryParamValues.filter((value)=>!allQueryParamValues.includes(value));
        if (queryParamsToHydrate.length === 0) {
            const newOptions = allCurrentOptions.map((option)=>({
                    isSelected: queryParamValues.includes(option.queryParamValue),
                    value: option.value
                }));
            const isCustomOptionSelected = newOptions.find((option)=>option.value === (0, $c9Etd.CUSTOM_OPTION_VALUE))?.isSelected;
            const customValueParser = initial.queryParams.customValueParser;
            let customValue;
            if (isCustomOptionSelected) {
                if (customValueParser) customValue = customValueParser(queryParams);
                else customValue = initial.customValueFields ? initial.customValueFields.reduce((acc, field)=>({
                        ...acc,
                        [field]: queryParams[field]?.[0] ?? ''
                    }), {}) : {};
            }
            const filterWithNewOptions = filter.setOption(newOptions, customValue);
            onStateChange?.(filterWithNewOptions.getState());
            return filterWithNewOptions;
        }
        // At this point we need to hydrate the filters with new options from
        // the query params
        const newQueryParamOptions = [
            ...state.queryParams.options
        ];
        const fetcher = initial.queryParams.fetcher;
        if (fetcher) {
            onStateChange?.({
                ...state,
                queryParams: {
                    ...state.queryParams,
                    isLoading: true
                }
            });
            const fetchedOptions = await fetcher(queryParamsToHydrate, config);
            fetchedOptions.forEach((option)=>{
                const mappedOption = {
                    isSelected: true,
                    trackingKey: option.trackingKey,
                    value: option.value,
                    queryParamValue: option.queryParamValue,
                    isSuggested: false,
                    isDefault: option.isDefault ?? false,
                    avatarUrl: option.avatarUrl,
                    label: option.label,
                    metadata: option.metadata,
                    product: (0, $4NJNH.getProductForFilterOption)({
                        config: config,
                        isUniversal: initial.universal
                    })
                };
                newQueryParamOptions.push(mappedOption);
            });
        }
        const selectedOptionsFromQueryParams = newQueryParamOptions.map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        const selectedInitialOptionsFromQueryParams = [
            ...state.initialOptions.options
        ].map((option)=>({
                ...option,
                isSelected: queryParamValues.includes(option.queryParamValue)
            }));
        let customValue;
        const isCustomOptionSelected = selectedOptionsFromQueryParams.find((option)=>option.value === (0, $c9Etd.CUSTOM_OPTION_VALUE))?.isSelected;
        if (isCustomOptionSelected) {
            const customValueParser = initial.queryParams.customValueParser;
            if (customValueParser) customValue = customValueParser(queryParams);
            else customValue = initial.customValueFields ? initial.customValueFields.reduce((acc, field)=>({
                    ...acc,
                    [field]: queryParams[field]?.[0] ?? ''
                }), {}) : {};
        }
        const hydratedQueryParams = $498f338ea1866e3a$export$44d389225cc01eb5({
            initial: initial,
            state: {
                ...state,
                queryParams: {
                    ...state.queryParams,
                    options: selectedOptionsFromQueryParams,
                    isLoading: false
                },
                initialOptions: {
                    ...state.initialOptions,
                    options: selectedInitialOptionsFromQueryParams
                },
                customValue: customValue
            },
            config: config
        });
        onStateChange?.(hydratedQueryParams.getState());
        return hydratedQueryParams;
    };
};
const $498f338ea1866e3a$export$44d389225cc01eb5 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $7ir7l.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: $498f338ea1866e3a$export$e2de15bbd9edf9c6({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: $498f338ea1866e3a$export$7755017099c85a0d({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $7ir7l.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $498f338ea1866e3a$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $7ir7l.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $7ir7l.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $7Nao2.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $7ir7l.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $7ir7l.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $498f338ea1866e3a$var$updateOptionState = (props)=>(option)=>{
        if (option.isDefault) return {
            ...option,
            isSelected: false
        };
        return {
            ...option,
            isSelected: props.selectedOption ? props.selectedOption.value === option.value : option.isSelected
        };
    };
const $498f338ea1866e3a$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option, customValue)=>{
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const selectedOption = optionsToChange.filter((o)=>o.isSelected)[0];
        const queryParamOptions = state.queryParams.options.map($498f338ea1866e3a$var$updateOptionState({
            selectedOption: selectedOption
        }));
        const initialOptions = state.initialOptions.options.map($498f338ea1866e3a$var$updateOptionState({
            selectedOption: selectedOption
        }));
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // These 'interacted' options need to be persisted if a user wants to select them again
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].map($498f338ea1866e3a$var$updateOptionState({
            selectedOption: selectedOption
        }));
        return $498f338ea1866e3a$export$44d389225cc01eb5({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                },
                customValue: customValue
            },
            config: config
        });
    };
};
module.exports["createSingleWithCustomOptionSelectFilter"] = $498f338ea1866e3a$export$711b0a1d273f9525;

});

parcelRegister("kZdMI", function(module, exports) {

var $7ir7l = parcelRequire("7ir7l");


var $1E0hA = parcelRequire("1E0hA");


var $7Nao2 = parcelRequire("7Nao2");

const $6f4c23c6c3ab5dea$export$b77715d04a87c12b = (initial)=>{
    const initialState = Object.freeze({
        id: initial.id,
        type: 'single-select',
        didMountPerProducts: {},
        hasSelection: false,
        alwaysVisible: initial.alwaysVisible,
        universal: initial.universal,
        queryParams: {
            isLoading: false,
            options: []
        },
        lookup: {
            isLoading: false,
            isActive: false,
            isDefined: !!initial.lookup,
            options: [],
            lookupResultOptions: [],
            input: ''
        },
        initialOptions: {
            options: [],
            isLoading: false
        },
        options: [],
        selectedOptions: [],
        value: [],
        products: initial.products
    });
    return {
        id: initial.id,
        type: initialState.type,
        queryParams: {
            key: initial.queryParams.key,
            getState: (initial.queryParams.generateQueryParamsGetState ?? (0, $1E0hA.generateQueryParamsGetState))(initialState, initial.queryParams.key)
        },
        products: initial.products,
        universal: initial.universal,
        customValueFields: initial.customValueFields,
        withState: (state, config)=>$6f4c23c6c3ab5dea$export$767f444f15b8d660({
                initial: initial,
                state: state,
                config: config
            }),
        getInitialState: (config)=>$6f4c23c6c3ab5dea$export$767f444f15b8d660({
                initial: initial,
                state: initialState,
                config: config
            }),
        isCompatible: (id)=>id === initial.id,
        isSupportCustomValue: false,
        isSuggestedFilter: initial.isSuggestedFilter,
        requiresTopLevel3PDatasource: initial.requiresTopLevel3PDatasource
    };
};
const $6f4c23c6c3ab5dea$export$767f444f15b8d660 = ({ initial: initial, state: state, config: config })=>{
    const filterState = Object.freeze({
        ...state
    });
    return {
        id: initial.id,
        type: filterState.type,
        getState: (0, $7ir7l.getState)({
            initial: initial,
            state: filterState,
            config: config
        }),
        queryParams: {
            key: initial.queryParams.key,
            get: (0, $7ir7l.getQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            }),
            set: (0, $7ir7l.setQueryParams)({
                initial: initial,
                state: filterState,
                config: config
            })
        },
        loadInitialOptions: (0, $7ir7l.loadInitialOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setOption: $6f4c23c6c3ab5dea$export$b2a7969df3fe0aa3({
            initial: initial,
            state: filterState,
            config: config
        }),
        clearOptions: (0, $7ir7l.clearOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        setLookupInput: (0, $7ir7l.setLookupInput)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getOptions: (0, $7Nao2.getOptions)({
            initial: initial,
            state: filterState,
            config: config
        }),
        getValue: (0, $7ir7l.getValue)({
            initial: initial,
            state: filterState,
            config: config
        }),
        clear: (0, $7ir7l.deselectOptions)({
            initial: initial,
            state: filterState,
            config: config
        })
    };
};
const $6f4c23c6c3ab5dea$var$updateOptionState = (props)=>(option)=>{
        if (option.isDefault) return {
            ...option,
            isSelected: false
        };
        return {
            ...option,
            isSelected: props.firstSelectedOption?.value === option.value
        };
    };
const $6f4c23c6c3ab5dea$export$b2a7969df3fe0aa3 = ({ initial: initial, state: state, config: config })=>{
    return (option)=>{
        // Theoretically this should only ever give you one option to change
        const optionsToChange = Array.isArray(option) ? option : [
            option
        ];
        const firstSelectedOption = optionsToChange[0];
        const isOptionAlreadySelected = state.options.filter((x)=>x.isSelected).find((x)=>x.value === firstSelectedOption?.value);
        if (isOptionAlreadySelected) // do nothing
        return $6f4c23c6c3ab5dea$export$767f444f15b8d660({
            initial: initial,
            state: state,
            config: config
        });
        const queryParamOptions = state.queryParams.options.map($6f4c23c6c3ab5dea$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        const initialOptions = state.initialOptions.options.map($6f4c23c6c3ab5dea$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        const lookupOptions = [
            ...state.lookup.options,
            // 'interacted' lookup options are options that a user made a lookup for and has either
            // selected or deselected an option from a lookup query
            // These 'interacted' options need to be persisted if a user wants to select them again
            ...state.lookup.lookupResultOptions.flatMap((option)=>{
                if (!optionsToChange.find((x)=>x.value === option.value)) return [];
                return [
                    option
                ];
            })
        ].map($6f4c23c6c3ab5dea$var$updateOptionState({
            optionsToChange: optionsToChange,
            firstSelectedOption: firstSelectedOption
        }));
        return $6f4c23c6c3ab5dea$export$767f444f15b8d660({
            initial: initial,
            state: {
                ...state,
                initialOptions: {
                    ...state.initialOptions,
                    options: initialOptions
                },
                queryParams: {
                    ...state.queryParams,
                    options: queryParamOptions
                },
                lookup: {
                    ...state.lookup,
                    options: lookupOptions
                }
            },
            config: config
        });
    };
};
module.exports["createSingleSelectFilter"] = $6f4c23c6c3ab5dea$export$b77715d04a87c12b;
module.exports["SingleSelectFilter"] = $6f4c23c6c3ab5dea$export$767f444f15b8d660;

});

parcelRegister("XRj3F", function(module, exports) {
// these are values for the query params
const $25241466e474a32c$export$d76b5866ae4061c8 = {
    Open: 'open',
    Closed: 'closed'
};
const $25241466e474a32c$export$ff1c9ca0ad19eecd = Object.values($25241466e474a32c$export$d76b5866ae4061c8);
const $25241466e474a32c$export$9e65f1e3288fbede = {
    [$25241466e474a32c$export$d76b5866ae4061c8.Open]: false,
    [$25241466e474a32c$export$d76b5866ae4061c8.Closed]: true
};
module.exports["allOpportunityStatusFilterValueKeys"] = $25241466e474a32c$export$ff1c9ca0ad19eecd;
module.exports["OpportunityStatusFilterValue"] = $25241466e474a32c$export$9e65f1e3288fbede;

});

parcelRegister("1Fy3P", function(module, exports) {
// these are values for the query params
const $1ea302473f169de3$export$dbcc81d768a46013 = {
    RoughDraft: 'roughDraft',
    InProgress: 'inProgress',
    ReadyForReview: 'readyForReview',
    Verified: 'verified'
};
const $1ea302473f169de3$export$48932d85514b3629 = Object.values($1ea302473f169de3$export$dbcc81d768a46013);
const $1ea302473f169de3$export$106c1c66f1b4a23e = {
    [$1ea302473f169de3$export$dbcc81d768a46013.RoughDraft]: 'Rough draft',
    [$1ea302473f169de3$export$dbcc81d768a46013.InProgress]: 'In progress',
    [$1ea302473f169de3$export$dbcc81d768a46013.ReadyForReview]: 'Ready for review',
    [$1ea302473f169de3$export$dbcc81d768a46013.Verified]: 'Verified'
};
const $1ea302473f169de3$export$1b1e4f3d8ba5c6c1 = (value)=>{
    return $1ea302473f169de3$export$48932d85514b3629.includes(value);
};
module.exports["PageStatusFilterValueKey"] = $1ea302473f169de3$export$dbcc81d768a46013;
module.exports["allPageStatusFilterValueKeys"] = $1ea302473f169de3$export$48932d85514b3629;
module.exports["PageStatusFilterValue"] = $1ea302473f169de3$export$106c1c66f1b4a23e;
module.exports["isPageStatusFilterValueKey"] = $1ea302473f169de3$export$1b1e4f3d8ba5c6c1;

});

parcelRegister("gFWyZ", function(module, exports) {
const $ed1006d28bdc8f5b$export$1e3b02869b42f77a = [
    'ati:cloud:graph:space'
];
module.exports["DEFAULT_CLOUD_GRAPH_SPACE_ENTITY_ATI"] = $ed1006d28bdc8f5b$export$1e3b02869b42f77a;

});

parcelRegister("S6W9B", function(module, exports) {

var $1Qme9 = parcelRequire("1Qme9");

const $e14285b53154dd46$export$98613a34994a7d63 = (cloudId, primaryProduct)=>{
    if ((0, $1Qme9.serveFpsMultiSiteSearchExperiment)({
        primaryProduct: primaryProduct,
        fireExperimentExposure: false
    })) return `ari:cloud:platform::site/${cloudId}`;
    return primaryProduct === 'jira' ? `ari:cloud:jira::site/${cloudId}` : `ari:cloud:confluence::site/${cloudId}`;
};
const $e14285b53154dd46$export$5af1ec507ebe78f1 = (cloudId, primaryProduct, additionalCloudIds = [])=>{
    const cloudIds = [
        cloudId,
        ...additionalCloudIds
    ].filter((id, index, all)=>Boolean(id) && all.indexOf(id) === index);
    return cloudIds.map((id)=>$e14285b53154dd46$export$98613a34994a7d63(id, primaryProduct));
};
module.exports["getCloudIdARI"] = $e14285b53154dd46$export$98613a34994a7d63;
module.exports["getCloudIdARIs"] = $e14285b53154dd46$export$5af1ec507ebe78f1;

});

parcelRegister("aCR6W", function(module, exports) {
/**
 * Generic fuzzy matching utility for filtering select filter options client-side.
 *
 * ## Normalization
 * Both the query and candidate text are normalized before comparison by:
 *   - Converting to lowercase
 *   - Stripping all non-alphanumeric characters (hyphens, underscores, spaces, punctuation, etc.)
 *
 * This means "trex" will match "t-rex", "t_rex", "T.Rex", "(T)Rex", etc.
 *
 * ## Matching strategy (applied to normalized strings)
 * 1. **Substring match** — normalized candidate contains normalized query as a contiguous substring.
 *    e.g. "flu" matches "confluence" → "confluence"
 * 2. **Subsequence match** — every character in the normalized query appears in the normalized
 *    candidate in the same relative order (but not necessarily contiguous).
 *    e.g. "cnf" matches "confluence" → "cnflue**n**ce" (c…n…f)
 *
 * An empty query matches everything.
 */ /** Strip all non-alphanumeric characters and lowercase. */ const $ea8a7d6f7faefd94$var$normalize = (text)=>text.toLowerCase().replace(/[^a-z0-9]/g, '');
/**
 * Returns true if every character in `query` appears in `text` in the same
 * relative order (subsequence match).
 */ const $ea8a7d6f7faefd94$var$isSubsequence = (text, query)=>{
    let queryIndex = 0;
    for(let i = 0; i < text.length && queryIndex < query.length; i++)if (text[i] === query[queryIndex]) queryIndex++;
    return queryIndex === query.length;
};
const $ea8a7d6f7faefd94$export$3ace64ce5180d918 = (query, candidate)=>{
    const normalizedQuery = $ea8a7d6f7faefd94$var$normalize(query);
    // Empty query matches everything
    if (!normalizedQuery) return true;
    const normalizedCandidate = $ea8a7d6f7faefd94$var$normalize(candidate);
    // Nothing left after stripping non-alphanumeric — can't match a non-empty query
    if (!normalizedCandidate) return false;
    // 1. Substring match (faster — try first)
    if (normalizedCandidate.includes(normalizedQuery)) return true;
    // 2. Subsequence match
    return $ea8a7d6f7faefd94$var$isSubsequence(normalizedCandidate, normalizedQuery);
};
const $ea8a7d6f7faefd94$export$775f9687cb3a8d8b = (query, items, getText)=>{
    if (!query) return items;
    return items.filter((item)=>$ea8a7d6f7faefd94$export$3ace64ce5180d918(query, getText(item)));
};
module.exports["fuzzyFilter"] = $ea8a7d6f7faefd94$export$775f9687cb3a8d8b;

});

parcelRegister("lDUCP", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $5pcom = parcelRequire("5pcom");


var $i28CG = parcelRequire("i28CG");


var $fIeaC = parcelRequire("fIeaC");


var $dsOco = parcelRequire("dsOco");

const $b23f12babcafb113$export$694cb0e3f167dbc8 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $dsOco.useCommonAndPrivateAttributes)();
    const callback = (0, $cozmU.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $5pcom.onOAuthStarted)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: {
                ...commonAttributes,
                ...(0, $fIeaC.getExtensionData)(commonAttributes.isCQL)
            },
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $i28CG.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
const $b23f12babcafb113$export$cbd7e681ca5b8fd4 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $dsOco.useCommonAndPrivateAttributes)();
    const callback = (0, $cozmU.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $5pcom.onOAuthCompleted)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $i28CG.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
const $b23f12babcafb113$export$cff3d5cd941b3b4d = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $dsOco.useCommonAndPrivateAttributes)();
    const callback = (0, $cozmU.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $5pcom.onOAuthFailed)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $i28CG.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
const $b23f12babcafb113$export$3168f7d5a2074317 = ({ cloudId: cloudId, product: product, connectorSource: connectorSource, isOnSearchDialog: isOnSearchDialog, thirdPartyConfigs: thirdPartyConfigs, extraAttributes: extraAttributes })=>{
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $dsOco.useAnalytics)();
    const { commonAttributes: commonAttributes, nonPrivacySafeAttributes: nonPrivacySafeAttributes } = (0, $dsOco.useCommonAndPrivateAttributes)();
    const callback = (0, $cozmU.useCallback)((oAuthSource)=>{
        fireAnalyticsEvent((0, $5pcom.onOAuthConnectHovered)({
            cloudId: cloudId,
            product: product,
            connectorSource: connectorSource,
            commonAttributes: commonAttributes,
            nonPrivacySafeAttributes: nonPrivacySafeAttributes,
            isOnSearchDialog: isOnSearchDialog,
            oAuthSource: oAuthSource,
            isImpersonated: (0, $i28CG.isProductImpersonated)(product, thirdPartyConfigs),
            extraAttributes: extraAttributes
        }));
    }, [
        fireAnalyticsEvent,
        cloudId,
        product,
        connectorSource,
        commonAttributes,
        nonPrivacySafeAttributes,
        isOnSearchDialog,
        thirdPartyConfigs,
        extraAttributes
    ]);
    return callback;
};
module.exports["useFireOAuthStarted"] = $b23f12babcafb113$export$694cb0e3f167dbc8;
module.exports["useFireOAuthCompleted"] = $b23f12babcafb113$export$cbd7e681ca5b8fd4;
module.exports["useFireOAuthFailed"] = $b23f12babcafb113$export$cff3d5cd941b3b4d;
module.exports["useFireOAuthHovered"] = $b23f12babcafb113$export$3168f7d5a2074317;

});

parcelRegister("fZV6T", function(module, exports) {
const $f464135d5c5977a6$export$2f5ba0d1129fe71 = (inputStr)=>{
    const htmlEntities = {
        '&nbsp;': ' ',
        '&lt;': '<',
        '&amp;': '&',
        '&quot;': '"',
        '&gt;': '>'
    };
    return Object.keys(htmlEntities).reduce((str, entity)=>{
        return str.replace(new RegExp(entity, 'g'), htmlEntities[entity]);
    }, inputStr);
};
module.exports["replaceHtmlEntities"] = $f464135d5c5977a6$export$2f5ba0d1129fe71;

});

parcelRegister("dTqCf", function(module, exports) {
const $cf4a96c4694a466a$export$158516eb8829fc93 = (timestamp)=>{
    if (!timestamp) timestamp = new Date();
    const now = new Date();
    return (now.getTime() - new Date(timestamp).getTime()) / 1000;
};
module.exports["secondsSinceDate"] = $cf4a96c4694a466a$export$158516eb8829fc93;

});

parcelRegister("480dC", function(module, exports) {
const $3d24f627ae2fbe4a$export$c7b83231a41239c7 = [
    'document'
];
module.exports["SHAREPOINT_RESOURCE_TYPES"] = $3d24f627ae2fbe4a$export$c7b83231a41239c7;

});

parcelRegister("7Rtv4", function(module, exports) {
const $cb96b18b3fb0fbd5$export$5c9d109db494cbec = [
    'message',
    'conversation',
    'video'
];
module.exports["TEAMS_RESOURCE_TYPES"] = $cb96b18b3fb0fbd5$export$5c9d109db494cbec;

});

parcelRegister("6zZLZ", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $ebab087727106624$export$9f8e6b98f3e412c5 = (0, $kSwu1.defineMessages)({
    all: {
        id: "search-page.filter.type.all",
        defaultMessage: "All"
    },
    position: {
        id: "search-page.filter.type.position",
        defaultMessage: "Positions"
    },
    document: {
        id: "search-page.filter.type.documents",
        defaultMessage: "Documents"
    },
    spreadsheet: {
        id: "search-page.filter.type.spreadsheet",
        defaultMessage: "Spreadsheets"
    },
    presentation: {
        id: "search-page.filter.type.presentation",
        defaultMessage: "Presentations"
    },
    repository: {
        id: "search-page.filter.type.repository",
        defaultMessage: "Repositories"
    },
    'pull-request': {
        id: "search-page.filter.type.pull-request",
        defaultMessage: "Pull requests"
    },
    branch: {
        id: "search-page.filter.type.branch",
        defaultMessage: "Branches"
    },
    commit: {
        id: "search-page.filter.type.commit",
        defaultMessage: "Commits"
    },
    conversation: {
        id: "search-page.filter.type.conversation",
        defaultMessage: "Channels"
    },
    message: {
        id: "search-page.filter.type.message",
        defaultMessage: "Messages"
    },
    video: {
        id: "search-page.filter.type.video",
        defaultMessage: "Videos"
    },
    design: {
        id: "search-page.filter.type.design",
        defaultMessage: "Designs"
    },
    pageAndLiveDoc: {
        id: "search-page.filter.type.pageAndLiveDoc",
        defaultMessage: "Pages and Live Docs"
    },
    page: {
        id: "search-page.filter.type.page",
        defaultMessage: "Pages"
    },
    blogpost: {
        id: "search-page.filter.type.blogpost",
        defaultMessage: "Blog posts"
    },
    attachment: {
        id: "search-page.filter.type.attachment",
        defaultMessage: "Attachments"
    },
    space: {
        id: "search-page.filter.type.space",
        defaultMessage: "Spaces"
    },
    whiteboard: {
        id: "search-page.filter.type.whiteboard",
        defaultMessage: "Whiteboards"
    },
    slide: {
        id: "search-page.filter.type.slide",
        defaultMessage: "Slides"
    },
    issue: {
        id: "search-page.filter.type.jira-work-item",
        defaultMessage: "Work items"
    },
    project: {
        id: "search-page.filter.type.project",
        defaultMessage: "Projects"
    },
    goal: {
        id: "search-page.filter.type.goal",
        defaultMessage: "Goals"
    },
    tag: {
        id: "search-page.filter.type.tag",
        defaultMessage: "Tags"
    },
    'web-page': {
        id: "search-page.filter.type.web-page",
        defaultMessage: "Web pages"
    },
    comment: {
        id: "search-page.filter.type.comment",
        defaultMessage: "Comments"
    },
    database: {
        id: "search-page.filter.type.database",
        defaultMessage: "Databases"
    },
    embed: {
        id: "search-page.filter.type.embed",
        defaultMessage: "Smart Links"
    },
    folder: {
        id: "search-page.filter.type.folder",
        defaultMessage: "Folders"
    },
    calendar: {
        id: "search-page.filter.type.calendar",
        defaultMessage: "Calendars"
    },
    'space-calendar': {
        id: "search-page.filter.type.space-calendar",
        defaultMessage: "Space calendars"
    },
    answer: {
        id: "search-page.filter.type.answer",
        defaultMessage: "Answers"
    },
    question: {
        id: "search-page.filter.type.question",
        defaultMessage: "Questions"
    },
    component: {
        id: "search-page.filter.type.component",
        defaultMessage: "Components"
    },
    'work-item': {
        id: "search-page.filter.type.work-item",
        defaultMessage: "Tasks"
    },
    card: {
        id: "search-page.filter.type.card",
        defaultMessage: "Cards"
    },
    incident: {
        id: "search-page.filter.type.incident",
        defaultMessage: "Incidents"
    },
    'focus-area': {
        id: "search-page.filter.type.focus-area",
        defaultMessage: "Focus areas"
    },
    organization: {
        id: "search-page.filter.type.organization",
        defaultMessage: "Organizations"
    },
    ask: {
        id: "search-page.filter.type.ask",
        defaultMessage: "Asks"
    },
    risk: {
        id: "search-page.filter.type.risk",
        defaultMessage: "Risks"
    },
    dashboard: {
        id: "search-page.filter.type.dashboard",
        defaultMessage: "Dashboards"
    },
    invoice: {
        id: "search-page.filter.type.invoice",
        defaultMessage: "Invoices"
    },
    deal: {
        id: "search-page.filter.type.deal",
        defaultMessage: "Deals"
    },
    gliffy: {
        id: "search-page.filter.type.gliffy",
        defaultMessage: "Gliffy Diagrams"
    },
    'customer-contact': {
        id: "search-page.filter.type.customer-contact",
        defaultMessage: "Customer Contacts"
    },
    'customer-org': {
        id: "search-page.filter.type.customer-org",
        defaultMessage: "Customer Organizations"
    },
    board: {
        id: "search-page.filter.type.board",
        defaultMessage: "Boards"
    },
    plan: {
        id: "search-page.filter.type.plan",
        defaultMessage: "Plans"
    },
    filter: {
        id: "search-page.filter.type.filter",
        defaultMessage: "Filters"
    },
    'data-table': {
        id: "search-page.filter.type.data-table",
        defaultMessage: "Data tables"
    },
    object: {
        id: "search-page.filter.type.object",
        defaultMessage: "Objects"
    },
    schema: {
        id: "search-page.filter.type.schema",
        defaultMessage: "Schemas"
    },
    type: {
        id: "search-page.filter.type.type",
        defaultMessage: "Object types"
    },
    epic: {
        id: "search-page.filter.type.epic",
        defaultMessage: "Epic"
    },
    bug: {
        id: "search-page.filter.type.bug",
        defaultMessage: "Bug"
    },
    story: {
        id: "search-page.filter.type.Story",
        defaultMessage: "Story"
    },
    task: {
        id: "search-page.filter.type.task",
        defaultMessage: "Task"
    },
    subtask: {
        id: "search-page.filter.type.subtask",
        defaultMessage: "Subtask"
    },
    image: {
        id: "search-page.filter.type.image",
        defaultMessage: "Images"
    },
    audio: {
        id: "search-page.filter.type.audio",
        defaultMessage: "Audio"
    },
    pdf: {
        id: "search-page.filter.type.pdf",
        defaultMessage: "PDF"
    },
    shortcut: {
        id: "search-page.filter.type.shortcut",
        defaultMessage: "Shortcut"
    },
    code: {
        id: "search-page.filter.type.code",
        defaultMessage: "Code"
    },
    archive: {
        id: "search-page.filter.type.archive",
        defaultMessage: "Archive"
    },
    form: {
        id: "search-page.filter.type.form",
        defaultMessage: "Form"
    },
    notebook: {
        id: "search-page.filter.type.notebook",
        defaultMessage: "Notebook"
    },
    other: {
        id: "search-page.filter.type.other",
        defaultMessage: "Other"
    },
    article: {
        id: "search-page.filter.type.article",
        defaultMessage: "Articles"
    },
    post: {
        id: "search-page.filter.type.post",
        defaultMessage: "Posts"
    },
    ticket: {
        id: "search-page.filter.type.ticket",
        defaultMessage: "Tickets"
    },
    'devops-work-item': {
        id: "search-page.filter.type.devops-work-item",
        defaultMessage: "Issues"
    },
    campaign: {
        id: "search-page.filter.type.campaign",
        defaultMessage: "Campaigns"
    },
    case: {
        id: "search-page.filter.type.case",
        defaultMessage: "Cases"
    },
    'catalog-item': {
        id: "search-page.filter.type.catalog-item",
        defaultMessage: "Catalog items"
    },
    'requested-item': {
        id: "search-page.filter.type.requested-item",
        defaultMessage: "Requested items"
    },
    'knowledge-article': {
        id: "search-page.filter.type.knowledge-article",
        defaultMessage: "Knowledge articles"
    },
    'news-article': {
        id: "search-page.filter.type.news-article",
        defaultMessage: "News articles"
    },
    demand: {
        id: "search-page.filter.type.demand",
        defaultMessage: "Demands"
    },
    lead: {
        id: "search-page.filter.type.lead",
        defaultMessage: "Leads"
    }
});
module.exports["typeLabels"] = $ebab087727106624$export$9f8e6b98f3e412c5;

});

parcelRegister("bHPvH", function(module, exports) {
/**
 * Pure function to get 3P product keys for a given filter ID.
 * Uses pre-computed static mapping instead of ThirdPartyConfigs
 * to avoid importing React icon components.
 */ 
var $cEDkb = parcelRequire("cEDkb");

const $9bd88cee383af9a7$export$ef6dfb919b1d7267 = (filterId)=>{
    return (0, $cEDkb.thirdPartyFilterProducts)[filterId] ?? [];
};
module.exports["getProducts3PFromConfigForFilter"] = $9bd88cee383af9a7$export$ef6dfb919b1d7267;

});

parcelRegister("iaii4", function(module, exports) {

var $hea5O = parcelRequire("hea5O");

const $bf3c9af35b635e5b$var$isIsoDate = (str)=>{
    if (!str) return false;
    if (!/\d{4}-\d{2}-\d{2}/.test(str)) return false;
    const d = new Date(str);
    return !isNaN(d.getTime());
};
const $bf3c9af35b635e5b$export$cb0ede5f191413 = (queryParams)=>{
    const { to: to, from: from } = queryParams;
    const isToDateValid = $bf3c9af35b635e5b$var$isIsoDate(to?.[0]);
    const isFromDateValid = $bf3c9af35b635e5b$var$isIsoDate(from?.[0]);
    const toDate = isToDateValid && to?.[0] ? to?.[0] : '';
    const fromDate = isFromDateValid && from?.[0] ? from?.[0] : '';
    const invalidDateRange = (0, $hea5O.getInvalidDateRange)(fromDate, toDate);
    if (!invalidDateRange) return {
        to: toDate,
        from: fromDate
    };
};
const $bf3c9af35b635e5b$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        let value;
        let customValue;
        if (Array.isArray(queryParamValue)) {
            value = queryParamValue;
            if (queryParamValue[0] === 'custom') customValue = $bf3c9af35b635e5b$export$cb0ede5f191413(queryParams);
        }
        return {
            ...initialState,
            value: value || initialState.value,
            customValue: customValue || initialState.customValue
        };
    };
};
module.exports["customValueParser"] = $bf3c9af35b635e5b$export$cb0ede5f191413;
module.exports["generateQueryParamsGetState"] = $bf3c9af35b635e5b$export$64e49a0c7bd6f7a0;

});

parcelRegister("2bNdD", function(module, exports) {

var $1Fy3P = parcelRequire("1Fy3P");

const $fa8fc29bf8514fb8$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        let value;
        if (Array.isArray(queryParamValue)) {
            if (queryParamValue[0] === 'all') value = queryParamValue;
            else if ((0, $1Fy3P.isPageStatusFilterValueKey)(queryParamValue[0])) value = [
                (0, $1Fy3P.PageStatusFilterValue)[queryParamValue[0]]
            ];
        }
        return {
            ...initialState,
            value: value || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $fa8fc29bf8514fb8$export$64e49a0c7bd6f7a0;

});

parcelRegister("26LZ9", function(module, exports) {
const $a7dc4cdc231636e7$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams)=>{
        const queryParamValue = queryParams[queryParamKey];
        let value;
        if (Array.isArray(queryParamValue)) value = queryParamValue.map((param)=>decodeURIComponent(param));
        return {
            ...initialState,
            value: value || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $a7dc4cdc231636e7$export$64e49a0c7bd6f7a0;

});

parcelRegister("2UU5O", function(module, exports) {

var $7avaU = parcelRequire("7avaU");


var $dvVWp = parcelRequire("dvVWp");

const $ceccebe48d4d7257$var$projectIdToARI = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;
const $ceccebe48d4d7257$export$64e49a0c7bd6f7a0 = (initialState, queryParamKey)=>{
    return (queryParams, cloudId)=>{
        const selectedProduct = (queryParams['product'] ?? [])[0];
        const queryParamValue = queryParams[queryParamKey] || [];
        // Query params hold ARIs. Links predating that hold bare project ids, which can only be
        // resolved against the current site here.
        // TODO QS-10359: drop the bare id branch once pre-ARI links have aged out. Note this
        // outlives the serveFpsMultiSiteSearchExperiment cleanup, since the ARI format is ungated.
        const value = selectedProduct === (0, $dvVWp.ProductKeys).JiraDC || selectedProduct === (0, $dvVWp.ProductKeys).JsmDC ? queryParamValue : queryParamValue.map((entry)=>(0, $7avaU.AnyAri).check(entry) ? entry : $ceccebe48d4d7257$var$projectIdToARI(cloudId || '', entry));
        return {
            ...initialState,
            value: value || initialState.value
        };
    };
};
module.exports["generateQueryParamsGetState"] = $ceccebe48d4d7257$export$64e49a0c7bd6f7a0;

});

parcelRegister("ieiUX", function(module, exports) {

var $8fNUp = parcelRequire("8fNUp");


var $9ekgQ = parcelRequire("9ekgQ");


var $9pcjO = parcelRequire("9pcjO");


var $hea5O = parcelRequire("hea5O");

const $e3a55b5f19f29c03$export$a97e25c038594c73 = (staticFilters, filterStates)=>{
    const staticFilterValues = Array.isArray(staticFilters) ? staticFilters : Object.values(staticFilters);
    const staticFiltersRecord = Array.isArray(staticFilters) ? Object.fromEntries(staticFilters.map((staticFilter)=>[
            staticFilter.id,
            staticFilter
        ])) : staticFilters;
    const filterStateValues = Array.isArray(filterStates) ? filterStates : Object.values(filterStates).filter((0, $hea5O.notEmpty));
    const filterStatesRecord = Array.isArray(filterStates) ? Object.fromEntries(filterStates.map((filterState)=>[
            filterState.id,
            filterState
        ])) : filterStates;
    return {
        staticFilters: staticFiltersRecord,
        staticFilterValues: staticFilterValues,
        filterStates: filterStatesRecord,
        filterStateValues: filterStateValues,
        getSelectedProducts: (queryParams)=>{
            const productKey = (0, $9ekgQ.productKeySchema).safeParse(queryParams.product);
            if (productKey.success) return [
                productKey.data
            ];
            const allProductsWithSelections = staticFilterValues.filter((staticFilter)=>!staticFilter.universal) // Ignore universal filters as they are relevant to every product
            .filter((staticFilter)=>queryParams[staticFilter.queryParams.key] !== undefined).map((staticFilter)=>staticFilter.products).flat();
            const selectedProducts = Array.from(new Set(allProductsWithSelections)); // might have to sort this based on some priority
            return selectedProducts;
        },
        isMissingProductSelection: (queryParams)=>{
            const selectedProducts = $e3a55b5f19f29c03$export$a97e25c038594c73(staticFilters, filterStates).getSelectedProducts(queryParams);
            const productKey = (0, $9ekgQ.productKeySchema).safeParse(queryParams.product).data;
            return selectedProducts.length > 0 && !productKey;
        },
        filtersByProduct: (products, experience, primaryProduct)=>{
            const staticFiltersByProduct = staticFilterValues.filter((staticFilterValue)=>{
                if (!products.length && experience === (0, $9pcjO.SearchExperience).SEARCH_PAGE) return(// If no apps are selected, only universal and suggested filters are relevant
                staticFilterValue.universal || staticFilterValue.isSuggestedFilter?.(primaryProduct));
                if (!products.length && experience === (0, $9pcjO.SearchExperience).QUICK_FIND) return staticFilterValue.products.find((product)=>product === primaryProduct);
                if (!products.length) return(// If no apps are selected, only universal and suggested filters are relevant
                staticFilterValue.universal || staticFilterValue.isSuggestedFilter?.(primaryProduct));
                // Universal filters should always be included for forge connectors
                // This is needed because forge connectors are dynamically loaded and not in the static products list
                if (staticFilterValue.universal && products.some((0, $8fNUp.isForgeConnectorProductKey))) return true;
                return staticFilterValue.products.some((product)=>products.includes(product));
            });
            const staticFiltersByProductKeys = staticFiltersByProduct.map((staticFilter)=>staticFilter.id);
            const filterStatesByProduct = filterStateValues.filter((filterState)=>staticFiltersByProductKeys.includes(filterState.id));
            return $e3a55b5f19f29c03$export$a97e25c038594c73(staticFiltersByProduct, filterStatesByProduct);
        },
        getFiltersWithSelection: ()=>{
            const filterIDsWithSelection = filterStateValues.filter((x)=>x.hasSelection).map((x)=>x.id);
            return filterIDsWithSelection;
        }
    };
};
module.exports["FilterUtils"] = $e3a55b5f19f29c03$export$a97e25c038594c73;

});

parcelRegister("6jeRt", function(module, exports) {

var $iDrrr = parcelRequire("iDrrr");


var $aqAfG = parcelRequire("aqAfG");


var $aoy1P = parcelRequire("aoy1P");


var $fd0l2 = parcelRequire("fd0l2");

const $282b3c72875f64ab$export$6702bcb53d02902a = ({ supportedProducts: supportedProducts, products: products, accessibleProducts: accessibleProducts })=>{
    if (!accessibleProducts) return [];
    const fgControlledProducts = {
        [(0, $aqAfG.ProductKeys1P).Talent]: (0, $iDrrr.fg)('talent_global_search')
    };
    const disabledProducts3PFromConfig = [];
    (0, $fd0l2.ThirdPartyConfigsSync).forEach((config, productKey3P)=>{
        if (config && !config.isEnabled()) disabledProducts3PFromConfig.push(productKey3P);
    });
    const accessibleAndSupportedProducts = accessibleProducts.filter((productKey)=>!disabledProducts3PFromConfig.includes(productKey) && (productKey in fgControlledProducts ? fgControlledProducts[productKey] : true)).filter((productKey)=>{
        // Forge connectors are dynamically added and won't be in supportedProducts
        if ((0, $aoy1P.isForgeConnectorProductKey)(productKey) && (0, $iDrrr.fg)('rovo-search-dynamic-forge-config')) return true;
        // For hardcoded products, check if they're in supportedProducts
        return supportedProducts.includes(productKey);
    });
    if (products) {
        const allowedProducts = products.filter((product)=>accessibleAndSupportedProducts.includes(product));
        return allowedProducts;
    } else {
        if (//TODO: move this logic to xpsearch aggregator before release with the correct conditions
        // eslint-disable-next-line @atlaskit/platform/no-preconditioning
        accessibleAndSupportedProducts.includes((0, $aqAfG.ProductKeys1P).JiraServiceManagement) && (0, $iDrrr.fg)('assets_rovo_search_all') && // add assets as a product if JSM license is present, but this is until assets becomes a platform
        !(0, $iDrrr.fg)('aurum-assets-as-a-platform') // disable this when assets becomes a platform and we will start getting assets as its product
        ) return [
            ...accessibleAndSupportedProducts,
            (0, $aqAfG.ProductKeys1P).Assets
        ];
        return accessibleAndSupportedProducts;
    }
};
module.exports["getSupportedAccessibleProducts"] = $282b3c72875f64ab$export$6702bcb53d02902a;

});

parcelRegister("a14M2", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $biQM6 = parcelRequire("biQM6");


var $ktiKH = parcelRequire("ktiKH");

const $e274018abf4fad3c$export$1e8af0ff123020f2 = {
    queryParams: {},
    referrer: undefined,
    /**
   * Empty because it is falsy and then will be overridden during boostrap
   * Can't be uuid() because then won't be overridden!
   * Can't be undefined, because we want to be explicit about the fact that this should be set during bootstrap and not be optional
   */ searchSessionId: '',
    smartLinkUsage: undefined,
    thirdPartyConfigs: undefined
};
const $e274018abf4fad3c$export$6286a07f09af7d90 = ({ children: children, searchSessionId: searchSessionId, referrer: referrer, smartLinkUsage: smartLinkUsage, queryParams: queryParams, thirdPartyConfigs: thirdPartyConfigs })=>{
    const parsedQueryParams = (0, $cozmU.useMemo)(()=>{
        return (0, $biQM6.parseQueryParams)(queryParams || $e274018abf4fad3c$export$1e8af0ff123020f2.queryParams);
    }, [
        queryParams
    ]);
    // A classic anything-updates useMemo
    const dynamicProps = (0, $cozmU.useMemo)(()=>{
        return {
            queryParams: parsedQueryParams,
            searchSessionId: // Passed directly through for easy hook access in code sites
            // TODO QS-9194 should all be prop drilled later
            searchSessionId,
            referrer: referrer,
            smartLinkUsage: smartLinkUsage,
            thirdPartyConfigs: thirdPartyConfigs
        };
    }, [
        parsedQueryParams,
        referrer,
        searchSessionId,
        smartLinkUsage,
        thirdPartyConfigs
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ktiKH.DynamicBootstrapContext).Provider, {
        value: dynamicProps
    }, children);
};
module.exports["defaultDynamicContext"] = $e274018abf4fad3c$export$1e8af0ff123020f2;
module.exports["DynamicContextProvider"] = $e274018abf4fad3c$export$6286a07f09af7d90;

});

parcelRegister("yW9ML", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

const $2c16c69ad6c9adc9$export$38b0e736a3b4e542 = (initial)=>{
    let state = initial;
    const listeners = new Set();
    return {
        getSnapshot: ()=>state,
        setState: (next)=>{
            if (next !== state) {
                state = next;
                listeners.forEach((listener)=>listener());
            }
        },
        subscribe: (listener)=>{
            listeners.add(listener);
            return ()=>{
                listeners.delete(listener);
            };
        }
    };
};
function $2c16c69ad6c9adc9$export$21fad0c5d7df52dc(store, selector) {
    const selectorRef = (0, $cozmU.useRef)(selector);
    selectorRef.current = selector;
    const cachedRef = (0, $cozmU.useRef)(null);
    const getSnapshot = (0, $cozmU.useCallback)(()=>{
        const currentState = store.getSnapshot();
        // If the underlying state hasn't changed, return the cached selected value.
        // This ensures referential stability for object/array selectors.
        if (cachedRef.current !== null && cachedRef.current.state === currentState) return cachedRef.current.value;
        const newValue = selectorRef.current(currentState);
        cachedRef.current = {
            value: newValue,
            state: currentState
        };
        return newValue;
    }, [
        store
    ]);
    // Third argument (getServerSnapshot) is required for SSR compatibility.
    // We reuse getSnapshot because store.getSnapshot() has no browser dependencies —
    // it simply returns the current state, which during SSR is the default initial state.
    return (0, $cozmU.useSyncExternalStore)(store.subscribe, getSnapshot, getSnapshot);
}
module.exports["createStaticBootstrapStore"] = $2c16c69ad6c9adc9$export$38b0e736a3b4e542;
module.exports["useStaticBootstrapSelector"] = $2c16c69ad6c9adc9$export$21fad0c5d7df52dc;

});

parcelRegister("bYMyf", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $1UWNP = parcelRequire("1UWNP");


var $cXtTj = parcelRequire("cXtTj");


var $3ZYG5 = parcelRequire("3ZYG5");


var $jXCr4 = parcelRequire("jXCr4");


var $4ysB6 = parcelRequire("4ysB6");


var $dvVWp = parcelRequire("dvVWp");


var $9pcjO = parcelRequire("9pcjO");


var $cJff5 = parcelRequire("cJff5");


var $9NmsO = parcelRequire("9NmsO");


var $ljBeq = parcelRequire("ljBeq");


var $03qcI = parcelRequire("03qcI");


var $biQM6 = parcelRequire("biQM6");


var $eD8r5 = parcelRequire("eD8r5");


var $4BJ6s = parcelRequire("4BJ6s");


var $ktiKH = parcelRequire("ktiKH");


var $yW9ML = parcelRequire("yW9ML");

// Attempting to build defaultstate from the same underlying definitions to ease migration to minimise migration
// omit from initialState
const { queryParams: $805dc5654c534215$var$_queryParams, referrer: $805dc5654c534215$var$_referrer, searchSessionId: $805dc5654c534215$var$_searchSessionId, thirdPartyConfigs: $805dc5654c534215$var$_thirdPartyConfigs, prevQueryParams: $805dc5654c534215$var$_prevQueryParams, initialSpaceARIs: $805dc5654c534215$var$_initialSpaceARIs, ...$805dc5654c534215$var$inheritedInitialState } = (0, $jXCr4.initialState);
const $805dc5654c534215$export$30ed20aaeaed4b77 = {
    ...$805dc5654c534215$var$inheritedInitialState,
    initialTextQueryParam: undefined,
    queryParamsCallback: ()=>{},
    refreshSearchSessionId: ()=>{},
    clearReferrer: ()=>{},
    setThirdPartyConfigs: ()=>{},
    onSearchCompleted: ()=>{},
    experience: (0, $9pcjO.SearchExperience).SEARCH_PAGE,
    applicationMode: (0, $ljBeq.getApplicationMode)({
        isRovoEnabled: $805dc5654c534215$var$inheritedInitialState.isRovoEnabled
    }),
    multiSiteSearchInRovo: (0, $cJff5.getMultiSiteSearchInRovo)($805dc5654c534215$var$inheritedInitialState.experimentConfig),
    isHello: (0, $03qcI.isHello)($805dc5654c534215$var$inheritedInitialState.cloudId),
    thirdPartyConfigs: {}
};
const $805dc5654c534215$export$bc36689a336ce85c = ({ children: children, initialProps: props, queryParams: queryParams, queryParamsCallback: queryParamsCallback, refreshSearchSessionId: refreshSearchSessionId, initialText: initialText, clearReferrer: clearReferrer, initialThirdPartyConfigs: initialThirdPartyConfigs, onSearchCompleted: onSearchCompleted, onOAuthSuccess: onOAuthSuccess, experience: experience, accessibleProducts: accessibleProducts })=>{
    /**
   * Static lock version counter. The useMemo recomputes whenever this value changes.
   *
   * Version semantics:
   * - 0: Lock open (bootstrap config not yet loaded)
   * - 1: Lock closed (bootstrap config loaded, values frozen)
   * - >1: Lock was reopened post-bootstrap via setThirdPartyConfigs (the ONLY path that increments above 1)
   *
   * If isConfigLoaded is already true on first render, starts at 1 so values are immediately available
   * without an extra render cycle.
   *
   * Post-bootstrap, setThirdPartyConfigs can increment the counter above 1 to force the useMemo to
   * recompute with updated refs. This is an expensive action that should be used sparingly and only
   * in response to uncommon user actions (e.g. OAuth connect flow).
   *
   * IMPORTANT: effectiveLockVersion is the SOLE dependency of the static useMemo. Do not add other dependencies.
   * If you need the useMemo to recompute for a new value, store that value in a ref and reopen the lock by incrementing this counter.
   */ const [staticLockVersion, setStaticLockVersion] = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).useState(()=>$805dc5654c534215$var$shouldStaticLockClose({
            isConfigLoaded: props.isConfigLoaded || false
        }) ? 1 : 0);
    /**
   * Close the static lock synchronously during render when isConfigLoaded becomes true.
   * Sets the version to exactly 1 (not an increment) so that only setThirdPartyConfigs can push the version above 1.
   */ if (staticLockVersion === 0 && $805dc5654c534215$var$shouldStaticLockClose({
        isConfigLoaded: props.isConfigLoaded || false
    })) setStaticLockVersion(1);
    // Create a stable store instance once per component lifetime
    const storeRef = (0, $cozmU.useRef)(null);
    /**
   * Derive the effective lock version synchronously from both the state counter AND props.isConfigLoaded.
   *
   * When isConfigLoaded transitions from false to true, the in-render setState above schedules a
   * state update, but staticLockVersion still reads as 0 on THIS render. Previously, the useMemo
   * (which depended solely on staticLockVersion) would not recompute until the NEXT render when
   * staticLockVersion became 1 — costing an extra render cycle (~100ms+ in a complex tree).
   *
   * effectiveLockVersion resolves this by treating the lock as closed immediately when
   * isConfigLoaded is true, even before the state update takes effect. The useMemo now depends
   * on effectiveLockVersion, so it recomputes on the same render that isConfigLoaded becomes true.
   *
   * For setThirdPartyConfigs (version > 1), the state-based counter still drives recomputation
   * as before, since isConfigLoaded is already true at that point.
   */ const effectiveLockVersion = staticLockVersion === 0 && $805dc5654c534215$var$shouldStaticLockClose({
        isConfigLoaded: props.isConfigLoaded || false
    }) ? 1 : staticLockVersion;
    /**
   * thirdPartyConfigs is expected to be static after bootstrap, but can be overridden during OAuth workflow as a cheap "cache bust".
   *
   * Stored in a ref so that updates do not directly cause re-renders. Instead, the OAuth callback
   * (setThirdPartyConfigs) updates the ref and reopens the static lock for exactly one render,
   * allowing the useMemo to recompute with the new value.
   */ const thirdPartyConfigsRef = (0, $cozmU.useRef)(initialThirdPartyConfigs || {});
    // Sync thirdPartyConfigs from props when config finishes loading (before static lock closes).
    // Uses staticLockVersion (not staticLockClosed/effectiveLockVersion) because when isConfigLoaded
    // transitions to true, effectiveLockVersion eagerly resolves to 1 on the same render. The ref
    // must be updated BEFORE the useMemo (which depends on effectiveLockVersion) recomputes, so we
    // check the underlying state which is still 0 on the transition render.
    if (staticLockVersion === 0 && props.isConfigLoaded) thirdPartyConfigsRef.current = initialThirdPartyConfigs || {};
    const setThirdPartyConfigs = (0, $cozmU.useCallback)((configs)=>{
        thirdPartyConfigsRef.current = configs;
        // Reopen the static lock for exactly one render so the useMemo recomputes with the new thirdPartyConfigs
        setStaticLockVersion((v)=>v + 1);
    }, []);
    const useMemoStaticProps = (0, $cozmU.useMemo)(()=>{
        const enableRovoSearchOverrides = Boolean(// eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        (0, $cXtTj.default).getExperimentValue('enable-rovo_search_overrides', 'value', false));
        const parsedQueryParams = queryParams && enableRovoSearchOverrides ? (0, $biQM6.parseQueryParams)(queryParams) : undefined;
        const isRovoEnabled = props.isRovoEnabled || $805dc5654c534215$export$30ed20aaeaed4b77.isRovoEnabled;
        const cloudId = props.cloudId || $805dc5654c534215$export$30ed20aaeaed4b77.cloudId;
        const primaryProduct = props.primaryProduct || $805dc5654c534215$export$30ed20aaeaed4b77.primaryProduct;
        const primarySubProduct = props.primarySubProduct || $805dc5654c534215$export$30ed20aaeaed4b77.primarySubProduct;
        const user = props.user || $805dc5654c534215$export$30ed20aaeaed4b77.user;
        // Under rovo-search-remove-rss-bootstrap-fg, compute experimentConfig directly
        // via getExperimentConfig instead of receiving it through props from BootstrapStoreProvider.
        // This moves the experiment config computation into the static context where it belongs,
        // using props already available here. If a prop is explicitly provided, use it as an
        // override (supports backward compat during rollout and test scenarios).
        // Keep in sync with: bootstrap-store-provider/index.tsx
        const experimentConfig = (0, $4BJ6s.serveBootstrapProviderExp)() ? props.experimentConfig || (0, $3ZYG5.getExperimentConfig)({
            experimentLayers: props.experimentLayers ?? [],
            sideBySideExperiment: props.features?.sideBySide?.experiments,
            statsigLayer: undefined,
            onError: (error)=>(0, $eD8r5.logException)(error, user?.id, primaryProduct)
        }) : props.experimentConfig || $805dc5654c534215$export$30ed20aaeaed4b77.experimentConfig;
        // This can contain duplicates from e.g. a full drive connector and a drive smartlink connector
        // Under rovo-search-remove-rss-bootstrap-fg, getAccessibleProducts is computed here
        // instead of in bootstrap-store-provider. On the old path, products is already processed.
        const products = (0, $4BJ6s.serveBootstrapProviderExp)() ? $805dc5654c534215$var$dedupProducts((0, $9NmsO.getAccessibleProducts)({
            supportedProducts: (0, $dvVWp.getAllProductKeys)(),
            products: props.products,
            accessibleProducts: accessibleProducts
        }), $805dc5654c534215$export$30ed20aaeaed4b77.products) : $805dc5654c534215$var$dedupProducts(props.products || [], $805dc5654c534215$export$30ed20aaeaed4b77.products);
        return {
            // Literal constant
            allFilterExcludedProducts: (0, $4ysB6.ALL_FILTER_EXCLUDED_PRODUCTS),
            // Static from internal props to BootstrapProvider
            experience: experience || $805dc5654c534215$export$30ed20aaeaed4b77.experience,
            // Static from host product props
            cloudId: cloudId,
            isHello: (0, $03qcI.isHello)(cloudId),
            aggregatorHostName: props.aggregatorHostName || $805dc5654c534215$export$30ed20aaeaed4b77.aggregatorHostName,
            aggAbsoluteUrl: props.aggAbsoluteUrl || $805dc5654c534215$export$30ed20aaeaed4b77.aggAbsoluteUrl,
            SAINHostName: props.SAINHostName || $805dc5654c534215$export$30ed20aaeaed4b77.SAINHostName,
            orgId: props.orgId || $805dc5654c534215$export$30ed20aaeaed4b77.orgId,
            primaryProduct: primaryProduct,
            primarySubProduct: primarySubProduct,
            analyticsAttributes: props.analyticsAttributes || $805dc5654c534215$export$30ed20aaeaed4b77.analyticsAttributes,
            features: props.features || $805dc5654c534215$export$30ed20aaeaed4b77.features,
            experimentLayers: props.experimentLayers || $805dc5654c534215$export$30ed20aaeaed4b77.experimentLayers,
            queryParamsCallback: queryParamsCallback || $805dc5654c534215$export$30ed20aaeaed4b77.queryParamsCallback,
            onSearchCompleted: onSearchCompleted || props.onSearchCompleted || $805dc5654c534215$export$30ed20aaeaed4b77.onSearchCompleted,
            onOAuthSuccess: onOAuthSuccess || props.onOAuthSuccess || $805dc5654c534215$export$30ed20aaeaed4b77.onOAuthSuccess,
            user: user,
            // Extracted on first load from queryParams (host product props)
            initialTextQueryParam: initialText,
            // DYNAMIC: from bootstrap config -> isConfigLoaded
            isConfigLoaded: props.isConfigLoaded || $805dc5654c534215$export$30ed20aaeaed4b77.isConfigLoaded,
            isRovoEnabled: isRovoEnabled,
            applicationMode: (0, $ljBeq.getApplicationMode)({
                isRovoEnabled: isRovoEnabled
            }),
            nouns: props.nouns || $805dc5654c534215$export$30ed20aaeaed4b77.nouns,
            productEdition: props.productEdition || $805dc5654c534215$export$30ed20aaeaed4b77.productEdition,
            productDataRegions: props.productDataRegions || $805dc5654c534215$export$30ed20aaeaed4b77.productDataRegions,
            rovoFeatures: props.rovoFeatures || $805dc5654c534215$export$30ed20aaeaed4b77.rovoFeatures,
            linkedCloudARIs: props.linkedCloudARIs || $805dc5654c534215$export$30ed20aaeaed4b77.linkedCloudARIs,
            unitMetadata: props.unitMetadata || $805dc5654c534215$export$30ed20aaeaed4b77.unitMetadata,
            isJiraIssueIndexed: props.isJiraIssueIndexed || $805dc5654c534215$export$30ed20aaeaed4b77.isJiraIssueIndexed,
            hasEditOrViewPlanPermission: props.hasEditOrViewPlanPermission || $805dc5654c534215$export$30ed20aaeaed4b77.hasEditOrViewPlanPermission,
            // when removing this feature flag, update the type to no longer be optional
            ...enableRovoSearchOverrides && {
                overrides: parsedQueryParams?.overrides || (0, $jXCr4.initialState).overrides
            },
            // Third party configs - static after bootstrap, mutable only via OAuth callback (read from ref)
            thirdPartyConfigs: thirdPartyConfigsRef.current,
            refreshSearchSessionId: // passed directly through from props
            refreshSearchSessionId,
            clearReferrer: clearReferrer,
            setThirdPartyConfigs: setThirdPartyConfigs,
            experimentConfig: // experimentConfig is now computed directly in this static context under
            // rovo-search-remove-rss-bootstrap-fg via getExperimentConfig, or falls back to props on the old path.
            experimentConfig,
            multiSiteSearchInRovo: (0, $cJff5.getMultiSiteSearchInRovo)(experimentConfig),
            products: products
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        effectiveLockVersion
    ]); // Do not expand this dependency. See effectiveLockVersion JSDoc. Reach out to #help-search-plex or #search-plex-perf-squad with any questions
    // Create or sync the external store.
    // On first render this creates the store; on subsequent renders it notifies
    // only subscribers whose selected slice actually changed.
    if (storeRef.current === null) storeRef.current = (0, $yW9ML.createStaticBootstrapStore)(useMemoStaticProps);
    else storeRef.current.setState(useMemoStaticProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ktiKH.StaticBootstrapContext).Provider, {
        value: useMemoStaticProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ktiKH.StaticBootstrapStoreContext).Provider, {
        value: storeRef.current
    }, children));
};
/**
 * Lock static context values after config is loaded to ensure they do not change during the session, as they are expected to be static after the bootstrap phase.
 * This also allows us to remove any dependencies on props that would cause unnecessary re-renders of the static context provider and all of its children
 *
 * The only values that should be here are booleans set by ASYNC behaviour that we must wait for (e.g. the config network call(s))
 * To add a new async dependency, provide a boolean e.g. myAsyncValue that is false until the async behaviour is complete, and then add it to the shouldStaticLockClose function.
 *
 * Note: This is on the search query critical performance path, any additional values added here should be carefully considered.
 * Reach out to #help-search-plex or #search-plex-perf-squad with any questions
 */ const $805dc5654c534215$var$shouldStaticLockClose = ({ isConfigLoaded: isConfigLoaded })=>{
    return isConfigLoaded; // Set by `useFetchConfig`, supported by promise-reuse and localStorage caching
};
/**
 * The set of `products` as passed in as a prop has duplicates due to smartlinks etc (drive can appear several times!)
 * We uniq() this list for use within search
 */ const $805dc5654c534215$var$dedupProducts = (0, (/*@__PURE__*/$parcel$interopDefault($1UWNP)))((a, b)=>{
    return [
        ...new Set([
            ...a,
            ...b
        ])
    ];
}, (a, b)=>a.join('') + b.join(''));
module.exports["defaultStaticContext"] = $805dc5654c534215$export$30ed20aaeaed4b77;
module.exports["StaticContextProvider"] = $805dc5654c534215$export$bc36689a336ce85c;

});


//# sourceMappingURL=QuickFind.41e644b1.js.map
